function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d1f"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d1f"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRequire.register("b0Nlg", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods);

var $cmFjP = parcelRequire("cmFjP");

var $289ZW = parcelRequire("289ZW");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");

var $6IwWN = parcelRequire("6IwWN");

var $7pcHN = parcelRequire("7pcHN");

var $aRkAb = parcelRequire("aRkAb");

var $iwSqi = parcelRequire("iwSqi");
/** Returns all trace headers that are currently on the top scope. */ function traceHeaders() {
    const scope = this.getScope();
    if (scope) {
        const span = scope.getSpan();
        if (span) return {
            "sentry-trace": span.toTraceparent()
        };
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $iwSqi.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $2zW56.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function _startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $aRkAb.Transaction)(transactionContext, this);
    transaction = sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function startIdleTransaction(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $7pcHN.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    return transaction;
}
/**
 * @private
 */ function _addTracingExtensions() {
    const carrier = (0, $cmFjP.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
}
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $cmFjP.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $289ZW.dynamicRequire)(module, "./integrations/node/mongo");
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $289ZW.dynamicRequire)(module, "./integrations/node/mongo");
            return new integration.Mongo({
                mongoose: true
            });
        },
        mysql () {
            const integration = (0, $289ZW.dynamicRequire)(module, "./integrations/node/mysql");
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $289ZW.dynamicRequire)(module, "./integrations/node/postgres");
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $289ZW.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if ((0, $289ZW.isNodeEnv)()) _autoloadDatabaseIntegrations();
    // If an error happens globally, we should make sure transaction status is set to error.
    (0, $6IwWN.registerErrorInstrumentation)();
}

});
parcelRequire.register("cmFjP", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $9007972943bbf579$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $9007972943bbf579$export$a07cdf6544bbd7c);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $3bpJ1 = parcelRequire("3bpJ1");
var $289ZW = parcelRequire("289ZW");
var $b1E2c = parcelRequire("b1E2c");

var $coQoV = parcelRequire("coQoV");

var $oyvka = parcelRequire("oyvka");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9007972943bbf579$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9007972943bbf579$var$DEFAULT_BREADCRUMBS = 100;
/**
 * A layer in the process stack.
 * @hidden
 */ /**
 * @inheritDoc
 */ class $9007972943bbf579$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ __init() {
        this._stack = [
            {}
        ];
    }
    /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $coQoV.Scope)(), _version = $9007972943bbf579$export$24a86ef7798177e4){
        this._version = _version;
        $9007972943bbf579$export$8c41bb232f1008b1.prototype.__init.call(this);
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $coQoV.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $b1E2c.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!scope || !client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9007972943bbf579$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $cvSY8.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $4g0Ct.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        const scope = this.getScope();
        if (scope) scope.setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        const scope = this.getScope();
        if (scope) scope.setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        const scope = this.getScope();
        if (scope) scope.setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        const scope = this.getScope();
        if (scope) scope.setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        const scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        const scope = this.getScope();
        if (scope) scope.setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (scope && client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $9007972943bbf579$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $9007972943bbf579$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        return this._callExtensionMethod("startTransaction", context, customSamplingContext);
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer && layer.scope;
        const session = scope && scope.getSession();
        if (session) (0, $oyvka.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $3bpJ1.GLOBAL_OBJ).navigator || {};
        const session = (0, $oyvka.makeSession)({
            release: release,
            environment: environment,
            ...scope && {
                user: scope.getUser()
            },
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        if (scope) {
            // End existing session if there's one
            const currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === "ok") (0, $oyvka.updateSession)(currentSession, {
                status: "exited"
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        if (!scope) return;
        const session = scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9007972943bbf579$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9007972943bbf579$export$19eade501500c6c1() {
    (0, $3bpJ1.GLOBAL_OBJ).__SENTRY__ = (0, $3bpJ1.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $3bpJ1.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $9007972943bbf579$export$4188a14ad302d1bc(hub) {
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    const oldHub = $9007972943bbf579$export$bfa8a924a84a76b7(registry);
    $9007972943bbf579$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $9007972943bbf579$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9007972943bbf579$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$9007972943bbf579$var$hasHubOnCarrier(registry) || $9007972943bbf579$export$bfa8a924a84a76b7(registry).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) $9007972943bbf579$export$849f05434e95d2f2(registry, new $9007972943bbf579$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $289ZW.isNodeEnv)()) return $9007972943bbf579$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $9007972943bbf579$export$bfa8a924a84a76b7(registry);
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $9007972943bbf579$var$getHubFromActiveDomain(registry) {
    try {
        const sentry = $9007972943bbf579$export$19eade501500c6c1().__SENTRY__;
        const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $9007972943bbf579$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$9007972943bbf579$var$hasHubOnCarrier(activeDomain) || $9007972943bbf579$export$bfa8a924a84a76b7(activeDomain).isOlderThan($9007972943bbf579$export$24a86ef7798177e4)) {
            const registryHubTopStack = $9007972943bbf579$export$bfa8a924a84a76b7(registry).getStackTop();
            $9007972943bbf579$export$849f05434e95d2f2(activeDomain, new $9007972943bbf579$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $coQoV.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $9007972943bbf579$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $9007972943bbf579$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9007972943bbf579$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $9007972943bbf579$export$bfa8a924a84a76b7(carrier) {
    return (0, $3bpJ1.getGlobalSingleton)("hub", ()=>new $9007972943bbf579$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $9007972943bbf579$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRequire.register("4g0Ct", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $3199231328e69de5$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $3199231328e69de5$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $3199231328e69de5$export$af88d00dbe7f521);

var $3bpJ1 = parcelRequire("3bpJ1");
/** Prefix for logging strings */ const $3199231328e69de5$var$PREFIX = "Sentry Logger ";
const $3199231328e69de5$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3199231328e69de5$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $3bpJ1.GLOBAL_OBJ))) return callback();
    const originalConsole = (0, $3bpJ1.GLOBAL_OBJ).console;
    const wrappedLevels = {};
    // Restore all wrapped console methods
    $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((level)=>{
        // TODO(v7): Remove this check as it's only needed for Node 6
        const originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in originalConsole && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach((level)=>{
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $3199231328e69de5$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $3199231328e69de5$export$cda52e2a8927a2ca(()=>{
                (0, $3bpJ1.GLOBAL_OBJ).console[name](`${$3199231328e69de5$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3199231328e69de5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let $3199231328e69de5$export$af88d00dbe7f521;
if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $3199231328e69de5$export$af88d00dbe7f521 = (0, $3bpJ1.getGlobalSingleton)("logger", $3199231328e69de5$var$makeLogger);
else $3199231328e69de5$export$af88d00dbe7f521 = $3199231328e69de5$var$makeLogger();

});
parcelRequire.register("3bpJ1", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $25165aaf01761cfd$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $25165aaf01761cfd$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $25165aaf01761cfd$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $25165aaf01761cfd$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $25165aaf01761cfd$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $25165aaf01761cfd$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $25165aaf01761cfd$var$isGlobalObj(window) || typeof self == "object" && $25165aaf01761cfd$var$isGlobalObj(self) || typeof $parcel$global == "object" && $25165aaf01761cfd$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $25165aaf01761cfd$export$256479dc0cea61c4() {
    return $25165aaf01761cfd$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $25165aaf01761cfd$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $25165aaf01761cfd$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRequire.register("cvSY8", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds);
$parcel$export(module.exports, "timestampWithMs", () => timestampWithMs);

var $289ZW = parcelRequire("289ZW");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $289ZW.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $289ZW.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
})();

});
parcelRequire.register("289ZW", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire);
$parcel$export(module.exports, "loadModule", () => loadModule);

var $Wgg6o = parcelRequire("Wgg6o");

var $hPtJY = parcelRequire("hPtJY");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $Wgg6o.isBrowserBundle)() && Object.prototype.toString.call(typeof $hPtJY !== "undefined" ? $hPtJY : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRequire.register("Wgg6o", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $0af207894032bdf2$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0af207894032bdf2$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}

});

parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRequire.register("b1E2c", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $806ed7b2edb8ea09$export$19f53698e68b2496);
$parcel$export(module.exports, "arrayify", () => $806ed7b2edb8ea09$export$3131421a7d01b4fb);

var $jL8lq = parcelRequire("jL8lq");

var $91U3U = parcelRequire("91U3U");

var $3bpJ1 = parcelRequire("3bpJ1");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $806ed7b2edb8ea09$export$19f53698e68b2496() {
    const gbl = (0, $3bpJ1.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
    const getRandomByte = crypto && crypto.getRandomValues ? ()=>crypto.getRandomValues(new Uint8Array(1))[0] : ()=>Math.random() * 16;
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $806ed7b2edb8ea09$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $806ed7b2edb8ea09$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $806ed7b2edb8ea09$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $806ed7b2edb8ea09$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $806ed7b2edb8ea09$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $806ed7b2edb8ea09$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $806ed7b2edb8ea09$export$d364f2020ab30578(input) {
    const match = input.match($806ed7b2edb8ea09$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $806ed7b2edb8ea09$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $91U3U.snipLine)(line, 0));
    frame.context_line = (0, $91U3U.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $91U3U.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $806ed7b2edb8ea09$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $jL8lq.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $806ed7b2edb8ea09$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRequire.register("jL8lq", function(module, exports) {

$parcel$export(module.exports, "fill", () => $e628e125e878fd27$export$9563e054e6f787fb);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $e628e125e878fd27$export$e73679ffaf56810e);
$parcel$export(module.exports, "dropUndefinedKeys", () => $e628e125e878fd27$export$d25f2688db1bb433);

var $ibKgU = parcelRequire("ibKgU");

var $2zW56 = parcelRequire("2zW56");

var $91U3U = parcelRequire("91U3U");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $e628e125e878fd27$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $e628e125e878fd27$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $e628e125e878fd27$export$5c1499e2e5d010ae(wrapped, original) {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $e628e125e878fd27$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $e628e125e878fd27$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $e628e125e878fd27$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $e628e125e878fd27$export$62ff257738bf57f5(value) {
    if ((0, $2zW56.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e628e125e878fd27$var$getOwnProperties(value)
    };
    else if ((0, $2zW56.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $e628e125e878fd27$var$serializeEventTarget(value.target),
            currentTarget: $e628e125e878fd27$var$serializeEventTarget(value.currentTarget),
            ...$e628e125e878fd27$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $2zW56.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $e628e125e878fd27$var$serializeEventTarget(target) {
    try {
        return (0, $2zW56.isElement)(target) ? (0, $ibKgU.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $e628e125e878fd27$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $e628e125e878fd27$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($e628e125e878fd27$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $91U3U.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $91U3U.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $e628e125e878fd27$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e628e125e878fd27$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $2zW56.isPlainObject)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $e628e125e878fd27$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($e628e125e878fd27$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $e628e125e878fd27$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2zW56.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRequire.register("ibKgU", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $d3dd25a69ce66c78$export$5647df6b7814ac86);

var $2zW56 = parcelRequire("2zW56");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $d3dd25a69ce66c78$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
const $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d3dd25a69ce66c78$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d3dd25a69ce66c78$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d3dd25a69ce66c78$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $2zW56.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $d3dd25a69ce66c78$export$1cfafeee2987818b() {
    try {
        return $d3dd25a69ce66c78$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d3dd25a69ce66c78$export$c660c1f3ab49225c(selector) {
    if ($d3dd25a69ce66c78$var$WINDOW.document && $d3dd25a69ce66c78$var$WINDOW.document.querySelector) return $d3dd25a69ce66c78$var$WINDOW.document.querySelector(selector);
    return null;
}

});
parcelRequire.register("2zW56", function(module, exports) {

$parcel$export(module.exports, "isError", () => $1e0be767ffa822d8$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $1e0be767ffa822d8$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $1e0be767ffa822d8$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $1e0be767ffa822d8$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $1e0be767ffa822d8$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $1e0be767ffa822d8$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $1e0be767ffa822d8$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $1e0be767ffa822d8$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $1e0be767ffa822d8$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isNaN", () => $1e0be767ffa822d8$export$c9f5652083b8129d);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $1e0be767ffa822d8$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$e6127cc7fe7395c3(wat) {
    switch($1e0be767ffa822d8$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $1e0be767ffa822d8$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$var$isBuiltin(wat, className) {
    return $1e0be767ffa822d8$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9f9636d330b71954(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$ef9e2056653f0c8e(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$12e869b2a583f783(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$844ec244b1367d54(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $1e0be767ffa822d8$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49841c62b9eff15(wat) {
    return $1e0be767ffa822d8$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $1e0be767ffa822d8$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$bc2894c7158efbac(wat) {
    return $1e0be767ffa822d8$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $1e0be767ffa822d8$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRequire.register("91U3U", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $692fb1c9fae23fc3$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $692fb1c9fae23fc3$export$4215662d762d6f9d);

var $2zW56 = parcelRequire("2zW56");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $692fb1c9fae23fc3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $692fb1c9fae23fc3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $692fb1c9fae23fc3$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $2zW56.isString)(value)) return false;
    if ((0, $2zW56.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $2zW56.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $692fb1c9fae23fc3$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$692fb1c9fae23fc3$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ function $692fb1c9fae23fc3$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

});



parcelRequire.register("coQoV", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $90705fab783f17f9$export$775b6bb06e53a214);

var $b1E2c = parcelRequire("b1E2c");
var $cvSY8 = parcelRequire("cvSY8");
var $3bpJ1 = parcelRequire("3bpJ1");
var $2zW56 = parcelRequire("2zW56");
var $4g0Ct = parcelRequire("4g0Ct");
var $j3a3y = parcelRequire("j3a3y");

var $oyvka = parcelRequire("oyvka");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $90705fab783f17f9$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $90705fab783f17f9$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $oyvka.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $90705fab783f17f9$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $90705fab783f17f9$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $2zW56.isPlainObject)(captureContext)) {
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $90705fab783f17f9$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $cvSY8.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs = [
            ...this._breadcrumbs,
            mergedBreadcrumb
        ].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = {
                transaction: transactionName,
                ...event.tags
            };
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [
            ...event.breadcrumbs || [],
            ...this._breadcrumbs
        ];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata
        };
        return this._notifyEventProcessors([
            ...$90705fab783f17f9$var$getGlobalEventProcessors(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * This will be called after {@link applyToEvent} is finished.
   */ _notifyEventProcessors(processors, event, hint, index = 0) {
        return new (0, $j3a3y.SyncPromise)((resolve, reject)=>{
            const processor = processors[index];
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                const result = processor({
                    ...event
                }, hint);
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && processor.id && result === null && (0, $4g0Ct.logger).log(`Event processor "${processor.id}" dropped event`);
                if ((0, $2zW56.isThenable)(result)) result.then((final)=>this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
                else this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $b1E2c.arrayify)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
/**
 * Returns the global event processors.
 */ function $90705fab783f17f9$var$getGlobalEventProcessors() {
    return (0, $3bpJ1.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $90705fab783f17f9$export$8e4e25f54d456511(callback) {
    $90705fab783f17f9$var$getGlobalEventProcessors().push(callback);
}

});
parcelRequire.register("j3a3y", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", () => $dde6191ffa17294f$export$6f292d4960313241);

var $2zW56 = parcelRequire("2zW56");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $dde6191ffa17294f$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($dde6191ffa17294f$var$States || ($dde6191ffa17294f$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $dde6191ffa17294f$export$1fda8aa4d135f8aa(value) {
    return new $dde6191ffa17294f$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $dde6191ffa17294f$export$78e43115b553f358(reason) {
    return new $dde6191ffa17294f$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $dde6191ffa17294f$export$6f292d4960313241 {
    __init() {
        this._state = $dde6191ffa17294f$var$States.PENDING;
    }
    __init2() {
        this._handlers = [];
    }
    constructor(executor){
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init2.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init3.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init4.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init5.call(this);
        $dde6191ffa17294f$export$6f292d4960313241.prototype.__init6.call(this);
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $dde6191ffa17294f$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init3() {
        this._resolve = (value)=>{
            this._setResult($dde6191ffa17294f$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init4() {
        this._reject = (reason)=>{
            this._setResult($dde6191ffa17294f$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init5() {
        this._setResult = (state, value)=>{
            if (this._state !== $dde6191ffa17294f$var$States.PENDING) return;
            if ((0, $2zW56.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init6() {
        this._executeHandlers = ()=>{
            if (this._state === $dde6191ffa17294f$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $dde6191ffa17294f$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $dde6191ffa17294f$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});

parcelRequire.register("oyvka", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $049d01d3a3164ac2$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $049d01d3a3164ac2$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $049d01d3a3164ac2$export$56521d9ba90f62ee);

var $jL8lq = parcelRequire("jL8lq");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $049d01d3a3164ac2$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $cvSY8.timestampInSeconds)();
    const session = {
        sid: (0, $b1E2c.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$049d01d3a3164ac2$var$sessionToJSON(session)
    };
    if (context) $049d01d3a3164ac2$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $049d01d3a3164ac2$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $cvSY8.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $b1E2c.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $049d01d3a3164ac2$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $049d01d3a3164ac2$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $049d01d3a3164ac2$var$sessionToJSON(session) {
    return (0, $jL8lq.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});



parcelRequire.register("6IwWN", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $4e4068cc7b2f1e19$export$637857c1d87b640c);

var $js14m = parcelRequire("js14m");
var $4g0Ct = parcelRequire("4g0Ct");

var $iwSqi = parcelRequire("iwSqi");
/**
 * Configures global error listeners
 */ function $4e4068cc7b2f1e19$export$637857c1d87b640c() {
    (0, $js14m.addInstrumentationHandler)("error", $4e4068cc7b2f1e19$var$errorCallback);
    (0, $js14m.addInstrumentationHandler)("unhandledrejection", $4e4068cc7b2f1e19$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $4e4068cc7b2f1e19$var$errorCallback() {
    const activeTransaction = (0, $iwSqi.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}

});
parcelRequire.register("js14m", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $e2917634788cccfb$export$285b9172a3741fb7);

var $2zW56 = parcelRequire("2zW56");

var $4g0Ct = parcelRequire("4g0Ct");

var $jL8lq = parcelRequire("jL8lq");

var $16dZf = parcelRequire("16dZf");

var $esO9h = parcelRequire("esO9h");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $e2917634788cccfb$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $e2917634788cccfb$var$handlers = {};
const $e2917634788cccfb$var$instrumented = {};
/** Instruments given API */ function $e2917634788cccfb$var$instrument(type) {
    if ($e2917634788cccfb$var$instrumented[type]) return;
    $e2917634788cccfb$var$instrumented[type] = true;
    switch(type){
        case "console":
            $e2917634788cccfb$var$instrumentConsole();
            break;
        case "dom":
            $e2917634788cccfb$var$instrumentDOM();
            break;
        case "xhr":
            $e2917634788cccfb$var$instrumentXHR();
            break;
        case "fetch":
            $e2917634788cccfb$var$instrumentFetch();
            break;
        case "history":
            $e2917634788cccfb$var$instrumentHistory();
            break;
        case "error":
            $e2917634788cccfb$var$instrumentError();
            break;
        case "unhandledrejection":
            $e2917634788cccfb$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("unknown instrumentation type:", type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e2917634788cccfb$export$285b9172a3741fb7(type, callback) {
    $e2917634788cccfb$var$handlers[type] = $e2917634788cccfb$var$handlers[type] || [];
    $e2917634788cccfb$var$handlers[type].push(callback);
    $e2917634788cccfb$var$instrument(type);
}
/** JSDoc */ function $e2917634788cccfb$var$triggerHandlers(type, data) {
    if (!type || !$e2917634788cccfb$var$handlers[type]) return;
    for (const handler of $e2917634788cccfb$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $16dZf.getFunctionName)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $e2917634788cccfb$var$instrumentConsole() {
    if (!("console" in $e2917634788cccfb$var$WINDOW)) return;
    (0, $4g0Ct.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $e2917634788cccfb$var$WINDOW.console)) return;
        (0, $jL8lq.fill)($e2917634788cccfb$var$WINDOW.console, level, function(originalConsoleMethod) {
            return function(...args) {
                $e2917634788cccfb$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($e2917634788cccfb$var$WINDOW.console, args);
            };
        });
    });
}
/** JSDoc */ function $e2917634788cccfb$var$instrumentFetch() {
    if (!(0, $esO9h.supportsNativeFetch)()) return;
    (0, $jL8lq.fill)($e2917634788cccfb$var$WINDOW, "fetch", function(originalFetch) {
        return function(...args) {
            const handlerData = {
                args: args,
                fetchData: {
                    method: $e2917634788cccfb$var$getFetchMethod(args),
                    url: $e2917634788cccfb$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $e2917634788cccfb$var$triggerHandlers("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($e2917634788cccfb$var$WINDOW, args).then((response)=>{
                $e2917634788cccfb$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $e2917634788cccfb$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $e2917634788cccfb$var$getFetchMethod(fetchArgs = []) {
    if ("Request" in $e2917634788cccfb$var$WINDOW && (0, $2zW56.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return "GET";
}
/** Extract `url` from fetch call arguments */ function $e2917634788cccfb$var$getFetchUrl(fetchArgs = []) {
    if (typeof fetchArgs[0] === "string") return fetchArgs[0];
    if ("Request" in $e2917634788cccfb$var$WINDOW && (0, $2zW56.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $e2917634788cccfb$var$instrumentXHR() {
    if (!("XMLHttpRequest" in $e2917634788cccfb$var$WINDOW)) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $jL8lq.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const xhr = this;
            const url = args[1];
            const xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $2zW56.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $2zW56.isString)(url) && xhrInfo.method === "POST" && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            const onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $e2917634788cccfb$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ("onreadystatechange" in xhr && typeof xhr.onreadystatechange === "function") (0, $jL8lq.fill)(xhr, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener("readystatechange", onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $jL8lq.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $e2917634788cccfb$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $e2917634788cccfb$var$lastHref;
/** JSDoc */ function $e2917634788cccfb$var$instrumentHistory() {
    if (!(0, $esO9h.supportsHistory)()) return;
    const oldOnPopState = $e2917634788cccfb$var$WINDOW.onpopstate;
    $e2917634788cccfb$var$WINDOW.onpopstate = function(...args) {
        const to = $e2917634788cccfb$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $e2917634788cccfb$var$lastHref;
        $e2917634788cccfb$var$lastHref = to;
        $e2917634788cccfb$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $e2917634788cccfb$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $e2917634788cccfb$var$lastHref = to;
                $e2917634788cccfb$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $jL8lq.fill)($e2917634788cccfb$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $jL8lq.fill)($e2917634788cccfb$var$WINDOW.history, "replaceState", historyReplacementFunction);
}
const $e2917634788cccfb$var$debounceDuration = 1000;
let $e2917634788cccfb$var$debounceTimerID;
let $e2917634788cccfb$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $e2917634788cccfb$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $e2917634788cccfb$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== "keypress") return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $e2917634788cccfb$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $e2917634788cccfb$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($e2917634788cccfb$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($e2917634788cccfb$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $e2917634788cccfb$var$lastCapturedEvent = event;
        } else if ($e2917634788cccfb$var$shouldShortcircuitPreviousDebounce($e2917634788cccfb$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $e2917634788cccfb$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($e2917634788cccfb$var$debounceTimerID);
        $e2917634788cccfb$var$debounceTimerID = $e2917634788cccfb$var$WINDOW.setTimeout(()=>{
            $e2917634788cccfb$var$debounceTimerID = undefined;
        }, $e2917634788cccfb$var$debounceDuration);
    };
}
/** JSDoc */ function $e2917634788cccfb$var$instrumentDOM() {
    if (!("document" in $e2917634788cccfb$var$WINDOW)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $e2917634788cccfb$var$triggerHandlers.bind(null, "dom");
    const globalDOMEventHandler = $e2917634788cccfb$var$makeDOMEventHandler(triggerDOMHandler, true);
    $e2917634788cccfb$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $e2917634788cccfb$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $e2917634788cccfb$var$WINDOW[target] && $e2917634788cccfb$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $jL8lq.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $e2917634788cccfb$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $jL8lq.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $e2917634788cccfb$var$_oldOnErrorHandler = null;
/** JSDoc */ function $e2917634788cccfb$var$instrumentError() {
    $e2917634788cccfb$var$_oldOnErrorHandler = $e2917634788cccfb$var$WINDOW.onerror;
    $e2917634788cccfb$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $e2917634788cccfb$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($e2917634788cccfb$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $e2917634788cccfb$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
let $e2917634788cccfb$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $e2917634788cccfb$var$instrumentUnhandledRejection() {
    $e2917634788cccfb$var$_oldOnUnhandledRejectionHandler = $e2917634788cccfb$var$WINDOW.onunhandledrejection;
    $e2917634788cccfb$var$WINDOW.onunhandledrejection = function(e) {
        $e2917634788cccfb$var$triggerHandlers("unhandledrejection", e);
        if ($e2917634788cccfb$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $e2917634788cccfb$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRequire.register("16dZf", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", () => $0cd1337813906a62$export$aad197c7121a6651);
const $0cd1337813906a62$var$STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $0cd1337813906a62$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        for (const line of stack.split("\n").slice(skipFirst)){
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = line.replace(/\(error: (.*)\)/, "$1");
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
        }
        return $0cd1337813906a62$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $0cd1337813906a62$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $0cd1337813906a62$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * @hidden
 */ function $0cd1337813906a62$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    let localStack = stack;
    const firstFrameFunction = localStack[0].function || "";
    const lastFrameFunction = localStack[localStack.length - 1].function || "";
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf("captureMessage") !== -1 || firstFrameFunction.indexOf("captureException") !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf("sentryWrapped") !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $0cd1337813906a62$var$STACKTRACE_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[0].filename,
            function: frame.function || "?"
        })).reverse();
}
const $0cd1337813906a62$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $0cd1337813906a62$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $0cd1337813906a62$var$defaultFunctionName;
        return fn.name || $0cd1337813906a62$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $0cd1337813906a62$var$defaultFunctionName;
    }
}
// eslint-disable-next-line complexity
function $0cd1337813906a62$var$node(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        const lineMatch = line.match(FULL_MATCH);
        if (!lineMatch) return undefined;
        let object;
        let method;
        let functionName;
        let typeName;
        let methodName;
        if (lineMatch[1]) {
            functionName = lineMatch[1];
            let methodStart = functionName.lastIndexOf(".");
            if (functionName[methodStart - 1] === ".") methodStart--;
            if (methodStart > 0) {
                object = functionName.slice(0, methodStart);
                method = functionName.slice(methodStart + 1);
                const objectEnd = object.indexOf(".Module");
                if (objectEnd > 0) {
                    functionName = functionName.slice(objectEnd + 1);
                    object = object.slice(0, objectEnd);
                }
            }
            typeName = undefined;
        }
        if (method) {
            typeName = object;
            methodName = method;
        }
        if (method === "<anonymous>") {
            methodName = undefined;
            functionName = undefined;
        }
        if (functionName === undefined) {
            methodName = methodName || "<anonymous>";
            functionName = typeName ? `${typeName}.${methodName}` : methodName;
        }
        const filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
        const isNative = lineMatch[5] === "native";
        const isInternal = isNative || filename && !filename.startsWith("/") && !filename.startsWith(".") && filename.indexOf(":\\") !== 1;
        // in_app is all that's not an internal Node function or a module within node_modules
        // note that isNative appears to return true even for node core libraries
        // see https://github.com/getsentry/raven-node/issues/176
        const in_app = !isInternal && filename !== undefined && !filename.includes("node_modules/");
        return {
            filename: filename,
            module: getModule ? getModule(filename) : undefined,
            function: functionName,
            lineno: parseInt(lineMatch[3], 10) || undefined,
            colno: parseInt(lineMatch[4], 10) || undefined,
            in_app: in_app
        };
    };
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $0cd1337813906a62$export$673345a0da635a78(getModule) {
    return [
        90,
        $0cd1337813906a62$var$node(getModule)
    ];
}

});

parcelRequire.register("esO9h", function(module, exports) {

$parcel$export(module.exports, "supportsNativeFetch", () => $a87a94b8e4ff7f26$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsHistory", () => $a87a94b8e4ff7f26$export$67fc34576016d6ec);

var $4g0Ct = parcelRequire("4g0Ct");

var $3bpJ1 = parcelRequire("3bpJ1");
// eslint-disable-next-line deprecation/deprecation
const $a87a94b8e4ff7f26$var$WINDOW = (0, $3bpJ1.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a87a94b8e4ff7f26$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a87a94b8e4ff7f26$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a87a94b8e4ff7f26$export$c82d238e23c40b21() {
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a87a94b8e4ff7f26$export$18cf36ed71d733e7($a87a94b8e4ff7f26$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a87a94b8e4ff7f26$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a87a94b8e4ff7f26$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$531055a6c684a70a() {
    return "ReportingObserver" in $a87a94b8e4ff7f26$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a87a94b8e4ff7f26$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $a87a94b8e4ff7f26$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $a87a94b8e4ff7f26$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $a87a94b8e4ff7f26$var$WINDOW && !!$a87a94b8e4ff7f26$var$WINDOW.history.pushState && !!$a87a94b8e4ff7f26$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRequire.register("iwSqi", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $d7d56e6ebc6c1ccf$export$5008da00b1b6dee6);
$parcel$export(module.exports, "getActiveTransaction", () => $d7d56e6ebc6c1ccf$export$a7feb32fdd923295);

var $cmFjP = parcelRequire("cmFjP");

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $d7d56e6ebc6c1ccf$export$5008da00b1b6dee6(maybeOptions) {
    const client = (0, $cmFjP.getCurrentHub)().getClient();
    const options = maybeOptions || client && client.getOptions();
    return !!options && ("tracesSampleRate" in options || "tracesSampler" in options);
}
/** Grabs active transaction off scope, if any */ function $d7d56e6ebc6c1ccf$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $cmFjP.getCurrentHub)();
    const scope = hub.getScope();
    return scope && scope.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $d7d56e6ebc6c1ccf$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}

});


parcelRequire.register("7pcHN", function(module, exports) {

$parcel$export(module.exports, "IdleTransaction", () => $5644b93d607dbbeb$export$b279e6bd7040371f);

var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");

var $fX68s = parcelRequire("fX68s");

var $aRkAb = parcelRequire("aRkAb");
const $5644b93d607dbbeb$export$68a507a5e6cb6de5 = 1000;
const $5644b93d607dbbeb$export$a9bb9f6cf9cd1d42 = 30000;
const $5644b93d607dbbeb$export$2cbc60a145813952 = 5000;
/**
 * @inheritDoc
 */ class $5644b93d607dbbeb$export$370d6113c18ba86c extends (0, $fX68s.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $cvSY8.timestampWithMs)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $5644b93d607dbbeb$export$b279e6bd7040371f extends (0, $aRkAb.Transaction) {
    // Activities store a list of active spans
    __init() {
        this.activities = {};
    }
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    __init2() {
        this._heartbeatCounter = 0;
    }
    // We should not use heartbeat if we finished a transaction
    __init3() {
        this._finished = false;
    }
    __init4() {
        this._beforeFinishCallbacks = [];
    }
    /**
   * Timer that tracks Transaction idleTimeout
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $5644b93d607dbbeb$export$68a507a5e6cb6de5, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $5644b93d607dbbeb$export$a9bb9f6cf9cd1d42, _heartbeatInterval = $5644b93d607dbbeb$export$2cbc60a145813952, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        $5644b93d607dbbeb$export$b279e6bd7040371f.prototype.__init.call(this);
        $5644b93d607dbbeb$export$b279e6bd7040371f.prototype.__init2.call(this);
        $5644b93d607dbbeb$export$b279e6bd7040371f.prototype.__init3.call(this);
        $5644b93d607dbbeb$export$b279e6bd7040371f.prototype.__init4.call(this);
        if (_onScope) {
            // There should only be one active transaction on the scope
            $5644b93d607dbbeb$var$clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._startIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $cvSY8.timestampWithMs)()) {
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus("cancelled");
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", JSON.stringify(span, undefined, 2));
                return keepSpan;
            });
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] flushing IdleTransaction");
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) $5644b93d607dbbeb$var$clearActiveTransaction(this._idleHub);
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $5644b93d607dbbeb$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idletimeout, if there is one
   */ _cancelIdleTimeout() {
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
        }
    }
    /**
   * Creates an idletimeout
   */ _startIdleTimeout(endTimestamp) {
        this._cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) this.finish(endTimestamp);
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this._cancelIdleTimeout();
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            const endTimestamp = (0, $cvSY8.timestampWithMs)() + this._idleTimeout / 1000;
            this._startIdleTimeout(endTimestamp);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus("deadline_exceeded");
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}
/**
 * Reset transaction on scope to `undefined`
 */ function $5644b93d607dbbeb$var$clearActiveTransaction(hub) {
    const scope = hub.getScope();
    if (scope) {
        const transaction = scope.getTransaction();
        if (transaction) scope.setSpan(undefined);
    }
}

});
parcelRequire.register("fX68s", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $b9d120122ceccb68$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $b9d120122ceccb68$export$5f1714a13ed34c01);

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");
var $b1E2c = parcelRequire("b1E2c");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $b9d120122ceccb68$export$10c95c129cd0d4fe {
    __init() {
        this.spans = [];
    }
    constructor(maxlen = 1000){
        $b9d120122ceccb68$export$10c95c129cd0d4fe.prototype.__init.call(this);
        this._maxlen = maxlen;
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $b9d120122ceccb68$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ __init2() {
        this.traceId = (0, $b1E2c.uuid4)();
    }
    /**
   * @inheritDoc
   */ __init3() {
        this.spanId = (0, $b1E2c.uuid4)().substring(16);
    }
    /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ __init4() {
        this.startTimestamp = (0, $cvSY8.timestampWithMs)();
    }
    /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ __init5() {
        this.tags = {};
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __init6() {
        this.data = {};
    }
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ __init7() {
        this.instrumenter = "sentry";
    }
    /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext){
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init2.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init3.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init4.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init5.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init6.call(this);
        $b9d120122ceccb68$export$5f1714a13ed34c01.prototype.__init7.call(this);
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
        if (spanContext.instrumenter) this.instrumenter = spanContext.instrumenter;
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $b9d120122ceccb68$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = childSpan.transaction.name || "< unknown name >";
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $4g0Ct.logger).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag("http.status_code", String(httpStatus));
        const spanStatus = $b9d120122ceccb68$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== "unknown_error") this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === "ok";
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $4g0Ct.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $cvSY8.timestampWithMs)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        let sampledString = "";
        if (this.sampled !== undefined) sampledString = this.sampled ? "-1" : "-0";
        return `${this.traceId}-${this.spanId}${sampledString}`;
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $jL8lq.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $b9d120122ceccb68$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}

});

parcelRequire.register("aRkAb", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $7e7ed1ea7bbcc692$export$febc5573c75cefb0);

var $cmFjP = parcelRequire("cmFjP");

var $jL8lq = parcelRequire("jL8lq");
var $4g0Ct = parcelRequire("4g0Ct");
var $cvSY8 = parcelRequire("cvSY8");

var $fX68s = parcelRequire("fX68s");
/** JSDoc */ class $7e7ed1ea7bbcc692$export$febc5573c75cefb0 extends (0, $fX68s.Span) {
    /**
   * The reference to the current hub.
   */ __init() {
        this._measurements = {};
    }
    __init2() {
        this._contexts = {};
    }
    __init3() {
        this._frozenDynamicSamplingContext = undefined;
    }
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        $7e7ed1ea7bbcc692$export$febc5573c75cefb0.prototype.__init.call(this);
        $7e7ed1ea7bbcc692$export$febc5573c75cefb0.prototype.__init2.call(this);
        $7e7ed1ea7bbcc692$export$febc5573c75cefb0.prototype.__init3.call(this);
        this._hub = hub || (0, $cmFjP.getCurrentHub)();
        this._name = transactionContext.name || "";
        this.metadata = {
            source: "custom",
            ...transactionContext.metadata,
            spanMetadata: {},
            changes: [],
            propagations: 0
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = "custom") {
        // `source` could change without the name changing if we discover that an unparameterized route is actually
        // parameterized by virtue of having no parameters in its path
        if (name !== this.name || source !== this.metadata.source) this.metadata.changes.push({
            // log previous source
            source: this.metadata.source,
            timestamp: (0, $cvSY8.timestampInSeconds)(),
            propagations: this.metadata.propagations
        });
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $fX68s.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this.name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            const client = this._hub.getClient();
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source,
                    changes: metadata.changes,
                    propagations: metadata.propagations
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $4g0Ct.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $jL8lq.dropUndefinedKeys)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $cmFjP.getCurrentHub)();
        const client = hub && hub.getClient();
        if (!client) return {};
        const { environment: environment, release: release } = client.getOptions() || {};
        const { publicKey: public_key } = client.getDsn() || {};
        const maybeSampleRate = this.metadata.sampleRate;
        const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;
        const scope = hub.getScope();
        const { segment: user_segment } = scope && scope.getUser() || {};
        const source = this.metadata.source;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const transaction = source && source !== "url" ? this.name : undefined;
        const dsc = (0, $jL8lq.dropUndefinedKeys)({
            environment: environment,
            release: release,
            transaction: transaction,
            user_segment: user_segment,
            public_key: public_key,
            trace_id: this.traceId,
            sample_rate: sample_rate
        });
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        return dsc;
    }
}

});



parcelRequire.register("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRequire.register("5Gn6I", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = mergeWith;

});

parcelRequire.register("8RYFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $675256233f0d2ee0$export$2e2bcd8739ae039);

var $gvVBt = parcelRequire("gvVBt");
var $675256233f0d2ee0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $675256233f0d2ee0$var$index = (0, $gvVBt.default)(function(prop) {
    return $675256233f0d2ee0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $675256233f0d2ee0$export$2e2bcd8739ae039 = $675256233f0d2ee0$var$index;

});
parcelRequire.register("gvVBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05c3971f0aa92b4$export$2e2bcd8739ae039);
function $c05c3971f0aa92b4$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $c05c3971f0aa92b4$export$2e2bcd8739ae039 = $c05c3971f0aa92b4$var$memoize;

});


parcelRequire.register("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRequire.register("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $b0Nlg = parcelRequire("b0Nlg");









// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === "undefined" || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $b0Nlg.addExtensionMethods)();


/**
 * React Router DOM v6.6.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.2.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref (to) {
            return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            index = clampIndex(index + delta);
            if (listener) listener({
                action: action,
                location: getCurrentLocation()
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$var$warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$var$warning$1(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location) {
    return {
        usr: location.state,
        key: location.key
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$createClientSideURL(location) {
    // window.location.origin is "null" (the literal string value) in Firefox
    // under certain conditions, notably when serving from a local HTML file
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
    let base = typeof window !== "undefined" && typeof window.location !== "undefined" && window.location.origin !== "null" ? window.location.origin : window.location.href;
    let href = typeof location === "string" ? location : $1d34d5c4a288b213$export$fe53371bee54353d(location);
    $1d34d5c4a288b213$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL for href: " + href);
    return new URL(href, base);
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        if (listener) listener({
            action: action,
            location: history.location
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location
        });
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = $1d34d5c4a288b213$var$createClientSideURL(typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, parentPath, allIds) {
    if (parentPath === void 0) parentPath = [];
    if (allIds === void 0) allIds = new Set();
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$f5708dca728d7177(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$f5708dca728d7177(!allIds.has(id), 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        allIds.add(id);
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, {
                id: id
            });
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, {
                id: id,
                children: route.children ? $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, treePath, allIds) : undefined
            });
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$f5708dca728d7177(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$491112666e282270(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    return path.replace(/^:(\w+)/g, (_, key)=>{
        $1d34d5c4a288b213$export$f5708dca728d7177(params[key] != null, 'Missing ":' + key + '" param');
        return params[key];
    }).replace(/\/:(\w+)/g, (_, key)=>{
        $1d34d5c4a288b213$export$f5708dca728d7177(params[key] != null, 'Missing ":' + key + '" param');
        return "/" + params[key];
    }).replace(/(\/?)\*/, (_, prefix, __, str)=>{
        const star = "*";
        if (params[star] == null) // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
         // Apply the splat
        return "" + prefix + params[star];
    });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$491112666e282270(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$491112666e282270(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$491112666e282270(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$491112666e282270(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$var$DeferredData {
    constructor(data){
        this.pendingKeys = new Set();
        this.subscriber = undefined;
        $1d34d5c4a288b213$export$f5708dca728d7177(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.pendingKeys.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeys.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        const subscriber = this.subscriber;
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            subscriber && subscriber(false);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        subscriber && subscriber(false);
        return data;
    }
    subscribe(fn) {
        this.subscriber = fn;
    }
    cancel() {
        this.controller.abort();
        this.pendingKeys.forEach((v, k)=>this.pendingKeys.delete(k));
        let subscriber = this.subscriber;
        subscriber && subscriber(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeys.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$f5708dca728d7177(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
function $1d34d5c4a288b213$export$260e5c0943f31606(data) {
    return new $1d34d5c4a288b213$var$DeferredData(data);
}
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response throw from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(e) {
    return e instanceof $1d34d5c4a288b213$export$acf1a680051f5031;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $1d34d5c4a288b213$var$isServer = !$1d34d5c4a288b213$var$isBrowser; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    $1d34d5c4a288b213$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = !initialMatches.some((m)=>m.route.loader) || init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location } = _ref;
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            // Don't restore on submission navigations
            restoreScrollPosition: state.navigation.formData ? false : getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: pendingPreventScrollReset
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(to, opts);
        let location = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        location = $1d34d5c4a288b213$var$_extends({}, location, init.history.encodeLocation(location));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        return await startNavigation(historyAction, location, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change
        if ($1d34d5c4a288b213$var$isHashChangeOnly(state.location, location)) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw new Error("defer() is not supported in actions");
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission ? submission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((_ref2)=>{
                let [key] = _ref2;
                let fetcher = state.fetchers.get(key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((_ref3)=>{
            let [key] = _ref3;
            return fetchControllers.set(key, pendingNavigationController);
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((_ref4)=>{
            let [key] = _ref4;
            return fetchControllers.delete(key);
        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($1d34d5c4a288b213$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $1d34d5c4a288b213$var$normalizeNavigateOptions(href, opts, true);
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, [
            path,
            match,
            matches
        ]);
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $1d34d5c4a288b213$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) $1d34d5c4a288b213$export$f5708dca728d7177(false, "defer() is not supported in actions");
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, state.navigation.location, init.basename) : state.matches;
        $1d34d5c4a288b213$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
            [match.route.id]: actionResult.data
        }, undefined, fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((_ref5)=>{
            let [staleKey] = _ref5;
            return staleKey !== key;
        }).forEach((_ref6)=>{
            let [staleKey] = _ref6;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((_ref7)=>{
            let [staleKey] = _ref7;
            return fetchControllers.delete(staleKey);
        });
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, router.basename); // Deferred isn't supported or fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$f5708dca728d7177(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, $1d34d5c4a288b213$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $1d34d5c4a288b213$export$f5708dca728d7177(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an external redirect that goes to a new origin
        if (typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let newOrigin = $1d34d5c4a288b213$var$createClientSideURL(redirect.location).origin;
            if (window.location.origin !== newOrigin) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, submission, {
                formAction: redirect.location
            })
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            }
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, router.basename)),
            ...fetchersToLoad.map((_ref8)=>{
                let [, href, match, fetchMatches] = _ref8;
                return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(href, request.signal), match, fetchMatches, router.basename);
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((_ref9)=>{
                let [, , match] = _ref9;
                return match;
            }), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$f5708dca728d7177(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$f5708dca728d7177(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "head") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "head") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        let routeData = [
            result.actionData,
            result.loaderData
        ].find((v)=>v);
        return Object.values(routeData || {})[0];
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error && !$1d34d5c4a288b213$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw new Error("defer() is not supported in actions");
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        let executedLoaders = new Set();
        results.forEach((result, i)=>{
            executedLoaders.add(matchesToLoad[i].route.id); // Can't do anything with these without the Remix side of things, so just
            // cancel them for now
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) result.deferredData.cancel();
        }); // Process and commit output from loaders
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError); // Add a null for any non-loader matches for proper revalidation on the client
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(to, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        submission = {
            formMethod: opts.formMethod || "get",
            formAction: $1d34d5c4a288b213$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    try {
        let searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
        // navigation GET submissions which run all loaders), we need to preserve
        // any incoming ?index params
        if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
        parsedPath.search = "?" + searchParams;
    } catch (e) {
        return {
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400)
        };
    }
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>match.route.loader != null && ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || // If this route had a pending deferred cancelled it must be revalidated
        cancelledDeferredRoutes.some((id)=>id === match.route.id) || $1d34d5c4a288b213$var$shouldRevalidateLoader(state.location, state.matches[index], submission, location, match, isRevalidationRequired, actionResult))); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches && fetchLoadMatches.forEach((_ref10, key)=>{
        let [href, match, fetchMatches] = _ref10;
        // This fetcher was cancelled from a prior action submission - force reload
        if (cancelledFetcherLoads.includes(key)) revalidatingFetchers.push([
            key,
            href,
            match,
            fetchMatches
        ]);
        else if (isRevalidationRequired) {
            let shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(href, match, submission, href, match, isRevalidationRequired, actionResult);
            if (shouldRevalidate) revalidatingFetchers.push([
                key,
                href,
                match,
                fetchMatches
            ]);
        }
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(currentLocation, currentMatch, submission, location, match, isRevalidationRequired, actionResult) {
    let currentUrl = $1d34d5c4a288b213$var$createClientSideURL(currentLocation);
    let currentParams = currentMatch.params;
    let nextUrl = $1d34d5c4a288b213$var$createClientSideURL(location);
    let nextParams = match.params; // This is the default implementation as to when we revalidate.  If the route
    // provides it's own implementation, then we give them full control but
    // provide this value so they can leverage it if needed after they check
    // their own specific use cases
    // Note that fetchers always provide the same current/next locations so the
    // URL-based checks here don't apply to fetcher shouldRevalidate calls
    let defaultShouldRevalidate = $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search || // Forced revalidation due to submission, useRevalidate, or X-Remix-Revalidate
    isRevalidationRequired;
    if (match.route.shouldRevalidate) {
        let routeChoice = match.route.shouldRevalidate($1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentParams,
            nextUrl: nextUrl,
            nextParams: nextParams
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return defaultShouldRevalidate;
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result; // Setup a promise we can race against so that abort signals short circuit
    let reject;
    let abortPromise = new Promise((_, r)=>reject = r);
    let onReject = ()=>reject();
    request.signal.addEventListener("abort", onReject);
    try {
        let handler = match.route[type];
        $1d34d5c4a288b213$export$f5708dca728d7177(handler, "Could not find the " + type + ' to run on the "' + match.route.id + '" route');
        result = await Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
        $1d34d5c4a288b213$export$f5708dca728d7177(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            let isAbsolute = /^[a-z+]+:\/\//i.test(location) || location.startsWith("//"); // Support relative routing in internal redirects
            if (!isAbsolute) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $1d34d5c4a288b213$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $1d34d5c4a288b213$export$f5708dca728d7177($1d34d5c4a288b213$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $1d34d5c4a288b213$export$fe53371bee54353d(resolvedLocation);
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $1d34d5c4a288b213$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if (result instanceof $1d34d5c4a288b213$var$DeferredData) return {
        type: $1d34d5c4a288b213$var$ResultType.deferred,
        deferredData: result
    };
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(location, signal, submission) {
    let url = $1d34d5c4a288b213$var$createClientSideURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission;
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries()){
        $1d34d5c4a288b213$export$f5708dca728d7177(typeof value === "string", 'File inputs are not supported with encType "application/x-www-form-urlencoded", please use "multipart/form-data" instead.');
        searchParams.append(key, value);
    }
    return searchParams;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$f5708dca728d7177(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds && activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data; // TODO: Add statusCode/headers once we wire up streaming in Remix
        } else {
            loaderData[id] = result.data; // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let [key, , match] = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$f5708dca728d7177(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        throw new Error("Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        throw new Error("Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else errorMessage = "Cannot submit binary form data using GET";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return result;
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method);
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method);
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $1d34d5c4a288b213$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.6.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $acw62 = parcelRequire("acw62");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $7939e29d663dd3ed$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $7939e29d663dd3ed$var$is = typeof Object.is === "function" ? Object.is : $7939e29d663dd3ed$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $7939e29d663dd3ed$var$useState, useEffect: $7939e29d663dd3ed$var$useEffect, useLayoutEffect: $7939e29d663dd3ed$var$useLayoutEffect, useDebugValue: $7939e29d663dd3ed$var$useDebugValue } = $acw62;
let $7939e29d663dd3ed$var$didWarnOld18Alpha = false;
let $7939e29d663dd3ed$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $7939e29d663dd3ed$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $7939e29d663dd3ed$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $7939e29d663dd3ed$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($7939e29d663dd3ed$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $7939e29d663dd3ed$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($7939e29d663dd3ed$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($7939e29d663dd3ed$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $7939e29d663dd3ed$var$useDebugValue(value);
    return value;
}
function $7939e29d663dd3ed$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$7939e29d663dd3ed$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $7939e29d663dd3ed$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $7939e29d663dd3ed$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $7939e29d663dd3ed$var$isServerEnvironment = !$7939e29d663dd3ed$var$canUseDOM;
const $7939e29d663dd3ed$var$shim = $7939e29d663dd3ed$var$isServerEnvironment ? $7939e29d663dd3ed$var$useSyncExternalStore$1 : $7939e29d663dd3ed$var$useSyncExternalStore$2;
const $7939e29d663dd3ed$var$useSyncExternalStore = "useSyncExternalStore" in $acw62 ? ((module)=>module.useSyncExternalStore)($acw62) : $7939e29d663dd3ed$var$shim;
// Contexts for data routers
const $7939e29d663dd3ed$export$30522a91b9deeaa0 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: []
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let dataRouterStateContext = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorElement() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unhandled Thrown Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, /*#__PURE__*/ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own\xa0", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "errorElement"), " props on\xa0", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "<Route>")));
}
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataStaticRouterContext = $acw62.useContext($7939e29d663dd3ed$export$30522a91b9deeaa0); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataStaticRouterContext && match.route.errorElement) dataStaticRouterContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorElement, null) : null;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>/*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches
                }
            }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
        // errorElement on this route.  Otherwise let it bubble up to an ancestor
        // errorElement
        return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($7939e29d663dd3ed$var$DataRouterHook || ($7939e29d663dd3ed$var$DataRouterHook = {}));
var $7939e29d663dd3ed$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($7939e29d663dd3ed$var$DataRouterStateHook || ($7939e29d663dd3ed$var$DataRouterStateHook = {}));
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return route;
}
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Sync router state to our component state to force re-renders
    let state = $7939e29d663dd3ed$var$useSyncExternalStore(router.subscribe, ()=>router.state, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    ()=>router.state);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: {
            router: router,
            navigator: navigator,
            static: false,
            basename: // Do we need this?
            basename
        }
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3565eb3d00ca5a74, null) : fallbackElement)));
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let dataRouterState = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    $acw62.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $7939e29d663dd3ed$export$16da398f5434bdec(children);
    return $7939e29d663dd3ed$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($7939e29d663dd3ed$var$AwaitRenderStatus || ($7939e29d663dd3ed$var$AwaitRenderStatus = {}));
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    if (typeof children === "function") return children(data);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, children);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, parentPath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        let treePath = [
            ...parentPath,
            index
        ];
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            hasErrorBoundary: element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */ function $7939e29d663dd3ed$export$c7b301c52f838c5f(routes) {
    return routes.map((route)=>{
        let routeClone = $7939e29d663dd3ed$var$_extends({}, route);
        if (routeClone.hasErrorBoundary == null) routeClone.hasErrorBoundary = routeClone.errorElement != null;
        if (routeClone.children) routeClone.children = $7939e29d663dd3ed$export$c7b301c52f838c5f(routeClone.children);
        return routeClone;
    });
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: $7939e29d663dd3ed$export$c7b301c52f838c5f(routes)
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
        searchParams.append(key, value);
    });
    return searchParams;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $040dbb9c344a508d$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative"
];
//#region Routers
////////////////////////////////////////////////////////////////////////////////
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: (0, $7939e29d663dd3ed$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: (0, $7939e29d663dd3ed$export$c7b301c52f838c5f)(routes)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: href,
        onClick: reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        ref: ref
    }));
});
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>$040dbb9c344a508d$var$getSearchParamsForLocation(location.search, defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    return $040dbb9c344a508d$var$useSubmitImpl();
}
function $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $040dbb9c344a508d$export$89a6bd6db0d97c56();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
            !routeId && (0, $1d34d5c4a288b213$export$f5708dca728d7177)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on unload
    $040dbb9c344a508d$export$c0a586b329cae57d($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Opt out of scroll reset if this link requested it
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback) {
    $acw62.useEffect(()=>{
        window.addEventListener("beforeunload", callback);
        return ()=>{
            window.removeEventListener("beforeunload", callback);
        };
    }, [
        callback
    ]);
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////
function $040dbb9c344a508d$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} //#endregion


// src/chakra-provider.tsx
// src/chakra-provider.tsx
// src/css-reset.tsx

var $acw62 = parcelRequire("acw62");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var O = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(O, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(O += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            O += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            O += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            O += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    O += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(O) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(O) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(O + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(O, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    O += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(O, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(O, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(O, 3) === 110 ? 100 : v){
                            case 100:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(O, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = O = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(O), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(O += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (O += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(O) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) O += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = O += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(O) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var k = 0, g = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; k < h; ++k)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[k] + " " + g : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(g, /&\f/g, p[k]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = $d68ffb0773f38e18$var$weakMemoize;


function $6bb1e54ce1bc6efa$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $6bb1e54ce1bc6efa$export$2e2bcd8739ae039 = $6bb1e54ce1bc6efa$var$memoize;


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? children[0].children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = $fc182b1f84212d3f$var$createCache;



var $acw62 = parcelRequire("acw62");

function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}



var $72623ab6bcb0a33b$exports = {};
"use strict";
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};
var $f1be2661c8fac766$export$2e2bcd8739ae039 = $f1be2661c8fac766$var$hoistNonReactStatics;


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $3629985b3ecf741f$export$2e2bcd8739ae039 = $3629985b3ecf741f$var$murmur2;


var $936be3b045ab836e$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $936be3b045ab836e$export$2e2bcd8739ae039 = $936be3b045ab836e$var$unitlessKeys;



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || (0, $acw62.useLayoutEffect);


var $ea69b9ccc73b096b$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $ea69b9ccc73b096b$var$EmotionCacheContext = /* #__PURE__ */ (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: "css"
}) : null);
var $ea69b9ccc73b096b$export$e7094788287c5e9b = $ea69b9ccc73b096b$var$EmotionCacheContext.Provider;
var $ea69b9ccc73b096b$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($ea69b9ccc73b096b$var$EmotionCacheContext);
};
var $ea69b9ccc73b096b$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($ea69b9ccc73b096b$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $ea69b9ccc73b096b$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $acw62.createContext)({});
var $ea69b9ccc73b096b$export$3b14a55fb2447963 = function useTheme() {
    return (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
};
var $ea69b9ccc73b096b$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $ea69b9ccc73b096b$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $ea69b9ccc73b096b$var$getTheme(outerTheme, theme);
    });
});
var $ea69b9ccc73b096b$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $ea69b9ccc73b096b$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $acw62.createElement)($ea69b9ccc73b096b$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $ea69b9ccc73b096b$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $acw62.createElement)(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $acw62.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $ea69b9ccc73b096b$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $ea69b9ccc73b096b$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $ea69b9ccc73b096b$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $ea69b9ccc73b096b$var$getLastPart(match[1]);
    return undefined;
};
var $ea69b9ccc73b096b$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $ea69b9ccc73b096b$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $ea69b9ccc73b096b$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $ea69b9ccc73b096b$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($ea69b9ccc73b096b$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $ea69b9ccc73b096b$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $ea69b9ccc73b096b$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $ea69b9ccc73b096b$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $ea69b9ccc73b096b$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($ea69b9ccc73b096b$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$ea69b9ccc73b096b$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $ea69b9ccc73b096b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $ea69b9ccc73b096b$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $ea69b9ccc73b096b$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$ea69b9ccc73b096b$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(registeredStyles, undefined, (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($ea69b9ccc73b096b$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $ea69b9ccc73b096b$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($ea69b9ccc73b096b$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ (0, $acw62.createElement)(WrappedComponent, newProps));
});


var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;








var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.10.5",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.10.5",
        "@emotion/cache": "^11.10.5",
        "@emotion/serialize": "^1.1.1",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
        "@emotion/utils": "^1.2.0",
        "@emotion/weak-memoize": "^0.3.0",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.18.5",
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.10.5",
        "@emotion/css-prettifier": "1.1.1",
        "@emotion/server": "11.10.0",
        "@emotion/styled": "11.10.5",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": "./macro.js"
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $ea69b9ccc73b096b$export$dda1d9f60106f0e9).call(props, "css")) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $ea69b9ccc73b096b$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $ea69b9ccc73b096b$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $ea69b9ccc73b096b$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)([
        styles
    ], undefined, (0, $acw62.useContext)((0, $ea69b9ccc73b096b$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $acw62.useRef)();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $ea69b9ccc73b096b$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $acw62.useContext)((0, $ea69b9ccc73b096b$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;



var $c3a85343c30bb17b$var$css = String.raw;
var $c3a85343c30bb17b$var$vhPolyfill = $c3a85343c30bb17b$var$css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
var $c3a85343c30bb17b$export$43a6590e493ec44a = ()=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: $c3a85343c30bb17b$var$vhPolyfill
    });
var $c3a85343c30bb17b$export$b751feffed387621 = ({ scope: scope = "" })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: $c3a85343c30bb17b$var$css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${$c3a85343c30bb17b$var$vhPolyfill}
    `
    });
var $c3a85343c30bb17b$export$428e8dbfc1580f11 = $c3a85343c30bb17b$export$b751feffed387621;


// src/portal-manager.tsx
// src/index.ts

var $acw62 = parcelRequire("acw62");
function $61ba61605ac0202a$var$getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function $61ba61605ac0202a$export$fd42f52fd3ae1109(options = {}) {
    const { name: name, strict: strict = true, hookName: hookName = "useContext", providerName: providerName = "Provider", errorMessage: errorMessage, defaultValue: defaultValue } = options;
    const Context = (0, $acw62.createContext)(defaultValue);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage != null ? errorMessage : $61ba61605ac0202a$var$getErrorMessage(hookName, providerName));
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}



var [$f0ef0206ab9ab709$var$PortalManagerContextProvider, $f0ef0206ab9ab709$export$ef203b29c2cc1f5d] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalManagerContext"
});
function $f0ef0206ab9ab709$export$52c7ef79917c2f38(props) {
    const { children: children, zIndex: zIndex } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f0ef0206ab9ab709$var$PortalManagerContextProvider, {
        value: {
            zIndex: zIndex
        },
        children: children
    });
}
$f0ef0206ab9ab709$export$52c7ef79917c2f38.displayName = "PortalManager";


// src/color-mode-context.ts

var $acw62 = parcelRequire("acw62");
var $83ba09a61bdcb2b2$export$49ddd74a6729fdb0 = (0, $acw62.createContext)({});
$83ba09a61bdcb2b2$export$49ddd74a6729fdb0.displayName = "ColorModeContext";
function $83ba09a61bdcb2b2$export$20f3076712c8dfa() {
    const context = (0, $acw62.useContext)($83ba09a61bdcb2b2$export$49ddd74a6729fdb0);
    if (context === void 0) throw new Error("useColorMode must be used within a ColorModeProvider");
    return context;
}
function $83ba09a61bdcb2b2$export$d18f2ef57b0d7644(light, dark) {
    const { colorMode: colorMode } = $83ba09a61bdcb2b2$export$20f3076712c8dfa();
    return colorMode === "dark" ? dark : light;
}


// src/color-mode.utils.ts
var $15543f7ed159fa06$var$classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
};
function $15543f7ed159fa06$export$4bb933d353baa01c(options = {}) {
    const { preventTransition: preventTransition = true } = options;
    const utils = {
        setDataset: (value)=>{
            const cleanup = preventTransition ? utils.preventTransition() : void 0;
            document.documentElement.dataset.theme = value;
            document.documentElement.style.colorScheme = value;
            cleanup == null || cleanup();
        },
        setClassName (dark) {
            document.body.classList.add(dark ? $15543f7ed159fa06$var$classNames.dark : $15543f7ed159fa06$var$classNames.light);
            document.body.classList.remove(dark ? $15543f7ed159fa06$var$classNames.light : $15543f7ed159fa06$var$classNames.dark);
        },
        query () {
            return window.matchMedia("(prefers-color-scheme: dark)");
        },
        getSystemTheme (fallback) {
            var _a;
            const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
            return dark ? "dark" : "light";
        },
        addListener (fn) {
            const mql = utils.query();
            const listener = (e)=>{
                fn(e.matches ? "dark" : "light");
            };
            if (typeof mql.addListener === "function") mql.addListener(listener);
            else mql.addEventListener("change", listener);
            return ()=>{
                if (typeof mql.removeListener === "function") mql.removeListener(listener);
                else mql.removeEventListener("change", listener);
            };
        },
        preventTransition () {
            const css = document.createElement("style");
            css.appendChild(document.createTextNode(`*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`));
            document.head.appendChild(css);
            return ()=>{
                (()=>window.getComputedStyle(document.body))();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        document.head.removeChild(css);
                    });
                });
            };
        }
    };
    return utils;
}


// src/storage-manager.ts
var $2e82ebbabe71d234$export$86880b4b2e1a2384 = "chakra-ui-color-mode";
function $2e82ebbabe71d234$export$cdf53b88b62eb393(key) {
    return {
        ssr: false,
        type: "localStorage",
        get (init) {
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            let value;
            try {
                value = localStorage.getItem(key) || init;
            } catch (e) {}
            return value || init;
        },
        set (value) {
            try {
                localStorage.setItem(key, value);
            } catch (e) {}
        }
    };
}
var $2e82ebbabe71d234$export$8e35886de8a54f45 = $2e82ebbabe71d234$export$cdf53b88b62eb393($2e82ebbabe71d234$export$86880b4b2e1a2384);
function $2e82ebbabe71d234$var$parseCookie(cookie, key) {
    const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
    return match == null ? void 0 : match[2];
}
function $2e82ebbabe71d234$export$df28b7d6efe2673c(key, cookie) {
    return {
        ssr: !!cookie,
        type: "cookie",
        get (init) {
            if (cookie) return $2e82ebbabe71d234$var$parseCookie(cookie, key);
            if (!(globalThis == null ? void 0 : globalThis.document)) return init;
            return $2e82ebbabe71d234$var$parseCookie(document.cookie, key) || init;
        },
        set (value) {
            document.cookie = `${key}=${value}; max-age=31536000; path=/`;
        }
    };
}
var $2e82ebbabe71d234$export$2e2b0158437077e3 = $2e82ebbabe71d234$export$df28b7d6efe2673c($2e82ebbabe71d234$export$86880b4b2e1a2384);
var $2e82ebbabe71d234$export$d76e8eed3e914fa0 = (cookie)=>$2e82ebbabe71d234$export$df28b7d6efe2673c($2e82ebbabe71d234$export$86880b4b2e1a2384, cookie);


// src/index.ts

var $acw62 = parcelRequire("acw62");
var $79d69f59c8a92bff$export$deebe11a338de063 = Boolean(globalThis == null ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");

var $23a20d92c4cd8150$var$noop = ()=>{};
function $23a20d92c4cd8150$var$getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function $23a20d92c4cd8150$export$7a858aa3ff83dde7(props) {
    const { value: value, children: children, options: { useSystemColorMode: useSystemColorMode, initialColorMode: initialColorMode, disableTransitionOnChange: disableTransitionOnChange } = {}, colorModeManager: colorModeManager = (0, $2e82ebbabe71d234$export$8e35886de8a54f45) } = props;
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = (0, $acw62.useState)(()=>$23a20d92c4cd8150$var$getTheme(colorModeManager, defaultColorMode));
    const [resolvedColorMode, setResolvedColorMode] = (0, $acw62.useState)(()=>$23a20d92c4cd8150$var$getTheme(colorModeManager));
    const { getSystemTheme: getSystemTheme, setClassName: setClassName, setDataset: setDataset, addListener: addListener } = (0, $acw62.useMemo)(()=>(0, $15543f7ed159fa06$export$4bb933d353baa01c)({
            preventTransition: disableTransitionOnChange
        }), [
        disableTransitionOnChange
    ]);
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = (0, $acw62.useCallback)((value2)=>{
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
    }, [
        colorModeManager,
        getSystemTheme,
        setClassName,
        setDataset
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (initialColorMode === "system") setResolvedColorMode(getSystemTheme());
    }, []);
    (0, $acw62.useEffect)(()=>{
        const managerValue = colorModeManager.get();
        if (managerValue) {
            setColorMode(managerValue);
            return;
        }
        if (initialColorMode === "system") {
            setColorMode("system");
            return;
        }
        setColorMode(defaultColorMode);
    }, [
        colorModeManager,
        defaultColorMode,
        initialColorMode,
        setColorMode
    ]);
    const toggleColorMode = (0, $acw62.useCallback)(()=>{
        setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [
        resolvedValue,
        setColorMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!useSystemColorMode) return;
        return addListener(setColorMode);
    }, [
        useSystemColorMode,
        addListener,
        setColorMode
    ]);
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: value != null ? value : resolvedValue,
            toggleColorMode: value ? $23a20d92c4cd8150$var$noop : toggleColorMode,
            setColorMode: value ? $23a20d92c4cd8150$var$noop : setColorMode,
            forced: value !== void 0
        }), [
        resolvedValue,
        toggleColorMode,
        setColorMode,
        value
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $83ba09a61bdcb2b2$export$49ddd74a6729fdb0).Provider, {
        value: context,
        children: children
    });
}
$23a20d92c4cd8150$export$7a858aa3ff83dde7.displayName = "ColorModeProvider";
function $23a20d92c4cd8150$export$8b41b18ed1f3731e(props) {
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: "dark",
            toggleColorMode: $23a20d92c4cd8150$var$noop,
            setColorMode: $23a20d92c4cd8150$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $83ba09a61bdcb2b2$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$23a20d92c4cd8150$export$8b41b18ed1f3731e.displayName = "DarkMode";
function $23a20d92c4cd8150$export$cee2b1aa9166b2a3(props) {
    const context = (0, $acw62.useMemo)(()=>({
            colorMode: "light",
            toggleColorMode: $23a20d92c4cd8150$var$noop,
            setColorMode: $23a20d92c4cd8150$var$noop,
            forced: true
        }), []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $83ba09a61bdcb2b2$export$49ddd74a6729fdb0).Provider, {
        value: context,
        ...props
    });
}
$23a20d92c4cd8150$export$cee2b1aa9166b2a3.displayName = "LightMode";

// src/providers.tsx

// src/context.ts

var $acw62 = parcelRequire("acw62");
function $e54f09380e048946$export$fd42f52fd3ae1109(options = {}) {
    const { strict: strict = true, errorMessage: errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider", name: name } = options;
    const Context = (0, $acw62.createContext)(void 0);
    Context.displayName = name;
    function useContext() {
        var _a;
        const context = (0, $acw62.useContext)(Context);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = "ContextError";
            (_a = Error.captureStackTrace) == null || _a.call(Error, error, useContext);
            throw error;
        }
        return context;
    }
    return [
        Context.Provider,
        useContext,
        Context
    ];
}


// src/utils/create-transform.ts
// src/index.ts
var $abe97432afb3d989$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $abe97432afb3d989$var$isDev() {
    return false;
}
function $abe97432afb3d989$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var $abe97432afb3d989$export$c106dd0671a0fc2d = (options)=>{
    const { condition: condition, message: message } = options;
    if (condition && $abe97432afb3d989$var$isDev()) console.warn(message);
};
function $abe97432afb3d989$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $abe97432afb3d989$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var $abe97432afb3d989$var$isFunction = (value)=>typeof value === "function";
var $abe97432afb3d989$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $abe97432afb3d989$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
function $abe97432afb3d989$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $abe97432afb3d989$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}



var $5Gn6I = parcelRequire("5Gn6I");
var $47a6d9fbbf7ee42d$var$isImportant = (value)=>/!(important)?$/.test(value);
var $47a6d9fbbf7ee42d$var$withoutImportant = (value)=>typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
var $47a6d9fbbf7ee42d$export$92f5bb613cffac78 = (scale, value)=>(theme)=>{
        const valueStr = String(value);
        const important = $47a6d9fbbf7ee42d$var$isImportant(valueStr);
        const valueWithoutImportant = $47a6d9fbbf7ee42d$var$withoutImportant(valueStr);
        const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
        let transformed = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
        transformed = $47a6d9fbbf7ee42d$var$withoutImportant(transformed);
        return important ? `${transformed} !important` : transformed;
    };
function $47a6d9fbbf7ee42d$var$createTransform(options) {
    const { scale: scale, transform: transform2, compose: compose } = options;
    const fn = (value, theme)=>{
        var _a;
        const _value = $47a6d9fbbf7ee42d$export$92f5bb613cffac78(scale, value)(theme);
        let result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
        if (compose) result = compose(result, theme);
        return result;
    };
    return fn;
}
// src/utils/pipe.ts
var $47a6d9fbbf7ee42d$var$pipe = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
// src/utils/prop-config.ts
function $47a6d9fbbf7ee42d$var$toConfig(scale, transform2) {
    return (property)=>{
        const result = {
            property: property,
            scale: scale
        };
        result.transform = $47a6d9fbbf7ee42d$var$createTransform({
            scale: scale,
            transform: transform2
        });
        return result;
    };
}
var $47a6d9fbbf7ee42d$var$getRtl = ({ rtl: rtl, ltr: ltr })=>(theme)=>theme.direction === "rtl" ? rtl : ltr;
function $47a6d9fbbf7ee42d$var$logical(options) {
    const { property: property, scale: scale, transform: transform2 } = options;
    return {
        scale: scale,
        property: $47a6d9fbbf7ee42d$var$getRtl(property),
        transform: scale ? $47a6d9fbbf7ee42d$var$createTransform({
            scale: scale,
            compose: transform2
        }) : transform2
    };
}
// src/utils/templates.ts
var $47a6d9fbbf7ee42d$var$transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
];
function $47a6d9fbbf7ee42d$var$getTransformTemplate() {
    return [
        "translateX(var(--chakra-translate-x, 0))",
        "translateY(var(--chakra-translate-y, 0))",
        ...$47a6d9fbbf7ee42d$var$transformTemplate
    ].join(" ");
}
function $47a6d9fbbf7ee42d$var$getTransformGpuTemplate() {
    return [
        "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
        ...$47a6d9fbbf7ee42d$var$transformTemplate
    ].join(" ");
}
var $47a6d9fbbf7ee42d$var$filterTemplate = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
        "var(--chakra-blur)",
        "var(--chakra-brightness)",
        "var(--chakra-contrast)",
        "var(--chakra-grayscale)",
        "var(--chakra-hue-rotate)",
        "var(--chakra-invert)",
        "var(--chakra-saturate)",
        "var(--chakra-sepia)",
        "var(--chakra-drop-shadow)"
    ].join(" ")
};
var $47a6d9fbbf7ee42d$var$backdropFilterTemplate = {
    backdropFilter: [
        "var(--chakra-backdrop-blur)",
        "var(--chakra-backdrop-brightness)",
        "var(--chakra-backdrop-contrast)",
        "var(--chakra-backdrop-grayscale)",
        "var(--chakra-backdrop-hue-rotate)",
        "var(--chakra-backdrop-invert)",
        "var(--chakra-backdrop-opacity)",
        "var(--chakra-backdrop-saturate)",
        "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function $47a6d9fbbf7ee42d$var$getRingTemplate(value) {
    return {
        "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
        "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
        "--chakra-ring-width": value,
        boxShadow: [
            `var(--chakra-ring-offset-shadow)`,
            `var(--chakra-ring-shadow)`,
            `var(--chakra-shadow, 0 0 #0000)`
        ].join(", ")
    };
}
var $47a6d9fbbf7ee42d$var$flexDirectionTemplate = {
    "row-reverse": {
        space: "--chakra-space-x-reverse",
        divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
        space: "--chakra-space-y-reverse",
        divide: "--chakra-divide-y-reverse"
    }
};
// src/utils/parse-gradient.ts
var $47a6d9fbbf7ee42d$var$directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
};
var $47a6d9fbbf7ee42d$var$valueSet = new Set(Object.values($47a6d9fbbf7ee42d$var$directionMap));
var $47a6d9fbbf7ee42d$var$globalSet = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
]);
var $47a6d9fbbf7ee42d$var$trimSpace = (str)=>str.trim();
function $47a6d9fbbf7ee42d$var$parseGradient(value, theme) {
    if (value == null || $47a6d9fbbf7ee42d$var$globalSet.has(value)) return value;
    const prevent = $47a6d9fbbf7ee42d$var$isCSSFunction(value) || $47a6d9fbbf7ee42d$var$globalSet.has(value);
    if (!prevent) return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results == null ? void 0 : results[1];
    const values = results == null ? void 0 : results[2];
    if (!type || !values) return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map($47a6d9fbbf7ee42d$var$trimSpace).filter(Boolean);
    if ((stops == null ? void 0 : stops.length) === 0) return value;
    const direction = maybeDirection in $47a6d9fbbf7ee42d$var$directionMap ? $47a6d9fbbf7ee42d$var$directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop)=>{
        if ($47a6d9fbbf7ee42d$var$valueSet.has(stop)) return stop;
        const firstStop = stop.indexOf(" ");
        const [_color, _stop] = firstStop !== -1 ? [
            stop.substr(0, firstStop),
            stop.substr(firstStop + 1)
        ] : [
            stop
        ];
        const _stopOrFunc = $47a6d9fbbf7ee42d$var$isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
        const key = `colors.${_color}`;
        const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
        return _stopOrFunc ? [
            color2,
            ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [
                _stopOrFunc
            ]
        ].join(" ") : color2;
    });
    return `${_type}(${_values.join(", ")})`;
}
var $47a6d9fbbf7ee42d$var$isCSSFunction = (value)=>{
    return typeof value === "string" && value.includes("(") && value.includes(")");
};
var $47a6d9fbbf7ee42d$var$gradientTransform = (value, theme)=>$47a6d9fbbf7ee42d$var$parseGradient(value, theme != null ? theme : {});
// src/utils/transform-functions.ts
function $47a6d9fbbf7ee42d$var$isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
}
var $47a6d9fbbf7ee42d$var$analyzeCSSValue = (value)=>{
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
};
var $47a6d9fbbf7ee42d$var$wrap = (str)=>(value)=>`${str}(${value})`;
var $47a6d9fbbf7ee42d$var$transformFunctions = {
    filter (value) {
        return value !== "auto" ? value : $47a6d9fbbf7ee42d$var$filterTemplate;
    },
    backdropFilter (value) {
        return value !== "auto" ? value : $47a6d9fbbf7ee42d$var$backdropFilterTemplate;
    },
    ring (value) {
        return $47a6d9fbbf7ee42d$var$getRingTemplate($47a6d9fbbf7ee42d$var$transformFunctions.px(value));
    },
    bgClip (value) {
        return value === "text" ? {
            color: "transparent",
            backgroundClip: "text"
        } : {
            backgroundClip: value
        };
    },
    transform (value) {
        if (value === "auto") return $47a6d9fbbf7ee42d$var$getTransformTemplate();
        if (value === "auto-gpu") return $47a6d9fbbf7ee42d$var$getTransformGpuTemplate();
        return value;
    },
    vh (value) {
        return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px (value) {
        if (value == null) return value;
        const { unitless: unitless } = $47a6d9fbbf7ee42d$var$analyzeCSSValue(value);
        return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction (value) {
        return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float (value, theme) {
        const map = {
            left: "right",
            right: "left"
        };
        return theme.direction === "rtl" ? map[value] : value;
    },
    degree (value) {
        if ($47a6d9fbbf7ee42d$var$isCssVar(value) || value == null) return value;
        const unitless = typeof value === "string" && !value.endsWith("deg");
        return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: $47a6d9fbbf7ee42d$var$gradientTransform,
    blur: $47a6d9fbbf7ee42d$var$wrap("blur"),
    opacity: $47a6d9fbbf7ee42d$var$wrap("opacity"),
    brightness: $47a6d9fbbf7ee42d$var$wrap("brightness"),
    contrast: $47a6d9fbbf7ee42d$var$wrap("contrast"),
    dropShadow: $47a6d9fbbf7ee42d$var$wrap("drop-shadow"),
    grayscale: $47a6d9fbbf7ee42d$var$wrap("grayscale"),
    hueRotate: $47a6d9fbbf7ee42d$var$wrap("hue-rotate"),
    invert: $47a6d9fbbf7ee42d$var$wrap("invert"),
    saturate: $47a6d9fbbf7ee42d$var$wrap("saturate"),
    sepia: $47a6d9fbbf7ee42d$var$wrap("sepia"),
    bgImage (value) {
        if (value == null) return value;
        const prevent = $47a6d9fbbf7ee42d$var$isCSSFunction(value) || $47a6d9fbbf7ee42d$var$globalSet.has(value);
        return !prevent ? `url(${value})` : value;
    },
    outline (value) {
        const isNoneOrZero = String(value) === "0" || String(value) === "none";
        return value !== null && isNoneOrZero ? {
            outline: "2px solid transparent",
            outlineOffset: "2px"
        } : {
            outline: value
        };
    },
    flexDirection (value) {
        var _a;
        const { space: space2, divide: divide2 } = (_a = $47a6d9fbbf7ee42d$var$flexDirectionTemplate[value]) != null ? _a : {};
        const result = {
            flexDirection: value
        };
        if (space2) result[space2] = 1;
        if (divide2) result[divide2] = 1;
        return result;
    }
};
// src/utils/index.ts
var $47a6d9fbbf7ee42d$var$t = {
    borderWidths: $47a6d9fbbf7ee42d$var$toConfig("borderWidths"),
    borderStyles: $47a6d9fbbf7ee42d$var$toConfig("borderStyles"),
    colors: $47a6d9fbbf7ee42d$var$toConfig("colors"),
    borders: $47a6d9fbbf7ee42d$var$toConfig("borders"),
    gradients: $47a6d9fbbf7ee42d$var$toConfig("gradients", $47a6d9fbbf7ee42d$var$transformFunctions.gradient),
    radii: $47a6d9fbbf7ee42d$var$toConfig("radii", $47a6d9fbbf7ee42d$var$transformFunctions.px),
    space: $47a6d9fbbf7ee42d$var$toConfig("space", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    spaceT: $47a6d9fbbf7ee42d$var$toConfig("space", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    degreeT (property) {
        return {
            property: property,
            transform: $47a6d9fbbf7ee42d$var$transformFunctions.degree
        };
    },
    prop (property, scale, transform2) {
        return {
            property: property,
            scale: scale,
            ...scale && {
                transform: $47a6d9fbbf7ee42d$var$createTransform({
                    scale: scale,
                    transform: transform2
                })
            }
        };
    },
    propT (property, transform2) {
        return {
            property: property,
            transform: transform2
        };
    },
    sizes: $47a6d9fbbf7ee42d$var$toConfig("sizes", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.px)),
    sizesT: $47a6d9fbbf7ee42d$var$toConfig("sizes", $47a6d9fbbf7ee42d$var$pipe($47a6d9fbbf7ee42d$var$transformFunctions.vh, $47a6d9fbbf7ee42d$var$transformFunctions.fraction)),
    shadows: $47a6d9fbbf7ee42d$var$toConfig("shadows"),
    logical: $47a6d9fbbf7ee42d$var$logical,
    blur: $47a6d9fbbf7ee42d$var$toConfig("blur", $47a6d9fbbf7ee42d$var$transformFunctions.blur)
};
// src/config/background.ts
var $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412 = {
    background: $47a6d9fbbf7ee42d$var$t.colors("background"),
    backgroundColor: $47a6d9fbbf7ee42d$var$t.colors("backgroundColor"),
    backgroundImage: $47a6d9fbbf7ee42d$var$t.gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.bgClip
    },
    bgSize: $47a6d9fbbf7ee42d$var$t.prop("backgroundSize"),
    bgPosition: $47a6d9fbbf7ee42d$var$t.prop("backgroundPosition"),
    bg: $47a6d9fbbf7ee42d$var$t.colors("background"),
    bgColor: $47a6d9fbbf7ee42d$var$t.colors("backgroundColor"),
    bgPos: $47a6d9fbbf7ee42d$var$t.prop("backgroundPosition"),
    bgRepeat: $47a6d9fbbf7ee42d$var$t.prop("backgroundRepeat"),
    bgAttachment: $47a6d9fbbf7ee42d$var$t.prop("backgroundAttachment"),
    bgGradient: $47a6d9fbbf7ee42d$var$t.gradients("backgroundImage"),
    bgClip: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.bgClip
    }
};
Object.assign($47a6d9fbbf7ee42d$export$8ce1fd94bee2f412, {
    bgImage: $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412.backgroundImage,
    bgImg: $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412.backgroundImage
});
// src/config/border.ts
var $47a6d9fbbf7ee42d$export$1edee58a52776cd9 = {
    border: $47a6d9fbbf7ee42d$var$t.borders("border"),
    borderWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderWidth"),
    borderStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderStyle"),
    borderColor: $47a6d9fbbf7ee42d$var$t.colors("borderColor"),
    borderRadius: $47a6d9fbbf7ee42d$var$t.radii("borderRadius"),
    borderTop: $47a6d9fbbf7ee42d$var$t.borders("borderTop"),
    borderBlockStart: $47a6d9fbbf7ee42d$var$t.borders("borderBlockStart"),
    borderTopLeftRadius: $47a6d9fbbf7ee42d$var$t.radii("borderTopLeftRadius"),
    borderStartStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopLeftRadius",
            rtl: "borderTopRightRadius"
        }
    }),
    borderEndStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomLeftRadius",
            rtl: "borderBottomRightRadius"
        }
    }),
    borderTopRightRadius: $47a6d9fbbf7ee42d$var$t.radii("borderTopRightRadius"),
    borderStartEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderTopRightRadius",
            rtl: "borderTopLeftRadius"
        }
    }),
    borderEndEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: "borderBottomRightRadius",
            rtl: "borderBottomLeftRadius"
        }
    }),
    borderRight: $47a6d9fbbf7ee42d$var$t.borders("borderRight"),
    borderInlineEnd: $47a6d9fbbf7ee42d$var$t.borders("borderInlineEnd"),
    borderBottom: $47a6d9fbbf7ee42d$var$t.borders("borderBottom"),
    borderBlockEnd: $47a6d9fbbf7ee42d$var$t.borders("borderBlockEnd"),
    borderBottomLeftRadius: $47a6d9fbbf7ee42d$var$t.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: $47a6d9fbbf7ee42d$var$t.radii("borderBottomRightRadius"),
    borderLeft: $47a6d9fbbf7ee42d$var$t.borders("borderLeft"),
    borderInlineStart: {
        property: "borderInlineStart",
        scale: "borders"
    },
    borderInlineStartRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ],
            rtl: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ]
        }
    }),
    borderInlineEndRadius: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "radii",
        property: {
            ltr: [
                "borderTopRightRadius",
                "borderBottomRightRadius"
            ],
            rtl: [
                "borderTopLeftRadius",
                "borderBottomLeftRadius"
            ]
        }
    }),
    borderX: $47a6d9fbbf7ee42d$var$t.borders([
        "borderLeft",
        "borderRight"
    ]),
    borderInline: $47a6d9fbbf7ee42d$var$t.borders("borderInline"),
    borderY: $47a6d9fbbf7ee42d$var$t.borders([
        "borderTop",
        "borderBottom"
    ]),
    borderBlock: $47a6d9fbbf7ee42d$var$t.borders("borderBlock"),
    borderTopWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderTopWidth"),
    borderBlockStartWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBlockStartWidth"),
    borderTopColor: $47a6d9fbbf7ee42d$var$t.colors("borderTopColor"),
    borderBlockStartColor: $47a6d9fbbf7ee42d$var$t.colors("borderBlockStartColor"),
    borderTopStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderTopStyle"),
    borderBlockStartStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderBlockEndWidth"),
    borderBottomColor: $47a6d9fbbf7ee42d$var$t.colors("borderBottomColor"),
    borderBlockEndColor: $47a6d9fbbf7ee42d$var$t.colors("borderBlockEndColor"),
    borderBottomStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderInlineStartWidth"),
    borderLeftColor: $47a6d9fbbf7ee42d$var$t.colors("borderLeftColor"),
    borderInlineStartColor: $47a6d9fbbf7ee42d$var$t.colors("borderInlineStartColor"),
    borderLeftStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderInlineStartStyle"),
    borderRightWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderRightWidth"),
    borderInlineEndWidth: $47a6d9fbbf7ee42d$var$t.borderWidths("borderInlineEndWidth"),
    borderRightColor: $47a6d9fbbf7ee42d$var$t.colors("borderRightColor"),
    borderInlineEndColor: $47a6d9fbbf7ee42d$var$t.colors("borderInlineEndColor"),
    borderRightStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderRightStyle"),
    borderInlineEndStyle: $47a6d9fbbf7ee42d$var$t.borderStyles("borderInlineEndStyle"),
    borderTopRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopLeftRadius",
        "borderTopRightRadius"
    ]),
    borderBottomRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderBottomLeftRadius",
        "borderBottomRightRadius"
    ]),
    borderLeftRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopLeftRadius",
        "borderBottomLeftRadius"
    ]),
    borderRightRadius: $47a6d9fbbf7ee42d$var$t.radii([
        "borderTopRightRadius",
        "borderBottomRightRadius"
    ])
};
Object.assign($47a6d9fbbf7ee42d$export$1edee58a52776cd9, {
    rounded: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderRadius,
    roundedTop: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopRadius,
    roundedTopLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopLeftRadius,
    roundedTopRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderTopRightRadius,
    roundedTopStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartStartRadius,
    roundedTopEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartEndRadius,
    roundedBottom: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomRadius,
    roundedBottomLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomLeftRadius,
    roundedBottomRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderBottomRightRadius,
    roundedBottomStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndStartRadius,
    roundedBottomEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndEndRadius,
    roundedLeft: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderLeftRadius,
    roundedRight: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderRightRadius,
    roundedStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartRadius,
    roundedEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStart: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStart,
    borderEnd: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEnd,
    borderTopStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartStartRadius,
    borderTopEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderStartEndRadius,
    borderBottomStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndStartRadius,
    borderBottomEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderEndEndRadius,
    borderStartRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartRadius,
    borderEndRadius: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndRadius,
    borderStartWidth: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartWidth,
    borderEndWidth: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndWidth,
    borderStartColor: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartColor,
    borderEndColor: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndColor,
    borderStartStyle: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineStartStyle,
    borderEndStyle: $47a6d9fbbf7ee42d$export$1edee58a52776cd9.borderInlineEndStyle
});
// src/config/color.ts
var $47a6d9fbbf7ee42d$export$35e9368ef982300f = {
    color: $47a6d9fbbf7ee42d$var$t.colors("color"),
    textColor: $47a6d9fbbf7ee42d$var$t.colors("color"),
    fill: $47a6d9fbbf7ee42d$var$t.colors("fill"),
    stroke: $47a6d9fbbf7ee42d$var$t.colors("stroke")
};
// src/config/effect.ts
var $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3 = {
    boxShadow: $47a6d9fbbf7ee42d$var$t.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: $47a6d9fbbf7ee42d$var$t.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: $47a6d9fbbf7ee42d$var$t.prop("backgroundBlendMode"),
    opacity: true
};
Object.assign($47a6d9fbbf7ee42d$export$dc573d8a6576cdb3, {
    shadow: $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3.boxShadow
});
// src/config/filter.ts
var $47a6d9fbbf7ee42d$export$3dea766d36a8935f = {
    filter: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.filter
    },
    blur: $47a6d9fbbf7ee42d$var$t.blur("--chakra-blur"),
    brightness: $47a6d9fbbf7ee42d$var$t.propT("--chakra-brightness", $47a6d9fbbf7ee42d$var$transformFunctions.brightness),
    contrast: $47a6d9fbbf7ee42d$var$t.propT("--chakra-contrast", $47a6d9fbbf7ee42d$var$transformFunctions.contrast),
    hueRotate: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-hue-rotate"),
    invert: $47a6d9fbbf7ee42d$var$t.propT("--chakra-invert", $47a6d9fbbf7ee42d$var$transformFunctions.invert),
    saturate: $47a6d9fbbf7ee42d$var$t.propT("--chakra-saturate", $47a6d9fbbf7ee42d$var$transformFunctions.saturate),
    dropShadow: $47a6d9fbbf7ee42d$var$t.propT("--chakra-drop-shadow", $47a6d9fbbf7ee42d$var$transformFunctions.dropShadow),
    backdropFilter: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.backdropFilter
    },
    backdropBlur: $47a6d9fbbf7ee42d$var$t.blur("--chakra-backdrop-blur"),
    backdropBrightness: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-brightness", $47a6d9fbbf7ee42d$var$transformFunctions.brightness),
    backdropContrast: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-contrast", $47a6d9fbbf7ee42d$var$transformFunctions.contrast),
    backdropHueRotate: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-backdrop-hue-rotate"),
    backdropInvert: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-invert", $47a6d9fbbf7ee42d$var$transformFunctions.invert),
    backdropSaturate: $47a6d9fbbf7ee42d$var$t.propT("--chakra-backdrop-saturate", $47a6d9fbbf7ee42d$var$transformFunctions.saturate)
};
// src/config/flexbox.ts
var $47a6d9fbbf7ee42d$export$feec61708a55c80e = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.flexDirection
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: $47a6d9fbbf7ee42d$var$t.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: $47a6d9fbbf7ee42d$var$t.space("gap"),
    rowGap: $47a6d9fbbf7ee42d$var$t.space("rowGap"),
    columnGap: $47a6d9fbbf7ee42d$var$t.space("columnGap")
};
Object.assign($47a6d9fbbf7ee42d$export$feec61708a55c80e, {
    flexDir: $47a6d9fbbf7ee42d$export$feec61708a55c80e.flexDirection
});
// src/config/grid.ts
var $47a6d9fbbf7ee42d$export$85fc379452d91af0 = {
    gridGap: $47a6d9fbbf7ee42d$var$t.space("gridGap"),
    gridColumnGap: $47a6d9fbbf7ee42d$var$t.space("gridColumnGap"),
    gridRowGap: $47a6d9fbbf7ee42d$var$t.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
};
// src/config/interactivity.ts
var $47a6d9fbbf7ee42d$export$2499a341a8256d68 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.outline
    },
    outlineOffset: true,
    outlineColor: $47a6d9fbbf7ee42d$var$t.colors("outlineColor")
};
// src/config/layout.ts
var $47a6d9fbbf7ee42d$export$b3219800bda33a1f = {
    width: $47a6d9fbbf7ee42d$var$t.sizesT("width"),
    inlineSize: $47a6d9fbbf7ee42d$var$t.sizesT("inlineSize"),
    height: $47a6d9fbbf7ee42d$var$t.sizes("height"),
    blockSize: $47a6d9fbbf7ee42d$var$t.sizes("blockSize"),
    boxSize: $47a6d9fbbf7ee42d$var$t.sizes([
        "width",
        "height"
    ]),
    minWidth: $47a6d9fbbf7ee42d$var$t.sizes("minWidth"),
    minInlineSize: $47a6d9fbbf7ee42d$var$t.sizes("minInlineSize"),
    minHeight: $47a6d9fbbf7ee42d$var$t.sizes("minHeight"),
    minBlockSize: $47a6d9fbbf7ee42d$var$t.sizes("minBlockSize"),
    maxWidth: $47a6d9fbbf7ee42d$var$t.sizes("maxWidth"),
    maxInlineSize: $47a6d9fbbf7ee42d$var$t.sizes("maxInlineSize"),
    maxHeight: $47a6d9fbbf7ee42d$var$t.sizes("maxHeight"),
    maxBlockSize: $47a6d9fbbf7ee42d$var$t.sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
            const mq = `@media screen and (min-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    hideBelow: {
        scale: "breakpoints",
        transform: (value, theme)=>{
            var _a, _b, _c;
            const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
            const mq = `@media screen and (max-width: ${breakpoint})`;
            return {
                [mq]: {
                    display: "none"
                }
            };
        }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: $47a6d9fbbf7ee42d$var$t.propT("float", $47a6d9fbbf7ee42d$var$transformFunctions.float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
};
Object.assign($47a6d9fbbf7ee42d$export$b3219800bda33a1f, {
    w: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.width,
    h: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.height,
    minW: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.minWidth,
    maxW: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.maxWidth,
    minH: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.minHeight,
    maxH: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.maxHeight,
    overscroll: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehavior,
    overscrollX: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehaviorX,
    overscrollY: $47a6d9fbbf7ee42d$export$b3219800bda33a1f.overscrollBehaviorY
});
// src/config/list.ts
var $47a6d9fbbf7ee42d$export$8837f4fc672e936d = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: $47a6d9fbbf7ee42d$var$t.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: $47a6d9fbbf7ee42d$var$t.prop("listStyleImage")
};
// src/get.ts
function $47a6d9fbbf7ee42d$var$get(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $47a6d9fbbf7ee42d$var$memoize = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $47a6d9fbbf7ee42d$var$memoizedGet = $47a6d9fbbf7ee42d$var$memoize($47a6d9fbbf7ee42d$var$get);
// src/config/others.ts
var $47a6d9fbbf7ee42d$var$srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
var $47a6d9fbbf7ee42d$var$srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
};
var $47a6d9fbbf7ee42d$var$getWithPriority = (theme, key, styles)=>{
    const result = {};
    const obj = $47a6d9fbbf7ee42d$var$memoizedGet(theme, key, {});
    for(const prop in obj){
        const isInStyles = prop in styles && styles[prop] != null;
        if (!isInStyles) result[prop] = obj[prop];
    }
    return result;
};
var $47a6d9fbbf7ee42d$export$36263e8f8d7ce3b1 = {
    srOnly: {
        transform (value) {
            if (value === true) return $47a6d9fbbf7ee42d$var$srOnly;
            if (value === "focusable") return $47a6d9fbbf7ee42d$var$srFocusable;
            return {};
        }
    },
    layerStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
        processResult: true,
        transform: (value, theme, styles)=>$47a6d9fbbf7ee42d$var$getWithPriority(theme, value, styles)
    }
};
// src/config/position.ts
var $47a6d9fbbf7ee42d$export$5880b8b5730aff45 = {
    position: true,
    pos: $47a6d9fbbf7ee42d$var$t.prop("position"),
    zIndex: $47a6d9fbbf7ee42d$var$t.prop("zIndex", "zIndices"),
    inset: $47a6d9fbbf7ee42d$var$t.spaceT("inset"),
    insetX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "left",
        "right"
    ]),
    insetInline: $47a6d9fbbf7ee42d$var$t.spaceT("insetInline"),
    insetY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "top",
        "bottom"
    ]),
    insetBlock: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlock"),
    top: $47a6d9fbbf7ee42d$var$t.spaceT("top"),
    insetBlockStart: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlockStart"),
    bottom: $47a6d9fbbf7ee42d$var$t.spaceT("bottom"),
    insetBlockEnd: $47a6d9fbbf7ee42d$var$t.spaceT("insetBlockEnd"),
    left: $47a6d9fbbf7ee42d$var$t.spaceT("left"),
    insetInlineStart: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "space",
        property: {
            ltr: "left",
            rtl: "right"
        }
    }),
    right: $47a6d9fbbf7ee42d$var$t.spaceT("right"),
    insetInlineEnd: $47a6d9fbbf7ee42d$var$t.logical({
        scale: "space",
        property: {
            ltr: "right",
            rtl: "left"
        }
    })
};
Object.assign($47a6d9fbbf7ee42d$export$5880b8b5730aff45, {
    insetStart: $47a6d9fbbf7ee42d$export$5880b8b5730aff45.insetInlineStart,
    insetEnd: $47a6d9fbbf7ee42d$export$5880b8b5730aff45.insetInlineEnd
});
// src/config/ring.ts
var $47a6d9fbbf7ee42d$export$e7d0da6968da5dd = {
    ring: {
        transform: $47a6d9fbbf7ee42d$var$transformFunctions.ring
    },
    ringColor: $47a6d9fbbf7ee42d$var$t.colors("--chakra-ring-color"),
    ringOffset: $47a6d9fbbf7ee42d$var$t.prop("--chakra-ring-offset-width"),
    ringOffsetColor: $47a6d9fbbf7ee42d$var$t.colors("--chakra-ring-offset-color"),
    ringInset: $47a6d9fbbf7ee42d$var$t.prop("--chakra-ring-inset")
};
// src/config/space.ts
var $47a6d9fbbf7ee42d$export$a941ed4b947d12f8 = {
    margin: $47a6d9fbbf7ee42d$var$t.spaceT("margin"),
    marginTop: $47a6d9fbbf7ee42d$var$t.spaceT("marginTop"),
    marginBlockStart: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlockStart"),
    marginRight: $47a6d9fbbf7ee42d$var$t.spaceT("marginRight"),
    marginInlineEnd: $47a6d9fbbf7ee42d$var$t.spaceT("marginInlineEnd"),
    marginBottom: $47a6d9fbbf7ee42d$var$t.spaceT("marginBottom"),
    marginBlockEnd: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlockEnd"),
    marginLeft: $47a6d9fbbf7ee42d$var$t.spaceT("marginLeft"),
    marginInlineStart: $47a6d9fbbf7ee42d$var$t.spaceT("marginInlineStart"),
    marginX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "marginInlineStart",
        "marginInlineEnd"
    ]),
    marginInline: $47a6d9fbbf7ee42d$var$t.spaceT("marginInline"),
    marginY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "marginTop",
        "marginBottom"
    ]),
    marginBlock: $47a6d9fbbf7ee42d$var$t.spaceT("marginBlock"),
    padding: $47a6d9fbbf7ee42d$var$t.space("padding"),
    paddingTop: $47a6d9fbbf7ee42d$var$t.space("paddingTop"),
    paddingBlockStart: $47a6d9fbbf7ee42d$var$t.space("paddingBlockStart"),
    paddingRight: $47a6d9fbbf7ee42d$var$t.space("paddingRight"),
    paddingBottom: $47a6d9fbbf7ee42d$var$t.space("paddingBottom"),
    paddingBlockEnd: $47a6d9fbbf7ee42d$var$t.space("paddingBlockEnd"),
    paddingLeft: $47a6d9fbbf7ee42d$var$t.space("paddingLeft"),
    paddingInlineStart: $47a6d9fbbf7ee42d$var$t.space("paddingInlineStart"),
    paddingInlineEnd: $47a6d9fbbf7ee42d$var$t.space("paddingInlineEnd"),
    paddingX: $47a6d9fbbf7ee42d$var$t.space([
        "paddingInlineStart",
        "paddingInlineEnd"
    ]),
    paddingInline: $47a6d9fbbf7ee42d$var$t.space("paddingInline"),
    paddingY: $47a6d9fbbf7ee42d$var$t.space([
        "paddingTop",
        "paddingBottom"
    ]),
    paddingBlock: $47a6d9fbbf7ee42d$var$t.space("paddingBlock")
};
Object.assign($47a6d9fbbf7ee42d$export$a941ed4b947d12f8, {
    m: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.margin,
    mt: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginTop,
    mr: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginRight,
    me: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineEnd,
    marginEnd: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineEnd,
    mb: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginBottom,
    ml: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginLeft,
    ms: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineStart,
    marginStart: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginInlineStart,
    mx: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginX,
    my: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.marginY,
    p: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.padding,
    pt: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingTop,
    py: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingY,
    px: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingX,
    pb: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingBottom,
    pl: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingLeft,
    ps: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineStart,
    paddingStart: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineStart,
    pr: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingRight,
    pe: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineEnd,
    paddingEnd: $47a6d9fbbf7ee42d$export$a941ed4b947d12f8.paddingInlineEnd
});
// src/config/text-decoration.ts
var $47a6d9fbbf7ee42d$export$6b7f9af9aa033040 = {
    textDecorationColor: $47a6d9fbbf7ee42d$var$t.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: {
        property: "textDecoration"
    },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: $47a6d9fbbf7ee42d$var$t.shadows("textShadow")
};
// src/config/transform.ts
var $47a6d9fbbf7ee42d$export$51186ad6e864892a = {
    clipPath: true,
    transform: $47a6d9fbbf7ee42d$var$t.propT("transform", $47a6d9fbbf7ee42d$var$transformFunctions.transform),
    transformOrigin: true,
    translateX: $47a6d9fbbf7ee42d$var$t.spaceT("--chakra-translate-x"),
    translateY: $47a6d9fbbf7ee42d$var$t.spaceT("--chakra-translate-y"),
    skewX: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-skew-x"),
    skewY: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-skew-y"),
    scaleX: $47a6d9fbbf7ee42d$var$t.prop("--chakra-scale-x"),
    scaleY: $47a6d9fbbf7ee42d$var$t.prop("--chakra-scale-y"),
    scale: $47a6d9fbbf7ee42d$var$t.prop([
        "--chakra-scale-x",
        "--chakra-scale-y"
    ]),
    rotate: $47a6d9fbbf7ee42d$var$t.degreeT("--chakra-rotate")
};
// src/config/transition.ts
var $47a6d9fbbf7ee42d$export$66bb15e2994e6a26 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: $47a6d9fbbf7ee42d$var$t.prop("transitionDuration", "transition.duration"),
    transitionProperty: $47a6d9fbbf7ee42d$var$t.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: $47a6d9fbbf7ee42d$var$t.prop("transitionTimingFunction", "transition.easing")
};
// src/config/typography.ts
var $47a6d9fbbf7ee42d$export$d846a084e680d8e = {
    fontFamily: $47a6d9fbbf7ee42d$var$t.prop("fontFamily", "fonts"),
    fontSize: $47a6d9fbbf7ee42d$var$t.prop("fontSize", "fontSizes", $47a6d9fbbf7ee42d$var$transformFunctions.px),
    fontWeight: $47a6d9fbbf7ee42d$var$t.prop("fontWeight", "fontWeights"),
    lineHeight: $47a6d9fbbf7ee42d$var$t.prop("lineHeight", "lineHeights"),
    letterSpacing: $47a6d9fbbf7ee42d$var$t.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
        transform (value) {
            if (value === true) return {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            };
        }
    },
    noOfLines: {
        static: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: "var(--chakra-line-clamp)"
        },
        property: "--chakra-line-clamp"
    }
};
// src/config/scroll.ts
var $47a6d9fbbf7ee42d$export$209876d7b1ac8f3 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    scrollMargin: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMargin"),
    scrollMarginTop: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginTop"),
    scrollMarginBottom: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginBottom"),
    scrollMarginLeft: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginLeft"),
    scrollMarginRight: $47a6d9fbbf7ee42d$var$t.spaceT("scrollMarginRight"),
    scrollMarginX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollMarginLeft",
        "scrollMarginRight"
    ]),
    scrollMarginY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollMarginTop",
        "scrollMarginBottom"
    ]),
    scrollPadding: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPadding"),
    scrollPaddingTop: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: $47a6d9fbbf7ee42d$var$t.spaceT("scrollPaddingRight"),
    scrollPaddingX: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollPaddingLeft",
        "scrollPaddingRight"
    ]),
    scrollPaddingY: $47a6d9fbbf7ee42d$var$t.spaceT([
        "scrollPaddingTop",
        "scrollPaddingBottom"
    ])
};
function $47a6d9fbbf7ee42d$var$resolveReference(operand) {
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $47a6d9fbbf7ee42d$var$toExpression = (operator, ...operands)=>operands.map($47a6d9fbbf7ee42d$var$resolveReference).join(` ${operator} `).replace(/calc/g, "");
var $47a6d9fbbf7ee42d$var$add = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("+", ...operands)})`;
var $47a6d9fbbf7ee42d$var$subtract = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("-", ...operands)})`;
var $47a6d9fbbf7ee42d$var$multiply = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("*", ...operands)})`;
var $47a6d9fbbf7ee42d$var$divide = (...operands)=>`calc(${$47a6d9fbbf7ee42d$var$toExpression("/", ...operands)})`;
var $47a6d9fbbf7ee42d$var$negate = (x)=>{
    const value = $47a6d9fbbf7ee42d$var$resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $47a6d9fbbf7ee42d$var$multiply(value, -1);
};
var $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$add(x, ...operands)),
        subtract: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$subtract(x, ...operands)),
        multiply: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$multiply(x, ...operands)),
        divide: (...operands)=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$divide(x, ...operands)),
        negate: ()=>$47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a($47a6d9fbbf7ee42d$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $47a6d9fbbf7ee42d$var$add,
    subtract: $47a6d9fbbf7ee42d$var$subtract,
    multiply: $47a6d9fbbf7ee42d$var$multiply,
    divide: $47a6d9fbbf7ee42d$var$divide,
    negate: $47a6d9fbbf7ee42d$var$negate
});
// src/create-theme-vars/css-var.ts
function $47a6d9fbbf7ee42d$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $47a6d9fbbf7ee42d$var$escape(value) {
    const valueStr = $47a6d9fbbf7ee42d$var$replaceWhiteSpace(value.toString());
    return $47a6d9fbbf7ee42d$var$escapeSymbol($47a6d9fbbf7ee42d$var$escapeDot(valueStr));
}
function $47a6d9fbbf7ee42d$var$escapeDot(value) {
    if (value.includes("\\.")) return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
}
function $47a6d9fbbf7ee42d$var$escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function $47a6d9fbbf7ee42d$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        value
    ].filter(Boolean).join("-");
}
function $47a6d9fbbf7ee42d$export$bb435e137b4b8e38(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function $47a6d9fbbf7ee42d$export$3695bd65cc73dae9(value, prefix = "") {
    return $47a6d9fbbf7ee42d$var$escape(`--${$47a6d9fbbf7ee42d$export$9748efee331ec573(value, prefix)}`);
}
function $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(name, fallback, cssVarPrefix) {
    const cssVariable = $47a6d9fbbf7ee42d$export$3695bd65cc73dae9(name, cssVarPrefix);
    return {
        variable: cssVariable,
        reference: $47a6d9fbbf7ee42d$export$bb435e137b4b8e38(cssVariable, fallback)
    };
}
function $47a6d9fbbf7ee42d$export$bd40561c6c056841(scope, keys2) {
    const vars = {};
    for (const key of keys2){
        if (Array.isArray(key)) {
            const [name, fallback] = key;
            vars[name] = $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(`${scope}-${name}`, fallback);
            continue;
        }
        vars[key] = $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(`${scope}-${key}`);
    }
    return vars;
}
function $47a6d9fbbf7ee42d$var$getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
}
function $47a6d9fbbf7ee42d$var$analyzeCSSValue2(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return {
        unitless: !unit,
        value: num,
        unit: unit
    };
}
function $47a6d9fbbf7ee42d$var$px(value) {
    if (value == null) return value;
    const { unitless: unitless } = $47a6d9fbbf7ee42d$var$analyzeCSSValue2(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
}
var $47a6d9fbbf7ee42d$var$sortByBreakpointValue = (a, b)=>parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var $47a6d9fbbf7ee42d$var$sortBps = (breakpoints)=>Object.fromEntries(Object.entries(breakpoints).sort($47a6d9fbbf7ee42d$var$sortByBreakpointValue));
function $47a6d9fbbf7ee42d$var$normalize(breakpoints) {
    const sorted = $47a6d9fbbf7ee42d$var$sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
}
function $47a6d9fbbf7ee42d$var$keys(breakpoints) {
    const value = Object.keys($47a6d9fbbf7ee42d$var$sortBps(breakpoints));
    return new Set(value);
}
function $47a6d9fbbf7ee42d$var$subtract2(value) {
    var _a;
    if (!value) return value;
    value = (_a = $47a6d9fbbf7ee42d$var$px(value)) != null ? _a : value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m)=>`${parseFloat(m) + OFFSET}`);
}
function $47a6d9fbbf7ee42d$var$toMediaQueryString(min, max) {
    const query = [
        "@media screen"
    ];
    if (min) query.push("and", `(min-width: ${$47a6d9fbbf7ee42d$var$px(min)})`);
    if (max) query.push("and", `(max-width: ${$47a6d9fbbf7ee42d$var$px(max)})`);
    return query.join(" ");
}
function $47a6d9fbbf7ee42d$var$analyzeBreakpoints(breakpoints) {
    var _a;
    if (!breakpoints) return null;
    breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
    const normalized = $47a6d9fbbf7ee42d$var$normalize(breakpoints);
    const queries = Object.entries(breakpoints).sort($47a6d9fbbf7ee42d$var$sortByBreakpointValue).map(([breakpoint, minW], index, entry)=>{
        var _a2;
        let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
        maxW = parseFloat(maxW) > 0 ? $47a6d9fbbf7ee42d$var$subtract2(maxW) : void 0;
        return {
            _minW: $47a6d9fbbf7ee42d$var$subtract2(minW),
            breakpoint: breakpoint,
            minW: minW,
            maxW: maxW,
            maxWQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(null, maxW),
            minWQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(minW),
            minMaxQuery: $47a6d9fbbf7ee42d$var$toMediaQueryString(minW, maxW)
        };
    });
    const _keys = $47a6d9fbbf7ee42d$var$keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
        keys: _keys,
        normalized: normalized,
        isResponsive (test) {
            const keys2 = Object.keys(test);
            return keys2.length > 0 && keys2.every((key)=>_keys.has(key));
        },
        asObject: $47a6d9fbbf7ee42d$var$sortBps(breakpoints),
        asArray: $47a6d9fbbf7ee42d$var$normalize(breakpoints),
        details: queries,
        get (key) {
            return queries.find((q)=>q.breakpoint === key);
        },
        media: [
            null,
            ...normalized.map((minW)=>$47a6d9fbbf7ee42d$var$toMediaQueryString(minW)).slice(1)
        ],
        toArrayValue (test) {
            if (!(0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(test)) throw new Error("toArrayValue: value must be an object");
            const result = _keysArr.map((bp)=>{
                var _a2;
                return (_a2 = test[bp]) != null ? _a2 : null;
            });
            while($47a6d9fbbf7ee42d$var$getLastItem(result) === null)result.pop();
            return result;
        },
        toObjectValue (test) {
            if (!Array.isArray(test)) throw new Error("toObjectValue: value must be an array");
            return test.reduce((acc, value, index)=>{
                const key = _keysArr[index];
                if (key != null && value != null) acc[key] = value;
                return acc;
            }, {});
        }
    };
}
// src/pseudos.ts
var $47a6d9fbbf7ee42d$var$state = {
    hover: (str, post)=>`${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post)=>`${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post)=>`${str}:focus-visible ${post}`,
    focusWithin: (str, post)=>`${str}:focus-within ${post}`,
    active: (str, post)=>`${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post)=>`${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post)=>`${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post)=>`${str}:checked ${post}, ${str}[data-checked] ${post}`,
    indeterminate: (str, post)=>`${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
    readOnly: (str, post)=>`${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
    expanded: (str, post)=>`${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
    placeholderShown: (str, post)=>`${str}:placeholder-shown ${post}`
};
var $47a6d9fbbf7ee42d$var$toGroup = (fn)=>$47a6d9fbbf7ee42d$var$merge((v)=>fn(v, "&"), "[role=group]", "[data-group]", ".group");
var $47a6d9fbbf7ee42d$var$toPeer = (fn)=>$47a6d9fbbf7ee42d$var$merge((v)=>fn(v, "~ &"), "[data-peer]", ".peer");
var $47a6d9fbbf7ee42d$var$merge = (fn, ...selectors)=>selectors.map(fn).join(", ");
var $47a6d9fbbf7ee42d$export$a36cf593fde2a546 = {
    _hover: "&:hover, &[data-hover]",
    _active: "&:active, &[data-active]",
    _focus: "&:focus, &[data-focus]",
    _highlighted: "&[data-highlighted]",
    _focusWithin: "&:focus-within",
    _focusVisible: "&:focus-visible, &[data-focus-visible]",
    _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    _before: "&::before",
    _after: "&::after",
    _empty: "&:empty",
    _expanded: "&[aria-expanded=true], &[data-expanded]",
    _checked: "&[aria-checked=true], &[data-checked]",
    _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    _pressed: "&[aria-pressed=true], &[data-pressed]",
    _invalid: "&[aria-invalid=true], &[data-invalid]",
    _valid: "&[data-valid], &[data-state=valid]",
    _loading: "&[data-loading], &[aria-busy=true]",
    _selected: "&[aria-selected=true], &[data-selected]",
    _hidden: "&[hidden], &[data-hidden]",
    _autofill: "&:-webkit-autofill",
    _even: "&:nth-of-type(even)",
    _odd: "&:nth-of-type(odd)",
    _first: "&:first-of-type",
    _firstLetter: "&::first-letter",
    _last: "&:last-of-type",
    _notFirst: "&:not(:first-of-type)",
    _notLast: "&:not(:last-of-type)",
    _visited: "&:visited",
    _activeLink: "&[aria-current=page]",
    _activeStep: "&[aria-current=step]",
    _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    _groupHover: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.hover),
    _peerHover: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.hover),
    _groupFocus: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focus),
    _peerFocus: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focus),
    _groupFocusVisible: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focusVisible),
    _peerFocusVisible: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focusVisible),
    _groupActive: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.active),
    _peerActive: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.active),
    _groupDisabled: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.disabled),
    _peerDisabled: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.disabled),
    _groupInvalid: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.invalid),
    _peerInvalid: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.invalid),
    _groupChecked: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.checked),
    _peerChecked: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.checked),
    _groupFocusWithin: $47a6d9fbbf7ee42d$var$toGroup($47a6d9fbbf7ee42d$var$state.focusWithin),
    _peerFocusWithin: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.focusWithin),
    _peerPlaceholderShown: $47a6d9fbbf7ee42d$var$toPeer($47a6d9fbbf7ee42d$var$state.placeholderShown),
    _placeholder: "&::placeholder",
    _placeholderShown: "&:placeholder-shown",
    _fullScreen: "&:fullscreen",
    _selection: "&::selection",
    _rtl: "[dir=rtl] &, &[dir=rtl]",
    _ltr: "[dir=ltr] &, &[dir=ltr]",
    _mediaDark: "@media (prefers-color-scheme: dark)",
    _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    _horizontal: "&[data-orientation=horizontal]",
    _vertical: "&[data-orientation=vertical]"
};
var $47a6d9fbbf7ee42d$export$4ec9644154df43c2 = Object.keys($47a6d9fbbf7ee42d$export$a36cf593fde2a546);
function $47a6d9fbbf7ee42d$var$tokenToCssVar(token, prefix) {
    return $47a6d9fbbf7ee42d$export$8b4981022bd80a4e(String(token).replace(/\./g, "-"), void 0, prefix);
}
function $47a6d9fbbf7ee42d$var$createThemeVars(flatTokens, options) {
    let cssVars = {};
    const cssMap = {};
    for (const [token, tokenValue] of Object.entries(flatTokens)){
        const { isSemantic: isSemantic, value: value } = tokenValue;
        const { variable: variable, reference: reference } = $47a6d9fbbf7ee42d$var$tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix);
        if (!isSemantic) {
            if (token.startsWith("space")) {
                const keys2 = token.split(".");
                const [firstKey, ...referenceKeys] = keys2;
                const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
                const negativeValue = $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a.negate(value);
                const negatedReference = $47a6d9fbbf7ee42d$export$42bfa9b2d4dad91a.negate(reference);
                cssMap[negativeLookupKey] = {
                    value: negativeValue,
                    var: variable,
                    varRef: negatedReference
                };
            }
            cssVars[variable] = value;
            cssMap[token] = {
                value: value,
                var: variable,
                varRef: reference
            };
            continue;
        }
        const lookupToken = (maybeToken)=>{
            const scale = String(token).split(".")[0];
            const withScale = [
                scale,
                maybeToken
            ].join(".");
            const resolvedTokenValue = flatTokens[withScale];
            if (!resolvedTokenValue) return maybeToken;
            const { reference: reference2 } = $47a6d9fbbf7ee42d$var$tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix);
            return reference2;
        };
        const normalizedValue = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) ? value : {
            default: value
        };
        cssVars = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(cssVars, Object.entries(normalizedValue).reduce((acc, [conditionAlias, conditionValue])=>{
            var _a, _b;
            if (!conditionValue) return acc;
            const tokenReference = lookupToken(`${conditionValue}`);
            if (conditionAlias === "default") {
                acc[variable] = tokenReference;
                return acc;
            }
            const conditionSelector = (_b = (_a = $47a6d9fbbf7ee42d$export$a36cf593fde2a546) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
            acc[conditionSelector] = {
                [variable]: tokenReference
            };
            return acc;
        }, {}));
        cssMap[token] = {
            value: reference,
            var: variable,
            varRef: reference
        };
    }
    return {
        cssVars: cssVars,
        cssMap: cssMap
    };
}
// ../../utilities/object-utils/src/omit.ts
function $47a6d9fbbf7ee42d$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
// ../../utilities/object-utils/src/pick.ts
function $47a6d9fbbf7ee42d$var$pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick)if (key in object) result[key] = object[key];
    return result;
}
// ../../utilities/object-utils/src/walk-object.ts
function $47a6d9fbbf7ee42d$var$isObject5(value) {
    return typeof value === "object" && value != null && !Array.isArray(value);
}
function $47a6d9fbbf7ee42d$var$walkObject(target, predicate, options = {}) {
    const { stop: stop, getKey: getKey } = options;
    function inner(value, path = []) {
        var _a;
        if ($47a6d9fbbf7ee42d$var$isObject5(value) || Array.isArray(value)) {
            const result = {};
            for (const [prop, child] of Object.entries(value)){
                const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
                const childPath = [
                    ...path,
                    key
                ];
                if (stop == null ? void 0 : stop(value, childPath)) return predicate(value, path);
                result[key] = inner(child, childPath);
            }
            return result;
        }
        return predicate(value, path);
    }
    return inner(target);
}
// src/create-theme-vars/theme-tokens.ts
var $47a6d9fbbf7ee42d$var$tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
];
function $47a6d9fbbf7ee42d$var$extractTokens(theme) {
    const _tokens = $47a6d9fbbf7ee42d$var$tokens;
    return $47a6d9fbbf7ee42d$var$pick(theme, _tokens);
}
function $47a6d9fbbf7ee42d$var$extractSemanticTokens(theme) {
    return theme.semanticTokens;
}
function $47a6d9fbbf7ee42d$var$omitVars(rawTheme) {
    const { __cssMap: __cssMap, __cssVars: __cssVars, __breakpoints: __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
}
// src/create-theme-vars/flatten-tokens.ts
var $47a6d9fbbf7ee42d$var$isSemanticCondition = (key)=>$47a6d9fbbf7ee42d$export$4ec9644154df43c2.includes(key) || "default" === key;
function $47a6d9fbbf7ee42d$export$8f520cff3dbc4769({ tokens: tokens2, semanticTokens: semanticTokens }) {
    const result = {};
    $47a6d9fbbf7ee42d$var$walkObject(tokens2, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: false,
            value: value
        };
    });
    $47a6d9fbbf7ee42d$var$walkObject(semanticTokens, (value, path)=>{
        if (value == null) return;
        result[path.join(".")] = {
            isSemantic: true,
            value: value
        };
    }, {
        stop: (value)=>Object.keys(value).every($47a6d9fbbf7ee42d$var$isSemanticCondition)
    });
    return result;
}
// src/create-theme-vars/to-css-var.ts
function $47a6d9fbbf7ee42d$export$d4e5dc2a444c0164(rawTheme) {
    var _a;
    const theme = $47a6d9fbbf7ee42d$var$omitVars(rawTheme);
    const tokens2 = $47a6d9fbbf7ee42d$var$extractTokens(theme);
    const semanticTokens = $47a6d9fbbf7ee42d$var$extractSemanticTokens(theme);
    const flatTokens = $47a6d9fbbf7ee42d$export$8f520cff3dbc4769({
        tokens: tokens2,
        semanticTokens: semanticTokens
    });
    const cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
    const { cssMap: cssMap, cssVars: cssVars } = $47a6d9fbbf7ee42d$var$createThemeVars(flatTokens, {
        cssVarPrefix: cssVarPrefix
    });
    const defaultCssVars = {
        "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
        "--chakra-ring-offset-width": "0px",
        "--chakra-ring-offset-color": "#fff",
        "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
        "--chakra-ring-offset-shadow": "0 0 #0000",
        "--chakra-ring-shadow": "0 0 #0000",
        "--chakra-space-x-reverse": "0",
        "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
        __cssVars: {
            ...defaultCssVars,
            ...cssVars
        },
        __cssMap: cssMap,
        __breakpoints: $47a6d9fbbf7ee42d$var$analyzeBreakpoints(theme.breakpoints)
    });
    return theme;
}
var $47a6d9fbbf7ee42d$export$30cfa87a708babfc = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, $47a6d9fbbf7ee42d$export$8ce1fd94bee2f412, $47a6d9fbbf7ee42d$export$1edee58a52776cd9, $47a6d9fbbf7ee42d$export$35e9368ef982300f, $47a6d9fbbf7ee42d$export$feec61708a55c80e, $47a6d9fbbf7ee42d$export$b3219800bda33a1f, $47a6d9fbbf7ee42d$export$3dea766d36a8935f, $47a6d9fbbf7ee42d$export$e7d0da6968da5dd, $47a6d9fbbf7ee42d$export$2499a341a8256d68, $47a6d9fbbf7ee42d$export$85fc379452d91af0, $47a6d9fbbf7ee42d$export$36263e8f8d7ce3b1, $47a6d9fbbf7ee42d$export$5880b8b5730aff45, $47a6d9fbbf7ee42d$export$dc573d8a6576cdb3, $47a6d9fbbf7ee42d$export$a941ed4b947d12f8, $47a6d9fbbf7ee42d$export$209876d7b1ac8f3, $47a6d9fbbf7ee42d$export$d846a084e680d8e, $47a6d9fbbf7ee42d$export$6b7f9af9aa033040, $47a6d9fbbf7ee42d$export$51186ad6e864892a, $47a6d9fbbf7ee42d$export$8837f4fc672e936d, $47a6d9fbbf7ee42d$export$66bb15e2994e6a26);
var $47a6d9fbbf7ee42d$var$layoutSystem = Object.assign({}, $47a6d9fbbf7ee42d$export$a941ed4b947d12f8, $47a6d9fbbf7ee42d$export$b3219800bda33a1f, $47a6d9fbbf7ee42d$export$feec61708a55c80e, $47a6d9fbbf7ee42d$export$85fc379452d91af0, $47a6d9fbbf7ee42d$export$5880b8b5730aff45);
var $47a6d9fbbf7ee42d$export$bccb7c6ca2f4f912 = Object.keys($47a6d9fbbf7ee42d$var$layoutSystem);
var $47a6d9fbbf7ee42d$export$332cc7004bcbb8b4 = [
    ...Object.keys($47a6d9fbbf7ee42d$export$30cfa87a708babfc),
    ...$47a6d9fbbf7ee42d$export$4ec9644154df43c2
];
var $47a6d9fbbf7ee42d$var$styleProps = {
    ...$47a6d9fbbf7ee42d$export$30cfa87a708babfc,
    ...$47a6d9fbbf7ee42d$export$a36cf593fde2a546
};
var $47a6d9fbbf7ee42d$export$95b76554d0cd12d6 = (prop)=>prop in $47a6d9fbbf7ee42d$var$styleProps;
var $47a6d9fbbf7ee42d$var$expandResponsive = (styles)=>(theme)=>{
        if (!theme.__breakpoints) return styles;
        const { isResponsive: isResponsive, toArrayValue: toArrayValue, media: medias } = theme.__breakpoints;
        const computedStyles = {};
        for(const key in styles){
            let value = (0, $abe97432afb3d989$export$624e501d81f5ffce)(styles[key], theme);
            if (value == null) continue;
            value = (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) && isResponsive(value) ? toArrayValue(value) : value;
            if (!Array.isArray(value)) {
                computedStyles[key] = value;
                continue;
            }
            const queries = value.slice(0, medias.length).length;
            for(let index = 0; index < queries; index += 1){
                const media = medias == null ? void 0 : medias[index];
                if (!media) {
                    computedStyles[key] = value[index];
                    continue;
                }
                computedStyles[media] = computedStyles[media] || {};
                if (value[index] == null) continue;
                computedStyles[media][key] = value[index];
            }
        }
        return computedStyles;
    };
// src/utils/split-by-comma.ts
function $47a6d9fbbf7ee42d$var$splitByComma(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for(let i = 0; i < value.length; i++){
        const char = value[i];
        if (char === "(") {
            inParens = true;
            chunk += char;
        } else if (char === ")") {
            inParens = false;
            chunk += char;
        } else if (char === "," && !inParens) {
            chunks.push(chunk);
            chunk = "";
        } else chunk += char;
    }
    chunk = chunk.trim();
    if (chunk) chunks.push(chunk);
    return chunks;
}
// src/css.ts
function $47a6d9fbbf7ee42d$var$isCssVar2(value) {
    return /^var\(--.+\)$/.test(value);
}
var $47a6d9fbbf7ee42d$var$isCSSVariableTokenValue = (key, value)=>key.startsWith("--") && typeof value === "string" && !$47a6d9fbbf7ee42d$var$isCssVar2(value);
var $47a6d9fbbf7ee42d$var$resolveTokenValue = (theme, value)=>{
    var _a, _b;
    if (value == null) return value;
    const getVar = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
    };
    const getValue = (val)=>{
        var _a2;
        return (_a2 = getVar(val)) != null ? _a2 : val;
    };
    const [tokenValue, fallbackValue] = $47a6d9fbbf7ee42d$var$splitByComma(value);
    value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
    return value;
};
function $47a6d9fbbf7ee42d$export$955358618f994a11(options) {
    const { configs: configs = {}, pseudos: pseudos = {}, theme: theme } = options;
    const css2 = (stylesOrFn, nested = false)=>{
        var _a, _b, _c;
        const _styles = (0, $abe97432afb3d989$export$624e501d81f5ffce)(stylesOrFn, theme);
        const styles = $47a6d9fbbf7ee42d$var$expandResponsive(_styles)(theme);
        let computedStyles = {};
        for(let key in styles){
            const valueOrFn = styles[key];
            let value = (0, $abe97432afb3d989$export$624e501d81f5ffce)(valueOrFn, theme);
            if (key in pseudos) key = pseudos[key];
            if ($47a6d9fbbf7ee42d$var$isCSSVariableTokenValue(key, value)) value = $47a6d9fbbf7ee42d$var$resolveTokenValue(theme, value);
            let config = configs[key];
            if (config === true) config = {
                property: key
            };
            if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value)) {
                computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
                computedStyles[key] = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles[key], css2(value, true));
                continue;
            }
            let rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
            rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
            const configProperty = (0, $abe97432afb3d989$export$624e501d81f5ffce)(config == null ? void 0 : config.property, theme);
            if (!nested && (config == null ? void 0 : config.static)) {
                const staticStyles = (0, $abe97432afb3d989$export$624e501d81f5ffce)(config.static, theme);
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, staticStyles);
            }
            if (configProperty && Array.isArray(configProperty)) {
                for (const property of configProperty)computedStyles[property] = rawValue;
                continue;
            }
            if (configProperty) {
                if (configProperty === "&" && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(rawValue)) computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, rawValue);
                else computedStyles[configProperty] = rawValue;
                continue;
            }
            if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(rawValue)) {
                computedStyles = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, computedStyles, rawValue);
                continue;
            }
            computedStyles[key] = rawValue;
        }
        return computedStyles;
    };
    return css2;
}
var $47a6d9fbbf7ee42d$export$dbf350e5966cf602 = (styles)=>(theme)=>{
        const cssFn = $47a6d9fbbf7ee42d$export$955358618f994a11({
            theme: theme,
            pseudos: $47a6d9fbbf7ee42d$export$a36cf593fde2a546,
            configs: $47a6d9fbbf7ee42d$export$30cfa87a708babfc
        });
        return cssFn(styles);
    };
// src/define-styles.ts
function $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839(styles) {
    return styles;
}
function $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4(config) {
    return config;
}
function $47a6d9fbbf7ee42d$export$d5f717dc145477b8(parts) {
    return {
        definePartsStyle (config) {
            return config;
        },
        defineMultiStyleConfig (config) {
            return {
                parts: parts,
                ...config
            };
        }
    };
}
function $47a6d9fbbf7ee42d$var$normalize2(value, toArray) {
    if (Array.isArray(value)) return value;
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value)) return toArray(value);
    if (value != null) return [
        value
    ];
}
function $47a6d9fbbf7ee42d$var$getNextIndex(values, i) {
    for(let j = i + 1; j < values.length; j++){
        if (values[j] != null) return j;
    }
    return -1;
}
function $47a6d9fbbf7ee42d$var$createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
        var _a, _b;
        if (!breakpointUtil) return;
        const result = {};
        const normalized = $47a6d9fbbf7ee42d$var$normalize2(value, breakpointUtil.toArrayValue);
        if (!normalized) return result;
        const len = normalized.length;
        const isSingle = len === 1;
        const isMultipart = !!config.parts;
        for(let i = 0; i < len; i++){
            const key = breakpointUtil.details[i];
            const nextKey = breakpointUtil.details[$47a6d9fbbf7ee42d$var$getNextIndex(normalized, i)];
            const query = $47a6d9fbbf7ee42d$var$toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
            const styles = (0, $abe97432afb3d989$export$624e501d81f5ffce)((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
            if (!styles) continue;
            if (isMultipart) {
                (_b = config.parts) == null || _b.forEach((part)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(result, {
                        [part]: isSingle ? styles[part] : {
                            [query]: styles[part]
                        }
                    });
                });
                continue;
            }
            if (!isMultipart) {
                if (isSingle) (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))(result, styles);
                else result[query] = styles;
                continue;
            }
            result[query] = styles;
        }
        return result;
    };
}
function $47a6d9fbbf7ee42d$export$f94106bbb00e81eb(config) {
    return (props)=>{
        var _a;
        const { variant: variant, size: size, theme: theme } = props;
        const recipe = $47a6d9fbbf7ee42d$var$createResolver(theme);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, (0, $abe97432afb3d989$export$624e501d81f5ffce)((_a = config.baseStyle) != null ? _a : {}, props), recipe(config, "sizes", size, props), recipe(config, "variants", variant, props));
    };
}
// src/get-css-var.ts
function $47a6d9fbbf7ee42d$export$93c8e06b7014dc33(theme, scale, value) {
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
}
// src/theming-props.ts
function $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785(props) {
    return $47a6d9fbbf7ee42d$var$omit(props, [
        "styleConfig",
        "size",
        "variant",
        "colorScheme"
    ]);
}


// src/object.ts

var $5Gn6I = parcelRequire("5Gn6I");
function $8cabe7dbd312f1c1$export$30a06c8d3562193f(object, keys) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) return;
        result[key] = object[key];
    });
    return result;
}
function $8cabe7dbd312f1c1$export$357523c63a2253b9(object, keys) {
    const result = {};
    keys.forEach((key)=>{
        if (key in object) result[key] = object[key];
    });
    return result;
}
function $8cabe7dbd312f1c1$export$65980d18b75784e2(object, keys) {
    const picked = {};
    const omitted = {};
    Object.keys(object).forEach((key)=>{
        if (keys.includes(key)) picked[key] = object[key];
        else omitted[key] = object[key];
    });
    return [
        picked,
        omitted
    ];
}
function $8cabe7dbd312f1c1$export$3988ae62b71be9a3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [
        path
    ];
    for(index = 0; index < key.length; index += 1){
        if (!obj) break;
        obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
}
var $8cabe7dbd312f1c1$export$fc10aeed3a532e2a = (fn)=>{
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index)=>{
        if (typeof obj === "undefined") return fn(obj, path, fallback);
        if (!cache.has(obj)) cache.set(obj, /* @__PURE__ */ new Map());
        const map = cache.get(obj);
        if (map.has(path)) return map.get(path);
        const value = fn(obj, path, fallback, index);
        map.set(path, value);
        return value;
    };
    return memoizedFn;
};
var $8cabe7dbd312f1c1$export$1bb32d0c65da6059 = $8cabe7dbd312f1c1$export$fc10aeed3a532e2a($8cabe7dbd312f1c1$export$3988ae62b71be9a3);
function $8cabe7dbd312f1c1$export$73b8ef55a37133c7(path, scale) {
    return $8cabe7dbd312f1c1$export$1bb32d0c65da6059(scale, path, path);
}
function $8cabe7dbd312f1c1$export$3417cf6417437960(object, fn) {
    const result = {};
    Object.keys(object).forEach((key)=>{
        const value = object[key];
        const shouldPass = fn(value, key, object);
        if (shouldPass) result[key] = value;
    });
    return result;
}
var $8cabe7dbd312f1c1$export$2458ce75c8ef9806 = (object)=>$8cabe7dbd312f1c1$export$3417cf6417437960(object, (val)=>val !== null && val !== void 0);
var $8cabe7dbd312f1c1$export$259b4dd69e654a7a = (obj)=>Object.keys(obj);
var $8cabe7dbd312f1c1$export$5150077fc2e7c662 = (entries)=>entries.reduce((carry, [key, value])=>{
        carry[key] = value;
        return carry;
    }, {});
var $8cabe7dbd312f1c1$export$93c8e06b7014dc33 = (theme, scale, value)=>{
    var _a, _b, _c;
    return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};

// src/assertion.ts
function $fbf5a7a3c8624538$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $fbf5a7a3c8624538$export$3f283ac14831e759(value) {
    return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function $fbf5a7a3c8624538$export$e90fb89750dba83f(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
function $fbf5a7a3c8624538$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $fbf5a7a3c8624538$export$4c0262a4f954db45(value) {
    return $fbf5a7a3c8624538$export$43bee75e5e14138e(value) && value.length === 0;
}
function $fbf5a7a3c8624538$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $fbf5a7a3c8624538$export$4e62c701997796c1(value) {
    return typeof value !== "undefined" && value !== void 0;
}
function $fbf5a7a3c8624538$export$fce6876652108ab(value) {
    return typeof value === "undefined" || value === void 0;
}
function $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !$fbf5a7a3c8624538$export$43bee75e5e14138e(value);
}
function $fbf5a7a3c8624538$export$83b788b1a3698c03(value) {
    return $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) && Object.keys(value).length === 0;
}
function $fbf5a7a3c8624538$export$e0287cc73292b477(value) {
    return value && !$fbf5a7a3c8624538$export$83b788b1a3698c03(value);
}
function $fbf5a7a3c8624538$export$630801d484da15df(value) {
    return value == null;
}
function $fbf5a7a3c8624538$export$844ec244b1367d54(value) {
    return Object.prototype.toString.call(value) === "[object String]";
}
function $fbf5a7a3c8624538$export$30a9abfd5fb9f5f6(value) {
    return /^var\(--.+\)$/.test(value);
}
function $fbf5a7a3c8624538$export$dd1bc94b04021eeb(value) {
    if ($fbf5a7a3c8624538$export$43bee75e5e14138e(value)) return $fbf5a7a3c8624538$export$4c0262a4f954db45(value);
    if ($fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value)) return $fbf5a7a3c8624538$export$83b788b1a3698c03(value);
    if (value == null || value === "") return true;
    return false;
}
var $fbf5a7a3c8624538$export$a866f231438cc228 = false;
var $fbf5a7a3c8624538$export$61cb32cff9a99948 = false;
function $fbf5a7a3c8624538$export$dedd81df7bc1307(val) {
    return "current" in val;
}
function $fbf5a7a3c8624538$export$4215e022093e324e(value) {
    return value && $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value) && $fbf5a7a3c8624538$export$a6cdc56e425d0d0a(value.target);
}


// src/function.ts
function $7e9e3a2462729b7f$export$624e501d81f5ffce(valueOrFn, ...args) {
    return (0, $fbf5a7a3c8624538$export$f6e2535fb5126e54)(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function $7e9e3a2462729b7f$export$5bdd3f730ec2c47e(...fns) {
    return function func(event) {
        fns.some((fn)=>{
            fn == null || fn(event);
            return event == null ? void 0 : event.defaultPrevented;
        });
    };
}
function $7e9e3a2462729b7f$export$9dd9a52f2dd5b9ce(...fns) {
    return function mergedFn(arg) {
        fns.forEach((fn)=>{
            fn == null || fn(arg);
        });
    };
}
var $7e9e3a2462729b7f$export$f672e0b6f7222cd7 = (fn1, ...fns)=>fns.reduce((f1, f2)=>(...args)=>f1(f2(...args)), fn1);
function $7e9e3a2462729b7f$export$d2de3aaeafa91619(fn) {
    let result;
    return function func(...args) {
        if (fn) {
            result = fn.apply(this, args);
            fn = null;
        }
        return result;
    };
}
var $7e9e3a2462729b7f$export$8793edee2d425525 = ()=>{};
var $7e9e3a2462729b7f$export$c106dd0671a0fc2d = /* @__PURE__ */ $7e9e3a2462729b7f$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $fbf5a7a3c8624538$export$a866f231438cc228)) console.warn(message);
    });
var $7e9e3a2462729b7f$export$a3bc9b8ed74fc = /* @__PURE__ */ $7e9e3a2462729b7f$export$d2de3aaeafa91619((options)=>()=>{
        const { condition: condition, message: message } = options;
        if (condition && (0, $fbf5a7a3c8624538$export$a866f231438cc228)) console.error(message);
    });
var $7e9e3a2462729b7f$export$a4627e546088548d = (...fns)=>(v)=>fns.reduce((a, b)=>b(a), v);
var $7e9e3a2462729b7f$var$distance1D = (a, b)=>Math.abs(a - b);
var $7e9e3a2462729b7f$var$isPoint = (point)=>"x" in point && "y" in point;
function $7e9e3a2462729b7f$export$9f17032d917177de(a, b) {
    if ((0, $fbf5a7a3c8624538$export$7e4aa119212bc614)(a) && (0, $fbf5a7a3c8624538$export$7e4aa119212bc614)(b)) return $7e9e3a2462729b7f$var$distance1D(a, b);
    if ($7e9e3a2462729b7f$var$isPoint(a) && $7e9e3a2462729b7f$var$isPoint(b)) {
        const xDelta = $7e9e3a2462729b7f$var$distance1D(a.x, b.x);
        const yDelta = $7e9e3a2462729b7f$var$distance1D(a.y, b.y);
        return Math.sqrt(xDelta ** 2 + yDelta ** 2);
    }
    return 0;
}




var $acw62 = parcelRequire("acw62");

function $19b2214d51386943$export$d8964aec282183a3(props) {
    const { cssVarsRoot: cssVarsRoot, theme: theme, children: children } = props;
    const computedTheme = (0, $acw62.useMemo)(()=>(0, $47a6d9fbbf7ee42d$export$d4e5dc2a444c0164)(theme), [
        theme
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $ea69b9ccc73b096b$export$407448d2b89b1813), {
        theme: computedTheme,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($19b2214d51386943$export$d767872124667db6, {
                root: cssVarsRoot
            }),
            children
        ]
    });
}
function $19b2214d51386943$export$d767872124667db6({ root: root = ":host, :root" }) {
    const selector = [
        root,
        `[data-theme]`
    ].join(",");
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: (theme)=>({
                [selector]: theme.__cssVars
            })
    });
}
var [$19b2214d51386943$export$dc4c659861f00dbe, $19b2214d51386943$export$28e6b9b82ee883c] = (0, $e54f09380e048946$export$fd42f52fd3ae1109)({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function $19b2214d51386943$export$11d9f9905bcdc114(componentName) {
    return (0, $e54f09380e048946$export$fd42f52fd3ae1109)({
        name: `${componentName}StylesContext`,
        errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
    });
}
function $19b2214d51386943$export$f05794e648629f6c() {
    const { colorMode: colorMode } = (0, $83ba09a61bdcb2b2$export$20f3076712c8dfa)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: (theme)=>{
            const styleObjectOrFn = (0, $8cabe7dbd312f1c1$export$1bb32d0c65da6059)(theme, "styles.global");
            const globalStyles = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(styleObjectOrFn, {
                theme: theme,
                colorMode: colorMode
            });
            if (!globalStyles) return void 0;
            const styles = (0, $47a6d9fbbf7ee42d$export$dbf350e5966cf602)(globalStyles)(theme);
            return styles;
        }
    });
}


// src/env.tsx


var $acw62 = parcelRequire("acw62");

var $2f7cbdad169aa03e$var$EnvironmentContext = (0, $acw62.createContext)({
    getDocument () {
        return document;
    },
    getWindow () {
        return window;
    }
});
$2f7cbdad169aa03e$var$EnvironmentContext.displayName = "EnvironmentContext";
function $2f7cbdad169aa03e$export$ea7ed2425832167d({ defer: defer } = {}) {
    const [, forceUpdate] = (0, $acw62.useReducer)((c)=>c + 1, 0);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!defer) return;
        forceUpdate();
    }, [
        defer
    ]);
    return (0, $acw62.useContext)($2f7cbdad169aa03e$var$EnvironmentContext);
}
function $2f7cbdad169aa03e$export$29a4c0b32fc9db42(props) {
    const { children: children, environment: environmentProp, disabled: disabled } = props;
    const ref = (0, $acw62.useRef)(null);
    const context = (0, $acw62.useMemo)(()=>{
        if (environmentProp) return environmentProp;
        return {
            getDocument: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
            },
            getWindow: ()=>{
                var _a, _b;
                return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
            }
        };
    }, [
        environmentProp
    ]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)($2f7cbdad169aa03e$var$EnvironmentContext.Provider, {
        value: context,
        children: [
            children,
            showSpan && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                id: "__chakra_env",
                hidden: true,
                ref: ref
            })
        ]
    });
}
$2f7cbdad169aa03e$export$29a4c0b32fc9db42.displayName = "EnvironmentProvider";



var $cc3b3e46667e9fbd$export$80dbe0482bcbd25a = (props)=>{
    const { children: children, colorModeManager: colorModeManager, portalZIndex: portalZIndex, resetScope: resetScope, resetCSS: resetCSS = true, theme: theme = {}, environment: environment, cssVarsRoot: cssVarsRoot, disableEnvironment: disableEnvironment, disableGlobalStyle: disableGlobalStyle } = props;
    const _children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2f7cbdad169aa03e$export$29a4c0b32fc9db42), {
        environment: environment,
        disabled: disableEnvironment,
        children: children
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $19b2214d51386943$export$d8964aec282183a3), {
        theme: theme,
        cssVarsRoot: cssVarsRoot,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $23a20d92c4cd8150$export$7a858aa3ff83dde7), {
            colorModeManager: colorModeManager,
            options: theme.config,
            children: [
                resetCSS ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3a85343c30bb17b$export$b751feffed387621), {
                    scope: resetScope
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c3a85343c30bb17b$export$43a6590e493ec44a), {}),
                !disableGlobalStyle && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $19b2214d51386943$export$f05794e648629f6c), {}),
                portalZIndex ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f0ef0206ab9ab709$export$52c7ef79917c2f38), {
                    zIndex: portalZIndex,
                    children: _children
                }) : _children
            ]
        })
    });
};


// src/utils/is-chakra-theme.ts

var $8820d60240fe7ca4$export$1fad0bb5bac74e8f = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
];
function $8820d60240fe7ca4$export$73a6ae01926a4f0e(unit) {
    if (!(0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(unit)) return false;
    return $8820d60240fe7ca4$export$1fad0bb5bac74e8f.every((propertyName)=>Object.prototype.hasOwnProperty.call(unit, propertyName));
}


// src/foundations/transition.ts
var $5afa406334da2a3e$var$transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
};
var $5afa406334da2a3e$var$transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var $5afa406334da2a3e$var$transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
};
var $5afa406334da2a3e$var$transition = {
    property: $5afa406334da2a3e$var$transitionProperty,
    easing: $5afa406334da2a3e$var$transitionTimingFunction,
    duration: $5afa406334da2a3e$var$transitionDuration
};
var $5afa406334da2a3e$export$6b266f9cfc4b7bb8 = $5afa406334da2a3e$var$transition;


// src/foundations/z-index.ts
var $4028069c115f8ef5$var$zIndices = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
};
var $4028069c115f8ef5$export$d9d5ef55fed42171 = $4028069c115f8ef5$var$zIndices;


// src/foundations/borders.ts
var $a30ab6338e6683f2$var$borders = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
};
var $a30ab6338e6683f2$export$196bfcf31ca4deb7 = $a30ab6338e6683f2$var$borders;


// src/foundations/breakpoints.ts
var $32d01d0ba6f4ae77$var$breakpoints = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
};
var $32d01d0ba6f4ae77$export$d0717e75346b884a = $32d01d0ba6f4ae77$var$breakpoints;


// src/foundations/colors.ts
var $049d84b60a734f12$var$colors = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
        50: "rgba(255, 255, 255, 0.04)",
        100: "rgba(255, 255, 255, 0.06)",
        200: "rgba(255, 255, 255, 0.08)",
        300: "rgba(255, 255, 255, 0.16)",
        400: "rgba(255, 255, 255, 0.24)",
        500: "rgba(255, 255, 255, 0.36)",
        600: "rgba(255, 255, 255, 0.48)",
        700: "rgba(255, 255, 255, 0.64)",
        800: "rgba(255, 255, 255, 0.80)",
        900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
        50: "rgba(0, 0, 0, 0.04)",
        100: "rgba(0, 0, 0, 0.06)",
        200: "rgba(0, 0, 0, 0.08)",
        300: "rgba(0, 0, 0, 0.16)",
        400: "rgba(0, 0, 0, 0.24)",
        500: "rgba(0, 0, 0, 0.36)",
        600: "rgba(0, 0, 0, 0.48)",
        700: "rgba(0, 0, 0, 0.64)",
        800: "rgba(0, 0, 0, 0.80)",
        900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
        50: "#F7FAFC",
        100: "#EDF2F7",
        200: "#E2E8F0",
        300: "#CBD5E0",
        400: "#A0AEC0",
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748",
        800: "#1A202C",
        900: "#171923"
    },
    red: {
        50: "#FFF5F5",
        100: "#FED7D7",
        200: "#FEB2B2",
        300: "#FC8181",
        400: "#F56565",
        500: "#E53E3E",
        600: "#C53030",
        700: "#9B2C2C",
        800: "#822727",
        900: "#63171B"
    },
    orange: {
        50: "#FFFAF0",
        100: "#FEEBC8",
        200: "#FBD38D",
        300: "#F6AD55",
        400: "#ED8936",
        500: "#DD6B20",
        600: "#C05621",
        700: "#9C4221",
        800: "#7B341E",
        900: "#652B19"
    },
    yellow: {
        50: "#FFFFF0",
        100: "#FEFCBF",
        200: "#FAF089",
        300: "#F6E05E",
        400: "#ECC94B",
        500: "#D69E2E",
        600: "#B7791F",
        700: "#975A16",
        800: "#744210",
        900: "#5F370E"
    },
    green: {
        50: "#F0FFF4",
        100: "#C6F6D5",
        200: "#9AE6B4",
        300: "#68D391",
        400: "#48BB78",
        500: "#38A169",
        600: "#2F855A",
        700: "#276749",
        800: "#22543D",
        900: "#1C4532"
    },
    teal: {
        50: "#E6FFFA",
        100: "#B2F5EA",
        200: "#81E6D9",
        300: "#4FD1C5",
        400: "#38B2AC",
        500: "#319795",
        600: "#2C7A7B",
        700: "#285E61",
        800: "#234E52",
        900: "#1D4044"
    },
    blue: {
        50: "#ebf8ff",
        100: "#bee3f8",
        200: "#90cdf4",
        300: "#63b3ed",
        400: "#4299e1",
        500: "#3182ce",
        600: "#2b6cb0",
        700: "#2c5282",
        800: "#2a4365",
        900: "#1A365D"
    },
    cyan: {
        50: "#EDFDFD",
        100: "#C4F1F9",
        200: "#9DECF9",
        300: "#76E4F7",
        400: "#0BC5EA",
        500: "#00B5D8",
        600: "#00A3C4",
        700: "#0987A0",
        800: "#086F83",
        900: "#065666"
    },
    purple: {
        50: "#FAF5FF",
        100: "#E9D8FD",
        200: "#D6BCFA",
        300: "#B794F4",
        400: "#9F7AEA",
        500: "#805AD5",
        600: "#6B46C1",
        700: "#553C9A",
        800: "#44337A",
        900: "#322659"
    },
    pink: {
        50: "#FFF5F7",
        100: "#FED7E2",
        200: "#FBB6CE",
        300: "#F687B3",
        400: "#ED64A6",
        500: "#D53F8C",
        600: "#B83280",
        700: "#97266D",
        800: "#702459",
        900: "#521B41"
    },
    linkedin: {
        50: "#E8F4F9",
        100: "#CFEDFB",
        200: "#9BDAF3",
        300: "#68C7EC",
        400: "#34B3E4",
        500: "#00A0DC",
        600: "#008CC9",
        700: "#0077B5",
        800: "#005E93",
        900: "#004471"
    },
    facebook: {
        50: "#E8F4F9",
        100: "#D9DEE9",
        200: "#B7C2DA",
        300: "#6482C0",
        400: "#4267B2",
        500: "#385898",
        600: "#314E89",
        700: "#29487D",
        800: "#223B67",
        900: "#1E355B"
    },
    messenger: {
        50: "#D0E6FF",
        100: "#B9DAFF",
        200: "#A2CDFF",
        300: "#7AB8FF",
        400: "#2E90FF",
        500: "#0078FF",
        600: "#0063D1",
        700: "#0052AC",
        800: "#003C7E",
        900: "#002C5C"
    },
    whatsapp: {
        50: "#dffeec",
        100: "#b9f5d0",
        200: "#90edb3",
        300: "#65e495",
        400: "#3cdd78",
        500: "#22c35e",
        600: "#179848",
        700: "#0c6c33",
        800: "#01421c",
        900: "#001803"
    },
    twitter: {
        50: "#E5F4FD",
        100: "#C8E9FB",
        200: "#A8DCFA",
        300: "#83CDF7",
        400: "#57BBF5",
        500: "#1DA1F2",
        600: "#1A94DA",
        700: "#1681BF",
        800: "#136B9E",
        900: "#0D4D71"
    },
    telegram: {
        50: "#E3F2F9",
        100: "#C5E4F3",
        200: "#A2D4EC",
        300: "#7AC1E4",
        400: "#47A9DA",
        500: "#0088CC",
        600: "#007AB8",
        700: "#006BA1",
        800: "#005885",
        900: "#003F5E"
    }
};
var $049d84b60a734f12$export$59d2d4241383b416 = $049d84b60a734f12$var$colors;


// src/foundations/radius.ts
var $ff852701d992b729$var$radii = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
};
var $ff852701d992b729$export$9aaceac1356558f4 = $ff852701d992b729$var$radii;


// src/foundations/shadows.ts
var $af6b77ab08b02860$var$shadows = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var $af6b77ab08b02860$export$e70f92e6000288b2 = $af6b77ab08b02860$var$shadows;


// src/foundations/blur.ts
var $b352728f366a261c$var$blur = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
};
var $b352728f366a261c$export$6b4e890355bf1451 = $b352728f366a261c$var$blur;


// src/foundations/typography.ts
var $4162f0caf6e4358a$var$typography = {
    letterSpacings: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        shorter: 1.25,
        short: 1.375,
        base: 1.5,
        tall: 1.625,
        taller: "2",
        "3": ".75rem",
        "4": "1rem",
        "5": "1.25rem",
        "6": "1.5rem",
        "7": "1.75rem",
        "8": "2rem",
        "9": "2.25rem",
        "10": "2.5rem"
    },
    fontWeights: {
        hairline: 100,
        thin: 200,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
        black: 900
    },
    fonts: {
        heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
        "3xs": "0.45rem",
        "2xs": "0.625rem",
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
        "2xl": "1.5rem",
        "3xl": "1.875rem",
        "4xl": "2.25rem",
        "5xl": "3rem",
        "6xl": "3.75rem",
        "7xl": "4.5rem",
        "8xl": "6rem",
        "9xl": "8rem"
    }
};
var $4162f0caf6e4358a$export$d7c5d8884f83c8db = $4162f0caf6e4358a$var$typography;


// src/foundations/spacing.ts
var $44ef3f8fe9a8cf5b$export$5458b64234d1333c = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
};


// src/foundations/sizes.ts
var $733d1be8502853ee$var$largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
};
var $733d1be8502853ee$var$container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
};
var $733d1be8502853ee$var$sizes = {
    ...(0, $44ef3f8fe9a8cf5b$export$5458b64234d1333c),
    ...$733d1be8502853ee$var$largeSizes,
    container: $733d1be8502853ee$var$container
};
var $733d1be8502853ee$export$d7d4c689520cc141 = $733d1be8502853ee$var$sizes;



// src/foundations/index.ts
var $8f364387ee1b6c3d$export$651a0b7b10dae380 = {
    breakpoints: (0, $32d01d0ba6f4ae77$export$d0717e75346b884a),
    zIndices: (0, $4028069c115f8ef5$export$d9d5ef55fed42171),
    radii: (0, $ff852701d992b729$export$9aaceac1356558f4),
    blur: (0, $b352728f366a261c$export$6b4e890355bf1451),
    colors: (0, $049d84b60a734f12$export$59d2d4241383b416),
    ...(0, $4162f0caf6e4358a$export$d7c5d8884f83c8db),
    sizes: (0, $733d1be8502853ee$export$d7d4c689520cc141),
    shadows: (0, $af6b77ab08b02860$export$e70f92e6000288b2),
    space: (0, $44ef3f8fe9a8cf5b$export$5458b64234d1333c),
    borders: (0, $a30ab6338e6683f2$export$196bfcf31ca4deb7),
    transition: (0, $5afa406334da2a3e$export$6b266f9cfc4b7bb8)
};










// src/components/stepper.ts

var { defineMultiStyleConfig: $2f5f31880c5d604c$var$defineMultiStyleConfig, definePartsStyle: $2f5f31880c5d604c$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
]);
var $2f5f31880c5d604c$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-indicator-size");
var $2f5f31880c5d604c$var$$iconSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-icon-size");
var $2f5f31880c5d604c$var$$titleFontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-title-font-size");
var $2f5f31880c5d604c$var$$descFontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-description-font-size");
var $2f5f31880c5d604c$var$$accentColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("stepper-accent-color");
var $2f5f31880c5d604c$var$baseStyle = $2f5f31880c5d604c$var$definePartsStyle(({ colorScheme: c })=>({
        stepper: {
            display: "flex",
            justifyContent: "space-between",
            gap: "4",
            "&[data-orientation=vertical]": {
                flexDirection: "column",
                alignItems: "flex-start"
            },
            "&[data-orientation=horizontal]": {
                flexDirection: "row",
                alignItems: "center"
            },
            [$2f5f31880c5d604c$var$$accentColor.variable]: `colors.${c}.500`,
            _dark: {
                [$2f5f31880c5d604c$var$$accentColor.variable]: `colors.${c}.200`
            }
        },
        title: {
            fontSize: $2f5f31880c5d604c$var$$titleFontSize.reference,
            fontWeight: "medium"
        },
        description: {
            fontSize: $2f5f31880c5d604c$var$$descFontSize.reference,
            color: "chakra-subtle-text"
        },
        number: {
            fontSize: $2f5f31880c5d604c$var$$titleFontSize.reference
        },
        step: {
            flexShrink: 0,
            position: "relative",
            display: "flex",
            gap: "2",
            "&[data-orientation=horizontal]": {
                alignItems: "center"
            },
            flex: "1",
            "&:last-of-type:not([data-stretch])": {
                flex: "initial"
            }
        },
        icon: {
            flexShrink: 0,
            width: $2f5f31880c5d604c$var$$iconSize.reference,
            height: $2f5f31880c5d604c$var$$iconSize.reference
        },
        indicator: {
            flexShrink: 0,
            borderRadius: "full",
            width: $2f5f31880c5d604c$var$$size.reference,
            height: $2f5f31880c5d604c$var$$size.reference,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&[data-status=active]": {
                borderWidth: "2px",
                borderColor: $2f5f31880c5d604c$var$$accentColor.reference
            },
            "&[data-status=complete]": {
                bg: $2f5f31880c5d604c$var$$accentColor.reference,
                color: "chakra-inverse-text"
            },
            "&[data-status=incomplete]": {
                borderWidth: "2px"
            }
        },
        separator: {
            bg: "chakra-border-color",
            flex: "1",
            "&[data-status=complete]": {
                bg: $2f5f31880c5d604c$var$$accentColor.reference
            },
            "&[data-orientation=horizontal]": {
                width: "100%",
                height: "2px",
                marginStart: "2"
            },
            "&[data-orientation=vertical]": {
                width: "2px",
                position: "absolute",
                height: "100%",
                maxHeight: `calc(100% - ${$2f5f31880c5d604c$var$$size.reference} - 8px)`,
                top: `calc(${$2f5f31880c5d604c$var$$size.reference} + 4px)`,
                insetStart: `calc(${$2f5f31880c5d604c$var$$size.reference} / 2 - 1px)`
            }
        }
    }));
var $2f5f31880c5d604c$export$54c84d54375c8d75 = $2f5f31880c5d604c$var$defineMultiStyleConfig({
    baseStyle: $2f5f31880c5d604c$var$baseStyle,
    sizes: {
        xs: $2f5f31880c5d604c$var$definePartsStyle({
            stepper: {
                [$2f5f31880c5d604c$var$$size.variable]: "sizes.4",
                [$2f5f31880c5d604c$var$$iconSize.variable]: "sizes.3",
                [$2f5f31880c5d604c$var$$titleFontSize.variable]: "fontSizes.xs",
                [$2f5f31880c5d604c$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        sm: $2f5f31880c5d604c$var$definePartsStyle({
            stepper: {
                [$2f5f31880c5d604c$var$$size.variable]: "sizes.6",
                [$2f5f31880c5d604c$var$$iconSize.variable]: "sizes.4",
                [$2f5f31880c5d604c$var$$titleFontSize.variable]: "fontSizes.sm",
                [$2f5f31880c5d604c$var$$descFontSize.variable]: "fontSizes.xs"
            }
        }),
        md: $2f5f31880c5d604c$var$definePartsStyle({
            stepper: {
                [$2f5f31880c5d604c$var$$size.variable]: "sizes.8",
                [$2f5f31880c5d604c$var$$iconSize.variable]: "sizes.5",
                [$2f5f31880c5d604c$var$$titleFontSize.variable]: "fontSizes.md",
                [$2f5f31880c5d604c$var$$descFontSize.variable]: "fontSizes.sm"
            }
        }),
        lg: $2f5f31880c5d604c$var$definePartsStyle({
            stepper: {
                [$2f5f31880c5d604c$var$$size.variable]: "sizes.10",
                [$2f5f31880c5d604c$var$$iconSize.variable]: "sizes.6",
                [$2f5f31880c5d604c$var$$titleFontSize.variable]: "fontSizes.lg",
                [$2f5f31880c5d604c$var$$descFontSize.variable]: "fontSizes.md"
            }
        })
    },
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/switch.ts
// src/anatomy.ts
function $2a167641725e706b$export$477202748c7242bf(name, map = {}) {
    let called = false;
    function assert() {
        if (!called) {
            called = true;
            return;
        }
        throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }
    function parts(...values) {
        assert();
        for (const part of values)map[part] = toPart(part);
        return $2a167641725e706b$export$477202748c7242bf(name, map);
    }
    function extend(...parts2) {
        for (const part of parts2){
            if (part in map) continue;
            map[part] = toPart(part);
        }
        return $2a167641725e706b$export$477202748c7242bf(name, map);
    }
    function selectors() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.selector
            ]));
        return value;
    }
    function classnames() {
        const value = Object.fromEntries(Object.entries(map).map(([key, part])=>[
                key,
                part.className
            ]));
        return value;
    }
    function toPart(part) {
        const el = [
            "container",
            "root"
        ].includes(part != null ? part : "") ? [
            name
        ] : [
            name,
            part
        ];
        const attr = el.filter(Boolean).join("__");
        const className = `chakra-${attr}`;
        const partObj = {
            className: className,
            selector: `.${className}`,
            toString: ()=>part
        };
        return partObj;
    }
    const __type = {};
    return {
        parts: parts,
        toPart: toPart,
        extend: extend,
        selectors: selectors,
        classnames: classnames,
        get keys () {
            return Object.keys(map);
        },
        __type: __type
    };
}


// src/components.ts
var $14dc7d8b583e9ee9$export$377a77e99e7c73a5 = (0, $2a167641725e706b$export$477202748c7242bf)("accordion").parts("root", "container", "button", "panel").extend("icon");
var $14dc7d8b583e9ee9$export$fc51889fa4de265a = (0, $2a167641725e706b$export$477202748c7242bf)("alert").parts("title", "description", "container").extend("icon", "spinner");
var $14dc7d8b583e9ee9$export$60f8655d889e17c7 = (0, $2a167641725e706b$export$477202748c7242bf)("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var $14dc7d8b583e9ee9$export$2fb03f744a6ecf93 = (0, $2a167641725e706b$export$477202748c7242bf)("breadcrumb").parts("link", "item", "container").extend("separator");
var $14dc7d8b583e9ee9$export$1699c5cb20c07888 = (0, $2a167641725e706b$export$477202748c7242bf)("button").parts();
var $14dc7d8b583e9ee9$export$21946b04497ed6ac = (0, $2a167641725e706b$export$477202748c7242bf)("checkbox").parts("control", "icon", "container").extend("label");
var $14dc7d8b583e9ee9$export$2c953111278f3272 = (0, $2a167641725e706b$export$477202748c7242bf)("progress").parts("track", "filledTrack").extend("label");
var $14dc7d8b583e9ee9$export$d3f4aaa4b0f2907a = (0, $2a167641725e706b$export$477202748c7242bf)("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $14dc7d8b583e9ee9$export$2813c9511eeab082 = (0, $2a167641725e706b$export$477202748c7242bf)("editable").parts("preview", "input", "textarea");
var $14dc7d8b583e9ee9$export$4b243e3f209a7e5e = (0, $2a167641725e706b$export$477202748c7242bf)("form").parts("container", "requiredIndicator", "helperText");
var $14dc7d8b583e9ee9$export$bb18c440c00e82d9 = (0, $2a167641725e706b$export$477202748c7242bf)("formError").parts("text", "icon");
var $14dc7d8b583e9ee9$export$1ffeb100b532f46d = (0, $2a167641725e706b$export$477202748c7242bf)("input").parts("addon", "field", "element");
var $14dc7d8b583e9ee9$export$12b3a655a94374ed = (0, $2a167641725e706b$export$477202748c7242bf)("list").parts("container", "item", "icon");
var $14dc7d8b583e9ee9$export$e251092a5dcb1329 = (0, $2a167641725e706b$export$477202748c7242bf)("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider");
var $14dc7d8b583e9ee9$export$34e33beb8d992ac2 = (0, $2a167641725e706b$export$477202748c7242bf)("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var $14dc7d8b583e9ee9$export$859cc7ca3200df97 = (0, $2a167641725e706b$export$477202748c7242bf)("numberinput").parts("root", "field", "stepperGroup", "stepper");
var $14dc7d8b583e9ee9$export$12bb869d7991ac50 = (0, $2a167641725e706b$export$477202748c7242bf)("pininput").parts("field");
var $14dc7d8b583e9ee9$export$afda07d12cd4337d = (0, $2a167641725e706b$export$477202748c7242bf)("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var $14dc7d8b583e9ee9$export$ba6328c242bd649c = (0, $2a167641725e706b$export$477202748c7242bf)("progress").parts("label", "filledTrack", "track");
var $14dc7d8b583e9ee9$export$d28d06d0e29ef022 = (0, $2a167641725e706b$export$477202748c7242bf)("radio").parts("container", "control", "label");
var $14dc7d8b583e9ee9$export$17993f0be9538b5a = (0, $2a167641725e706b$export$477202748c7242bf)("select").parts("field", "icon");
var $14dc7d8b583e9ee9$export$c21b4b3f8b239f32 = (0, $2a167641725e706b$export$477202748c7242bf)("slider").parts("container", "track", "thumb", "filledTrack", "mark");
var $14dc7d8b583e9ee9$export$2cfbad67ae6ee421 = (0, $2a167641725e706b$export$477202748c7242bf)("stat").parts("container", "label", "helpText", "number", "icon");
var $14dc7d8b583e9ee9$export$921c1a2d1ce1e86a = (0, $2a167641725e706b$export$477202748c7242bf)("switch").parts("container", "track", "thumb");
var $14dc7d8b583e9ee9$export$8b1b9cdd5db9f5fd = (0, $2a167641725e706b$export$477202748c7242bf)("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
var $14dc7d8b583e9ee9$export$97383552563be58d = (0, $2a167641725e706b$export$477202748c7242bf)("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
var $14dc7d8b583e9ee9$export$4c2f5f7f2ea94a8e = (0, $2a167641725e706b$export$477202748c7242bf)("tag").parts("container", "label", "closeButton");
var $14dc7d8b583e9ee9$export$487a447ffa5755b6 = (0, $2a167641725e706b$export$477202748c7242bf)("card").parts("container", "header", "body", "footer");



// src/css-calc.ts

function $e5b1604dd31a03f9$var$toRef(operand) {
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(operand) && operand.reference) return operand.reference;
    return String(operand);
}
var $e5b1604dd31a03f9$var$toExpr = (operator, ...operands)=>operands.map($e5b1604dd31a03f9$var$toRef).join(` ${operator} `).replace(/calc/g, "");
var $e5b1604dd31a03f9$var$add = (...operands)=>`calc(${$e5b1604dd31a03f9$var$toExpr("+", ...operands)})`;
var $e5b1604dd31a03f9$var$subtract = (...operands)=>`calc(${$e5b1604dd31a03f9$var$toExpr("-", ...operands)})`;
var $e5b1604dd31a03f9$var$multiply = (...operands)=>`calc(${$e5b1604dd31a03f9$var$toExpr("*", ...operands)})`;
var $e5b1604dd31a03f9$var$divide = (...operands)=>`calc(${$e5b1604dd31a03f9$var$toExpr("/", ...operands)})`;
var $e5b1604dd31a03f9$var$negate = (x)=>{
    const value = $e5b1604dd31a03f9$var$toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    return $e5b1604dd31a03f9$var$multiply(value, -1);
};
var $e5b1604dd31a03f9$export$42bfa9b2d4dad91a = Object.assign((x)=>({
        add: (...operands)=>$e5b1604dd31a03f9$export$42bfa9b2d4dad91a($e5b1604dd31a03f9$var$add(x, ...operands)),
        subtract: (...operands)=>$e5b1604dd31a03f9$export$42bfa9b2d4dad91a($e5b1604dd31a03f9$var$subtract(x, ...operands)),
        multiply: (...operands)=>$e5b1604dd31a03f9$export$42bfa9b2d4dad91a($e5b1604dd31a03f9$var$multiply(x, ...operands)),
        divide: (...operands)=>$e5b1604dd31a03f9$export$42bfa9b2d4dad91a($e5b1604dd31a03f9$var$divide(x, ...operands)),
        negate: ()=>$e5b1604dd31a03f9$export$42bfa9b2d4dad91a($e5b1604dd31a03f9$var$negate(x)),
        toString: ()=>x.toString()
    }), {
    add: $e5b1604dd31a03f9$var$add,
    subtract: $e5b1604dd31a03f9$var$subtract,
    multiply: $e5b1604dd31a03f9$var$multiply,
    divide: $e5b1604dd31a03f9$var$divide,
    negate: $e5b1604dd31a03f9$var$negate
});

// src/css-var.ts
function $47f55a9b9bd6210d$export$2ad0182371401ea4(value) {
    return !Number.isInteger(parseFloat(value.toString()));
}
function $47f55a9b9bd6210d$var$replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
}
function $47f55a9b9bd6210d$var$escape(value) {
    const valueStr = $47f55a9b9bd6210d$var$replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\.")) return value;
    return $47f55a9b9bd6210d$export$2ad0182371401ea4(value) ? valueStr.replace(".", `\\.`) : value;
}
function $47f55a9b9bd6210d$export$9748efee331ec573(value, prefix = "") {
    return [
        prefix,
        $47f55a9b9bd6210d$var$escape(value)
    ].filter(Boolean).join("-");
}
function $47f55a9b9bd6210d$export$44410db3a43190e8(name, fallback) {
    return `var(${$47f55a9b9bd6210d$var$escape(name)}${fallback ? `, ${fallback}` : ""})`;
}
function $47f55a9b9bd6210d$export$e2ffa342f278b3a3(value, prefix = "") {
    return `--${$47f55a9b9bd6210d$export$9748efee331ec573(value, prefix)}`;
}
function $47f55a9b9bd6210d$export$8b4981022bd80a4e(name, options) {
    const cssVariable = $47f55a9b9bd6210d$export$e2ffa342f278b3a3(name, options == null ? void 0 : options.prefix);
    return {
        variable: cssVariable,
        reference: $47f55a9b9bd6210d$export$44410db3a43190e8(cssVariable, $47f55a9b9bd6210d$var$getFallback(options == null ? void 0 : options.fallback))
    };
}
function $47f55a9b9bd6210d$var$getFallback(fallback) {
    if (typeof fallback === "string") return fallback;
    return fallback == null ? void 0 : fallback.reference;
}


var { defineMultiStyleConfig: $33844a1471636d94$var$defineMultiStyleConfig, definePartsStyle: $33844a1471636d94$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$921c1a2d1ce1e86a).keys);
var $33844a1471636d94$var$$width = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("switch-track-width");
var $33844a1471636d94$var$$height = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("switch-track-height");
var $33844a1471636d94$var$$diff = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("switch-track-diff");
var $33844a1471636d94$var$diffValue = (0, $e5b1604dd31a03f9$export$42bfa9b2d4dad91a).subtract($33844a1471636d94$var$$width, $33844a1471636d94$var$$height);
var $33844a1471636d94$var$$translateX = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("switch-thumb-x");
var $33844a1471636d94$var$$bg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("switch-bg");
var $33844a1471636d94$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        borderRadius: "full",
        p: "0.5",
        width: [
            $33844a1471636d94$var$$width.reference
        ],
        height: [
            $33844a1471636d94$var$$height.reference
        ],
        transitionProperty: "common",
        transitionDuration: "fast",
        [$33844a1471636d94$var$$bg.variable]: "colors.gray.300",
        _dark: {
            [$33844a1471636d94$var$$bg.variable]: "colors.whiteAlpha.400"
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        },
        _checked: {
            [$33844a1471636d94$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$33844a1471636d94$var$$bg.variable]: `colors.${c}.200`
            }
        },
        bg: $33844a1471636d94$var$$bg.reference
    };
});
var $33844a1471636d94$var$baseStyleThumb = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [
        $33844a1471636d94$var$$height.reference
    ],
    height: [
        $33844a1471636d94$var$$height.reference
    ],
    _checked: {
        transform: `translateX(${$33844a1471636d94$var$$translateX.reference})`
    }
});
var $33844a1471636d94$var$baseStyle = $33844a1471636d94$var$definePartsStyle((props)=>({
        container: {
            [$33844a1471636d94$var$$diff.variable]: $33844a1471636d94$var$diffValue,
            [$33844a1471636d94$var$$translateX.variable]: $33844a1471636d94$var$$diff.reference,
            _rtl: {
                [$33844a1471636d94$var$$translateX.variable]: (0, $e5b1604dd31a03f9$export$42bfa9b2d4dad91a)($33844a1471636d94$var$$diff).negate().toString()
            }
        },
        track: $33844a1471636d94$var$baseStyleTrack(props),
        thumb: $33844a1471636d94$var$baseStyleThumb
    }));
var $33844a1471636d94$var$sizes = {
    sm: $33844a1471636d94$var$definePartsStyle({
        container: {
            [$33844a1471636d94$var$$width.variable]: "1.375rem",
            [$33844a1471636d94$var$$height.variable]: "sizes.3"
        }
    }),
    md: $33844a1471636d94$var$definePartsStyle({
        container: {
            [$33844a1471636d94$var$$width.variable]: "1.875rem",
            [$33844a1471636d94$var$$height.variable]: "sizes.4"
        }
    }),
    lg: $33844a1471636d94$var$definePartsStyle({
        container: {
            [$33844a1471636d94$var$$width.variable]: "2.875rem",
            [$33844a1471636d94$var$$height.variable]: "sizes.6"
        }
    })
};
var $33844a1471636d94$export$6856b73e98185bff = $33844a1471636d94$var$defineMultiStyleConfig({
    baseStyle: $33844a1471636d94$var$baseStyle,
    sizes: $33844a1471636d94$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/table.ts


// src/component.ts
function $edac90b4236d0f41$export$549ff81930776885(light, dark) {
    return (props)=>props.colorMode === "dark" ? dark : light;
}
function $edac90b4236d0f41$export$f3eec17ee6065eee(options) {
    const { orientation: orientation, vertical: vertical, horizontal: horizontal } = options;
    if (!orientation) return {};
    return orientation === "vertical" ? vertical : horizontal;
}


var { defineMultiStyleConfig: $fa23e9310c0e1d60$var$defineMultiStyleConfig, definePartsStyle: $fa23e9310c0e1d60$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$8b1b9cdd5db9f5fd).keys);
var $fa23e9310c0e1d60$var$baseStyle = $fa23e9310c0e1d60$var$definePartsStyle({
    table: {
        fontVariantNumeric: "lining-nums tabular-nums",
        borderCollapse: "collapse",
        width: "full"
    },
    th: {
        fontFamily: "heading",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "wider",
        textAlign: "start"
    },
    td: {
        textAlign: "start"
    },
    caption: {
        mt: 4,
        fontFamily: "heading",
        textAlign: "center",
        fontWeight: "medium"
    }
});
var $fa23e9310c0e1d60$var$numericStyles = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    "&[data-is-numeric=true]": {
        textAlign: "end"
    }
});
var $fa23e9310c0e1d60$var$variantSimple = $fa23e9310c0e1d60$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$fa23e9310c0e1d60$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$fa23e9310c0e1d60$var$numericStyles
        },
        caption: {
            color: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $fa23e9310c0e1d60$var$variantStripe = $fa23e9310c0e1d60$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        th: {
            color: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.600", "gray.400")(props),
            borderBottom: "1px",
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$fa23e9310c0e1d60$var$numericStyles
        },
        td: {
            borderBottom: "1px",
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props),
            ...$fa23e9310c0e1d60$var$numericStyles
        },
        caption: {
            color: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.600", "gray.100")(props)
        },
        tbody: {
            tr: {
                "&:nth-of-type(odd)": {
                    "th, td": {
                        borderBottomWidth: "1px",
                        borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    },
                    td: {
                        background: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.100`, `${c}.700`)(props)
                    }
                }
            }
        },
        tfoot: {
            tr: {
                "&:last-of-type": {
                    th: {
                        borderBottomWidth: 0
                    }
                }
            }
        }
    };
});
var $fa23e9310c0e1d60$var$variants = {
    simple: $fa23e9310c0e1d60$var$variantSimple,
    striped: $fa23e9310c0e1d60$var$variantStripe,
    unstyled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({})
};
var $fa23e9310c0e1d60$var$sizes = {
    sm: $fa23e9310c0e1d60$var$definePartsStyle({
        th: {
            px: "4",
            py: "1",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            lineHeight: "4"
        },
        caption: {
            px: "4",
            py: "2",
            fontSize: "xs"
        }
    }),
    md: $fa23e9310c0e1d60$var$definePartsStyle({
        th: {
            px: "6",
            py: "3",
            lineHeight: "4",
            fontSize: "xs"
        },
        td: {
            px: "6",
            py: "4",
            lineHeight: "5"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "sm"
        }
    }),
    lg: $fa23e9310c0e1d60$var$definePartsStyle({
        th: {
            px: "8",
            py: "4",
            lineHeight: "5",
            fontSize: "sm"
        },
        td: {
            px: "8",
            py: "5",
            lineHeight: "6"
        },
        caption: {
            px: "6",
            py: "2",
            fontSize: "md"
        }
    })
};
var $fa23e9310c0e1d60$export$3339219781bb5161 = $fa23e9310c0e1d60$var$defineMultiStyleConfig({
    baseStyle: $fa23e9310c0e1d60$var$baseStyle,
    variants: $fa23e9310c0e1d60$var$variants,
    sizes: $fa23e9310c0e1d60$var$sizes,
    defaultProps: {
        variant: "simple",
        size: "md",
        colorScheme: "gray"
    }
});


// src/components/tabs.ts


// src/color.ts

/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */ function $82bd23a4eacb9716$export$864d727b48066337(low, high, value) {
    return Math.min(Math.max(low, value), high);
}
class $82bd23a4eacb9716$var$ColorError extends Error {
    constructor(color){
        super(`Failed to parse color: "${color}"`);
    }
}
var $82bd23a4eacb9716$export$21f8cadbc4af9bbf = $82bd23a4eacb9716$var$ColorError;
/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */ function $82bd23a4eacb9716$export$88c26fe48243d749(color) {
    if (typeof color !== "string") throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
    if (color.trim().toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    let normalizedColor = color.trim();
    normalizedColor = $82bd23a4eacb9716$var$namedColorRegex.test(color) ? $82bd23a4eacb9716$var$nameToHex(color) : color;
    const reducedHexMatch = $82bd23a4eacb9716$var$reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
        const arr = Array.from(reducedHexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt($82bd23a4eacb9716$var$r(x, 2), 16)),
            parseInt($82bd23a4eacb9716$var$r(arr[3] || "f", 2), 16) / 255
        ];
    }
    const hexMatch = $82bd23a4eacb9716$var$hexRegex.exec(normalizedColor);
    if (hexMatch) {
        const arr = Array.from(hexMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 16)),
            parseInt(arr[3] || "ff", 16) / 255
        ];
    }
    const rgbaMatch = $82bd23a4eacb9716$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
        const arr = Array.from(rgbaMatch).slice(1);
        return [
            ...arr.slice(0, 3).map((x)=>parseInt(x, 10)),
            parseFloat(arr[3] || "1")
        ];
    }
    const hslaMatch = $82bd23a4eacb9716$var$hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
        const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
        if ($82bd23a4eacb9716$export$864d727b48066337(0, 100, s) !== s) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
        if ($82bd23a4eacb9716$export$864d727b48066337(0, 100, l) !== l) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
        return [
            ...$82bd23a4eacb9716$var$hslToRgb(h, s, l),
            Number.isNaN(a) ? 1 : a
        ];
    }
    throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
}
function $82bd23a4eacb9716$var$hash(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return (hash >>> 0) % 2341;
}
const $82bd23a4eacb9716$var$colorToInt = (x)=>parseInt(x.replace(/_/g, ""), 36);
const $82bd23a4eacb9716$var$compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next)=>{
    const key = $82bd23a4eacb9716$var$colorToInt(next.substring(0, 3));
    const hex = $82bd23a4eacb9716$var$colorToInt(next.substring(3)).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = "";
    for(let i = 0; i < 6 - hex.length; i++)prefix += "0";
    acc[key] = `${prefix}${hex}`;
    return acc;
}, {});
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */ function $82bd23a4eacb9716$var$nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = $82bd23a4eacb9716$var$compressedColorMap[$82bd23a4eacb9716$var$hash(normalizedColorName)];
    if (!result) throw new $82bd23a4eacb9716$export$21f8cadbc4af9bbf(color);
    return `#${result}`;
}
const $82bd23a4eacb9716$var$r = (str, amount)=>Array.from(Array(amount)).map(()=>str).join("");
const $82bd23a4eacb9716$var$reducedHexRegex = new RegExp(`^#${$82bd23a4eacb9716$var$r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
const $82bd23a4eacb9716$var$hexRegex = new RegExp(`^#${$82bd23a4eacb9716$var$r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
const $82bd23a4eacb9716$var$rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${$82bd23a4eacb9716$var$r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
const $82bd23a4eacb9716$var$hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const $82bd23a4eacb9716$var$namedColorRegex = /^[a-z]+$/i;
const $82bd23a4eacb9716$var$roundColor = (color)=>{
    return Math.round(color * 255);
};
const $82bd23a4eacb9716$var$hslToRgb = (hue, saturation, lightness)=>{
    let l = lightness / 100;
    if (saturation === 0) // achromatic
    return [
        l,
        l,
        l
    ].map($82bd23a4eacb9716$var$roundColor);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [
        finalRed,
        finalGreen,
        finalBlue
    ].map($82bd23a4eacb9716$var$roundColor);
};
// taken from:
/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */ function $82bd23a4eacb9716$export$c7d9b10ca8edee87(color) {
    const [red, green, blue, alpha] = $82bd23a4eacb9716$export$88c26fe48243d749(color).map((value, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? value : value / 255);
    const max = Math.max(red, green, blue);
    const min = Math.min(red, green, blue);
    const lightness = (max + min) / 2;
    // achromatic
    if (max === min) return [
        0,
        0,
        lightness,
        alpha
    ];
    const delta = max - min;
    const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
    return [
        hue,
        saturation,
        lightness,
        alpha
    ];
}
/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$810b04175080204c(hue, saturation, lightness, alpha) {
    return `hsla(${(hue % 360).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 100, saturation * 100).toFixed()}%, ${$82bd23a4eacb9716$export$864d727b48066337(0, 100, lightness * 100).toFixed()}%, ${parseFloat($82bd23a4eacb9716$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */ function $82bd23a4eacb9716$export$2b372a09365374d6(color, degrees) {
    const [h, s, l, a] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(h + degrees, s, l, a);
}
/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$4b073707ff63303(color, amount) {
    const [hue, saturation, lightness, alpha] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(hue, saturation, lightness - amount, alpha);
}
/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$fb75607d98509d9(color, amount) {
    const [h, s, l, a] = $82bd23a4eacb9716$export$c7d9b10ca8edee87(color);
    return $82bd23a4eacb9716$export$810b04175080204c(h, s - amount, l, a);
}
// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js
/**
 * Returns a number (float) representing the luminance of a color.
 */ function $82bd23a4eacb9716$export$c852d90bf7403b62(color) {
    if (color === "transparent") return 0;
    function f(x) {
        const channel = x / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    const [r, g, b] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}
// taken from:
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */ function $82bd23a4eacb9716$export$850ce485a60d103b(color1, color2) {
    const luminance1 = $82bd23a4eacb9716$export$c852d90bf7403b62(color1);
    const luminance2 = $82bd23a4eacb9716$export$c852d90bf7403b62(color2);
    return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}
/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$4e46ac54fc82cf3b(red, green, blue, alpha) {
    return `rgba(${$82bd23a4eacb9716$export$864d727b48066337(0, 255, red).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 255, green).toFixed()}, ${$82bd23a4eacb9716$export$864d727b48066337(0, 255, blue).toFixed()}, ${parseFloat($82bd23a4eacb9716$export$864d727b48066337(0, 1, alpha).toFixed(3))})`;
}
/**
 * Mixes two colors together. Taken from sass's implementation.
 */ function $82bd23a4eacb9716$export$2c9e8a9632a706b2(color1, color2, weight) {
    const normalize = (n, index)=>// 3rd index is alpha channel which is already normalized
        index === 3 ? n : n / 255;
    const [r1, g1, b1, a1] = $82bd23a4eacb9716$export$88c26fe48243d749(color1).map(normalize);
    const [r2, g2, b2, a2] = $82bd23a4eacb9716$export$88c26fe48243d749(color2).map(normalize);
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    const alphaDelta = a2 - a1;
    const normalizedWeight = weight * 2 - 1;
    const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
    const weight2 = (combinedWeight + 1) / 2;
    const weight1 = 1 - weight2;
    const r = (r1 * weight1 + r2 * weight2) * 255;
    const g = (g1 * weight1 + g2 * weight2) * 255;
    const b = (b1 * weight1 + b2 * weight2) * 255;
    const a = a2 * weight + a1 * (1 - weight);
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(r, g, b, a);
}
/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */ function $82bd23a4eacb9716$export$5cdac61cf538712e(...colors) {
    return (n)=>{
        const lastIndex = colors.length - 1;
        const lowIndex = $82bd23a4eacb9716$export$864d727b48066337(0, lastIndex, Math.floor(n * lastIndex));
        const highIndex = $82bd23a4eacb9716$export$864d727b48066337(0, lastIndex, Math.ceil(n * lastIndex));
        const color1 = colors[lowIndex];
        const color2 = colors[highIndex];
        const unit = 1 / lastIndex;
        const weight = (n - unit * lowIndex) / unit;
        return $82bd23a4eacb9716$export$2c9e8a9632a706b2(color1, color2, weight);
    };
}
const $82bd23a4eacb9716$var$guidelines = {
    decorative: 1.5,
    readable: 3,
    aa: 4.5,
    aaa: 7
};
/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */ function $82bd23a4eacb9716$export$f4ab80233a44f806(color, standard = "aa", background = "#fff") {
    return $82bd23a4eacb9716$export$850ce485a60d103b(color, background) < $82bd23a4eacb9716$var$guidelines[standard];
}
/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$c0816ed86df316af(color, amount) {
    return $82bd23a4eacb9716$export$4b073707ff63303(color, -amount);
}
/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$d11da87e55cc498f(color, amount) {
    const [r, g, b, a] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(r, g, b, a - amount);
}
/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$f4f50e3877dd0530(color, amount) {
    return $82bd23a4eacb9716$export$d11da87e55cc498f(color, -amount);
}
/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */ function $82bd23a4eacb9716$export$dcb2d24cf045d06(color) {
    return $82bd23a4eacb9716$export$c852d90bf7403b62(color) > 0.179;
}
/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */ function $82bd23a4eacb9716$export$61654c1796c44811(color) {
    return $82bd23a4eacb9716$export$dcb2d24cf045d06(color) ? "#000" : "#fff";
}
/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */ function $82bd23a4eacb9716$export$5fcac96f5a87e3db(color, amount) {
    return $82bd23a4eacb9716$export$fb75607d98509d9(color, -amount);
}
/**
 * Takes in any color and returns it as a hex code.
 */ function $82bd23a4eacb9716$export$7ea66e3774a60b67(color) {
    const [r, g, b, a] = $82bd23a4eacb9716$export$88c26fe48243d749(color);
    let hex = (x)=>{
        const h = $82bd23a4eacb9716$export$864d727b48066337(0, 255, x).toString(16);
        // NOTE: padStart could be used here but it breaks Node 6 compat
        // https://github.com/ricokahler/color2k/issues/351
        return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}
/**
 * Takes in any color and returns it as an rgba string.
 */ function $82bd23a4eacb9716$export$5db297beaffffbfc(color) {
    return $82bd23a4eacb9716$export$4e46ac54fc82cf3b(...$82bd23a4eacb9716$export$88c26fe48243d749(color));
}
/**
 * Takes in any color and returns it as an hsla string.
 */ function $82bd23a4eacb9716$export$b9678a7d4ac803cc(color) {
    return $82bd23a4eacb9716$export$810b04175080204c(...$82bd23a4eacb9716$export$c7d9b10ca8edee87(color));
}


// ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
function $bcc5e97ee12ebad5$var$dlv_es_default(t, e, l, n, r) {
    for(e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)t = t ? t[e[n]] : r;
    return t === r ? l : t;
}
// src/color.ts
var $bcc5e97ee12ebad5$var$isEmptyObject = (obj)=>Object.keys(obj).length === 0;
var $bcc5e97ee12ebad5$export$5551a2d24ff40153 = (theme, color, fallback)=>{
    const hex = $bcc5e97ee12ebad5$var$dlv_es_default(theme, `colors.${color}`, color);
    try {
        (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)(hex);
        return hex;
    } catch  {
        return fallback != null ? fallback : "#000000";
    }
};
var $bcc5e97ee12ebad5$export$fdaf813cf8a11246 = (theme, color, fallback)=>{
    var _a;
    return (_a = (0, $47a6d9fbbf7ee42d$export$93c8e06b7014dc33)(theme, "colors", color)) != null ? _a : fallback;
};
var $bcc5e97ee12ebad5$var$getBrightness = (color)=>{
    const [r, g, b] = (0, $82bd23a4eacb9716$export$88c26fe48243d749)(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
};
var $bcc5e97ee12ebad5$export$7297c25227171a1f = (color)=>(theme)=>{
        const hex = $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, color);
        const brightness = $bcc5e97ee12ebad5$var$getBrightness(hex);
        const isDark2 = brightness < 128;
        return isDark2 ? "dark" : "light";
    };
var $bcc5e97ee12ebad5$export$a79ad82046afa44e = (color)=>(theme)=>$bcc5e97ee12ebad5$export$7297c25227171a1f(color)(theme) === "dark";
var $bcc5e97ee12ebad5$export$44af652f4cca9039 = (color)=>(theme)=>$bcc5e97ee12ebad5$export$7297c25227171a1f(color)(theme) === "light";
var $bcc5e97ee12ebad5$export$d11da87e55cc498f = (color, opacity)=>(theme)=>{
        const raw = $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$d11da87e55cc498f)(raw, 1 - opacity);
    };
var $bcc5e97ee12ebad5$export$81525e9955aa80e8 = (color, amount)=>(theme)=>{
        const raw = $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$2c9e8a9632a706b2)(raw, "#fff", amount));
    };
var $bcc5e97ee12ebad5$export$2b471577c483101c = (color, amount)=>(theme)=>{
        const raw = $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$2c9e8a9632a706b2)(raw, "#000", amount / 100));
    };
var $bcc5e97ee12ebad5$export$4b073707ff63303 = (color, amount)=>(theme)=>{
        const raw = $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, color);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$4b073707ff63303)(raw, amount / 100));
    };
var $bcc5e97ee12ebad5$export$c0816ed86df316af = (color, amount)=>(theme)=>{
        const raw = $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, color);
        (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$c0816ed86df316af)(raw, amount / 100));
    };
var $bcc5e97ee12ebad5$export$1ec78ac20028ebd4 = (fg, bg)=>(theme)=>(0, $82bd23a4eacb9716$export$850ce485a60d103b)($bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, bg), $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, fg));
var $bcc5e97ee12ebad5$export$cd41ae544cfc2a65 = (textColor, bgColor, options)=>(theme)=>$bcc5e97ee12ebad5$export$3fe5b5ca1e6a6a28($bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, bgColor), $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, textColor), options);
function $bcc5e97ee12ebad5$export$3fe5b5ca1e6a6a28(color1, color2, wcag2 = {
    level: "AA",
    size: "small"
}) {
    var _a, _b;
    const readabilityLevel = $bcc5e97ee12ebad5$export$b7b705aaad1c5b6a(color1, color2);
    switch(((_a = wcag2.level) != null ? _a : "AA") + ((_b = wcag2.size) != null ? _b : "small")){
        case "AAsmall":
        case "AAAlarge":
            return readabilityLevel >= 4.5;
        case "AAlarge":
            return readabilityLevel >= 3;
        case "AAAsmall":
            return readabilityLevel >= 7;
        default:
            return false;
    }
}
function $bcc5e97ee12ebad5$export$b7b705aaad1c5b6a(color1, color2) {
    return (Math.max((0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color1), (0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color2)) + 0.05) / (Math.min((0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color1), (0, $82bd23a4eacb9716$export$c852d90bf7403b62)(color2)) + 0.05);
}
var $bcc5e97ee12ebad5$export$504efcfbebdbcaf = (color)=>(theme)=>{
        const raw = $bcc5e97ee12ebad5$export$5551a2d24ff40153(theme, color);
        const hsl = (0, $82bd23a4eacb9716$export$c7d9b10ca8edee87)(raw);
        const complementHsl = Object.assign(hsl, [
            (hsl[0] + 180) % 360
        ]);
        return (0, $82bd23a4eacb9716$export$7ea66e3774a60b67)((0, $82bd23a4eacb9716$export$810b04175080204c)(...complementHsl));
    };
function $bcc5e97ee12ebad5$export$db0ffb03ee9f3080(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
        backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
        backgroundSize: `${size} ${size}`
    };
}
var $bcc5e97ee12ebad5$var$randomHex = ()=>`#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function $bcc5e97ee12ebad5$export$f3c6ed4330abfc18(opts) {
    const fallback = $bcc5e97ee12ebad5$var$randomHex();
    if (!opts || $bcc5e97ee12ebad5$var$isEmptyObject(opts)) return fallback;
    if (opts.string && opts.colors) return $bcc5e97ee12ebad5$var$randomColorFromList(opts.string, opts.colors);
    if (opts.string && !opts.colors) return $bcc5e97ee12ebad5$var$randomColorFromString(opts.string);
    if (opts.colors && !opts.string) return $bcc5e97ee12ebad5$var$randomFromList(opts.colors);
    return fallback;
}
function $bcc5e97ee12ebad5$var$randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0) return hash.toString();
    for(let i = 0; i < str.length; i += 1){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    let color = "#";
    for(let j = 0; j < 3; j += 1){
        const value = hash >> j * 8 & 255;
        color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
}
function $bcc5e97ee12ebad5$var$randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0) return list[0];
    for(let i = 0; i < str.length; i += 1){
        index = str.charCodeAt(i) + ((index << 5) - index);
        index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
}
function $bcc5e97ee12ebad5$var$randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
}


var $c7ac2fd943c388b9$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-color");
var $c7ac2fd943c388b9$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-bg");
var $c7ac2fd943c388b9$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tabs-border-color");
var { defineMultiStyleConfig: $c7ac2fd943c388b9$var$defineMultiStyleConfig, definePartsStyle: $c7ac2fd943c388b9$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$97383552563be58d).keys);
var $c7ac2fd943c388b9$var$baseStyleRoot = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: orientation === "vertical" ? "flex" : "block"
    };
});
var $c7ac2fd943c388b9$var$baseStyleTab = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isFitted: isFitted } = props;
    return {
        flex: isFitted ? 1 : void 0,
        transitionProperty: "common",
        transitionDuration: "normal",
        _focusVisible: {
            zIndex: 1,
            boxShadow: "outline"
        },
        _disabled: {
            cursor: "not-allowed",
            opacity: 0.4
        }
    };
});
var $c7ac2fd943c388b9$var$baseStyleTablist = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { align: align = "start", orientation: orientation } = props;
    const alignments = {
        end: "flex-end",
        center: "center",
        start: "flex-start"
    };
    return {
        justifyContent: alignments[align],
        flexDirection: orientation === "vertical" ? "column" : "row"
    };
});
var $c7ac2fd943c388b9$var$baseStyleTabpanel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    p: 4
});
var $c7ac2fd943c388b9$var$baseStyle = $c7ac2fd943c388b9$var$definePartsStyle((props)=>({
        root: $c7ac2fd943c388b9$var$baseStyleRoot(props),
        tab: $c7ac2fd943c388b9$var$baseStyleTab(props),
        tablist: $c7ac2fd943c388b9$var$baseStyleTablist(props),
        tabpanel: $c7ac2fd943c388b9$var$baseStyleTabpanel
    }));
var $c7ac2fd943c388b9$var$sizes = {
    sm: $c7ac2fd943c388b9$var$definePartsStyle({
        tab: {
            py: 1,
            px: 4,
            fontSize: "sm"
        }
    }),
    md: $c7ac2fd943c388b9$var$definePartsStyle({
        tab: {
            fontSize: "md",
            py: 2,
            px: 4
        }
    }),
    lg: $c7ac2fd943c388b9$var$definePartsStyle({
        tab: {
            fontSize: "lg",
            py: 3,
            px: 4
        }
    })
};
var $c7ac2fd943c388b9$var$variantLine = $c7ac2fd943c388b9$var$definePartsStyle((props)=>{
    const { colorScheme: c, orientation: orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
        tablist: {
            [borderProp]: "2px solid",
            borderColor: "inherit"
        },
        tab: {
            [borderProp]: "2px solid",
            borderColor: "transparent",
            [marginProp]: "-2px",
            _selected: {
                [$c7ac2fd943c388b9$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$c7ac2fd943c388b9$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "currentColor"
            },
            _active: {
                [$c7ac2fd943c388b9$var$$bg.variable]: "colors.gray.200",
                _dark: {
                    [$c7ac2fd943c388b9$var$$bg.variable]: "colors.whiteAlpha.300"
                }
            },
            _disabled: {
                _active: {
                    bg: "none"
                }
            },
            color: $c7ac2fd943c388b9$var$$fg.reference,
            bg: $c7ac2fd943c388b9$var$$bg.reference
        }
    };
});
var $c7ac2fd943c388b9$var$variantEnclosed = $c7ac2fd943c388b9$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderTopRadius: "md",
            border: "1px solid",
            borderColor: "transparent",
            mb: "-1px",
            [$c7ac2fd943c388b9$var$$border.variable]: "transparent",
            _selected: {
                [$c7ac2fd943c388b9$var$$fg.variable]: `colors.${c}.600`,
                [$c7ac2fd943c388b9$var$$border.variable]: `colors.white`,
                _dark: {
                    [$c7ac2fd943c388b9$var$$fg.variable]: `colors.${c}.300`,
                    [$c7ac2fd943c388b9$var$$border.variable]: `colors.gray.800`
                },
                borderColor: "inherit",
                borderBottomColor: $c7ac2fd943c388b9$var$$border.reference
            },
            color: $c7ac2fd943c388b9$var$$fg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $c7ac2fd943c388b9$var$variantEnclosedColored = $c7ac2fd943c388b9$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            border: "1px solid",
            borderColor: "inherit",
            [$c7ac2fd943c388b9$var$$bg.variable]: "colors.gray.50",
            _dark: {
                [$c7ac2fd943c388b9$var$$bg.variable]: "colors.whiteAlpha.50"
            },
            mb: "-1px",
            _notLast: {
                marginEnd: "-1px"
            },
            _selected: {
                [$c7ac2fd943c388b9$var$$bg.variable]: "colors.white",
                [$c7ac2fd943c388b9$var$$fg.variable]: `colors.${c}.600`,
                _dark: {
                    [$c7ac2fd943c388b9$var$$bg.variable]: "colors.gray.800",
                    [$c7ac2fd943c388b9$var$$fg.variable]: `colors.${c}.300`
                },
                borderColor: "inherit",
                borderTopColor: "currentColor",
                borderBottomColor: "transparent"
            },
            color: $c7ac2fd943c388b9$var$$fg.reference,
            bg: $c7ac2fd943c388b9$var$$bg.reference
        },
        tablist: {
            mb: "-1px",
            borderBottom: "1px solid",
            borderColor: "inherit"
        }
    };
});
var $c7ac2fd943c388b9$var$variantSoftRounded = $c7ac2fd943c388b9$var$definePartsStyle((props)=>{
    const { colorScheme: c, theme: theme } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            color: "gray.600",
            _selected: {
                color: (0, $bcc5e97ee12ebad5$export$5551a2d24ff40153)(theme, `${c}.700`),
                bg: (0, $bcc5e97ee12ebad5$export$5551a2d24ff40153)(theme, `${c}.100`)
            }
        }
    };
});
var $c7ac2fd943c388b9$var$variantSolidRounded = $c7ac2fd943c388b9$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        tab: {
            borderRadius: "full",
            fontWeight: "semibold",
            [$c7ac2fd943c388b9$var$$fg.variable]: "colors.gray.600",
            _dark: {
                [$c7ac2fd943c388b9$var$$fg.variable]: "inherit"
            },
            _selected: {
                [$c7ac2fd943c388b9$var$$fg.variable]: "colors.white",
                [$c7ac2fd943c388b9$var$$bg.variable]: `colors.${c}.600`,
                _dark: {
                    [$c7ac2fd943c388b9$var$$fg.variable]: "colors.gray.800",
                    [$c7ac2fd943c388b9$var$$bg.variable]: `colors.${c}.300`
                }
            },
            color: $c7ac2fd943c388b9$var$$fg.reference,
            bg: $c7ac2fd943c388b9$var$$bg.reference
        }
    };
});
var $c7ac2fd943c388b9$var$variantUnstyled = $c7ac2fd943c388b9$var$definePartsStyle({});
var $c7ac2fd943c388b9$var$variants = {
    line: $c7ac2fd943c388b9$var$variantLine,
    enclosed: $c7ac2fd943c388b9$var$variantEnclosed,
    "enclosed-colored": $c7ac2fd943c388b9$var$variantEnclosedColored,
    "soft-rounded": $c7ac2fd943c388b9$var$variantSoftRounded,
    "solid-rounded": $c7ac2fd943c388b9$var$variantSolidRounded,
    unstyled: $c7ac2fd943c388b9$var$variantUnstyled
};
var $c7ac2fd943c388b9$export$847a245e7ebce2a1 = $c7ac2fd943c388b9$var$defineMultiStyleConfig({
    baseStyle: $c7ac2fd943c388b9$var$baseStyle,
    sizes: $c7ac2fd943c388b9$var$sizes,
    variants: $c7ac2fd943c388b9$var$variants,
    defaultProps: {
        size: "md",
        variant: "line",
        colorScheme: "blue"
    }
});


// src/components/badge.ts


var $cf27f314dc675791$export$3cb96c9f6c8d16a4 = (0, $47a6d9fbbf7ee42d$export$bd40561c6c056841)("badge", [
    "bg",
    "color",
    "shadow"
]);
var $cf27f314dc675791$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: $cf27f314dc675791$export$3cb96c9f6c8d16a4.bg.reference,
    color: $cf27f314dc675791$export$3cb96c9f6c8d16a4.color.reference,
    boxShadow: $cf27f314dc675791$export$3cb96c9f6c8d16a4.shadow.reference
});
var $cf27f314dc675791$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const dark = (0, $bcc5e97ee12ebad5$export$d11da87e55cc498f)(`${c}.500`, 0.6)(theme);
    return {
        [$cf27f314dc675791$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.500`,
        [$cf27f314dc675791$export$3cb96c9f6c8d16a4.color.variable]: `colors.white`,
        _dark: {
            [$cf27f314dc675791$export$3cb96c9f6c8d16a4.bg.variable]: dark,
            [$cf27f314dc675791$export$3cb96c9f6c8d16a4.color.variable]: `colors.whiteAlpha.800`
        }
    };
});
var $cf27f314dc675791$var$variantSubtle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkBg = (0, $bcc5e97ee12ebad5$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        [$cf27f314dc675791$export$3cb96c9f6c8d16a4.bg.variable]: `colors.${c}.100`,
        [$cf27f314dc675791$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.800`,
        _dark: {
            [$cf27f314dc675791$export$3cb96c9f6c8d16a4.bg.variable]: darkBg,
            [$cf27f314dc675791$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.200`
        }
    };
});
var $cf27f314dc675791$var$variantOutline = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    const darkColor = (0, $bcc5e97ee12ebad5$export$d11da87e55cc498f)(`${c}.200`, 0.8)(theme);
    return {
        [$cf27f314dc675791$export$3cb96c9f6c8d16a4.color.variable]: `colors.${c}.500`,
        _dark: {
            [$cf27f314dc675791$export$3cb96c9f6c8d16a4.color.variable]: darkColor
        },
        [$cf27f314dc675791$export$3cb96c9f6c8d16a4.shadow.variable]: `inset 0 0 0px 1px ${$cf27f314dc675791$export$3cb96c9f6c8d16a4.color.reference}`
    };
});
var $cf27f314dc675791$var$variants = {
    solid: $cf27f314dc675791$var$variantSolid,
    subtle: $cf27f314dc675791$var$variantSubtle,
    outline: $cf27f314dc675791$var$variantOutline
};
var $cf27f314dc675791$export$eb6e7cbc82d0f88b = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $cf27f314dc675791$var$baseStyle,
    variants: $cf27f314dc675791$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "gray"
    }
});




var { defineMultiStyleConfig: $fc4b98d4e69336a7$var$defineMultiStyleConfig, definePartsStyle: $fc4b98d4e69336a7$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$4c2f5f7f2ea94a8e).keys);
var $fc4b98d4e69336a7$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-bg");
var $fc4b98d4e69336a7$var$$color = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-color");
var $fc4b98d4e69336a7$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-shadow");
var $fc4b98d4e69336a7$var$$minH = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-min-height");
var $fc4b98d4e69336a7$var$$minW = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-min-width");
var $fc4b98d4e69336a7$var$$fontSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-font-size");
var $fc4b98d4e69336a7$var$$paddingX = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("tag-padding-inline");
var $fc4b98d4e69336a7$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$fc4b98d4e69336a7$var$$color.variable]: (0, $cf27f314dc675791$export$3cb96c9f6c8d16a4).color.reference,
    [$fc4b98d4e69336a7$var$$bg.variable]: (0, $cf27f314dc675791$export$3cb96c9f6c8d16a4).bg.reference,
    [$fc4b98d4e69336a7$var$$shadow.variable]: (0, $cf27f314dc675791$export$3cb96c9f6c8d16a4).shadow.reference,
    color: $fc4b98d4e69336a7$var$$color.reference,
    bg: $fc4b98d4e69336a7$var$$bg.reference,
    boxShadow: $fc4b98d4e69336a7$var$$shadow.reference,
    borderRadius: "md",
    minH: $fc4b98d4e69336a7$var$$minH.reference,
    minW: $fc4b98d4e69336a7$var$$minW.reference,
    fontSize: $fc4b98d4e69336a7$var$$fontSize.reference,
    px: $fc4b98d4e69336a7$var$$paddingX.reference,
    _focusVisible: {
        [$fc4b98d4e69336a7$var$$shadow.variable]: "shadows.outline"
    }
});
var $fc4b98d4e69336a7$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: 1.2,
    overflow: "visible"
});
var $fc4b98d4e69336a7$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
        opacity: 0.4
    },
    _focusVisible: {
        boxShadow: "outline",
        bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
        opacity: 0.8
    },
    _active: {
        opacity: 1
    }
});
var $fc4b98d4e69336a7$var$baseStyle = $fc4b98d4e69336a7$var$definePartsStyle({
    container: $fc4b98d4e69336a7$var$baseStyleContainer,
    label: $fc4b98d4e69336a7$var$baseStyleLabel,
    closeButton: $fc4b98d4e69336a7$var$baseStyleCloseButton
});
var $fc4b98d4e69336a7$var$sizes = {
    sm: $fc4b98d4e69336a7$var$definePartsStyle({
        container: {
            [$fc4b98d4e69336a7$var$$minH.variable]: "sizes.5",
            [$fc4b98d4e69336a7$var$$minW.variable]: "sizes.5",
            [$fc4b98d4e69336a7$var$$fontSize.variable]: "fontSizes.xs",
            [$fc4b98d4e69336a7$var$$paddingX.variable]: "space.2"
        },
        closeButton: {
            marginEnd: "-2px",
            marginStart: "0.35rem"
        }
    }),
    md: $fc4b98d4e69336a7$var$definePartsStyle({
        container: {
            [$fc4b98d4e69336a7$var$$minH.variable]: "sizes.6",
            [$fc4b98d4e69336a7$var$$minW.variable]: "sizes.6",
            [$fc4b98d4e69336a7$var$$fontSize.variable]: "fontSizes.sm",
            [$fc4b98d4e69336a7$var$$paddingX.variable]: "space.2"
        }
    }),
    lg: $fc4b98d4e69336a7$var$definePartsStyle({
        container: {
            [$fc4b98d4e69336a7$var$$minH.variable]: "sizes.8",
            [$fc4b98d4e69336a7$var$$minW.variable]: "sizes.8",
            [$fc4b98d4e69336a7$var$$fontSize.variable]: "fontSizes.md",
            [$fc4b98d4e69336a7$var$$paddingX.variable]: "space.3"
        }
    })
};
var $fc4b98d4e69336a7$var$variants = {
    subtle: $fc4b98d4e69336a7$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $cf27f314dc675791$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.subtle(props)
        };
    }),
    solid: $fc4b98d4e69336a7$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $cf27f314dc675791$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.solid(props)
        };
    }),
    outline: $fc4b98d4e69336a7$var$definePartsStyle((props)=>{
        var _a;
        return {
            container: (_a = (0, $cf27f314dc675791$export$eb6e7cbc82d0f88b).variants) == null ? void 0 : _a.outline(props)
        };
    })
};
var $fc4b98d4e69336a7$export$f8ab9ac2a319695b = $fc4b98d4e69336a7$var$defineMultiStyleConfig({
    variants: $fc4b98d4e69336a7$var$variants,
    baseStyle: $fc4b98d4e69336a7$var$baseStyle,
    sizes: $fc4b98d4e69336a7$var$sizes,
    defaultProps: {
        size: "md",
        variant: "subtle",
        colorScheme: "gray"
    }
});


// src/components/input.ts



var { definePartsStyle: $ec1ccabff4629292$var$definePartsStyle, defineMultiStyleConfig: $ec1ccabff4629292$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$1ffeb100b532f46d).keys);
var $ec1ccabff4629292$var$baseStyle = $ec1ccabff4629292$var$definePartsStyle({
    field: {
        width: "100%",
        minWidth: 0,
        outline: 0,
        position: "relative",
        appearance: "none",
        transitionProperty: "common",
        transitionDuration: "normal",
        _disabled: {
            opacity: 0.4,
            cursor: "not-allowed"
        }
    }
});
var $ec1ccabff4629292$var$size = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "lg",
        px: "4",
        h: "12",
        borderRadius: "md"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "md",
        px: "4",
        h: "10",
        borderRadius: "md"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        px: "3",
        h: "8",
        borderRadius: "sm"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "xs",
        px: "2",
        h: "6",
        borderRadius: "sm"
    })
};
var $ec1ccabff4629292$var$sizes = {
    lg: $ec1ccabff4629292$var$definePartsStyle({
        field: $ec1ccabff4629292$var$size.lg,
        addon: $ec1ccabff4629292$var$size.lg
    }),
    md: $ec1ccabff4629292$var$definePartsStyle({
        field: $ec1ccabff4629292$var$size.md,
        addon: $ec1ccabff4629292$var$size.md
    }),
    sm: $ec1ccabff4629292$var$definePartsStyle({
        field: $ec1ccabff4629292$var$size.sm,
        addon: $ec1ccabff4629292$var$size.sm
    }),
    xs: $ec1ccabff4629292$var$definePartsStyle({
        field: $ec1ccabff4629292$var$size.xs,
        addon: $ec1ccabff4629292$var$size.xs
    })
};
function $ec1ccabff4629292$var$getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
        focusBorderColor: fc || (0, $edac90b4236d0f41$export$549ff81930776885)("blue.500", "blue.300")(props),
        errorBorderColor: ec || (0, $edac90b4236d0f41$export$549ff81930776885)("red.500", "red.300")(props)
    };
}
var $ec1ccabff4629292$var$variantOutline = $ec1ccabff4629292$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $ec1ccabff4629292$var$getDefaults(props);
    return {
        field: {
            border: "1px solid",
            borderColor: "inherit",
            bg: "inherit",
            _hover: {
                borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.300", "whiteAlpha.400")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, ec),
                boxShadow: `0 0 0 1px ${(0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, ec)}`
            },
            _focusVisible: {
                zIndex: 1,
                borderColor: (0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, fc),
                boxShadow: `0 0 0 1px ${(0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, fc)}`
            }
        },
        addon: {
            border: "1px solid",
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)("inherit", "whiteAlpha.50")(props),
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
        }
    };
});
var $ec1ccabff4629292$var$variantFilled = $ec1ccabff4629292$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $ec1ccabff4629292$var$getDefaults(props);
    return {
        field: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props),
            _hover: {
                bg: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.200", "whiteAlpha.100")(props)
            },
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, ec)
            },
            _focusVisible: {
                bg: "transparent",
                borderColor: (0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, fc)
            }
        },
        addon: {
            border: "2px solid",
            borderColor: "transparent",
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.100", "whiteAlpha.50")(props)
        }
    };
});
var $ec1ccabff4629292$var$variantFlushed = $ec1ccabff4629292$var$definePartsStyle((props)=>{
    const { theme: theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = $ec1ccabff4629292$var$getDefaults(props);
    return {
        field: {
            borderBottom: "1px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent",
            _readOnly: {
                boxShadow: "none !important",
                userSelect: "all"
            },
            _invalid: {
                borderColor: (0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, ec),
                boxShadow: `0px 1px 0px 0px ${(0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, ec)}`
            },
            _focusVisible: {
                borderColor: (0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, fc),
                boxShadow: `0px 1px 0px 0px ${(0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(theme, fc)}`
            }
        },
        addon: {
            borderBottom: "2px solid",
            borderColor: "inherit",
            borderRadius: "0",
            px: "0",
            bg: "transparent"
        }
    };
});
var $ec1ccabff4629292$var$variantUnstyled = $ec1ccabff4629292$var$definePartsStyle({
    field: {
        bg: "transparent",
        px: "0",
        height: "auto"
    },
    addon: {
        bg: "transparent",
        px: "0",
        height: "auto"
    }
});
var $ec1ccabff4629292$var$variants = {
    outline: $ec1ccabff4629292$var$variantOutline,
    filled: $ec1ccabff4629292$var$variantFilled,
    flushed: $ec1ccabff4629292$var$variantFlushed,
    unstyled: $ec1ccabff4629292$var$variantUnstyled
};
var $ec1ccabff4629292$export$b1b9f3bced726e54 = $ec1ccabff4629292$var$defineMultiStyleConfig({
    baseStyle: $ec1ccabff4629292$var$baseStyle,
    sizes: $ec1ccabff4629292$var$sizes,
    variants: $ec1ccabff4629292$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});



var $3e8807b7633df861$var$_a;
var $3e8807b7633df861$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($3e8807b7633df861$var$_a = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $3e8807b7633df861$var$_a.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
});
var $3e8807b7633df861$var$_a2, $3e8807b7633df861$var$_b;
var $3e8807b7633df861$var$variants = {
    outline: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.outline(props).field) != null ? _b3 : {};
    }),
    flushed: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.flushed(props).field) != null ? _b3 : {};
    }),
    filled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a4, _b3;
        return (_b3 = (_a4 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants) == null ? void 0 : _a4.filled(props).field) != null ? _b3 : {};
    }),
    unstyled: ($3e8807b7633df861$var$_b = ($3e8807b7633df861$var$_a2 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants) == null ? void 0 : $3e8807b7633df861$var$_a2.unstyled.field) != null ? $3e8807b7633df861$var$_b : {}
};
var $3e8807b7633df861$var$_a3, $3e8807b7633df861$var$_b2, $3e8807b7633df861$var$_c, $3e8807b7633df861$var$_d, $3e8807b7633df861$var$_e, $3e8807b7633df861$var$_f, $3e8807b7633df861$var$_g, $3e8807b7633df861$var$_h;
var $3e8807b7633df861$var$sizes = {
    xs: ($3e8807b7633df861$var$_b2 = ($3e8807b7633df861$var$_a3 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $3e8807b7633df861$var$_a3.xs.field) != null ? $3e8807b7633df861$var$_b2 : {},
    sm: ($3e8807b7633df861$var$_d = ($3e8807b7633df861$var$_c = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $3e8807b7633df861$var$_c.sm.field) != null ? $3e8807b7633df861$var$_d : {},
    md: ($3e8807b7633df861$var$_f = ($3e8807b7633df861$var$_e = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $3e8807b7633df861$var$_e.md.field) != null ? $3e8807b7633df861$var$_f : {},
    lg: ($3e8807b7633df861$var$_h = ($3e8807b7633df861$var$_g = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $3e8807b7633df861$var$_g.lg.field) != null ? $3e8807b7633df861$var$_h : {}
};
var $3e8807b7633df861$export$394b8322fab774c1 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $3e8807b7633df861$var$baseStyle,
    sizes: $3e8807b7633df861$var$sizes,
    variants: $3e8807b7633df861$var$variants,
    defaultProps: {
        size: "md",
        variant: "outline"
    }
});


// src/components/tooltip.ts


var $b9637a0dbd0da5cb$var$$bg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("tooltip-bg");
var $b9637a0dbd0da5cb$var$$fg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("tooltip-fg");
var $b9637a0dbd0da5cb$var$$arrowBg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("popper-arrow-bg");
var $b9637a0dbd0da5cb$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: $b9637a0dbd0da5cb$var$$bg.reference,
    color: $b9637a0dbd0da5cb$var$$fg.reference,
    [$b9637a0dbd0da5cb$var$$bg.variable]: "colors.gray.700",
    [$b9637a0dbd0da5cb$var$$fg.variable]: "colors.whiteAlpha.900",
    _dark: {
        [$b9637a0dbd0da5cb$var$$bg.variable]: "colors.gray.300",
        [$b9637a0dbd0da5cb$var$$fg.variable]: "colors.gray.900"
    },
    [$b9637a0dbd0da5cb$var$$arrowBg.variable]: $b9637a0dbd0da5cb$var$$bg.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
});
var $b9637a0dbd0da5cb$export$7472a7883840b563 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $b9637a0dbd0da5cb$var$baseStyle
});


// src/components/progress.ts



var { defineMultiStyleConfig: $2d094992e522cf2e$var$defineMultiStyleConfig, definePartsStyle: $2d094992e522cf2e$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$ba6328c242bd649c).keys);
var $2d094992e522cf2e$var$filledStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: t, isIndeterminate: isIndeterminate, hasStripe: hasStripe } = props;
    const stripeStyle = (0, $edac90b4236d0f41$export$549ff81930776885)((0, $bcc5e97ee12ebad5$export$db0ffb03ee9f3080)(), (0, $bcc5e97ee12ebad5$export$db0ffb03ee9f3080)("1rem", "rgba(0,0,0,0.1)"))(props);
    const bgColor = (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${(0, $bcc5e97ee12ebad5$export$fdaf813cf8a11246)(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
        ...addStripe && stripeStyle,
        ...isIndeterminate ? {
            bgImage: gradient
        } : {
            bgColor: bgColor
        }
    };
});
var $2d094992e522cf2e$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
});
var $2d094992e522cf2e$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    return {
        bg: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.100", "whiteAlpha.300")(props)
    };
});
var $2d094992e522cf2e$var$baseStyleFilledTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    return {
        transitionProperty: "common",
        transitionDuration: "slow",
        ...$2d094992e522cf2e$var$filledStyle(props)
    };
});
var $2d094992e522cf2e$var$baseStyle = $2d094992e522cf2e$var$definePartsStyle((props)=>({
        label: $2d094992e522cf2e$var$baseStyleLabel,
        filledTrack: $2d094992e522cf2e$var$baseStyleFilledTrack(props),
        track: $2d094992e522cf2e$var$baseStyleTrack(props)
    }));
var $2d094992e522cf2e$var$sizes = {
    xs: $2d094992e522cf2e$var$definePartsStyle({
        track: {
            h: "1"
        }
    }),
    sm: $2d094992e522cf2e$var$definePartsStyle({
        track: {
            h: "2"
        }
    }),
    md: $2d094992e522cf2e$var$definePartsStyle({
        track: {
            h: "3"
        }
    }),
    lg: $2d094992e522cf2e$var$definePartsStyle({
        track: {
            h: "4"
        }
    })
};
var $2d094992e522cf2e$export$dc04d8e6a17afea1 = $2d094992e522cf2e$var$defineMultiStyleConfig({
    sizes: $2d094992e522cf2e$var$sizes,
    baseStyle: $2d094992e522cf2e$var$baseStyle,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/utils/run-if-fn.ts
var $369b968b41e26508$var$isFunction = (value)=>typeof value === "function";
function $369b968b41e26508$export$624e501d81f5ffce(valueOrFn, ...args) {
    return $369b968b41e26508$var$isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}





var { definePartsStyle: $71db5bbb6bc24be3$var$definePartsStyle, defineMultiStyleConfig: $71db5bbb6bc24be3$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$21946b04497ed6ac).keys);
var $71db5bbb6bc24be3$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("checkbox-size");
var $71db5bbb6bc24be3$var$baseStyleControl = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        w: $71db5bbb6bc24be3$var$$size.reference,
        h: $71db5bbb6bc24be3$var$$size.reference,
        transitionProperty: "box-shadow",
        transitionDuration: "normal",
        border: "2px solid",
        borderRadius: "sm",
        borderColor: "inherit",
        color: "white",
        _checked: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $edac90b4236d0f41$export$549ff81930776885)("white", "gray.900")(props),
            _hover: {
                bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props),
                borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.600`, `${c}.300`)(props)
            },
            _disabled: {
                borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.200", "transparent")(props),
                bg: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.200", "whiteAlpha.300")(props),
                color: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.500", "whiteAlpha.500")(props)
            }
        },
        _indeterminate: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
            color: (0, $edac90b4236d0f41$export$549ff81930776885)("white", "gray.900")(props)
        },
        _disabled: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.100", "whiteAlpha.100")(props),
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)("gray.100", "transparent")(props)
        },
        _focusVisible: {
            boxShadow: "outline"
        },
        _invalid: {
            borderColor: (0, $edac90b4236d0f41$export$549ff81930776885)("red.500", "red.300")(props)
        }
    };
});
var $71db5bbb6bc24be3$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    _disabled: {
        cursor: "not-allowed"
    }
});
var $71db5bbb6bc24be3$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    userSelect: "none",
    _disabled: {
        opacity: 0.4
    }
});
var $71db5bbb6bc24be3$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "transform",
    transitionDuration: "normal"
});
var $71db5bbb6bc24be3$var$baseStyle = $71db5bbb6bc24be3$var$definePartsStyle((props)=>({
        icon: $71db5bbb6bc24be3$var$baseStyleIcon,
        container: $71db5bbb6bc24be3$var$baseStyleContainer,
        control: (0, $369b968b41e26508$export$624e501d81f5ffce)($71db5bbb6bc24be3$var$baseStyleControl, props),
        label: $71db5bbb6bc24be3$var$baseStyleLabel
    }));
var $71db5bbb6bc24be3$var$sizes = {
    sm: $71db5bbb6bc24be3$var$definePartsStyle({
        control: {
            [$71db5bbb6bc24be3$var$$size.variable]: "sizes.3"
        },
        label: {
            fontSize: "sm"
        },
        icon: {
            fontSize: "3xs"
        }
    }),
    md: $71db5bbb6bc24be3$var$definePartsStyle({
        control: {
            [$71db5bbb6bc24be3$var$$size.variable]: "sizes.4"
        },
        label: {
            fontSize: "md"
        },
        icon: {
            fontSize: "2xs"
        }
    }),
    lg: $71db5bbb6bc24be3$var$definePartsStyle({
        control: {
            [$71db5bbb6bc24be3$var$$size.variable]: "sizes.5"
        },
        label: {
            fontSize: "lg"
        },
        icon: {
            fontSize: "2xs"
        }
    })
};
var $71db5bbb6bc24be3$export$86286d8c37984115 = $71db5bbb6bc24be3$var$defineMultiStyleConfig({
    baseStyle: $71db5bbb6bc24be3$var$baseStyle,
    sizes: $71db5bbb6bc24be3$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





var { defineMultiStyleConfig: $32d81c24fe4274bc$var$defineMultiStyleConfig, definePartsStyle: $32d81c24fe4274bc$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$d28d06d0e29ef022).keys);
var $32d81c24fe4274bc$var$baseStyleControl = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a;
    const controlStyle = (_a = (0, $369b968b41e26508$export$624e501d81f5ffce)((0, $71db5bbb6bc24be3$export$86286d8c37984115).baseStyle, props)) == null ? void 0 : _a.control;
    return {
        ...controlStyle,
        borderRadius: "full",
        _checked: {
            ...controlStyle == null ? void 0 : controlStyle["_checked"],
            _before: {
                content: `""`,
                display: "inline-block",
                pos: "relative",
                w: "50%",
                h: "50%",
                borderRadius: "50%",
                bg: "currentColor"
            }
        }
    };
});
var $32d81c24fe4274bc$var$baseStyle = $32d81c24fe4274bc$var$definePartsStyle((props)=>{
    var _a, _b, _c, _d;
    return {
        label: (_b = (_a = (0, $71db5bbb6bc24be3$export$86286d8c37984115)).baseStyle) == null ? void 0 : _b.call(_a, props).label,
        container: (_d = (_c = (0, $71db5bbb6bc24be3$export$86286d8c37984115)).baseStyle) == null ? void 0 : _d.call(_c, props).container,
        control: $32d81c24fe4274bc$var$baseStyleControl(props)
    };
});
var $32d81c24fe4274bc$var$sizes = {
    md: $32d81c24fe4274bc$var$definePartsStyle({
        control: {
            w: "4",
            h: "4"
        },
        label: {
            fontSize: "md"
        }
    }),
    lg: $32d81c24fe4274bc$var$definePartsStyle({
        control: {
            w: "5",
            h: "5"
        },
        label: {
            fontSize: "lg"
        }
    }),
    sm: $32d81c24fe4274bc$var$definePartsStyle({
        control: {
            width: "3",
            height: "3"
        },
        label: {
            fontSize: "sm"
        }
    })
};
var $32d81c24fe4274bc$export$f0b387b940941887 = $32d81c24fe4274bc$var$defineMultiStyleConfig({
    baseStyle: $32d81c24fe4274bc$var$baseStyle,
    sizes: $32d81c24fe4274bc$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});





var { defineMultiStyleConfig: $6313575cc72520d0$var$defineMultiStyleConfig, definePartsStyle: $6313575cc72520d0$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$17993f0be9538b5a).keys);
var $6313575cc72520d0$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("select-bg");
var $6313575cc72520d0$var$_a;
var $6313575cc72520d0$var$baseStyleField = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($6313575cc72520d0$var$_a = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $6313575cc72520d0$var$_a.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $6313575cc72520d0$var$$bg.reference,
    [$6313575cc72520d0$var$$bg.variable]: "colors.white",
    _dark: {
        [$6313575cc72520d0$var$$bg.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
        bg: $6313575cc72520d0$var$$bg.reference
    }
});
var $6313575cc72520d0$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
        opacity: 0.5
    }
});
var $6313575cc72520d0$var$baseStyle = $6313575cc72520d0$var$definePartsStyle({
    field: $6313575cc72520d0$var$baseStyleField,
    icon: $6313575cc72520d0$var$baseStyleIcon
});
var $6313575cc72520d0$var$iconSpacing = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    paddingInlineEnd: "8"
});
var $6313575cc72520d0$var$_a2, $6313575cc72520d0$var$_b, $6313575cc72520d0$var$_c, $6313575cc72520d0$var$_d, $6313575cc72520d0$var$_e, $6313575cc72520d0$var$_f, $6313575cc72520d0$var$_g, $6313575cc72520d0$var$_h;
var $6313575cc72520d0$var$sizes = {
    lg: {
        ...($6313575cc72520d0$var$_a2 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $6313575cc72520d0$var$_a2.lg,
        field: {
            ...($6313575cc72520d0$var$_b = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $6313575cc72520d0$var$_b.lg.field,
            ...$6313575cc72520d0$var$iconSpacing
        }
    },
    md: {
        ...($6313575cc72520d0$var$_c = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $6313575cc72520d0$var$_c.md,
        field: {
            ...($6313575cc72520d0$var$_d = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $6313575cc72520d0$var$_d.md.field,
            ...$6313575cc72520d0$var$iconSpacing
        }
    },
    sm: {
        ...($6313575cc72520d0$var$_e = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $6313575cc72520d0$var$_e.sm,
        field: {
            ...($6313575cc72520d0$var$_f = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $6313575cc72520d0$var$_f.sm.field,
            ...$6313575cc72520d0$var$iconSpacing
        }
    },
    xs: {
        ...($6313575cc72520d0$var$_g = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $6313575cc72520d0$var$_g.xs,
        field: {
            ...($6313575cc72520d0$var$_h = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : $6313575cc72520d0$var$_h.xs.field,
            ...$6313575cc72520d0$var$iconSpacing
        },
        icon: {
            insetEnd: "1"
        }
    }
};
var $6313575cc72520d0$export$21af0fc3c16183e1 = $6313575cc72520d0$var$defineMultiStyleConfig({
    baseStyle: $6313575cc72520d0$var$baseStyle,
    sizes: $6313575cc72520d0$var$sizes,
    variants: (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $ec1ccabff4629292$export$b1b9f3bced726e54).defaultProps
});


// src/components/skeleton.ts

var $775a4667e088267b$var$$startColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skeleton-start-color");
var $775a4667e088267b$var$$endColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skeleton-end-color");
var $775a4667e088267b$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$775a4667e088267b$var$$startColor.variable]: "colors.gray.100",
    [$775a4667e088267b$var$$endColor.variable]: "colors.gray.400",
    _dark: {
        [$775a4667e088267b$var$$startColor.variable]: "colors.gray.800",
        [$775a4667e088267b$var$$endColor.variable]: "colors.gray.600"
    },
    background: $775a4667e088267b$var$$startColor.reference,
    borderColor: $775a4667e088267b$var$$endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
});
var $775a4667e088267b$export$7680371ad2d79142 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $775a4667e088267b$var$baseStyle
});


// src/components/skip-link.ts

var $b2192be54fce925a$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("skip-link-bg");
var $b2192be54fce925a$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
        boxShadow: "outline",
        padding: "4",
        position: "fixed",
        top: "6",
        insetStart: "6",
        [$b2192be54fce925a$var$$bg.variable]: "colors.white",
        _dark: {
            [$b2192be54fce925a$var$$bg.variable]: "colors.gray.700"
        },
        bg: $b2192be54fce925a$var$$bg.reference
    }
});
var $b2192be54fce925a$export$a8cf3228ef52959 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $b2192be54fce925a$var$baseStyle
});


// src/components/slider.ts



var { defineMultiStyleConfig: $dad79d07dec1684f$var$defineMultiStyleConfig, definePartsStyle: $dad79d07dec1684f$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$c21b4b3f8b239f32).keys);
var $dad79d07dec1684f$var$$thumbSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-thumb-size");
var $dad79d07dec1684f$var$$trackSize = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-track-size");
var $dad79d07dec1684f$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("slider-bg");
var $dad79d07dec1684f$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    return {
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        _disabled: {
            opacity: 0.6,
            cursor: "default",
            pointerEvents: "none"
        },
        ...(0, $edac90b4236d0f41$export$f3eec17ee6065eee)({
            orientation: orientation,
            vertical: {
                h: "100%"
            },
            horizontal: {
                w: "100%"
            }
        })
    };
});
var $dad79d07dec1684f$var$baseStyleTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const orientationStyles = (0, $edac90b4236d0f41$export$f3eec17ee6065eee)({
        orientation: props.orientation,
        horizontal: {
            h: $dad79d07dec1684f$var$$trackSize.reference
        },
        vertical: {
            w: $dad79d07dec1684f$var$$trackSize.reference
        }
    });
    return {
        ...orientationStyles,
        overflow: "hidden",
        borderRadius: "sm",
        [$dad79d07dec1684f$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$dad79d07dec1684f$var$$bg.variable]: "colors.whiteAlpha.200"
        },
        _disabled: {
            [$dad79d07dec1684f$var$$bg.variable]: "colors.gray.300",
            _dark: {
                [$dad79d07dec1684f$var$$bg.variable]: "colors.whiteAlpha.300"
            }
        },
        bg: $dad79d07dec1684f$var$$bg.reference
    };
});
var $dad79d07dec1684f$var$baseStyleThumb = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { orientation: orientation } = props;
    const orientationStyle = (0, $edac90b4236d0f41$export$f3eec17ee6065eee)({
        orientation: orientation,
        vertical: {
            left: "50%",
            transform: `translateX(-50%)`,
            _active: {
                transform: `translateX(-50%) scale(1.15)`
            }
        },
        horizontal: {
            top: "50%",
            transform: `translateY(-50%)`,
            _active: {
                transform: `translateY(-50%) scale(1.15)`
            }
        }
    });
    return {
        ...orientationStyle,
        w: $dad79d07dec1684f$var$$thumbSize.reference,
        h: $dad79d07dec1684f$var$$thumbSize.reference,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        outline: 0,
        zIndex: 1,
        borderRadius: "full",
        bg: "white",
        boxShadow: "base",
        border: "1px solid",
        borderColor: "transparent",
        transitionProperty: "transform",
        transitionDuration: "normal",
        _focusVisible: {
            boxShadow: "outline"
        },
        _disabled: {
            bg: "gray.300"
        }
    };
});
var $dad79d07dec1684f$var$baseStyleFilledTrack = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        width: "inherit",
        height: "inherit",
        [$dad79d07dec1684f$var$$bg.variable]: `colors.${c}.500`,
        _dark: {
            [$dad79d07dec1684f$var$$bg.variable]: `colors.${c}.200`
        },
        bg: $dad79d07dec1684f$var$$bg.reference
    };
});
var $dad79d07dec1684f$var$baseStyle = $dad79d07dec1684f$var$definePartsStyle((props)=>({
        container: $dad79d07dec1684f$var$baseStyleContainer(props),
        track: $dad79d07dec1684f$var$baseStyleTrack(props),
        thumb: $dad79d07dec1684f$var$baseStyleThumb(props),
        filledTrack: $dad79d07dec1684f$var$baseStyleFilledTrack(props)
    }));
var $dad79d07dec1684f$var$sizeLg = $dad79d07dec1684f$var$definePartsStyle({
    container: {
        [$dad79d07dec1684f$var$$thumbSize.variable]: `sizes.4`,
        [$dad79d07dec1684f$var$$trackSize.variable]: `sizes.1`
    }
});
var $dad79d07dec1684f$var$sizeMd = $dad79d07dec1684f$var$definePartsStyle({
    container: {
        [$dad79d07dec1684f$var$$thumbSize.variable]: `sizes.3.5`,
        [$dad79d07dec1684f$var$$trackSize.variable]: `sizes.1`
    }
});
var $dad79d07dec1684f$var$sizeSm = $dad79d07dec1684f$var$definePartsStyle({
    container: {
        [$dad79d07dec1684f$var$$thumbSize.variable]: `sizes.2.5`,
        [$dad79d07dec1684f$var$$trackSize.variable]: `sizes.0.5`
    }
});
var $dad79d07dec1684f$var$sizes = {
    lg: $dad79d07dec1684f$var$sizeLg,
    md: $dad79d07dec1684f$var$sizeMd,
    sm: $dad79d07dec1684f$var$sizeSm
};
var $dad79d07dec1684f$export$fff8df8fd8e1ed6f = $dad79d07dec1684f$var$defineMultiStyleConfig({
    baseStyle: $dad79d07dec1684f$var$baseStyle,
    sizes: $dad79d07dec1684f$var$sizes,
    defaultProps: {
        size: "md",
        colorScheme: "blue"
    }
});


// src/components/spinner.ts


var $cbcd1109f2fb6181$var$$size = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("spinner-size");
var $cbcd1109f2fb6181$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: [
        $cbcd1109f2fb6181$var$$size.reference
    ],
    height: [
        $cbcd1109f2fb6181$var$$size.reference
    ]
});
var $cbcd1109f2fb6181$var$sizes = {
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$cbcd1109f2fb6181$var$$size.variable]: "sizes.3"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$cbcd1109f2fb6181$var$$size.variable]: "sizes.4"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$cbcd1109f2fb6181$var$$size.variable]: "sizes.6"
    }),
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$cbcd1109f2fb6181$var$$size.variable]: "sizes.8"
    }),
    xl: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$cbcd1109f2fb6181$var$$size.variable]: "sizes.12"
    })
};
var $cbcd1109f2fb6181$export$d76156e68e556d3f = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $cbcd1109f2fb6181$var$baseStyle,
    sizes: $cbcd1109f2fb6181$var$sizes,
    defaultProps: {
        size: "md"
    }
});


// src/components/stat.ts


var { defineMultiStyleConfig: $c0dffa7e3b5c800f$var$defineMultiStyleConfig, definePartsStyle: $c0dffa7e3b5c800f$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$2cfbad67ae6ee421).keys);
var $c0dffa7e3b5c800f$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontWeight: "medium"
});
var $c0dffa7e3b5c800f$var$baseStyleHelpText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.8,
    marginBottom: "2"
});
var $c0dffa7e3b5c800f$var$baseStyleNumber = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    verticalAlign: "baseline",
    fontWeight: "semibold"
});
var $c0dffa7e3b5c800f$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
});
var $c0dffa7e3b5c800f$var$baseStyle = $c0dffa7e3b5c800f$var$definePartsStyle({
    container: {},
    label: $c0dffa7e3b5c800f$var$baseStyleLabel,
    helpText: $c0dffa7e3b5c800f$var$baseStyleHelpText,
    number: $c0dffa7e3b5c800f$var$baseStyleNumber,
    icon: $c0dffa7e3b5c800f$var$baseStyleIcon
});
var $c0dffa7e3b5c800f$var$sizes = {
    md: $c0dffa7e3b5c800f$var$definePartsStyle({
        label: {
            fontSize: "sm"
        },
        helpText: {
            fontSize: "sm"
        },
        number: {
            fontSize: "2xl"
        }
    })
};
var $c0dffa7e3b5c800f$export$f3301eb37a20f09e = $c0dffa7e3b5c800f$var$defineMultiStyleConfig({
    baseStyle: $c0dffa7e3b5c800f$var$baseStyle,
    sizes: $c0dffa7e3b5c800f$var$sizes,
    defaultProps: {
        size: "md"
    }
});


// src/components/kbd.ts

var $154d41908783067b$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("kbd-bg");
var $154d41908783067b$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$154d41908783067b$var$$bg.variable]: "colors.gray.100",
    _dark: {
        [$154d41908783067b$var$$bg.variable]: "colors.whiteAlpha.100"
    },
    bg: $154d41908783067b$var$$bg.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
});
var $154d41908783067b$export$e193528a501e9a4a = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $154d41908783067b$var$baseStyle
});


// src/components/link.ts

var $cf7f7fc1c118a2d3$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
        textDecoration: "underline"
    },
    _focusVisible: {
        boxShadow: "outline"
    }
});
var $cf7f7fc1c118a2d3$export$af7f58b96695762e = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $cf7f7fc1c118a2d3$var$baseStyle
});


// src/components/list.ts


var { defineMultiStyleConfig: $2fb614b96236acfc$var$defineMultiStyleConfig, definePartsStyle: $2fb614b96236acfc$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$12b3a655a94374ed).keys);
var $2fb614b96236acfc$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
});
var $2fb614b96236acfc$var$baseStyle = $2fb614b96236acfc$var$definePartsStyle({
    icon: $2fb614b96236acfc$var$baseStyleIcon
});
var $2fb614b96236acfc$export$ce840f8e8ef752d = $2fb614b96236acfc$var$defineMultiStyleConfig({
    baseStyle: $2fb614b96236acfc$var$baseStyle
});


// src/components/menu.ts


var { defineMultiStyleConfig: $a18a4fc75c223b21$var$defineMultiStyleConfig, definePartsStyle: $a18a4fc75c223b21$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$e251092a5dcb1329).keys);
var $a18a4fc75c223b21$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("menu-bg");
var $a18a4fc75c223b21$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("menu-shadow");
var $a18a4fc75c223b21$var$baseStyleList = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$a18a4fc75c223b21$var$$bg.variable]: "#fff",
    [$a18a4fc75c223b21$var$$shadow.variable]: "shadows.sm",
    _dark: {
        [$a18a4fc75c223b21$var$$bg.variable]: "colors.gray.700",
        [$a18a4fc75c223b21$var$$shadow.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px",
    bg: $a18a4fc75c223b21$var$$bg.reference,
    boxShadow: $a18a4fc75c223b21$var$$shadow.reference
});
var $a18a4fc75c223b21$var$baseStyleItem = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
        [$a18a4fc75c223b21$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$a18a4fc75c223b21$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$a18a4fc75c223b21$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$a18a4fc75c223b21$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _expanded: {
        [$a18a4fc75c223b21$var$$bg.variable]: "colors.gray.100",
        _dark: {
            [$a18a4fc75c223b21$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    bg: $a18a4fc75c223b21$var$$bg.reference
});
var $a18a4fc75c223b21$var$baseStyleGroupTitle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
});
var $a18a4fc75c223b21$var$baseStyleCommand = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.6
});
var $a18a4fc75c223b21$var$baseStyleDivider = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
});
var $a18a4fc75c223b21$var$baseStyleButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $a18a4fc75c223b21$var$baseStyle = $a18a4fc75c223b21$var$definePartsStyle({
    button: $a18a4fc75c223b21$var$baseStyleButton,
    list: $a18a4fc75c223b21$var$baseStyleList,
    item: $a18a4fc75c223b21$var$baseStyleItem,
    groupTitle: $a18a4fc75c223b21$var$baseStyleGroupTitle,
    command: $a18a4fc75c223b21$var$baseStyleCommand,
    divider: $a18a4fc75c223b21$var$baseStyleDivider
});
var $a18a4fc75c223b21$export$687ce088075ea42b = $a18a4fc75c223b21$var$defineMultiStyleConfig({
    baseStyle: $a18a4fc75c223b21$var$baseStyle
});





var { defineMultiStyleConfig: $a1b49894409ffd9d$var$defineMultiStyleConfig, definePartsStyle: $a1b49894409ffd9d$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$34e33beb8d992ac2).keys);
var $a1b49894409ffd9d$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("modal-bg");
var $a1b49894409ffd9d$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("modal-shadow");
var $a1b49894409ffd9d$var$baseStyleOverlay = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "modal"
});
var $a1b49894409ffd9d$var$baseStyleDialogContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        display: "flex",
        zIndex: "modal",
        justifyContent: "center",
        alignItems: isCentered ? "center" : "flex-start",
        overflow: scrollBehavior === "inside" ? "hidden" : "auto",
        overscrollBehaviorY: "none"
    };
});
var $a1b49894409ffd9d$var$baseStyleDialog = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isCentered: isCentered, scrollBehavior: scrollBehavior } = props;
    return {
        borderRadius: "md",
        color: "inherit",
        my: isCentered ? "auto" : "16",
        mx: isCentered ? "auto" : void 0,
        zIndex: "modal",
        maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
        [$a1b49894409ffd9d$var$$bg.variable]: "colors.white",
        [$a1b49894409ffd9d$var$$shadow.variable]: "shadows.lg",
        _dark: {
            [$a1b49894409ffd9d$var$$bg.variable]: "colors.gray.700",
            [$a1b49894409ffd9d$var$$shadow.variable]: "shadows.dark-lg"
        },
        bg: $a1b49894409ffd9d$var$$bg.reference,
        boxShadow: $a1b49894409ffd9d$var$$shadow.reference
    };
});
var $a1b49894409ffd9d$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $a1b49894409ffd9d$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $a1b49894409ffd9d$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { scrollBehavior: scrollBehavior } = props;
    return {
        px: "6",
        py: "2",
        flex: "1",
        overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
});
var $a1b49894409ffd9d$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
var $a1b49894409ffd9d$var$baseStyle = $a1b49894409ffd9d$var$definePartsStyle((props)=>({
        overlay: $a1b49894409ffd9d$var$baseStyleOverlay,
        dialogContainer: (0, $369b968b41e26508$export$624e501d81f5ffce)($a1b49894409ffd9d$var$baseStyleDialogContainer, props),
        dialog: (0, $369b968b41e26508$export$624e501d81f5ffce)($a1b49894409ffd9d$var$baseStyleDialog, props),
        header: $a1b49894409ffd9d$var$baseStyleHeader,
        closeButton: $a1b49894409ffd9d$var$baseStyleCloseButton,
        body: (0, $369b968b41e26508$export$624e501d81f5ffce)($a1b49894409ffd9d$var$baseStyleBody, props),
        footer: $a1b49894409ffd9d$var$baseStyleFooter
    }));
function $a1b49894409ffd9d$var$getSize(value) {
    if (value === "full") return $a1b49894409ffd9d$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            minH: "$100vh",
            my: "0",
            borderRadius: "0"
        }
    });
    return $a1b49894409ffd9d$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $a1b49894409ffd9d$var$sizes = {
    xs: $a1b49894409ffd9d$var$getSize("xs"),
    sm: $a1b49894409ffd9d$var$getSize("sm"),
    md: $a1b49894409ffd9d$var$getSize("md"),
    lg: $a1b49894409ffd9d$var$getSize("lg"),
    xl: $a1b49894409ffd9d$var$getSize("xl"),
    "2xl": $a1b49894409ffd9d$var$getSize("2xl"),
    "3xl": $a1b49894409ffd9d$var$getSize("3xl"),
    "4xl": $a1b49894409ffd9d$var$getSize("4xl"),
    "5xl": $a1b49894409ffd9d$var$getSize("5xl"),
    "6xl": $a1b49894409ffd9d$var$getSize("6xl"),
    full: $a1b49894409ffd9d$var$getSize("full")
};
var $a1b49894409ffd9d$export$158ae9a07be41c05 = $a1b49894409ffd9d$var$defineMultiStyleConfig({
    baseStyle: $a1b49894409ffd9d$var$baseStyle,
    sizes: $a1b49894409ffd9d$var$sizes,
    defaultProps: {
        size: "md"
    }
});








var { defineMultiStyleConfig: $0ebdb8860a80e280$var$defineMultiStyleConfig, definePartsStyle: $0ebdb8860a80e280$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$859cc7ca3200df97).keys);
var $0ebdb8860a80e280$var$$stepperWidth = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("number-input-stepper-width");
var $0ebdb8860a80e280$var$$inputPadding = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("number-input-input-padding");
var $0ebdb8860a80e280$var$inputPaddingValue = (0, $e5b1604dd31a03f9$export$42bfa9b2d4dad91a)($0ebdb8860a80e280$var$$stepperWidth).add("0.5rem").toString();
var $0ebdb8860a80e280$var$$bg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("number-input-bg");
var $0ebdb8860a80e280$var$$fg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("number-input-color");
var $0ebdb8860a80e280$var$$border = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("number-input-border-color");
var $0ebdb8860a80e280$var$baseStyleRoot = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$0ebdb8860a80e280$var$$stepperWidth.variable]: "sizes.6",
    [$0ebdb8860a80e280$var$$inputPadding.variable]: $0ebdb8860a80e280$var$inputPaddingValue
});
var $0ebdb8860a80e280$var$baseStyleField = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a, _b;
    return (_b = (_a = (0, $369b968b41e26508$export$624e501d81f5ffce)((0, $ec1ccabff4629292$export$b1b9f3bced726e54).baseStyle, props)) == null ? void 0 : _a.field) != null ? _b : {};
});
var $0ebdb8860a80e280$var$baseStyleStepperGroup = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    width: $0ebdb8860a80e280$var$$stepperWidth.reference
});
var $0ebdb8860a80e280$var$baseStyleStepper = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStart: "1px solid",
    borderStartColor: $0ebdb8860a80e280$var$$border.reference,
    color: $0ebdb8860a80e280$var$$fg.reference,
    bg: $0ebdb8860a80e280$var$$bg.reference,
    [$0ebdb8860a80e280$var$$fg.variable]: "colors.chakra-body-text",
    [$0ebdb8860a80e280$var$$border.variable]: "colors.chakra-border-color",
    _dark: {
        [$0ebdb8860a80e280$var$$fg.variable]: "colors.whiteAlpha.800",
        [$0ebdb8860a80e280$var$$border.variable]: "colors.whiteAlpha.300"
    },
    _active: {
        [$0ebdb8860a80e280$var$$bg.variable]: "colors.gray.200",
        _dark: {
            [$0ebdb8860a80e280$var$$bg.variable]: "colors.whiteAlpha.300"
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    }
});
var $0ebdb8860a80e280$var$baseStyle = $0ebdb8860a80e280$var$definePartsStyle((props)=>{
    var _a;
    return {
        root: $0ebdb8860a80e280$var$baseStyleRoot,
        field: (_a = (0, $369b968b41e26508$export$624e501d81f5ffce)($0ebdb8860a80e280$var$baseStyleField, props)) != null ? _a : {},
        stepperGroup: $0ebdb8860a80e280$var$baseStyleStepperGroup,
        stepper: $0ebdb8860a80e280$var$baseStyleStepper
    };
});
function $0ebdb8860a80e280$var$getSize(size) {
    var _a, _b, _c;
    const sizeStyle = (_a = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).sizes) == null ? void 0 : _a[size];
    const radius = {
        lg: "md",
        md: "md",
        sm: "sm",
        xs: "sm"
    };
    const _fontSize = (_c = (_b = sizeStyle.field) == null ? void 0 : _b.fontSize) != null ? _c : "md";
    const fontSize = (0, $4162f0caf6e4358a$export$d7c5d8884f83c8db).fontSizes[_fontSize];
    return $0ebdb8860a80e280$var$definePartsStyle({
        field: {
            ...sizeStyle.field,
            paddingInlineEnd: $0ebdb8860a80e280$var$$inputPadding.reference,
            verticalAlign: "top"
        },
        stepper: {
            fontSize: (0, $e5b1604dd31a03f9$export$42bfa9b2d4dad91a)(fontSize).multiply(0.75).toString(),
            _first: {
                borderTopEndRadius: radius[size]
            },
            _last: {
                borderBottomEndRadius: radius[size],
                mt: "-1px",
                borderTopWidth: 1
            }
        }
    });
}
var $0ebdb8860a80e280$var$sizes = {
    xs: $0ebdb8860a80e280$var$getSize("xs"),
    sm: $0ebdb8860a80e280$var$getSize("sm"),
    md: $0ebdb8860a80e280$var$getSize("md"),
    lg: $0ebdb8860a80e280$var$getSize("lg")
};
var $0ebdb8860a80e280$export$b9bc5fa6e7f960a1 = $0ebdb8860a80e280$var$defineMultiStyleConfig({
    baseStyle: $0ebdb8860a80e280$var$baseStyle,
    sizes: $0ebdb8860a80e280$var$sizes,
    variants: (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants,
    defaultProps: (0, $ec1ccabff4629292$export$b1b9f3bced726e54).defaultProps
});





var $9ff8a6396d629f06$var$_a;
var $9ff8a6396d629f06$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    ...($9ff8a6396d629f06$var$_a = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).baseStyle) == null ? void 0 : $9ff8a6396d629f06$var$_a.field,
    textAlign: "center"
});
var $9ff8a6396d629f06$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "lg",
        w: 12,
        h: 12,
        borderRadius: "md"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "md",
        w: 10,
        h: 10,
        borderRadius: "md"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        w: 8,
        h: 8,
        borderRadius: "sm"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "xs",
        w: 6,
        h: 6,
        borderRadius: "sm"
    })
};
var $9ff8a6396d629f06$var$_a2, $9ff8a6396d629f06$var$_b;
var $9ff8a6396d629f06$var$variants = {
    outline: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $369b968b41e26508$export$624e501d81f5ffce)((_a3 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.outline, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    flushed: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $369b968b41e26508$export$624e501d81f5ffce)((_a3 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.flushed, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    filled: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
        var _a3, _b2, _c;
        return (_c = (_b2 = (0, $369b968b41e26508$export$624e501d81f5ffce)((_a3 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants) == null ? void 0 : _a3.filled, props)) == null ? void 0 : _b2.field) != null ? _c : {};
    }),
    unstyled: ($9ff8a6396d629f06$var$_b = ($9ff8a6396d629f06$var$_a2 = (0, $ec1ccabff4629292$export$b1b9f3bced726e54).variants) == null ? void 0 : $9ff8a6396d629f06$var$_a2.unstyled.field) != null ? $9ff8a6396d629f06$var$_b : {}
};
var $9ff8a6396d629f06$export$8504c22c55a552e0 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $9ff8a6396d629f06$var$baseStyle,
    sizes: $9ff8a6396d629f06$var$sizes,
    variants: $9ff8a6396d629f06$var$variants,
    defaultProps: (0, $ec1ccabff4629292$export$b1b9f3bced726e54).defaultProps
});


// src/components/popover.ts



var { defineMultiStyleConfig: $7569aecd919000a0$var$defineMultiStyleConfig, definePartsStyle: $7569aecd919000a0$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$afda07d12cd4337d).keys);
var $7569aecd919000a0$var$$popperBg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("popper-bg");
var $7569aecd919000a0$var$$arrowBg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("popper-arrow-bg");
var $7569aecd919000a0$var$$arrowShadowColor = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("popper-arrow-shadow-color");
var $7569aecd919000a0$var$baseStylePopper = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    zIndex: 10
});
var $7569aecd919000a0$var$baseStyleContent = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$7569aecd919000a0$var$$popperBg.variable]: `colors.white`,
    bg: $7569aecd919000a0$var$$popperBg.reference,
    [$7569aecd919000a0$var$$arrowBg.variable]: $7569aecd919000a0$var$$popperBg.reference,
    [$7569aecd919000a0$var$$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
        [$7569aecd919000a0$var$$popperBg.variable]: `colors.gray.700`,
        [$7569aecd919000a0$var$$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
        outline: 0,
        boxShadow: "outline"
    }
});
var $7569aecd919000a0$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
});
var $7569aecd919000a0$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2
});
var $7569aecd919000a0$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
});
var $7569aecd919000a0$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
});
var $7569aecd919000a0$var$baseStyle = $7569aecd919000a0$var$definePartsStyle({
    popper: $7569aecd919000a0$var$baseStylePopper,
    content: $7569aecd919000a0$var$baseStyleContent,
    header: $7569aecd919000a0$var$baseStyleHeader,
    body: $7569aecd919000a0$var$baseStyleBody,
    footer: $7569aecd919000a0$var$baseStyleFooter,
    closeButton: $7569aecd919000a0$var$baseStyleCloseButton
});
var $7569aecd919000a0$export$135f12f777be1ef7 = $7569aecd919000a0$var$defineMultiStyleConfig({
    baseStyle: $7569aecd919000a0$var$baseStyle
});





var { definePartsStyle: $b149de7d34d1aea4$var$definePartsStyle, defineMultiStyleConfig: $b149de7d34d1aea4$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$d3f4aaa4b0f2907a).keys);
var $b149de7d34d1aea4$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("drawer-bg");
var $b149de7d34d1aea4$var$$bs = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("drawer-box-shadow");
function $b149de7d34d1aea4$var$getSize(value) {
    if (value === "full") return $b149de7d34d1aea4$var$definePartsStyle({
        dialog: {
            maxW: "100vw",
            h: "100vh"
        }
    });
    return $b149de7d34d1aea4$var$definePartsStyle({
        dialog: {
            maxW: value
        }
    });
}
var $b149de7d34d1aea4$var$baseStyleOverlay = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "blackAlpha.600",
    zIndex: "overlay"
});
var $b149de7d34d1aea4$var$baseStyleDialogContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
});
var $b149de7d34d1aea4$var$baseStyleDialog = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { isFullHeight: isFullHeight } = props;
    return {
        ...isFullHeight && {
            height: "100vh"
        },
        zIndex: "modal",
        maxH: "100vh",
        color: "inherit",
        [$b149de7d34d1aea4$var$$bg.variable]: "colors.white",
        [$b149de7d34d1aea4$var$$bs.variable]: "shadows.lg",
        _dark: {
            [$b149de7d34d1aea4$var$$bg.variable]: "colors.gray.700",
            [$b149de7d34d1aea4$var$$bs.variable]: "shadows.dark-lg"
        },
        bg: $b149de7d34d1aea4$var$$bg.reference,
        boxShadow: $b149de7d34d1aea4$var$$bs.reference
    };
});
var $b149de7d34d1aea4$var$baseStyleHeader = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
});
var $b149de7d34d1aea4$var$baseStyleCloseButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    position: "absolute",
    top: "2",
    insetEnd: "3"
});
var $b149de7d34d1aea4$var$baseStyleBody = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
});
var $b149de7d34d1aea4$var$baseStyleFooter = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    px: "6",
    py: "4"
});
var $b149de7d34d1aea4$var$baseStyle = $b149de7d34d1aea4$var$definePartsStyle((props)=>({
        overlay: $b149de7d34d1aea4$var$baseStyleOverlay,
        dialogContainer: $b149de7d34d1aea4$var$baseStyleDialogContainer,
        dialog: (0, $369b968b41e26508$export$624e501d81f5ffce)($b149de7d34d1aea4$var$baseStyleDialog, props),
        header: $b149de7d34d1aea4$var$baseStyleHeader,
        closeButton: $b149de7d34d1aea4$var$baseStyleCloseButton,
        body: $b149de7d34d1aea4$var$baseStyleBody,
        footer: $b149de7d34d1aea4$var$baseStyleFooter
    }));
var $b149de7d34d1aea4$var$sizes = {
    xs: $b149de7d34d1aea4$var$getSize("xs"),
    sm: $b149de7d34d1aea4$var$getSize("md"),
    md: $b149de7d34d1aea4$var$getSize("lg"),
    lg: $b149de7d34d1aea4$var$getSize("2xl"),
    xl: $b149de7d34d1aea4$var$getSize("4xl"),
    full: $b149de7d34d1aea4$var$getSize("full")
};
var $b149de7d34d1aea4$export$8057937c11129602 = $b149de7d34d1aea4$var$defineMultiStyleConfig({
    baseStyle: $b149de7d34d1aea4$var$baseStyle,
    sizes: $b149de7d34d1aea4$var$sizes,
    defaultProps: {
        size: "xs"
    }
});


// src/components/editable.ts


var { definePartsStyle: $25dc8689dadb4cee$var$definePartsStyle, defineMultiStyleConfig: $25dc8689dadb4cee$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$2813c9511eeab082).keys);
var $25dc8689dadb4cee$var$baseStylePreview = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
});
var $25dc8689dadb4cee$var$baseStyleInput = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $25dc8689dadb4cee$var$baseStyleTextarea = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: {
        boxShadow: "outline"
    },
    _placeholder: {
        opacity: 0.6
    }
});
var $25dc8689dadb4cee$var$baseStyle = $25dc8689dadb4cee$var$definePartsStyle({
    preview: $25dc8689dadb4cee$var$baseStylePreview,
    input: $25dc8689dadb4cee$var$baseStyleInput,
    textarea: $25dc8689dadb4cee$var$baseStyleTextarea
});
var $25dc8689dadb4cee$export$a09813cbe72349b1 = $25dc8689dadb4cee$var$defineMultiStyleConfig({
    baseStyle: $25dc8689dadb4cee$var$baseStyle
});


// src/components/form-control.ts


var { definePartsStyle: $933c3dcd100c760b$var$definePartsStyle, defineMultiStyleConfig: $933c3dcd100c760b$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$4b243e3f209a7e5e).keys);
var $933c3dcd100c760b$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("form-control-color");
var $933c3dcd100c760b$var$baseStyleRequiredIndicator = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginStart: "1",
    [$933c3dcd100c760b$var$$fg.variable]: "colors.red.500",
    _dark: {
        [$933c3dcd100c760b$var$$fg.variable]: "colors.red.300"
    },
    color: $933c3dcd100c760b$var$$fg.reference
});
var $933c3dcd100c760b$var$baseStyleHelperText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    mt: "2",
    [$933c3dcd100c760b$var$$fg.variable]: "colors.gray.600",
    _dark: {
        [$933c3dcd100c760b$var$$fg.variable]: "colors.whiteAlpha.600"
    },
    color: $933c3dcd100c760b$var$$fg.reference,
    lineHeight: "normal",
    fontSize: "sm"
});
var $933c3dcd100c760b$var$baseStyle = $933c3dcd100c760b$var$definePartsStyle({
    container: {
        width: "100%",
        position: "relative"
    },
    requiredIndicator: $933c3dcd100c760b$var$baseStyleRequiredIndicator,
    helperText: $933c3dcd100c760b$var$baseStyleHelperText
});
var $933c3dcd100c760b$export$870bcc1d98fee0aa = $933c3dcd100c760b$var$defineMultiStyleConfig({
    baseStyle: $933c3dcd100c760b$var$baseStyle
});


// src/components/form-error.ts


var { definePartsStyle: $239100f869b4095f$var$definePartsStyle, defineMultiStyleConfig: $239100f869b4095f$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$bb18c440c00e82d9).keys);
var $239100f869b4095f$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("form-error-color");
var $239100f869b4095f$var$baseStyleText = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    [$239100f869b4095f$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$239100f869b4095f$var$$fg.variable]: `colors.red.300`
    },
    color: $239100f869b4095f$var$$fg.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
});
var $239100f869b4095f$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    marginEnd: "0.5em",
    [$239100f869b4095f$var$$fg.variable]: `colors.red.500`,
    _dark: {
        [$239100f869b4095f$var$$fg.variable]: `colors.red.300`
    },
    color: $239100f869b4095f$var$$fg.reference
});
var $239100f869b4095f$var$baseStyle = $239100f869b4095f$var$definePartsStyle({
    text: $239100f869b4095f$var$baseStyleText,
    icon: $239100f869b4095f$var$baseStyleIcon
});
var $239100f869b4095f$export$b8d6747e16cd5f4d = $239100f869b4095f$var$defineMultiStyleConfig({
    baseStyle: $239100f869b4095f$var$baseStyle
});


// src/components/form-label.ts

var $c969545ce5fdffff$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
        opacity: 0.4
    }
});
var $c969545ce5fdffff$export$c49af69dbfc0c993 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $c969545ce5fdffff$var$baseStyle
});


// src/components/heading.ts

var $182cefaf31bafecf$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: "heading",
    fontWeight: "bold"
});
var $182cefaf31bafecf$var$sizes = {
    "4xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "6xl",
            null,
            "7xl"
        ],
        lineHeight: 1
    }),
    "3xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "5xl",
            null,
            "6xl"
        ],
        lineHeight: 1
    }),
    "2xl": (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "4xl",
            null,
            "5xl"
        ],
        lineHeight: [
            1.2,
            null,
            1
        ]
    }),
    xl: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "3xl",
            null,
            "4xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: [
            "2xl",
            null,
            "3xl"
        ],
        lineHeight: [
            1.33,
            null,
            1.2
        ]
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "xl",
        lineHeight: 1.2
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "md",
        lineHeight: 1.2
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        fontSize: "sm",
        lineHeight: 1.2
    })
};
var $182cefaf31bafecf$export$5f175074e0f09e7b = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $182cefaf31bafecf$var$baseStyle,
    sizes: $182cefaf31bafecf$var$sizes,
    defaultProps: {
        size: "xl"
    }
});



// src/components/breadcrumb.ts


var { defineMultiStyleConfig: $77962fd07a1deed1$var$defineMultiStyleConfig, definePartsStyle: $77962fd07a1deed1$var$definePartsStyle } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$2fb03f744a6ecf93).keys);
var $77962fd07a1deed1$var$$decor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("breadcrumb-link-decor");
var $77962fd07a1deed1$var$baseStyleLink = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $77962fd07a1deed1$var$$decor.reference,
    [$77962fd07a1deed1$var$$decor.variable]: "none",
    "&:not([aria-current=page])": {
        cursor: "pointer",
        _hover: {
            [$77962fd07a1deed1$var$$decor.variable]: "underline"
        },
        _focusVisible: {
            boxShadow: "outline"
        }
    }
});
var $77962fd07a1deed1$var$baseStyle = $77962fd07a1deed1$var$definePartsStyle({
    link: $77962fd07a1deed1$var$baseStyleLink
});
var $77962fd07a1deed1$export$e2d8c6f6af55009 = $77962fd07a1deed1$var$defineMultiStyleConfig({
    baseStyle: $77962fd07a1deed1$var$baseStyle
});





var $df079183c8c71186$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
        boxShadow: "outline"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        _disabled: {
            bg: "initial"
        }
    }
});
var $df079183c8c71186$var$variantGhost = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c, theme: theme } = props;
    if (c === "gray") return {
        color: (0, $edac90b4236d0f41$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props)
        }
    };
    const darkHoverBg = (0, $bcc5e97ee12ebad5$export$d11da87e55cc498f)(`${c}.200`, 0.12)(theme);
    const darkActiveBg = (0, $bcc5e97ee12ebad5$export$d11da87e55cc498f)(`${c}.200`, 0.24)(theme);
    return {
        color: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.600`, `${c}.200`)(props),
        bg: "transparent",
        _hover: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.50`, darkHoverBg)(props)
        },
        _active: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.100`, darkActiveBg)(props)
        }
    };
});
var $df079183c8c71186$var$variantOutline = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    const borderColor = (0, $edac90b4236d0f41$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props);
    return {
        border: "1px solid",
        borderColor: c === "gray" ? borderColor : "currentColor",
        ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": {
            marginEnd: "-1px"
        },
        ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": {
            marginBottom: "-1px"
        },
        ...(0, $369b968b41e26508$export$624e501d81f5ffce)($df079183c8c71186$var$variantGhost, props)
    };
});
var $df079183c8c71186$var$accessibleColorMap = {
    yellow: {
        bg: "yellow.400",
        color: "black",
        hoverBg: "yellow.500",
        activeBg: "yellow.600"
    },
    cyan: {
        bg: "cyan.400",
        color: "black",
        hoverBg: "cyan.500",
        activeBg: "cyan.600"
    }
};
var $df079183c8c71186$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    var _a;
    const { colorScheme: c } = props;
    if (c === "gray") {
        const bg2 = (0, $edac90b4236d0f41$export$549ff81930776885)(`gray.100`, `whiteAlpha.200`)(props);
        return {
            bg: bg2,
            color: (0, $edac90b4236d0f41$export$549ff81930776885)(`gray.800`, `whiteAlpha.900`)(props),
            _hover: {
                bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`gray.200`, `whiteAlpha.300`)(props),
                _disabled: {
                    bg: bg2
                }
            },
            _active: {
                bg: (0, $edac90b4236d0f41$export$549ff81930776885)(`gray.300`, `whiteAlpha.400`)(props)
            }
        };
    }
    const { bg: bg = `${c}.500`, color: color = "white", hoverBg: hoverBg = `${c}.600`, activeBg: activeBg = `${c}.700` } = (_a = $df079183c8c71186$var$accessibleColorMap[c]) != null ? _a : {};
    const background = (0, $edac90b4236d0f41$export$549ff81930776885)(bg, `${c}.200`)(props);
    return {
        bg: background,
        color: (0, $edac90b4236d0f41$export$549ff81930776885)(color, `gray.800`)(props),
        _hover: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)(hoverBg, `${c}.300`)(props),
            _disabled: {
                bg: background
            }
        },
        _active: {
            bg: (0, $edac90b4236d0f41$export$549ff81930776885)(activeBg, `${c}.400`)(props)
        }
    };
});
var $df079183c8c71186$var$variantLink = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { colorScheme: c } = props;
    return {
        padding: 0,
        height: "auto",
        lineHeight: "normal",
        verticalAlign: "baseline",
        color: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.500`, `${c}.200`)(props),
        _hover: {
            textDecoration: "underline",
            _disabled: {
                textDecoration: "none"
            }
        },
        _active: {
            color: (0, $edac90b4236d0f41$export$549ff81930776885)(`${c}.700`, `${c}.500`)(props)
        }
    };
});
var $df079183c8c71186$var$variantUnstyled = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
});
var $df079183c8c71186$var$variants = {
    ghost: $df079183c8c71186$var$variantGhost,
    outline: $df079183c8c71186$var$variantOutline,
    solid: $df079183c8c71186$var$variantSolid,
    link: $df079183c8c71186$var$variantLink,
    unstyled: $df079183c8c71186$var$variantUnstyled
};
var $df079183c8c71186$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "12",
        minW: "12",
        fontSize: "lg",
        px: "6"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "10",
        minW: "10",
        fontSize: "md",
        px: "4"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "8",
        minW: "8",
        fontSize: "sm",
        px: "3"
    }),
    xs: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        h: "6",
        minW: "6",
        fontSize: "xs",
        px: "2"
    })
};
var $df079183c8c71186$export$577deec5d331f6be = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $df079183c8c71186$var$baseStyle,
    variants: $df079183c8c71186$var$variants,
    sizes: $df079183c8c71186$var$sizes,
    defaultProps: {
        variant: "solid",
        size: "md",
        colorScheme: "gray"
    }
});


// src/components/card.ts


var { definePartsStyle: $bb091e73d7a71730$var$definePartsStyle, defineMultiStyleConfig: $bb091e73d7a71730$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$487a447ffa5755b6).keys);
var $bb091e73d7a71730$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-bg");
var $bb091e73d7a71730$var$$padding = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-padding");
var $bb091e73d7a71730$var$$shadow = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-shadow");
var $bb091e73d7a71730$var$$radius = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-radius");
var $bb091e73d7a71730$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-border-width", "0");
var $bb091e73d7a71730$var$$borderColor = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("card-border-color");
var $bb091e73d7a71730$var$baseStyle = $bb091e73d7a71730$var$definePartsStyle({
    container: {
        [$bb091e73d7a71730$var$$bg.variable]: "colors.chakra-body-bg",
        backgroundColor: $bb091e73d7a71730$var$$bg.reference,
        boxShadow: $bb091e73d7a71730$var$$shadow.reference,
        borderRadius: $bb091e73d7a71730$var$$radius.reference,
        color: "chakra-body-text",
        borderWidth: $bb091e73d7a71730$var$$border.reference,
        borderColor: $bb091e73d7a71730$var$$borderColor.reference
    },
    body: {
        padding: $bb091e73d7a71730$var$$padding.reference,
        flex: "1 1 0%"
    },
    header: {
        padding: $bb091e73d7a71730$var$$padding.reference
    },
    footer: {
        padding: $bb091e73d7a71730$var$$padding.reference
    }
});
var $bb091e73d7a71730$var$sizes = {
    sm: $bb091e73d7a71730$var$definePartsStyle({
        container: {
            [$bb091e73d7a71730$var$$radius.variable]: "radii.base",
            [$bb091e73d7a71730$var$$padding.variable]: "space.3"
        }
    }),
    md: $bb091e73d7a71730$var$definePartsStyle({
        container: {
            [$bb091e73d7a71730$var$$radius.variable]: "radii.md",
            [$bb091e73d7a71730$var$$padding.variable]: "space.5"
        }
    }),
    lg: $bb091e73d7a71730$var$definePartsStyle({
        container: {
            [$bb091e73d7a71730$var$$radius.variable]: "radii.xl",
            [$bb091e73d7a71730$var$$padding.variable]: "space.7"
        }
    })
};
var $bb091e73d7a71730$var$variants = {
    elevated: $bb091e73d7a71730$var$definePartsStyle({
        container: {
            [$bb091e73d7a71730$var$$shadow.variable]: "shadows.base",
            _dark: {
                [$bb091e73d7a71730$var$$bg.variable]: "colors.gray.700"
            }
        }
    }),
    outline: $bb091e73d7a71730$var$definePartsStyle({
        container: {
            [$bb091e73d7a71730$var$$border.variable]: "1px",
            [$bb091e73d7a71730$var$$borderColor.variable]: "colors.chakra-border-color"
        }
    }),
    filled: $bb091e73d7a71730$var$definePartsStyle({
        container: {
            [$bb091e73d7a71730$var$$bg.variable]: "colors.chakra-subtle-bg"
        }
    }),
    unstyled: {
        body: {
            [$bb091e73d7a71730$var$$padding.variable]: 0
        },
        header: {
            [$bb091e73d7a71730$var$$padding.variable]: 0
        },
        footer: {
            [$bb091e73d7a71730$var$$padding.variable]: 0
        }
    }
};
var $bb091e73d7a71730$export$880f7b1201440c23 = $bb091e73d7a71730$var$defineMultiStyleConfig({
    baseStyle: $bb091e73d7a71730$var$baseStyle,
    variants: $bb091e73d7a71730$var$variants,
    sizes: $bb091e73d7a71730$var$sizes,
    defaultProps: {
        variant: "elevated",
        size: "md"
    }
});



// src/components/close-button.ts


var $4d0f440026510ba2$var$$size = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("close-button-size");
var $4d0f440026510ba2$var$$bg = (0, $47f55a9b9bd6210d$export$8b4981022bd80a4e)("close-button-bg");
var $4d0f440026510ba2$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    w: [
        $4d0f440026510ba2$var$$size.reference
    ],
    h: [
        $4d0f440026510ba2$var$$size.reference
    ],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        boxShadow: "none"
    },
    _hover: {
        [$4d0f440026510ba2$var$$bg.variable]: "colors.blackAlpha.100",
        _dark: {
            [$4d0f440026510ba2$var$$bg.variable]: "colors.whiteAlpha.100"
        }
    },
    _active: {
        [$4d0f440026510ba2$var$$bg.variable]: "colors.blackAlpha.200",
        _dark: {
            [$4d0f440026510ba2$var$$bg.variable]: "colors.whiteAlpha.200"
        }
    },
    _focusVisible: {
        boxShadow: "outline"
    },
    bg: $4d0f440026510ba2$var$$bg.reference
});
var $4d0f440026510ba2$var$sizes = {
    lg: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$4d0f440026510ba2$var$$size.variable]: "sizes.10",
        fontSize: "md"
    }),
    md: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$4d0f440026510ba2$var$$size.variable]: "sizes.8",
        fontSize: "xs"
    }),
    sm: (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
        [$4d0f440026510ba2$var$$size.variable]: "sizes.6",
        fontSize: "2xs"
    })
};
var $4d0f440026510ba2$export$47615e5b7f7e315f = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $4d0f440026510ba2$var$baseStyle,
    sizes: $4d0f440026510ba2$var$sizes,
    defaultProps: {
        size: "md"
    }
});




var { variants: $8d6cbacbe8f4b3ab$var$variants, defaultProps: $8d6cbacbe8f4b3ab$var$defaultProps } = (0, $cf27f314dc675791$export$eb6e7cbc82d0f88b);
var $8d6cbacbe8f4b3ab$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: (0, $cf27f314dc675791$export$3cb96c9f6c8d16a4).bg.reference,
    color: (0, $cf27f314dc675791$export$3cb96c9f6c8d16a4).color.reference,
    boxShadow: (0, $cf27f314dc675791$export$3cb96c9f6c8d16a4).shadow.reference
});
var $8d6cbacbe8f4b3ab$export$f9b9a8633a36e3c7 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $8d6cbacbe8f4b3ab$var$baseStyle,
    variants: $8d6cbacbe8f4b3ab$var$variants,
    defaultProps: $8d6cbacbe8f4b3ab$var$defaultProps
});


// src/components/container.ts

var $969cbc6e1b3ec392$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
});
var $969cbc6e1b3ec392$export$3ca0760d240fe5f4 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $969cbc6e1b3ec392$var$baseStyle
});


// src/components/divider.ts

var $0ec03bba1f05a7bd$var$baseStyle = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    opacity: 0.6,
    borderColor: "inherit"
});
var $0ec03bba1f05a7bd$var$variantSolid = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStyle: "solid"
});
var $0ec03bba1f05a7bd$var$variantDashed = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderStyle: "dashed"
});
var $0ec03bba1f05a7bd$var$variants = {
    solid: $0ec03bba1f05a7bd$var$variantSolid,
    dashed: $0ec03bba1f05a7bd$var$variantDashed
};
var $0ec03bba1f05a7bd$export$f0e91f779c5bb416 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    baseStyle: $0ec03bba1f05a7bd$var$baseStyle,
    variants: $0ec03bba1f05a7bd$var$variants,
    defaultProps: {
        variant: "solid"
    }
});


// src/components/accordion.ts


var { definePartsStyle: $5bcafc970eb03425$var$definePartsStyle, defineMultiStyleConfig: $5bcafc970eb03425$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$377a77e99e7c73a5).keys);
var $5bcafc970eb03425$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
        borderBottomWidth: "1px"
    }
});
var $5bcafc970eb03425$var$baseStyleButton = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
        boxShadow: "outline"
    },
    _hover: {
        bg: "blackAlpha.50"
    },
    _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    },
    px: "4",
    py: "2"
});
var $5bcafc970eb03425$var$baseStylePanel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    pt: "2",
    px: "4",
    pb: "5"
});
var $5bcafc970eb03425$var$baseStyleIcon = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: "1.25em"
});
var $5bcafc970eb03425$var$baseStyle = $5bcafc970eb03425$var$definePartsStyle({
    container: $5bcafc970eb03425$var$baseStyleContainer,
    button: $5bcafc970eb03425$var$baseStyleButton,
    panel: $5bcafc970eb03425$var$baseStylePanel,
    icon: $5bcafc970eb03425$var$baseStyleIcon
});
var $5bcafc970eb03425$export$20ec2254f76fa604 = $5bcafc970eb03425$var$defineMultiStyleConfig({
    baseStyle: $5bcafc970eb03425$var$baseStyle
});


// src/components/alert.ts



var { definePartsStyle: $079cf9c1f773fda9$var$definePartsStyle, defineMultiStyleConfig: $079cf9c1f773fda9$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$fc51889fa4de265a).keys);
var $079cf9c1f773fda9$var$$fg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("alert-fg");
var $079cf9c1f773fda9$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("alert-bg");
var $079cf9c1f773fda9$var$baseStyle = $079cf9c1f773fda9$var$definePartsStyle({
    container: {
        bg: $079cf9c1f773fda9$var$$bg.reference,
        px: "4",
        py: "3"
    },
    title: {
        fontWeight: "bold",
        lineHeight: "6",
        marginEnd: "2"
    },
    description: {
        lineHeight: "6"
    },
    icon: {
        color: $079cf9c1f773fda9$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "6"
    },
    spinner: {
        color: $079cf9c1f773fda9$var$$fg.reference,
        flexShrink: 0,
        marginEnd: "3",
        w: "5",
        h: "5"
    }
});
function $079cf9c1f773fda9$var$getBg(props) {
    const { theme: theme, colorScheme: c } = props;
    const darkBg = (0, $bcc5e97ee12ebad5$export$d11da87e55cc498f)(`${c}.200`, 0.16)(theme);
    return {
        light: `colors.${c}.100`,
        dark: darkBg
    };
}
var $079cf9c1f773fda9$var$variantSubtle = $079cf9c1f773fda9$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $079cf9c1f773fda9$var$getBg(props);
    return {
        container: {
            [$079cf9c1f773fda9$var$$fg.variable]: `colors.${c}.500`,
            [$079cf9c1f773fda9$var$$bg.variable]: bg.light,
            _dark: {
                [$079cf9c1f773fda9$var$$fg.variable]: `colors.${c}.200`,
                [$079cf9c1f773fda9$var$$bg.variable]: bg.dark
            }
        }
    };
});
var $079cf9c1f773fda9$var$variantLeftAccent = $079cf9c1f773fda9$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $079cf9c1f773fda9$var$getBg(props);
    return {
        container: {
            [$079cf9c1f773fda9$var$$fg.variable]: `colors.${c}.500`,
            [$079cf9c1f773fda9$var$$bg.variable]: bg.light,
            _dark: {
                [$079cf9c1f773fda9$var$$fg.variable]: `colors.${c}.200`,
                [$079cf9c1f773fda9$var$$bg.variable]: bg.dark
            },
            paddingStart: "3",
            borderStartWidth: "4px",
            borderStartColor: $079cf9c1f773fda9$var$$fg.reference
        }
    };
});
var $079cf9c1f773fda9$var$variantTopAccent = $079cf9c1f773fda9$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    const bg = $079cf9c1f773fda9$var$getBg(props);
    return {
        container: {
            [$079cf9c1f773fda9$var$$fg.variable]: `colors.${c}.500`,
            [$079cf9c1f773fda9$var$$bg.variable]: bg.light,
            _dark: {
                [$079cf9c1f773fda9$var$$fg.variable]: `colors.${c}.200`,
                [$079cf9c1f773fda9$var$$bg.variable]: bg.dark
            },
            pt: "2",
            borderTopWidth: "4px",
            borderTopColor: $079cf9c1f773fda9$var$$fg.reference
        }
    };
});
var $079cf9c1f773fda9$var$variantSolid = $079cf9c1f773fda9$var$definePartsStyle((props)=>{
    const { colorScheme: c } = props;
    return {
        container: {
            [$079cf9c1f773fda9$var$$fg.variable]: `colors.white`,
            [$079cf9c1f773fda9$var$$bg.variable]: `colors.${c}.500`,
            _dark: {
                [$079cf9c1f773fda9$var$$fg.variable]: `colors.gray.900`,
                [$079cf9c1f773fda9$var$$bg.variable]: `colors.${c}.200`
            },
            color: $079cf9c1f773fda9$var$$fg.reference
        }
    };
});
var $079cf9c1f773fda9$var$variants = {
    subtle: $079cf9c1f773fda9$var$variantSubtle,
    "left-accent": $079cf9c1f773fda9$var$variantLeftAccent,
    "top-accent": $079cf9c1f773fda9$var$variantTopAccent,
    solid: $079cf9c1f773fda9$var$variantSolid
};
var $079cf9c1f773fda9$export$9d77d9665d829e89 = $079cf9c1f773fda9$var$defineMultiStyleConfig({
    baseStyle: $079cf9c1f773fda9$var$baseStyle,
    variants: $079cf9c1f773fda9$var$variants,
    defaultProps: {
        variant: "subtle",
        colorScheme: "blue"
    }
});







var { definePartsStyle: $9853ed1fed826087$var$definePartsStyle, defineMultiStyleConfig: $9853ed1fed826087$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$60f8655d889e17c7).keys);
var $9853ed1fed826087$var$$border = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-border-color");
var $9853ed1fed826087$var$$bg = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-bg");
var $9853ed1fed826087$var$$fs = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-font-size");
var $9853ed1fed826087$var$$size = (0, $47a6d9fbbf7ee42d$export$8b4981022bd80a4e)("avatar-size");
var $9853ed1fed826087$var$baseStyleBadge = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $9853ed1fed826087$var$$border.reference,
    [$9853ed1fed826087$var$$border.variable]: "white",
    _dark: {
        [$9853ed1fed826087$var$$border.variable]: "colors.gray.800"
    }
});
var $9853ed1fed826087$var$baseStyleExcessLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    bg: $9853ed1fed826087$var$$bg.reference,
    fontSize: $9853ed1fed826087$var$$fs.reference,
    width: $9853ed1fed826087$var$$size.reference,
    height: $9853ed1fed826087$var$$size.reference,
    lineHeight: "1",
    [$9853ed1fed826087$var$$bg.variable]: "colors.gray.200",
    _dark: {
        [$9853ed1fed826087$var$$bg.variable]: "colors.whiteAlpha.400"
    }
});
var $9853ed1fed826087$var$baseStyleContainer = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)((props)=>{
    const { name: name, theme: theme } = props;
    const bg = name ? (0, $bcc5e97ee12ebad5$export$f3c6ed4330abfc18)({
        string: name
    }) : "colors.gray.400";
    const isBgDark = (0, $bcc5e97ee12ebad5$export$a79ad82046afa44e)(bg)(theme);
    let color = "white";
    if (!isBgDark) color = "gray.800";
    return {
        bg: $9853ed1fed826087$var$$bg.reference,
        fontSize: $9853ed1fed826087$var$$fs.reference,
        color: color,
        borderColor: $9853ed1fed826087$var$$border.reference,
        verticalAlign: "top",
        width: $9853ed1fed826087$var$$size.reference,
        height: $9853ed1fed826087$var$$size.reference,
        "&:not([data-loaded])": {
            [$9853ed1fed826087$var$$bg.variable]: bg
        },
        [$9853ed1fed826087$var$$border.variable]: "colors.white",
        _dark: {
            [$9853ed1fed826087$var$$border.variable]: "colors.gray.800"
        }
    };
});
var $9853ed1fed826087$var$baseStyleLabel = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontSize: $9853ed1fed826087$var$$fs.reference,
    lineHeight: "1"
});
var $9853ed1fed826087$var$baseStyle = $9853ed1fed826087$var$definePartsStyle((props)=>({
        badge: (0, $369b968b41e26508$export$624e501d81f5ffce)($9853ed1fed826087$var$baseStyleBadge, props),
        excessLabel: (0, $369b968b41e26508$export$624e501d81f5ffce)($9853ed1fed826087$var$baseStyleExcessLabel, props),
        container: (0, $369b968b41e26508$export$624e501d81f5ffce)($9853ed1fed826087$var$baseStyleContainer, props),
        label: $9853ed1fed826087$var$baseStyleLabel
    }));
function $9853ed1fed826087$var$getSize(size) {
    const themeSize = size !== "100%" ? (0, $733d1be8502853ee$export$d7d4c689520cc141)[size] : void 0;
    return $9853ed1fed826087$var$definePartsStyle({
        container: {
            [$9853ed1fed826087$var$$size.variable]: themeSize != null ? themeSize : size,
            [$9853ed1fed826087$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        },
        excessLabel: {
            [$9853ed1fed826087$var$$size.variable]: themeSize != null ? themeSize : size,
            [$9853ed1fed826087$var$$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
        }
    });
}
var $9853ed1fed826087$var$sizes = {
    "2xs": $9853ed1fed826087$var$getSize(4),
    xs: $9853ed1fed826087$var$getSize(6),
    sm: $9853ed1fed826087$var$getSize(8),
    md: $9853ed1fed826087$var$getSize(12),
    lg: $9853ed1fed826087$var$getSize(16),
    xl: $9853ed1fed826087$var$getSize(24),
    "2xl": $9853ed1fed826087$var$getSize(32),
    full: $9853ed1fed826087$var$getSize("100%")
};
var $9853ed1fed826087$export$9975d21893c10e66 = $9853ed1fed826087$var$defineMultiStyleConfig({
    baseStyle: $9853ed1fed826087$var$baseStyle,
    sizes: $9853ed1fed826087$var$sizes,
    defaultProps: {
        size: "md"
    }
});



// src/components/index.ts
var $3da6059ff7549039$export$9b5ac10f59f76296 = {
    Accordion: (0, $5bcafc970eb03425$export$20ec2254f76fa604),
    Alert: (0, $079cf9c1f773fda9$export$9d77d9665d829e89),
    Avatar: (0, $9853ed1fed826087$export$9975d21893c10e66),
    Badge: (0, $cf27f314dc675791$export$eb6e7cbc82d0f88b),
    Breadcrumb: (0, $77962fd07a1deed1$export$e2d8c6f6af55009),
    Button: (0, $df079183c8c71186$export$577deec5d331f6be),
    Checkbox: (0, $71db5bbb6bc24be3$export$86286d8c37984115),
    CloseButton: (0, $4d0f440026510ba2$export$47615e5b7f7e315f),
    Code: (0, $8d6cbacbe8f4b3ab$export$f9b9a8633a36e3c7),
    Container: (0, $969cbc6e1b3ec392$export$3ca0760d240fe5f4),
    Divider: (0, $0ec03bba1f05a7bd$export$f0e91f779c5bb416),
    Drawer: (0, $b149de7d34d1aea4$export$8057937c11129602),
    Editable: (0, $25dc8689dadb4cee$export$a09813cbe72349b1),
    Form: (0, $933c3dcd100c760b$export$870bcc1d98fee0aa),
    FormError: (0, $239100f869b4095f$export$b8d6747e16cd5f4d),
    FormLabel: (0, $c969545ce5fdffff$export$c49af69dbfc0c993),
    Heading: (0, $182cefaf31bafecf$export$5f175074e0f09e7b),
    Input: (0, $ec1ccabff4629292$export$b1b9f3bced726e54),
    Kbd: (0, $154d41908783067b$export$e193528a501e9a4a),
    Link: (0, $cf7f7fc1c118a2d3$export$af7f58b96695762e),
    List: (0, $2fb614b96236acfc$export$ce840f8e8ef752d),
    Menu: (0, $a18a4fc75c223b21$export$687ce088075ea42b),
    Modal: (0, $a1b49894409ffd9d$export$158ae9a07be41c05),
    NumberInput: (0, $0ebdb8860a80e280$export$b9bc5fa6e7f960a1),
    PinInput: (0, $9ff8a6396d629f06$export$8504c22c55a552e0),
    Popover: (0, $7569aecd919000a0$export$135f12f777be1ef7),
    Progress: (0, $2d094992e522cf2e$export$dc04d8e6a17afea1),
    Radio: (0, $32d81c24fe4274bc$export$f0b387b940941887),
    Select: (0, $6313575cc72520d0$export$21af0fc3c16183e1),
    Skeleton: (0, $775a4667e088267b$export$7680371ad2d79142),
    SkipLink: (0, $b2192be54fce925a$export$a8cf3228ef52959),
    Slider: (0, $dad79d07dec1684f$export$fff8df8fd8e1ed6f),
    Spinner: (0, $cbcd1109f2fb6181$export$d76156e68e556d3f),
    Stat: (0, $c0dffa7e3b5c800f$export$f3301eb37a20f09e),
    Switch: (0, $33844a1471636d94$export$6856b73e98185bff),
    Table: (0, $fa23e9310c0e1d60$export$3339219781bb5161),
    Tabs: (0, $c7ac2fd943c388b9$export$847a245e7ebce2a1),
    Tag: (0, $fc4b98d4e69336a7$export$f8ab9ac2a319695b),
    Textarea: (0, $3e8807b7633df861$export$394b8322fab774c1),
    Tooltip: (0, $b9637a0dbd0da5cb$export$7472a7883840b563),
    Card: (0, $bb091e73d7a71730$export$880f7b1201440c23),
    Stepper: (0, $2f5f31880c5d604c$export$54c84d54375c8d75)
};









































// src/semantic-tokens.ts
var $dee3c2f46ae029ee$export$c1b409c4e1d33fce = {
    colors: {
        "chakra-body-text": {
            _light: "gray.800",
            _dark: "whiteAlpha.900"
        },
        "chakra-body-bg": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-border-color": {
            _light: "gray.200",
            _dark: "whiteAlpha.300"
        },
        "chakra-inverse-text": {
            _light: "white",
            _dark: "gray.800"
        },
        "chakra-subtle-bg": {
            _light: "gray.100",
            _dark: "gray.700"
        },
        "chakra-subtle-text": {
            _light: "gray.600",
            _dark: "gray.400"
        },
        "chakra-placeholder-color": {
            _light: "gray.500",
            _dark: "whiteAlpha.400"
        }
    }
};


// src/styles.ts
var $bdc845b036d46cf6$export$9dd6ff9ea0189349 = {
    global: {
        body: {
            fontFamily: "body",
            color: "chakra-body-text",
            bg: "chakra-body-bg",
            transitionProperty: "background-color",
            transitionDuration: "normal",
            lineHeight: "base"
        },
        "*::placeholder": {
            color: "chakra-placeholder-color"
        },
        "*, *::before, &::after": {
            borderColor: "chakra-border-color"
        }
    }
};










// src/index.ts
var $fecf4860da5314d0$var$direction = "ltr";
var $fecf4860da5314d0$var$config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
};
var $fecf4860da5314d0$export$bca14c5b3b88a9c9 = {
    semanticTokens: $dee3c2f46ae029ee$export$c1b409c4e1d33fce,
    direction: $fecf4860da5314d0$var$direction,
    ...(0, $8f364387ee1b6c3d$export$651a0b7b10dae380),
    components: $3da6059ff7549039$export$9b5ac10f59f76296,
    styles: $bdc845b036d46cf6$export$9dd6ff9ea0189349,
    config: $fecf4860da5314d0$var$config
};
var $fecf4860da5314d0$export$2e2bcd8739ae039 = $fecf4860da5314d0$export$bca14c5b3b88a9c9;
var $fecf4860da5314d0$export$9e955aef208055a6 = {
    semanticTokens: $dee3c2f46ae029ee$export$c1b409c4e1d33fce,
    direction: $fecf4860da5314d0$var$direction,
    components: {},
    ...(0, $8f364387ee1b6c3d$export$651a0b7b10dae380),
    styles: $bdc845b036d46cf6$export$9dd6ff9ea0189349,
    config: $fecf4860da5314d0$var$config
};


// src/toast.utils.ts
var $469966aa105099a2$export$6486ede9e74d7d9d = (arr, id)=>arr.find((toast)=>toast.id === id);
function $469966aa105099a2$export$67080b9d5f0a62ea(toasts, id) {
    const position = $469966aa105099a2$export$500f52ac46324ec6(toasts, id);
    const index = position ? toasts[position].findIndex((toast)=>toast.id === id) : -1;
    return {
        position: position,
        index: index
    };
}
function $469966aa105099a2$export$500f52ac46324ec6(toasts, id) {
    for (const [position, values] of Object.entries(toasts)){
        if ($469966aa105099a2$export$6486ede9e74d7d9d(values, id)) return position;
    }
}
var $469966aa105099a2$export$795910f5f15a9633 = (toasts, id)=>!!$469966aa105099a2$export$500f52ac46324ec6(toasts, id);
function $469966aa105099a2$export$27777812cc6d52de(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty) alignItems = "flex-end";
    if (isLefty) alignItems = "flex-start";
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: alignItems
    };
}
function $469966aa105099a2$export$55dd410e8ef136e0(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
        position: "fixed",
        zIndex: "var(--toast-z-index, 5500)",
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        margin: margin,
        top: top,
        bottom: bottom,
        right: right,
        left: left
    };
}


// src/index.ts

var $acw62 = parcelRequire("acw62");
// src/index.ts

var $acw62 = parcelRequire("acw62");
function $eeeb32c390fb7f0b$export$25bec8c6f54ee79a(callback, deps = []) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
    }, deps);
}


function $3efd861ddab1b905$export$d8e6abf214c9ec0f(callback, delay) {
    const fn = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(callback);
    (0, $acw62.useEffect)(()=>{
        if (delay == null) return void 0;
        let timeoutId = null;
        timeoutId = window.setTimeout(()=>{
            fn();
        }, delay);
        return ()=>{
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [
        delay,
        fn
    ]);
}


// src/index.ts

var $acw62 = parcelRequire("acw62");
function $9af20caeda6fe4e1$export$496315a1608d9602(callback, deps) {
    const renderCycleRef = (0, $acw62.useRef)(false);
    const effectCycleRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const mounted = renderCycleRef.current;
        const run = mounted && effectCycleRef.current;
        if (run) return callback();
        effectCycleRef.current = true;
    }, deps);
    (0, $acw62.useEffect)(()=>{
        renderCycleRef.current = true;
        return ()=>{
            renderCycleRef.current = false;
        };
    }, []);
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});
function $3ce32ada97cfc8f7$export$cd995842eb2ab956() {
    return (0, $acw62.useContext)($3ce32ada97cfc8f7$export$2285bbca2c666415).visualElement;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);




var $acw62 = parcelRequire("acw62");
const $784730508f12f72c$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});



function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const parent = (0, $3ce32ada97cfc8f7$export$cd995842eb2ab956)();
    const lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext ? presenceContext.id : undefined,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        visualElement && visualElement.render();
    });
    /**
     * If we have optimised appear animations to handoff from, trigger animateChanges
     * from a synchronous useLayoutEffect to ensure there's no flash of incorrectly
     * styled component in the event of a hydration error.
     */ (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        if (visualElement && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    return visualElement;
}



var $acw62 = parcelRequire("acw62");
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $06b1046bf0f33e63$var$variantProps = [
    "initial",
    "animate",
    "exit",
    "whileHover",
    "whileDrag",
    "whileTap",
    "whileFocus",
    "whileInView"
];
function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(props.animate) || $06b1046bf0f33e63$var$variantProps.some((name)=>(0, $a35be4d5814e7c66$export$720b90e312cea233)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a35be4d5814e7c66$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a35be4d5814e7c66$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $a8d82256030e9525$var$createDefinition = (propNames)=>({
        isEnabled: (props)=>propNames.some((name)=>!!props[name])
    });
const $a8d82256030e9525$export$65570e08d843624d = {
    measureLayout: $a8d82256030e9525$var$createDefinition([
        "layout",
        "layoutId",
        "drag"
    ]),
    animation: $a8d82256030e9525$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ]),
    exit: $a8d82256030e9525$var$createDefinition([
        "exit"
    ]),
    drag: $a8d82256030e9525$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $a8d82256030e9525$var$createDefinition([
        "whileFocus"
    ]),
    hover: $a8d82256030e9525$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $a8d82256030e9525$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $a8d82256030e9525$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    inView: $a8d82256030e9525$var$createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ])
};



function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)if (key === "projectionNodeConstructor") (0, $a8d82256030e9525$export$65570e08d843624d).projectionNodeConstructor = features[key];
    else (0, $a8d82256030e9525$export$65570e08d843624d)[key].Component = features[key];
}




var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};


let $050be86dbc9816d5$var$id = 1;
function $050be86dbc9816d5$export$5ed57b87c18af11a() {
    return (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(()=>{
        if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated) return $050be86dbc9816d5$var$id++;
    });
}



var $acw62 = parcelRequire("acw62");
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});



var $acw62 = parcelRequire("acw62");
class $f5d17fe65e7e845e$export$a9ca437df31f9491 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */ getSnapshotBeforeUpdate() {
        const { visualElement: visualElement, props: props } = this.props;
        if (visualElement) visualElement.setProps(props);
        return null;
    }
    componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}




var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});


const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, projectionNodeConstructor: projectionNodeConstructor, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $b9879783068c1762$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        let features = null;
        const context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ const projectionId = isStatic ? undefined : (0, $050be86dbc9816d5$export$5ed57b87c18af11a)();
        /**
         *
         */ const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const lazyStrictMode = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171)).strict;
            const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
            if (context.visualElement) features = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, lazyStrictMode, preloadedFeatures, projectionId, projectionNodeConstructor || (0, $a8d82256030e9525$export$65570e08d843624d).projectionNodeConstructor, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $f5d17fe65e7e845e$export$a9ca437df31f9491), {
            visualElement: context.visualElement,
            props: configAndProps
        }, features, $acw62.createElement((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context
        }, useRender(Component, props, projectionId, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)));
    }
    const ForwardRefComponent = (0, $acw62.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $9b94ea54d3350cc1$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $ac502869c4d3e65a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ac502869c4d3e65a$export$7b42a0094fb00b6e = new Set($ac502869c4d3e65a$export$280dc01950909d86);


function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $55c3387a92452647$export$605d60a2578142d3 = (value)=>!!(value === null || value === void 0 ? void 0 : value.getVelocity);



const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $1724c99b9b724858$var$sortTransformProps = (a, b)=>(0, $ac502869c4d3e65a$export$280dc01950909d86).indexOf(a) - (0, $ac502869c4d3e65a$export$280dc01950909d86).indexOf(b);
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914({ transform: transform, transformKeys: transformKeys }, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort($1724c99b9b724858$var$sortTransformProps);
    // Loop over each transform and build them into transformString
    for (const key of transformKeys)transformString += `${$1724c99b9b724858$var$translateAlias[key] || key}(${transform[key]}) `;
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


/**
 * Returns true if the provided key is a CSS variable
 */ function $f9c5e88311214d2a$export$451bc42768436155(key) {
    return key.startsWith("--");
}



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a19b1277e1098e3a$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $965bce4b5aab9d94$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $965bce4b5aab9d94$export$58f0f39f63f3cf42 = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    transform: (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $965bce4b5aab9d94$export$dcdf75081b88279d = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $9d068be114f1d873$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $9d068be114f1d873$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $9d068be114f1d873$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $9d068be114f1d873$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $9d068be114f1d873$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $25ca921ba8e55794$var$createUnitType = (unit)=>({
        test: (v)=>(0, $9d068be114f1d873$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $25ca921ba8e55794$export$41fc368e1a942b97 = $25ca921ba8e55794$var$createUnitType("deg");
const $25ca921ba8e55794$export$626336c2cd4b14de = $25ca921ba8e55794$var$createUnitType("%");
const $25ca921ba8e55794$export$91c0eda1d06bf008 = $25ca921ba8e55794$var$createUnitType("px");
const $25ca921ba8e55794$export$f91e8c45a95a32f2 = $25ca921ba8e55794$var$createUnitType("vh");
const $25ca921ba8e55794$export$aed3d7b7d206c196 = $25ca921ba8e55794$var$createUnitType("vw");
const $25ca921ba8e55794$export$44e2e1705876d7ed = {
    ...$25ca921ba8e55794$export$626336c2cd4b14de,
    parse: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.transform(v * 100)
};



const $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: Math.round
};


const $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRightWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    radius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    height: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxHeight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    size: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    top: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    right: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    bottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    left: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    margin: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateZ: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    scale: $965bce4b5aab9d94$export$dcdf75081b88279d,
    scaleX: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleY: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleZ: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    skew: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    distance: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateX: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateY: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    x: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    y: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    z: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    perspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    transformPerspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    opacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    originX: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originY: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    numOctaves: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e)
};


function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformKeys: transformKeys, transformOrigin: transformOrigin } = state;
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $f9c5e88311214d2a$export$451bc42768436155)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(state, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    });


function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $55c3387a92452647$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    htmlProps.style = style;
    return htmlProps;
}


const $c4bee6acbf082b7d$var$animationProps = [
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
];
const $c4bee6acbf082b7d$var$tapProps = [
    "whileTap",
    "onTap",
    "onTapStart",
    "onTapCancel"
];
const $c4bee6acbf082b7d$var$panProps = [
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
];
const $c4bee6acbf082b7d$var$inViewProps = [
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport"
];
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "onHoverStart",
    "onHoverEnd",
    "layoutScroll",
    ...$c4bee6acbf082b7d$var$inViewProps,
    ...$c4bee6acbf082b7d$var$tapProps,
    ...$c4bee6acbf082b7d$var$animationProps,
    ...$c4bee6acbf082b7d$var$panProps
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("8RYFI")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props)if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    return filteredProps;
}




var $acw62 = parcelRequire("acw62");



function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2860344bf6c6c49f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $57bb451bc3d87577$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}


function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, projectionId, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $acw62.createElement)(Component, elementProps);
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $55c3387a92452647$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps.style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}


function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $55c3387a92452647$export$605d60a2578142d3)(props[key]) || (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $acw62 = parcelRequire("acw62");


function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $21f654501c04362b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $21f654501c04362b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $21f654501c04362b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $5c26ebcca6422185$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(make);
    };
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
        createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
            (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





const $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a8ee53e44f8c4ac8$export$16da615486abaa45,
        createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
    })
};


function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    const baseConfig = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $fde6d634ecc7ed6c$export$44dabd3fae512e85) : (0, $dcb38e10dcfb6316$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $dc80cb5954e76638$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        projectionNodeConstructor: projectionNodeConstructor,
        Component: Component
    };
}


var $bc94049262afe059$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})($bc94049262afe059$export$2deb71ebd3734d23 || ($bc94049262afe059$export$2deb71ebd3734d23 = {}));



var $acw62 = parcelRequire("acw62");
function $cba4f237926ffdf7$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $cba4f237926ffdf7$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $acw62.useEffect)(()=>{
        const element = ref.current;
        if (handler && element) return $cba4f237926ffdf7$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}


/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $5431ad674d2aa8ad$export$cac52d7cca250a66({ whileFocus: whileFocus, visualElement: visualElement }) {
    const { animationState: animationState } = visualElement;
    const onFocus = ()=>{
        animationState && animationState.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Focus, true);
    };
    const onBlur = ()=>{
        animationState && animationState.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Focus, false);
    };
    (0, $cba4f237926ffdf7$export$c1052189363cb2e0)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $cba4f237926ffdf7$export$c1052189363cb2e0)(visualElement, "blur", whileFocus ? onBlur : undefined);
}




/**
 * Specifically match against false here as incomplete versions of
 * PointerEvents in very old browser might have it set as undefined.
 */ const $6b2f8b101475710a$export$a4cf9c8a4b063a6e = (event)=>event.isPrimary !== false;


function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};


function $a3f7c96fbe45f23e$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $cba4f237926ffdf7$export$b1d829ddf82884aa)(target, eventName, (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}
function $a3f7c96fbe45f23e$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $cba4f237926ffdf7$export$c1052189363cb2e0)(ref, eventName, handler && (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}


function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
const $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        const openHorizontal = $df8cc4eab047d382$var$globalHorizontalLock();
        const openVertical = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $68f67e0924891ff4$var$isMouseEvent(event) {
    return event.type !== "pen" && event.type !== "touch";
}
function $68f67e0924891ff4$var$createHoverEvent(visualElement, isActive, callback) {
    return (event, info)=>{
        if (!$68f67e0924891ff4$var$isMouseEvent(event) || (0, $df8cc4eab047d382$export$1b3dd616664938e4)()) return;
        /**
         * Ensure we trigger animations before firing event callback
         */ if (visualElement.animationState) visualElement.animationState.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Hover, isActive);
        callback && callback(event, info);
    };
}
function $68f67e0924891ff4$export$dea06860711b7ebc({ onHoverStart: onHoverStart, onHoverEnd: onHoverEnd, whileHover: whileHover, visualElement: visualElement }) {
    (0, $a3f7c96fbe45f23e$export$734d04395f5243cd)(visualElement, "pointerenter", onHoverStart || whileHover ? $68f67e0924891ff4$var$createHoverEvent(visualElement, true, onHoverStart) : undefined, {
        passive: !onHoverStart
    });
    (0, $a3f7c96fbe45f23e$export$734d04395f5243cd)(visualElement, "pointerleave", onHoverEnd || whileHover ? $68f67e0924891ff4$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined, {
        passive: !onHoverEnd
    });
}



var $acw62 = parcelRequire("acw62");
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ae5289b89bf4fd95$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};




var $acw62 = parcelRequire("acw62");
function $7bbbf777b15ef7cf$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(()=>()=>callback(), []);
}




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $21841eadb135946f$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $21841eadb135946f$export$a4627e546088548d = (...transformers)=>transformers.reduce($21841eadb135946f$var$combineFunctions);


/**
 * @param handlers -
 * @internal
 */ function $3f9742550fb7ca4c$export$16dee6ef8c34532({ onTap: onTap, onTapStart: onTapStart, onTapCancel: onTapCancel, whileTap: whileTap, visualElement: visualElement }) {
    const hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    const isPressing = (0, $acw62.useRef)(false);
    const cancelPointerEndListeners = (0, $acw62.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */ const eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
    };
    function removePointerEndListener() {
        cancelPointerEndListeners.current && cancelPointerEndListeners.current();
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        removePointerEndListener();
        isPressing.current = false;
        visualElement.animationState && visualElement.animationState.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Tap, false);
        return !(0, $df8cc4eab047d382$export$1b3dd616664938e4)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $ae5289b89bf4fd95$export$e841ada32ff745b)(visualElement.current, event.target) ? onTapCancel && onTapCancel(event, info) : onTap && onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel && onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $21841eadb135946f$export$a4627e546088548d)((0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointerup", onPointerUp, eventOptions), (0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */ visualElement.animationState && visualElement.animationState.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Tap, true);
        onTapStart && onTapStart(event, info);
    }
    (0, $a3f7c96fbe45f23e$export$734d04395f5243cd)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(removePointerEndListener);
}



var $acw62 = parcelRequire("acw62");


/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


function $554007e400b24229$export$297ec8eb77d6211d({ visualElement: visualElement, whileInView: whileInView, onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave, viewport: viewport = {} }) {
    const state = (0, $acw62.useRef)({
        hasEnteredView: false,
        isInView: false
    });
    let shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView) shouldObserve = false;
    const useObserver = typeof IntersectionObserver === "undefined" ? $554007e400b24229$var$useMissingIntersectionObserver : $554007e400b24229$var$useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
const $554007e400b24229$var$thresholdNames = {
    some: 0,
    all: 1
};
function $554007e400b24229$var$useIntersectionObserver(shouldObserve, state, visualElement, { root: root, margin: rootMargin, amount: amount = "some", once: once }) {
    (0, $acw62.useEffect)(()=>{
        if (!shouldObserve || !visualElement.current) return;
        const options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $554007e400b24229$var$thresholdNames[amount]
        };
        const intersectionCallback = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (state.isInView === isIntersecting) return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && state.hasEnteredView) return;
            else if (isIntersecting) state.hasEnteredView = true;
            if (visualElement.animationState) visualElement.animationState.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).InView, isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const props = visualElement.getProps();
            const callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
            callback && callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(visualElement.current, options, intersectionCallback);
    }, [
        shouldObserve,
        root,
        rootMargin,
        amount
    ]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */ function $554007e400b24229$var$useMissingIntersectionObserver(shouldObserve, state, visualElement, { fallback: fallback = true }) {
    (0, $acw62.useEffect)(()=>{
        if (!shouldObserve || !fallback) return;
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */ requestAnimationFrame(()=>{
            state.hasEnteredView = true;
            const { onViewportEnter: onViewportEnter } = visualElement.getProps();
            onViewportEnter && onViewportEnter(null);
            if (visualElement.animationState) visualElement.animationState.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).InView, true);
        });
    }, [
        shouldObserve
    ]);
}


const $ff62e0eea2bbc1b2$export$46d1d6d046f826e4 = (hook)=>(props)=>{
        hook(props);
        return null;
    };


const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $554007e400b24229$export$297ec8eb77d6211d)),
    tap: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $3f9742550fb7ca4c$export$16dee6ef8c34532)),
    focus: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $5431ad674d2aa8ad$export$cac52d7cca250a66)),
    hover: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $68f67e0924891ff4$export$dea06860711b7ebc))
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}





function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $d56714d1e4e43615$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $933209bc9c035719$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);



const $b54248de5cdf5520$export$fff89137e9e818ce = {
    delta: 0,
    timestamp: 0
};


/*
  Detect and load appropriate clock setting for the execution environment
 */ const $97767d026c4510a8$export$f8caf8121275292d = 1 / 60 * 1000;
const $97767d026c4510a8$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $97767d026c4510a8$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($97767d026c4510a8$var$getCurrentTime()), $97767d026c4510a8$export$f8caf8121275292d);


function $84275669f74db65a$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */ let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}



const $b4999b8a0b43adc6$var$maxElapsed = 40;
let $b4999b8a0b43adc6$var$useDefaultElapsed = true;
let $b4999b8a0b43adc6$var$runNextFrame = false;
let $b4999b8a0b43adc6$var$isProcessing = false;
const $b4999b8a0b43adc6$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $b4999b8a0b43adc6$var$steps = $b4999b8a0b43adc6$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $84275669f74db65a$export$b995e5e85f5c8289)(()=>$b4999b8a0b43adc6$var$runNextFrame = true);
    return acc;
}, {});
const $b4999b8a0b43adc6$export$92d6409d68f0739a = $b4999b8a0b43adc6$var$stepsOrder.reduce((acc, key)=>{
    const step = $b4999b8a0b43adc6$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$b4999b8a0b43adc6$var$runNextFrame) $b4999b8a0b43adc6$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $b4999b8a0b43adc6$export$d93e9c1fe0553512 = $b4999b8a0b43adc6$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $b4999b8a0b43adc6$var$steps[key].cancel;
    return acc;
}, {});
const $b4999b8a0b43adc6$export$cd75ccfd720a3cd4 = $b4999b8a0b43adc6$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$b4999b8a0b43adc6$var$steps[key].process((0, $b54248de5cdf5520$export$fff89137e9e818ce));
    return acc;
}, {});
const $b4999b8a0b43adc6$var$processStep = (stepId)=>$b4999b8a0b43adc6$var$steps[stepId].process((0, $b54248de5cdf5520$export$fff89137e9e818ce));
const $b4999b8a0b43adc6$var$processFrame = (timestamp)=>{
    $b4999b8a0b43adc6$var$runNextFrame = false;
    (0, $b54248de5cdf5520$export$fff89137e9e818ce).delta = $b4999b8a0b43adc6$var$useDefaultElapsed ? (0, $97767d026c4510a8$export$f8caf8121275292d) : Math.max(Math.min(timestamp - (0, $b54248de5cdf5520$export$fff89137e9e818ce).timestamp, $b4999b8a0b43adc6$var$maxElapsed), 1);
    (0, $b54248de5cdf5520$export$fff89137e9e818ce).timestamp = timestamp;
    $b4999b8a0b43adc6$var$isProcessing = true;
    $b4999b8a0b43adc6$var$stepsOrder.forEach($b4999b8a0b43adc6$var$processStep);
    $b4999b8a0b43adc6$var$isProcessing = false;
    if ($b4999b8a0b43adc6$var$runNextFrame) {
        $b4999b8a0b43adc6$var$useDefaultElapsed = false;
        (0, $97767d026c4510a8$export$4fdea63ab5513fd5)($b4999b8a0b43adc6$var$processFrame);
    }
};
const $b4999b8a0b43adc6$var$startLoop = ()=>{
    $b4999b8a0b43adc6$var$runNextFrame = true;
    $b4999b8a0b43adc6$var$useDefaultElapsed = true;
    if (!$b4999b8a0b43adc6$var$isProcessing) (0, $97767d026c4510a8$export$4fdea63ab5513fd5)($b4999b8a0b43adc6$var$processFrame);
};


function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ad746ac6e5aa4783$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $acbc43562ac6dbd8$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $e32104bb79321603$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $e32104bb79321603$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "8.1.7";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $b54248de5cdf5520$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(animation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.stopAnimation = animation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.stopAnimation) {
            this.stopAnimation();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.stopAnimation;
    }
    clearAnimation() {
        this.stopAnimation = null;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $e32104bb79321603$export$ce8bdc721e76545f(init, options) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init, options);
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ded99e01d9b518c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (0, $9d068be114f1d873$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ded99e01d9b518c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $9d068be114f1d873$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $c79d1e7d77418d04$var$clampRgbUnit = (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 255, v);
const $c79d1e7d77418d04$export$7a99c86b5b1f4c9e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: (v)=>Math.round($c79d1e7d77418d04$var$clampRgbUnit(v))
};
const $c79d1e7d77418d04$export$4e46ac54fc82cf3b = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $875e9bff470aaa65$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875e9bff470aaa65$export$834dfc94dde4b3d8 = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("#"),
    parse: $875e9bff470aaa65$var$parseHex,
    transform: (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform
};






const $8bf8a43b3506d305$export$810b04175080204c = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d8fe6ea9e8bd3d9c$export$35e9368ef982300f = {
    test: (v)=>(0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v) || (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).test(v) || (0, $8bf8a43b3506d305$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v)) return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $8bf8a43b3506d305$export$810b04175080204c).test(v)) return (0, $8bf8a43b3506d305$export$810b04175080204c).parse(v);
        else return (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $9d068be114f1d873$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(v) : (0, $8bf8a43b3506d305$export$810b04175080204c).transform(v);
    }
};




const $b7b50ce2c2d54405$var$colorToken = "${c}";
const $b7b50ce2c2d54405$var$numberToken = "${n}";
function $b7b50ce2c2d54405$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (((_a = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
function $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    let numNumbers = 0;
    const colors = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba));
    if (colors) {
        numColors = colors.length;
        // Strip colors from input so they're not picked up by number regex.
        // There's a better way to combine these regex searches, but its beyond my regex skills
        v = v.replace((0, $9d068be114f1d873$export$740b69c5fad25dba), $b7b50ce2c2d54405$var$colorToken);
        values.push(...colors.map((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).parse));
    }
    const numbers = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
    if (numbers) {
        numNumbers = numbers.length;
        v = v.replace((0, $9d068be114f1d873$export$2444ca58c08448e4), $b7b50ce2c2d54405$var$numberToken);
        values.push(...numbers.map((0, $965bce4b5aab9d94$export$98e628dec113755e).parse));
    }
    return {
        values: values,
        numColors: numColors,
        numNumbers: numNumbers,
        tokenised: v
    };
}
function $b7b50ce2c2d54405$var$parse(v) {
    return $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v).values;
}
function $b7b50ce2c2d54405$var$createTransformer(source) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $b7b50ce2c2d54405$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $b7b50ce2c2d54405$var$colorToken : $b7b50ce2c2d54405$var$numberToken, i < numColors ? (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).transform(v[i]) : (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(v[i]));
        return output;
    };
}
const $b7b50ce2c2d54405$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b7b50ce2c2d54405$var$getAnimatableNone(v) {
    const parsed = $b7b50ce2c2d54405$var$parse(v);
    const transformer = $b7b50ce2c2d54405$var$createTransformer(v);
    return transformer(parsed.map($b7b50ce2c2d54405$var$convertNumbersToZero));
}
const $b7b50ce2c2d54405$export$83a0e34f1302825b = {
    test: $b7b50ce2c2d54405$var$test,
    parse: $b7b50ce2c2d54405$var$parse,
    createTransformer: $b7b50ce2c2d54405$var$createTransformer,
    getAnimatableNone: $b7b50ce2c2d54405$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $c55938f2e5f09a1e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c55938f2e5f09a1e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9d068be114f1d873$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c55938f2e5f09a1e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c55938f2e5f09a1e$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $c55938f2e5f09a1e$export$3dea766d36a8935f = {
    ...(0, $b7b50ce2c2d54405$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c55938f2e5f09a1e$var$functionRegex);
        return functions ? functions.map($c55938f2e5f09a1e$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = {
    ...(0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b),
    color: // Color props
    $d8fe6ea9e8bd3d9c$export$35e9368ef982300f,
    backgroundColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    outlineColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    fill: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    stroke: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderTopColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderRightColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderBottomColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderLeftColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    filter: $c55938f2e5f09a1e$export$3dea766d36a8935f,
    WebkitFilter: (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6da1de6e0a9a8c9d$export$67d1babe0338d23b = (key)=>$6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];


function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    var _a;
    let defaultValueType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)) defaultValueType = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}






/**
 * Tests a provided value against a ValueType
 */ const $a1e2618328995be8$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $965bce4b5aab9d94$export$98e628dec113755e),
    (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    (0, $25ca921ba8e55794$export$626336c2cd4b14de),
    (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    (0, $25ca921ba8e55794$export$aed3d7b7d206c196),
    (0, $25ca921ba8e55794$export$f91e8c45a95a32f2),
    (0, $c231a4375b038d3c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a90ec5e4ad59372f$export$eefdd52e3ccae428 = (v)=>$a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $0bb49f6c51badae3$var$valueTypes = [
    ...(0, $a90ec5e4ad59372f$export$d176691c1998a1f5),
    (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $0bb49f6c51badae3$export$950e7e59ea1ffed7 = (v)=>$0bb49f6c51badae3$var$valueTypes.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $58c1fda9d3891d8d$var$getCurrent(visualElement), $58c1fda9d3891d8d$var$getVelocity(visualElement));
}


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $21f654501c04362b$export$5485128c47bd48bb)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}
function $ea04fe669600292a$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        var _a;
        const variant = visualElement.getVariant(key);
        variant && $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            $ea04fe669600292a$var$setVariants(child, variantLabels);
        });
    });
}
function $ea04fe669600292a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ea04fe669600292a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ea04fe669600292a$var$setVariants(visualElement, [
        definition
    ]);
    else $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition);
}
function $ea04fe669600292a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $d56714d1e4e43615$export$65583ed5a868f2d9)(value) || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $0bb49f6c51badae3$export$950e7e59ea1ffed7)(value) && (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(targetValue)) value = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $ea04fe669600292a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ea04fe669600292a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a;
    const origin = {};
    for(const key in target){
        const transitionOrigin = $ea04fe669600292a$export$c3befe8e18686628(key, transition);
        origin[key] = transitionOrigin !== undefined ? transitionOrigin : (_a = visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.get();
    }
    return origin;
}





function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $55c3387a92452647$export$605d60a2578142d3)(value) && value.add);
}




const $dc0fe85c8e78ca18$export$c4a39f7e38d37eb9 = (id, value)=>`${id}: ${value}`;


function $4f69af4939ee8d9a$export$470de7e050cf9631(id, name) {
    const { MotionAppearAnimations: MotionAppearAnimations } = window;
    const animationId = (0, $dc0fe85c8e78ca18$export$c4a39f7e38d37eb9)(id, (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(name) ? "transform" : name);
    const animation = MotionAppearAnimations && MotionAppearAnimations.get(animationId);
    if (animation) {
        /**
         * We allow the animation to persist until the next frame:
         *   1. So it continues to play until Framer Motion is ready to render
         *      (avoiding a potential flash of the element's original state)
         *   2. As all independent transforms share a single transform animation, stopping
         *      it synchronously would prevent subsequent transforms from handing off.
         */ (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).render(()=>{
            /**
             * Animation.cancel() throws so it needs to be wrapped in a try/catch
             */ try {
                animation.cancel();
                MotionAppearAnimations.delete(animationId);
            } catch (e) {}
        });
        return animation.currentTime || 0;
    } else return 0;
}



const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $9dc069bda924fd3f$export$9fd24a634729c672)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);


var $4fd1ae9b00853f6f$export$491112666e282270 = function() {};
var $4fd1ae9b00853f6f$export$f5708dca728d7177 = function() {};


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $083454c8244247d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;


const $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};



// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6fc2fca13a5370f0$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $daf16ad73b68faf0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $c24ef35c6cea05c0$export$929e5a82286172a6 = (p)=>p * p;
const $c24ef35c6cea05c0$export$57636bb43b1ccbb0 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($c24ef35c6cea05c0$export$929e5a82286172a6);
const $c24ef35c6cea05c0$export$c07234257a03d5e9 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($c24ef35c6cea05c0$export$929e5a82286172a6);





/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $70c54e935a247717$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $fd6f5ba04ea8bac3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue);
        blue = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $7691d9e96675321f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $7691d9e96675321f$var$colorTypes = [
    (0, $875e9bff470aaa65$export$834dfc94dde4b3d8),
    (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b),
    (0, $8bf8a43b3506d305$export$810b04175080204c)
];
const $7691d9e96675321f$var$getColorType = (v)=>$7691d9e96675321f$var$colorTypes.find((type)=>type.test(v));
function $7691d9e96675321f$var$asRGBA(color) {
    const type = $7691d9e96675321f$var$getColorType(color);
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $8bf8a43b3506d305$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $7691d9e96675321f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $7691d9e96675321f$var$asRGBA(from);
    const toRGBA = $7691d9e96675321f$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(blended);
    };
};








function $6ec69123567a0d66$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(origin)) return (0, $7691d9e96675321f$export$51e568cf5c039bac)(origin, target);
    else return $6ec69123567a0d66$export$65516310a87d8205(origin, target);
}
const $6ec69123567a0d66$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$6ec69123567a0d66$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $6ec69123567a0d66$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $6ec69123567a0d66$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $6ec69123567a0d66$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $21841eadb135946f$export$a4627e546088548d)($6ec69123567a0d66$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $4fd1ae9b00853f6f$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $3a28fe0c82ae45f8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $ec602dd05d6627bc$var$mixNumber = (from, to)=>(p)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(from, to, p);
function $ec602dd05d6627bc$var$detectMixerFactory(v) {
    if (typeof v === "number") return $ec602dd05d6627bc$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(v)) return 0, $7691d9e96675321f$export$51e568cf5c039bac;
        else return 0, $6ec69123567a0d66$export$65516310a87d8205;
    } else if (Array.isArray(v)) return 0, $6ec69123567a0d66$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $6ec69123567a0d66$export$ebc23b6840c51ba1;
    return $ec602dd05d6627bc$var$mixNumber;
}
function $ec602dd05d6627bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $ec602dd05d6627bc$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $21841eadb135946f$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec602dd05d6627bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec602dd05d6627bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}



const $448ce039afb5ec07$export$8793edee2d425525 = (any)=>any;


/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $cdee14e408821ec6$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $cdee14e408821ec6$var$subdivisionPrecision = 0.0000001;
const $cdee14e408821ec6$var$subdivisionMaxIterations = 12;
function $cdee14e408821ec6$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $cdee14e408821ec6$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $cdee14e408821ec6$var$subdivisionPrecision && ++i < $cdee14e408821ec6$var$subdivisionMaxIterations);
    return currentT;
}
function $cdee14e408821ec6$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $448ce039afb5ec07$export$8793edee2d425525;
    const getTForX = (aX)=>$cdee14e408821ec6$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $cdee14e408821ec6$var$calcBezier(getTForX(t), mY1, mY2);
}






const $66a2361fd99a4040$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $66a2361fd99a4040$export$c8d67a19199d1a50 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($66a2361fd99a4040$export$e444123e42d03385);
const $66a2361fd99a4040$export$30d3455eee55bed5 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($66a2361fd99a4040$export$c8d67a19199d1a50);





const $a7ddcde2a4282efd$export$77edfce482316a60 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $a7ddcde2a4282efd$export$b01116c84cdfe1a2 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($a7ddcde2a4282efd$export$77edfce482316a60);
const $a7ddcde2a4282efd$export$ddc5fd596f6c71b2 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($a7ddcde2a4282efd$export$b01116c84cdfe1a2);



const $5e5a5cfe1fa796ef$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $a7ddcde2a4282efd$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $09ac0b286989a3ae$var$easingLookup = {
    linear: (0, $448ce039afb5ec07$export$8793edee2d425525),
    easeIn: $c24ef35c6cea05c0$export$929e5a82286172a6,
    easeInOut: $c24ef35c6cea05c0$export$c07234257a03d5e9,
    easeOut: $c24ef35c6cea05c0$export$57636bb43b1ccbb0,
    circIn: $66a2361fd99a4040$export$e444123e42d03385,
    circInOut: $66a2361fd99a4040$export$30d3455eee55bed5,
    circOut: $66a2361fd99a4040$export$c8d67a19199d1a50,
    backIn: $a7ddcde2a4282efd$export$b01116c84cdfe1a2,
    backInOut: $a7ddcde2a4282efd$export$ddc5fd596f6c71b2,
    backOut: $a7ddcde2a4282efd$export$77edfce482316a60,
    anticipate: $5e5a5cfe1fa796ef$export$6b0af63b873d419e
};
const $09ac0b286989a3ae$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)($09ac0b286989a3ae$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $09ac0b286989a3ae$var$easingLookup[definition];
    }
    return definition;
};
const $09ac0b286989a3ae$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


function $fec49c65f9f76c79$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c24ef35c6cea05c0$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $fec49c65f9f76c79$export$24dbcec0b26e6d9d(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function $fec49c65f9f76c79$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}
function $fec49c65f9f76c79$export$d25ddfdf17c3ad3e({ keyframes: keyframeValues, ease: ease = (0, $c24ef35c6cea05c0$export$c07234257a03d5e9), times: times, duration: duration = 300 }) {
    keyframeValues = [
        ...keyframeValues
    ];
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $09ac0b286989a3ae$export$216948827bbdc797)(ease) ? ease.map((0, $09ac0b286989a3ae$export$ef97fe084f156ca4)) : (0, $09ac0b286989a3ae$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = $fec49c65f9f76c79$export$2a91b4e3a4539316(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : $fec49c65f9f76c79$export$24dbcec0b26e6d9d(keyframeValues), duration);
    function createInterpolator() {
        return (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
            ease: Array.isArray(easingFunctions) ? easingFunctions : $fec49c65f9f76c79$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            keyframeValues.reverse();
            interpolator = createInterpolator();
        }
    };
}




const $d4e4dd0fc1a7d755$var$safeMin = 0.001;
const $d4e4dd0fc1a7d755$export$a3cdb76e84ee608e = 0.01;
const $d4e4dd0fc1a7d755$export$1824b851fad8862b = 10.0;
const $d4e4dd0fc1a7d755$export$ff08f2d53484465 = 0.05;
const $d4e4dd0fc1a7d755$export$201ca48e54038115 = 1;
function $d4e4dd0fc1a7d755$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $4fd1ae9b00853f6f$export$491112666e282270)(duration <= $d4e4dd0fc1a7d755$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($d4e4dd0fc1a7d755$export$ff08f2d53484465, $d4e4dd0fc1a7d755$export$201ca48e54038115, dampingRatio);
    duration = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($d4e4dd0fc1a7d755$export$a3cdb76e84ee608e, $d4e4dd0fc1a7d755$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $d4e4dd0fc1a7d755$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $d4e4dd0fc1a7d755$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $d4e4dd0fc1a7d755$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $d4e4dd0fc1a7d755$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$d4e4dd0fc1a7d755$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $d4e4dd0fc1a7d755$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $d4e4dd0fc1a7d755$var$rootIterations = 12;
function $d4e4dd0fc1a7d755$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $d4e4dd0fc1a7d755$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $d4e4dd0fc1a7d755$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}



const $81759af2b3a28146$var$durationKeys = [
    "duration",
    "bounce"
];
const $81759af2b3a28146$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $81759af2b3a28146$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $81759af2b3a28146$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$81759af2b3a28146$var$isSpringType(options, $81759af2b3a28146$var$physicsKeys) && $81759af2b3a28146$var$isSpringType(options, $81759af2b3a28146$var$durationKeys)) {
        const derived = (0, $d4e4dd0fc1a7d755$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
const $81759af2b3a28146$var$velocitySampleDuration = 5;
/**
 * This is based on the spring implementation of Wobble https://github.com/skevy/wobble
 */ function $81759af2b3a28146$export$b36281d89752ae66({ keyframes: keyframes, restSpeed: restSpeed = 2, restDelta: restDelta = 0.01, ...options }) {
    let origin = keyframes[0];
    let target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $81759af2b3a28146$var$getSpringOptions(options);
    let resolveSpring = $81759af2b3a28146$var$zero;
    let initialVelocity = velocity ? -(velocity / 1000) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    function createSpring() {
        const initialDelta = target - origin;
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        /**
         * If we're working within what looks like a 0-1 range, change the default restDelta
         * to 0.01
         */ if (restDelta === undefined) restDelta = Math.min(Math.abs(target - origin) / 100, 0.4);
        if (dampingRatio < 1) {
            const angularFreq = (0, $d4e4dd0fc1a7d755$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
            // Underdamped spring
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
        } else if (dampingRatio === 1) // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            // Overdamped spring
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                // When performing sinh or cosh values can hit Infinity so we cap them here
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) {
                        const prevT = Math.max(0, t - $81759af2b3a28146$var$velocitySampleDuration);
                        currentVelocity = (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(current - resolveSpring(prevT), t - prevT);
                    } else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        flipTarget: ()=>{
            initialVelocity = -initialVelocity;
            [origin, target] = [
                target,
                origin
            ];
            createSpring();
        }
    };
}
$81759af2b3a28146$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $81759af2b3a28146$var$zero = (_t)=>0;


function $1f1a2d3e8d02242a$export$e9341ba102272ab9({ keyframes: /**
 * The decay animation dynamically calculates an end of the animation
 * based on the initial keyframe, so we only need to define a single keyframe
 * as default.
 */ keyframes = [
    0
], velocity: velocity = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const origin = keyframes[0];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}




const $1eaabe23cae0a8f9$var$types = {
    decay: $1f1a2d3e8d02242a$export$e9341ba102272ab9,
    keyframes: (0, $fec49c65f9f76c79$export$d25ddfdf17c3ad3e),
    tween: (0, $fec49c65f9f76c79$export$d25ddfdf17c3ad3e),
    spring: $81759af2b3a28146$export$b36281d89752ae66
};
function $1eaabe23cae0a8f9$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $1eaabe23cae0a8f9$export$ab9042754680126b(elapsed, duration = 0, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $1eaabe23cae0a8f9$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $1eaabe23cae0a8f9$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const $1eaabe23cae0a8f9$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(passTimestamp, true),
        stop: ()=>(0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).update(passTimestamp)
    };
};
function $1eaabe23cae0a8f9$export$e3607ec2d7a891c4({ duration: duration, driver: driver = $1eaabe23cae0a8f9$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, keyframes: keyframes$1, autoplay: autoplay = true, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate, type: type = "keyframes", ...options }) {
    var _a, _b;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = $1eaabe23cae0a8f9$var$types[keyframes$1.length > 2 ? "keyframes" : type] || (0, $fec49c65f9f76c79$export$d25ddfdf17c3ad3e);
    const origin = keyframes$1[0];
    const target = keyframes$1[keyframes$1.length - 1];
    if ((_b = (_a = animator).needsInterpolation) === null || _b === void 0 ? void 0 : _b.call(_a, origin, target)) {
        interpolateFromNumber = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)([
            0,
            100
        ], [
            origin,
            target
        ], {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const animation = animator({
        ...options,
        duration: duration,
        keyframes: keyframes$1
    });
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = $1eaabe23cae0a8f9$export$ab9042754680126b(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = $1eaabe23cae0a8f9$export$7d0784e050d8e25f(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate && onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration = computedDuration !== undefined ? computedDuration : elapsed;
            if (repeatCount < repeatMax) $1eaabe23cae0a8f9$export$c9c9437f9b8733b5(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay && onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop && onStop();
            driverControls.stop();
        },
        sample: (t)=>{
            return animation.next(Math.max(0, t));
        }
    };
}


function $2e4dc549f5b87e20$export$fcdd8f3f2160beda(easing) {
    return !easing || // Default easing
    Array.isArray(easing) || // Bezier curve
    typeof easing === "string" && $2e4dc549f5b87e20$export$2cf569f5e2221176[easing];
}
const $2e4dc549f5b87e20$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $2e4dc549f5b87e20$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $2e4dc549f5b87e20$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $2e4dc549f5b87e20$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $2e4dc549f5b87e20$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $2e4dc549f5b87e20$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $2e4dc549f5b87e20$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return Array.isArray(easing) ? $2e4dc549f5b87e20$export$2523b8f0bd8f44cb(easing) : $2e4dc549f5b87e20$export$2cf569f5e2221176[easing];
}


function $65d6992f3988c2c3$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    return element.animate({
        [valueName]: keyframes,
        offset: times
    }, {
        delay: delay,
        duration: duration,
        easing: (0, $2e4dc549f5b87e20$export$916ea73bcd3a6030)(ease),
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $bfa4b4f99ad894bb$var$sampleDelta = 10; //ms
function $bfa4b4f99ad894bb$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    let { keyframes: keyframes, duration: duration = 300, elapsed: elapsed = 0, ease: ease } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if (options.type === "spring" || !(0, $2e4dc549f5b87e20$export$fcdd8f3f2160beda)(options.ease)) {
        const sampleAnimation = (0, $1eaabe23cae0a8f9$export$e3607ec2d7a891c4)(options);
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        let t = 0;
        while(!state.done){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $bfa4b4f99ad894bb$var$sampleDelta;
        }
        keyframes = pregeneratedKeyframes;
        duration = t - $bfa4b4f99ad894bb$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $65d6992f3988c2c3$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        delay: -elapsed,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease
    });
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
    };
    /**
     * Animation interrupt callback.
     */ return ()=>{
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ const { currentTime: currentTime } = animation;
        if (currentTime) {
            const sampleAnimation = (0, $1eaabe23cae0a8f9$export$e3607ec2d7a891c4)(options);
            value.setWithVelocity(sampleAnimation.sample(currentTime - $bfa4b4f99ad894bb$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $bfa4b4f99ad894bb$var$sampleDelta);
        }
        (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(()=>animation.cancel());
    };
}



/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).read(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).read(checkElapsed, true);
    return ()=>(0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).read(checkElapsed);
}


function $0b4349754b713b18$export$6f34fc8ef6c42b70({ keyframes: keyframes, elapsed: elapsed, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        return ()=>{};
    };
    return elapsed ? (0, $fab50a206e6cc096$export$1391212d75b2ee65)(setValue, -elapsed) : setValue();
}






function $23fab257a8b45cd7$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    const origin = keyframes[0];
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function findNearestBoundary(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $1eaabe23cae0a8f9$export$e3607ec2d7a891c4)({
            keyframes: [
                0,
                1
            ],
            velocity: 0,
            ...options,
            driver: driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete,
            onStop: onStop
        });
    }
    function startSpring(options) {
        startAnimation({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta,
            ...options
        });
    }
    if (isOutOfBounds(origin)) // Start the animation with spring if outside the defined boundaries
    startSpring({
        velocity: velocity,
        keyframes: [
            origin,
            findNearestBoundary(origin)
        ]
    });
    else {
        /**
         * Or if the value is out of bounds, simulate the inertia movement
         * with the decay animation.
         *
         * Pre-calculate the target so we can detect if it's out-of-bounds.
         * If it is, we want to check per frame when to switch to a spring
         * animation
         */ let target = power * velocity + origin;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = findNearestBoundary(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(v - prev, (0, $b54248de5cdf5520$export$fff89137e9e818ce).delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                keyframes: [
                    v,
                    boundary
                ],
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            keyframes: [
                origin,
                0
            ],
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}


const $5f1d5ca1d398e82d$export$2577c2184b2254d3 = ()=>({
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$export$a743142a31c132c = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$export$c2d663fbb86d66d6 = ()=>({
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
const $5f1d5ca1d398e82d$var$defaultTransitions = {
    x: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    y: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    z: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotate: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateX: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateY: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateZ: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    scaleX: $5f1d5ca1d398e82d$export$a743142a31c132c,
    scaleY: $5f1d5ca1d398e82d$export$a743142a31c132c,
    scale: $5f1d5ca1d398e82d$export$a743142a31c132c,
    opacity: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    backgroundColor: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    color: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    default: $5f1d5ca1d398e82d$export$a743142a31c132c
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else {
        const factory = $5f1d5ca1d398e82d$var$defaultTransitions[valueKey] || $5f1d5ca1d398e82d$var$defaultTransitions.default;
        return factory(keyframes[1]);
    }
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ef4086713d7b0bdb$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ec9bae3b9c638c7a$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $ec9bae3b9c638c7a$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $ca0a3798777df465$export$cea0cedcb94873b5)("", potentialUnitType);
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}


function $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, target);
    let origin = transition.from !== undefined ? transition.from : value.get();
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(valueName, target);
    else if ((0, $ec9bae3b9c638c7a$export$c46ec7d82fb1f602)(origin) && typeof target === "string") origin = (0, $ec9bae3b9c638c7a$export$36cd6032f9de8a48)(target);
    else if (!Array.isArray(target) && (0, $ec9bae3b9c638c7a$export$c46ec7d82fb1f602)(target) && typeof origin === "string") target = (0, $ec9bae3b9c638c7a$export$36cd6032f9de8a48)(origin);
    /**
     * If the target has been defined as a series of keyframes
     */ if (Array.isArray(target)) {
        /**
         * Ensure an initial wildcard keyframe is hydrated by the origin.
         * TODO: Support extra wildcard keyframes i.e [1, null, 0]
         */ if (target[0] === null) target[0] = origin;
        return target;
    } else return [
        origin,
        target
    ];
}



const $2e784339013f8329$var$featureTests = {
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate")
};
const $2e784339013f8329$var$results = {};
const $2e784339013f8329$export$cde6a56f9669daf6 = {};
/**
 * Generate features tests that cache their results.
 */ for(const key in $2e784339013f8329$var$featureTests)$2e784339013f8329$export$cde6a56f9669daf6[key] = ()=>{
    if ($2e784339013f8329$var$results[key] === undefined) $2e784339013f8329$var$results[key] = $2e784339013f8329$var$featureTests[key]();
    return $2e784339013f8329$var$results[key];
};


/**
 * A list of values that can be hardware-accelerated.
 */ const $1e549d306124fdeb$var$acceleratedValues = new Set([
    "opacity"
]);
const $1e549d306124fdeb$export$208d7b28e5ce5514 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $4fd1ae9b00853f6f$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ...valueTransition,
            elapsed: elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $77818709e1bb6833$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $0b4349754b713b18$export$6f34fc8ef6c42b70)(options);
        else if (valueTransition.type === "inertia") {
            /**
             * If this is an inertia animation, we currently don't support pre-generating
             * keyframes for this as such it must always run on the main thread.
             */ const animation = (0, $23fab257a8b45cd7$export$ee3ff3a17106998)(options);
            return ()=>animation.stop();
        }
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        const visualElement = value.owner;
        const element = visualElement && visualElement.current;
        const canAccelerateAnimation = (0, $2e784339013f8329$export$cde6a56f9669daf6).waapi() && $1e549d306124fdeb$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && visualElement && element instanceof HTMLElement && !visualElement.getProps().onUpdate;
        if (canAccelerateAnimation) /**
             * If this animation is capable of being run via WAAPI, then do so.
             */ return (0, $bfa4b4f99ad894bb$export$4d5d9557ab897126)(value, valueName, options);
        else {
            /**
             * Otherwise, fall back to the main thread.
             */ const animation = (0, $1eaabe23cae0a8f9$export$e3607ec2d7a891c4)(options);
            return ()=>animation.stop();
        }
    };
};


function $66bcda5a48aeb596$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>$66bcda5a48aeb596$var$animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $66bcda5a48aeb596$var$animateVariant(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = $66bcda5a48aeb596$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}
function $66bcda5a48aeb596$var$animateVariant(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>$66bcda5a48aeb596$var$animateTarget(visualElement, resolved, options) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $66bcda5a48aeb596$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $66bcda5a48aeb596$var$animateTarget(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && ((_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.getState()[type]);
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $66bcda5a48aeb596$var$shouldBlockAnimation(animationTypeState, key)) continue;
        let valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */ if (visualElement.shouldReduceMotion && (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) valueTransition = {
            ...valueTransition,
            type: false,
            delay: 0
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (!value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
            if (appearId) valueTransition.elapsed = (0, $4f69af4939ee8d9a$export$470de7e050cf9631)(appearId, key);
        }
        let animation = value.start((0, $1e549d306124fdeb$export$208d7b28e5ce5514)(key, value, valueTarget, valueTransition));
        if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation = animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    return Promise.all(animations).then(()=>{
        transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
}
function $66bcda5a48aeb596$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($66bcda5a48aeb596$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($66bcda5a48aeb596$var$animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $66bcda5a48aeb596$export$3cc6f911ef1fd837(visualElement) {
    visualElement.values.forEach((value)=>value.stop());
}
function $66bcda5a48aeb596$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $66bcda5a48aeb596$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}





const $351ff45a987b08cc$export$16e45afcc206d3a8 = [
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Animate,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).InView,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Focus,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Hover,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Tap,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Drag,
    (0, $bc94049262afe059$export$2deb71ebd3734d23).Exit
];
const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...$351ff45a987b08cc$export$16e45afcc206d3a8
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = $351ff45a987b08cc$export$16e45afcc206d3a8.length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $66bcda5a48aeb596$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    const state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a35be4d5814e7c66$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        [(0, $bc94049262afe059$export$2deb71ebd3734d23).Animate]: $351ff45a987b08cc$var$createTypeState(true),
        [(0, $bc94049262afe059$export$2deb71ebd3734d23).InView]: $351ff45a987b08cc$var$createTypeState(),
        [(0, $bc94049262afe059$export$2deb71ebd3734d23).Hover]: $351ff45a987b08cc$var$createTypeState(),
        [(0, $bc94049262afe059$export$2deb71ebd3734d23).Tap]: $351ff45a987b08cc$var$createTypeState(),
        [(0, $bc94049262afe059$export$2deb71ebd3734d23).Drag]: $351ff45a987b08cc$var$createTypeState(),
        [(0, $bc94049262afe059$export$2deb71ebd3734d23).Focus]: $351ff45a987b08cc$var$createTypeState(),
        [(0, $bc94049262afe059$export$2deb71ebd3734d23).Exit]: $351ff45a987b08cc$var$createTypeState()
    };
}




const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)(({ visualElement: visualElement, animate: animate })=>{
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) (0, $acw62.useEffect)(()=>animate.subscribe(visualElement), [
            animate
        ]);
    }),
    exit: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((props)=>{
        const { custom: custom, visualElement: visualElement } = props;
        const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        (0, $acw62.useEffect)(()=>{
            visualElement.isPresent = isPresent;
            const animation = visualElement.animationState && visualElement.animationState.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Exit, !isPresent, {
                custom: presenceContext && presenceContext.custom || custom
            });
            if (animation && !isPresent) animation.then(safeToRemove);
        }, [
            isPresent
        ]);
    })
};



var $acw62 = parcelRequire("acw62");






const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $6af3e4ae1e03c8d7$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $6af3e4ae1e03c8d7$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $8eeaeb5692ba8175$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $b54248de5cdf5520$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $6af3e4ae1e03c8d7$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $6af3e4ae1e03c8d7$var$getPanInfo($6af3e4ae1e03c8d7$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        const initialInfo = $6af3e4ae1e03c8d7$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $b54248de5cdf5520$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $6af3e4ae1e03c8d7$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $21841eadb135946f$export$a4627e546088548d)((0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).update(this.updatePoint);
    }
}
function $6af3e4ae1e03c8d7$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $6af3e4ae1e03c8d7$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $6af3e4ae1e03c8d7$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $6af3e4ae1e03c8d7$var$subtractPoint(point, $6af3e4ae1e03c8d7$var$lastDevicePoint(history)),
        offset: $6af3e4ae1e03c8d7$var$subtractPoint(point, $6af3e4ae1e03c8d7$var$startDevicePoint(history)),
        velocity: $6af3e4ae1e03c8d7$var$getVelocity(history, 0.1)
    };
}
function $6af3e4ae1e03c8d7$var$startDevicePoint(history) {
    return history[0];
}
function $6af3e4ae1e03c8d7$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $6af3e4ae1e03c8d7$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $6af3e4ae1e03c8d7$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    const targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}



const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });


function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    var _a, _b;
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $d8332eb74969584e$var$snapToDefault(treeScale.x);
    treeScale.y = $d8332eb74969584e$var$snapToDefault(treeScale.y);
}
function $d8332eb74969584e$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d8332eb74969584e$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d8332eb74969584e$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform, $d8332eb74969584e$var$xKeys);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform, $d8332eb74969584e$var$yKeys);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ if (this.visualElement.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $df8cc4eab047d382$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                var _a, _b;
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(current)) {
                    const measuredAxis = (_b = (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.layoutBox[axis];
                    if (measuredAxis) {
                        const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                        current = length * (parseFloat(current) / 100);
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = this.visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Drag, true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $6af3e4ae1e03c8d7$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    }
    cancel() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) this.visualElement.projection.isAnimationBlocked = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $bc94049262afe059$export$2deb71ebd3734d23).Drag, false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = (constraints === null || constraints === void 0 ? void 0 : constraints[axis]) || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $1e549d306124fdeb$export$208d7b28e5ce5514)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        var _a;
        const dragKey = "_drag" + axis.toUpperCase();
        const externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, ((_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) || 0);
    }
    snapToCursor(point) {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        var _a;
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        var _a;
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $a3f7c96fbe45f23e$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $cba4f237926ffdf7$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 || stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}



/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $b89949ca91f83f6d$export$7941f8aafa4b6021(props) {
    const { dragControls: groupDragControls, visualElement: visualElement } = props;
    const dragControls = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(()=>new (0, $59924ee873defaad$export$86bff71f18910307)(visualElement));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $acw62.useEffect)(()=>groupDragControls && groupDragControls.subscribe(dragControls), [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, $acw62.useEffect)(()=>dragControls.addListeners(), [
        dragControls
    ]);
}



var $acw62 = parcelRequire("acw62");




/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $86a042f96484b9fd$export$eb0f62174cac1aec({ onPan: onPan, onPanStart: onPanStart, onPanEnd: onPanEnd, onPanSessionStart: onPanSessionStart, visualElement: visualElement }) {
    const hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    const panSession = (0, $acw62.useRef)(null);
    const { transformPagePoint: transformPagePoint } = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d));
    const handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: (event, info)=>{
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $6af3e4ae1e03c8d7$export$d9c66232c9c4689c)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $a3f7c96fbe45f23e$export$734d04395f5243cd)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(()=>panSession.current && panSession.current.end());
}



const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $86a042f96484b9fd$export$eb0f62174cac1aec)),
    drag: (0, $ff62e0eea2bbc1b2$export$46d1d6d046f826e4)((0, $b89949ca91f83f6d$export$7941f8aafa4b6021))
};











function $ac0e5a3978f40f61$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ac0e5a3978f40f61$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    const match = $ac0e5a3978f40f61$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$var$getVariableValue(current, element, depth = 1) {
    (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(depth <= $ac0e5a3978f40f61$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($ac0e5a3978f40f61$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ac0e5a3978f40f61$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ac0e5a3978f40f61$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!$ac0e5a3978f40f61$var$isCSSVariable(current)) return;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!$ac0e5a3978f40f61$var$isCSSVariable(current)) continue;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd && transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $a731b8aa4fe311d9$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
const $a731b8aa4fe311d9$var$isPositionalKey = (key)=>$a731b8aa4fe311d9$var$positionalKeys.has(key);
const $a731b8aa4fe311d9$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($a731b8aa4fe311d9$var$isPositionalKey);
};
const $a731b8aa4fe311d9$var$isNumOrPxType = (v)=>v === (0, $965bce4b5aab9d94$export$98e628dec113755e) || v === (0, $25ca921ba8e55794$export$91c0eda1d06bf008);
var $a731b8aa4fe311d9$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($a731b8aa4fe311d9$export$d0c75e4fa9e69db8 || ($a731b8aa4fe311d9$export$d0c75e4fa9e69db8 = {}));
const $a731b8aa4fe311d9$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a731b8aa4fe311d9$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $ac502869c4d3e65a$export$280dc01950909d86).filter((key)=>!$a731b8aa4fe311d9$var$transformKeys.has(key));
function $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
const $a731b8aa4fe311d9$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($a731b8aa4fe311d9$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]);
                (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)(toType === fromType || $a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $4fd1ae9b00853f6f$export$f5708dca728d7177)((0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $25ca921ba8e55794$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $a731b8aa4fe311d9$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $784730508f12f72c$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a731b8aa4fe311d9$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a731b8aa4fe311d9$var$hasPositionalKey(target) ? $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $d9a589b84d5ec1d1$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $ac0e5a3978f40f61$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $a731b8aa4fe311d9$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};





var $acw62 = parcelRequire("acw62");




// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};


function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = false;
}















function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $55c3387a92452647$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}




const $e66750f3fb0f96bb$var$featureNames = Object.keys((0, $a8d82256030e9525$export$65570e08d843624d));
const $e66750f3fb0f96bb$var$numFeatures = $e66750f3fb0f96bb$var$featureNames.length;
const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Tracks whether this VisualElement's React component is currently present
         * within the defined React tree.
         */ this.isPresent = true;
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $b4999b8a0b43adc6$export$92d6409d68f0739a).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $55c3387a92452647$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        var _a;
        this.current = instance;
        if (this.projection) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current) (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.setProps(this.props);
    }
    unmount() {
        var _a, _b, _c;
        (_a = this.projection) === null || _a === void 0 || _a.unmount();
        (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).update(this.notifyUpdate);
        (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).render(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        (_b = this.removeFromVariantTree) === null || _b === void 0 || _b.call(this);
        (_c = this.parent) === null || _c === void 0 || _c.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures(renderedProps, isStrict, preloadedFeatures, projectionId, ProjectionNodeConstructor, initialLayoutGroupConfig) {
        const features = [];
        for(let i = 0; i < $e66750f3fb0f96bb$var$numFeatures; i++){
            const name = $e66750f3fb0f96bb$var$featureNames[i];
            const { isEnabled: isEnabled, Component: Component } = (0, $a8d82256030e9525$export$65570e08d843624d)[name];
            /**
             * It might be possible in the future to use this moment to
             * dynamically request functionality. In initial tests this
             * was producing a lot of duplication amongst bundles.
             */ if (isEnabled(renderedProps) && Component) features.push((0, $acw62.createElement)(Component, {
                key: name,
                ...renderedProps,
                visualElement: this
            }));
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(projectionId, this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll
            });
        }
        return features;
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ setProps(props) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        const prevProps = this.props;
        this.props = props;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, prevProps), this.prevMotionValues);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        var _a;
        return (_a = this.props.variants) === null || _a === void 0 ? void 0 : _a[name];
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        var _a;
        return this.isVariantNode ? this : (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getClosestVariantNode();
    }
    getVariantContext(startAtParent = false) {
        var _a, _b;
        if (startAtParent) return (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getVariantContext();
        if (!this.isControllingVariants) {
            const context = ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.getVariantContext()) || {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e66750f3fb0f96bb$var$numVariantProps; i++){
            const name = $e66750f3fb0f96bb$var$variantProps[i];
            const prop = this.props[name];
            if ((0, $a35be4d5814e7c66$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        var _a;
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        var _a;
        this.values.delete(key);
        (_a = this.valueSubscriptions.get(key)) === null || _a === void 0 || _a();
        this.valueSubscriptions.delete(key);
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $e32104bb79321603$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $55c3387a92452647$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        var _a;
        (_a = this.events[eventName]) === null || _a === void 0 || _a.notify(...args);
    }
}
const $e66750f3fb0f96bb$var$variantProps = [
    "initial",
    ...(0, $351ff45a987b08cc$export$16e45afcc206d3a8)
];
const $e66750f3fb0f96bb$var$numVariantProps = $e66750f3fb0f96bb$var$variantProps.length;


class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $e66750f3fb0f96bb$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $ea04fe669600292a$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $ea04fe669600292a$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $d9a589b84d5ec1d1$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}


function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $f9c5e88311214d2a$export$451bc42768436155)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        var _a;
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) return ((_a = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $eac085b45c9e0925$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? new (0, $a0798b9f9973cb35$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $bce82b8bf0dbf6b7$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




var $acw62 = parcelRequire("acw62");





function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};





const $a42cd9e0ef50cb70$var$varToken = "_$css";
const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ const containsCSSVariables = latest.includes("var(");
        const cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $ac0e5a3978f40f61$export$f7c0a352d8ef6313), (match)=>{
            cssVariables.push(match);
            return $a42cd9e0ef50cb70$var$varToken;
        });
        const shadow = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        let output = template(shadow);
        if (containsCSSVariables) {
            let i = 0;
            output = output.replace($a42cd9e0ef50cb70$var$varToken, ()=>{
                const cssVariable = cssVariables[i];
                i++;
                return cssVariable;
            });
        }
        return output;
    }
};



class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $eced91e16bda42df$export$de9e7791c71225fd)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(()=>{
                var _a;
                if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove === null || safeToRemove === void 0 || safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $967b202c839557ef$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};


const $2cb9ab33756189ff$export$518df03f164c507 = {
    measureLayout: (0, $cdf2a2ac04e7ce67$export$779f5fb01ad751cd)
};






/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $1ef13963bb19565a$export$e3607ec2d7a891c4(from, to, transition = {}) {
    const value = (0, $55c3387a92452647$export$605d60a2578142d3)(from) ? from : (0, $e32104bb79321603$export$ce8bdc721e76545f)(from);
    value.start((0, $1e549d306124fdeb$export$208d7b28e5ce5514)("", value, to, transition));
    return {
        stop: ()=>value.stop(),
        isAnimating: ()=>value.isAnimating()
    };
}








const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $70c54e935a247717$export$2c9e8a9632a706b2)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(leadRadius) || (0, $25ca921ba8e55794$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $66a2361fd99a4040$export$c8d67a19199d1a50));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $448ce039afb5ec07$export$8793edee2d425525));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}





function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.x) / (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.y);
}



class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        var _a;
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 || _e.call(_d);
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(elementId, latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            this.isTransformDirty = false;
            /**
             * Flag to true if we think the projection calculations for this or any
             * child might need recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.elementId = elementId;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            elementId && this.root.registerPotentialNode(elementId, this);
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        registerPotentialNode(elementId, node) {
            this.potentialNodes.set(elementId, node);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = false) {
            var _a;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.elementId && this.root.potentialNodes.delete(this.elementId);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $fab50a206e6cc096$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                var _a, _b, _c, _d, _e;
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = (_b = (_a = this.options.transition) !== null && _a !== void 0 ? _a : visualElement.getDefaultTransition()) !== null && _b !== void 0 ? _b : $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_c = this.resumeFrom) === null || _c === void 0 ? void 0 : _c.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && this.animationProgress === 0) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    this.isLead() && ((_e = (_d = this.options).onExitComplete) === null || _e === void 0 || _e.call(_d));
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).preRender(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            var _a;
            return this.isAnimationBlocked || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach($d2ca41ba1b84bcfe$var$resetRotation);
            this.animationId++;
        }
        willUpdate(shouldNotifyListeners = true) {
            var _a, _b, _c;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        // Note: Currently only running on root node
        didUpdate() {
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($d2ca41ba1b84bcfe$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $b4999b8a0b43adc6$export$cd75ccfd720a3cd4).update();
            (0, $b4999b8a0b43adc6$export$cd75ccfd720a3cd4).preRender();
            (0, $b4999b8a0b43adc6$export$cd75ccfd720a3cd4).render();
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notify("LayoutMeasure", this.layout.layoutBox, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.layoutBox);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            var _a;
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            const transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            var _a;
            const boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layoutBox, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        /**
         *
         */ setTargetDelta(delta) {
            this.targetDelta = delta;
            this.isProjectionDirty = true;
            this.root.scheduleUpdateProjection();
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        /**
         * Frame calculations
         */ resolveTargetDelta() {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ if (!this.isProjectionDirty && !this.attemptToResolveRelativeTarget) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        calcProjection() {
            var _a;
            const { isProjectionDirty: isProjectionDirty, isTransformDirty: isTransformDirty } = this;
            this.isProjectionDirty = this.isTransformDirty = false;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            if (isProjectionDirty) canSkip = false;
            if (isShared && isTransformDirty) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            const { target: target } = lead;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            }
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a, _b, _c;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            var _a, _b;
            const snapshot = this.snapshot;
            const snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const isSharedLayoutAnimation = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.source) !== ((_a = this.layout) === null || _a === void 0 ? void 0 : _a.source);
            const isOnlyMember = (((_b = this.getStack()) === null || _b === void 0 ? void 0 : _b.members.length) || 0) <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = (latest)=>{
                var _a;
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        }
        startAnimation(options) {
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(()=>{
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $1ef13963bb19565a$export$e3607ec2d7a891c4)(0, $d2ca41ba1b84bcfe$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        var _a;
                        this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: ()=>{
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, $d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const xLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                const key = "rotate" + $d2ca41ba1b84bcfe$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b, _c;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_c = (_b = valuesToRender.opacity) !== null && _b !== void 0 ? _b : this.latestValues.opacity) !== null && _c !== void 0 ? _c : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key];
                const corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a, _b, _c;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        const layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) (_c = (_b = node.options).onExitComplete) === null || _c === void 0 || _c.call(_b);
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Propagate isProjectionDirty. Nodes are ordered by depth, so if the parent here
     * is dirty we can simply pass this forward.
     */ node.isProjectionDirty || (node.isProjectionDirty = Boolean(node.parent && node.parent.isProjectionDirty));
    /**
     * Propagate isTransformDirty.
     */ node.isTransformDirty || (node.isTransformDirty = Boolean(node.parent && node.parent.isTransformDirty));
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetRotation(node) {
    node.resetRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $d2ca41ba1b84bcfe$var$mountNodeEarly(node, elementId) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ let searchNode = node.root;
    for(let i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    const searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    const element = searchElement.querySelector(`[data-projection-id="${elementId}"]`);
    if (element) node.mount(element, true);
}
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $b352f7cdd42c49d7$export$28d0384c4b79bde2)((0, $b070f9c5f268d45c$export$c5706146bc63213)(snapshot), (0, $b070f9c5f268d45c$export$c5706146bc63213)(layout), 0.2);
}




const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $cba4f237926ffdf7$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $a93b6401f922fd1e$var$featureBundle = {
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2cb9ab33756189ff$export$518df03f164c507)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $16a09bb264d348bb$export$a28d6df673050e18)((Component, config)=>(0, $73e3a8d89278ed7b$export$732916c0e88175fb)(Component, config, $a93b6401f922fd1e$var$featureBundle, (0, $2f8881102ac6dde9$export$56ba0183203348f5), (0, $a3289660bde9b219$export$b61a9eb3dbde8858)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)((0, $73e3a8d89278ed7b$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$featureBundle, (0, $2f8881102ac6dde9$export$56ba0183203348f5), (0, $a3289660bde9b219$export$b61a9eb3dbde8858)));
}


// src/should-forward-prop.ts

var $66dca93801d8deae$var$allPropNames = /* @__PURE__ */ new Set([
    ...(0, $47a6d9fbbf7ee42d$export$332cc7004bcbb8b4),
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
]);
var $66dca93801d8deae$var$validHTMLProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
]);
function $66dca93801d8deae$export$3ba67b570e26eea0(prop) {
    return $66dca93801d8deae$var$validHTMLProps.has(prop) || !$66dca93801d8deae$var$allPropNames.has(prop);
}





// src/assign-after.ts
function $497654f4cc41b610$export$1ab078c80230a125(target, ...sources) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    const result = {
        ...target
    };
    for (const nextSource of sources){
        if (nextSource == null) continue;
        for(const nextKey in nextSource){
            if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
            if (nextKey in result) delete result[nextKey];
            result[nextKey] = nextSource[nextKey];
        }
    }
    return result;
}



parcelRequire("acw62");

var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$var$isPropValid = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = $bcd4e42ca4163639$var$isPropValid;




var $acw62 = parcelRequire("acw62");





var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $bcd4e42ca4163639$export$2e2bcd8739ae039);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $ea69b9ccc73b096b$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $acw62.useContext)((0, $ea69b9ccc73b096b$export$971d5caa766a69d7));
            }
            if (typeof props.className === "string") className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ (0, $acw62.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = $60e97af874e8cdaa$var$createStyled;






var $12ab803fa905d303$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $12ab803fa905d303$var$newStyled = (0, $60e97af874e8cdaa$export$2e2bcd8739ae039).bind();
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $12ab803fa905d303$var$newStyled[tagName] = $12ab803fa905d303$var$newStyled(tagName);
});
var $12ab803fa905d303$export$2e2bcd8739ae039 = $12ab803fa905d303$var$newStyled;



var $acw62 = parcelRequire("acw62");
var $c1cdd2de88fd2c3a$var$_a;
var $c1cdd2de88fd2c3a$var$emotion_styled = ($c1cdd2de88fd2c3a$var$_a = (0, $12ab803fa905d303$export$2e2bcd8739ae039).default) != null ? $c1cdd2de88fd2c3a$var$_a : (0, $12ab803fa905d303$export$2e2bcd8739ae039);
var $c1cdd2de88fd2c3a$export$9dba07f3d84163bb = ({ baseStyle: baseStyle })=>(props)=>{
        const { theme: theme, css: cssProp, __css: __css, sx: sx, ...rest } = props;
        const styleProps = (0, $8cabe7dbd312f1c1$export$3417cf6417437960)(rest, (_, prop)=>(0, $47a6d9fbbf7ee42d$export$95b76554d0cd12d6)(prop));
        const finalBaseStyle = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(baseStyle, props);
        const finalStyles = (0, $497654f4cc41b610$export$1ab078c80230a125)({}, __css, finalBaseStyle, (0, $8cabe7dbd312f1c1$export$2458ce75c8ef9806)(styleProps), sx);
        const computedCSS = (0, $47a6d9fbbf7ee42d$export$dbf350e5966cf602)(finalStyles)(props.theme);
        return cssProp ? [
            computedCSS,
            cssProp
        ] : computedCSS;
    };
function $c1cdd2de88fd2c3a$export$3817b7a54a07cec7(component, options) {
    const { baseStyle: baseStyle, ...styledOptions } = options != null ? options : {};
    if (!styledOptions.shouldForwardProp) styledOptions.shouldForwardProp = (0, $66dca93801d8deae$export$3ba67b570e26eea0);
    const styleObject = $c1cdd2de88fd2c3a$export$9dba07f3d84163bb({
        baseStyle: baseStyle
    });
    const Component = $c1cdd2de88fd2c3a$var$emotion_styled(component, styledOptions)(styleObject);
    const chakraComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ChakraComponent(props, ref) {
        const { colorMode: colorMode, forced: forced } = (0, $83ba09a61bdcb2b2$export$20f3076712c8dfa)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
            ref: ref,
            "data-theme": forced ? colorMode : void 0,
            ...props
        });
    });
    return chakraComponent;
}


// src/factory.ts
function $f1b95b1386d3a42c$var$factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy((0, $c1cdd2de88fd2c3a$export$3817b7a54a07cec7), {
        apply (target, thisArg, argArray) {
            return (0, $c1cdd2de88fd2c3a$export$3817b7a54a07cec7)(...argArray);
        },
        get (_, element) {
            if (!cache.has(element)) cache.set(element, (0, $c1cdd2de88fd2c3a$export$3817b7a54a07cec7)(element));
            return cache.get(element);
        }
    });
}
var $f1b95b1386d3a42c$export$7cd122d781af9fa4 = $f1b95b1386d3a42c$var$factory();



var $acw62 = parcelRequire("acw62");

var $9fac1487ebb38118$var$toastMotionVariants = {
    initial: (props)=>{
        const { position: position } = props;
        const dir = [
            "top",
            "bottom"
        ].includes(position) ? "y" : "x";
        let factor = [
            "top-right",
            "bottom-right"
        ].includes(position) ? 1 : -1;
        if (position === "bottom") factor = 1;
        return {
            opacity: 0,
            [dir]: factor * 24
        };
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                1,
                1
            ]
        }
    }
};
var $9fac1487ebb38118$export$8743ba3ef25f9582 = (0, $acw62.memo)((props)=>{
    const { id: id, message: message, onCloseComplete: onCloseComplete, onRequestRemove: onRequestRemove, requestClose: requestClose = false, position: position = "bottom", duration: duration = 5e3, containerStyle: containerStyle, motionVariants: motionVariants = $9fac1487ebb38118$var$toastMotionVariants, toastSpacing: toastSpacing = "0.5rem" } = props;
    const [delay, setDelay] = (0, $acw62.useState)(duration);
    const isPresent = (0, $bc77fac60b5d77cc$export$8249053f690ea39a)();
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!isPresent) onCloseComplete == null || onCloseComplete();
    }, [
        isPresent
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        setDelay(duration);
    }, [
        duration
    ]);
    const onMouseEnter = ()=>setDelay(null);
    const onMouseLeave = ()=>setDelay(duration);
    const close = ()=>{
        if (isPresent) onRequestRemove();
    };
    (0, $acw62.useEffect)(()=>{
        if (isPresent && requestClose) onRequestRemove();
    }, [
        isPresent,
        requestClose,
        onRequestRemove
    ]);
    (0, $3efd861ddab1b905$export$d8e6abf214c9ec0f)(close, delay);
    const containerStyles = (0, $acw62.useMemo)(()=>({
            pointerEvents: "auto",
            maxWidth: 560,
            minWidth: 300,
            margin: toastSpacing,
            ...containerStyle
        }), [
        containerStyle,
        toastSpacing
    ]);
    const toastStyle = (0, $acw62.useMemo)(()=>(0, $469966aa105099a2$export$27777812cc6d52de)(position), [
        position
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: {
            position: position
        },
        style: toastStyle,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: (0, $abe97432afb3d989$export$624e501d81f5ffce)(message, {
                id: id,
                onClose: close
            })
        })
    });
});
$9fac1487ebb38118$export$8743ba3ef25f9582.displayName = "ToastComponent";



// src/toast.placement.ts
function $7a1564152ad1d4ad$export$5b03f73d5fd4425(position, dir) {
    var _a;
    const computedPosition = position != null ? position : "bottom";
    const logicals = {
        "top-start": {
            ltr: "top-left",
            rtl: "top-right"
        },
        "top-end": {
            ltr: "top-right",
            rtl: "top-left"
        },
        "bottom-start": {
            ltr: "bottom-left",
            rtl: "bottom-right"
        },
        "bottom-end": {
            ltr: "bottom-right",
            rtl: "bottom-left"
        }
    };
    const logical = logicals[computedPosition];
    return (_a = logical == null ? void 0 : logical[dir]) != null ? _a : computedPosition;
}


// src/icons.tsx
// src/icon.tsx
// src/forward-ref.tsx

var $acw62 = parcelRequire("acw62");
function $ccbd86c9321ccea7$export$257a8862b851cb5b(component) {
    return (0, $acw62.forwardRef)(component);
}

// src/use-theme.ts


var $acw62 = parcelRequire("acw62");
function $dfd3c776139494e3$export$93d4e7f90805808f() {
    const theme = (0, $acw62.useContext)((0, $ea69b9ccc73b096b$export$971d5caa766a69d7));
    if (!theme) throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
    return theme;
}



function $fe369539e4cd5c80$export$a513a93efd9ab8a7() {
    const colorModeResult = (0, $83ba09a61bdcb2b2$export$20f3076712c8dfa)();
    const theme = (0, $dfd3c776139494e3$export$93d4e7f90805808f)();
    return {
        ...colorModeResult,
        theme: theme
    };
}
function $fe369539e4cd5c80$var$getBreakpointValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__breakpoints) == null ? void 0 : _a2.asArray) == null ? void 0 : _b2[val];
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $fe369539e4cd5c80$var$getTokenValue(theme, value, fallback) {
    var _a, _b;
    if (value == null) return value;
    const getValue = (val)=>{
        var _a2, _b2;
        return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.value;
    };
    return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function $fe369539e4cd5c80$export$31dcd79391e423fe(scale, token, fallback) {
    const theme = (0, $dfd3c776139494e3$export$93d4e7f90805808f)();
    return $fe369539e4cd5c80$export$257b2d10b709d8ef(scale, token, fallback)(theme);
}
function $fe369539e4cd5c80$export$257b2d10b709d8ef(scale, token, fallback) {
    const _token = Array.isArray(token) ? token : [
        token
    ];
    const _fallback = Array.isArray(fallback) ? fallback : [
        fallback
    ];
    return (theme)=>{
        const fallbackArr = _fallback.filter(Boolean);
        const result = _token.map((token2, index)=>{
            var _a, _b;
            if (scale === "breakpoints") return $fe369539e4cd5c80$var$getBreakpointValue(theme, token2, (_a = fallbackArr[index]) != null ? _a : token2);
            const path = `${scale}.${token2}`;
            return $fe369539e4cd5c80$var$getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
        });
        return Array.isArray(token) ? result : result[0];
    };
}



// src/extend-theme.ts


var $5Gn6I = parcelRequire("5Gn6I");
function $72e226b9ca0e0bbe$var$isFunction(value) {
    return typeof value === "function";
}
function $72e226b9ca0e0bbe$var$pipe(...fns) {
    return (v)=>fns.reduce((a, b)=>b(a), v);
}
var $72e226b9ca0e0bbe$var$createExtendTheme = (theme2)=>{
    return function extendTheme2(...extensions) {
        let overrides = [
            ...extensions
        ];
        let activeTheme = extensions[extensions.length - 1];
        if ((0, $8820d60240fe7ca4$export$73a6ae01926a4f0e)(activeTheme) && overrides.length > 1) overrides = overrides.slice(0, overrides.length - 1);
        else activeTheme = theme2;
        return $72e226b9ca0e0bbe$var$pipe(...overrides.map((extension)=>(prevTheme)=>$72e226b9ca0e0bbe$var$isFunction(extension) ? extension(prevTheme) : $72e226b9ca0e0bbe$export$c42236daa9a25fdd(prevTheme, extension)))(activeTheme);
    };
};
var $72e226b9ca0e0bbe$export$33a2b855d5b8731e = $72e226b9ca0e0bbe$var$createExtendTheme((0, $fecf4860da5314d0$export$bca14c5b3b88a9c9));
var $72e226b9ca0e0bbe$export$4c7add5200c9692a = $72e226b9ca0e0bbe$var$createExtendTheme((0, $fecf4860da5314d0$export$9e955aef208055a6));
function $72e226b9ca0e0bbe$export$c42236daa9a25fdd(...overrides) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, ...overrides, $72e226b9ca0e0bbe$var$mergeThemeCustomizer);
}
function $72e226b9ca0e0bbe$var$mergeThemeCustomizer(source, override, key, object) {
    if (($72e226b9ca0e0bbe$var$isFunction(source) || $72e226b9ca0e0bbe$var$isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) return (...args)=>{
        const sourceValue = $72e226b9ca0e0bbe$var$isFunction(source) ? source(...args) : source;
        const overrideValue = $72e226b9ca0e0bbe$var$isFunction(override) ? override(...args) : override;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({}, sourceValue, overrideValue, $72e226b9ca0e0bbe$var$mergeThemeCustomizer);
    };
    return void 0;
}



var $5Gn6I = parcelRequire("5Gn6I");

var $acw62 = parcelRequire("acw62");
var $77ddc6be16b1d7de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$77ddc6be16b1d7de$exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


function $77e83ee974fe0992$var$useStyleConfigImpl(themeKey, props = {}) {
    var _a;
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme: theme, colorMode: colorMode } = (0, $fe369539e4cd5c80$export$a513a93efd9ab8a7)();
    const themeStyleConfig = themeKey ? (0, $8cabe7dbd312f1c1$export$1bb32d0c65da6059)(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($5Gn6I)))({
        theme: theme,
        colorMode: colorMode
    }, (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {}, (0, $8cabe7dbd312f1c1$export$2458ce75c8ef9806)((0, $8cabe7dbd312f1c1$export$30a06c8d3562193f)(rest, [
        "children"
    ])));
    const stylesRef = (0, $acw62.useRef)({});
    if (styleConfig) {
        const getStyles = (0, $47a6d9fbbf7ee42d$export$f94106bbb00e81eb)(styleConfig);
        const styles = getStyles(mergedProps);
        const isStyleEqual = (0, (/*@__PURE__*/$parcel$interopDefault($77ddc6be16b1d7de$exports)))(stylesRef.current, styles);
        if (!isStyleEqual) stylesRef.current = styles;
    }
    return stylesRef.current;
}
function $77e83ee974fe0992$export$b863f77547fbcb03(themeKey, props = {}) {
    return $77e83ee974fe0992$var$useStyleConfigImpl(themeKey, props);
}
function $77e83ee974fe0992$export$31cdfe60c085d76f(themeKey, props = {}) {
    return $77e83ee974fe0992$var$useStyleConfigImpl(themeKey, props);
}
function $77e83ee974fe0992$export$d47b3683b351a542(themeKey, props) {
    var _a;
    const { baseConfig: baseConfig, ...restProps } = props;
    const { theme: theme } = (0, $fe369539e4cd5c80$export$a513a93efd9ab8a7)();
    const overrides = (_a = theme.components) == null ? void 0 : _a[themeKey];
    const styleConfig = overrides ? (0, $72e226b9ca0e0bbe$export$c42236daa9a25fdd)(overrides, baseConfig) : baseConfig;
    return $77e83ee974fe0992$var$useStyleConfigImpl(null, {
        ...restProps,
        styleConfig: styleConfig
    });
}




var $c7d8d08ac7551ab9$var$fallbackIcon = {
    path: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                strokeLinecap: "round",
                fill: "none",
                d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                strokeLinecap: "round",
                d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                fill: "none",
                strokeMiterlimit: "10",
                cx: "12",
                cy: "12",
                r: "11.25"
            })
        ]
    }),
    viewBox: "0 0 24 24"
};
var $c7d8d08ac7551ab9$export$f04a61298a47a40f = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { as: element, viewBox: viewBox, color: color = "currentColor", focusable: focusable = false, children: children, className: className, __css: __css, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-icon", className);
    const customStyles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Icon", props);
    const styles = {
        w: "1em",
        h: "1em",
        display: "inline-block",
        lineHeight: "1em",
        flexShrink: 0,
        color: color,
        ...__css,
        ...customStyles
    };
    const shared = {
        ref: ref,
        focusable: focusable,
        className: _className,
        __css: styles
    };
    const _viewBox = viewBox != null ? viewBox : $c7d8d08ac7551ab9$var$fallbackIcon.viewBox;
    if (element && typeof element !== "string") return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).svg, {
        as: element,
        ...shared,
        ...rest
    });
    const _path = children != null ? children : $c7d8d08ac7551ab9$var$fallbackIcon.path;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).svg, {
        verticalAlign: "middle",
        viewBox: _viewBox,
        ...shared,
        ...rest,
        children: _path
    });
});
$c7d8d08ac7551ab9$export$f04a61298a47a40f.displayName = "Icon";
var $c7d8d08ac7551ab9$export$21036209a317fcec = $c7d8d08ac7551ab9$export$f04a61298a47a40f;



function $4afb0a06ec076976$export$7dd004358974b05d(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c7d8d08ac7551ab9$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
        })
    });
}
function $4afb0a06ec076976$export$2957fc44b3d2481(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c7d8d08ac7551ab9$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
        })
    });
}
function $4afb0a06ec076976$export$f7dc499a72baa103(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c7d8d08ac7551ab9$export$f04a61298a47a40f), {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
}



// src/spinner.tsx



var $2abf42c373b7af6c$var$spin = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $2abf42c373b7af6c$export$7f7cbe89f1eacd2 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Spinner", props);
    const { label: label = "Loading...", thickness: thickness = "2px", speed: speed = "0.45s", emptyColor: emptyColor = "transparent", className: className, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-spinner", className);
    const spinnerStyles = {
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: thickness,
        borderBottomColor: emptyColor,
        borderLeftColor: emptyColor,
        animation: `${$2abf42c373b7af6c$var$spin} ${speed} linear infinite`,
        ...styles
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
            srOnly: true,
            children: label
        })
    });
});
$2abf42c373b7af6c$export$7f7cbe89f1eacd2.displayName = "Spinner";


var [$d546901816eddb3a$export$a7901f7b4cce70b0, $d546901816eddb3a$export$50b520f08832063d] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
});
var [$d546901816eddb3a$export$17cf5063e294f385, $d546901816eddb3a$export$167ececdbea67592] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
});
var $d546901816eddb3a$var$STATUSES = {
    info: {
        icon: (0, $4afb0a06ec076976$export$2957fc44b3d2481),
        colorScheme: "blue"
    },
    warning: {
        icon: (0, $4afb0a06ec076976$export$f7dc499a72baa103),
        colorScheme: "orange"
    },
    success: {
        icon: (0, $4afb0a06ec076976$export$7dd004358974b05d),
        colorScheme: "green"
    },
    error: {
        icon: (0, $4afb0a06ec076976$export$f7dc499a72baa103),
        colorScheme: "red"
    },
    loading: {
        icon: (0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2),
        colorScheme: "blue"
    }
};
function $d546901816eddb3a$export$8df8f66d0469c54d(status) {
    return $d546901816eddb3a$var$STATUSES[status].colorScheme;
}
function $d546901816eddb3a$export$c742923ea4ac4c1c(status) {
    return $d546901816eddb3a$var$STATUSES[status].icon;
}





var $0f429e331c7b6f4b$export$caec2af78bcc877f = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Alert2(props, ref) {
    var _a;
    const { status: status = "info", addRole: addRole = true, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const colorScheme = (_a = props.colorScheme) != null ? _a : (0, $d546901816eddb3a$export$8df8f66d0469c54d)(status);
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Alert", {
        ...props,
        colorScheme: colorScheme
    });
    const alertStyles = {
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
        ...styles.container
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d546901816eddb3a$export$a7901f7b4cce70b0), {
        value: {
            status: status
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d546901816eddb3a$export$17cf5063e294f385), {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
                "data-status": status,
                role: addRole ? "alert" : void 0,
                ref: ref,
                ...rest,
                className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert", props.className),
                __css: alertStyles
            })
        })
    });
});
$0f429e331c7b6f4b$export$caec2af78bcc877f.displayName = "Alert";





var $a85737e2eeda27d8$export$d4feae172fccda11 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function AlertDescription2(props, ref) {
    const styles = (0, $d546901816eddb3a$export$167ececdbea67592)();
    const { status: status } = (0, $d546901816eddb3a$export$50b520f08832063d)();
    const descriptionStyles = {
        display: "inline",
        ...styles.description
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__desc", props.className),
        __css: descriptionStyles
    });
});
$a85737e2eeda27d8$export$d4feae172fccda11.displayName = "AlertDescription";





function $92200e681b16e3f1$export$4a143c8822a09fb4(props) {
    const { status: status } = (0, $d546901816eddb3a$export$50b520f08832063d)();
    const BaseIcon = (0, $d546901816eddb3a$export$c742923ea4ac4c1c)(status);
    const styles = (0, $d546901816eddb3a$export$167ececdbea67592)();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
        display: "inherit",
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(BaseIcon, {
            h: "100%",
            w: "100%"
        })
    });
}
$92200e681b16e3f1$export$4a143c8822a09fb4.displayName = "AlertIcon";





var $c6d73ec69e2f5e43$export$4a7253439a300753 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function AlertTitle2(props, ref) {
    const styles = (0, $d546901816eddb3a$export$167ececdbea67592)();
    const { status: status } = (0, $d546901816eddb3a$export$50b520f08832063d)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        "data-status": status,
        ...props,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-alert__title", props.className),
        __css: styles.title
    });
});
$c6d73ec69e2f5e43$export$4a7253439a300753.displayName = "AlertTitle";



// src/close-button.tsx



function $3563aea4a86523bd$var$CloseIcon(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c7d8d08ac7551ab9$export$f04a61298a47a40f), {
        focusable: "false",
        "aria-hidden": true,
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
        })
    });
}
var $3563aea4a86523bd$export$de65de8213222d10 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function CloseButton2(props, ref) {
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("CloseButton", props);
    const { children: children, isDisabled: isDisabled, __css: __css, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).button, {
        type: "button",
        "aria-label": "Close",
        ref: ref,
        disabled: isDisabled,
        __css: {
            ...baseStyle,
            ...styles,
            ...__css
        },
        ...rest,
        children: children || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3563aea4a86523bd$var$CloseIcon, {
            width: "1em",
            height: "1em"
        })
    });
});
$3563aea4a86523bd$export$de65de8213222d10.displayName = "CloseButton";




// src/toast.store.ts
var $eb1addcd21d45ee8$var$initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
};
var $eb1addcd21d45ee8$export$e80fa18a42ed98ef = $eb1addcd21d45ee8$var$createStore($eb1addcd21d45ee8$var$initialState);
function $eb1addcd21d45ee8$var$createStore(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn)=>{
        state = setStateFn(state);
        listeners.forEach((l)=>l());
    };
    return {
        getState: ()=>state,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                setState(()=>initialState2);
                listeners.delete(listener);
            };
        },
        removeToast: (id, position)=>{
            setState((prevState)=>({
                    ...prevState,
                    [position]: prevState[position].filter((toast)=>toast.id != id)
                }));
        },
        notify: (message, options)=>{
            const toast = $eb1addcd21d45ee8$var$createToast(message, options);
            const { position: position, id: id } = toast;
            setState((prevToasts)=>{
                var _a, _b;
                const isTop = position.includes("top");
                const toasts = isTop ? [
                    toast,
                    ...(_a = prevToasts[position]) != null ? _a : []
                ] : [
                    ...(_b = prevToasts[position]) != null ? _b : [],
                    toast
                ];
                return {
                    ...prevToasts,
                    [position]: toasts
                };
            });
            return id;
        },
        update: (id, options)=>{
            if (!id) return;
            setState((prevState)=>{
                const nextState = {
                    ...prevState
                };
                const { position: position, index: index } = (0, $469966aa105099a2$export$67080b9d5f0a62ea)(nextState, id);
                if (position && index !== -1) nextState[position][index] = {
                    ...nextState[position][index],
                    ...options,
                    message: $eb1addcd21d45ee8$export$d9d796c483697359(options)
                };
                return nextState;
            });
        },
        closeAll: ({ positions: positions } = {})=>{
            setState((prev)=>{
                const allPositions = [
                    "bottom",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "top-left",
                    "top-right"
                ];
                const positionsToClose = positions != null ? positions : allPositions;
                return positionsToClose.reduce((acc, position)=>{
                    acc[position] = prev[position].map((toast)=>({
                            ...toast,
                            requestClose: true
                        }));
                    return acc;
                }, {
                    ...prev
                });
            });
        },
        close: (id)=>{
            setState((prevState)=>{
                const position = (0, $469966aa105099a2$export$500f52ac46324ec6)(prevState, id);
                if (!position) return prevState;
                return {
                    ...prevState,
                    [position]: prevState[position].map((toast)=>{
                        if (toast.id == id) return {
                            ...toast,
                            requestClose: true
                        };
                        return toast;
                    })
                };
            });
        },
        isActive: (id)=>Boolean((0, $469966aa105099a2$export$67080b9d5f0a62ea)($eb1addcd21d45ee8$export$e80fa18a42ed98ef.getState(), id).position)
    };
}
var $eb1addcd21d45ee8$var$counter = 0;
function $eb1addcd21d45ee8$var$createToast(message, options = {}) {
    var _a, _b;
    $eb1addcd21d45ee8$var$counter += 1;
    const id = (_a = options.id) != null ? _a : $eb1addcd21d45ee8$var$counter;
    const position = (_b = options.position) != null ? _b : "bottom";
    return {
        id: id,
        message: message,
        position: position,
        duration: options.duration,
        onCloseComplete: options.onCloseComplete,
        onRequestRemove: ()=>$eb1addcd21d45ee8$export$e80fa18a42ed98ef.removeToast(String(id), position),
        status: options.status,
        requestClose: false,
        containerStyle: options.containerStyle
    };
}
var $eb1addcd21d45ee8$export$8d8dc7d5f743331b = (props)=>{
    const { status: status, variant: variant = "solid", id: id, title: title, isClosable: isClosable, onClose: onClose, description: description, colorScheme: colorScheme, icon: icon } = props;
    const ids = id ? {
        root: `toast-${id}`,
        title: `toast-${id}-title`,
        description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $0f429e331c7b6f4b$export$caec2af78bcc877f), {
        addRole: false,
        status: status,
        variant: variant,
        id: ids == null ? void 0 : ids.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme: colorScheme,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $92200e681b16e3f1$export$4a143c8822a09fb4), {
                children: icon
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
                flex: "1",
                maxWidth: "100%",
                children: [
                    title && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c6d73ec69e2f5e43$export$4a7253439a300753), {
                        id: ids == null ? void 0 : ids.title,
                        children: title
                    }),
                    description && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a85737e2eeda27d8$export$d4feae172fccda11), {
                        id: ids == null ? void 0 : ids.description,
                        display: "block",
                        children: description
                    })
                ]
            }),
            isClosable && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3563aea4a86523bd$export$de65de8213222d10), {
                size: "sm",
                onClick: onClose,
                position: "absolute",
                insetEnd: 1,
                top: 1
            })
        ]
    });
};
function $eb1addcd21d45ee8$export$d9d796c483697359(options = {}) {
    const { render: render, toastComponent: ToastComponent = $eb1addcd21d45ee8$export$8d8dc7d5f743331b } = options;
    const renderToast = (props)=>{
        if (typeof render === "function") return render({
            ...props,
            ...options
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ToastComponent, {
            ...props,
            ...options
        });
    };
    return renderToast;
}
function $eb1addcd21d45ee8$export$f3af62d19eb14261(dir, defaultOptions) {
    const normalizeToastOptions = (options)=>{
        var _a;
        return {
            ...defaultOptions,
            ...options,
            position: (0, $7a1564152ad1d4ad$export$5b03f73d5fd4425)((_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position, dir)
        };
    };
    const toast = (options)=>{
        const normalizedToastOptions = normalizeToastOptions(options);
        const Message = $eb1addcd21d45ee8$export$d9d796c483697359(normalizedToastOptions);
        return $eb1addcd21d45ee8$export$e80fa18a42ed98ef.notify(Message, normalizedToastOptions);
    };
    toast.update = (id, options)=>{
        $eb1addcd21d45ee8$export$e80fa18a42ed98ef.update(id, normalizeToastOptions(options));
    };
    toast.promise = (promise, options)=>{
        const id = toast({
            ...options.loading,
            status: "loading",
            duration: null
        });
        promise.then((data)=>toast.update(id, {
                status: "success",
                duration: 5e3,
                ...(0, $abe97432afb3d989$export$624e501d81f5ffce)(options.success, data)
            })).catch((error)=>toast.update(id, {
                status: "error",
                duration: 5e3,
                ...(0, $abe97432afb3d989$export$624e501d81f5ffce)(options.error, error)
            }));
    };
    toast.closeAll = $eb1addcd21d45ee8$export$e80fa18a42ed98ef.closeAll;
    toast.close = $eb1addcd21d45ee8$export$e80fa18a42ed98ef.close;
    toast.isActive = $eb1addcd21d45ee8$export$e80fa18a42ed98ef.isActive;
    return toast;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $acw62.createElement($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $acw62.cloneElement(children, {
        ref: ref
    }));
}


const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $acw62.createElement((0, $6f8c626e496e1918$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $acw62.createElement((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}






const $06516233abcfeeff$var$getChildKey = (child)=>child.key || "";
function $06516233abcfeeff$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $06516233abcfeeff$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $06516233abcfeeff$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    // Support deprecated exitBeforeEnter prop
    if (exitBeforeEnter) mode = "wait";
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    let [forceRender] = (0, $0316e1262c81ebb4$export$91db9bc4f8ac944a)();
    const forceRenderLayoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).forceRender;
    if (forceRenderLayoutGroup) forceRender = forceRenderLayoutGroup;
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $06516233abcfeeff$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $acw62.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $acw62.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $acw62.useRef)(true);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $06516233abcfeeff$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) return $acw62.createElement($acw62.Fragment, null, childrenToRender.map((child)=>$acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($06516233abcfeeff$var$getChildKey);
    const targetKeys = filteredChildren.map($06516233abcfeeff$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach((key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        const onExit = ()=>{
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exiting.has(key) ? child : $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $acw62.createElement($acw62.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map((child)=>(0, $acw62.cloneElement)(child)));
};







var $acw62 = parcelRequire("acw62");

var [$7dccfa70b276af4f$var$PortalContextProvider, $7dccfa70b276af4f$var$usePortalContext] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "PortalContext"
});
var $7dccfa70b276af4f$var$PORTAL_CLASSNAME = "chakra-portal";
var $7dccfa70b276af4f$var$PORTAL_SELECTOR = `.chakra-portal`;
var $7dccfa70b276af4f$var$Container = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "chakra-portal-zIndex",
        style: {
            position: "absolute",
            zIndex: props.zIndex,
            top: 0,
            left: 0,
            right: 0
        },
        children: props.children
    });
var $7dccfa70b276af4f$var$DefaultPortal = (props)=>{
    const { appendToParentPortal: appendToParentPortal, children: children } = props;
    const [tempNode, setTempNode] = (0, $acw62.useState)(null);
    const portal = (0, $acw62.useRef)(null);
    const [, forceUpdate] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>forceUpdate({}), []);
    const parentPortal = $7dccfa70b276af4f$var$usePortalContext();
    const manager = (0, $f0ef0206ab9ab709$export$ef203b29c2cc1f5d)();
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!tempNode) return;
        const doc = tempNode.ownerDocument;
        const host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
        if (!host) return;
        portal.current = doc.createElement("div");
        portal.current.className = $7dccfa70b276af4f$var$PORTAL_CLASSNAME;
        host.appendChild(portal.current);
        forceUpdate({});
        const portalNode = portal.current;
        return ()=>{
            if (host.contains(portalNode)) host.removeChild(portalNode);
        };
    }, [
        tempNode
    ]);
    const _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($7dccfa70b276af4f$var$Container, {
        zIndex: manager == null ? void 0 : manager.zIndex,
        children: children
    }) : children;
    return portal.current ? (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($7dccfa70b276af4f$var$PortalContextProvider, {
        value: portal.current,
        children: _children
    }), portal.current) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        ref: (el)=>{
            if (el) setTempNode(el);
        }
    });
};
var $7dccfa70b276af4f$var$ContainerPortal = (props)=>{
    const { children: children, containerRef: containerRef, appendToParentPortal: appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
    const portal = (0, $acw62.useMemo)(()=>{
        const node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
        if (node) node.className = $7dccfa70b276af4f$var$PORTAL_CLASSNAME;
        return node;
    }, [
        containerEl
    ]);
    const [, forceUpdate] = (0, $acw62.useState)({});
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>forceUpdate({}), []);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!portal || !host) return;
        host.appendChild(portal);
        return ()=>{
            host.removeChild(portal);
        };
    }, [
        portal,
        host
    ]);
    if (host && portal) return (0, $11492dca620dcaa5$exports.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($7dccfa70b276af4f$var$PortalContextProvider, {
        value: appendToParentPortal ? portal : null,
        children: children
    }), portal);
    return null;
};
function $7dccfa70b276af4f$export$602eac185826482c(props) {
    const portalProps = {
        appendToParentPortal: true,
        ...props
    };
    const { containerRef: containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($7dccfa70b276af4f$var$ContainerPortal, {
        containerRef: containerRef,
        ...rest
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($7dccfa70b276af4f$var$DefaultPortal, {
        ...rest
    });
}
$7dccfa70b276af4f$export$602eac185826482c.className = $7dccfa70b276af4f$var$PORTAL_CLASSNAME;
$7dccfa70b276af4f$export$602eac185826482c.selector = $7dccfa70b276af4f$var$PORTAL_SELECTOR;
$7dccfa70b276af4f$export$602eac185826482c.displayName = "Portal";



var $acw62 = parcelRequire("acw62");


var [$bec5422162fb9c65$export$cfcc07abbe2e36a8, $bec5422162fb9c65$export$7c4af276256dc908] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `ToastOptionsContext`,
    strict: false
});
var $bec5422162fb9c65$export$f5d03d415824e0e = (props)=>{
    const state = (0, $acw62.useSyncExternalStore)((0, $eb1addcd21d45ee8$export$e80fa18a42ed98ef).subscribe, (0, $eb1addcd21d45ee8$export$e80fa18a42ed98ef).getState, (0, $eb1addcd21d45ee8$export$e80fa18a42ed98ef).getState);
    const { motionVariants: motionVariants, component: Component = (0, $9fac1487ebb38118$export$8743ba3ef25f9582), portalProps: portalProps } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position)=>{
        const toasts = state[position];
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "region",
            "aria-live": "polite",
            id: `chakra-toast-manager-${position}`,
            style: (0, $469966aa105099a2$export$55dd410e8ef136e0)(position),
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                initial: false,
                children: toasts.map((toast)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Component, {
                        motionVariants: motionVariants,
                        ...toast
                    }, toast.id))
            })
        }, position);
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7dccfa70b276af4f$export$602eac185826482c), {
        ...portalProps,
        children: toastList
    });
};



var $27b686752740163d$var$createChakraProvider = (providerTheme)=>{
    return function ChakraProvider2({ children: children, theme: theme = providerTheme, toastOptions: toastOptions, ...restProps }) {
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $cc3b3e46667e9fbd$export$80dbe0482bcbd25a), {
            theme: theme,
            ...restProps,
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $bec5422162fb9c65$export$cfcc07abbe2e36a8), {
                    value: toastOptions == null ? void 0 : toastOptions.defaultOptions,
                    children: children
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $bec5422162fb9c65$export$f5d03d415824e0e), {
                    ...toastOptions
                })
            ]
        });
    };
};
var $27b686752740163d$export$80dbe0482bcbd25a = $27b686752740163d$var$createChakraProvider((0, $fecf4860da5314d0$export$bca14c5b3b88a9c9));
var $27b686752740163d$export$39d642dd5c97e94c = $27b686752740163d$var$createChakraProvider((0, $fecf4860da5314d0$export$9e955aef208055a6));


function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}


function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}




function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}




function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(self);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}



function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $7d110e739ae14cc6$export$2e2bcd8739ae039(arr) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $673ff3dfc4a496de$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $673ff3dfc4a496de$var$ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $673ff3dfc4a496de$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $673ff3dfc4a496de$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $673ff3dfc4a496de$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $673ff3dfc4a496de$var$_objectSpread$6($673ff3dfc4a496de$var$_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
var $673ff3dfc4a496de$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $673ff3dfc4a496de$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    var _getLastOfPath = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    var _getLastOfPath3 = $673ff3dfc4a496de$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    var value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $673ff3dfc4a496de$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $673ff3dfc4a496de$var$_entityMap[s];
    });
    return data;
}
var $673ff3dfc4a496de$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $673ff3dfc4a496de$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $673ff3dfc4a496de$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $673ff3dfc4a496de$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $673ff3dfc4a496de$var$ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $673ff3dfc4a496de$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $673ff3dfc4a496de$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
var $673ff3dfc4a496de$var$ResourceStore = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $673ff3dfc4a496de$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $673ff3dfc4a496de$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
                if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
                else pack = $673ff3dfc4a496de$var$_objectSpread$5($673ff3dfc4a496de$var$_objectSpread$5({}, pack), resources);
                $673ff3dfc4a496de$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $673ff3dfc4a496de$var$_objectSpread$5($673ff3dfc4a496de$var$_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($673ff3dfc4a496de$var$EventEmitter);
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $673ff3dfc4a496de$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $673ff3dfc4a496de$var$ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $673ff3dfc4a496de$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $673ff3dfc4a496de$var$checkedLoadedFor = {};
var $673ff3dfc4a496de$var$Translator = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Translator);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        $673ff3dfc4a496de$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create("translator");
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) {
                            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
                            return resolved;
                        }
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) {
                        resolved.res = key;
                        return resolved;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, options), {
                        interpolation: $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $673ff3dfc4a496de$var$_objectSpread$4($673ff3dfc4a496de$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $673ff3dfc4a496de$var$_objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $673ff3dfc4a496de$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $673ff3dfc4a496de$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("languageUtils");
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $673ff3dfc4a496de$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $673ff3dfc4a496de$var$createRules() {
    var rules = {};
    $673ff3dfc4a496de$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $673ff3dfc4a496de$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$673ff3dfc4a496de$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $673ff3dfc4a496de$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $673ff3dfc4a496de$var$ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $673ff3dfc4a496de$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $673ff3dfc4a496de$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $673ff3dfc4a496de$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, k), f, lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && options.hasOwnProperty(matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = $673ff3dfc4a496de$var$_objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $673ff3dfc4a496de$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $673ff3dfc4a496de$var$_objectSpread$3($673ff3dfc4a496de$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $673ff3dfc4a496de$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $673ff3dfc4a496de$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $673ff3dfc4a496de$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $7d110e739ae14cc6$export$2e2bcd8739ae039)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $673ff3dfc4a496de$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $673ff3dfc4a496de$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Formatter);
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, options);
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.NumberFormat(lng, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, options), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.DateTimeFormat(lng, $673ff3dfc4a496de$var$_objectSpread$2({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.RelativeTimeFormat(lng, $673ff3dfc4a496de$var$_objectSpread$2({}, options));
                return function(val) {
                    return formatter.format(val, options.range || "day");
                };
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter(function(lng, options) {
                var formatter = new Intl.ListFormat(lng, $673ff3dfc4a496de$var$_objectSpread$2({}, options));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng, options) {
                var _this = this;
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $673ff3dfc4a496de$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2($673ff3dfc4a496de$var$_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $673ff3dfc4a496de$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $673ff3dfc4a496de$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $673ff3dfc4a496de$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $673ff3dfc4a496de$var$Connector = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Connector);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $673ff3dfc4a496de$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $673ff3dfc4a496de$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $673ff3dfc4a496de$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(ns) {
                                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = $673ff3dfc4a496de$var$_objectSpread$1($673ff3dfc4a496de$var$_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($673ff3dfc4a496de$var$EventEmitter);
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[2]) === "object" || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $673ff3dfc4a496de$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $673ff3dfc4a496de$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $673ff3dfc4a496de$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $673ff3dfc4a496de$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $673ff3dfc4a496de$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $673ff3dfc4a496de$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $673ff3dfc4a496de$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $673ff3dfc4a496de$var$noop() {}
function $673ff3dfc4a496de$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $673ff3dfc4a496de$var$I18n = function(_EventEmitter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    var _super = $673ff3dfc4a496de$var$_createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, I18n);
        _this = _super.call(this);
        if ($673ff3dfc4a496de$var$isIE10) $673ff3dfc4a496de$var$EventEmitter.call((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        _this.options = $673ff3dfc4a496de$var$transformOptions(options);
        _this.services = {};
        _this.logger = $673ff3dfc4a496de$var$baseLogger;
        _this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(_this, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $673ff3dfc4a496de$var$get();
                this.options = $673ff3dfc4a496de$var$_objectSpread($673ff3dfc4a496de$var$_objectSpread($673ff3dfc4a496de$var$_objectSpread({}, defOpts), this.options), $673ff3dfc4a496de$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $673ff3dfc4a496de$var$_objectSpread($673ff3dfc4a496de$var$_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $673ff3dfc4a496de$var$Formatter;
                    var lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
                    this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $673ff3dfc4a496de$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $673ff3dfc4a496de$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $673ff3dfc4a496de$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $673ff3dfc4a496de$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $673ff3dfc4a496de$var$_objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $673ff3dfc4a496de$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $673ff3dfc4a496de$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
                var mergedOptions = $673ff3dfc4a496de$var$_objectSpread($673ff3dfc4a496de$var$_objectSpread($673ff3dfc4a496de$var$_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $673ff3dfc4a496de$var$_objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($673ff3dfc4a496de$var$EventEmitter);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($673ff3dfc4a496de$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $673ff3dfc4a496de$var$I18n(options, callback);
});
var $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
var $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
var $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
var $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
var $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
var $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
var $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
var $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
var $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
var $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
var $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
var $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
var $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
var $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
var $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(obj);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$_toPrimitive(input, hint) {
    if ($b77c8068776c2a21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b77c8068776c2a21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$_toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$_toPropertyKey(arg) {
    var key = $b77c8068776c2a21$exports(arg, "string");
    return $010f4e0e13c82e16$var$_typeof(key) === "symbol" ? key : String(key);
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$_toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $010f4e0e13c82e16$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;


var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bc9a7bbcf9a2a3b$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


function $cfb6e0167e0b350d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $cfb6e0167e0b350d$var$alreadyWarned = {};
function $cfb6e0167e0b350d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $cfb6e0167e0b350d$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $cfb6e0167e0b350d$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}



var $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $d7f2d92b0368699f$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $d7f2d92b0368699f$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $d7f2d92b0368699f$var$htmlEntities[m];
};
var $d7f2d92b0368699f$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);
};


function $4f75eea5b29ffc65$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f75eea5b29ffc65$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4f75eea5b29ffc65$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4f75eea5b29ffc65$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $d7f2d92b0368699f$export$e8bacd2802a88316)
};
function $4f75eea5b29ffc65$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $4f75eea5b29ffc65$var$defaultOptions = $4f75eea5b29ffc65$var$_objectSpread($4f75eea5b29ffc65$var$_objectSpread({}, $4f75eea5b29ffc65$var$defaultOptions), options);
}
function $4f75eea5b29ffc65$export$212bb2fc580a90a8() {
    return $4f75eea5b29ffc65$var$defaultOptions;
}


var $1d04edb3ddd0d89e$var$i18nInstance;
function $1d04edb3ddd0d89e$export$a039134f2fc7e0(instance) {
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
}
function $1d04edb3ddd0d89e$export$64af334f494c2f47() {
    return $1d04edb3ddd0d89e$var$i18nInstance;
}


var $acffcb171536f8e9$var$_excluded = [
    "format"
], $acffcb171536f8e9$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $acffcb171536f8e9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $acffcb171536f8e9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $acffcb171536f8e9$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $acffcb171536f8e9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $acffcb171536f8e9$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $acffcb171536f8e9$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $acffcb171536f8e9$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $acw62.isValidElement)(child);
    });
}
function $acffcb171536f8e9$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $acffcb171536f8e9$var$mergeProps(source, target) {
    var newTarget = $acffcb171536f8e9$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $acffcb171536f8e9$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $acw62.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(child) === "object") {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(child, $acffcb171536f8e9$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $acffcb171536f8e9$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(child) === "object" && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $acffcb171536f8e9$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $acw62.cloneElement)(child, $acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        var astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $acw62.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $acw62.cloneElement)(child, $acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($2ef66ab8c52ac1c0$exports)))(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $acw62.cloneElement)(child, $acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $acw62.cloneElement)(child, $acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
}
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $acffcb171536f8e9$var$_excluded2);
    var i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread({}, (0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread($acffcb171536f8e9$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $acffcb171536f8e9$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};

function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $010f4e0e13c82e16$exports(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;



var $acw62 = parcelRequire("acw62");




var $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


function $0636c84fe4549f1f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0636c84fe4549f1f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0636c84fe4549f1f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0636c84fe4549f1f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
var $0636c84fe4549f1f$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $0636c84fe4549f1f$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($0636c84fe4549f1f$var$_objectSpread($0636c84fe4549f1f$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $0636c84fe4549f1f$export$704200e5d0b9e8f() {
    var i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $e04d9533328ca578$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $e04d9533328ca578$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e04d9533328ca578$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e04d9533328ca578$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e04d9533328ca578$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e04d9533328ca578$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $e04d9533328ca578$var$_excluded);
    var _ref2 = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)($e04d9533328ca578$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}



var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(arr, i) {
    return $bf2dbd940d8d1ee7$exports(arr) || $efa3fde0b6100532$exports(arr, i) || $51f08ebed50a2438$exports(arr, i) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;




var $acw62 = parcelRequire("acw62");


function $3765cebd031b52c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3765cebd031b52c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3765cebd031b52c0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3765cebd031b52c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3765cebd031b52c0$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $3765cebd031b52c0$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $3765cebd031b52c0$var$_objectSpread($3765cebd031b52c0$var$_objectSpread($3765cebd031b52c0$var$_objectSpread({}, (0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $acw62.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    var previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    var isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}






var $acw62 = parcelRequire("acw62");


var $d9bd4545752f9667$var$_excluded = [
    "forwardedRef"
];
function $d9bd4545752f9667$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d9bd4545752f9667$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d9bd4545752f9667$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d9bd4545752f9667$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d9bd4545752f9667$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $d9bd4545752f9667$var$_excluded);
            var _useTranslation = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, $d9bd4545752f9667$var$_objectSpread($d9bd4545752f9667$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $d9bd4545752f9667$var$_objectSpread($d9bd4545752f9667$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}





var $868685a400877801$var$_excluded = [
    "ns",
    "children"
];
function $868685a400877801$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(props, $868685a400877801$var$_excluded);
    var _useTranslation = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $acw62.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $d97c91d803f78bcc$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




var $afd5c8e3ef499392$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $afd5c8e3ef499392$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $afd5c8e3ef499392$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $afd5c8e3ef499392$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $afd5c8e3ef499392$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $afd5c8e3ef499392$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $afd5c8e3ef499392$var$_excluded);
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, $afd5c8e3ef499392$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}




var $2843511fe0fbbf82$export$324d90190a8b822a = function date() {
    return "";
};
var $2843511fe0fbbf82$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $2843511fe0fbbf82$export$98e628dec113755e = function number() {
    return "";
};
var $2843511fe0fbbf82$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $2843511fe0fbbf82$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $2843511fe0fbbf82$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};


function $f6e8edbd6de2d1a8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f6e8edbd6de2d1a8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f6e8edbd6de2d1a8$var$_typeof(obj);
}
var $f6e8edbd6de2d1a8$var$arr = [];
var $f6e8edbd6de2d1a8$var$each = $f6e8edbd6de2d1a8$var$arr.forEach;
var $f6e8edbd6de2d1a8$var$slice = $f6e8edbd6de2d1a8$var$arr.slice;
function $f6e8edbd6de2d1a8$export$ebe90cb607ad99e(obj) {
    $f6e8edbd6de2d1a8$var$each.call($f6e8edbd6de2d1a8$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $f6e8edbd6de2d1a8$export$87022daa49baf612() {
    return typeof XMLHttpRequest === "function" || (typeof XMLHttpRequest === "undefined" ? "undefined" : $f6e8edbd6de2d1a8$var$_typeof(XMLHttpRequest)) === "object";
}
function $f6e8edbd6de2d1a8$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === "function";
}
function $f6e8edbd6de2d1a8$export$1625492ec82002b9(maybePromise) {
    if ($f6e8edbd6de2d1a8$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



var $24c3677c8ec8d51d$exports = {};
var $24c3677c8ec8d51d$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $24c3677c8ec8d51d$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $24c3677c8ec8d51d$var$fetchApi = window.fetch;
    else $24c3677c8ec8d51d$var$fetchApi = fetch;
}

if (typeof window === "undefined" || typeof window.document === "undefined") {
    var $24c3677c8ec8d51d$var$f = $24c3677c8ec8d51d$var$fetchApi || (parcelRequire("R5nvG"));
    if ($24c3677c8ec8d51d$var$f.default) $24c3677c8ec8d51d$var$f = $24c3677c8ec8d51d$var$f.default;
    $24c3677c8ec8d51d$exports.default = $24c3677c8ec8d51d$var$f;
    $24c3677c8ec8d51d$exports = $24c3677c8ec8d51d$exports.default;
}


function $cad892b69e25befc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cad892b69e25befc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cad892b69e25befc$var$_typeof(obj);
}
var $cad892b69e25befc$var$fetchApi;
if (typeof fetch === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.fetch) $cad892b69e25befc$var$fetchApi = $parcel$global.fetch;
    else if (typeof window !== "undefined" && window.fetch) $cad892b69e25befc$var$fetchApi = window.fetch;
    else $cad892b69e25befc$var$fetchApi = fetch;
}
var $cad892b69e25befc$var$XmlHttpRequestApi;
if ((0, $f6e8edbd6de2d1a8$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== "undefined" && $parcel$global.XMLHttpRequest) $cad892b69e25befc$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== "undefined" && window.XMLHttpRequest) $cad892b69e25befc$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $cad892b69e25befc$var$ActiveXObjectApi;
if (typeof ActiveXObject === "function") {
    if (typeof $parcel$global !== "undefined" && $parcel$global.ActiveXObject) $cad892b69e25befc$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== "undefined" && window.ActiveXObject) $cad892b69e25befc$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$cad892b69e25befc$var$fetchApi && $24c3677c8ec8d51d$exports && !$cad892b69e25befc$var$XmlHttpRequestApi && !$cad892b69e25befc$var$ActiveXObjectApi) $cad892b69e25befc$var$fetchApi = $24c3677c8ec8d51d$exports.default || $24c3677c8ec8d51d$exports;
if (typeof $cad892b69e25befc$var$fetchApi !== "function") $cad892b69e25befc$var$fetchApi = undefined;
var $cad892b69e25befc$var$addQueryString = function addQueryString(url, params) {
    if (params && $cad892b69e25befc$var$_typeof(params) === "object") {
        var queryString = "";
        for(var paramName in params)queryString += "&" + encodeURIComponent(paramName) + "=" + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf("?") !== -1 ? "&" : "?") + queryString.slice(1);
    }
    return url;
};
var $cad892b69e25befc$var$fetchIt = function fetchIt(url, fetchOptions, callback) {
    $cad892b69e25befc$var$fetchApi(url, fetchOptions).then(function(response) {
        if (!response.ok) return callback(response.statusText || "Error", {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    }).catch(callback);
};
var $cad892b69e25befc$var$omitFetchOptions = false;
var $cad892b69e25befc$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $cad892b69e25befc$var$addQueryString(url, options.queryStringParams);
    var headers = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)({}, typeof options.customHeaders === "function" ? options.customHeaders() : options.customHeaders);
    if (payload) headers["Content-Type"] = "application/json";
    var reqOptions = typeof options.requestOptions === "function" ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)({
        method: payload ? "POST" : "GET",
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $cad892b69e25befc$var$omitFetchOptions ? {} : reqOptions);
    try {
        $cad892b69e25befc$var$fetchIt(url, fetchOptions, callback);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf("not implemented") < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $cad892b69e25befc$var$fetchIt(url, fetchOptions, callback);
            $cad892b69e25befc$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $cad892b69e25befc$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $cad892b69e25befc$var$_typeof(payload) === "object") payload = $cad892b69e25befc$var$addQueryString("", payload).slice(1);
    if (options.queryStringParams) url = $cad892b69e25befc$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($cad892b69e25befc$var$XmlHttpRequestApi) x = new $cad892b69e25befc$var$XmlHttpRequestApi();
        else x = new $cad892b69e25befc$var$ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
        x.open(payload ? "POST" : "GET", url, 1);
        if (!options.crossDomain) x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        if (x.overrideMimeType) x.overrideMimeType("application/json");
        var h = options.customHeaders;
        h = typeof h === "function" ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $cad892b69e25befc$var$request = function request(options, url, payload, callback) {
    if (typeof payload === "function") {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($cad892b69e25befc$var$fetchApi && url.indexOf("file:") !== 0) return $cad892b69e25befc$var$requestWithFetch(options, url, payload, callback);
    if ((0, $f6e8edbd6de2d1a8$export$87022daa49baf612)() || typeof ActiveXObject === "function") return $cad892b69e25befc$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error("No fetch and no xhr implementation found!"));
};
var $cad892b69e25befc$export$2e2bcd8739ae039 = $cad892b69e25befc$var$request;


function $3faa45b77b2a48ba$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3faa45b77b2a48ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3faa45b77b2a48ba$var$_typeof(obj);
}
function $3faa45b77b2a48ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3faa45b77b2a48ba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3faa45b77b2a48ba$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3faa45b77b2a48ba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3faa45b77b2a48ba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3faa45b77b2a48ba$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3faa45b77b2a48ba$var$_defineProperty(obj, key, value) {
    key = $3faa45b77b2a48ba$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3faa45b77b2a48ba$var$_toPropertyKey(arg) {
    var key = $3faa45b77b2a48ba$var$_toPrimitive(arg, "string");
    return $3faa45b77b2a48ba$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3faa45b77b2a48ba$var$_toPrimitive(input, hint) {
    if ($3faa45b77b2a48ba$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3faa45b77b2a48ba$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3faa45b77b2a48ba$var$getDefaults = function getDefaults() {
    return {
        loadPath: "/locales/{{lng}}/{{ns}}.json",
        addPath: "/locales/add/{{lng}}/{{ns}}",
        allowMultiLoading: false,
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $3faa45b77b2a48ba$var$_defineProperty({}, key, fallbackValue || "");
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $cad892b69e25befc$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== "undefined" ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: "cors",
            credentials: "same-origin",
            cache: "default"
        }
    };
};
var $3faa45b77b2a48ba$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $3faa45b77b2a48ba$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = "backend";
        this.init(services, options, allOptions);
    }
    $3faa45b77b2a48ba$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = (0, $f6e8edbd6de2d1a8$export$ebe90cb607ad99e)(options, this.options || {}, $3faa45b77b2a48ba$var$getDefaults());
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) setInterval(function() {
                    return _this.reload();
                }, this.options.reloadInterval);
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === "function") loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $f6e8edbd6de2d1a8$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join("+"),
                        ns: namespaces.join("+")
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === "string" ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === "string" ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback("failed loading " + url + "; status code: " + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback("failed loading " + url + "; status code: " + res.status, false);
                    if (!res && err && err.message && err.message.indexOf("Failed to fetch") > -1) return callback("failed loading " + url + ": " + err.message, true);
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === "string") ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = "failed parsing " + url + " to json";
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === "string") languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === "function") addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === "function") callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === "cimode") return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, "read", null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
    return Backend;
}();
$3faa45b77b2a48ba$var$Backend.type = "backend";
var $3faa45b77b2a48ba$export$2e2bcd8739ae039 = $3faa45b77b2a48ba$var$Backend;


var $a58aa9515ba31974$exports = {};
$a58aa9515ba31974$exports = JSON.parse('{"Skip to content":"Skip to content","SPECIAL PROCEDURES":"SPECIAL PROCEDURES","PUBLIC REGISTER":"PUBLIC REGISTER","Search Results":"Search Results","No results found":"No results found","Close":"Close","Search for business or practitioner name":"Search for business or practitioner name","Filter":"Filter","Local authority":"Local authority","Select local authority":"Select local authority","Procedure type":"Procedure type","Select a licence":"Select a licence","Search":"Search","Tattooing":"Tattooing","Body piercing":"Body piercing","Acupuncture":"Acupuncture","Electrolysis":"Electrolysis","Semi-permanent makeup":"Semi-permanent makeup","Dry needling":"Dry needling","Certificate holder name":"Certificate holder name","Approved premises address":"Approved premises address","Number of workstations":"Number of workstations","Show more":"Show more","Associated business":"Associated business","Apply":"Apply","Sign in":"Sign in","Sign out":"Sign out","Email":"Email","Password":"Password","Forgotten password?":"Forgotten password?","Show archive":"Show archive","Issue date":"Issue date","Bulk Upload":"Bulk Upload","Continue":"Continue","Enter practitioner name":"Enter practitioner name","Practitioner name":"Practitioner name","Address line 2":"Address line 2","Enter town / city here":"Enter town / city here","Enter address line 2 here":"Enter address line 2 here","Address line 1":"Address line 1","Town / City":"Town / City","Enter associated business name here":"Enter associated business name here","Associated business name":"Associated business name","Enter postcode here":"Enter postcode here","Enter address line 1 here":"Enter address line 1 here","Add another business":"Add another business","Internal notes (optional)":"Internal notes (optional)","Back":"Back","Save":"Save","Postcode":"Postcode","Licence successfully created":"Licence successfully created","Premises":"Premises","Practitioner":"Practitioner","Vehicle":"Vehicle","Create Single":"Create Single","Submit":"Submit","Success":"Success","Bulk upload successful":"Bulk upload successful","Error":"Error","Invalid bulk upload content, if you need assistance with uploading data please contact us on {{supportEmail}}":"Invalid bulk upload content, if you need assistance with uploading data please contact us on {{supportEmail}}","You have been logged out":"You have been logged out","Invalid username / password":"Invalid username / password","There is a problem":"There is a problem","A network error occurred":"A network error occurred","Licence type":"Licence type","Status":"Status","Show Less":"Show Less","paginationSummary":"Page {{page}} of {{totalPages}}","dateSuffixedArchived":"Archived - {{date}}","dateSuffixedApproved":"Approved - {{date}}","Enter a valid email address":"Enter a valid email address","Enter a valid password":"Enter a valid password","Please select an option":"Please select an option","Please enter a value":"Please enter a value","Enter a certificate holder name here":"Enter a certificate holder name here","Enter business name here":"Enter business name here","Enter number of workstations here":"Enter number of workstations here","Business name":"Business name","Please enter a valid number":"Please enter a valid number","Licence could not be created":"Licence could not be created","Unknown error, please try again later":"Unknown error, please try again later","smarter":"smarter","public":"public","protection":"protection","Help":"Help","Accessibility":"Accessibility","Contact":"Contact","Legal":"Legal","Copyright":"Copyright","Privacy Policy":"Privacy Policy","Terms Conditions":"Terms and Conditions","RH Environmental Limited trading as RHE Global. All rights reserved.":"RH Environmental Limited trading as RHE Global. All rights reserved.","Please select a licence type":"Please select a licence type","Please enter the licence number":"Please enter the licence number","marketing":{"part-1":"The Special Procedures Licensing Scheme for Wales came into force on 29th November 2024. This public national register provides details of all individuals who are <1>licensed</1> and all premises and vehicles which have been <3>approved</3> under the new Licensing Scheme for the purpose of providing special procedures in Wales. Special procedures are: ","licence-type-1":"Acupuncture (including dry needling)","licence-type-2":"Body piercing","licence-type-3":"Electrolysis","licence-type-4":"Tattooing (including semi-permanent make-up / microblading)","part-2":"Previously registered practitioners and premises will not appear on this register but if they have received a transitional licence and/or transitional premises/vehicle approval certificate from their local authority they can continue to trade while local authorities process their applications under the new scheme. This could take a number of months for local authorities to assess. Information on the transitional arrangements, licensing conditions, and how to apply for a licence is available from your Local Authority and the Welsh Government website. <1>If you would like to check whether a practitioner or business holds a transitional licence, please contact your Local Authority</1>.","info-section-1":"<0>A Special Procedure Licence</0> <2>does not</2> provide any assurance of the competence, skill levels, quality of work, or artistic ability of the licence holder performing the special procedure. The Licence confirms the licence holder\'s knowledge and application of infection prevention and control standards, and first aid relating to their performance of their specified special procedures so as to reduce any risks of harm to clients\' health in the performance of those procedures.","info-section-2":"<0>A Premises/Vehicle Approval Certificate</0> <2>does not</2> relate to the quality of work performed by or at that business. The Approval Certificate confirms that the premises/vehicle is of a standard that will enable compliance with the required infection prevention and control standards applicable for the performance of the special procedures within them.","info-section-3":"<0>Exempted Individuals and Individuals to Whom the Licensing Scheme Does Not Apply.</0> This licensing scheme <2>does not apply</2> to the NHS in Wales, therefore medical professionals and healthcare professionals with statutory professional registration and regulation who are employed within the NHS and who may perform one or more of the four specified special procedures as part of their NHS role are not captured by this licensing scheme. These individuals will therefore not feature within this Register.","info-section-4":"Additionally, there are regulated medical professionals and healthcare professionals who may also legitimately perform one or more of the four specified special procedures, but on the basis of their statutory professional registration and regulation and the fact they operate from within a regulated healthcare setting in Wales (such as regulated independent hospitals, clinics and dental practices) they are exempt from the requirement to be licensed under this licensing scheme to perform those special procedures. These individuals will therefore not feature within this Register.","outro":"<0>CLICK HERE</0> <2>for further information on the requirements for Licence Holders and Approval Certificate Holders</2> (this information provides register users with information on what individuals must fulfil to be able to be granted a licence and/or an approval certificate)","link":"https://riams.org/connect/documents/iqlbcUWFB07X"},"Further details can be found":"Further details can be found","here":"here","Let\'s get started":"Let\'s get started"}');


var $168d5dd9ae1d7362$exports = {};
$168d5dd9ae1d7362$exports = JSON.parse('{"Skip to content":"Yn neidio i\'r cynnwys","SPECIAL PROCEDURES":"GWEITHDREFNAU ARBENNIG","PUBLIC REGISTER":"COFRESTR GYHOEDDUS","Search Results":"Canlyniadau chwilio","No results found":"Heb ddod o hyd i ganlyniadau","Close":"Cau","Search for business or practitioner name":"Chwilio am enw busnes neu ymarferydd","Filter":"Hidlo","Local authority":"Awdurdod lleol","Select local authority":"Dewis awdurdod lleol","Procedure type":"Math o weithdrefn","Select a licence":"Dewiswch drwydded","Search":"Chwilio","Tattooing":"Tatŵio","Body piercing":"Tyllu\'r corff","Acupuncture":"Aciwbigo","Electrolysis":"Electrolysis","Semi-permanent makeup":"Colur lled-barhaol","Dry needling":"Gosod nodwyddau sych","Certificate holder name":"Enw deiliad y dystysgrif","Approved premises address":"Cyfeiriad safle cymeradwy","Number of workstations":"Nifer y gweithfannau","Show more":"Dangos mwy","Associated business":"Busnes cysylltiedig","Apply":"Gwneud cais","Sign in":"Mewngofnodi","Sign out":"Sign out","Email":"Ebost","Password":"Cyfrinair","Forgotten password?":"Wedi anghofio eich cyfrinair?","Show archive":"Dangos yr archif","Issue date":"Dyddiad cyhoeddi","Bulk Upload":"Uwchlwytho swmp","Continue":"Parhau","Enter practitioner name":"Nodwch enw\'r ymarferydd","Practitioner name":"Enw\'r ymarferydd","Address line 2":"Llinell 2 y cyfeiriad","Enter town / city here":"Nodwch y dref / dinas yma","Enter address line 2 here":"Nodwch linell 2 y cyfeiriad yma","Address line 1":"Llinell 1 y cyfeiriad ","Town / City":"Tref / Dinas","Enter associated business name here":"Nodwch enw\'r busnes cysylltiedig yma","Associated business name":"Enw\'r busnes cysylltiedig","Enter postcode here":"Nodwch y cod post yma","Enter address line 1 here":"Nodwch linell 1 y cyfeiriad yma","Add another business":"Ychwanegu busnes arall","Internal notes (optional)":"Nodiadau mewnol (dewisol)","Back":"Yn \xf4l","Save":"Cadw","Postcode":"Cod post","Licence successfully created":"Trwydded wedi ei chreu\'n llwyddiannus","Premises":"Safleoedd","Practitioner":"Ymarferwr","Vehicle":"Cerbyd","Create Single":"Creu sengl","Submit":"Cyflwyno","Success":"Llwyddiant","Bulk upload successful":"Wedi uwchlwytho swmp yn llwyddiannus","Error":"Gwall","Invalid bulk upload content, if you need assistance with uploading data please contact us on {{supportEmail}}":"Cynnwys annilys wedi\'i uwchlwytho fel swmp, os oes angen help arnoch i uwchlwytho data, cysylltwch \xe2 ni ar {{supportEmail}}","You have been logged out":"Rydych wedi cael eich allgofnodi","Invalid username / password":"Enw defnyddiwr / cyfrinair annilys","There is a problem":"Mae problem wedi codi","A network error occurred":"Mae gwall gyda\'r rhwydwaith wedi codi","Licence type":"Math o drwydded","Status":"Statws","Show Less":"Dangos llai","paginationSummary":"Tudalen {{page}} o {{totalPages}}","dateSuffixedArchived":"Archifwyd - {{date}}","dateSuffixedApproved":"Cymeradwywyd - {{date}}","Enter a valid email address":"Nodwch gyfeiriad e-bost dilys","Enter a valid password":"Nodwch gyfrinair dilys","Please select an option":"Dewiswch opsiwn","Please enter a value":"Nodwch werth","Enter a certificate holder name here":"Nodwch enw deiliad y dystysgrif yma","Enter business name here":"Nodwch enw busnes yma","Enter number of workstations here":"Nodwch nifer y gweithfannau yma","Business name":"Enw\'r busnes","Please enter a valid number":"Nodwch rif dilys","Licence could not be created":"Nid oedd modd creu trwydded","Unknown error, please try again later":"Gwall anhysbys, rhowch gynnig arall arni yn nes ymlaen","smarter":"smarter","public":"public","protection":"protection","Help":"Help","Accessibility":"Hygyrchedd","Contact":"Cysylltu","Legal":"Cyfreithiol","Copyright":"Hawlfraint","Privacy Policy":"Polisi Preifatrwydd","Terms Conditions":"Telerau ac Amodau","RH Environmental Limited trading as RHE Global. All rights reserved.":"RH Environmental Limited yn masnachu fel RHE Global. Cedwir pob hawl.","Please select a licence type":"Dewis math o drwydded","Please enter the licence number":"Please enter the licence number","Further details can be found":"Mae rhagor o fanylion am y cynllun ar gael","here":"yma","Special Procedures Wales Public Register":"Cofrestr Gyhoeddus Gweithdrefnau Arbennig Cymru","Let\'s get started":"Gadewch i ni ddechrau","marketing":{"part-1":"Daeth Cynllun Trwyddedu Triniaethau Arbennig Cymru i rym ar 29 Tachwedd 2024. Mae\'r gofrestr genedlaethol gyhoeddus hon yn rhoi manylion yr holl unigolion sydd wedi\'u trwyddedu a\'r holl adeiladau a cherbydau sydd wedi cael eu cymeradwyo o dan y Cynllun Trwyddedu newydd er mwyn darparu gweithdrefnau arbennig yng Nghymru. Triniaethau arbennig yw:","licence-type-1":"Aciwbigo (gan gynnwys nodwyddo sych)","licence-type-2":"Tyllu\'r corff","licence-type-3":"Electrolysis","licence-type-4":"Tatŵio (gan gynnwys colur lled-barhaol / meicro-llafnu)","part-2":"Ni fydd ymarferwyr a mangreoedd a gofrestrwyd yn flaenorol yn ymddangos ar y gofrestr hon, ond os ydynt wedi cael trwydded drosiannol a/neu dystysgrif cymeradwyo mangre/cerbyd trosiannol gan eu hawdurdod lleol, gallant barhau i fasnachu tra bod awdurdodau lleol yn prosesu eu ceisiadau o dan y cynllun newydd. Gallai hyn gymryd nifer o fisoedd i awdurdodau lleol asesu. Mae gwybodaeth am y trefniadau trosiannol, amodau trwyddedu, a sut i wneud cais am drwydded ar gael gan eich Awdurdod Lleol a gwefan Llywodraeth Cymru. <1>Os hoffech wirio a oes gan ymarferydd neu fusnes drwydded drosiannol, cysylltwch \xe2\'ch Awdurdod Lleol.</1>","info-section-1":"Nid yw Trwydded Triniaeth Arbennig yn darparu unrhyw sicrwydd o gymhwysedd, lefelau sgiliau, ansawdd gwaith, neu allu artistig deiliad y drwydded i gyflawni\'r weithdrefn arbennig.  Mae\'r Drwydded yn cadarnhau gwybodaeth a chymhwysiad deiliad y drwydded o safonau atal a rheoli heintiau, a chymorth cyntaf sy\'n ymwneud \xe2\'u perfformiad o\'u gweithdrefnau arbennig penodedig, er mwyn lleihau unrhyw risgiau o niwed i iechyd cleientiaid wrth gyflawni\'r gweithdrefnau hynny.","info-section-2":"Nid yw Tystysgrif Mangre/Cerbyd Cymeradwy yn ymwneud ag ansawdd y gwaith a gyflawnir gan neu yn y busnes hwnnw. Mae\'r Dystysgrif Mangre/Cerbyd Cymeradwy yn cadarnhau bod y safle/cerbyd o safon a fydd yn galluogi cydymffurfio \xe2\'r safonau atal a rheoli heintiau gofynnol sy\'n gymwys ar gyfer cyflawni\'r gweithdrefnau arbennig ynddynt.","info-section-3":"Unigolion ac Unigolion sydd wedi\'u heithrio nad yw\'r Cynllun Trwyddedu yn berthnasol iddynt.   Nid yw\'r cynllun trwyddedu hwn yn berthnasol i\'r GIG yng Nghymru, felly nid yw gweithwyr meddygol proffesiynol a gweithwyr gofal iechyd proffesiynol, sydd \xe2 chofrestru a rheoleiddio proffesiynol statudol sy\'n cael eu cyflogi o fewn y GIG ac a allai gyflawni un neu fwy o\'r pedair gweithdrefn arbennig benodol fel rhan o\'u r\xf4l GIG, yn cael eu cynnwys o fewn y cynllun trwyddedu hwn. Felly ni fydd yr unigolion hyn yn ymddangos yn y Gofrestr hon.","info-section-4":"Yn ogystal, mae yna weithwyr meddygol proffesiynol rheoledig a gweithwyr gofal iechyd proffesiynol a all hefyd berfformio un neu fwy o\'r pedair gweithdrefn arbennig benodol yn gyfreithlon, ond ar sail eu cofrestriad a\'u rheoleiddio proffesiynol statudol a\'r ffaith eu bod yn gweithredu o fewn lleoliad gofal iechyd rheoledig yng Nghymru (megis ysbytai annibynnol rheoledig, clinigau a phractisau deintyddol) maent wedi\'u heithrio rhag y gofyniad i gael eu trwyddedu o dan y cynllun trwyddedu hwn i gyflawni\'r gweithdrefnau arbennig hynny. Felly ni fydd yr unigolion hyn yn ymddangos yn y Gofrestr hon.","outro":"<0>CLICIWCH YMA</0> i gael rhagor o wybodaeth am y gofynion ar gyfer Deiliaid Trwydded a Deiliaid Tystysgrifau Mangre/Cerbyd Cymeradwy (mae\'r wybodaeth hon yn rhoi gwybodaeth i ddefnyddwyr cofrestredig am yr hyn y mae\'n rhaid i unigolion ei gyflawni er mwyn gallu cael trwydded a/neu dystysgrif gymeradwyo).","link":"https://signin.riams.org/connect/documents/SKPgn8ON9MvT"},"Important Information":"Gwybodaeth Bwysig:","Enter search text":"Rhowch destun chwilio","Procedure types":"Mathau o weithdrefnau","Licence number":"Rhif trwydded","Vehicle registration details":"Manylion cofrestru cerbyd","Vehicle details":"Manylion y cerbyd"}');


const $c02b04ee7bc17cb7$var$commonOptions = {
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    },
    debug: false,
    returnNull: false
};
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).use((0, $26bfda595e5aa141$export$ae7e14d40d89f296)).init({
    ...$c02b04ee7bc17cb7$var$commonOptions,
    resources: {
        en: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($a58aa9515ba31974$exports)))
        },
        cy: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($168d5dd9ae1d7362$exports)))
        }
    }
});






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $49553c78695c6663$export$1cbb4184b742b6e9 = (0, $acw62.createContext)({
    token: "",
    setToken: ()=>{},
    isLoggedIn: false,
    setIsLoggedIn: ()=>{},
    user: undefined,
    setUser: ()=>{}
});



// src/center.tsx


var $ef3eb35d4abe9e46$export$1f54913ccc4368b1 = (0, $f1b95b1386d3a42c$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
});
$ef3eb35d4abe9e46$export$1f54913ccc4368b1.displayName = "Center";
var $ef3eb35d4abe9e46$var$centerStyles = {
    horizontal: {
        insetStart: "50%",
        transform: "translateX(-50%)"
    },
    vertical: {
        top: "50%",
        transform: "translateY(-50%)"
    },
    both: {
        insetStart: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)"
    }
};
var $ef3eb35d4abe9e46$export$335dd19f2cdf1a5c = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function AbsoluteCenter2(props, ref) {
    const { axis: axis = "both", ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: $ef3eb35d4abe9e46$var$centerStyles[axis],
        ...rest,
        position: "absolute"
    });
});



var $acw62 = parcelRequire("acw62");



// src/box.tsx


var $f52a9bf465e52cde$export$e71c4d32a2263218 = (0, $f1b95b1386d3a42c$export$7cd122d781af9fa4)("div");
$f52a9bf465e52cde$export$e71c4d32a2263218.displayName = "Box";
var $f52a9bf465e52cde$export$b09fb900337259de = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Square2(props, ref) {
    const { size: size, centerContent: centerContent = true, ...rest } = props;
    const styles = centerContent ? {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    } : {};
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f52a9bf465e52cde$export$e71c4d32a2263218, {
        ref: ref,
        boxSize: size,
        __css: {
            ...styles,
            flexShrink: 0,
            flexGrow: 0
        },
        ...rest
    });
});
$f52a9bf465e52cde$export$b09fb900337259de.displayName = "Square";
var $f52a9bf465e52cde$export$c89a927ffc67e6fa = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Circle2(props, ref) {
    const { size: size, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f52a9bf465e52cde$export$b09fb900337259de, {
        size: size,
        ref: ref,
        borderRadius: "9999px",
        ...rest
    });
});
$f52a9bf465e52cde$export$c89a927ffc67e6fa.displayName = "Circle";

// src/card-context.tsx

var [$306e6f73ed942c91$export$f051b3a3c1998e0, $306e6f73ed942c91$export$7e0f545483b3a68c] = (0, $19b2214d51386943$export$11d9f9905bcdc114)("Card");





var $d74216d2c0bf0981$export$60332b2344f7fe41 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Card2(props, ref) {
    const { className: className, children: children, direction: direction = "column", justify: justify, align: align, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Card", props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-card", className),
        __css: {
            display: "flex",
            flexDirection: direction,
            justifyContent: justify,
            alignItems: align,
            position: "relative",
            minWidth: 0,
            wordWrap: "break-word",
            ...styles.container
        },
        ...rest,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $306e6f73ed942c91$export$f051b3a3c1998e0), {
            value: styles,
            children: children
        })
    });
});





var $cf2c7f89c79144c1$export$851de33184ecdac4 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function CardBody2(props, ref) {
    const { className: className, ...rest } = props;
    const styles = (0, $306e6f73ed942c91$export$7e0f545483b3a68c)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-card__body", className),
        __css: styles.body,
        ...rest
    });
});





var $3307ee9fb8204c10$export$5665775b26e26c5d = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function CardHeader2(props, ref) {
    const { className: className, ...rest } = props;
    const styles = (0, $306e6f73ed942c91$export$7e0f545483b3a68c)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-card__header", className),
        __css: styles.header,
        ...rest
    });
});

// src/stack/stack-item.tsx


var $ec577583605eb6b7$export$50d5391cd1a018c6 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        className: "chakra-stack__item",
        ...props,
        __css: {
            display: "inline-block",
            flex: "0 0 auto",
            minWidth: 0,
            ...props["__css"]
        }
    });
$ec577583605eb6b7$export$50d5391cd1a018c6.displayName = "StackItem";


// src/stack/stack.utils.tsx
// src/responsive.ts

var $37c1adb04c994149$export$d07517a676ce386f = Object.freeze([
    "base",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl"
]);
function $37c1adb04c994149$export$eca1915781c2aaca(prop, mapper) {
    if (Array.isArray(prop)) return prop.map((item)=>item === null ? null : mapper(item));
    if ((0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(prop)) return Object.keys(prop).reduce((result, key)=>{
        result[key] = mapper(prop[key]);
        return result;
    }, {});
    if (prop != null) return mapper(prop);
    return null;
}
function $37c1adb04c994149$export$d9dcf045f3ec145e(obj, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const result = bps.map((br)=>{
        var _a;
        return (_a = obj[br]) != null ? _a : null;
    });
    const lastItem = result[result.length - 1];
    while(lastItem === null)result.pop();
    return result;
}
function $37c1adb04c994149$export$60476530468641e7(values, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const result = {};
    values.forEach((value, index)=>{
        const key = bps[index];
        if (value == null) return;
        result[key] = value;
    });
    return result;
}
function $37c1adb04c994149$export$2f4b3062f5f33794(obj, bps = $37c1adb04c994149$export$d07517a676ce386f) {
    const keys = Object.keys(obj);
    return keys.length > 0 && keys.every((key)=>bps.includes(key));
}
var $37c1adb04c994149$export$4cdfc817e07de39e = (v)=>Number.isNaN(Number(v));


function $c3eac2cb5270a742$export$d4a6a5cc582519a5(options) {
    const { spacing: spacing, direction: direction } = options;
    const dividerStyles = {
        column: {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        "column-reverse": {
            my: spacing,
            mx: 0,
            borderLeftWidth: 0,
            borderBottomWidth: "1px"
        },
        row: {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        },
        "row-reverse": {
            mx: spacing,
            my: 0,
            borderLeftWidth: "1px",
            borderBottomWidth: 0
        }
    };
    return {
        "&": (0, $37c1adb04c994149$export$eca1915781c2aaca)(direction, (value)=>dividerStyles[value])
    };
}


// src/index.ts

var $acw62 = parcelRequire("acw62");
function $197fffec5094e9ee$export$b2c43d7d050b2e63(children) {
    return (0, $acw62.Children).toArray(children).filter((child)=>(0, $acw62.isValidElement)(child));
}





var $acw62 = parcelRequire("acw62");

var $9d16df24508f5c77$export$694e0d28c7ffc90c = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { isInline: isInline, direction: directionProp, align: align, justify: justify, spacing: spacing = "0.5rem", wrap: wrap, children: children, divider: divider, className: className, shouldWrapChildren: shouldWrapChildren, ...rest } = props;
    const direction = isInline ? "row" : directionProp != null ? directionProp : "column";
    const dividerStyle = (0, $acw62.useMemo)(()=>(0, $c3eac2cb5270a742$export$d4a6a5cc582519a5)({
            spacing: spacing,
            direction: direction
        }), [
        spacing,
        direction
    ]);
    const hasDivider = !!divider;
    const shouldUseChildren = !shouldWrapChildren && !hasDivider;
    const clones = (0, $acw62.useMemo)(()=>{
        const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
        return shouldUseChildren ? validChildren : validChildren.map((child, index)=>{
            const key = typeof child.key !== "undefined" ? child.key : index;
            const isLast = index + 1 === validChildren.length;
            const wrappedChild = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ec577583605eb6b7$export$50d5391cd1a018c6), {
                children: child
            }, key);
            const _child = shouldWrapChildren ? wrappedChild : child;
            if (!hasDivider) return _child;
            const clonedDivider = (0, $acw62.cloneElement)(divider, {
                __css: dividerStyle
            });
            const _divider = isLast ? null : clonedDivider;
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    _child,
                    _divider
                ]
            }, key);
        });
    }, [
        divider,
        dividerStyle,
        hasDivider,
        shouldUseChildren,
        shouldWrapChildren,
        children
    ]);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-stack", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: hasDivider ? void 0 : spacing,
        className: _className,
        ...rest,
        children: clones
    });
});
$9d16df24508f5c77$export$694e0d28c7ffc90c.displayName = "Stack";


/**
 * Do not edit directly
 * Generated on Wed, 01 Feb 2023 16:56:55 GMT
 */ const $590eee45b2f4b5a8$export$6aefc03aa88b5914 = "#fafafa";
const $590eee45b2f4b5a8$export$bbab08086b8634b3 = "#6e6764";
const $590eee45b2f4b5a8$export$4bdf0898d78f829f = "#5e5856";
const $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf = "#403b39";
const $590eee45b2f4b5a8$export$cac2caa807436676 = "#1a1a1a";
const $590eee45b2f4b5a8$export$1715288b4e75850e = "#c23300";
const $590eee45b2f4b5a8$export$b0ac3c99e1f94deb = "#c30909";
const $590eee45b2f4b5a8$export$67efe7a6dccb9914 = "#2d5ab4";
const $590eee45b2f4b5a8$export$a788d85e35a74fe0 = "#284687";
const $590eee45b2f4b5a8$export$76d96729ea98bb77 = "#2471f5";
const $590eee45b2f4b5a8$export$bbc01caad8c0564b = "#08a141";
const $590eee45b2f4b5a8$export$f658b86d9d7043af = "#f5ba31";
const $590eee45b2f4b5a8$export$292aa28deb82f6ec = "Helvetica Neue";
const $590eee45b2f4b5a8$export$bf12335799fd8efd = 300;
const $590eee45b2f4b5a8$export$ed345f932fb8865a = 64;
const $590eee45b2f4b5a8$export$7aa478b3971f3bb1 = 48;
const $590eee45b2f4b5a8$export$e4a4173a12619852 = "0%";
const $590eee45b2f4b5a8$export$8146bc42ca12e18f = 0;
const $590eee45b2f4b5a8$export$f4f3d65650c79d29 = 0;
const $590eee45b2f4b5a8$export$2757c8478892139c = "none";
const $590eee45b2f4b5a8$export$83369c1e55f553b2 = "none";
const $590eee45b2f4b5a8$export$205d2d2718e60261 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$f1aac2523ed5a222 = 300;
const $590eee45b2f4b5a8$export$47c0c17ac9dcf85d = 60;
const $590eee45b2f4b5a8$export$e6a204a4cf43d019 = 40;
const $590eee45b2f4b5a8$export$506ebddbff60eb87 = "0%";
const $590eee45b2f4b5a8$export$a3a5858317e7a502 = 0;
const $590eee45b2f4b5a8$export$69525c97a6de3efe = 0;
const $590eee45b2f4b5a8$export$d9db7c5efb52589b = "none";
const $590eee45b2f4b5a8$export$541454ba11173d6d = "none";
const $590eee45b2f4b5a8$export$ca99389922d7dfc = "Helvetica Neue";
const $590eee45b2f4b5a8$export$40b7e08a4fcb5761 = 300;
const $590eee45b2f4b5a8$export$ef70f03b669253bc = 48;
const $590eee45b2f4b5a8$export$891939884187874e = 32;
const $590eee45b2f4b5a8$export$9ead2b7f7aa82159 = "0%";
const $590eee45b2f4b5a8$export$a18cd76b3cc5d0c4 = 0;
const $590eee45b2f4b5a8$export$bca33cc736047d9e = 0;
const $590eee45b2f4b5a8$export$9fbf609d344419bc = "none";
const $590eee45b2f4b5a8$export$3a0ab423fe66edb3 = "none";
const $590eee45b2f4b5a8$export$6ded285245556693 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$551c1be1ccab0e43 = 300;
const $590eee45b2f4b5a8$export$ae355babc43656d1 = 32;
const $590eee45b2f4b5a8$export$e145890412ec5292 = 24;
const $590eee45b2f4b5a8$export$218c3a7826075780 = "0%";
const $590eee45b2f4b5a8$export$fef003c0bae75dd3 = 0;
const $590eee45b2f4b5a8$export$99b7deb9b841559f = 0;
const $590eee45b2f4b5a8$export$9ed9fd7d239c902e = "none";
const $590eee45b2f4b5a8$export$1a5727466b96c599 = "none";
const $590eee45b2f4b5a8$export$3b06b298f99cc1b6 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$d854bab43b85c38b = 300;
const $590eee45b2f4b5a8$export$b2cdb94ff33ee111 = 28;
const $590eee45b2f4b5a8$export$cbbe384bd9f86a4b = 18;
const $590eee45b2f4b5a8$export$ce27788bd471341c = "0%";
const $590eee45b2f4b5a8$export$e611827d86f34a72 = 0;
const $590eee45b2f4b5a8$export$728daf0a05b50f8b = 0;
const $590eee45b2f4b5a8$export$ffba2e7f9f1597b5 = "none";
const $590eee45b2f4b5a8$export$d7a14b5045f7d209 = "none";
const $590eee45b2f4b5a8$export$cbf8f0b12c1706d = "Helvetica Neue";
const $590eee45b2f4b5a8$export$d181039be6d8a946 = 300;
const $590eee45b2f4b5a8$export$52283bb8b8edb8c9 = 24;
const $590eee45b2f4b5a8$export$9c53b98c25e28fe9 = 16;
const $590eee45b2f4b5a8$export$ed4f518cafc1b6d7 = "0%";
const $590eee45b2f4b5a8$export$fdbc2776ca653b27 = 0;
const $590eee45b2f4b5a8$export$8f25cc9397059384 = 0;
const $590eee45b2f4b5a8$export$511d63ad815fc837 = "none";
const $590eee45b2f4b5a8$export$f40df5bc3cf9daac = "none";
const $590eee45b2f4b5a8$export$878fe9f3cecf32a1 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$20f0be0830b8f8f0 = 500;
const $590eee45b2f4b5a8$export$87f750443c5b7a0b = 64;
const $590eee45b2f4b5a8$export$b8960a7c5fb656e2 = 48;
const $590eee45b2f4b5a8$export$de7b25774e2ad24c = "0%";
const $590eee45b2f4b5a8$export$661417ce77b275d4 = 0;
const $590eee45b2f4b5a8$export$18bc26a06184a6dd = 0;
const $590eee45b2f4b5a8$export$8db22fdb9dcded67 = "none";
const $590eee45b2f4b5a8$export$be666595b179e5ea = "none";
const $590eee45b2f4b5a8$export$3e50f1c612b01b46 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$79e1fb61fb8bde4d = 500;
const $590eee45b2f4b5a8$export$9c8fea5f4f4965f6 = 60;
const $590eee45b2f4b5a8$export$2c37fadc16f0d822 = 40;
const $590eee45b2f4b5a8$export$5f6e0b4d27811ca5 = "0%";
const $590eee45b2f4b5a8$export$bef76389cef5878a = 0;
const $590eee45b2f4b5a8$export$bb3cc0f1de2d6cdc = 0;
const $590eee45b2f4b5a8$export$7ec3671b11ff4bc1 = "none";
const $590eee45b2f4b5a8$export$7ba94d4f89b37ab1 = "none";
const $590eee45b2f4b5a8$export$d2ea4895146e705d = "Helvetica Neue";
const $590eee45b2f4b5a8$export$552afd081534a97e = 500;
const $590eee45b2f4b5a8$export$1ea8405b8d1462c = 48;
const $590eee45b2f4b5a8$export$94969d445d2250bd = 32;
const $590eee45b2f4b5a8$export$8665939500c31d87 = "0%";
const $590eee45b2f4b5a8$export$ed72d154e442535e = 0;
const $590eee45b2f4b5a8$export$79b55c00d6e085a7 = 0;
const $590eee45b2f4b5a8$export$dfa75d5c918f5ec3 = "none";
const $590eee45b2f4b5a8$export$311d3703ae80609d = "none";
const $590eee45b2f4b5a8$export$91626964489edf0d = "Helvetica Neue";
const $590eee45b2f4b5a8$export$37e237aefd2a0a94 = 500;
const $590eee45b2f4b5a8$export$c5b94acc9ce6cab9 = 32;
const $590eee45b2f4b5a8$export$da3fbc117361d103 = 24;
const $590eee45b2f4b5a8$export$3759a7b59a7fc39 = "0%";
const $590eee45b2f4b5a8$export$598690a934e1e731 = 0;
const $590eee45b2f4b5a8$export$312ebff674ee5a90 = 0;
const $590eee45b2f4b5a8$export$8d95a054ad315e = "none";
const $590eee45b2f4b5a8$export$7e6f83aba4758909 = "none";
const $590eee45b2f4b5a8$export$4611f4d46dc7eb33 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$3c964489a6506e6 = 500;
const $590eee45b2f4b5a8$export$318d65dd2ec57b20 = 28;
const $590eee45b2f4b5a8$export$fb2698992220c4b = 18;
const $590eee45b2f4b5a8$export$b87cfefc3909c22f = "0%";
const $590eee45b2f4b5a8$export$ebd52e153c383241 = 0;
const $590eee45b2f4b5a8$export$4d330e578f2f7100 = 0;
const $590eee45b2f4b5a8$export$7571b9f48af3bc6 = "none";
const $590eee45b2f4b5a8$export$2ae8aa862e969717 = "none";
const $590eee45b2f4b5a8$export$2e58fe52ac126347 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$431a6622f9795b9e = 500;
const $590eee45b2f4b5a8$export$6562b26fc3b502c4 = 24;
const $590eee45b2f4b5a8$export$7185a68768b6b5fc = 16;
const $590eee45b2f4b5a8$export$61580f1dda72df60 = "0%";
const $590eee45b2f4b5a8$export$f532949723465754 = 0;
const $590eee45b2f4b5a8$export$6ae11180425c0cb1 = 0;
const $590eee45b2f4b5a8$export$e54b8b621c9a5e7e = "none";
const $590eee45b2f4b5a8$export$c85026323cda12ac = "none";
const $590eee45b2f4b5a8$export$33ea0b2361413c1f = "Helvetica Neue";
const $590eee45b2f4b5a8$export$e97b1368f9194929 = 400;
const $590eee45b2f4b5a8$export$1780642f5685c471 = 32;
const $590eee45b2f4b5a8$export$c3babe055b763009 = 24;
const $590eee45b2f4b5a8$export$d8f1dce60e7eacd9 = "0%";
const $590eee45b2f4b5a8$export$1850daac5eecd748 = 0;
const $590eee45b2f4b5a8$export$4b20e0da8dc66e03 = 0;
const $590eee45b2f4b5a8$export$3239c7eb20498cfe = "none";
const $590eee45b2f4b5a8$export$2a2873c645fe2e1b = "none";
const $590eee45b2f4b5a8$export$3c777a585cb58ec = "Helvetica Neue";
const $590eee45b2f4b5a8$export$b2106c41dc8777c = 400;
const $590eee45b2f4b5a8$export$7a33fdad703593b9 = 28;
const $590eee45b2f4b5a8$export$c08ab810dec3a02e = 18;
const $590eee45b2f4b5a8$export$8186c0f4e9d8d53e = "0%";
const $590eee45b2f4b5a8$export$cce2b1687d8d74ab = 0;
const $590eee45b2f4b5a8$export$6ce22ca340f96e64 = 0;
const $590eee45b2f4b5a8$export$60eeb2cf97aa1fdb = "none";
const $590eee45b2f4b5a8$export$4fd414c4a5d1ed = "none";
const $590eee45b2f4b5a8$export$f5765c5d56afcf36 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$4efdac93b8c031f3 = 400;
const $590eee45b2f4b5a8$export$bbf94eb9e9c3fb86 = 24;
const $590eee45b2f4b5a8$export$1986f92956d2cf69 = 16;
const $590eee45b2f4b5a8$export$300c3eab212cbef5 = "0%";
const $590eee45b2f4b5a8$export$ab146d8ff66bbbf5 = 0;
const $590eee45b2f4b5a8$export$b4b902883e12b78 = 0;
const $590eee45b2f4b5a8$export$28d08c4cbb57e20f = "none";
const $590eee45b2f4b5a8$export$6bcdac418900a522 = "none";
const $590eee45b2f4b5a8$export$10fcfc3f7e64ed9c = "Helvetica Neue";
const $590eee45b2f4b5a8$export$17e242d5f7403ce5 = 400;
const $590eee45b2f4b5a8$export$a5c94894e62f6149 = 20;
const $590eee45b2f4b5a8$export$69027de17ce58d50 = 14;
const $590eee45b2f4b5a8$export$e46f0991d2c4040c = "0%";
const $590eee45b2f4b5a8$export$112c8bd0b84d9a7f = 0;
const $590eee45b2f4b5a8$export$c289ed7828d8cfae = 0;
const $590eee45b2f4b5a8$export$c907894989c2c608 = "none";
const $590eee45b2f4b5a8$export$65bede91f19c65b3 = "none";
const $590eee45b2f4b5a8$export$d4a747df524fd985 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$80c5057d538df754 = 400;
const $590eee45b2f4b5a8$export$38c3dc096cb45a73 = 18;
const $590eee45b2f4b5a8$export$7e3b25c91eb80d5 = 12;
const $590eee45b2f4b5a8$export$6becbd83f6b2ece5 = "0%";
const $590eee45b2f4b5a8$export$f0dbc6426ee4013e = 0;
const $590eee45b2f4b5a8$export$f0c3ef4edb4d0681 = 0;
const $590eee45b2f4b5a8$export$9e3085cbf70874c0 = "none";
const $590eee45b2f4b5a8$export$c6e88e35297021f5 = "none";
const $590eee45b2f4b5a8$export$e4c253b4fdd5c8bd = "Helvetica Neue";
const $590eee45b2f4b5a8$export$7822c06ef9697821 = 400;
const $590eee45b2f4b5a8$export$aa1d28cf2ab80cd0 = 16;
const $590eee45b2f4b5a8$export$53f9b3fae6c0adf8 = 10;
const $590eee45b2f4b5a8$export$2cefe6550f10f1bc = "0%";
const $590eee45b2f4b5a8$export$3a7ed5d938f929c0 = 0;
const $590eee45b2f4b5a8$export$f6f8033b2206fec7 = 0;
const $590eee45b2f4b5a8$export$6bd4dedef66bbcd5 = "none";
const $590eee45b2f4b5a8$export$785a04ee2a67f56a = "none";
const $590eee45b2f4b5a8$export$bd0309fdff5ce324 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$be3cee54fbf010ac = 500;
const $590eee45b2f4b5a8$export$af0120f066604539 = 32;
const $590eee45b2f4b5a8$export$5fa9b60f488aa626 = 24;
const $590eee45b2f4b5a8$export$bfbe72f6686c282d = "0%";
const $590eee45b2f4b5a8$export$49eb5a7bb30b181a = 0;
const $590eee45b2f4b5a8$export$6354cb92c99152fb = 0;
const $590eee45b2f4b5a8$export$de3141ca52594c1d = "none";
const $590eee45b2f4b5a8$export$a5de027882363644 = "none";
const $590eee45b2f4b5a8$export$fd500d60282e8941 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$68b40d86835f6e20 = 500;
const $590eee45b2f4b5a8$export$7ade3a9440227c42 = 28;
const $590eee45b2f4b5a8$export$7a39a38167192dfb = 18;
const $590eee45b2f4b5a8$export$2857a44a139cff8b = "0%";
const $590eee45b2f4b5a8$export$54576027ebfb97ff = 0;
const $590eee45b2f4b5a8$export$6fa27769c87bd366 = 0;
const $590eee45b2f4b5a8$export$bdcf30481646a548 = "none";
const $590eee45b2f4b5a8$export$2d48240462915cdf = "none";
const $590eee45b2f4b5a8$export$e1c356845e929286 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$99a9e48d08419c04 = 500;
const $590eee45b2f4b5a8$export$120e29ae13fcf68b = 24;
const $590eee45b2f4b5a8$export$fa8c8c6a1f3b700f = 16;
const $590eee45b2f4b5a8$export$32259957cf1bf44f = "0%";
const $590eee45b2f4b5a8$export$707b4bbeb4b88f05 = 0;
const $590eee45b2f4b5a8$export$317d2c67922ad0cb = 0;
const $590eee45b2f4b5a8$export$346d28403e8ed847 = "none";
const $590eee45b2f4b5a8$export$aea1425f29a7992c = "none";
const $590eee45b2f4b5a8$export$fcd25cb19b57747f = "Helvetica Neue";
const $590eee45b2f4b5a8$export$c702f2c8b91e5dac = 500;
const $590eee45b2f4b5a8$export$800fa31cc224d2fd = 20;
const $590eee45b2f4b5a8$export$808adbba399a6506 = 14;
const $590eee45b2f4b5a8$export$2a885dd7468bb58c = "0%";
const $590eee45b2f4b5a8$export$e6fc8ea16b76b609 = 0;
const $590eee45b2f4b5a8$export$beb0dda3bce1355 = 0;
const $590eee45b2f4b5a8$export$ebdedb0d2b619773 = "none";
const $590eee45b2f4b5a8$export$bb86fa8b978463c7 = "none";
const $590eee45b2f4b5a8$export$f72cb77dda9ab41a = "Helvetica Neue";
const $590eee45b2f4b5a8$export$b3f82d7ace582b9 = 500;
const $590eee45b2f4b5a8$export$967e2604742eca2b = 18;
const $590eee45b2f4b5a8$export$49e5e4c2059f5c20 = 12;
const $590eee45b2f4b5a8$export$412ba4e6d4bdb209 = "0%";
const $590eee45b2f4b5a8$export$bb054eafccc89e44 = 0;
const $590eee45b2f4b5a8$export$d53e677f133c55fe = 0;
const $590eee45b2f4b5a8$export$c6dd5848cbe08372 = "none";
const $590eee45b2f4b5a8$export$4ef92420a963fbdc = "none";
const $590eee45b2f4b5a8$export$c57d254bd1351012 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$f21bdaa4c92ef41c = 500;
const $590eee45b2f4b5a8$export$b46cd2b984eb552b = 16;
const $590eee45b2f4b5a8$export$e7b83fdfddb4f5e9 = 10;
const $590eee45b2f4b5a8$export$f0bba12ab17907eb = "0%";
const $590eee45b2f4b5a8$export$d41c0cdf63e496bb = 0;
const $590eee45b2f4b5a8$export$2f7cb30204293e5c = 0;
const $590eee45b2f4b5a8$export$954fd63146f78661 = "none";
const $590eee45b2f4b5a8$export$8cfbebf16ab9ce21 = "none";
const $590eee45b2f4b5a8$export$43fa15f9b1161443 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$bfc21125bd5be8c9 = 400;
const $590eee45b2f4b5a8$export$ab26b21368bb116a = 32;
const $590eee45b2f4b5a8$export$a25f603e1e8abaaf = 24;
const $590eee45b2f4b5a8$export$f28f1ab51d8a96ef = "0%";
const $590eee45b2f4b5a8$export$8cea85e8b8c7b443 = 0;
const $590eee45b2f4b5a8$export$e72b06aeb1abe5ea = 0;
const $590eee45b2f4b5a8$export$8824636ca6684cd0 = "none";
const $590eee45b2f4b5a8$export$1c6a4e6611bd887c = "underline";
const $590eee45b2f4b5a8$export$30200a59a7b41a14 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$c5c8602bece5ea66 = 400;
const $590eee45b2f4b5a8$export$b9fa18a76607b200 = 28;
const $590eee45b2f4b5a8$export$74fa21d16d71f8b9 = 18;
const $590eee45b2f4b5a8$export$b4b6b76a18a62c7f = "0%";
const $590eee45b2f4b5a8$export$b4dcba5091188895 = 0;
const $590eee45b2f4b5a8$export$e43c66ebf83b44e3 = 0;
const $590eee45b2f4b5a8$export$c4abdbd1cd7afdbd = "none";
const $590eee45b2f4b5a8$export$20a7f5fac1e24fb0 = "underline";
const $590eee45b2f4b5a8$export$d48eb10d85d3ddde = "Helvetica Neue";
const $590eee45b2f4b5a8$export$58134dbe8d6ea6b2 = 400;
const $590eee45b2f4b5a8$export$e57476518d302739 = 24;
const $590eee45b2f4b5a8$export$ef443d51f0b128b = 16;
const $590eee45b2f4b5a8$export$65e85ba1b75278d9 = "0%";
const $590eee45b2f4b5a8$export$39c6c8b49cd480f6 = 0;
const $590eee45b2f4b5a8$export$102e6ff9defc2374 = 0;
const $590eee45b2f4b5a8$export$f7b5aff6f38f472d = "none";
const $590eee45b2f4b5a8$export$93882d553f55d1da = "underline";
const $590eee45b2f4b5a8$export$ec734e0aa9967354 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$c23273c6909be83d = 400;
const $590eee45b2f4b5a8$export$a9953ce6112a12de = 20;
const $590eee45b2f4b5a8$export$3eedbc45e050fffd = 14;
const $590eee45b2f4b5a8$export$16f6f7ccf4fc7220 = "0%";
const $590eee45b2f4b5a8$export$5d04d2519f931ec9 = 0;
const $590eee45b2f4b5a8$export$bd74cc84781e24a4 = 0;
const $590eee45b2f4b5a8$export$3e18ba893bd862a7 = "none";
const $590eee45b2f4b5a8$export$be6e37e703bb5551 = "underline";
const $590eee45b2f4b5a8$export$84d2e277d6070ae4 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$41d8d509f8e76b56 = 400;
const $590eee45b2f4b5a8$export$f72409b4949457e3 = 18;
const $590eee45b2f4b5a8$export$41561efef079c238 = 12;
const $590eee45b2f4b5a8$export$4103d68be6712477 = "0%";
const $590eee45b2f4b5a8$export$6b36069ed177153b = 0;
const $590eee45b2f4b5a8$export$994470db89996e8d = 0;
const $590eee45b2f4b5a8$export$a252266e2ae1b2e2 = "none";
const $590eee45b2f4b5a8$export$29e30791a94581f0 = "underline";
const $590eee45b2f4b5a8$export$40bb710796c2dfb6 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$11b7a921a9a87dd4 = 400;
const $590eee45b2f4b5a8$export$565f329e2a6a9e51 = 16;
const $590eee45b2f4b5a8$export$7a15b652d180dc90 = 10;
const $590eee45b2f4b5a8$export$c50a6e11e72579a5 = "0%";
const $590eee45b2f4b5a8$export$1669ca53678e499c = 0;
const $590eee45b2f4b5a8$export$c70b736172344c1a = 0;
const $590eee45b2f4b5a8$export$5293dcb7e20a6904 = "none";
const $590eee45b2f4b5a8$export$5d01cce0680059c = "underline";
const $590eee45b2f4b5a8$export$1c73f78b0ebc8758 = "Helvetica Neue";
const $590eee45b2f4b5a8$export$5153e2b97b52496 = 500;
const $590eee45b2f4b5a8$export$b8793440059a10a6 = 28;
const $590eee45b2f4b5a8$export$c2e8b99552f3690d = 18;
const $590eee45b2f4b5a8$export$12514d49352d9d60 = "0%";
const $590eee45b2f4b5a8$export$f333a5340f1dd20e = 0;
const $590eee45b2f4b5a8$export$15e24d3ddecfd99e = 0;
const $590eee45b2f4b5a8$export$9bd88b4641092732 = "none";
const $590eee45b2f4b5a8$export$f29cf82b27aec2db = "none";
const $590eee45b2f4b5a8$export$76d56331f9bc203b = "Helvetica Neue";
const $590eee45b2f4b5a8$export$5f47ab32c5ca034e = 500;
const $590eee45b2f4b5a8$export$33fd2561203dee2e = 24;
const $590eee45b2f4b5a8$export$b52a4ab3fc8d5633 = 16;
const $590eee45b2f4b5a8$export$240c89b94ed04c53 = "0%";
const $590eee45b2f4b5a8$export$3564c3acdd06f97a = 0;
const $590eee45b2f4b5a8$export$b8f0d933d2c923a3 = 0;
const $590eee45b2f4b5a8$export$e2c645197509422 = "none";
const $590eee45b2f4b5a8$export$f037a438bba65086 = "none";
const $590eee45b2f4b5a8$export$b58ee2cddcfa0a3c = "Helvetica Neue";
const $590eee45b2f4b5a8$export$428e07a28b3b6026 = 500;
const $590eee45b2f4b5a8$export$fc2908fe8e6b310c = 20;
const $590eee45b2f4b5a8$export$4f038b27f964d915 = 14;
const $590eee45b2f4b5a8$export$986bfaa1aa2d293b = "0%";
const $590eee45b2f4b5a8$export$a037b08e914a0acd = 0;
const $590eee45b2f4b5a8$export$18ab327a24abe91f = 0;
const $590eee45b2f4b5a8$export$c67b1538c9f307f4 = "none";
const $590eee45b2f4b5a8$export$70e12cde98ec0473 = "none";
const $590eee45b2f4b5a8$export$993f5ca1aced2c9 = "#fafafa";
const $590eee45b2f4b5a8$export$1a357d028333308a = "#6e6764";
const $590eee45b2f4b5a8$export$90cfbd2e6796672c = "#5e5856";
const $590eee45b2f4b5a8$export$5243b0cc57f410c2 = "#403b39";
const $590eee45b2f4b5a8$export$24ea9f9eb19eaf3d = "#1a1a1a";
const $590eee45b2f4b5a8$export$75380f08893c757c = "#c23300";
const $590eee45b2f4b5a8$export$9b16a769d5781f76 = "#751f00";
const $590eee45b2f4b5a8$export$66493327321323ad = "#c30909";
const $590eee45b2f4b5a8$export$5be70e40251e6f9b = "#f5ba31";
const $590eee45b2f4b5a8$export$5edb0957c158f31c = "#2471f5";
const $590eee45b2f4b5a8$export$9cae035d1b6ae1dc = "#08a141";
const $590eee45b2f4b5a8$export$b3d20c8ec09e98bc = "#fafafa";
const $590eee45b2f4b5a8$export$2acf0bd6e4a649be = "#cac6c5";
const $590eee45b2f4b5a8$export$78c7442df4e4fa92 = "#6e6764";
const $590eee45b2f4b5a8$export$e9cb372114aadf30 = "#5e5856";
const $590eee45b2f4b5a8$export$27612612c66000ae = "#403b39";
const $590eee45b2f4b5a8$export$f820c0a220822c5 = "#1a1a1a";
const $590eee45b2f4b5a8$export$3a4601f6f873d8a = "#c30909";
const $590eee45b2f4b5a8$export$65d709c7d4424538 = "#c23300";
const $590eee45b2f4b5a8$export$6aba7ce9a9a6ceb = "#2d5ab4";
const $590eee45b2f4b5a8$export$12e3571bf85cb604 = "#2471f5";
const $590eee45b2f4b5a8$export$df1e6677042a0997 = "#08a141";
const $590eee45b2f4b5a8$export$1808bbce9ce3d821 = "#f5ba31";
const $590eee45b2f4b5a8$export$5273722fbdc5ce7b = "#fafafa";
const $590eee45b2f4b5a8$export$c500f73a63679704 = "#f5f5f5";
const $590eee45b2f4b5a8$export$7c019747e1c094e8 = "#ededed";
const $590eee45b2f4b5a8$export$74bec8fff1ee428 = "#e6e6e6";
const $590eee45b2f4b5a8$export$5620df9d7014777 = "#f3ebe8";
const $590eee45b2f4b5a8$export$9dde2a87e9b8c926 = "#f3efe8";
const $590eee45b2f4b5a8$export$ffb2798d2b4dbfbe = "#dbe0eb";
const $590eee45b2f4b5a8$export$e8807b35956ebe9e = "#e8f3ec";
const $590eee45b2f4b5a8$export$e37de4b4fac6db2b = "#fafafa";
const $590eee45b2f4b5a8$export$28e00750b991884e = "#e6e6e6";
const $590eee45b2f4b5a8$export$4f99ab36c26efe10 = "#f5f5f5";
const $590eee45b2f4b5a8$export$e8709c1c5d5e668b = "#c23300";
const $590eee45b2f4b5a8$export$48040938cbb639bf = "#2471f5";
const $590eee45b2f4b5a8$export$b3f316d48e1c1c6b = "#08a141";
const $590eee45b2f4b5a8$export$f10ec6798286828e = "#f5ba31";
const $590eee45b2f4b5a8$export$9f2352af6fa3d8ff = "#c30909";
const $590eee45b2f4b5a8$export$9d28229a90ae9808 = "#e6e6e6";
const $590eee45b2f4b5a8$export$fa0abf3b9ffec737 = "#4f4a48";
const $590eee45b2f4b5a8$export$d4fe70c0d858b322 = "#e6e8f5";
const $590eee45b2f4b5a8$export$89757fc6b70ad930 = "#c23300";
const $590eee45b2f4b5a8$export$22259b45a1bc390d = "#a82d00";
const $590eee45b2f4b5a8$export$d1df5dfcfd7477e4 = "#8f2400";
const $590eee45b2f4b5a8$export$7f8c21e0a2a6d0fc = "#fafafa";
const $590eee45b2f4b5a8$export$a27b12126da4687f = "#cac6c5";
const $590eee45b2f4b5a8$export$a5a477a21dad7928 = "#ada6a4";
const $590eee45b2f4b5a8$export$24fd3294b7309ba1 = "#fafafa";
const $590eee45b2f4b5a8$export$a3c868e9cf82c94e = "#cac6c5";
const $590eee45b2f4b5a8$export$d40370904165c66e = "#ada6a4";
const $590eee45b2f4b5a8$export$f0f3e3baee17a67f = "#ada6a4";
const $590eee45b2f4b5a8$export$e98aa9f3e50b8670 = "#fafafa";
const $590eee45b2f4b5a8$export$b3edcfd12ee1e54e = "#f5f5f5";
const $590eee45b2f4b5a8$export$55b3678155c8978e = "#ededed";
const $590eee45b2f4b5a8$export$ec686f240b7b1594 = "#c23300";
const $590eee45b2f4b5a8$export$d40d2299f4fa6d58 = "#a82d00";
const $590eee45b2f4b5a8$export$877c121c7c0baaa9 = "#8f2400";
const $590eee45b2f4b5a8$export$12e5c37a32ae1343 = "#c23300";
const $590eee45b2f4b5a8$export$ae33e66d4b63717d = "#c23300";
const $590eee45b2f4b5a8$export$c863636218ea0da9 = "#a82d00";
const $590eee45b2f4b5a8$export$e492196b9ac3af4c = "#a82d00";
const $590eee45b2f4b5a8$export$c3d941e950932122 = "#8f2400";
const $590eee45b2f4b5a8$export$cb9b7388ebc4e510 = "#8f2400";
const $590eee45b2f4b5a8$export$edd5c7d6324d9b6e = "#c23300";
const $590eee45b2f4b5a8$export$d9fa2bcbf5df1836 = "#c23300";
const $590eee45b2f4b5a8$export$164da1d739f2b545 = "#c23300";
const $590eee45b2f4b5a8$export$6e452cdcdd11b5ce = "#a82d00";
const $590eee45b2f4b5a8$export$bdc22f41e159ca50 = "#a82d00";
const $590eee45b2f4b5a8$export$ade54236f991d9b0 = "#a82d00";
const $590eee45b2f4b5a8$export$b4f5d1017dd8674a = "#8f2400";
const $590eee45b2f4b5a8$export$94f0aac6620cb39b = "#8f2400";
const $590eee45b2f4b5a8$export$a563447fea233d7c = "#8f2400";
const $590eee45b2f4b5a8$export$43c02427260a010a = "#c23300";
const $590eee45b2f4b5a8$export$ab18548f5e0137ef = "#a82d00";
const $590eee45b2f4b5a8$export$e8c667d55d987d82 = "#8f2400";
const $590eee45b2f4b5a8$export$8097dca3e04b4a3f = "#c23300";
const $590eee45b2f4b5a8$export$73f824aee30f3f95 = "#a82d00";
const $590eee45b2f4b5a8$export$9e7c1d9bc04f68d6 = "#8f2400";
const $590eee45b2f4b5a8$export$5c431ba3110f33a7 = "#c23300";
const $590eee45b2f4b5a8$export$737c313dab435f03 = "#a82d00";
const $590eee45b2f4b5a8$export$78ac6175e40ad339 = "#f5f5f5";
const $590eee45b2f4b5a8$export$81f6d3f3067d733a = "#403b39";
const $590eee45b2f4b5a8$export$647e0840d9d327e8 = "#403b39";
const $590eee45b2f4b5a8$export$df247ad6dd8688ce = "#fafafa";
const $590eee45b2f4b5a8$export$f5af98448bf855c = "#fafafa";
const $590eee45b2f4b5a8$export$ab5483b358ac0e4 = "#f5f5f5";
const $590eee45b2f4b5a8$export$70a6b59688980552 = "#ededed";
const $590eee45b2f4b5a8$export$194e0c930c1614d = "#e6e6e6";
const $590eee45b2f4b5a8$export$8850788a6c30f50d = "#c23300";
const $590eee45b2f4b5a8$export$d3059d65aaa7fc87 = "#cac6c5";
const $590eee45b2f4b5a8$export$2e869c4e839a0066 = "#fafafa";
const $590eee45b2f4b5a8$export$796dc8fdca918adf = "#403b39";
const $590eee45b2f4b5a8$export$364846c5400b83e3 = "#5e5856";
const $590eee45b2f4b5a8$export$c61be8db8d528998 = "#751f00";
const $590eee45b2f4b5a8$export$29650df12b790c63 = "#fafafa";
const $590eee45b2f4b5a8$export$2153df39761f2b4 = "#fafafa";
const $590eee45b2f4b5a8$export$5a78eb203bf6ad01 = "#ada6a4";
const $590eee45b2f4b5a8$export$54830509930cfa97 = 0;
const $590eee45b2f4b5a8$export$c7a01a900877df68 = 2;
const $590eee45b2f4b5a8$export$4cacc6533891eb93 = 4;
const $590eee45b2f4b5a8$export$59237760b754467e = 0;
const $590eee45b2f4b5a8$export$f0a163cab0d1f2a2 = "#1a1a1a33";
const $590eee45b2f4b5a8$export$ed948376ecb2a82b = "dropShadow";
const $590eee45b2f4b5a8$export$8063186e2605c4c0 = 0;
const $590eee45b2f4b5a8$export$af2ee9449b4f80ef = 4;
const $590eee45b2f4b5a8$export$2e58cd7e031981d = 6;
const $590eee45b2f4b5a8$export$6d57cbe9153de068 = 0;
const $590eee45b2f4b5a8$export$4c781b365d3f391d = "#1a1a1a33";
const $590eee45b2f4b5a8$export$b510097fb9747874 = "dropShadow";
const $590eee45b2f4b5a8$export$8721c2578018abd6 = 0;
const $590eee45b2f4b5a8$export$6e4a2da01a787ed7 = -2;
const $590eee45b2f4b5a8$export$90890220a4bbb4fa = 4;
const $590eee45b2f4b5a8$export$82a8e09d9376d4c4 = 0;
const $590eee45b2f4b5a8$export$96818d417656b4a8 = "#1a1a1a33";
const $590eee45b2f4b5a8$export$e3791fbef71aef18 = "dropShadow";
const $590eee45b2f4b5a8$export$d9755d4209bc90b9 = 0;
const $590eee45b2f4b5a8$export$b803f41cd8b9ba11 = -4;
const $590eee45b2f4b5a8$export$80339dc37cbd77f6 = 6;
const $590eee45b2f4b5a8$export$d1dd15a047ebf818 = 0;
const $590eee45b2f4b5a8$export$3a1f65e90330bb44 = "#1a1a1a33";
const $590eee45b2f4b5a8$export$ee8555135dc7ff56 = "dropShadow";
const $590eee45b2f4b5a8$export$1abf36ebf1b2c0ee = -2;
const $590eee45b2f4b5a8$export$8150da37908b4677 = 0;
const $590eee45b2f4b5a8$export$44343243665d9b59 = 4;
const $590eee45b2f4b5a8$export$f29f8da08803ebd4 = 0;
const $590eee45b2f4b5a8$export$d2cad09d9d907bff = "#1a1a1a33";
const $590eee45b2f4b5a8$export$a90376f286bc8dea = "dropShadow";
const $590eee45b2f4b5a8$export$c2334ed526c602 = -4;
const $590eee45b2f4b5a8$export$9ab80262256cc828 = 0;
const $590eee45b2f4b5a8$export$128cc2ba417eccf1 = 6;
const $590eee45b2f4b5a8$export$9e835ef6b53f9290 = 0;
const $590eee45b2f4b5a8$export$4363ca23badb3f59 = "#1a1a1a33";
const $590eee45b2f4b5a8$export$492bd851af859cf9 = "dropShadow";
const $590eee45b2f4b5a8$export$b2b581580a60c4eb = 2;
const $590eee45b2f4b5a8$export$ed532847b77b5a82 = 0;
const $590eee45b2f4b5a8$export$2feffbc2fa69e257 = 4;
const $590eee45b2f4b5a8$export$9954b802b2e564be = 0;
const $590eee45b2f4b5a8$export$c6defa75d9e66336 = "#1a1a1a33";
const $590eee45b2f4b5a8$export$808891f431cc1a1e = "dropShadow";
const $590eee45b2f4b5a8$export$ffc743971d90eb81 = 4;
const $590eee45b2f4b5a8$export$9bfdd7a586c47c19 = 0;
const $590eee45b2f4b5a8$export$6a6166d2e7fa4d69 = 6;
const $590eee45b2f4b5a8$export$a3249067ec37b98f = 0;
const $590eee45b2f4b5a8$export$bc6c3059b6b4ed6a = "#1a1a1a33";
const $590eee45b2f4b5a8$export$21d17c78ad17dc1e = "dropShadow";
const $590eee45b2f4b5a8$export$9ccd7d778bacab0 = 0;
const $590eee45b2f4b5a8$export$808181978586874d = 0;
const $590eee45b2f4b5a8$export$33b10531a8f1147a = 4;
const $590eee45b2f4b5a8$export$3baa390bbaf94ffc = 0;
const $590eee45b2f4b5a8$export$318eb825a42321c2 = "#1a1a1a33";
const $590eee45b2f4b5a8$export$ac7d6ce0d628bf05 = "dropShadow";
const $590eee45b2f4b5a8$export$f5a2118233a2e007 = 0;
const $590eee45b2f4b5a8$export$f3eeed47cf2e3c39 = 0;
const $590eee45b2f4b5a8$export$b9e2893963198445 = 6;
const $590eee45b2f4b5a8$export$1d0bac02874010b0 = 0;
const $590eee45b2f4b5a8$export$2b61bfdf544ecbee = "#1a1a1a33";
const $590eee45b2f4b5a8$export$7397aa91c26b9889 = "dropShadow";
const $590eee45b2f4b5a8$export$82e1976588d1fc7c = 0;
const $590eee45b2f4b5a8$export$cd569af2f704f216 = 2;
const $590eee45b2f4b5a8$export$c45f94b963c4c37b = 4;
const $590eee45b2f4b5a8$export$5231156381f9884e = 0;
const $590eee45b2f4b5a8$export$fac8e8efc20285b1 = "#1a1a1a66";
const $590eee45b2f4b5a8$export$7bc123f979456291 = "dropShadow";
const $590eee45b2f4b5a8$export$bb718256bdc93030 = 0;
const $590eee45b2f4b5a8$export$68a04312d13c435e = 4;
const $590eee45b2f4b5a8$export$141ea3c7a2a4ffae = 6;
const $590eee45b2f4b5a8$export$cf99f4d4eaaa0ebe = 0;
const $590eee45b2f4b5a8$export$6e54868b3ce24ce4 = "#1a1a1a66";
const $590eee45b2f4b5a8$export$4e33171600536080 = "dropShadow";
const $590eee45b2f4b5a8$export$3fc441af2807f617 = -2;
const $590eee45b2f4b5a8$export$69cd70ae4b857d31 = 0;
const $590eee45b2f4b5a8$export$c6d0c4dd0914cad7 = 4;
const $590eee45b2f4b5a8$export$e8eb84f6bf6f12cd = 0;
const $590eee45b2f4b5a8$export$7a0d0422d1f96461 = "#1a1a1a66";
const $590eee45b2f4b5a8$export$d87d7c3e50933681 = "dropShadow";
const $590eee45b2f4b5a8$export$656ef8a7317a05b6 = -4;
const $590eee45b2f4b5a8$export$b7b79fafc3622ee8 = 0;
const $590eee45b2f4b5a8$export$77aba2807f660279 = 6;
const $590eee45b2f4b5a8$export$e405467fe6a06ebf = 0;
const $590eee45b2f4b5a8$export$fcbba5aeec09583e = "#1a1a1a66";
const $590eee45b2f4b5a8$export$995a86d60ebf4309 = "dropShadow";
const $590eee45b2f4b5a8$export$e7ae1ae56ef8df6d = 2;
const $590eee45b2f4b5a8$export$1e4f38b195d94a22 = 0;
const $590eee45b2f4b5a8$export$7e7a4155b199337f = 4;
const $590eee45b2f4b5a8$export$90cb820dd21c9b29 = 0;
const $590eee45b2f4b5a8$export$1cef1185b57f2f4b = "#1a1a1a66";
const $590eee45b2f4b5a8$export$c455b156c23bf810 = "dropShadow";
const $590eee45b2f4b5a8$export$884e2ff630c54013 = 4;
const $590eee45b2f4b5a8$export$99cc121aeeb0b72d = 0;
const $590eee45b2f4b5a8$export$16d1f5517a2ab40e = 6;
const $590eee45b2f4b5a8$export$e38f0420dd71fd6b = 0;
const $590eee45b2f4b5a8$export$e1f6dd4d2039a157 = "#1a1a1a66";
const $590eee45b2f4b5a8$export$5b581b9541dab3b0 = "dropShadow";
const $590eee45b2f4b5a8$export$61f9e7afafad9e7c = 0;
const $590eee45b2f4b5a8$export$df59fc6cd25de1ce = -2;
const $590eee45b2f4b5a8$export$fde39a50dcdae67c = 4;
const $590eee45b2f4b5a8$export$f429adaf4221ab2a = 0;
const $590eee45b2f4b5a8$export$a9795de1832e6eef = "#1a1a1a66";
const $590eee45b2f4b5a8$export$57e954437b175bde = "dropShadow";
const $590eee45b2f4b5a8$export$4f926ff1a968dd52 = 0;
const $590eee45b2f4b5a8$export$613205e07205381 = -4;
const $590eee45b2f4b5a8$export$3070bb33bca86de1 = 6;
const $590eee45b2f4b5a8$export$d55b5088a5655087 = 0;
const $590eee45b2f4b5a8$export$5ac6cebab9d91f2c = "#1a1a1a66";
const $590eee45b2f4b5a8$export$56d6cd37a1b642dc = "dropShadow";
const $590eee45b2f4b5a8$export$775840481491ba6d = 0;
const $590eee45b2f4b5a8$export$86572c2d71cac24e = 0;
const $590eee45b2f4b5a8$export$872c4340288c7ba6 = 4;
const $590eee45b2f4b5a8$export$5b3a61904624db37 = 0;
const $590eee45b2f4b5a8$export$5a75ada0c0b35704 = "#1a1a1a66";
const $590eee45b2f4b5a8$export$7cb18ced48862d1e = "dropShadow";
const $590eee45b2f4b5a8$export$701c1e6157910c76 = 0;
const $590eee45b2f4b5a8$export$1c0e94de8e9c33ac = 0;
const $590eee45b2f4b5a8$export$fcd1ca1cfe1a7c98 = 6;
const $590eee45b2f4b5a8$export$58006b6be722191c = 0;
const $590eee45b2f4b5a8$export$2bee272cacea1107 = "#1a1a1a66";
const $590eee45b2f4b5a8$export$a5348d120010434c = "dropShadow";
const $590eee45b2f4b5a8$export$ed3436448555521c = 0;
const $590eee45b2f4b5a8$export$b61940449d0fd1c2 = 2;
const $590eee45b2f4b5a8$export$84ced8abb997d88a = 4;
const $590eee45b2f4b5a8$export$be00afaa3c1d88e1 = 0;
const $590eee45b2f4b5a8$export$ad1e08faf53ffed0 = "#1a1a1a99";
const $590eee45b2f4b5a8$export$6145277ad8d63af5 = "dropShadow";
const $590eee45b2f4b5a8$export$62730874a6820f04 = 0;
const $590eee45b2f4b5a8$export$6a41e59fc5cf0b0a = 4;
const $590eee45b2f4b5a8$export$8c8655252e9246db = 6;
const $590eee45b2f4b5a8$export$b23a6d415651bd7b = 0;
const $590eee45b2f4b5a8$export$e911b675050534fe = "#1a1a1a99";
const $590eee45b2f4b5a8$export$4abb39c6d4ac170d = "dropShadow";
const $590eee45b2f4b5a8$export$6fcfa1bbd70748d6 = 0;
const $590eee45b2f4b5a8$export$3879f89f3d4d76a0 = -2;
const $590eee45b2f4b5a8$export$4b2624755df4e8f2 = 4;
const $590eee45b2f4b5a8$export$2fb5ef74fe5d7f2c = 0;
const $590eee45b2f4b5a8$export$6165f1f2b84153e0 = "#1a1a1a99";
const $590eee45b2f4b5a8$export$2c62c2c5ebe93b03 = "dropShadow";
const $590eee45b2f4b5a8$export$e4e6135a94bb81f9 = 0;
const $590eee45b2f4b5a8$export$2ce708d1177272b1 = -4;
const $590eee45b2f4b5a8$export$f346bc2c80d70af5 = 6;
const $590eee45b2f4b5a8$export$af58b1e991b9ca23 = 0;
const $590eee45b2f4b5a8$export$549299c017a4940e = "#1a1a1a99";
const $590eee45b2f4b5a8$export$47d70ac86c1261fd = "dropShadow";
const $590eee45b2f4b5a8$export$82fb18a19aa3b262 = -2;
const $590eee45b2f4b5a8$export$59fc5df3309a7324 = 0;
const $590eee45b2f4b5a8$export$5262f62f24800e0e = 4;
const $590eee45b2f4b5a8$export$678832c866fce815 = 0;
const $590eee45b2f4b5a8$export$4a4ecf011e60a090 = "#1a1a1a99";
const $590eee45b2f4b5a8$export$87e8901d6b906d3a = "dropShadow";
const $590eee45b2f4b5a8$export$d0230af3f90d4f80 = -4;
const $590eee45b2f4b5a8$export$95b86f833548524c = 0;
const $590eee45b2f4b5a8$export$6664cdd378214656 = 6;
const $590eee45b2f4b5a8$export$e277f4cadd0b42b5 = 0;
const $590eee45b2f4b5a8$export$ad0454bd9ebc9746 = "#1a1a1a99";
const $590eee45b2f4b5a8$export$ce229a21af21a283 = "dropShadow";
const $590eee45b2f4b5a8$export$d1542f6144a5bdc1 = 2;
const $590eee45b2f4b5a8$export$a19ecdf051c3b924 = 0;
const $590eee45b2f4b5a8$export$307492eeb7dba2e6 = 4;
const $590eee45b2f4b5a8$export$e9dba33dd3a21950 = 0;
const $590eee45b2f4b5a8$export$b7fe46d083b81625 = "#1a1a1a99";
const $590eee45b2f4b5a8$export$8c02e4e1de9c1b62 = "dropShadow";
const $590eee45b2f4b5a8$export$bdeb0b51d804bac3 = 4;
const $590eee45b2f4b5a8$export$c04f06c9008f4160 = 0;
const $590eee45b2f4b5a8$export$a0545eb62eecc160 = 6;
const $590eee45b2f4b5a8$export$fb98fb386d30bca2 = 0;
const $590eee45b2f4b5a8$export$a17cd78f0483aa3 = "#1a1a1a99";
const $590eee45b2f4b5a8$export$27108b211d4bf1c3 = "dropShadow";
const $590eee45b2f4b5a8$export$c65816dd5911d099 = 0;
const $590eee45b2f4b5a8$export$17b569b3abb248db = 0;
const $590eee45b2f4b5a8$export$6eec4f3de25c578e = 4;
const $590eee45b2f4b5a8$export$d8763dbf3572e8a3 = 0;
const $590eee45b2f4b5a8$export$9ced98c67ae6a781 = "#1a1a1a99";
const $590eee45b2f4b5a8$export$8775db9d6928bd50 = "dropShadow";
const $590eee45b2f4b5a8$export$13d9fc6fc4f0a03a = 0;
const $590eee45b2f4b5a8$export$a264d5885a507a64 = 0;
const $590eee45b2f4b5a8$export$75383a46d1fc090b = 6;
const $590eee45b2f4b5a8$export$be941ba6a1339b9c = 0;
const $590eee45b2f4b5a8$export$a7b7738de9b5807d = "#1a1a1a99";
const $590eee45b2f4b5a8$export$712a0458fadea8f6 = "dropShadow";
const $590eee45b2f4b5a8$export$740bd960cf8d6dad = "#fafafa";
const $590eee45b2f4b5a8$export$2f62d126c50939e2 = "#e6e6e6";
const $590eee45b2f4b5a8$export$ec9cec10af03c979 = "#5e5856";
const $590eee45b2f4b5a8$export$ae801e356712c603 = "#403b39";
const $590eee45b2f4b5a8$export$e4b1458c7b948ca9 = "#5e5856";
const $590eee45b2f4b5a8$export$c8e026ccbce64b26 = "#403b39";
const $590eee45b2f4b5a8$export$13b1fbbcda18d79b = "#c23300";
const $590eee45b2f4b5a8$export$646efb6397923ec = "Helvetica Neue";
const $590eee45b2f4b5a8$export$4c754db1aaeee32b = 64;
const $590eee45b2f4b5a8$export$2bd28778f3e6bac = 60;
const $590eee45b2f4b5a8$export$15db5bf451a801aa = 48;
const $590eee45b2f4b5a8$export$ab9196fcc25be1a = 32;
const $590eee45b2f4b5a8$export$a7dfb7cada3ab45 = 28;
const $590eee45b2f4b5a8$export$8139ef676b4e195a = 24;
const $590eee45b2f4b5a8$export$a99590973e55a97e = 20;
const $590eee45b2f4b5a8$export$4eb6bf2642bd63e2 = 18;
const $590eee45b2f4b5a8$export$6289b5a00e97850 = 16;
const $590eee45b2f4b5a8$export$a035dab7a4764446 = 300;
const $590eee45b2f4b5a8$export$9cf11e343e593874 = 500;
const $590eee45b2f4b5a8$export$d110ca4a94fba3a8 = 400;
const $590eee45b2f4b5a8$export$8fd308bfa00e6293 = 10;
const $590eee45b2f4b5a8$export$bd4eee9ac38dcb16 = 12;
const $590eee45b2f4b5a8$export$a2163312de15f704 = 14;
const $590eee45b2f4b5a8$export$18961b6d6062b21f = 18;
const $590eee45b2f4b5a8$export$28444e249d85955d = 24;
const $590eee45b2f4b5a8$export$e8408e6e870c1466 = 32;
const $590eee45b2f4b5a8$export$9afe821f84d27aca = 40;
const $590eee45b2f4b5a8$export$26b9c3035f29b72b = 48;
const $590eee45b2f4b5a8$export$4bb0c9e28864c3bc = 16;
const $590eee45b2f4b5a8$export$97dd767df9e3dbb = "0%";
const $590eee45b2f4b5a8$export$e6e7e5cb83ecf97a = 0;
const $590eee45b2f4b5a8$export$1290a4b4758cbdcb = "none";
const $590eee45b2f4b5a8$export$54f69077a28cb4a0 = "none";
const $590eee45b2f4b5a8$export$b03f54a1be1b6736 = "underline";
const $590eee45b2f4b5a8$export$b211ec951a5f8d9b = "#f3ebe8";
const $590eee45b2f4b5a8$export$22d080e95259e9f7 = "#fa7342";
const $590eee45b2f4b5a8$export$ceb1df752473f776 = "#f95215";
const $590eee45b2f4b5a8$export$d7d337f833701c0e = "#db3a00";
const $590eee45b2f4b5a8$export$65ba7e8b8b6cf01a = "#c23300";
const $590eee45b2f4b5a8$export$c89299924d844f0f = "#a82d00";
const $590eee45b2f4b5a8$export$cf646e73036934ce = "#8f2400";
const $590eee45b2f4b5a8$export$3146b3714cf9b9a4 = "#751f00";
const $590eee45b2f4b5a8$export$1d6558d856838ff1 = "#e6e8f5";
const $590eee45b2f4b5a8$export$8db0e96a3bb830ea = "#c3c8e6";
const $590eee45b2f4b5a8$export$1e3cbfe2f66aec97 = "#8c9bcd";
const $590eee45b2f4b5a8$export$f5a24885553e1305 = "#5f77b9";
const $590eee45b2f4b5a8$export$cac7a624f2777488 = "#2d5ab4";
const $590eee45b2f4b5a8$export$efb78b0c9c036725 = "#284687";
const $590eee45b2f4b5a8$export$4750e12427cead73 = "#193264";
const $590eee45b2f4b5a8$export$46994b0398cf817a = "#051441";
const $590eee45b2f4b5a8$export$38294672be7f03aa = "#e4e2e2";
const $590eee45b2f4b5a8$export$fa724cacf6f2839c = "#cac6c5";
const $590eee45b2f4b5a8$export$1ae1cebe22dcedb4 = "#ada6a4";
const $590eee45b2f4b5a8$export$ea4b07cc638db010 = "#938b88";
const $590eee45b2f4b5a8$export$3274407c470cc307 = "#6e6764";
const $590eee45b2f4b5a8$export$79eae692a1215ced = "#5e5856";
const $590eee45b2f4b5a8$export$a47549b7706958f = "#4f4a48";
const $590eee45b2f4b5a8$export$a9c0ef0cf247423d = "#403b39";
const $590eee45b2f4b5a8$export$ce4c96c681f74f16 = "#fafafa";
const $590eee45b2f4b5a8$export$3f00b0fb16b195b4 = "#f5f5f5";
const $590eee45b2f4b5a8$export$faf805d08d735f2a = "#ededed";
const $590eee45b2f4b5a8$export$26553509f5970e6f = "#e6e6e6";
const $590eee45b2f4b5a8$export$86d4f15f0992f910 = "#595959";
const $590eee45b2f4b5a8$export$25e7eddc778cc2c8 = "#4d4d4d";
const $590eee45b2f4b5a8$export$f3b92e92ff5f4448 = "#333333";
const $590eee45b2f4b5a8$export$bbb740810e88602b = "#1a1a1a";
const $590eee45b2f4b5a8$export$9078c51d1d0b33cd = 2;
const $590eee45b2f4b5a8$export$6eac148052ad90cb = 4;
const $590eee45b2f4b5a8$export$c379318046269863 = "#e8f3ec";
const $590eee45b2f4b5a8$export$177e19beae9b12b5 = "#08a141";
const $590eee45b2f4b5a8$export$d91201a2ecb9c802 = "#dbe0eb";
const $590eee45b2f4b5a8$export$a0c3172074063f2e = "#2471f5";
const $590eee45b2f4b5a8$export$32deeab16c8572ff = "#f3ebe8";
const $590eee45b2f4b5a8$export$ba73aa8c8f437d22 = "#c30909";
const $590eee45b2f4b5a8$export$43403c47a2c0cd04 = "#f3efe8";
const $590eee45b2f4b5a8$export$37318cdd51c50c53 = "#f5ba31";
const $590eee45b2f4b5a8$export$a1b13b0099b51b3f = 8;
const $590eee45b2f4b5a8$export$377770b16f70f79e = 16;
const $590eee45b2f4b5a8$export$cd9ead0feef17e8f = 1;
const $590eee45b2f4b5a8$export$3373d970111b7d43 = 2;
const $590eee45b2f4b5a8$export$43179893ad9f1189 = 4;
const $590eee45b2f4b5a8$export$7a0415b986e0612e = 8;
const $590eee45b2f4b5a8$export$6acf6eb6495d450b = "20%";
const $590eee45b2f4b5a8$export$a29839f1461b65ad = "40%";
const $590eee45b2f4b5a8$export$a9c84a7a66e5bf43 = "60%";
const $590eee45b2f4b5a8$export$76e62bb62497815e = "70%";
const $590eee45b2f4b5a8$export$845501b417ddb231 = "80%";
const $590eee45b2f4b5a8$export$5c5b23c24f336104 = "90%";
const $590eee45b2f4b5a8$export$4eaa1d4f12b95711 = 2;
const $590eee45b2f4b5a8$export$ed7bdee048351354 = 4;
const $590eee45b2f4b5a8$export$381f0d4736587f5e = 8;
const $590eee45b2f4b5a8$export$a275cc59cf419b0e = 12;
const $590eee45b2f4b5a8$export$2e9d67b3a51e4aea = 16;
const $590eee45b2f4b5a8$export$3ba0070c9b17960f = 24;
const $590eee45b2f4b5a8$export$9eb2f1764dbb2e83 = 32;
const $590eee45b2f4b5a8$export$cc470731e2bfd3d2 = 40;
const $590eee45b2f4b5a8$export$8bc24d096e81d267 = "#1a1a1a1a";
const $590eee45b2f4b5a8$export$a3733a66f0025093 = "#1a1a1a33";
const $590eee45b2f4b5a8$export$840139ced5ac3c31 = "#1a1a1a4d";
const $590eee45b2f4b5a8$export$1ceba053aead0823 = "#1a1a1a66";
const $590eee45b2f4b5a8$export$54ce381e4393e8a0 = "#1a1a1a80";
const $590eee45b2f4b5a8$export$9f3af72b119b01e = "#1a1a1a99";
const $590eee45b2f4b5a8$export$c393a0b55340894e = "#1a1a1ab3";
const $590eee45b2f4b5a8$export$70268fd8f29beed2 = "#1a1a1acc";
const $590eee45b2f4b5a8$export$82bd5eb23ae328c5 = "#1a1a1ae6";
const $590eee45b2f4b5a8$export$73c941b7574bf14b = "global";
const $590eee45b2f4b5a8$export$e2b06d4229aec520 = "Light-mode";
const $590eee45b2f4b5a8$export$fd2df71c53fd0a82 = "[object Object]";
const $590eee45b2f4b5a8$export$b31917fb06a11eb4 = "[object Object]";





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $6c373dd14e8d5a80$export$e1cf286322cbb4cb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    error: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setError: ()=>{}
});


const $1071234c98a0a33d$export$8f2ccbc6b4e5d821 = (props)=>{
    const [error, setError] = (0, $acw62.useState)(undefined);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c373dd14e8d5a80$export$e1cf286322cbb4cb).Provider, {
        value: {
            error: error,
            setError: setError
        },
        children: props.children
    });
};




var $acw62 = parcelRequire("acw62");


var $6145d3befdc3de2c$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode[ErrorCode["UNKNOWN"] = 0] = "UNKNOWN";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["VALIDATION_ERROR"] = 2] = "VALIDATION_ERROR";
    ErrorCode[ErrorCode["UNAUTHENTICATED"] = 3] = "UNAUTHENTICATED";
    ErrorCode[ErrorCode["EMPTY_INPUT_VALIDATION"] = 4] = "EMPTY_INPUT_VALIDATION";
    ErrorCode[ErrorCode["EMPTY_SELECT_VALIDATION"] = 5] = "EMPTY_SELECT_VALIDATION";
    ErrorCode[ErrorCode["INVALID_BULK_UPLOAD"] = 6] = "INVALID_BULK_UPLOAD";
    ErrorCode[ErrorCode["LOGGED_OUT"] = 7] = "LOGGED_OUT";
    ErrorCode[ErrorCode["INVALID_PERMISSIONS"] = 8] = "INVALID_PERMISSIONS";
    ErrorCode[ErrorCode["BULK_UPLOAD_PARSE_ERROR_GENERIC"] = 9] = "BULK_UPLOAD_PARSE_ERROR_GENERIC";
    ErrorCode[ErrorCode["BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS"] = 10] = "BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS";
    ErrorCode[ErrorCode["BULK_UPLOAD_MAX_RECORD_SIZE"] = 11] = "BULK_UPLOAD_MAX_RECORD_SIZE";
    ErrorCode[ErrorCode["BULK_UPLOAD_INCONSISTENT_COLUMNS"] = 12] = "BULK_UPLOAD_INCONSISTENT_COLUMNS";
})($6145d3befdc3de2c$export$d4e71bc0b80dc0fb || ($6145d3befdc3de2c$export$d4e71bc0b80dc0fb = {}));


const $1e087ff174cd7c1d$export$d8bd0967cb58683 = {
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).UNKNOWN]: "An unknown error occurred",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).NETWORK_ERROR]: "A network error occurred",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).VALIDATION_ERROR]: "A validation error occurred",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).UNAUTHENTICATED]: "Invalid username / password",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).EMPTY_INPUT_VALIDATION]: "Please enter a value",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).EMPTY_SELECT_VALIDATION]: "Please select an option",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).INVALID_BULK_UPLOAD]: "Invalid bulk upload content, if you need assistance with uploading data please contact us on {{supportEmail}}",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).LOGGED_OUT]: "You have been logged out",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).INVALID_PERMISSIONS]: "You do not have permission to perform this action",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).BULK_UPLOAD_PARSE_ERROR_GENERIC]: "An error occurred while parsing the bulk upload file",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS]: "The columns in the file do not match the expected columns",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).BULK_UPLOAD_MAX_RECORD_SIZE]: "One or more fields in the file are too large",
    [(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).BULK_UPLOAD_INCONSISTENT_COLUMNS]: "The columns in the file are inconsistent, all columns must follow the same format"
};


const $a4c71e3abee08e6a$export$e0e09b7d717f1251 = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return {
        get: (error)=>t((0, $1e087ff174cd7c1d$export$d8bd0967cb58683)[error.code], {
                supportEmail: "support@rheglobal.com"
            })
    };
};


const $66bfb0253608fd83$export$5511e886634120cb = (props)=>{
    const { get: get } = (0, $a4c71e3abee08e6a$export$e0e09b7d717f1251)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: get(props.error)
    });
};






var $ac55bae635a0b519$export$15e411dc07b9c834 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9d16df24508f5c77$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "row",
        ref: ref
    }));
$ac55bae635a0b519$export$15e411dc07b9c834.displayName = "HStack";

// src/text.tsx


// src/compact.ts
function $6bc154251470a415$export$8e16b83750b44988(object) {
    const clone = Object.assign({}, object);
    for(let key in clone)if (clone[key] === void 0) delete clone[key];
    return clone;
}



var $c3398707317c270b$export$5f1af8db9871e1d6 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Text2(props, ref) {
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Text", props);
    const { className: className, align: align, decoration: decoration, casing: casing, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const aliasedProps = (0, $6bc154251470a415$export$8e16b83750b44988)({
        textAlign: props.align,
        textDecoration: props.decoration,
        textTransform: props.casing
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).p, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
    });
});
$c3398707317c270b$export$5f1af8db9871e1d6.displayName = "Text";




function $0180d89bb5504dcc$export$7d4f4094ff87ec53({ color: color = "currentColor", height: height = "24px", width: width = "24px" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: color,
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
        })
    });
}



const $0ce0e8c0ab7a5d29$export$1d64315127b209a = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        layerStyle: "primaryModalAlert",
        "data-testid": "modal-alert",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9d16df24508f5c77$export$694e0d28c7ffc90c), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
                    color: "error.icon",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0180d89bb5504dcc$export$7d4f4094ff87ec53), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                            textStyle: "textBodyMedium3",
                            color: "error.text",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "There is a problem"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                    children: props.children
                })
            ]
        })
    });
};



const $fcf4ae264bbac4fb$export$c64f601a6e4de099 = ()=>{
    const { error: error } = (0, $acw62.useContext)((0, $6c373dd14e8d5a80$export$e1cf286322cbb4cb));
    return error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ce0e8c0ab7a5d29$export$1d64315127b209a), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66bfb0253608fd83$export$5511e886634120cb), {
            error: error
        })
    }) : null;
};



// src/use-button-type.tsx

var $acw62 = parcelRequire("acw62");
function $964de075fc953d8f$export$867b668ad7ef61e5(value) {
    const [isButton, setIsButton] = (0, $acw62.useState)(!value);
    const refCallback = (0, $acw62.useCallback)((node)=>{
        if (!node) return;
        setIsButton(node.tagName === "BUTTON");
    }, []);
    const type = isButton ? "button" : void 0;
    return {
        ref: refCallback,
        type: type
    };
}


// src/button-context.ts

var [$8c725fd9c694dda4$export$85041a2bb9328e33, $8c725fd9c694dda4$export$749e21be8b14b968] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "ButtonGroupContext"
});


// src/button-icon.tsx



var $acw62 = parcelRequire("acw62");

function $fa1f56bf50313303$export$e1c22a2ee2645e36(props) {
    const { children: children, className: className, ...rest } = props;
    const _children = (0, $acw62.isValidElement)(children) ? (0, $acw62.cloneElement)(children, {
        "aria-hidden": true,
        focusable: false
    }) : children;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button__icon", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0,
        ...rest,
        className: _className,
        children: _children
    });
}
$fa1f56bf50313303$export$e1c22a2ee2645e36.displayName = "ButtonIcon";


// src/button-spinner.tsx




var $acw62 = parcelRequire("acw62");

function $d330ae21a9acd40f$export$f2c034885dd3ba7b(props) {
    const { label: label, placement: placement, spacing: spacing = "0.5rem", children: children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2), {
        color: "currentColor",
        width: "1em",
        height: "1em"
    }), className: className, __css: __css, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button__spinner", className);
    const marginProp = placement === "start" ? "marginEnd" : "marginStart";
    const spinnerStyles = (0, $acw62.useMemo)(()=>({
            display: "flex",
            alignItems: "center",
            position: label ? "relative" : "absolute",
            [marginProp]: label ? spacing : 0,
            fontSize: "1em",
            lineHeight: "normal",
            ...__css
        }), [
        __css,
        label,
        marginProp,
        spacing
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        className: _className,
        ...rest,
        __css: spinnerStyles,
        children: children
    });
}
$d330ae21a9acd40f$export$f2c034885dd3ba7b.displayName = "ButtonSpinner";


// src/index.ts

var $acw62 = parcelRequire("acw62");
function $457901a59fc0a4e6$export$d734136a7b018efe(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
function $457901a59fc0a4e6$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>{
            $457901a59fc0a4e6$export$d734136a7b018efe(ref, node);
        });
    };
}
function $457901a59fc0a4e6$export$74665b213cb5c4cf(...refs) {
    return (0, $acw62.useMemo)(()=>$457901a59fc0a4e6$export$c9058316764c140e(...refs), refs);
}





var $acw62 = parcelRequire("acw62");

var $3d4025908d716953$export$353f5b6fc5456de1 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const group = (0, $8c725fd9c694dda4$export$749e21be8b14b968)();
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Button", {
        ...group,
        ...props
    });
    const { isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, isLoading: isLoading, isActive: isActive, children: children, leftIcon: leftIcon, rightIcon: rightIcon, loadingText: loadingText, iconSpacing: iconSpacing = "0.5rem", type: type, spinner: spinner, spinnerPlacement: spinnerPlacement = "start", className: className, as: as, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const buttonStyles = (0, $acw62.useMemo)(()=>{
        const _focus = {
            ...styles == null ? void 0 : styles["_focus"],
            zIndex: 1
        };
        return {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
            position: "relative",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
            outline: "none",
            ...styles,
            ...!!group && {
                _focus: _focus
            }
        };
    }, [
        styles,
        group
    ]);
    const { ref: _ref, type: defaultType } = (0, $964de075fc953d8f$export$867b668ad7ef61e5)(as);
    const contentProps = {
        rightIcon: rightIcon,
        leftIcon: leftIcon,
        iconSpacing: iconSpacing,
        children: children
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).button, {
        ref: (0, $457901a59fc0a4e6$export$74665b213cb5c4cf)(ref, _ref),
        as: as,
        type: type != null ? type : defaultType,
        "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isActive),
        "data-loading": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isLoading),
        __css: buttonStyles,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-button", className),
        ...rest,
        disabled: isDisabled || isLoading,
        children: [
            isLoading && spinnerPlacement === "start" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d330ae21a9acd40f$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--start",
                label: loadingText,
                placement: "start",
                spacing: iconSpacing,
                children: spinner
            }),
            isLoading ? loadingText || /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
                opacity: 0,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3d4025908d716953$var$ButtonContent, {
                    ...contentProps
                })
            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3d4025908d716953$var$ButtonContent, {
                ...contentProps
            }),
            isLoading && spinnerPlacement === "end" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $d330ae21a9acd40f$export$f2c034885dd3ba7b), {
                className: "chakra-button__spinner--end",
                label: loadingText,
                placement: "end",
                spacing: iconSpacing,
                children: spinner
            })
        ]
    });
});
$3d4025908d716953$export$353f5b6fc5456de1.displayName = "Button";
function $3d4025908d716953$var$ButtonContent(props) {
    const { leftIcon: leftIcon, rightIcon: rightIcon, children: children, iconSpacing: iconSpacing } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            leftIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $fa1f56bf50313303$export$e1c22a2ee2645e36), {
                marginEnd: iconSpacing,
                children: leftIcon
            }),
            children,
            rightIcon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $fa1f56bf50313303$export$e1c22a2ee2645e36), {
                marginStart: iconSpacing,
                children: rightIcon
            })
        ]
    });
}

// src/form-control.tsx





var $acw62 = parcelRequire("acw62");

var [$cd6270424eaeb4d4$var$FormControlStylesProvider, $cd6270424eaeb4d4$export$2824197c2cd75b1e] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `FormControlStylesContext`,
    errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
});
var [$cd6270424eaeb4d4$var$FormControlProvider, $cd6270424eaeb4d4$export$97a2352498389516] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "FormControlContext"
});
function $cd6270424eaeb4d4$var$useFormControlProvider(props) {
    const { id: idProp, isRequired: isRequired, isInvalid: isInvalid, isDisabled: isDisabled, isReadOnly: isReadOnly, ...htmlProps } = props;
    const uuid = (0, $acw62.useId)();
    const id = idProp || `field-${uuid}`;
    const labelId = `${id}-label`;
    const feedbackId = `${id}-feedback`;
    const helpTextId = `${id}-helptext`;
    const [hasFeedbackText, setHasFeedbackText] = (0, $acw62.useState)(false);
    const [hasHelpText, setHasHelpText] = (0, $acw62.useState)(false);
    const [isFocused, setFocus] = (0, $acw62.useState)(false);
    const getHelpTextProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            id: helpTextId,
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasHelpText(true);
            })
        }), [
        helpTextId
    ]);
    const getLabelProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            "data-focus": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isReadOnly),
            id: props2.id !== void 0 ? props2.id : labelId,
            htmlFor: props2.htmlFor !== void 0 ? props2.htmlFor : id
        }), [
        id,
        isDisabled,
        isFocused,
        isInvalid,
        isReadOnly,
        labelId
    ]);
    const getErrorMessageProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            id: feedbackId,
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setHasFeedbackText(true);
            }),
            "aria-live": "polite"
        }), [
        feedbackId
    ]);
    const getRootProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ...htmlProps,
            ref: forwardedRef,
            role: "group"
        }), [
        htmlProps
    ]);
    const getRequiredIndicatorProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            role: "presentation",
            "aria-hidden": true,
            children: props2.children || "*"
        }), []);
    return {
        isRequired: !!isRequired,
        isInvalid: !!isInvalid,
        isReadOnly: !!isReadOnly,
        isDisabled: !!isDisabled,
        isFocused: !!isFocused,
        onFocus: ()=>setFocus(true),
        onBlur: ()=>setFocus(false),
        hasFeedbackText: hasFeedbackText,
        setHasFeedbackText: setHasFeedbackText,
        hasHelpText: hasHelpText,
        setHasHelpText: setHasHelpText,
        id: id,
        labelId: labelId,
        feedbackId: feedbackId,
        helpTextId: helpTextId,
        htmlProps: htmlProps,
        getHelpTextProps: getHelpTextProps,
        getErrorMessageProps: getErrorMessageProps,
        getRootProps: getRootProps,
        getLabelProps: getLabelProps,
        getRequiredIndicatorProps: getRequiredIndicatorProps
    };
}
var $cd6270424eaeb4d4$export$fe5d99d8691b3f62 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function FormControl2(props, ref) {
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Form", props);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { getRootProps: getRootProps, htmlProps: _, ...context } = $cd6270424eaeb4d4$var$useFormControlProvider(ownProps);
    const className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-form-control", props.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($cd6270424eaeb4d4$var$FormControlProvider, {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($cd6270424eaeb4d4$var$FormControlStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
                ...getRootProps({}, ref),
                className: className,
                __css: styles["container"]
            })
        })
    });
});
$cd6270424eaeb4d4$export$fe5d99d8691b3f62.displayName = "FormControl";
var $cd6270424eaeb4d4$export$75f9ed82f6172e27 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function FormHelperText2(props, ref) {
    const field = $cd6270424eaeb4d4$export$97a2352498389516();
    const styles = $cd6270424eaeb4d4$export$2824197c2cd75b1e();
    const className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-form__helper-text", props.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ...field == null ? void 0 : field.getHelpTextProps(props, ref),
        __css: styles.helperText,
        className: className
    });
});
$cd6270424eaeb4d4$export$75f9ed82f6172e27.displayName = "FormHelperText";







var [$9936500b9cef4dbd$var$FormErrorStylesProvider, $9936500b9cef4dbd$export$13b57d826b8f5004] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `FormErrorStylesContext`,
    errorMessage: `useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormError />" `
});
var $9936500b9cef4dbd$export$185a8afe504e8fca = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("FormError", props);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const field = (0, $cd6270424eaeb4d4$export$97a2352498389516)();
    if (!(field == null ? void 0 : field.isInvalid)) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9936500b9cef4dbd$var$FormErrorStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
            ...field == null ? void 0 : field.getErrorMessageProps(ownProps, ref),
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-form__error-message", props.className),
            __css: {
                display: "flex",
                alignItems: "center",
                ...styles.text
            }
        })
    });
});
$9936500b9cef4dbd$export$185a8afe504e8fca.displayName = "FormErrorMessage";
var $9936500b9cef4dbd$export$67864f4c98b1437d = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = $9936500b9cef4dbd$export$13b57d826b8f5004();
    const field = (0, $cd6270424eaeb4d4$export$97a2352498389516)();
    if (!(field == null ? void 0 : field.isInvalid)) return null;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-form__error-icon", props.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c7d8d08ac7551ab9$export$f04a61298a47a40f), {
        ref: ref,
        "aria-hidden": true,
        ...props,
        __css: styles.icon,
        className: _className,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        })
    });
});
$9936500b9cef4dbd$export$67864f4c98b1437d.displayName = "FormErrorIcon";





var $ef3866dc6a93af5f$export$842aba50ed0ce9d7 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function FormLabel2(passedProps, ref) {
    var _a;
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("FormLabel", passedProps);
    const props = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(passedProps);
    const { className: className, children: children, requiredIndicator: requiredIndicator = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($ef3866dc6a93af5f$export$b36d93bade3250e4, {}), optionalIndicator: optionalIndicator = null, ...rest } = props;
    const field = (0, $cd6270424eaeb4d4$export$97a2352498389516)();
    const ownProps = (_a = field == null ? void 0 : field.getLabelProps(rest, ref)) != null ? _a : {
        ref: ref,
        ...rest
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).label, {
        ...ownProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-form__label", props.className),
        __css: {
            display: "block",
            textAlign: "start",
            ...styles
        },
        children: [
            children,
            (field == null ? void 0 : field.isRequired) ? requiredIndicator : optionalIndicator
        ]
    });
});
$ef3866dc6a93af5f$export$842aba50ed0ce9d7.displayName = "FormLabel";
var $ef3866dc6a93af5f$export$b36d93bade3250e4 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function RequiredIndicator2(props, ref) {
    const field = (0, $cd6270424eaeb4d4$export$97a2352498389516)();
    const styles = (0, $cd6270424eaeb4d4$export$2824197c2cd75b1e)();
    if (!(field == null ? void 0 : field.isRequired)) return null;
    const className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-form__required-indicator", props.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
        ...field == null ? void 0 : field.getRequiredIndicatorProps(props, ref),
        __css: styles.requiredIndicator,
        className: className
    });
});
$ef3866dc6a93af5f$export$b36d93bade3250e4.displayName = "RequiredIndicator";

// src/input.tsx


function $6129e3e578a61ce7$export$62ecd8ad1bbe1a18(props) {
    const { isDisabled: isDisabled, isInvalid: isInvalid, isReadOnly: isReadOnly, isRequired: isRequired, ...rest } = $6129e3e578a61ce7$export$1819803dd567b95f(props);
    return {
        ...rest,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        "aria-invalid": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(isInvalid),
        "aria-required": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(isRequired),
        "aria-readonly": (0, $abe97432afb3d989$export$91a6105db3d4be7b)(isReadOnly)
    };
}
function $6129e3e578a61ce7$export$1819803dd567b95f(props) {
    var _a, _b, _c;
    const field = (0, $cd6270424eaeb4d4$export$97a2352498389516)();
    const { id: id, disabled: disabled, readOnly: readOnly, required: required, isRequired: isRequired, isInvalid: isInvalid, isReadOnly: isReadOnly, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, ...rest } = props;
    const labelIds = props["aria-describedby"] ? [
        props["aria-describedby"]
    ] : [];
    if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) labelIds.push(field.feedbackId);
    if (field == null ? void 0 : field.hasHelpText) labelIds.push(field.helpTextId);
    return {
        ...rest,
        "aria-describedby": labelIds.join(" ") || void 0,
        id: id != null ? id : field == null ? void 0 : field.id,
        isDisabled: (_a = disabled != null ? disabled : isDisabled) != null ? _a : field == null ? void 0 : field.isDisabled,
        isReadOnly: (_b = readOnly != null ? readOnly : isReadOnly) != null ? _b : field == null ? void 0 : field.isReadOnly,
        isRequired: (_c = required != null ? required : isRequired) != null ? _c : field == null ? void 0 : field.isRequired,
        isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
        onFocus: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(field == null ? void 0 : field.onFocus, onFocus),
        onBlur: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(field == null ? void 0 : field.onBlur, onBlur)
    };
}





var $13ef127d438f0ac5$export$f5b8910cec6cf069 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Input2(props, ref) {
    const { htmlSize: htmlSize, ...rest } = props;
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Input", rest);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(rest);
    const input = (0, $6129e3e578a61ce7$export$62ecd8ad1bbe1a18)(ownProps);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-input", props.className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).input, {
        size: htmlSize,
        ...input,
        __css: styles.field,
        ref: ref,
        className: _className
    });
});
$13ef127d438f0ac5$export$f5b8910cec6cf069.displayName = "Input";
$13ef127d438f0ac5$export$f5b8910cec6cf069.id = "Input";

// src/input-group.tsx






var $acw62 = parcelRequire("acw62");

var [$c7a110bd37e6dedc$var$InputGroupStylesProvider, $c7a110bd37e6dedc$export$635b0139be441f68] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `InputGroupStylesContext`,
    errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
});
var $c7a110bd37e6dedc$export$6e5a9cd40e0c9b97 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function InputGroup2(props, ref) {
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Input", props);
    const { children: children, className: className, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-input__group", className);
    const groupStyles = {};
    const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
    const input = styles.field;
    validChildren.forEach((child)=>{
        var _a, _b;
        if (!styles) return;
        if (input && child.type.id === "InputLeftElement") groupStyles.paddingStart = (_a = input.height) != null ? _a : input.h;
        if (input && child.type.id === "InputRightElement") groupStyles.paddingEnd = (_b = input.height) != null ? _b : input.h;
        if (child.type.id === "InputRightAddon") groupStyles.borderEndRadius = 0;
        if (child.type.id === "InputLeftAddon") groupStyles.borderStartRadius = 0;
    });
    const clones = validChildren.map((child)=>{
        var _a, _b;
        const theming = (0, $6bc154251470a415$export$8e16b83750b44988)({
            size: ((_a = child.props) == null ? void 0 : _a.size) || props.size,
            variant: ((_b = child.props) == null ? void 0 : _b.variant) || props.variant
        });
        return child.type.id !== "Input" ? (0, $acw62.cloneElement)(child, theming) : (0, $acw62.cloneElement)(child, Object.assign(theming, groupStyles, child.props));
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        className: _className,
        ref: ref,
        __css: {
            width: "100%",
            display: "flex",
            position: "relative",
            isolation: "isolate"
        },
        "data-group": true,
        ...rest,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c7a110bd37e6dedc$var$InputGroupStylesProvider, {
            value: styles,
            children: clones
        })
    });
});
$c7a110bd37e6dedc$export$6e5a9cd40e0c9b97.displayName = "InputGroup";





var $3444b8d3cbeb4c12$var$StyledInputElement = (0, $f1b95b1386d3a42c$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "0",
        zIndex: 2
    }
});
var $3444b8d3cbeb4c12$var$InputElement = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function InputElement2(props, ref) {
    var _a, _b;
    const { placement: placement = "left", ...rest } = props;
    const styles = (0, $c7a110bd37e6dedc$export$635b0139be441f68)();
    const input = styles.field;
    const attr = placement === "left" ? "insetStart" : "insetEnd";
    const elementStyles = {
        [attr]: "0",
        width: (_a = input == null ? void 0 : input.height) != null ? _a : input == null ? void 0 : input.h,
        height: (_b = input == null ? void 0 : input.height) != null ? _b : input == null ? void 0 : input.h,
        fontSize: input == null ? void 0 : input.fontSize,
        ...styles.element
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3444b8d3cbeb4c12$var$StyledInputElement, {
        ref: ref,
        __css: elementStyles,
        ...rest
    });
});
$3444b8d3cbeb4c12$var$InputElement.id = "InputElement";
$3444b8d3cbeb4c12$var$InputElement.displayName = "InputElement";
var $3444b8d3cbeb4c12$export$b5cdbc34a3b65f4c = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function InputLeftElement2(props, ref) {
    const { className: className, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-input__left-element", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3444b8d3cbeb4c12$var$InputElement, {
        ref: ref,
        placement: "left",
        className: _className,
        ...rest
    });
});
$3444b8d3cbeb4c12$export$b5cdbc34a3b65f4c.id = "InputLeftElement";
$3444b8d3cbeb4c12$export$b5cdbc34a3b65f4c.displayName = "InputLeftElement";
var $3444b8d3cbeb4c12$export$8a7b8bdd4608e7e3 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function InputRightElement2(props, ref) {
    const { className: className, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-input__right-element", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3444b8d3cbeb4c12$var$InputElement, {
        ref: ref,
        placement: "right",
        className: _className,
        ...rest
    });
});
$3444b8d3cbeb4c12$export$8a7b8bdd4608e7e3.id = "InputRightElement";
$3444b8d3cbeb4c12$export$8a7b8bdd4608e7e3.displayName = "InputRightElement";

// src/link.tsx



var $2a845447b1ebfe73$export$a6c7ac8248d6e38a = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Link2(props, ref) {
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Link", props);
    const { className: className, isExternal: isExternal, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).a, {
        target: isExternal ? "_blank" : void 0,
        rel: isExternal ? "noopener" : void 0,
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-link", className),
        ...rest,
        __css: styles
    });
});
$2a845447b1ebfe73$export$a6c7ac8248d6e38a.displayName = "Link";




var $91114d1604a86a91$export$e6c02a6dccfa2120 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9d16df24508f5c77$export$694e0d28c7ffc90c), {
        align: "center",
        ...props,
        direction: "column",
        ref: ref
    }));
$91114d1604a86a91$export$e6c02a6dccfa2120.displayName = "VStack";



var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === "object";
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(obj)) return defaultValue;
    const result = $0d70f179cf56e662$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $0d70f179cf56e662$var$isUndefined(result) || result === obj ? $0d70f179cf56e662$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>exact && signalName ? name === signalName : !name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $0d70f179cf56e662$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $0d70f179cf56e662$var$shouldSubscribeByName(_name.current, value1.name, exact) && $0d70f179cf56e662$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _mounted.current = true;
        const isDirty = control._proxyFormState.isDirty && control._getDirty();
        if (isDirty !== control._formState.isDirty) control._subjects.state.next({
            isDirty: isDirty
        });
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === "string";
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $0d70f179cf56e662$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($0d70f179cf56e662$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $0d70f179cf56e662$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !$0d70f179cf56e662$var$isPlainObject(data)) copy = data;
        else for(const key in data)copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
    } else return data;
    return copy;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.watch,
        next: (formState)=>{
            if ($0d70f179cf56e662$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        return ()=>{
            const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
            (isArrayField ? _shouldUnregisterField && !control._stateFlags.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    return {
        field: {
            name: name,
            value: value1,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $0d70f179cf56e662$var$getEventValue(event),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $0d70f179cf56e662$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
const $0d70f179cf56e662$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                } else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($0d70f179cf56e662$var$isObject(currentField)) $0d70f179cf56e662$var$focusFieldBy(currentField, callback);
        }
    }
};
var $0d70f179cf56e662$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === "file";
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === "function";
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMessage = (value1)=>$0d70f179cf56e662$var$isString(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(value1);
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === "radio";
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === "" ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getValidateError(result, ref, type = "validate") {
    if ($0d70f179cf56e662$var$isMessage(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isMessage) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $0d70f179cf56e662$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $0d70f179cf56e662$var$append(data, value1) {
    return [
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
}
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $0d70f179cf56e662$var$prepend(data, value1) {
    return [
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
}
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (!$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $0d70f179cf56e662$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$append(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$append, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prepend(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prepend, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._stateFlags.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({});
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $0d70f179cf56e662$var$validateField(field, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.watch.next({
            name: name,
            values: control._formValues
        });
        control._names.focus && $0d70f179cf56e662$var$focusFieldBy(control._fields, (key)=>!!key && key.startsWith(control._names.focus || ""));
        control._names.focus = "";
        control._updateValid();
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $0d70f179cf56e662$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return object1 === object2;
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0d70f179cf56e662$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $0d70f179cf56e662$var$markFieldsDirty(data[key], []) : {
                ...$0d70f179cf56e662$var$markFieldsDirty(data[key])
            };
            else $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data[key], $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else $0d70f179cf56e662$var$deepEqual(data[key], formValues[key]) ? delete dirtyFieldsFromValues[key] : dirtyFieldsFromValues[key] = true;
    }
    return dirtyFieldsFromValues;
}
var $0d70f179cf56e662$var$getDirtyFields = (defaultValues, formValues)=>$0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $0d70f179cf56e662$var$markFieldsDirty(formValues));
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: true,
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.defaultValues) || $0d70f179cf56e662$var$isObject(_options.values) ? $0d70f179cf56e662$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _stateFlags = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        watch: $0d70f179cf56e662$var$createSubject(),
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = window.setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _stateFlags.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _stateFlags.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>await _options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema();
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._stateFlags.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_stateFlags.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? "" : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.watch.next({
                        name: name
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$0d70f179cf56e662$var$isPrimitive(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: _formValues
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({});
        _subjects.watch.next({
            name: name
        });
        !_stateFlags.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.watch.next({
                name: name,
                type: event.type
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({});
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            } else {
                error = (await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                if (error) isValid = false;
                else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
            }
            field._f.deps && trigger(field._f.deps);
            shouldRenderByError(name, isValid, error, fieldState);
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$focusFieldBy(_fields, (key)=>key && $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._stateFlags.mount ? _formValues : {}
        };
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.watch.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName)) {
                if (!options.keepValue) {
                    $0d70f179cf56e662$var$unset(_fields, fieldName);
                    $0d70f179cf56e662$var$unset(_formValues, fieldName);
                }
                !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
                !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
                !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
                !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
            }
        }
        _subjects.watch.next({});
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        field ? disabledIsDefined && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, options.disabled ? undefined : $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.shouldUseNativeValidation ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _stateFlags.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$focusFieldBy(_fields, (key)=>key && $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $0d70f179cf56e662$var$unset(_formState.errors, "root");
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const values = formValues && !$0d70f179cf56e662$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : cloneUpdatedValues;
            _subjects.array.next({
                values: values
            });
            _subjects.watch.next({
                values: values
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_stateFlags.mount && flushRootRender();
        _stateFlags.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _stateFlags.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirty || keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    if ($0d70f179cf56e662$var$isFunction(_options.defaultValues)) _options.defaultValues().then((values)=>{
        reset(values, _options.resetOptions);
        _subjects.state.next({
            isLoading: false
        });
    });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            _executeSchema: _executeSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _updateFormState: _updateFormState,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _stateFlags () {
                return _stateFlags;
            },
            set _stateFlags (value){
                _stateFlags = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: true,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$0d70f179cf56e662$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($0d70f179cf56e662$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._stateFlags.mount) {
            control._updateValid();
            control._stateFlags.mount = true;
        }
        if (control._stateFlags.watch) {
            control._stateFlags.watch = false;
            control._subjects.state.next({});
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, control._defaultValues)) control._reset(props.values, control._options.resetOptions);
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        formState.submitCount && control._focusError();
    }, [
        control,
        formState.submitCount
    ]);
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control);
    return _formControl.current;
}



/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */ var $71166b40361ce577$var$F = function() {
    return false;
};
var $71166b40361ce577$export$2e2bcd8739ae039 = $71166b40361ce577$var$F;


/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var $a7575c2b1a08b3b4$var$T = function() {
    return true;
};
var $a7575c2b1a08b3b4$export$2e2bcd8739ae039 = $a7575c2b1a08b3b4$var$T;


/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var $f4a755dcd8e84c0f$export$2e2bcd8739ae039 = {
    "@@functional/placeholder": true
};


function $e7e651d63487d7d6$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}


function $7ec77605189b4758$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}



function $1ae74cc5623cea21$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) ? f2 : (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) && (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(b) ? f2 : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) ? (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function(_a) {
                    return fn(_a, b);
                }) : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(b) ? (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}


/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var $757411ca5124d4c2$var$add = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function add(a, b) {
    return Number(a) + Number(b);
});
var $757411ca5124d4c2$export$2e2bcd8739ae039 = $757411ca5124d4c2$var$add;


/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ function $48a4c161d30e4183$export$2e2bcd8739ae039(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}



function $35f53eb613cc1282$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}






function $da2b3dc738142f7b$export$2e2bcd8739ae039(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(left, $da2b3dc738142f7b$export$2e2bcd8739ae039(length, combined, fn));
    };
}


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $3b7e85b0e9d353dc$var$curryN = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function curryN(length, fn) {
    if (length === 1) return (0, $7ec77605189b4758$export$2e2bcd8739ae039)(fn);
    return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(length, (0, $da2b3dc738142f7b$export$2e2bcd8739ae039)(length, [], fn));
});
var $3b7e85b0e9d353dc$export$2e2bcd8739ae039 = $3b7e85b0e9d353dc$var$curryN;


/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig (((a ...) -> b) ... -> [a] -> *) -> (((a ..., Int, [a]) -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var $c98ca3ba98e34b05$var$addIndex = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function addIndex(fn) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, $48a4c161d30e4183$export$2e2bcd8739ae039)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
var $c98ca3ba98e34b05$export$2e2bcd8739ae039 = $c98ca3ba98e34b05$var$addIndex;






function $d630269a6cff22d9$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) ? f3 : (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) && (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(b) ? f3 : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) ? (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(b) ? (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) && (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(b) && (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(c) ? f3 : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) && (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(b) ? (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) && (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(c) ? (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(b) && (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(c) ? (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(a) ? (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(b) ? (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $e7e651d63487d7d6$export$2e2bcd8739ae039)(c) ? (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}


/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var $7f73db655ec2f6ce$var$adjust = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function adjust(idx, fn, list) {
    var len = list.length;
    if (idx >= len || idx < -len) return list;
    var _idx = (len + idx) % len;
    var _list = (0, $48a4c161d30e4183$export$2e2bcd8739ae039)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
var $7f73db655ec2f6ce$export$2e2bcd8739ae039 = $7f73db655ec2f6ce$var$adjust;



/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $7eea8a68c490b09b$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};


function $d2e26a2a9b11036b$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}


function $517f9939d3c2c885$export$2e2bcd8739ae039(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!(0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ((0, $d2e26a2a9b11036b$export$2e2bcd8739ae039)(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}



function $ddc178dcc7c7ccc5$export$2e2bcd8739ae039(x) {
    return x && x["@@transducer/reduced"] ? x : {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}


var $ad08508171bdd1fe$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};


var $5cde28cd36e3ce44$var$XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XAll.prototype["@@transducer/result"] = function(result) {
        if (this.all) result = this.xf["@@transducer/step"](result, true);
        return this.xf["@@transducer/result"](result);
    };
    XAll.prototype["@@transducer/step"] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, false));
        }
        return result;
    };
    return XAll;
}();
var $5cde28cd36e3ce44$var$_xall = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xall(f, xf) {
    return new $5cde28cd36e3ce44$var$XAll(f, xf);
});
var $5cde28cd36e3ce44$export$2e2bcd8739ae039 = $5cde28cd36e3ce44$var$_xall;


/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var $d21f920c7affe2af$var$all = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "all"
], (0, $5cde28cd36e3ce44$export$2e2bcd8739ae039), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
var $d21f920c7affe2af$export$2e2bcd8739ae039 = $d21f920c7affe2af$var$all;





/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var $0c43941275b0bc8e$var$max = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function max(a, b) {
    return b > a ? b : a;
});
var $0c43941275b0bc8e$export$2e2bcd8739ae039 = $0c43941275b0bc8e$var$max;





function $c71baf20e55260bc$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}




function $fba16ff7050dd77f$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}


/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $2a419b1d87c69d2d$var$_isArrayLike = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function isArrayLike(x) {
    if ((0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ((0, $fba16ff7050dd77f$export$2e2bcd8739ae039)(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $2a419b1d87c69d2d$export$2e2bcd8739ae039 = $2a419b1d87c69d2d$var$_isArrayLike;


var $a41bc283a458b174$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $a41bc283a458b174$export$2e2bcd8739ae039(fn) {
    return new $a41bc283a458b174$var$XWrap(fn);
}




/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $1b44f66a6f82142b$var$bind = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function bind(fn, thisObj) {
    return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $1b44f66a6f82142b$export$2e2bcd8739ae039 = $1b44f66a6f82142b$var$bind;


function $f8880cbac514a5a0$var$_arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
function $f8880cbac514a5a0$var$_iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $f8880cbac514a5a0$var$_methodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]((0, $1b44f66a6f82142b$export$2e2bcd8739ae039)(xf["@@transducer/step"], xf), acc));
}
var $f8880cbac514a5a0$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $f8880cbac514a5a0$export$2e2bcd8739ae039(fn, acc, list) {
    if (typeof fn === "function") fn = (0, $a41bc283a458b174$export$2e2bcd8739ae039)(fn);
    if ((0, $2a419b1d87c69d2d$export$2e2bcd8739ae039)(list)) return $f8880cbac514a5a0$var$_arrayReduce(fn, acc, list);
    if (typeof list["fantasy-land/reduce"] === "function") return $f8880cbac514a5a0$var$_methodReduce(fn, acc, list, "fantasy-land/reduce");
    if (list[$f8880cbac514a5a0$var$symIterator] != null) return $f8880cbac514a5a0$var$_iterableReduce(fn, acc, list[$f8880cbac514a5a0$var$symIterator]());
    if (typeof list.next === "function") return $f8880cbac514a5a0$var$_iterableReduce(fn, acc, list);
    if (typeof list.reduce === "function") return $f8880cbac514a5a0$var$_methodReduce(fn, acc, list, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
}




var $3cc275a5f5c51b13$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XMap.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var $3cc275a5f5c51b13$var$_xmap = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xmap(f, xf) {
    return new $3cc275a5f5c51b13$var$XMap(f, xf);
});
var $3cc275a5f5c51b13$export$2e2bcd8739ae039 = $3cc275a5f5c51b13$var$_xmap;




function $3e434626b2866668$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}



var $d0eb546af0a6cb8d$var$toString = Object.prototype.toString;
var $d0eb546af0a6cb8d$var$_isArguments = /*#__PURE__*/ function() {
    return $d0eb546af0a6cb8d$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $d0eb546af0a6cb8d$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, $3e434626b2866668$export$2e2bcd8739ae039)("callee", x);
    };
}();
var $d0eb546af0a6cb8d$export$2e2bcd8739ae039 = $d0eb546af0a6cb8d$var$_isArguments;


var $89717ab94613e822$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $89717ab94613e822$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
]; // Safari bug
var $89717ab94613e822$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $89717ab94613e822$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $89717ab94613e822$var$keys = typeof Object.keys === "function" && !$89717ab94613e822$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $89717ab94613e822$var$hasArgsEnumBug && (0, $d0eb546af0a6cb8d$export$2e2bcd8739ae039)(obj);
    for(prop in obj)if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($89717ab94613e822$var$hasEnumBug) {
        nIdx = $89717ab94613e822$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $89717ab94613e822$var$nonEnumerableProps[nIdx];
            if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(prop, obj) && !$89717ab94613e822$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $89717ab94613e822$export$2e2bcd8739ae039 = $89717ab94613e822$var$keys;


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $b01f107cd36c1471$var$map = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "fantasy-land/map",
    "map"
], (0, $3cc275a5f5c51b13$export$2e2bcd8739ae039), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, $89717ab94613e822$export$2e2bcd8739ae039)(functor));
        default:
            return (0, $c71baf20e55260bc$export$2e2bcd8739ae039)(fn, functor);
    }
}));
var $b01f107cd36c1471$export$2e2bcd8739ae039 = $b01f107cd36c1471$var$map;



/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $a36ac71f20068253$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};




/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $a16e55901f91382d$var$nth = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $fba16ff7050dd77f$export$2e2bcd8739ae039)(list) ? list.charAt(idx) : list[idx];
});
var $a16e55901f91382d$export$2e2bcd8739ae039 = $a16e55901f91382d$var$nth;


/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.props, R.pluck, R.project, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var $d925005fae164d75$var$prop = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function prop(p, obj) {
    if (obj == null) return;
    return (0, $a36ac71f20068253$export$2e2bcd8739ae039)(p) ? (0, $a16e55901f91382d$export$2e2bcd8739ae039)(p, obj) : obj[p];
});
var $d925005fae164d75$export$2e2bcd8739ae039 = $d925005fae164d75$var$prop;


/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.project, R.prop, R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var $c57cf2ecbe3ddf08$var$pluck = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function pluck(p, list) {
    return (0, $b01f107cd36c1471$export$2e2bcd8739ae039)((0, $d925005fae164d75$export$2e2bcd8739ae039)(p), list);
});
var $c57cf2ecbe3ddf08$export$2e2bcd8739ae039 = $c57cf2ecbe3ddf08$var$pluck;




/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $0fda840d89c87320$var$reduce = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)((0, $f8880cbac514a5a0$export$2e2bcd8739ae039));
var $0fda840d89c87320$export$2e2bcd8739ae039 = $0fda840d89c87320$var$reduce;


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var $1bc4aea3bba47cb8$var$allPass = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function allPass(preds) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)((0, $0fda840d89c87320$export$2e2bcd8739ae039)((0, $0c43941275b0bc8e$export$2e2bcd8739ae039), 0, (0, $c57cf2ecbe3ddf08$export$2e2bcd8739ae039)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
var $1bc4aea3bba47cb8$export$2e2bcd8739ae039 = $1bc4aea3bba47cb8$var$allPass;



/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var $2ff120835f8592de$var$always = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function always(val) {
    return function() {
        return val;
    };
});
var $2ff120835f8592de$export$2e2bcd8739ae039 = $2ff120835f8592de$var$always;



/**
 * Returns the first argument if it is falsy, otherwise the second argument.
 * Acts as the boolean `and` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.both, R.or
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var $6f9cc58c03527f53$var$and = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function and(a, b) {
    return a && b;
});
var $6f9cc58c03527f53$export$2e2bcd8739ae039 = $6f9cc58c03527f53$var$and;







var $bb0ec6840cf6baf3$var$XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XAny.prototype["@@transducer/result"] = function(result) {
        if (!this.any) result = this.xf["@@transducer/step"](result, false);
        return this.xf["@@transducer/result"](result);
    };
    XAny.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, true));
        }
        return result;
    };
    return XAny;
}();
var $bb0ec6840cf6baf3$var$_xany = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xany(f, xf) {
    return new $bb0ec6840cf6baf3$var$XAny(f, xf);
});
var $bb0ec6840cf6baf3$export$2e2bcd8739ae039 = $bb0ec6840cf6baf3$var$_xany;


/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var $9aca1997a2eaa1ab$var$any = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "any"
], (0, $bb0ec6840cf6baf3$export$2e2bcd8739ae039), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
var $9aca1997a2eaa1ab$export$2e2bcd8739ae039 = $9aca1997a2eaa1ab$var$any;







/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var $35e3c08d2ef8d581$var$anyPass = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function anyPass(preds) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)((0, $0fda840d89c87320$export$2e2bcd8739ae039)((0, $0c43941275b0bc8e$export$2e2bcd8739ae039), 0, (0, $c57cf2ecbe3ddf08$export$2e2bcd8739ae039)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
var $35e3c08d2ef8d581$export$2e2bcd8739ae039 = $35e3c08d2ef8d581$var$anyPass;






/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var $798be8b27a50c416$var$ap = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function ap(applyF, applyX) {
    return typeof applyX["fantasy-land/ap"] === "function" ? applyX["fantasy-land/ap"](applyF) : typeof applyF.ap === "function" ? applyF.ap(applyX) : typeof applyF === "function" ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(acc, f) {
        return (0, $48a4c161d30e4183$export$2e2bcd8739ae039)(acc, (0, $b01f107cd36c1471$export$2e2bcd8739ae039)(f, applyX));
    }, [], applyF);
});
var $798be8b27a50c416$export$2e2bcd8739ae039 = $798be8b27a50c416$var$ap;


function $463cbb4b3fdbb970$export$2e2bcd8739ae039(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}







var $6f0ff3ca27b0bed3$var$XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XAperture.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XAperture.prototype["@@transducer/step"] = function(result, input) {
        this.store(input);
        return this.full ? this.xf["@@transducer/step"](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, $48a4c161d30e4183$export$2e2bcd8739ae039)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
var $6f0ff3ca27b0bed3$var$_xaperture = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xaperture(n, xf) {
    return new $6f0ff3ca27b0bed3$var$XAperture(n, xf);
});
var $6f0ff3ca27b0bed3$export$2e2bcd8739ae039 = $6f0ff3ca27b0bed3$var$_xaperture;


/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var $1afb80efd3ed3a24$var$aperture = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $6f0ff3ca27b0bed3$export$2e2bcd8739ae039), (0, $463cbb4b3fdbb970$export$2e2bcd8739ae039)));
var $1afb80efd3ed3a24$export$2e2bcd8739ae039 = $1afb80efd3ed3a24$var$aperture;




/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var $a5e78bac7f8829c8$var$append = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function append(el, list) {
    return (0, $48a4c161d30e4183$export$2e2bcd8739ae039)(list, [
        el
    ]);
});
var $a5e78bac7f8829c8$export$2e2bcd8739ae039 = $a5e78bac7f8829c8$var$append;



/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var $de170f844fc81fb7$var$apply = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function apply(fn, args) {
    return fn.apply(this, args);
});
var $de170f844fc81fb7$export$2e2bcd8739ae039 = $de170f844fc81fb7$var$apply;












/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys, R.toPairs
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var $7c3594007c6fb40d$var$values = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function values(obj) {
    var props = (0, $89717ab94613e822$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
var $7c3594007c6fb40d$export$2e2bcd8739ae039 = $7c3594007c6fb40d$var$values;


// delegating calls to .map
function $fe91345bd31babe2$var$mapValues(fn, obj) {
    return (0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(obj) ? obj.map(fn) : (0, $89717ab94613e822$export$2e2bcd8739ae039)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var $fe91345bd31babe2$var$applySpec = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function applySpec(spec) {
    spec = $fe91345bd31babe2$var$mapValues(function(v) {
        return typeof v == "function" ? v : applySpec(v);
    }, spec);
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)((0, $0fda840d89c87320$export$2e2bcd8739ae039)((0, $0c43941275b0bc8e$export$2e2bcd8739ae039), 0, (0, $c57cf2ecbe3ddf08$export$2e2bcd8739ae039)("length", (0, $7c3594007c6fb40d$export$2e2bcd8739ae039)(spec))), function() {
        var args = arguments;
        return $fe91345bd31babe2$var$mapValues(function(f) {
            return (0, $de170f844fc81fb7$export$2e2bcd8739ae039)(f, args);
        }, spec);
    });
});
var $fe91345bd31babe2$export$2e2bcd8739ae039 = $fe91345bd31babe2$var$applySpec;



/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */ var $e2f0f38310773ec0$var$applyTo = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function applyTo(x, f) {
    return f(x);
});
var $e2f0f38310773ec0$export$2e2bcd8739ae039 = $e2f0f38310773ec0$var$applyTo;



/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $f1748de474d72f74$var$ascend = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
var $f1748de474d72f74$export$2e2bcd8739ae039 = $f1748de474d72f74$var$ascend;








function $d98e4d563993ddcf$export$2e2bcd8739ae039(prop, val, obj) {
    if ((0, $a36ac71f20068253$export$2e2bcd8739ae039)(prop) && (0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = val;
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
}



/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $0cd8964fcc0096b1$var$isNil = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function isNil(x) {
    return x == null;
});
var $0cd8964fcc0096b1$export$2e2bcd8739ae039 = $0cd8964fcc0096b1$var$isNil;


/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var $f63804dd4a880548$var$assocPath = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, $0cd8964fcc0096b1$export$2e2bcd8739ae039)(obj) && (0, $3e434626b2866668$export$2e2bcd8739ae039)(idx, obj) ? obj[idx] : (0, $a36ac71f20068253$export$2e2bcd8739ae039)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    return (0, $d98e4d563993ddcf$export$2e2bcd8739ae039)(idx, val, obj);
});
var $f63804dd4a880548$export$2e2bcd8739ae039 = $f63804dd4a880548$var$assocPath;


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig Idx -> a -> {k: v} -> {k: v}
 * @param {String|Number} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var $a9760553a5e17ba5$var$assoc = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function assoc(prop, val, obj) {
    return (0, $f63804dd4a880548$export$2e2bcd8739ae039)([
        prop
    ], val, obj);
});
var $a9760553a5e17ba5$export$2e2bcd8739ae039 = $a9760553a5e17ba5$var$assoc;





/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var $26474154062a5b29$var$nAry = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
    }
});
var $26474154062a5b29$export$2e2bcd8739ae039 = $26474154062a5b29$var$nAry;


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> ((a, b) -> z)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var $7d7a06561d30057e$var$binary = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function binary(fn) {
    return (0, $26474154062a5b29$export$2e2bcd8739ae039)(2, fn);
});
var $7d7a06561d30057e$export$2e2bcd8739ae039 = $7d7a06561d30057e$var$binary;




function $0eef464cca01ff27$export$2e2bcd8739ae039(x) {
    var type = Object.prototype.toString.call(x);
    return type === "[object Function]" || type === "[object AsyncFunction]" || type === "[object GeneratorFunction]" || type === "[object AsyncGeneratorFunction]";
}









/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var $88154aac63bd773b$var$liftN = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function liftN(arity, fn) {
    var lifted = (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(arity, fn);
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(arity, function() {
        return (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)((0, $798be8b27a50c416$export$2e2bcd8739ae039), (0, $b01f107cd36c1471$export$2e2bcd8739ae039)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
var $88154aac63bd773b$export$2e2bcd8739ae039 = $88154aac63bd773b$var$liftN;


/**
 * "lifts" a function of arity >= 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([100, 200], [30, 40], [5, 6, 7]); //=> [135, 136, 137, 145, 146, 147, 235, 236, 237, 245, 246, 247]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([10, 20], [1], [2, 3], [4], [100, 200]); //=> [117, 217, 118, 218, 127, 227, 128, 228]
 */ var $d4a47b4162ca03e7$var$lift = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function lift(fn) {
    return (0, $88154aac63bd773b$export$2e2bcd8739ae039)(fn.length, fn);
});
var $d4a47b4162ca03e7$export$2e2bcd8739ae039 = $d4a47b4162ca03e7$var$lift;


/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.either, R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */ var $13463e5380cd74a1$var$both = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function both(f, g) {
    return (0, $0eef464cca01ff27$export$2e2bcd8739ae039)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, $d4a47b4162ca03e7$export$2e2bcd8739ae039)((0, $6f9cc58c03527f53$export$2e2bcd8739ae039))(f, g);
});
var $13463e5380cd74a1$export$2e2bcd8739ae039 = $13463e5380cd74a1$var$both;



/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig ((*... -> a), *...) -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(
 *        R.repeat(' '),
 *        R.join(''),
 *        R.replace(/^(?!$)/gm)
 *      );
 *
 *      const format = R.converge(
 *        R.call,
 *        [
 *          R.pipe(R.prop('indent'), indentN),
 *          R.prop('value')
 *        ]
 *      );
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var $e57fac361835623d$var$call = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
var $e57fac361835623d$export$2e2bcd8739ae039 = $e57fac361835623d$var$call;





function $8f92ae87b39064ea$export$2e2bcd8739ae039(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, $2a419b1d87c69d2d$export$2e2bcd8739ae039)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}



function $e9352f1495fd93ec$export$2e2bcd8739ae039(x) {
    return {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}





var $3d98da33875e7c67$var$preservingReduced = function(xf) {
    return {
        "@@transducer/init": (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init,
        "@@transducer/result": function(result) {
            return xf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            var ret = xf["@@transducer/step"](result, input);
            return ret["@@transducer/reduced"] ? (0, $e9352f1495fd93ec$export$2e2bcd8739ae039)(ret) : ret;
        }
    };
};
var $3d98da33875e7c67$var$_flatCat = function _xcat(xf) {
    var rxf = $3d98da33875e7c67$var$preservingReduced(xf);
    return {
        "@@transducer/init": (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init,
        "@@transducer/result": function(result) {
            return rxf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            return !(0, $2a419b1d87c69d2d$export$2e2bcd8739ae039)(input) ? (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(rxf, result, [
                input
            ]) : (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(rxf, result, input);
        }
    };
};
var $3d98da33875e7c67$export$2e2bcd8739ae039 = $3d98da33875e7c67$var$_flatCat;



var $231587c465d9ab00$var$_xchain = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xchain(f, xf) {
    return (0, $b01f107cd36c1471$export$2e2bcd8739ae039)(f, (0, $3d98da33875e7c67$export$2e2bcd8739ae039)(xf));
});
var $231587c465d9ab00$export$2e2bcd8739ae039 = $231587c465d9ab00$var$_xchain;



/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var $afee388cd3a0702e$var$chain = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "fantasy-land/chain",
    "chain"
], (0, $231587c465d9ab00$export$2e2bcd8739ae039), function chain(fn, monad) {
    if (typeof monad === "function") return function(x) {
        return fn(monad(x))(x);
    };
    return (0, $8f92ae87b39064ea$export$2e2bcd8739ae039)(false)((0, $b01f107cd36c1471$export$2e2bcd8739ae039)(fn, monad));
}));
var $afee388cd3a0702e$export$2e2bcd8739ae039 = $afee388cd3a0702e$var$chain;



/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var $f37cff5931bfbb9e$var$clamp = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function clamp(min, max, value) {
    if (min > max) throw new Error("min must not be greater than max in clamp(min, max, value)");
    return value < min ? min : value > max ? max : value;
});
var $f37cff5931bfbb9e$export$2e2bcd8739ae039 = $f37cff5931bfbb9e$var$clamp;


function $992689f1f5b36f20$export$2e2bcd8739ae039(pattern) {
    return new RegExp(pattern.source, (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : ""));
}



/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $5b647918ed6a8a39$var$type = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $5b647918ed6a8a39$export$2e2bcd8739ae039 = $5b647918ed6a8a39$var$type;


function $11797de4521b5141$export$2e2bcd8739ae039(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx] = value;
        refTo[idx] = copiedValue;
        for(var key in value)if (value.hasOwnProperty(key)) copiedValue[key] = deep ? $11797de4521b5141$export$2e2bcd8739ae039(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, $5b647918ed6a8a39$export$2e2bcd8739ae039)(value)){
        case "Object":
            return copy(Object.create(Object.getPrototypeOf(value)));
        case "Array":
            return copy([]);
        case "Date":
            return new Date(value.valueOf());
        case "RegExp":
            return (0, $992689f1f5b36f20$export$2e2bcd8739ae039)(value);
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "BigInt64Array":
        case "BigUint64Array":
            return value.slice();
        default:
            return value;
    }
}



/**
 * Creates a deep copy of the source that can be used in place of the source
 * object without retaining any references to it.
 * The source object may contain (nested) `Array`s and `Object`s,
 * `Number`s, `String`s, `Boolean`s and `Date`s.
 * `Function`s are assigned by reference rather than copied.
 *
 * Dispatches to a `clone` method if present.
 *
 * Note that if the source object has multiple nodes that share a reference,
 * the returned object will have the same structure, but the references will
 * be pointed to the location within the cloned value.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var $6ff2619c5464e152$var$clone = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function clone(value) {
    return value != null && typeof value.clone === "function" ? value.clone() : (0, $11797de4521b5141$export$2e2bcd8739ae039)(value, [], [], true);
});
var $6ff2619c5464e152$export$2e2bcd8739ae039 = $6ff2619c5464e152$var$clone;




/**
 * Splits a list into sub-lists, based on the result of calling a key-returning function on each element,
 * and grouping the results according to values returned.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> [[b]]
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Array}
 *    An array of arrays where each sub-array contains items for which
 *    the String-returning function has returned the same value.
 * @see R.groupBy, R.partition
 * @example
 *      R.collectBy(R.prop('type'), [
 *        {type: 'breakfast', item: '☕️'},
 *        {type: 'lunch', item: '🌯'},
 *        {type: 'dinner', item: '🍝'},
 *        {type: 'breakfast', item: '🥐'},
 *        {type: 'lunch', item: '🍕'}
 *      ]);
 *
 *      // [ [ {type: 'breakfast', item: '☕️'},
 *      //     {type: 'breakfast', item: '🥐'} ],
 *      //   [ {type: 'lunch', item: '🌯'},
 *      //     {type: 'lunch', item: '🍕'} ],
 *      //   [ {type: 'dinner', item: '🍝'} ] ]
 */ var $a4af5b1102f88307$var$collectBy = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function collectBy(fn, list) {
    var group = (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(o, x) {
        var tag = fn(x);
        if (o[tag] === undefined) o[tag] = [];
        o[tag].push(x);
        return o;
    }, {}, list);
    var newList = [];
    for(var tag in group)newList.push(group[tag]);
    return newList;
});
var $a4af5b1102f88307$export$2e2bcd8739ae039 = $a4af5b1102f88307$var$collectBy;



/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $b62d65d7b46e838a$var$comparator = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
var $b62d65d7b46e838a$export$2e2bcd8739ae039 = $b62d65d7b46e838a$var$comparator;




/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var $fc6d663e9099e5f2$var$not = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function not(a) {
    return !a;
});
var $fc6d663e9099e5f2$export$2e2bcd8739ae039 = $fc6d663e9099e5f2$var$not;


/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      R.isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      R.isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var $00e7ef89a75f9f8e$var$complement = /*#__PURE__*/ (0, $d4a47b4162ca03e7$export$2e2bcd8739ae039)((0, $fc6d663e9099e5f2$export$2e2bcd8739ae039));
var $00e7ef89a75f9f8e$export$2e2bcd8739ae039 = $00e7ef89a75f9f8e$var$complement;



function $642f361a13081dbc$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}




function $d8ccc90b207990fc$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}





/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $c45f92b9793bed27$var$slice = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $d8ccc90b207990fc$export$2e2bcd8739ae039)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $c45f92b9793bed27$export$2e2bcd8739ae039 = $c45f92b9793bed27$var$slice;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $ae8d4779ceb1bf28$var$tail = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $d8ccc90b207990fc$export$2e2bcd8739ae039)("tail", /*#__PURE__*/ (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(1, Infinity)));
var $ae8d4779ceb1bf28$export$2e2bcd8739ae039 = $ae8d4779ceb1bf28$var$tail;


function $368f657a44b4e40a$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(arguments[0].length, (0, $0fda840d89c87320$export$2e2bcd8739ae039)((0, $642f361a13081dbc$export$2e2bcd8739ae039), arguments[0], (0, $ae8d4779ceb1bf28$export$2e2bcd8739ae039)(arguments)));
}




/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $221f174d4005544c$var$reverse = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function reverse(list) {
    return (0, $fba16ff7050dd77f$export$2e2bcd8739ae039)(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
var $221f174d4005544c$export$2e2bcd8739ae039 = $221f174d4005544c$var$reverse;


function $759e6a2bc2cac489$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("compose requires at least one argument");
    return (0, $368f657a44b4e40a$export$2e2bcd8739ae039).apply(this, (0, $221f174d4005544c$export$2e2bcd8739ae039)(arguments));
}






/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var $b23345e505d4a129$var$head = /*#__PURE__*/ (0, $a16e55901f91382d$export$2e2bcd8739ae039)(0);
var $b23345e505d4a129$export$2e2bcd8739ae039 = $b23345e505d4a129$var$head;





function $4e7387e3232e683f$export$2e2bcd8739ae039(x) {
    return x;
}


/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var $54ee1c4ac03392aa$var$identity = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)((0, $4e7387e3232e683f$export$2e2bcd8739ae039));
var $54ee1c4ac03392aa$export$2e2bcd8739ae039 = $54ee1c4ac03392aa$var$identity;


/**
 * Performs left-to-right function composition using transforming function. The first function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried. Transforming function is not used on the
 * first argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to pipe
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, g(...args)))
 */ var $6167e1f46c5d3b7b$var$pipeWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function pipeWith(xf, list) {
    if (list.length <= 0) return 0, $54ee1c4ac03392aa$export$2e2bcd8739ae039;
    var headList = (0, $b23345e505d4a129$export$2e2bcd8739ae039)(list);
    var tailList = (0, $ae8d4779ceb1bf28$export$2e2bcd8739ae039)(list);
    return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(headList.length, function() {
        return (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(result, f) {
            return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
    });
});
var $6167e1f46c5d3b7b$export$2e2bcd8739ae039 = $6167e1f46c5d3b7b$var$pipeWith;



/**
 * Performs right-to-left function composition using transforming function. The last function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of composeWith is not automatically curried. Transforming function is not used
 * on the last argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, i(...args)))
 */ var $8fb90e6e8ff46932$var$composeWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function composeWith(xf, list) {
    return (0, $6167e1f46c5d3b7b$export$2e2bcd8739ae039).apply(this, [
        xf,
        (0, $221f174d4005544c$export$2e2bcd8739ae039)(list)
    ]);
});
var $8fb90e6e8ff46932$export$2e2bcd8739ae039 = $8fb90e6e8ff46932$var$composeWith;








function $84d6f9f9a58cca82$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}


function $298b882271db9e5b$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}


function $0e66d5ef9194bf29$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}



// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $91e3de09550f1416$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $91e3de09550f1416$export$2e2bcd8739ae039 = typeof Object.is === "function" ? Object.is : $91e3de09550f1416$var$_objectIs;




/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $ff75afc2044d59c0$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $84d6f9f9a58cca82$export$2e2bcd8739ae039)(aIterator);
    var b = (0, $84d6f9f9a58cca82$export$2e2bcd8739ae039)(bIterator);
    function eq(_a, _b) {
        return $ff75afc2044d59c0$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*
    return !(0, $298b882271db9e5b$export$2e2bcd8739ae039)(function(b, aItem) {
        return !(0, $298b882271db9e5b$export$2e2bcd8739ae039)(eq, aItem, b);
    }, b, a);
}
function $ff75afc2044d59c0$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $91e3de09550f1416$export$2e2bcd8739ae039)(a, b)) return true;
    var typeA = (0, $5b647918ed6a8a39$export$2e2bcd8739ae039)(a);
    if (typeA !== (0, $5b647918ed6a8a39$export$2e2bcd8739ae039)(b)) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, $0e66d5ef9194bf29$export$2e2bcd8739ae039)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, $91e3de09550f1416$export$2e2bcd8739ae039)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, $91e3de09550f1416$export$2e2bcd8739ae039)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return $ff75afc2044d59c0$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return $ff75afc2044d59c0$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $89717ab94613e822$export$2e2bcd8739ae039)(a);
    if (keysA.length !== (0, $89717ab94613e822$export$2e2bcd8739ae039)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $3e434626b2866668$export$2e2bcd8739ae039)(key, b) && $ff75afc2044d59c0$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}


/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $f5f23b53da900217$var$equals = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function equals(a, b) {
    return (0, $ff75afc2044d59c0$export$2e2bcd8739ae039)(a, b, [], []);
});
var $f5f23b53da900217$export$2e2bcd8739ae039 = $f5f23b53da900217$var$equals;


function $70b8d125c84c0682$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            } // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
     // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $f5f23b53da900217$export$2e2bcd8739ae039)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}


function $ffa2ed402645a184$export$2e2bcd8739ae039(a, list) {
    return (0, $70b8d125c84c0682$export$2e2bcd8739ae039)(list, a, 0) >= 0;
}



function $3097cbacd8f99590$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}


/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $a1bab742c708109e$var$pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var $a1bab742c708109e$var$_toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + $a1bab742c708109e$var$pad(d.getUTCMonth() + 1) + "-" + $a1bab742c708109e$var$pad(d.getUTCDate()) + "T" + $a1bab742c708109e$var$pad(d.getUTCHours()) + ":" + $a1bab742c708109e$var$pad(d.getUTCMinutes()) + ":" + $a1bab742c708109e$var$pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
var $a1bab742c708109e$export$2e2bcd8739ae039 = $a1bab742c708109e$var$_toISOString;



function $36e62400fc48e701$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}





function $f1fc8dd126aa3213$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}


function $0a9142ae7089a2b4$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}





var $696ff683ca156b87$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XFilter.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
var $696ff683ca156b87$var$_xfilter = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xfilter(f, xf) {
    return new $696ff683ca156b87$var$XFilter(f, xf);
});
var $696ff683ca156b87$export$2e2bcd8739ae039 = $696ff683ca156b87$var$_xfilter;



/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $b0ba695691479374$var$filter = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "fantasy-land/filter",
    "filter"
], (0, $696ff683ca156b87$export$2e2bcd8739ae039), function(pred, filterable) {
    return (0, $0a9142ae7089a2b4$export$2e2bcd8739ae039)(filterable) ? (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $89717ab94613e822$export$2e2bcd8739ae039)(filterable)) : (0, $f1fc8dd126aa3213$export$2e2bcd8739ae039)(pred, filterable);
}));
var $b0ba695691479374$export$2e2bcd8739ae039 = $b0ba695691479374$var$filter;


/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 !== 0;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $a50384c73326e174$var$reject = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function reject(pred, filterable) {
    return (0, $b0ba695691479374$export$2e2bcd8739ae039)((0, $36e62400fc48e701$export$2e2bcd8739ae039)(pred), filterable);
});
var $a50384c73326e174$export$2e2bcd8739ae039 = $a50384c73326e174$var$reject;


function $0c6da83ecedaf41e$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $ffa2ed402645a184$export$2e2bcd8739ae039)(y, xs) ? "<Circular>" : $0c6da83ecedaf41e$export$2e2bcd8739ae039(y, xs);
    }; //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $c71baf20e55260bc$export$2e2bcd8739ae039)(function(k) {
            return (0, $3097cbacd8f99590$export$2e2bcd8739ae039)(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + (0, $c71baf20e55260bc$export$2e2bcd8739ae039)(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + (0, $c71baf20e55260bc$export$2e2bcd8739ae039)(recur, x).concat(mapPairs(x, (0, $a50384c73326e174$export$2e2bcd8739ae039)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $89717ab94613e822$export$2e2bcd8739ae039)(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : (0, $3097cbacd8f99590$export$2e2bcd8739ae039)((0, $a1bab742c708109e$export$2e2bcd8739ae039)(x))) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : (0, $3097cbacd8f99590$export$2e2bcd8739ae039)(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, (0, $89717ab94613e822$export$2e2bcd8739ae039)(x)).join(", ") + "}";
    }
}


/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $754b63e580f0fde1$var$toString = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function toString(val) {
    return (0, $0c6da83ecedaf41e$export$2e2bcd8739ae039)(val, []);
});
var $754b63e580f0fde1$export$2e2bcd8739ae039 = $754b63e580f0fde1$var$toString;


/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var $20d6a9e934cc0e00$var$concat = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function concat(a, b) {
    if ((0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(a)) {
        if ((0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(b)) return a.concat(b);
        throw new TypeError((0, $754b63e580f0fde1$export$2e2bcd8739ae039)(b) + " is not an array");
    }
    if ((0, $fba16ff7050dd77f$export$2e2bcd8739ae039)(a)) {
        if ((0, $fba16ff7050dd77f$export$2e2bcd8739ae039)(b)) return a + b;
        throw new TypeError((0, $754b63e580f0fde1$export$2e2bcd8739ae039)(b) + " is not a string");
    }
    if (a != null && (0, $0eef464cca01ff27$export$2e2bcd8739ae039)(a["fantasy-land/concat"])) return a["fantasy-land/concat"](b);
    if (a != null && (0, $0eef464cca01ff27$export$2e2bcd8739ae039)(a.concat)) return a.concat(b);
    throw new TypeError((0, $754b63e580f0fde1$export$2e2bcd8739ae039)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
var $20d6a9e934cc0e00$export$2e2bcd8739ae039 = $20d6a9e934cc0e00$var$concat;







/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * **Please note**: This is not a direct substitute for a `switch` statement.
 * Remember that both elements of every pair passed to `cond` are *functions*,
 * and `cond` returns a function.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var $40eb3393f03f13a1$var$cond = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function cond(pairs) {
    var arity = (0, $0fda840d89c87320$export$2e2bcd8739ae039)((0, $0c43941275b0bc8e$export$2e2bcd8739ae039), 0, (0, $b01f107cd36c1471$export$2e2bcd8739ae039)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
var $40eb3393f03f13a1$export$2e2bcd8739ae039 = $40eb3393f03f13a1$var$cond;






/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $092b7900a45befbb$var$curry = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function curry(fn) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(fn.length, fn);
});
var $092b7900a45befbb$export$2e2bcd8739ae039 = $092b7900a45befbb$var$curry;



/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var $6944c6b535d73cad$var$constructN = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function constructN(n, Fn) {
    if (n > 10) throw new Error("Constructor with greater than ten arguments");
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, $092b7900a45befbb$export$2e2bcd8739ae039)((0, $26474154062a5b29$export$2e2bcd8739ae039)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(arguments.length){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
var $6944c6b535d73cad$export$2e2bcd8739ae039 = $6944c6b535d73cad$var$constructN;


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var $6b1b88651f424922$var$construct = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function construct(Fn) {
    return (0, $6944c6b535d73cad$export$2e2bcd8739ae039)(Fn.length, Fn);
});
var $6b1b88651f424922$export$2e2bcd8739ae039 = $6b1b88651f424922$var$construct;









/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var $55b7cb4cf5a94fb5$var$converge = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function converge(after, fns) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)((0, $0fda840d89c87320$export$2e2bcd8739ae039)((0, $0c43941275b0bc8e$export$2e2bcd8739ae039), 0, (0, $c57cf2ecbe3ddf08$export$2e2bcd8739ae039)("length", fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, $c71baf20e55260bc$export$2e2bcd8739ae039)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
var $55b7cb4cf5a94fb5$export$2e2bcd8739ae039 = $55b7cb4cf5a94fb5$var$converge;




/**
 * Returns the number of items in a given `list` matching the predicate `f`
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} predicate to match items against
 * @return {Array} list of items to count in
 * @example
 *
 *      const even = x => x % 2 == 0;
 *
 *      R.count(even, [1, 2, 3, 4, 5]); // => 2
 *      R.map(R.count(even), [[1, 1, 1], [2, 3, 4, 5], [6]]); // => [0, 2, 1]
 */ var $faee1086836d374f$var$count = /*#__PURE__*/ (0, $092b7900a45befbb$export$2e2bcd8739ae039)(function(pred, list) {
    return (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(a, e) {
        return pred(e) ? a + 1 : a;
    }, 0, list);
});
var $faee1086836d374f$export$2e2bcd8739ae039 = $faee1086836d374f$var$count;











var $bb1c58e58d16d4ab$var$XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XReduceBy.prototype["@@transducer/result"] = function(result) {
        var key;
        for(key in this.inputs)if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(key, this.inputs)) {
            result = this.xf["@@transducer/step"](result, this.inputs[key]);
            if (result["@@transducer/reduced"]) {
                result = result["@@transducer/value"];
                break;
            }
        }
        this.inputs = null;
        return this.xf["@@transducer/result"](result);
    };
    XReduceBy.prototype["@@transducer/step"] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var $bb1c58e58d16d4ab$var$_xreduceBy = /*#__PURE__*/ (0, $da2b3dc738142f7b$export$2e2bcd8739ae039)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new $bb1c58e58d16d4ab$var$XReduceBy(valueFn, valueAcc, keyFn, xf);
});
var $bb1c58e58d16d4ab$export$2e2bcd8739ae039 = $bb1c58e58d16d4ab$var$_xreduceBy;


/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * The value function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to short circuit the iteration.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce, R.reduced
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var $d27468100aaa010c$var$reduceBy = /*#__PURE__*/ (0, $da2b3dc738142f7b$export$2e2bcd8739ae039)(4, [], /*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $bb1c58e58d16d4ab$export$2e2bcd8739ae039), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(acc, elt) {
        var key = keyFn(elt);
        var value = valueFn((0, $3e434626b2866668$export$2e2bcd8739ae039)(key, acc) ? acc[key] : (0, $11797de4521b5141$export$2e2bcd8739ae039)(valueAcc, [], [], false), elt);
        if (value && value["@@transducer/reduced"]) return (0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039)(acc);
        acc[key] = value;
        return acc;
    }, {}, list);
}));
var $d27468100aaa010c$export$2e2bcd8739ae039 = $d27468100aaa010c$var$reduceBy;


/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var $10db1b26e989981a$var$countBy = /*#__PURE__*/ (0, $d27468100aaa010c$export$2e2bcd8739ae039)(function(acc, elem) {
    return acc + 1;
}, 0);
var $10db1b26e989981a$export$2e2bcd8739ae039 = $10db1b26e989981a$var$countBy;





/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var $265522880e26d873$var$dec = /*#__PURE__*/ (0, $757411ca5124d4c2$export$2e2bcd8739ae039)(-1);
var $265522880e26d873$export$2e2bcd8739ae039 = $265522880e26d873$var$dec;



/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var $0a7f9f2c99a59791$var$defaultTo = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
var $0a7f9f2c99a59791$export$2e2bcd8739ae039 = $0a7f9f2c99a59791$var$defaultTo;



/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var $832bd2e4b73e0e56$var$descend = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
var $832bd2e4b73e0e56$export$2e2bcd8739ae039 = $832bd2e4b73e0e56$var$descend;




var $6078c297d1e76956$var$_Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === "function" ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !$6078c297d1e76956$var$hasOrAdd(item, true, this);
    }; //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return $6078c297d1e76956$var$hasOrAdd(item, false, this);
    }; //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function $6078c297d1e76956$var$hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case "string":
        case "number":
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items["-0"]) return true;
                else {
                    if (shouldAdd) set._items["-0"] = true;
                    return false;
                }
            } // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case "boolean":
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case "function":
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, $ffa2ed402645a184$export$2e2bcd8739ae039)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case "undefined":
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case "object":
            if (item === null) {
                if (!set._items["null"]) {
                    if (shouldAdd) set._items["null"] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            } // scan through all previously applied items
            if (!(0, $ffa2ed402645a184$export$2e2bcd8739ae039)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
} // A simple Set type that honours R.equals semantics
var $6078c297d1e76956$export$2e2bcd8739ae039 = $6078c297d1e76956$var$_Set;


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var $4c7bf31ad3cf804f$var$difference = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, $6078c297d1e76956$export$2e2bcd8739ae039)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
var $4c7bf31ad3cf804f$export$2e2bcd8739ae039 = $4c7bf31ad3cf804f$var$difference;




/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var $59cd35db3021243a$var$differenceWith = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, $298b882271db9e5b$export$2e2bcd8739ae039)(pred, first[idx], second) && !(0, $298b882271db9e5b$export$2e2bcd8739ae039)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
var $59cd35db3021243a$export$2e2bcd8739ae039 = $59cd35db3021243a$var$differenceWith;







/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var $816319d7569c0c4f$var$remove = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
var $816319d7569c0c4f$export$2e2bcd8739ae039 = $816319d7569c0c4f$var$remove;


function $594f323765eb409e$export$2e2bcd8739ae039(prop, obj) {
    if (obj == null) return obj;
    if ((0, $a36ac71f20068253$export$2e2bcd8739ae039)(prop) && (0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(obj)) return (0, $816319d7569c0c4f$export$2e2bcd8739ae039)(prop, 1, obj);
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
}





/**
 * Makes a shallow clone of an object. Note that this copies and flattens
 * prototype properties onto the new object as well. All non-primitive
 * properties are copied by reference.
 *
 * @private
 * @param {String|Integer} prop The prop operating
 * @param {Object|Array} obj The object to clone
 * @return {Object|Array} A new object equivalent to the original.
 */ function $3f577aa3b6f252cf$var$_shallowCloneObject(prop, obj) {
    if ((0, $a36ac71f20068253$export$2e2bcd8739ae039)(prop) && (0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(obj)) return [].concat(obj);
    var result = {};
    for(var p in obj)result[p] = obj[p];
    return result;
}
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var $3f577aa3b6f252cf$var$dissocPath = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function dissocPath(path, obj) {
    if (obj == null) return obj;
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, $594f323765eb409e$export$2e2bcd8739ae039)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return $3f577aa3b6f252cf$var$_shallowCloneObject(head, obj);
            else return (0, $a9760553a5e17ba5$export$2e2bcd8739ae039)(head, dissocPath(tail, obj[head]), obj);
    }
});
var $3f577aa3b6f252cf$export$2e2bcd8739ae039 = $3f577aa3b6f252cf$var$dissocPath;


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var $456dcf9b41d32b07$var$dissoc = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function dissoc(prop, obj) {
    return (0, $3f577aa3b6f252cf$export$2e2bcd8739ae039)([
        prop
    ], obj);
});
var $456dcf9b41d32b07$export$2e2bcd8739ae039 = $456dcf9b41d32b07$var$dissoc;




/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var $ce26d877daaac912$var$divide = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function divide(a, b) {
    return a / b;
});
var $ce26d877daaac912$export$2e2bcd8739ae039 = $ce26d877daaac912$var$divide;






var $c87f60e2576c6321$var$XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XDrop.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XDrop.prototype["@@transducer/step"] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDrop;
}();
var $c87f60e2576c6321$var$_xdrop = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xdrop(n, xf) {
    return new $c87f60e2576c6321$var$XDrop(n, xf);
});
var $c87f60e2576c6321$export$2e2bcd8739ae039 = $c87f60e2576c6321$var$_xdrop;



/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var $19b155931c59b3cd$var$drop = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "drop"
], (0, $c87f60e2576c6321$export$2e2bcd8739ae039), function drop(n, xs) {
    return (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(Math.max(0, n), Infinity, xs);
}));
var $19b155931c59b3cd$export$2e2bcd8739ae039 = $19b155931c59b3cd$var$drop;









var $c53d1cebe3168cbb$var$XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XTake.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XTake.prototype["@@transducer/step"] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf["@@transducer/step"](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039)(ret) : ret;
    };
    return XTake;
}();
var $c53d1cebe3168cbb$var$_xtake = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xtake(n, xf) {
    return new $c53d1cebe3168cbb$var$XTake(n, xf);
});
var $c53d1cebe3168cbb$export$2e2bcd8739ae039 = $c53d1cebe3168cbb$var$_xtake;



/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var $d84b5ce3f84ef07d$var$take = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "take"
], (0, $c53d1cebe3168cbb$export$2e2bcd8739ae039), function take(n, xs) {
    return (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(0, n < 0 ? Infinity : n, xs);
}));
var $d84b5ce3f84ef07d$export$2e2bcd8739ae039 = $d84b5ce3f84ef07d$var$take;


function $e0483d825a50a930$export$2e2bcd8739ae039(n, xs) {
    return (0, $d84b5ce3f84ef07d$export$2e2bcd8739ae039)(n < xs.length ? xs.length - n : 0, xs);
}




var $9bd23d0097aaddae$var$XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XDropLast.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.full) result = this.xf["@@transducer/step"](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
var $9bd23d0097aaddae$var$_xdropLast = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xdropLast(n, xf) {
    return new $9bd23d0097aaddae$var$XDropLast(n, xf);
});
var $9bd23d0097aaddae$export$2e2bcd8739ae039 = $9bd23d0097aaddae$var$_xdropLast;


/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var $a05dadf462ec455d$var$dropLast = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $9bd23d0097aaddae$export$2e2bcd8739ae039), (0, $e0483d825a50a930$export$2e2bcd8739ae039)));
var $a05dadf462ec455d$export$2e2bcd8739ae039 = $a05dadf462ec455d$var$dropLast;





function $83e202f45e5e4339$export$2e2bcd8739ae039(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(0, idx + 1, xs);
}





var $624d04ca672e330c$var$XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XDropLastWhile.prototype["@@transducer/result"] = function(result) {
        this.retained = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLastWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(this.xf["@@transducer/step"], result, this.retained);
        this.retained = [];
        return this.xf["@@transducer/step"](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
var $624d04ca672e330c$var$_xdropLastWhile = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xdropLastWhile(fn, xf) {
    return new $624d04ca672e330c$var$XDropLastWhile(fn, xf);
});
var $624d04ca672e330c$export$2e2bcd8739ae039 = $624d04ca672e330c$var$_xdropLastWhile;


/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var $7a7cb5b9c29c5f6b$var$dropLastWhile = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $624d04ca672e330c$export$2e2bcd8739ae039), (0, $83e202f45e5e4339$export$2e2bcd8739ae039)));
var $7a7cb5b9c29c5f6b$export$2e2bcd8739ae039 = $7a7cb5b9c29c5f6b$var$dropLastWhile;






var $3f1f9dbf8e4272c8$var$XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XDropRepeatsWith.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XDropRepeatsWith.prototype["@@transducer/step"] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf["@@transducer/step"](result, input);
    };
    return XDropRepeatsWith;
}();
var $3f1f9dbf8e4272c8$var$_xdropRepeatsWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xdropRepeatsWith(pred, xf) {
    return new $3f1f9dbf8e4272c8$var$XDropRepeatsWith(pred, xf);
});
var $3f1f9dbf8e4272c8$export$2e2bcd8739ae039 = $3f1f9dbf8e4272c8$var$_xdropRepeatsWith;






/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var $9cc159b9b281daa7$var$last = /*#__PURE__*/ (0, $a16e55901f91382d$export$2e2bcd8739ae039)(-1);
var $9cc159b9b281daa7$export$2e2bcd8739ae039 = $9cc159b9b281daa7$var$last;


/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var $989e959fb13b9d3a$var$dropRepeatsWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $3f1f9dbf8e4272c8$export$2e2bcd8739ae039), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, $9cc159b9b281daa7$export$2e2bcd8739ae039)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
var $989e959fb13b9d3a$export$2e2bcd8739ae039 = $989e959fb13b9d3a$var$dropRepeatsWith;



/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var $2d26c05a69167215$var$dropRepeats = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], /*#__PURE__*/ (0, $3f1f9dbf8e4272c8$export$2e2bcd8739ae039)((0, $f5f23b53da900217$export$2e2bcd8739ae039)), /*#__PURE__*/ (0, $989e959fb13b9d3a$export$2e2bcd8739ae039)((0, $f5f23b53da900217$export$2e2bcd8739ae039))));
var $2d26c05a69167215$export$2e2bcd8739ae039 = $2d26c05a69167215$var$dropRepeats;







var $74d7df4fbc979b48$var$XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XDropWhile.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XDropWhile.prototype["@@transducer/step"] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDropWhile;
}();
var $74d7df4fbc979b48$var$_xdropWhile = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xdropWhile(f, xf) {
    return new $74d7df4fbc979b48$var$XDropWhile(f, xf);
});
var $74d7df4fbc979b48$export$2e2bcd8739ae039 = $74d7df4fbc979b48$var$_xdropWhile;



/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var $ba678016da668f18$var$dropWhile = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "dropWhile"
], (0, $74d7df4fbc979b48$export$2e2bcd8739ae039), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(idx, Infinity, xs);
}));
var $ba678016da668f18$export$2e2bcd8739ae039 = $ba678016da668f18$var$dropWhile;






/**
 * Returns the first argument if it is truthy, otherwise the second argument.
 * Acts as the boolean `or` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.either, R.and
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var $a394b964a29c41ab$var$or = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function or(a, b) {
    return a || b;
});
var $a394b964a29c41ab$export$2e2bcd8739ae039 = $a394b964a29c41ab$var$or;


/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.both, R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var $174740c9e060027b$var$either = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function either(f, g) {
    return (0, $0eef464cca01ff27$export$2e2bcd8739ae039)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, $d4a47b4162ca03e7$export$2e2bcd8739ae039)((0, $a394b964a29c41ab$export$2e2bcd8739ae039))(f, g);
});
var $174740c9e060027b$export$2e2bcd8739ae039 = $174740c9e060027b$var$either;







/**
 * Tests whether or not an object is a typed array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is a typed array, `false` otherwise.
 * @example
 *
 *      _isTypedArray(new Uint8Array([])); //=> true
 *      _isTypedArray(new Float32Array([])); //=> true
 *      _isTypedArray([]); //=> false
 *      _isTypedArray(null); //=> false
 *      _isTypedArray({}); //=> false
 */ function $f1150e2c44776968$export$2e2bcd8739ae039(val) {
    var type = Object.prototype.toString.call(val);
    return type === "[object Uint8ClampedArray]" || type === "[object Int8Array]" || type === "[object Uint8Array]" || type === "[object Int16Array]" || type === "[object Uint16Array]" || type === "[object Int32Array]" || type === "[object Uint32Array]" || type === "[object Float32Array]" || type === "[object Float64Array]" || type === "[object BigInt64Array]" || type === "[object BigUint64Array]";
}


/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`),
 * TypedArray (`Uint8Array []`, `Float32Array []`, etc), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));               //=> Nothing()
 *      R.empty([1, 2, 3]);              //=> []
 *      R.empty('unicorns');             //=> ''
 *      R.empty({x: 1, y: 2});           //=> {}
 *      R.empty(Uint8Array.from('123')); //=> Uint8Array []
 */ var $9dd73ca76fee62b7$var$empty = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function empty(x) {
    return x != null && typeof x["fantasy-land/empty"] === "function" ? x["fantasy-land/empty"]() : x != null && x.constructor != null && typeof x.constructor["fantasy-land/empty"] === "function" ? x.constructor["fantasy-land/empty"]() : x != null && typeof x.empty === "function" ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === "function" ? x.constructor.empty() : (0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(x) ? [] : (0, $fba16ff7050dd77f$export$2e2bcd8739ae039)(x) ? "" : (0, $0a9142ae7089a2b4$export$2e2bcd8739ae039)(x) ? {} : (0, $d0eb546af0a6cb8d$export$2e2bcd8739ae039)(x) ? function() {
        return arguments;
    }() : (0, $f1150e2c44776968$export$2e2bcd8739ae039)(x) ? x.constructor.from("") : void 0 // else
    ;
});
var $9dd73ca76fee62b7$export$2e2bcd8739ae039 = $9dd73ca76fee62b7$var$empty;






/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var $3b1dc68a71f369a5$var$takeLast = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function takeLast(n, xs) {
    return (0, $19b155931c59b3cd$export$2e2bcd8739ae039)(n >= 0 ? xs.length - n : 0, xs);
});
var $3b1dc68a71f369a5$export$2e2bcd8739ae039 = $3b1dc68a71f369a5$var$takeLast;


/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $e84d2fe9ca8acb5c$var$endsWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(suffix, list) {
    return (0, $f5f23b53da900217$export$2e2bcd8739ae039)((0, $3b1dc68a71f369a5$export$2e2bcd8739ae039)(suffix.length, list), suffix);
});
var $e84d2fe9ca8acb5c$export$2e2bcd8739ae039 = $e84d2fe9ca8acb5c$var$endsWith;




/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var $1442937e086297a9$var$eqBy = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function eqBy(f, x, y) {
    return (0, $f5f23b53da900217$export$2e2bcd8739ae039)(f(x), f(y));
});
var $1442937e086297a9$export$2e2bcd8739ae039 = $1442937e086297a9$var$eqBy;




/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var $934cb6857bd14bf9$var$eqProps = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function eqProps(prop, obj1, obj2) {
    return (0, $f5f23b53da900217$export$2e2bcd8739ae039)(obj1[prop], obj2[prop]);
});
var $934cb6857bd14bf9$export$2e2bcd8739ae039 = $934cb6857bd14bf9$var$eqProps;






/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var $959106279ff4ef33$var$evolve = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function evolve(transformations, object) {
    if (!(0, $0a9142ae7089a2b4$export$2e2bcd8739ae039)(object) && !(0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(object)) return object;
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === "function" ? transformation(object[key]) : transformation && type === "object" ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
var $959106279ff4ef33$export$2e2bcd8739ae039 = $959106279ff4ef33$var$evolve;








var $4d11a95ca32445c4$var$XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XFind.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, void 0);
        return this.xf["@@transducer/result"](result);
    };
    XFind.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, input));
        }
        return result;
    };
    return XFind;
}();
var $4d11a95ca32445c4$var$_xfind = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xfind(f, xf) {
    return new $4d11a95ca32445c4$var$XFind(f, xf);
});
var $4d11a95ca32445c4$export$2e2bcd8739ae039 = $4d11a95ca32445c4$var$_xfind;


/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var $91330ac21ab7206c$var$find = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "find"
], (0, $4d11a95ca32445c4$export$2e2bcd8739ae039), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
var $91330ac21ab7206c$export$2e2bcd8739ae039 = $91330ac21ab7206c$var$find;







var $a386bb2d6040bbfd$var$XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XFindIndex.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, -1);
        return this.xf["@@transducer/result"](result);
    };
    XFindIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var $a386bb2d6040bbfd$var$_xfindIndex = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xfindIndex(f, xf) {
    return new $a386bb2d6040bbfd$var$XFindIndex(f, xf);
});
var $a386bb2d6040bbfd$export$2e2bcd8739ae039 = $a386bb2d6040bbfd$var$_xfindIndex;


/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.indexOf
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $36743806dca79c19$var$findIndex = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $a386bb2d6040bbfd$export$2e2bcd8739ae039), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
var $36743806dca79c19$export$2e2bcd8739ae039 = $36743806dca79c19$var$findIndex;






var $898ac2f5fbdaf15e$var$XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XFindLast.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.last));
    };
    XFindLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var $898ac2f5fbdaf15e$var$_xfindLast = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xfindLast(f, xf) {
    return new $898ac2f5fbdaf15e$var$XFindLast(f, xf);
});
var $898ac2f5fbdaf15e$export$2e2bcd8739ae039 = $898ac2f5fbdaf15e$var$_xfindLast;


/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var $9a9cbca76bf79723$var$findLast = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $898ac2f5fbdaf15e$export$2e2bcd8739ae039), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
var $9a9cbca76bf79723$export$2e2bcd8739ae039 = $9a9cbca76bf79723$var$findLast;






var $0c0737bfc446fc08$var$XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XFindLastIndex.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.lastIdx));
    };
    XFindLastIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
var $0c0737bfc446fc08$var$_xfindLastIndex = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xfindLastIndex(f, xf) {
    return new $0c0737bfc446fc08$var$XFindLastIndex(f, xf);
});
var $0c0737bfc446fc08$export$2e2bcd8739ae039 = $0c0737bfc446fc08$var$_xfindLastIndex;


/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.lastIndexOf
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $ca41a883ca50cc1a$var$findLastIndex = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $0c0737bfc446fc08$export$2e2bcd8739ae039), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
var $ca41a883ca50cc1a$export$2e2bcd8739ae039 = $ca41a883ca50cc1a$var$findLastIndex;




/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var $8d39c4a7815175c3$var$flatten = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $8f92ae87b39064ea$export$2e2bcd8739ae039)(true));
var $8d39c4a7815175c3$export$2e2bcd8739ae039 = $8d39c4a7815175c3$var$flatten;




/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var $0ccde7bdbe6db1af$var$flip = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function flip(fn) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
var $0ccde7bdbe6db1af$export$2e2bcd8739ae039 = $0ccde7bdbe6db1af$var$flip;




/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var $1ff0a02f756518d8$var$forEach = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $d8ccc90b207990fc$export$2e2bcd8739ae039)("forEach", function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
var $1ff0a02f756518d8$export$2e2bcd8739ae039 = $1ff0a02f756518d8$var$forEach;




/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var $4fe451fa362e0776$var$forEachObjIndexed = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, $89717ab94613e822$export$2e2bcd8739ae039)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
var $4fe451fa362e0776$export$2e2bcd8739ae039 = $4fe451fa362e0776$var$forEachObjIndexed;



/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var $e06924646d6ef2ad$var$fromPairs = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
var $e06924646d6ef2ad$export$2e2bcd8739ae039 = $e06924646d6ef2ad$var$fromPairs;





/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a key-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: [b]}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce, R.indexBy
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var $4b0fe120dfec3288$var$groupBy = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $d8ccc90b207990fc$export$2e2bcd8739ae039)("groupBy", /*#__PURE__*/ (0, $d27468100aaa010c$export$2e2bcd8739ae039)(function(acc, item) {
    acc.push(item);
    return acc;
}, [])));
var $4b0fe120dfec3288$export$2e2bcd8739ae039 = $4b0fe120dfec3288$var$groupBy;



/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * const isVowel = R.test(/^[aeiou]$/i);
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var $01a43d7499699b35$var$groupWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
var $01a43d7499699b35$export$2e2bcd8739ae039 = $01a43d7499699b35$var$groupWith;



/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var $18f0b908f2cfe15a$var$gt = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function gt(a, b) {
    return a > b;
});
var $18f0b908f2cfe15a$export$2e2bcd8739ae039 = $18f0b908f2cfe15a$var$gt;



/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var $3537f64c9e455977$var$gte = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function gte(a, b) {
    return a >= b;
});
var $3537f64c9e455977$export$2e2bcd8739ae039 = $3537f64c9e455977$var$gte;






/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var $fa87ec08b45b57a0$var$hasPath = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function hasPath(_path, obj) {
    if (_path.length === 0 || (0, $0cd8964fcc0096b1$export$2e2bcd8739ae039)(obj)) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if (!(0, $0cd8964fcc0096b1$export$2e2bcd8739ae039)(val) && (0, $3e434626b2866668$export$2e2bcd8739ae039)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
var $fa87ec08b45b57a0$export$2e2bcd8739ae039 = $fa87ec08b45b57a0$var$hasPath;


/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var $a1c76089443586f4$var$has = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function has(prop, obj) {
    return (0, $fa87ec08b45b57a0$export$2e2bcd8739ae039)([
        prop
    ], obj);
});
var $a1c76089443586f4$export$2e2bcd8739ae039 = $a1c76089443586f4$var$has;




/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var $8df7939dbd57a1e1$var$hasIn = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function hasIn(prop, obj) {
    if ((0, $0cd8964fcc0096b1$export$2e2bcd8739ae039)(obj)) return false;
    return prop in obj;
});
var $8df7939dbd57a1e1$export$2e2bcd8739ae039 = $8df7939dbd57a1e1$var$hasIn;






/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var $d9728a848c054655$var$identical = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)((0, $91e3de09550f1416$export$2e2bcd8739ae039));
var $d9728a848c054655$export$2e2bcd8739ae039 = $d9728a848c054655$var$identical;





/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({ count: 1 }); //=> { count: 2 }
 *      incCount({});           //=> { count: 1 }
 */ var $e612267c9d2f1844$var$ifElse = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function ifElse(condition, onTrue, onFalse) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
var $e612267c9d2f1844$export$2e2bcd8739ae039 = $e612267c9d2f1844$var$ifElse;



/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var $1893a82a498a2323$var$inc = /*#__PURE__*/ (0, $757411ca5124d4c2$export$2e2bcd8739ae039)(1);
var $1893a82a498a2323$export$2e2bcd8739ae039 = $1893a82a498a2323$var$inc;




/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Also works with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var $b7ec0c134a3cae99$var$includes = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)((0, $ffa2ed402645a184$export$2e2bcd8739ae039));
var $b7ec0c134a3cae99$export$2e2bcd8739ae039 = $b7ec0c134a3cae99$var$includes;



/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: b}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @see R.groupBy
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var $ade4d1c3c66ca336$var$indexBy = /*#__PURE__*/ (0, $d27468100aaa010c$export$2e2bcd8739ae039)(function(acc, elem) {
    return elem;
}, null);
var $ade4d1c3c66ca336$export$2e2bcd8739ae039 = $ade4d1c3c66ca336$var$indexBy;





/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf, R.findIndex
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var $7d2f82a08ef93437$var$indexOf = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function indexOf(target, xs) {
    return typeof xs.indexOf === "function" && !(0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(xs) ? xs.indexOf(target) : (0, $70b8d125c84c0682$export$2e2bcd8739ae039)(xs, target, 0);
});
var $7d2f82a08ef93437$export$2e2bcd8739ae039 = $7d2f82a08ef93437$var$indexOf;



/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var $d94373664a8c6040$var$init = /*#__PURE__*/ (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(0, -1);
var $d94373664a8c6040$export$2e2bcd8739ae039 = $d94373664a8c6040$var$init;





/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var $f136a683c66c46f6$var$innerJoin = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function innerJoin(pred, xs, ys) {
    return (0, $f1fc8dd126aa3213$export$2e2bcd8739ae039)(function(x) {
        return (0, $298b882271db9e5b$export$2e2bcd8739ae039)(pred, x, ys);
    }, xs);
});
var $f136a683c66c46f6$export$2e2bcd8739ae039 = $f136a683c66c46f6$var$innerJoin;



/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var $24775fc0d8720af5$var$insert = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
var $24775fc0d8720af5$export$2e2bcd8739ae039 = $24775fc0d8720af5$var$insert;



/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var $d4419bbae6444f96$var$insertAll = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
var $d4419bbae6444f96$export$2e2bcd8739ae039 = $d4419bbae6444f96$var$insertAll;













var $9193865a1950ecde$var$XUniqBy = /*#__PURE__*/ function() {
    function XUniqBy(f, xf) {
        this.xf = xf;
        this.f = f;
        this.set = new (0, $6078c297d1e76956$export$2e2bcd8739ae039)();
    }
    XUniqBy.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XUniqBy.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XUniqBy.prototype["@@transducer/step"] = function(result, input) {
        return this.set.add(this.f(input)) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XUniqBy;
}();
var $9193865a1950ecde$var$_xuniqBy = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xuniqBy(f, xf) {
    return new $9193865a1950ecde$var$XUniqBy(f, xf);
});
var $9193865a1950ecde$export$2e2bcd8739ae039 = $9193865a1950ecde$var$_xuniqBy;


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var $0f7e2b1ccc5ecfc4$var$uniqBy = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $9193865a1950ecde$export$2e2bcd8739ae039), function(fn, list) {
    var set = new (0, $6078c297d1e76956$export$2e2bcd8739ae039)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
}));
var $0f7e2b1ccc5ecfc4$export$2e2bcd8739ae039 = $0f7e2b1ccc5ecfc4$var$uniqBy;


/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var $6304fcdb3884aaf5$var$uniq = /*#__PURE__*/ (0, $0f7e2b1ccc5ecfc4$export$2e2bcd8739ae039)((0, $54ee1c4ac03392aa$export$2e2bcd8739ae039));
var $6304fcdb3884aaf5$export$2e2bcd8739ae039 = $6304fcdb3884aaf5$var$uniq;


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var $b90c6cab60c1a161$var$intersection = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, $6304fcdb3884aaf5$export$2e2bcd8739ae039)((0, $f1fc8dd126aa3213$export$2e2bcd8739ae039)((0, $0ccde7bdbe6db1af$export$2e2bcd8739ae039)((0, $ffa2ed402645a184$export$2e2bcd8739ae039))(lookupList), filteredList));
});
var $b90c6cab60c1a161$export$2e2bcd8739ae039 = $b90c6cab60c1a161$var$intersection;




/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var $1f3f562952e933df$var$intersperse = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $d8ccc90b207990fc$export$2e2bcd8739ae039)("intersperse", function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
var $1f3f562952e933df$export$2e2bcd8739ae039 = $1f3f562952e933df$var$intersperse;







function $dce528b8d576e911$var$_objectAssign(target) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
var $dce528b8d576e911$export$2e2bcd8739ae039 = typeof Object.assign === "function" ? Object.assign : $dce528b8d576e911$var$_objectAssign;






/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var $428346b5ac35601e$var$objOf = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
var $428346b5ac35601e$export$2e2bcd8739ae039 = $428346b5ac35601e$var$objOf;


var $b8ea6102910442af$var$_stepCatArray = {
    "@@transducer/init": Array,
    "@@transducer/step": function(xs, x) {
        xs.push(x);
        return xs;
    },
    "@@transducer/result": (0, $4e7387e3232e683f$export$2e2bcd8739ae039)
};
var $b8ea6102910442af$var$_stepCatString = {
    "@@transducer/init": String,
    "@@transducer/step": function(a, b) {
        return a + b;
    },
    "@@transducer/result": (0, $4e7387e3232e683f$export$2e2bcd8739ae039)
};
var $b8ea6102910442af$var$_stepCatObject = {
    "@@transducer/init": Object,
    "@@transducer/step": function(result, input) {
        return (0, $dce528b8d576e911$export$2e2bcd8739ae039)(result, (0, $2a419b1d87c69d2d$export$2e2bcd8739ae039)(input) ? (0, $428346b5ac35601e$export$2e2bcd8739ae039)(input[0], input[1]) : input);
    },
    "@@transducer/result": (0, $4e7387e3232e683f$export$2e2bcd8739ae039)
};
function $b8ea6102910442af$export$2e2bcd8739ae039(obj) {
    if ((0, $d2e26a2a9b11036b$export$2e2bcd8739ae039)(obj)) return obj;
    if ((0, $2a419b1d87c69d2d$export$2e2bcd8739ae039)(obj)) return $b8ea6102910442af$var$_stepCatArray;
    if (typeof obj === "string") return $b8ea6102910442af$var$_stepCatString;
    if (typeof obj === "object") return $b8ea6102910442af$var$_stepCatObject;
    throw new Error("Cannot create transformer for " + obj);
}


/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var $26b09f65c081aa98$var$into = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function into(acc, xf, list) {
    return (0, $d2e26a2a9b11036b$export$2e2bcd8739ae039)(acc) ? (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(xf(acc), acc["@@transducer/init"](), list) : (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(xf((0, $b8ea6102910442af$export$2e2bcd8739ae039)(acc)), (0, $11797de4521b5141$export$2e2bcd8739ae039)(acc, [], [], false), list);
});
var $26b09f65c081aa98$export$2e2bcd8739ae039 = $26b09f65c081aa98$var$into;





/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var $2bf0a4a56de8f705$var$invert = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function invert(obj) {
    var props = (0, $89717ab94613e822$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, $3e434626b2866668$export$2e2bcd8739ae039)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
var $2bf0a4a56de8f705$export$2e2bcd8739ae039 = $2bf0a4a56de8f705$var$invert;




/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var $07c2821392879bcb$var$invertObj = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function invertObj(obj) {
    var props = (0, $89717ab94613e822$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
var $07c2821392879bcb$export$2e2bcd8739ae039 = $07c2821392879bcb$var$invertObj;






/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of any of the target object's methods to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 *
 *      const dog = {
 *        speak: async () => 'Woof!'
 *      };
 *      const speak = R.invoker(0, 'speak');
 *      speak(dog).then(console.log) //~> 'Woof!'
 *
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var $0e383c5d409fb7c7$var$invoker = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function invoker(arity, method) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, $0eef464cca01ff27$export$2e2bcd8739ae039)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, $754b63e580f0fde1$export$2e2bcd8739ae039)(target) + ' does not have a method named "' + method + '"');
    });
});
var $0e383c5d409fb7c7$export$2e2bcd8739ae039 = $0e383c5d409fb7c7$var$invoker;



/**
 * See if an object (i.e. `val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 * If `val` was created using `Object.create`, `R.is(Object, val) === true`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var $5d8019f2a3c9ed03$var$is = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function is(Ctor, val) {
    return val instanceof Ctor || val != null && (val.constructor === Ctor || Ctor.name === "Object" && typeof val === "object");
});
var $5d8019f2a3c9ed03$export$2e2bcd8739ae039 = $5d8019f2a3c9ed03$var$is;





/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);           //=> false
 *      R.isEmpty([]);                  //=> true
 *      R.isEmpty('');                  //=> true
 *      R.isEmpty(null);                //=> false
 *      R.isEmpty({});                  //=> true
 *      R.isEmpty({length: 0});         //=> false
 *      R.isEmpty(Uint8Array.from('')); //=> true
 */ var $ec30f762231a8e05$var$isEmpty = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function isEmpty(x) {
    return x != null && (0, $f5f23b53da900217$export$2e2bcd8739ae039)(x, (0, $9dd73ca76fee62b7$export$2e2bcd8739ae039)(x));
});
var $ec30f762231a8e05$export$2e2bcd8739ae039 = $ec30f762231a8e05$var$isEmpty;




/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var $7778044010b59ed5$var$join = /*#__PURE__*/ (0, $0e383c5d409fb7c7$export$2e2bcd8739ae039)(1, "join");
var $7778044010b59ed5$export$2e2bcd8739ae039 = $7778044010b59ed5$var$join;




/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var $6ad4ce8ee33df63f$var$juxt = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function juxt(fns) {
    return (0, $55b7cb4cf5a94fb5$export$2e2bcd8739ae039)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
var $6ad4ce8ee33df63f$export$2e2bcd8739ae039 = $6ad4ce8ee33df63f$var$juxt;




/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var $cefe561a89539ca1$var$keysIn = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
var $cefe561a89539ca1$export$2e2bcd8739ae039 = $cefe561a89539ca1$var$keysIn;






/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf, R.findLastIndex
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var $eaec592dd4ded264$var$lastIndexOf = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === "function" && !(0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, $f5f23b53da900217$export$2e2bcd8739ae039)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
var $eaec592dd4ded264$export$2e2bcd8739ae039 = $eaec592dd4ded264$var$lastIndexOf;



function $2b963c5066d50841$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Number]";
}


/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var $7dfe924c13ca1796$var$length = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function length(list) {
    return list != null && (0, $2b963c5066d50841$export$2e2bcd8739ae039)(list.length) ? list.length : NaN;
});
var $7dfe924c13ca1796$export$2e2bcd8739ae039 = $7dfe924c13ca1796$var$length;




/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $8a1180def7cabf93$var$lens = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, $b01f107cd36c1471$export$2e2bcd8739ae039)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
var $8a1180def7cabf93$export$2e2bcd8739ae039 = $8a1180def7cabf93$var$lens;








/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var $a08f44105d44c69f$var$update = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function update(idx, x, list) {
    return (0, $7f73db655ec2f6ce$export$2e2bcd8739ae039)(idx, (0, $2ff120835f8592de$export$2e2bcd8739ae039)(x), list);
});
var $a08f44105d44c69f$export$2e2bcd8739ae039 = $a08f44105d44c69f$var$update;


/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over, R.nth
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var $6a38004ad63f5b5c$var$lensIndex = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function lensIndex(n) {
    return (0, $8a1180def7cabf93$export$2e2bcd8739ae039)((0, $a16e55901f91382d$export$2e2bcd8739ae039)(n), (0, $a08f44105d44c69f$export$2e2bcd8739ae039)(n));
});
var $6a38004ad63f5b5c$export$2e2bcd8739ae039 = $6a38004ad63f5b5c$var$lensIndex;









/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int | Symbol]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var $38b7e48b37b1dd5d$var$paths = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function paths(pathsArray, obj) {
    return pathsArray.map(function(paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < paths.length){
            if (val == null) return;
            p = paths[idx];
            val = (0, $a36ac71f20068253$export$2e2bcd8739ae039)(p) ? (0, $a16e55901f91382d$export$2e2bcd8739ae039)(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
var $38b7e48b37b1dd5d$export$2e2bcd8739ae039 = $38b7e48b37b1dd5d$var$paths;


/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 */ var $9bd9d0833c80fa65$var$path = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function path(pathAr, obj) {
    return (0, $38b7e48b37b1dd5d$export$2e2bcd8739ae039)([
        pathAr
    ], obj)[0];
});
var $9bd9d0833c80fa65$export$2e2bcd8739ae039 = $9bd9d0833c80fa65$var$path;


/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var $bce95dd416d55717$var$lensPath = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function lensPath(p) {
    return (0, $8a1180def7cabf93$export$2e2bcd8739ae039)((0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)(p), (0, $f63804dd4a880548$export$2e2bcd8739ae039)(p));
});
var $bce95dd416d55717$export$2e2bcd8739ae039 = $bce95dd416d55717$var$lensPath;






/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $73a409bdc76205e2$var$lensProp = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function lensProp(k) {
    return (0, $8a1180def7cabf93$export$2e2bcd8739ae039)((0, $d925005fae164d75$export$2e2bcd8739ae039)(k), (0, $a9760553a5e17ba5$export$2e2bcd8739ae039)(k));
});
var $73a409bdc76205e2$export$2e2bcd8739ae039 = $73a409bdc76205e2$var$lensProp;





/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var $7639a278b5ac4dbc$var$lt = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function lt(a, b) {
    return a < b;
});
var $7639a278b5ac4dbc$export$2e2bcd8739ae039 = $7639a278b5ac4dbc$var$lt;



/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var $258ef72187a06d41$var$lte = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function lte(a, b) {
    return a <= b;
});
var $258ef72187a06d41$export$2e2bcd8739ae039 = $258ef72187a06d41$var$lte;




/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var $097d37ec80270e16$var$mapAccum = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $097d37ec80270e16$export$2e2bcd8739ae039 = $097d37ec80270e16$var$mapAccum;



/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */ var $0f0cff1a52caf846$var$mapAccumRight = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $0f0cff1a52caf846$export$2e2bcd8739ae039 = $0f0cff1a52caf846$var$mapAccumRight;





/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var $5eb0a129afa48116$var$mapObjIndexed = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function mapObjIndexed(fn, obj) {
    return (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, $89717ab94613e822$export$2e2bcd8739ae039)(obj));
});
var $5eb0a129afa48116$export$2e2bcd8739ae039 = $5eb0a129afa48116$var$mapObjIndexed;



/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var $869aa81c0c166aef$var$match = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function match(rx, str) {
    return str.match(rx) || [];
});
var $869aa81c0c166aef$export$2e2bcd8739ae039 = $869aa81c0c166aef$var$match;




/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var $2f1c2cd8a79e3b57$var$mathMod = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function mathMod(m, p) {
    if (!(0, $a36ac71f20068253$export$2e2bcd8739ae039)(m)) return NaN;
    if (!(0, $a36ac71f20068253$export$2e2bcd8739ae039)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
var $2f1c2cd8a79e3b57$export$2e2bcd8739ae039 = $2f1c2cd8a79e3b57$var$mathMod;




/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var $e0160e0d54353241$var$maxBy = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function maxBy(f, a, b) {
    return f(b) > f(a) ? b : a;
});
var $e0160e0d54353241$export$2e2bcd8739ae039 = $e0160e0d54353241$var$maxBy;





/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var $76342b55fa34e586$var$sum = /*#__PURE__*/ (0, $0fda840d89c87320$export$2e2bcd8739ae039)((0, $757411ca5124d4c2$export$2e2bcd8739ae039), 0);
var $76342b55fa34e586$export$2e2bcd8739ae039 = $76342b55fa34e586$var$sum;


/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var $2eb7548e25d1dcd0$var$mean = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function mean(list) {
    return (0, $76342b55fa34e586$export$2e2bcd8739ae039)(list) / list.length;
});
var $2eb7548e25d1dcd0$export$2e2bcd8739ae039 = $2eb7548e25d1dcd0$var$mean;




/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var $f4d3566f3dbfaa40$var$median = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, $2eb7548e25d1dcd0$export$2e2bcd8739ae039)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
var $f4d3566f3dbfaa40$export$2e2bcd8739ae039 = $f4d3566f3dbfaa40$var$median;





/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * Care must be taken when implementing key generation to avoid key collision,
 * or if tracking references, memory leaks and mutating arguments.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(Number, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var $c7850122648ba5a7$var$memoizeWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function memoizeWith(mFn, fn) {
    var cache = {};
    return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(fn.length, function() {
        var key = mFn.apply(this, arguments);
        if (!(0, $3e434626b2866668$export$2e2bcd8739ae039)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
var $c7850122648ba5a7$export$2e2bcd8739ae039 = $c7850122648ba5a7$var$memoizeWith;




/**
 * Creates one new object with the own properties from a list of objects.
 * If a key exists in more than one object, the value from the last
 * object it exists in will be used.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var $1f14783b524d43e5$var$mergeAll = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function mergeAll(list) {
    return (0, $dce528b8d576e911$export$2e2bcd8739ae039).apply(null, [
        {}
    ].concat(list));
});
var $1f14783b524d43e5$export$2e2bcd8739ae039 = $1f14783b524d43e5$var$mergeAll;







/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $88f9c2e4c46f4f3a$var$mergeWithKey = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(k, l)) result[k] = (0, $3e434626b2866668$export$2e2bcd8739ae039)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(k, r) && !(0, $3e434626b2866668$export$2e2bcd8739ae039)(k, result)) result[k] = r[k];
    return result;
});
var $88f9c2e4c46f4f3a$export$2e2bcd8739ae039 = $88f9c2e4c46f4f3a$var$mergeWithKey;


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $8d8ed28c9538581e$var$mergeDeepWithKey = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $88f9c2e4c46f4f3a$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        if ((0, $0a9142ae7089a2b4$export$2e2bcd8739ae039)(lVal) && (0, $0a9142ae7089a2b4$export$2e2bcd8739ae039)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $8d8ed28c9538581e$export$2e2bcd8739ae039 = $8d8ed28c9538581e$var$mergeDeepWithKey;


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $f093519f526756af$var$mergeDeepLeft = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function mergeDeepLeft(lObj, rObj) {
    return (0, $8d8ed28c9538581e$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
var $f093519f526756af$export$2e2bcd8739ae039 = $f093519f526756af$var$mergeDeepLeft;




/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $1d7f6fc3baf8e6e8$var$mergeDeepRight = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function mergeDeepRight(lObj, rObj) {
    return (0, $8d8ed28c9538581e$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $1d7f6fc3baf8e6e8$export$2e2bcd8739ae039 = $1d7f6fc3baf8e6e8$var$mergeDeepRight;




/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var $d67552c9062c0280$var$mergeDeepWith = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, $8d8ed28c9538581e$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
var $d67552c9062c0280$export$2e2bcd8739ae039 = $d67552c9062c0280$var$mergeDeepWith;





/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var $bf5541ad2a2a031b$var$mergeLeft = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function mergeLeft(l, r) {
    return (0, $dce528b8d576e911$export$2e2bcd8739ae039)({}, r, l);
});
var $bf5541ad2a2a031b$export$2e2bcd8739ae039 = $bf5541ad2a2a031b$var$mergeLeft;




/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var $1ad830fed2fe76e8$var$mergeRight = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function mergeRight(l, r) {
    return (0, $dce528b8d576e911$export$2e2bcd8739ae039)({}, l, r);
});
var $1ad830fed2fe76e8$export$2e2bcd8739ae039 = $1ad830fed2fe76e8$var$mergeRight;




/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var $3122f2192237535b$var$mergeWith = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function mergeWith(fn, l, r) {
    return (0, $88f9c2e4c46f4f3a$export$2e2bcd8739ae039)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
var $3122f2192237535b$export$2e2bcd8739ae039 = $3122f2192237535b$var$mergeWith;




/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var $c877f35d79fe080b$var$min = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function min(a, b) {
    return b < a ? b : a;
});
var $c877f35d79fe080b$export$2e2bcd8739ae039 = $c877f35d79fe080b$var$min;



/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var $9f5cd257b12cdbdb$var$minBy = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
var $9f5cd257b12cdbdb$export$2e2bcd8739ae039 = $9f5cd257b12cdbdb$var$minBy;










function $684013d7b0660705$export$2e2bcd8739ae039(prop, fn, obj) {
    if ((0, $a36ac71f20068253$export$2e2bcd8739ae039)(prop) && (0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = fn(arr[prop]);
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = fn(result[prop]);
    return result;
}


/**
 * Creates a shallow clone of the passed object by applying an `fn` function
 * to the value at the given path.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding path does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig [Idx] -> (v -> v) -> {k: v} -> {k: v}
 * @param {Array} path The path to be modified.
 * @param {Function} fn The function to apply to the path.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', address: { zipCode: '90216' }};
 *      R.modifyPath(['address', 'zipCode'], R.reverse, person); //=> {name: 'James', address: { zipCode: '61209' }}
 *
 *      // Can handle arrays too
 *      const person = {name: 'James', addresses: [{ zipCode: '90216' }]};
 *      R.modifyPath(['addresses', 0, 'zipCode'], R.reverse, person); //=> {name: 'James', addresses: [{ zipCode: '61209' }]}
 */ var $1080ec04d46af352$var$modifyPath = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function modifyPath(path, fn, object) {
    if (!(0, $0a9142ae7089a2b4$export$2e2bcd8739ae039)(object) && !(0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(object) || path.length === 0) return object;
    var idx = path[0];
    if (!(0, $3e434626b2866668$export$2e2bcd8739ae039)(idx, object)) return object;
    if (path.length === 1) return (0, $684013d7b0660705$export$2e2bcd8739ae039)(idx, fn, object);
    var val = modifyPath(Array.prototype.slice.call(path, 1), fn, object[idx]);
    if (val === object[idx]) return object;
    return (0, $d98e4d563993ddcf$export$2e2bcd8739ae039)(idx, val, object);
});
var $1080ec04d46af352$export$2e2bcd8739ae039 = $1080ec04d46af352$var$modifyPath;


/**
 * Creates a copy of the passed object by applying an `fn` function to the given `prop` property.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding property does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig Idx -> (v -> v) -> {k: v} -> {k: v}
 * @param {String|Number} prop The property to be modified.
 * @param {Function} fn The function to apply to the property.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', age: 20, pets: ['dog', 'cat']};
 *      R.modify('age', R.add(1), person); //=> {name: 'James', age: 21, pets: ['dog', 'cat']}
 *      R.modify('pets', R.append('turtle'), person); //=> {name: 'James', age: 20, pets: ['dog', 'cat', 'turtle']}
 */ var $4c3102c44a541f83$var$modify = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function modify(prop, fn, object) {
    return (0, $1080ec04d46af352$export$2e2bcd8739ae039)([
        prop
    ], fn, object);
});
var $4c3102c44a541f83$export$2e2bcd8739ae039 = $4c3102c44a541f83$var$modify;




/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var $e0cecc682c0745dd$var$modulo = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function modulo(a, b) {
    return a % b;
});
var $e0cecc682c0745dd$export$2e2bcd8739ae039 = $e0cecc682c0745dd$var$modulo;



/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var $d66424345bc6d38f$var$move = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
var $d66424345bc6d38f$export$2e2bcd8739ae039 = $d66424345bc6d38f$var$move;



/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var $37211b73a19f3a8b$var$multiply = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function multiply(a, b) {
    return a * b;
});
var $37211b73a19f3a8b$export$2e2bcd8739ae039 = $37211b73a19f3a8b$var$multiply;



var $d0aff671524d0bc8$exports = {};


var /**
 * Takes a function `f` and an object, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the object
 * provided initially merged deeply (right) with the object provided as an argument to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (({ a, b, c, ..., n }) -> x) -> { a, b, c, ...} -> ({ d, e, f, ..., n } -> x)
 * @param {Function} f
 * @param {Object} props
 * @return {Function}
 * @see R.partial, R.partialRight, R.curry, R.mergeDeepRight
 * @example
 *
 *      const multiply2 = ({ a, b }) => a * b;
 *      const double = R.partialObject(multiply2, { a: 2 });
 *      double({ b: 2 }); //=> 4
 *
 *      const greet = ({ salutation, title, firstName, lastName }) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partialObject(greet, { salutation: 'Hello' });
 *      const sayHelloToMs = R.partialObject(sayHello, { title: 'Ms.' });
 *      sayHelloToMs({ firstName: 'Jane', lastName: 'Jones' }); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialObject(f, { a, b })({ c, d }) = f({ a, b, c, d })
 */ $d0aff671524d0bc8$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)((f, o)=>(props)=>f.call(undefined, (0, $1d7f6fc3baf8e6e8$export$2e2bcd8739ae039)(o, props)));



/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var $702876edcff848ce$var$negate = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function negate(n) {
    return -n;
});
var $702876edcff848ce$export$2e2bcd8739ae039 = $702876edcff848ce$var$negate;





/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 !== 0;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var $e27b6730621501aa$var$none = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function none(fn, input) {
    return (0, $d21f920c7affe2af$export$2e2bcd8739ae039)((0, $36e62400fc48e701$export$2e2bcd8739ae039)(fn), input);
});
var $e27b6730621501aa$export$2e2bcd8739ae039 = $e27b6730621501aa$var$none;







/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var $b17fa64d8e6bf6d6$var$nthArg = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(arity, function() {
        return (0, $a16e55901f91382d$export$2e2bcd8739ae039)(n, arguments);
    });
});
var $b17fa64d8e6bf6d6$export$2e2bcd8739ae039 = $b17fa64d8e6bf6d6$var$nthArg;



/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var $4a113cacbf89a5ee$var$o = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function o(f, g, x) {
    return f(g(x));
});
var $4a113cacbf89a5ee$export$2e2bcd8739ae039 = $4a113cacbf89a5ee$var$o;




function $1c24519850035d73$export$2e2bcd8739ae039(x) {
    return [
        x
    ];
}


/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */ var $78f066a435df53c7$var$of = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)((0, $1c24519850035d73$export$2e2bcd8739ae039));
var $78f066a435df53c7$export$2e2bcd8739ae039 = $78f066a435df53c7$var$of;



/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var $cc8ac6ed0ffb93b6$var$omit = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
var $cc8ac6ed0ffb93b6$export$2e2bcd8739ae039 = $cc8ac6ed0ffb93b6$var$omit;



/**
 * Takes a binary function `f`, a unary function `g`, and two values.
 * Applies `g` to each value, then applies the result of each to `f`.
 *
 * Also known as the P combinator.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig ((a, a) -> b) -> (c -> a) -> c -> c -> b
 * @param {Function} f a binary function
 * @param {Function} g a unary function
 * @param {any} a any value
 * @param {any} b any value
 * @return {any} The result of `f`
 * @example
 *
 *      const eqBy = R.on((a, b) => a === b);
 *      eqBy(R.prop('a'), {b:0, a:1}, {a:1}) //=> true;
 *
 *      const containsInsensitive = R.on(R.contains, R.toLower);
 *      containsInsensitive('o', 'FOO'); //=> true
 * @symb R.on(f, g, a, b) = f(g(a), g(b))
 */ var $f7c4853fbd3b9181$var$on = /*#__PURE__*/ (0, $da2b3dc738142f7b$export$2e2bcd8739ae039)(4, [], function on(f, g, a, b) {
    return f(g(a), g(b));
});
var $f7c4853fbd3b9181$export$2e2bcd8739ae039 = $f7c4853fbd3b9181$var$on;




/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var $ae77f5a16a482bad$var$once = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function once(fn) {
    var called = false;
    var result;
    return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
var $ae77f5a16a482bad$export$2e2bcd8739ae039 = $ae77f5a16a482bad$var$once;






function $9c421153aee09b52$export$2e2bcd8739ae039(name, p) {
    if (p == null || !(0, $0eef464cca01ff27$export$2e2bcd8739ae039)(p.then)) throw new TypeError("`" + name + "` expected a Promise, received " + (0, $0c6da83ecedaf41e$export$2e2bcd8739ae039)(p, []));
}


/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.andThen
 * @example
 *
 *      const failedFetch = id => Promise.reject('bad ID');
 *      const useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' });
 *
 *      //recoverFromFailure :: String -> Promise ({ firstName, lastName })
 *      const recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.andThen(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log);
 */ var $f002b1137df2b73e$var$otherwise = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function otherwise(f, p) {
    (0, $9c421153aee09b52$export$2e2bcd8739ae039)("otherwise", p);
    return p.then(null, f);
});
var $f002b1137df2b73e$export$2e2bcd8739ae039 = $f002b1137df2b73e$var$otherwise;



// transforms the held value with the provided function.
var $ca144c4b4db1df35$var$Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return $ca144c4b4db1df35$var$Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.view, R.set, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var $ca144c4b4db1df35$var$over = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return $ca144c4b4db1df35$var$Identity(f(y));
    })(x).value;
});
var $ca144c4b4db1df35$export$2e2bcd8739ae039 = $ca144c4b4db1df35$var$over;



/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var $c1bbf687edcb37e4$var$pair = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
var $c1bbf687edcb37e4$export$2e2bcd8739ae039 = $c1bbf687edcb37e4$var$pair;





function $994e8a21c627e6ea$export$2e2bcd8739ae039(concat) {
    return (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(fn, args) {
        return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(3); //=> 6
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var $edcc809f946deaa6$var$partial = /*#__PURE__*/ (0, $994e8a21c627e6ea$export$2e2bcd8739ae039)((0, $48a4c161d30e4183$export$2e2bcd8739ae039));
var $edcc809f946deaa6$export$2e2bcd8739ae039 = $edcc809f946deaa6$var$partial;





/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var $bb206714590b7727$var$partialRight = /*#__PURE__*/ (0, $994e8a21c627e6ea$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $0ccde7bdbe6db1af$export$2e2bcd8739ae039)((0, $48a4c161d30e4183$export$2e2bcd8739ae039)));
var $bb206714590b7727$export$2e2bcd8739ae039 = $bb206714590b7727$var$partialRight;





/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var $2104dd420dcbd326$var$partition = /*#__PURE__*/ (0, $6ad4ce8ee33df63f$export$2e2bcd8739ae039)([
    (0, $b0ba695691479374$export$2e2bcd8739ae039),
    (0, $a50384c73326e174$export$2e2bcd8739ae039)
]);
var $2104dd420dcbd326$export$2e2bcd8739ae039 = $2104dd420dcbd326$var$partition;







/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var $f5e04597776fcda0$var$pathEq = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function pathEq(_path, val, obj) {
    return (0, $f5f23b53da900217$export$2e2bcd8739ae039)((0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)(_path, obj), val);
});
var $f5e04597776fcda0$export$2e2bcd8739ae039 = $f5e04597776fcda0$var$pathEq;





/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $2ec3fd40f6e47b46$var$pathOr = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function pathOr(d, p, obj) {
    return (0, $0a7f9f2c99a59791$export$2e2bcd8739ae039)(d, (0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)(p, obj));
});
var $2ec3fd40f6e47b46$export$2e2bcd8739ae039 = $2ec3fd40f6e47b46$var$pathOr;




/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int | Symbol
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 *      R.pathSatisfies(R.is(Object), [], {x: {y: 2}}); //=> true
 */ var $a81a39abe517fe88$var$pathSatisfies = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function pathSatisfies(pred, propPath, obj) {
    return pred((0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)(propPath, obj));
});
var $a81a39abe517fe88$export$2e2bcd8739ae039 = $a81a39abe517fe88$var$pathSatisfies;



/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var $329d28ecd48758d6$var$pick = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
var $329d28ecd48758d6$export$2e2bcd8739ae039 = $329d28ecd48758d6$var$pick;



/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var $10b54769fc0f5f11$var$pickAll = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
var $10b54769fc0f5f11$export$2e2bcd8739ae039 = $10b54769fc0f5f11$var$pickAll;



/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var $5eac081d516476b5$var$pickBy = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
var $5eac081d516476b5$export$2e2bcd8739ae039 = $5eac081d516476b5$var$pickBy;







/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var $9578d83caf05820f$var$prepend = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function prepend(el, list) {
    return (0, $48a4c161d30e4183$export$2e2bcd8739ae039)([
        el
    ], list);
});
var $9578d83caf05820f$export$2e2bcd8739ae039 = $9578d83caf05820f$var$prepend;




/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var $e4de4d2c86acb420$var$product = /*#__PURE__*/ (0, $0fda840d89c87320$export$2e2bcd8739ae039)((0, $37211b73a19f3a8b$export$2e2bcd8739ae039), 1);
var $e4de4d2c86acb420$export$2e2bcd8739ae039 = $e4de4d2c86acb420$var$product;







/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var $27a17f281e748e38$var$useWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function useWith(fn, transformers) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
var $27a17f281e748e38$export$2e2bcd8739ae039 = $27a17f281e748e38$var$useWith;


/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @see R.pluck, R.props, R.prop
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var $e497a645817430fe$var$project = /*#__PURE__*/ (0, $27a17f281e748e38$export$2e2bcd8739ae039)((0, $c71baf20e55260bc$export$2e2bcd8739ae039), [
    (0, $10b54769fc0f5f11$export$2e2bcd8739ae039),
    (0, $54ee1c4ac03392aa$export$2e2bcd8739ae039)
]); // passing `identity` gives correct arity
var $e497a645817430fe$export$2e2bcd8739ae039 = $e497a645817430fe$var$project;




function $58381b576ff64367$export$2e2bcd8739ae039(f, g, profunctor) {
    return function(x) {
        return g(profunctor(f(x)));
    };
}





var $2efa4f068b7e4fc2$var$XPromap = /*#__PURE__*/ function() {
    function XPromap(f, g, xf) {
        this.xf = xf;
        this.f = f;
        this.g = g;
    }
    XPromap.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XPromap.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XPromap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, (0, $58381b576ff64367$export$2e2bcd8739ae039)(this.f, this.g, input));
    };
    return XPromap;
}();
var $2efa4f068b7e4fc2$var$_xpromap = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function _xpromap(f, g, xf) {
    return new $2efa4f068b7e4fc2$var$XPromap(f, g, xf);
});
var $2efa4f068b7e4fc2$export$2e2bcd8739ae039 = $2efa4f068b7e4fc2$var$_xpromap;


/**
 * Takes two functions as pre- and post- processors respectively for a third function,
 * i.e. `promap(f, g, h)(x) === g(h(f(x)))`.
 *
 * Dispatches to the `promap` method of the third argument, if present,
 * according to the [FantasyLand Profunctor spec](https://github.com/fantasyland/fantasy-land#profunctor).
 *
 * Acts as a transducer if a transformer is given in profunctor position.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (a -> b) -> (c -> d) -> (b -> c) -> (a -> d)
 * @sig Profunctor p => (a -> b) -> (c -> d) -> p b c -> p a d
 * @param {Function} f The preprocessor function, a -> b
 * @param {Function} g The postprocessor function, c -> d
 * @param {Profunctor} profunctor The profunctor instance to be promapped, e.g. b -> c
 * @return {Profunctor} The new profunctor instance, e.g. a -> d
 * @see R.transduce
 * @example
 *
 *      const decodeChar = R.promap(s => s.charCodeAt(), String.fromCharCode, R.add(-8))
 *      const decodeString = R.promap(R.split(''), R.join(''), R.map(decodeChar))
 *      decodeString("ziuli") //=> "ramda"
 *
 * @symb R.promap(f, g, h) = x => g(h(f(x)))
 * @symb R.promap(f, g, profunctor) = profunctor.promap(f, g)
 */ var $e740e579cebaa74a$var$promap = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "fantasy-land/promap",
    "promap"
], (0, $2efa4f068b7e4fc2$export$2e2bcd8739ae039), (0, $58381b576ff64367$export$2e2bcd8739ae039)));
var $e740e579cebaa74a$export$2e2bcd8739ae039 = $e740e579cebaa74a$var$promap;






/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var $cebf04ec59ada341$var$propEq = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function propEq(name, val, obj) {
    return (0, $f5f23b53da900217$export$2e2bcd8739ae039)(val, (0, $d925005fae164d75$export$2e2bcd8739ae039)(name, obj));
});
var $cebf04ec59ada341$export$2e2bcd8739ae039 = $cebf04ec59ada341$var$propEq;





/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var $6e34e672cb78ed17$var$propIs = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function propIs(type, name, obj) {
    return (0, $5d8019f2a3c9ed03$export$2e2bcd8739ae039)(type, (0, $d925005fae164d75$export$2e2bcd8739ae039)(name, obj));
});
var $6e34e672cb78ed17$export$2e2bcd8739ae039 = $6e34e672cb78ed17$var$propIs;





/**
 * Return the specified property of the given non-null object if the property
 * is present and it's value is not `null`, `undefined` or `NaN`.
 *
 * Otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var $b65afcadd845f952$var$propOr = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function propOr(val, p, obj) {
    return (0, $0a7f9f2c99a59791$export$2e2bcd8739ae039)(val, (0, $d925005fae164d75$export$2e2bcd8739ae039)(p, obj));
});
var $b65afcadd845f952$export$2e2bcd8739ae039 = $b65afcadd845f952$var$propOr;




/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var $26a3101d4493dbf3$var$propSatisfies = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function propSatisfies(pred, name, obj) {
    return pred((0, $d925005fae164d75$export$2e2bcd8739ae039)(name, obj));
});
var $26a3101d4493dbf3$export$2e2bcd8739ae039 = $26a3101d4493dbf3$var$propSatisfies;




/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @see R.prop, R.pluck, R.project
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var $cd74b04315b9a4e0$var$props = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function props(ps, obj) {
    return ps.map(function(p) {
        return (0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)([
            p
        ], obj);
    });
});
var $cd74b04315b9a4e0$export$2e2bcd8739ae039 = $cd74b04315b9a4e0$var$props;




/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var $ee56887a9dc21c9b$var$range = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function range(from, to) {
    if (!((0, $2b963c5066d50841$export$2e2bcd8739ae039)(from) && (0, $2b963c5066d50841$export$2e2bcd8739ae039)(to))) throw new TypeError("Both arguments to range must be numbers");
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
var $ee56887a9dc21c9b$export$2e2bcd8739ae039 = $ee56887a9dc21c9b$var$range;





/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*. `reduceRight` may use [`reduced`](#reduced)
 * to short circuit the iteration.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex, R.reduced
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var $6f62584ef9dadd92$var$reduceRight = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx -= 1;
    }
    return acc;
});
var $6f62584ef9dadd92$export$2e2bcd8739ae039 = $6f62584ef9dadd92$var$reduceRight;





/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator. `reduceWhile` may alternatively be short-circuited
 * via [`reduced`](#reduced).
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 !== 0;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var $b0e0d8f47d964444$var$reduceWhile = /*#__PURE__*/ (0, $da2b3dc738142f7b$export$2e2bcd8739ae039)(4, [], function _reduceWhile(pred, fn, a, list) {
    return (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039)(acc);
    }, a, list);
});
var $b0e0d8f47d964444$export$2e2bcd8739ae039 = $b0e0d8f47d964444$var$reduceWhile;




/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * This optimization is available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`reduceBy`](#reduceBy)
 * - [`reduceRight`](#reduceRight)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.reduceBy, R.reduceRight, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var $d6008d5f27df8ece$var$reduced = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)((0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039));
var $d6008d5f27df8ece$export$2e2bcd8739ae039 = $d6008d5f27df8ece$var$reduced;







/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var $ef512446502692c8$var$times = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError("n must be a non-negative number");
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
var $ef512446502692c8$export$2e2bcd8739ae039 = $ef512446502692c8$var$times;


/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var $932cf34f6b86107b$var$repeat = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function repeat(value, n) {
    return (0, $ef512446502692c8$export$2e2bcd8739ae039)((0, $2ff120835f8592de$export$2e2bcd8739ae039)(value), n);
});
var $932cf34f6b86107b$export$2e2bcd8739ae039 = $932cf34f6b86107b$var$repeat;



/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var $0cad6ce08f496a9f$var$replace = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
var $0cad6ce08f496a9f$export$2e2bcd8739ae039 = $0cad6ce08f496a9f$var$replace;




/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var $96b0348e7ab101cd$var$scan = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
});
var $96b0348e7ab101cd$export$2e2bcd8739ae039 = $96b0348e7ab101cd$var$scan;







/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */ var $dab3de081ff86bac$var$sequence = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function sequence(of, traversable) {
    return typeof traversable.sequence === "function" ? traversable.sequence(of) : (0, $6f62584ef9dadd92$export$2e2bcd8739ae039)(function(x, acc) {
        return (0, $798be8b27a50c416$export$2e2bcd8739ae039)((0, $b01f107cd36c1471$export$2e2bcd8739ae039)((0, $9578d83caf05820f$export$2e2bcd8739ae039), x), acc);
    }, of([]), traversable);
});
var $dab3de081ff86bac$export$2e2bcd8739ae039 = $dab3de081ff86bac$var$sequence;





/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.view, R.over, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var $e28f7a597a6e8a99$var$set = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function set(lens, v, x) {
    return (0, $ca144c4b4db1df35$export$2e2bcd8739ae039)(lens, (0, $2ff120835f8592de$export$2e2bcd8739ae039)(v), x);
});
var $e28f7a597a6e8a99$export$2e2bcd8739ae039 = $e28f7a597a6e8a99$var$set;




/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @see R.ascend, R.descend
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var $77c61834d23555c1$var$sort = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
var $77c61834d23555c1$export$2e2bcd8739ae039 = $77c61834d23555c1$var$sort;



/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var $a4529adb39872fec$var$sortBy = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
var $a4529adb39872fec$export$2e2bcd8739ae039 = $a4529adb39872fec$var$sortBy;



/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @see R.ascend, R.descend
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var $cfc44796ec194f05$var$sortWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
var $cfc44796ec194f05$export$2e2bcd8739ae039 = $cfc44796ec194f05$var$sortWith;



/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `sep`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var $0ff5b324cb26dd15$var$split = /*#__PURE__*/ (0, $0e383c5d409fb7c7$export$2e2bcd8739ae039)(1, "split");
var $0ff5b324cb26dd15$export$2e2bcd8739ae039 = $0ff5b324cb26dd15$var$split;





/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var $1df586caa09879b9$var$splitAt = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function splitAt(index, array) {
    return [
        (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(0, index, array),
        (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(index, (0, $7dfe924c13ca1796$export$2e2bcd8739ae039)(array), array)
    ];
});
var $1df586caa09879b9$export$2e2bcd8739ae039 = $1df586caa09879b9$var$splitAt;




/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var $9cdf7710401823f9$var$splitEvery = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function splitEvery(n, list) {
    if (n <= 0) throw new Error("First argument to splitEvery must be a positive integer");
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, $c45f92b9793bed27$export$2e2bcd8739ae039)(idx, idx += n, list));
    return result;
});
var $9cdf7710401823f9$export$2e2bcd8739ae039 = $9cdf7710401823f9$var$splitEvery;



/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var $15290061cec9663a$var$splitWhen = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
var $15290061cec9663a$export$2e2bcd8739ae039 = $15290061cec9663a$var$splitWhen;



/**
 * Splits an array into slices on every occurrence of a value.
 *
 * @func
 * @memberOf R
 * @since v0.26.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhenever(R.equals(2), [1, 2, 3, 2, 4, 5, 2, 6, 7]); //=> [[1], [3], [4, 5], [6, 7]]
 */ var $38582eab03e5b78a$var$splitWhenever = /*#__PURE__*/ (0, $da2b3dc738142f7b$export$2e2bcd8739ae039)(2, [], function splitWhenever(pred, list) {
    var acc = [];
    var curr = [];
    for(var i = 0; i < list.length; i = i + 1){
        if (!pred(list[i])) curr.push(list[i]);
        if ((i < list.length - 1 && pred(list[i + 1]) || i === list.length - 1) && curr.length > 0) {
            acc.push(curr);
            curr = [];
        }
    }
    return acc;
});
var $38582eab03e5b78a$export$2e2bcd8739ae039 = $38582eab03e5b78a$var$splitWhenever;





/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $8a2031395edec627$var$startsWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(prefix, list) {
    return (0, $f5f23b53da900217$export$2e2bcd8739ae039)((0, $d84b5ce3f84ef07d$export$2e2bcd8739ae039)(prefix.length, list), prefix);
});
var $8a2031395edec627$export$2e2bcd8739ae039 = $8a2031395edec627$var$startsWith;



/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var $5b52b842b81a55ac$var$subtract = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function subtract(a, b) {
    return Number(a) - Number(b);
});
var $5b52b842b81a55ac$export$2e2bcd8739ae039 = $5b52b842b81a55ac$var$subtract;






/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var $0d6c9bcd3ce58351$var$symmetricDifference = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function symmetricDifference(list1, list2) {
    return (0, $20d6a9e934cc0e00$export$2e2bcd8739ae039)((0, $4c7bf31ad3cf804f$export$2e2bcd8739ae039)(list1, list2), (0, $4c7bf31ad3cf804f$export$2e2bcd8739ae039)(list2, list1));
});
var $0d6c9bcd3ce58351$export$2e2bcd8739ae039 = $0d6c9bcd3ce58351$var$symmetricDifference;





/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var $31ab672c69626841$var$symmetricDifferenceWith = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, $20d6a9e934cc0e00$export$2e2bcd8739ae039)((0, $59cd35db3021243a$export$2e2bcd8739ae039)(pred, list1, list2), (0, $59cd35db3021243a$export$2e2bcd8739ae039)(pred, list2, list1));
});
var $31ab672c69626841$export$2e2bcd8739ae039 = $31ab672c69626841$var$symmetricDifferenceWith;







/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var $44e8719ec710cdfa$var$takeLastWhile = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(idx + 1, Infinity, xs);
});
var $44e8719ec710cdfa$export$2e2bcd8739ae039 = $44e8719ec710cdfa$var$takeLastWhile;







var $98c01c5cf1a0b548$var$XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XTakeWhile.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XTakeWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : (0, $ddc178dcc7c7ccc5$export$2e2bcd8739ae039)(result);
    };
    return XTakeWhile;
}();
var $98c01c5cf1a0b548$var$_xtakeWhile = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xtakeWhile(f, xf) {
    return new $98c01c5cf1a0b548$var$XTakeWhile(f, xf);
});
var $98c01c5cf1a0b548$export$2e2bcd8739ae039 = $98c01c5cf1a0b548$var$_xtakeWhile;



/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var $d62a1df17156e216$var$takeWhile = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([
    "takeWhile"
], (0, $98c01c5cf1a0b548$export$2e2bcd8739ae039), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, $c45f92b9793bed27$export$2e2bcd8739ae039)(0, idx, xs);
}));
var $d62a1df17156e216$export$2e2bcd8739ae039 = $d62a1df17156e216$var$takeWhile;






var $2d55addb98a0ff14$var$XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XTap.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XTap.prototype["@@transducer/step"] = function(result, input) {
        this.f(input);
        return this.xf["@@transducer/step"](result, input);
    };
    return XTap;
}();
var $2d55addb98a0ff14$var$_xtap = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xtap(f, xf) {
    return new $2d55addb98a0ff14$var$XTap(f, xf);
});
var $2d55addb98a0ff14$export$2e2bcd8739ae039 = $2d55addb98a0ff14$var$_xtap;


/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */ var $271bccc994e648d9$var$tap = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $2d55addb98a0ff14$export$2e2bcd8739ae039), function tap(fn, x) {
    fn(x);
    return x;
}));
var $271bccc994e648d9$export$2e2bcd8739ae039 = $271bccc994e648d9$var$tap;




function $b3aa896ca8f8588e$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
}



/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var $af71ba1baecffe3b$var$test = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function test(pattern, str) {
    if (!(0, $b3aa896ca8f8588e$export$2e2bcd8739ae039)(pattern)) throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received " + (0, $754b63e580f0fde1$export$2e2bcd8739ae039)(pattern));
    return (0, $992689f1f5b36f20$export$2e2bcd8739ae039)(pattern).test(str);
});
var $af71ba1baecffe3b$export$2e2bcd8739ae039 = $af71ba1baecffe3b$var$test;




/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      const makeQuery = email => ({ query: { email }});
 *      const fetchMember = request =>
 *        Promise.resolve({ firstName: 'Bob', lastName: 'Loblaw', id: 42 });
 *
 *      //getMemberName :: String -> Promise ({ firstName, lastName })
 *      const getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.andThen(R.pick(['firstName', 'lastName']))
 *      );
 *
 *      getMemberName('bob@gmail.com').then(console.log);
 */ var $2d71bb08cc0aa25b$var$andThen = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function andThen(f, p) {
    (0, $9c421153aee09b52$export$2e2bcd8739ae039)("andThen", p);
    return p.then(f);
});
var $2d71bb08cc0aa25b$export$2e2bcd8739ae039 = $2d71bb08cc0aa25b$var$andThen;




/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var $70119a8b48349792$var$toLower = /*#__PURE__*/ (0, $0e383c5d409fb7c7$export$2e2bcd8739ae039)(0, "toLowerCase");
var $70119a8b48349792$export$2e2bcd8739ae039 = $70119a8b48349792$var$toLower;




/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs, R.keys, R.values
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var $fd1c997519c70801$var$toPairs = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $fd1c997519c70801$export$2e2bcd8739ae039 = $fd1c997519c70801$var$toPairs;



/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var $7fae43354bf3a288$var$toPairsIn = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $7fae43354bf3a288$export$2e2bcd8739ae039 = $7fae43354bf3a288$var$toPairsIn;




/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var $ae4631ef43a3f95f$var$toUpper = /*#__PURE__*/ (0, $0e383c5d409fb7c7$export$2e2bcd8739ae039)(0, "toUpperCase");
var $ae4631ef43a3f95f$export$2e2bcd8739ae039 = $ae4631ef43a3f95f$var$toUpper;





/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 !== 0;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var $1167afd2539a7c28$var$transduce = /*#__PURE__*/ (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(4, function transduce(xf, fn, acc, list) {
    return (0, $f8880cbac514a5a0$export$2e2bcd8739ae039)(xf(typeof fn === "function" ? (0, $a41bc283a458b174$export$2e2bcd8739ae039)(fn) : fn), acc, list);
});
var $1167afd2539a7c28$export$2e2bcd8739ae039 = $1167afd2539a7c28$var$transduce;



/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var $c9777eeef95902a5$var$transpose = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === "undefined") result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
var $c9777eeef95902a5$export$2e2bcd8739ae039 = $c9777eeef95902a5$var$transpose;





/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */ var $69fc26d3d8737672$var$traverse = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function traverse(of, f, traversable) {
    return typeof traversable["fantasy-land/traverse"] === "function" ? traversable["fantasy-land/traverse"](f, of) : typeof traversable.traverse === "function" ? traversable.traverse(f, of) : (0, $dab3de081ff86bac$export$2e2bcd8739ae039)(of, (0, $b01f107cd36c1471$export$2e2bcd8739ae039)(f, traversable));
});
var $69fc26d3d8737672$export$2e2bcd8739ae039 = $69fc26d3d8737672$var$traverse;



var $6440b6e828d5579a$var$ws = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";
var $6440b6e828d5579a$var$zeroWidth = "​";
var $6440b6e828d5579a$var$hasProtoTrim = typeof String.prototype.trim === "function";
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var $6440b6e828d5579a$var$trim = !$6440b6e828d5579a$var$hasProtoTrim || /*#__PURE__*/ $6440b6e828d5579a$var$ws.trim() || !/*#__PURE__*/ $6440b6e828d5579a$var$zeroWidth.trim() ? /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function trim(str) {
    var beginRx = new RegExp("^[" + $6440b6e828d5579a$var$ws + "][" + $6440b6e828d5579a$var$ws + "]*");
    var endRx = new RegExp("[" + $6440b6e828d5579a$var$ws + "][" + $6440b6e828d5579a$var$ws + "]*$");
    return str.replace(beginRx, "").replace(endRx, "");
}) : /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function trim(str) {
    return str.trim();
});
var $6440b6e828d5579a$export$2e2bcd8739ae039 = $6440b6e828d5579a$var$trim;





/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send them to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('caught'))('bar') // =>
 *      'caught'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 *      R.tryCatch(() => { throw 'this is not a valid value'}, (err, value)=>({error : err,  value }))('bar') // => {'error': 'this is not a valid value', 'value': 'bar'}
 */ var $dd13c4e5498267d0$var$tryCatch = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _tryCatch(tryer, catcher) {
    return (0, $35f53eb613cc1282$export$2e2bcd8739ae039)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, $48a4c161d30e4183$export$2e2bcd8739ae039)([
                e
            ], arguments));
        }
    });
});
var $dd13c4e5498267d0$export$2e2bcd8739ae039 = $dd13c4e5498267d0$var$tryCatch;




/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var $4561d1e2c8d79db5$var$unapply = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
var $4561d1e2c8d79db5$export$2e2bcd8739ae039 = $4561d1e2c8d79db5$var$unapply;




/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> (a -> z)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var $f1879365bbd38f26$var$unary = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function unary(fn) {
    return (0, $26474154062a5b29$export$2e2bcd8739ae039)(1, fn);
});
var $f1879365bbd38f26$export$2e2bcd8739ae039 = $f1879365bbd38f26$var$unary;




/**
 * Returns a function of arity `n` from a (manually) curried function.
 * Note that, the returned function is actually a ramda style
 * curryied function, which can accept one or more arguments in each
 * function calling.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b -> c ... -> z) -> ((a -> b -> c ...) -> z)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry, R.curryN
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var $0d9848e03f7a06a8$var$uncurryN = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function uncurryN(depth, fn) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === "function"){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
var $0d9848e03f7a06a8$export$2e2bcd8739ae039 = $0d9848e03f7a06a8$var$uncurryN;



/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var $f651b8b8ac8118f3$var$unfold = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
var $f651b8b8ac8118f3$export$2e2bcd8739ae039 = $f651b8b8ac8118f3$var$unfold;






/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var $2db0365ce3c52910$var$union = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $759e6a2bc2cac489$export$2e2bcd8739ae039)((0, $6304fcdb3884aaf5$export$2e2bcd8739ae039), (0, $48a4c161d30e4183$export$2e2bcd8739ae039)));
var $2db0365ce3c52910$export$2e2bcd8739ae039 = $2db0365ce3c52910$var$union;










var $a54f12647b484aab$var$XUniqWith = /*#__PURE__*/ function() {
    function XUniqWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.items = [];
    }
    XUniqWith.prototype["@@transducer/init"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).init;
    XUniqWith.prototype["@@transducer/result"] = (0, $ad08508171bdd1fe$export$2e2bcd8739ae039).result;
    XUniqWith.prototype["@@transducer/step"] = function(result, input) {
        if ((0, $298b882271db9e5b$export$2e2bcd8739ae039)(this.pred, input, this.items)) return result;
        else {
            this.items.push(input);
            return this.xf["@@transducer/step"](result, input);
        }
    };
    return XUniqWith;
}();
var $a54f12647b484aab$var$_xuniqWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function _xuniqWith(pred, xf) {
    return new $a54f12647b484aab$var$XUniqWith(pred, xf);
});
var $a54f12647b484aab$export$2e2bcd8739ae039 = $a54f12647b484aab$var$_xuniqWith;


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var $3496c4f9bd4fdade$var$uniqWith = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $517f9939d3c2c885$export$2e2bcd8739ae039)([], (0, $a54f12647b484aab$export$2e2bcd8739ae039), function(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, $298b882271db9e5b$export$2e2bcd8739ae039)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
}));
var $3496c4f9bd4fdade$export$2e2bcd8739ae039 = $3496c4f9bd4fdade$var$uniqWith;


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements. If an element exists
 * in both lists, the first element from the first list will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var $bb1a1d2f9d6a0c4d$var$unionWith = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function unionWith(pred, list1, list2) {
    return (0, $3496c4f9bd4fdade$export$2e2bcd8739ae039)(pred, (0, $48a4c161d30e4183$export$2e2bcd8739ae039)(list1, list2));
});
var $bb1a1d2f9d6a0c4d$export$2e2bcd8739ae039 = $bb1a1d2f9d6a0c4d$var$unionWith;






/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var $7a5e5c10adc3d8cd$var$unless = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
var $7a5e5c10adc3d8cd$export$2e2bcd8739ae039 = $7a5e5c10adc3d8cd$var$unless;




/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var $972e9ba02808edd7$var$unnest = /*#__PURE__*/ (0, $afee388cd3a0702e$export$2e2bcd8739ae039)((0, $4e7387e3232e683f$export$2e2bcd8739ae039));
var $972e9ba02808edd7$export$2e2bcd8739ae039 = $972e9ba02808edd7$var$unnest;



/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var $ed9beca65495505a$var$until = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
var $ed9beca65495505a$export$2e2bcd8739ae039 = $ed9beca65495505a$var$until;






/**
 *
 * Deconstructs an array field from the input documents to output a document for each element.
 * Each output document is the input document with the value of the array field replaced by the element.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig String -> {k: [v]} -> [{k: v}]
 * @param {String} key The key to determine which property of the object should be unwind
 * @param {Object} object The object containing list under property named as key which is to unwind
 * @return {List} A new list of object containing the value of input key having list replaced by each element in the object.
 * @example
 *
 * R.unwind('hobbies', {
 *   name: 'alice',
 *   hobbies: ['Golf', 'Hacking'],
 *   colors: ['red', 'green'],
 * });
 * // [
 * //   { name: 'alice', hobbies: 'Golf', colors: ['red', 'green'] },
 * //   { name: 'alice', hobbies: 'Hacking', colors: ['red', 'green'] }
 * // ]
 */ var $51559167c21c09da$var$unwind = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(key, object) {
    // If key is not in object or key is not as a list in object
    if (!(key in object && (0, $7eea8a68c490b09b$export$2e2bcd8739ae039)(object[key]))) return [
        object
    ];
     // Map over object[key] which is a list and assoc each element with key
    return (0, $c71baf20e55260bc$export$2e2bcd8739ae039)(function(item) {
        return (0, $d98e4d563993ddcf$export$2e2bcd8739ae039)(key, item, object);
    }, object[key]);
});
var $51559167c21c09da$export$2e2bcd8739ae039 = $51559167c21c09da$var$unwind;






/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var $c76b70c8b9892e5a$var$valuesIn = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
var $c76b70c8b9892e5a$export$2e2bcd8739ae039 = $c76b70c8b9892e5a$var$valuesIn;



var $25fd8537af2a96e7$var$Const = function(x) {
    return {
        value: x,
        "fantasy-land/map": function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.set, R.over, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var $25fd8537af2a96e7$var$view = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens($25fd8537af2a96e7$var$Const)(x).value;
});
var $25fd8537af2a96e7$export$2e2bcd8739ae039 = $25fd8537af2a96e7$var$view;



/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var $d6b0de3fc120c2b2$var$when = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
var $d6b0de3fc120c2b2$export$2e2bcd8739ae039 = $d6b0de3fc120c2b2$var$when;




/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var $670fc07c29638272$var$where = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
var $670fc07c29638272$export$2e2bcd8739ae039 = $670fc07c29638272$var$where;




/**
 * Takes a spec object and a test object; each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `whereAny` returns true if at least one of the predicates return true,
 * false otherwise.
 *
 * `whereAny` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereAny({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('xxx')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 8, y: 34}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 9, y: 21}); //=> false
 *      pred({a: 'bar', b: 'xxx', x: 10, y: 20}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 10, y: 20}); //=> true
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> true
 */ var $541f47ea612faa2a$var$whereAny = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function whereAny(spec, testObj) {
    for(var prop in spec){
        if ((0, $3e434626b2866668$export$2e2bcd8739ae039)(prop, spec) && spec[prop](testObj[prop])) return true;
    }
    return false;
});
var $541f47ea612faa2a$export$2e2bcd8739ae039 = $541f47ea612faa2a$var$whereAny;






/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var $09ab655d4d042c60$var$whereEq = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function whereEq(spec, testObj) {
    return (0, $670fc07c29638272$export$2e2bcd8739ae039)((0, $b01f107cd36c1471$export$2e2bcd8739ae039)((0, $f5f23b53da900217$export$2e2bcd8739ae039), spec), testObj);
});
var $09ab655d4d042c60$export$2e2bcd8739ae039 = $09ab655d4d042c60$var$whereEq;






/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var $924b4d24995bac86$var$without = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function(xs, list) {
    return (0, $a50384c73326e174$export$2e2bcd8739ae039)((0, $0ccde7bdbe6db1af$export$2e2bcd8739ae039)((0, $ffa2ed402645a184$export$2e2bcd8739ae039))(xs), list);
});
var $924b4d24995bac86$export$2e2bcd8739ae039 = $924b4d24995bac86$var$without;



/**
 * Exclusive disjunction logical operation.
 * Returns `true` if one of the arguments is truthy and the other is falsy.
 * Otherwise, it returns `false`.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Logic
 * @sig a -> b -> Boolean
 * @param {Any} a
 * @param {Any} b
 * @return {Boolean} true if one of the arguments is truthy and the other is falsy
 * @see R.or, R.and
 * @example
 *
 *      R.xor(true, true); //=> false
 *      R.xor(true, false); //=> true
 *      R.xor(false, true); //=> true
 *      R.xor(false, false); //=> false
 */ var $0bd24c5a158cb0b7$var$xor = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function xor(a, b) {
    return Boolean(!a ^ !b);
});
var $0bd24c5a158cb0b7$export$2e2bcd8739ae039 = $0bd24c5a158cb0b7$var$xor;



/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var $5a3e86aed074bfb7$var$xprod = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
var $5a3e86aed074bfb7$export$2e2bcd8739ae039 = $5a3e86aed074bfb7$var$xprod;



/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var $57bf511a617cf2fe$var$zip = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
var $57bf511a617cf2fe$export$2e2bcd8739ae039 = $57bf511a617cf2fe$var$zip;



/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var $afad6f23917b99b8$var$zipObj = /*#__PURE__*/ (0, $1ae74cc5623cea21$export$2e2bcd8739ae039)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
var $afad6f23917b99b8$export$2e2bcd8739ae039 = $afad6f23917b99b8$var$zipObj;



/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var $6f329900b5e02336$var$zipWith = /*#__PURE__*/ (0, $d630269a6cff22d9$export$2e2bcd8739ae039)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
var $6f329900b5e02336$export$2e2bcd8739ae039 = $6f329900b5e02336$var$zipWith;




/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */ var $0de1d2ed781fa720$var$thunkify = /*#__PURE__*/ (0, $7ec77605189b4758$export$2e2bcd8739ae039)(function thunkify(fn) {
    return (0, $3b7e85b0e9d353dc$export$2e2bcd8739ae039)(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
            return fn.apply(this, fnArgs);
        };
    });
});
var $0de1d2ed781fa720$export$2e2bcd8739ae039 = $0de1d2ed781fa720$var$thunkify;




const $1a8e7e7ea2d4704f$export$7afbc6ab0d56b4de = (error)=>{
    if ((0, $a1c76089443586f4$export$2e2bcd8739ae039)("validationErrors", error)) return error;
    return undefined;
};



var $acw62 = parcelRequire("acw62");

const $4da5e0f720531533$export$1262e741a2e2f18 = (options)=>{
    const { error: error, setError: setError } = (0, $acw62.useContext)((0, $6c373dd14e8d5a80$export$e1cf286322cbb4cb));
    (0, $acw62.useEffect)(()=>{
        setError(options.error);
    }, [
        options.error
    ]);
    return {
        error: error,
        setError: setError
    };
};




function $a39c7b18ba33fcee$export$4656e7db9801e7ad({ height: height = "24px", width: width = "24px" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z"
        })
    });
}




function $9a600bd511b0e43a$export$4b2c798a70974642({ height: height = "24px", width: width = "24px" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z"
        })
    });
}



var $acw62 = parcelRequire("acw62");

const $1d5090bbb9ec8e9b$export$91c0eda1d06bf008 = (token)=>token + "px";


const $ea2ca5cd54b7d224$export$4d56ea2816714768 = {
    color: (0, $590eee45b2f4b5a8$export$b0ac3c99e1f94deb),
    textStyle: "textBodyMedium4",
    marginTop: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$4eaa1d4f12b95711))
};






var $acw62 = parcelRequire("acw62");

/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Special Procedures API
 * Special Procedures API
 * OpenAPI spec version: 1.0.0
 */ 
var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
"use strict";

$c8e45c4daa4b95cb$exports = (parcelRequire("30Ie1"));


"use client";
const $cb54322a339eb896$export$306c0aa65ff9ec16 = (0, $c8e45c4daa4b95cb$exports.useSyncExternalStore);


const $9bd79d53e26c8f96$export$1cf3d545f2d4635c = console;


// TYPES
// UTILS
const $f8b865b18d670cc6$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $f8b865b18d670cc6$export$8793edee2d425525() {
    return undefined;
}
function $f8b865b18d670cc6$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $f8b865b18d670cc6$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $f8b865b18d670cc6$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $f8b865b18d670cc6$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $f8b865b18d670cc6$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $f8b865b18d670cc6$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$f8b865b18d670cc6$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $f8b865b18d670cc6$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $f8b865b18d670cc6$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $f8b865b18d670cc6$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $f8b865b18d670cc6$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $f8b865b18d670cc6$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $f8b865b18d670cc6$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $f8b865b18d670cc6$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$f8b865b18d670cc6$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $f8b865b18d670cc6$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($f8b865b18d670cc6$export$5fcb678681417b54(mutation.options.mutationKey) !== $f8b865b18d670cc6$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$f8b865b18d670cc6$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $f8b865b18d670cc6$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $f8b865b18d670cc6$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $f8b865b18d670cc6$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$f8b865b18d670cc6$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $f8b865b18d670cc6$export$2f07189bb9fa26a7(a, b) {
    return $f8b865b18d670cc6$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $f8b865b18d670cc6$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$f8b865b18d670cc6$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $f8b865b18d670cc6$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $f8b865b18d670cc6$export$7a8558113332b71e(a) && $f8b865b18d670cc6$export$7a8558113332b71e(b);
    if (array || $f8b865b18d670cc6$export$53b83ca8eaab0383(a) && $f8b865b18d670cc6$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $f8b865b18d670cc6$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $f8b865b18d670cc6$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $f8b865b18d670cc6$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $f8b865b18d670cc6$export$53b83ca8eaab0383(o) {
    if (!$f8b865b18d670cc6$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$f8b865b18d670cc6$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $f8b865b18d670cc6$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $f8b865b18d670cc6$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $f8b865b18d670cc6$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $f8b865b18d670cc6$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $f8b865b18d670cc6$export$4304cb76768ca134(callback) {
    $f8b865b18d670cc6$export$e772c8ff12451969(0).then(callback);
}
function $f8b865b18d670cc6$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $f8b865b18d670cc6$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $f8b865b18d670cc6$export$77a71fc411098696(prevData, data);
    return data;
}


function $9c9aacadc80c6826$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $f8b865b18d670cc6$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $f8b865b18d670cc6$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $9c9aacadc80c6826$export$520687f44db6e1ab = $9c9aacadc80c6826$export$316a8efd03cd1458();



class $3141b454c0d4745f$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $f8b865b18d670cc6$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $f8b865b18d670cc6$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


class $29a2986ef88e4ed5$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $2a29005856faa11a$export$86f1af424b2ca4de extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $f8b865b18d670cc6$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $2a29005856faa11a$export$6bf54661be5b02cf = new $2a29005856faa11a$export$86f1af424b2ca4de();




const $bdda8765d46ccf87$var$onlineEvents = [
    "online",
    "offline"
];
class $bdda8765d46ccf87$export$58774fb55d5ff7fc extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $f8b865b18d670cc6$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $bdda8765d46ccf87$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $bdda8765d46ccf87$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $bdda8765d46ccf87$export$b113e788b2dd3fdc = new $bdda8765d46ccf87$export$58774fb55d5ff7fc();



function $cd25260720ff3eef$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $cd25260720ff3eef$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline() : true;
}
class $cd25260720ff3eef$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $cd25260720ff3eef$export$986cc6445c1d323(value) {
    return value instanceof $cd25260720ff3eef$export$a8430ed4188f35a9;
}
function $cd25260720ff3eef$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $cd25260720ff3eef$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $cd25260720ff3eef$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $f8b865b18d670cc6$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($cd25260720ff3eef$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}


// CLASS
class $da939cdf983103e1$export$17b8b19c814bcf56 extends (0, $3141b454c0d4745f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $da939cdf983103e1$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $cd25260720ff3eef$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $cd25260720ff3eef$export$61b92f63f30245cf)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $da939cdf983103e1$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}





// CLASS
class $d72b95cae394c51c$export$d3c1860ee66f291a extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $da939cdf983103e1$export$a1659b54bac3252a)();
        const result = {
            ...state,
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
}



var $acw62 = parcelRequire("acw62");
"use client";
const $0126047dd734bc33$export$2fba198b5b2e37fa = /*#__PURE__*/ $acw62.createContext(undefined);
const $0126047dd734bc33$var$QueryClientSharingContext = /*#__PURE__*/ $acw62.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $0126047dd734bc33$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $0126047dd734bc33$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $0126047dd734bc33$export$2fba198b5b2e37fa;
}
const $0126047dd734bc33$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $acw62.useContext($0126047dd734bc33$var$getQueryClientContext(context, $acw62.useContext($0126047dd734bc33$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $0126047dd734bc33$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $0126047dd734bc33$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $acw62.createElement($0126047dd734bc33$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: client
    }, children));
};


function $a6837397414c8694$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


"use client";
function $cb7b7c348969488c$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $f8b865b18d670cc6$export$b646c531ea475334)(arg1, arg2, arg3);
    const queryClient = (0, $0126047dd734bc33$export$22e77b9572c4fded)({
        context: options.context
    });
    const [observer] = $acw62.useState(()=>new (0, $d72b95cae394c51c$export$d3c1860ee66f291a)(queryClient, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $cb54322a339eb896$export$306c0aa65ff9ec16)($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($cb7b7c348969488c$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $a6837397414c8694$export$2072f68e6c3507cf)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $cb7b7c348969488c$var$noop() {}






class $d07b9a140ad50c23$export$a06cf8c0066f0d4c extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($d07b9a140ad50c23$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $d07b9a140ad50c23$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $d07b9a140ad50c23$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $d07b9a140ad50c23$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        return this.createResult(query, options);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $f8b865b18d670cc6$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $f8b865b18d670cc6$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $f8b865b18d670cc6$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $f8b865b18d670cc6$export$6acf61af03e62db) || this.options.enabled === false || !(0, $f8b865b18d670cc6$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $d07b9a140ad50c23$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $d07b9a140ad50c23$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $cd25260720ff3eef$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $d07b9a140ad50c23$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            if (notifyOnChangeProps === "all" || !notifyOnChangeProps && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangeProps != null ? notifyOnChangeProps : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $cd25260720ff3eef$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function $d07b9a140ad50c23$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $d07b9a140ad50c23$var$shouldFetchOnMount(query, options) {
    return $d07b9a140ad50c23$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $d07b9a140ad50c23$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $d07b9a140ad50c23$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $d07b9a140ad50c23$var$isStale(query, options);
    }
    return false;
}
function $d07b9a140ad50c23$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $d07b9a140ad50c23$var$isStale(query, options);
}
function $d07b9a140ad50c23$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
"use client";
function $d8c18f57bc93d04e$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $acw62.createContext($d8c18f57bc93d04e$var$createValue()); // HOOK
const $d8c18f57bc93d04e$export$50dfac555130cafd = ()=>$acw62.useContext($d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext); // COMPONENT
const $d8c18f57bc93d04e$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$d8c18f57bc93d04e$var$createValue());
    return /*#__PURE__*/ $acw62.createElement($d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};




var $acw62 = parcelRequire("acw62");
"use client";
const $d73410633d0f0f28$var$IsRestoringContext = /*#__PURE__*/ $acw62.createContext(false);
const $d73410633d0f0f28$export$4da0178d6b5f553 = ()=>$acw62.useContext($d73410633d0f0f28$var$IsRestoringContext);
const $d73410633d0f0f28$export$593807d4e94f9621 = $d73410633d0f0f28$var$IsRestoringContext.Provider;



var $acw62 = parcelRequire("acw62");

"use client";
const $2cae4142f68cd6ce$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $2cae4142f68cd6ce$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $2cae4142f68cd6ce$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a6837397414c8694$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


const $bf865f1d403d5a28$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $bf865f1d403d5a28$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $bf865f1d403d5a28$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $bf865f1d403d5a28$export$e0a3f29513afe430(result, isRestoring);
const $bf865f1d403d5a28$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


"use client";
function $ede1b94721233a5e$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $0126047dd734bc33$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $d73410633d0f0f28$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $d8c18f57bc93d04e$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $bf865f1d403d5a28$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $2cae4142f68cd6ce$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $2cae4142f68cd6ce$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $acw62.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $cb54322a339eb896$export$306c0aa65ff9ec16)($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $bf865f1d403d5a28$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $bf865f1d403d5a28$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2cae4142f68cd6ce$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $6f7384520c92f99a$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $ede1b94721233a5e$export$fff0865807e996c5)(parsedOptions, (0, $d07b9a140ad50c23$export$a06cf8c0066f0d4c));
}


"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    const pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$toString.call(thing) === pattern || $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === pattern);
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[_-\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        if (reducer(descriptor, name, obj) !== false) reducedDescriptors[name] = descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


var $a7ef50337bd246c5$exports = {};
/* eslint-env browser */ $a7ef50337bd246c5$exports = typeof self == "object" ? self.FormData : window.FormData;


var $c9c2d7f2c3ab68f5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($a7ef50337bd246c5$exports)));


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isSpecCompliant(thing) {
    return thing && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator];
}
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $c9c2d7f2c3ab68f5$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && $e6cbd383b18c9625$var$isSpecCompliant(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = FormData;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $2f71637df772b183$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $2f71637df772b183$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: Blob
    },
    isStandardBrowserEnv: $2f71637df772b183$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $2f71637df772b183$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
const $843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": undefined
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $2f71637df772b183$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $843bf0209bc94df8$var$defaults.headers[method] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge($843bf0209bc94df8$var$DEFAULT_CONTENT_TYPE);
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
function $866cce54f6bdfb0c$var$isValidHeaderName(str) {
    return /^[-_a-zA-Z]+$/.test(str.trim());
}
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear() {
        return Object.keys(this).forEach(this.delete.bind(this));
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent"
]);
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders.prototype);
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;




// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;




"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


"use strict";
function $79f0a48d5eb7919b$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(requestData) && ((0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv)) requestHeaders.setContentType(false); // Let the browser set it
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $2f71637df772b183$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $79f0a48d5eb7919b$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $2f71637df772b183$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $e8c8c7960873e9ee$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp($e8c8c7960873e9ee$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.2.2";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
            encode: $a93486d2307f31c3$var$validators.function,
            serialize: $a93486d2307f31c3$var$validators.function
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        let contextHeaders;
        // Flatten headers
        contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        contextHeaders && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}



const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);



const $2e59f0ff0fac9290$export$53ea70b747a790ee = (token)=>{
    const headers = {};
    if (token) headers.authorization = `Bearer ${token}`;
    return (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
        baseURL: "https://api.specialprocedures.co.uk",
        headers: headers
    });
};


var $1563e9259f492e76$exports = {};

$parcel$export($1563e9259f492e76$exports, "default", () => $1563e9259f492e76$export$2e2bcd8739ae039);
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $6e565e8985522db4$export$98e6a39c04603d36;
var $6e565e8985522db4$export$dfdc1655ccc5b9cb;
"use strict";
$6e565e8985522db4$export$98e6a39c04603d36 = $6e565e8985522db4$var$parse;
$6e565e8985522db4$export$dfdc1655ccc5b9cb = $6e565e8985522db4$var$serialize;
/**
 * Module variables.
 * @private
 */ var $6e565e8985522db4$var$decode = decodeURIComponent;
var $6e565e8985522db4$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $6e565e8985522db4$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $6e565e8985522db4$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || $6e565e8985522db4$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $6e565e8985522db4$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $6e565e8985522db4$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $6e565e8985522db4$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$6e565e8985522db4$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$6e565e8985522db4$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$6e565e8985522db4$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$6e565e8985522db4$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $6e565e8985522db4$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $fdf7998ace1a9ccf$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === "object" && typeof document.cookie === "string";
}
function $fdf7998ace1a9ccf$export$bfce569af136abdc() {
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
function $fdf7998ace1a9ccf$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === "string") return $6e565e8985522db4$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === "object" && cookies !== null) return cookies;
    else return {};
}
function $fdf7998ace1a9ccf$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === "undefined") // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
    return !doNotParse;
}
function $fdf7998ace1a9ccf$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $fdf7998ace1a9ccf$var$cleanupCookieValue(value);
    if ($fdf7998ace1a9ccf$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $fdf7998ace1a9ccf$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === "j" && value[1] === ":") return value.substr(2);
    return value;
}


var $1563e9259f492e76$var$__assign = undefined && undefined.__assign || function() {
    $1563e9259f492e76$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1563e9259f492e76$var$__assign.apply(this, arguments);
};
var $1563e9259f492e76$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $fdf7998ace1a9ccf$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $fdf7998ace1a9ccf$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $6e565e8985522db4$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $fdf7998ace1a9ccf$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $fdf7998ace1a9ccf$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === "object") value = JSON.stringify(value);
        this.cookies = $1563e9259f492e76$var$__assign($1563e9259f492e76$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $6e565e8985522db4$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $1563e9259f492e76$var$__assign($1563e9259f492e76$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $1563e9259f492e76$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $6e565e8985522db4$export$dfdc1655ccc5b9cb(name, "", finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $1563e9259f492e76$export$2e2bcd8739ae039 = $1563e9259f492e76$var$Cookies;


var $9814bc57a8c0985e$export$2e2bcd8739ae039 = (0, $1563e9259f492e76$exports.default);


var $924bec3bf8f0d914$exports = {};

$parcel$export($924bec3bf8f0d914$exports, "apiMapper", () => $924bec3bf8f0d914$export$b0b8598934ca46b6);


var $f83b2fbdd997e842$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ErrorCode[ErrorCode["UNKNOWN"] = -1] = "UNKNOWN";
    ErrorCode[ErrorCode["VALIDATION_ERROR"] = 100] = "VALIDATION_ERROR";
    ErrorCode[ErrorCode["INVALID_INPUT_FORMAT"] = 200] = "INVALID_INPUT_FORMAT";
    ErrorCode[ErrorCode["UNAUTHENTICATED"] = 300] = "UNAUTHENTICATED";
})($f83b2fbdd997e842$export$d4e71bc0b80dc0fb || ($f83b2fbdd997e842$export$d4e71bc0b80dc0fb = {}));


const $9b579bbdc66dad76$export$fbe12f4d55f2b7be = (error)=>{
    return (0, $a1c76089443586f4$export$2e2bcd8739ae039)("response", error) && (0, $a1c76089443586f4$export$2e2bcd8739ae039)("data", error.response) && (0, $a1c76089443586f4$export$2e2bcd8739ae039)("errorCode", error.response.data) && error.response.data.errorCode == (0, $f83b2fbdd997e842$export$d4e71bc0b80dc0fb).UNAUTHENTICATED;
};




const $2b7a3a2a97f271fe$export$f715db496ec47204 = (error)=>{
    const errorCodePath = [
        "response",
        "data",
        "errorCode"
    ];
    return (0, $fa87ec08b45b57a0$export$2e2bcd8739ae039)(errorCodePath) && (0, $f5f23b53da900217$export$2e2bcd8739ae039)((0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)(errorCodePath, error), (0, $f83b2fbdd997e842$export$d4e71bc0b80dc0fb).VALIDATION_ERROR);
};



class $2a76f3d38a8c34fb$export$a65dfbbccf74de8b extends Error {
    constructor(message, code){
        super(message);
        this.code = code;
    }
}






class $eec9c1cc8052bcc2$export$2191b9da168c6cf0 extends (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b) {
    constructor(validationErrors){
        super("Validation Error", (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).VALIDATION_ERROR);
        this.validationErrors = validationErrors;
    }
    getForField(field) {
        return this.validationErrors.find((error)=>{
            return (0, $b23345e505d4a129$export$2e2bcd8739ae039)(error.path) == field;
        });
    }
    existsForField(field) {
        return this.validationErrors.filter((error)=>(0, $b23345e505d4a129$export$2e2bcd8739ae039)(error.path) == field).length > 0;
    }
}


const $eaf4362a39c20654$export$edd375d2cee65f9c = (error)=>{
    const errorDetailPath = [
        "response",
        "data",
        "validationErrors"
    ];
    if (!(0, $fa87ec08b45b57a0$export$2e2bcd8739ae039)(errorDetailPath, error) || !Array.isArray((0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)(errorDetailPath, error))) return new (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b)("Unknown Error", (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).UNKNOWN);
    return new (0, $eec9c1cc8052bcc2$export$2191b9da168c6cf0)((0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)(errorDetailPath, error));
};







var $1b55d5c4a79f8127$export$af5bcc2e24b52a1f;
(function(ApplicationErrorCode) {
    ApplicationErrorCode[ApplicationErrorCode["INVALID_PERMISSIONS"] = 310] = "INVALID_PERMISSIONS";
    ApplicationErrorCode[ApplicationErrorCode["INVALID_BULK_UPLOAD_LICENSES"] = 400] = "INVALID_BULK_UPLOAD_LICENSES";
    ApplicationErrorCode[ApplicationErrorCode["BULK_UPLOAD_PARSE_ERROR_GENERIC"] = 500] = "BULK_UPLOAD_PARSE_ERROR_GENERIC";
    ApplicationErrorCode[ApplicationErrorCode["BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS"] = 501] = "BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS";
    ApplicationErrorCode[ApplicationErrorCode["BULK_UPLOAD_MAX_RECORD_SIZE"] = 502] = "BULK_UPLOAD_MAX_RECORD_SIZE";
    ApplicationErrorCode[ApplicationErrorCode["BULK_UPLOAD_INCONSISTENT_COLUMNS"] = 503] = "BULK_UPLOAD_INCONSISTENT_COLUMNS";
})($1b55d5c4a79f8127$export$af5bcc2e24b52a1f || ($1b55d5c4a79f8127$export$af5bcc2e24b52a1f = {}));


const $be6a1ccf20a40d64$var$map = new Map;
$be6a1ccf20a40d64$var$map.set((0, $1b55d5c4a79f8127$export$af5bcc2e24b52a1f).INVALID_BULK_UPLOAD_LICENSES, (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).INVALID_BULK_UPLOAD);
$be6a1ccf20a40d64$var$map.set((0, $1b55d5c4a79f8127$export$af5bcc2e24b52a1f).INVALID_PERMISSIONS, (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).INVALID_PERMISSIONS);
$be6a1ccf20a40d64$var$map.set((0, $1b55d5c4a79f8127$export$af5bcc2e24b52a1f).BULK_UPLOAD_PARSE_ERROR_GENERIC, (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).BULK_UPLOAD_PARSE_ERROR_GENERIC);
$be6a1ccf20a40d64$var$map.set((0, $1b55d5c4a79f8127$export$af5bcc2e24b52a1f).BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS, (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).BULK_UPLOAD_PARSE_ERROR_MISMATCH_COLUMNS);
$be6a1ccf20a40d64$var$map.set((0, $1b55d5c4a79f8127$export$af5bcc2e24b52a1f).BULK_UPLOAD_MAX_RECORD_SIZE, (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).BULK_UPLOAD_MAX_RECORD_SIZE);
$be6a1ccf20a40d64$var$map.set((0, $1b55d5c4a79f8127$export$af5bcc2e24b52a1f).BULK_UPLOAD_INCONSISTENT_COLUMNS, (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).BULK_UPLOAD_INCONSISTENT_COLUMNS);
const $be6a1ccf20a40d64$export$dc4b8ce12d6e0f6b = (error)=>{
    if (!(0, $0cd8964fcc0096b1$export$2e2bcd8739ae039)(error.response) && (0, $a1c76089443586f4$export$2e2bcd8739ae039)("errorCode", error.response.data) && typeof error.response.data.errorCode == "number") {
        const code = $be6a1ccf20a40d64$var$map.get(error.response.data.errorCode);
        if (code) return new (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b)("Generic application error", code);
    }
    return new (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b)("Unknown Error", (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).UNKNOWN);
};


var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


const $740ca0a739975b1d$export$b07523a6c2c029a5 = new (0, $5440e9199a418654$exports.EventEmitter)();


const $e0be57266b53bbce$export$376f4704b715057c = (error)=>{
    if (!(0, $b302555736d21bd7$export$fbafdbe06a5b5a9a)(error)) return undefined;
    const axiosError = error;
    if (axiosError.code == "ERR_NETWORK") return new (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b)("Network Error", (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).NETWORK_ERROR);
    if (axiosError.code == "ERR_BAD_REQUEST") {
        if ((0, $2b7a3a2a97f271fe$export$f715db496ec47204)(axiosError)) return (0, $eaf4362a39c20654$export$edd375d2cee65f9c)(axiosError);
        else if (axiosError.response?.status == 401 || axiosError.response?.status == 403) {
            (0, $740ca0a739975b1d$export$b07523a6c2c029a5).emit("unauthenticated");
            return new (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b)("Unauthenticated", (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).LOGGED_OUT);
        } else if ((0, $9b579bbdc66dad76$export$fbe12f4d55f2b7be)(axiosError)) return new (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b)("Unauthenticated", (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).UNAUTHENTICATED);
        else if (axiosError.response?.status == 400) return (0, $be6a1ccf20a40d64$export$dc4b8ce12d6e0f6b)(axiosError);
    }
    return new (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b)("Unknown Error", (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).UNKNOWN);
};


const $924bec3bf8f0d914$export$b0b8598934ca46b6 = (0, $e0be57266b53bbce$export$376f4704b715057c);





const $6da8ce5b7382f9de$export$e6359ca21a53a579 = (error)=>{
    let i = 0;
    let applicationError = undefined;
    const mapperKeys = (0, $89717ab94613e822$export$2e2bcd8739ae039)($924bec3bf8f0d914$exports);
    while(i < mapperKeys.length){
        const key = mapperKeys[i];
        applicationError = $924bec3bf8f0d914$exports[key](error);
        if (applicationError) return applicationError;
        i++;
    }
    return new (0, $2a76f3d38a8c34fb$export$a65dfbbccf74de8b)("Unknown Error", (0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).UNKNOWN);
};


const $45a2a4a9f8b8cb5d$var$cookie = new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)();
const $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82 = async (config, options)=>{
    const axios = (0, $2e59f0ff0fac9290$export$53ea70b747a790ee)($45a2a4a9f8b8cb5d$var$cookie.get("token") ?? undefined);
    const source = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).CancelToken.source();
    try {
        const response = await axios.request({
            ...config,
            ...options,
            cancelToken: source.token
        });
        return response.data;
    } catch (error) {
        if ((0, $b302555736d21bd7$export$fbafdbe06a5b5a9a)(error)) throw (0, $6da8ce5b7382f9de$export$e6359ca21a53a579)(error);
        throw new Error("Unknown error");
    }
};


const $0e529258adfac30f$export$44ba657484a7e61c = (options)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/logout`,
        method: "post"
    }, options);
};
const $0e529258adfac30f$export$90c923f1aa1542da = (options)=>{
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = ()=>{
        return $0e529258adfac30f$export$44ba657484a7e61c(requestOptions);
    };
    return {
        mutationFn: mutationFn,
        ...mutationOptions
    };
};
const $0e529258adfac30f$export$d816d864bc4e1280 = (options)=>{
    const mutationOptions = $0e529258adfac30f$export$90c923f1aa1542da(options);
    return (0, $cb7b7c348969488c$export$609860bf8b0084c)(mutationOptions);
};
const $0e529258adfac30f$export$ad736163b3df1f08 = (params, options, signal)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/licence`,
        method: "get",
        params: params,
        signal: signal
    }, options);
};
const $0e529258adfac30f$export$39367b52b4276d3b = (params)=>[
        `/licence`,
        ...params ? [
            params
        ] : []
    ];
const $0e529258adfac30f$export$eaa8a4d1e3a15b3e = (params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? $0e529258adfac30f$export$39367b52b4276d3b(params);
    const queryFn = ({ signal: signal })=>$0e529258adfac30f$export$ad736163b3df1f08(params, requestOptions, signal);
    return {
        queryKey: queryKey,
        queryFn: queryFn,
        ...queryOptions
    };
};
const $0e529258adfac30f$export$be8ce6c65f29d3ba = (params, options)=>{
    const queryOptions = $0e529258adfac30f$export$eaa8a4d1e3a15b3e(params, options);
    const query = (0, $6f7384520c92f99a$export$dd0a697e1782aedd)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const $0e529258adfac30f$export$edd5a6c84cb44aad = (params, options, signal)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/licence-types`,
        method: "get",
        params: params,
        signal: signal
    }, options);
};
const $0e529258adfac30f$export$83afda26ea578668 = (params)=>[
        `/licence-types`,
        ...params ? [
            params
        ] : []
    ];
const $0e529258adfac30f$export$66e2cfce4945d1c5 = (params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? $0e529258adfac30f$export$83afda26ea578668(params);
    const queryFn = ({ signal: signal })=>$0e529258adfac30f$export$edd5a6c84cb44aad(params, requestOptions, signal);
    return {
        queryKey: queryKey,
        queryFn: queryFn,
        ...queryOptions
    };
};
const $0e529258adfac30f$export$6c8e7212a9bf390a = (params, options)=>{
    const queryOptions = $0e529258adfac30f$export$66e2cfce4945d1c5(params, options);
    const query = (0, $6f7384520c92f99a$export$dd0a697e1782aedd)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const $0e529258adfac30f$export$b1bbcb857b7b49dc = (params, options, signal)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/procedure-types`,
        method: "get",
        params: params,
        signal: signal
    }, options);
};
const $0e529258adfac30f$export$be93e9d2bd47a84d = (params)=>[
        `/procedure-types`,
        ...params ? [
            params
        ] : []
    ];
const $0e529258adfac30f$export$6ec8c41928315e45 = (params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? $0e529258adfac30f$export$be93e9d2bd47a84d(params);
    const queryFn = ({ signal: signal })=>$0e529258adfac30f$export$b1bbcb857b7b49dc(params, requestOptions, signal);
    return {
        queryKey: queryKey,
        queryFn: queryFn,
        ...queryOptions
    };
};
const $0e529258adfac30f$export$4be4fb61d64ae3de = (params, options)=>{
    const queryOptions = $0e529258adfac30f$export$6ec8c41928315e45(params, options);
    const query = (0, $6f7384520c92f99a$export$dd0a697e1782aedd)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const $0e529258adfac30f$export$be146dc3b44817c4 = (params, options, signal)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/local-authorities`,
        method: "get",
        params: params,
        signal: signal
    }, options);
};
const $0e529258adfac30f$export$2103cd12bd33fe6a = (params)=>[
        `/local-authorities`,
        ...params ? [
            params
        ] : []
    ];
const $0e529258adfac30f$export$523d7c6a22bd07c8 = (params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? $0e529258adfac30f$export$2103cd12bd33fe6a(params);
    const queryFn = ({ signal: signal })=>$0e529258adfac30f$export$be146dc3b44817c4(params, requestOptions, signal);
    return {
        queryKey: queryKey,
        queryFn: queryFn,
        ...queryOptions
    };
};
const $0e529258adfac30f$export$fd2e5ba55b656870 = (params, options)=>{
    const queryOptions = $0e529258adfac30f$export$523d7c6a22bd07c8(params, options);
    const query = (0, $6f7384520c92f99a$export$dd0a697e1782aedd)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const $0e529258adfac30f$export$f2b793fb6eff54de = (postLoginBody, options)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/login`,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        data: postLoginBody
    }, options);
};
const $0e529258adfac30f$export$c66de2dc531bf559 = (options)=>{
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data: data } = props ?? {};
        return $0e529258adfac30f$export$f2b793fb6eff54de(data, requestOptions);
    };
    return {
        mutationFn: mutationFn,
        ...mutationOptions
    };
};
const $0e529258adfac30f$export$4aceabc47fd5a77e = (options)=>{
    const mutationOptions = $0e529258adfac30f$export$c66de2dc531bf559(options);
    return (0, $cb7b7c348969488c$export$609860bf8b0084c)(mutationOptions);
};
const $0e529258adfac30f$export$f9e8e20ff0afda42 = (postBulkUploadBody, options)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/bulk-upload`,
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        data: postBulkUploadBody
    }, options);
};
const $0e529258adfac30f$export$5b50992486633cff = (options)=>{
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data: data } = props ?? {};
        return $0e529258adfac30f$export$f9e8e20ff0afda42(data, requestOptions);
    };
    return {
        mutationFn: mutationFn,
        ...mutationOptions
    };
};
const $0e529258adfac30f$export$80d7e80571e8d095 = (options)=>{
    const mutationOptions = $0e529258adfac30f$export$5b50992486633cff(options);
    return (0, $cb7b7c348969488c$export$609860bf8b0084c)(mutationOptions);
};
const $0e529258adfac30f$export$17495f9c20464b8 = (params, options, signal)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/organisations`,
        method: "get",
        params: params,
        signal: signal
    }, options);
};
const $0e529258adfac30f$export$c306d2cbdad8a72b = (params)=>[
        `/organisations`,
        ...params ? [
            params
        ] : []
    ];
const $0e529258adfac30f$export$6f5fbe0fb4ec1ab1 = (params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? $0e529258adfac30f$export$c306d2cbdad8a72b(params);
    const queryFn = ({ signal: signal })=>$0e529258adfac30f$export$17495f9c20464b8(params, requestOptions, signal);
    return {
        queryKey: queryKey,
        queryFn: queryFn,
        ...queryOptions
    };
};
const $0e529258adfac30f$export$9dbe3df0445d7a7b = (params, options)=>{
    const queryOptions = $0e529258adfac30f$export$6f5fbe0fb4ec1ab1(params, options);
    const query = (0, $6f7384520c92f99a$export$dd0a697e1782aedd)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const $0e529258adfac30f$export$115885b444641d2d = (params, options)=>{
    return (0, $45a2a4a9f8b8cb5d$export$9137b3f525d9ed82)({
        url: `/resource-link`,
        method: "post",
        params: params
    }, options);
};
const $0e529258adfac30f$export$f2d33f5bc8cf8065 = (options)=>{
    const { mutation: mutationOptions, request: requestOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { params: params } = props ?? {};
        return $0e529258adfac30f$export$115885b444641d2d(params, requestOptions);
    };
    return {
        mutationFn: mutationFn,
        ...mutationOptions
    };
};
const $0e529258adfac30f$export$ac85db810fc6a0b8 = (options)=>{
    const mutationOptions = $0e529258adfac30f$export$f2d33f5bc8cf8065(options);
    return (0, $cb7b7c348969488c$export$609860bf8b0084c)(mutationOptions);
};


const $d943e1c07c3eb739$export$d4e22f05f73ea56b = ()=>{
    const { setToken: setToken, setIsLoggedIn: setIsLoggedIn, setUser: setUser } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const { mutate: mutate, error: error, isLoading: isLoading } = (0, $0e529258adfac30f$export$4aceabc47fd5a77e)();
    const login = (0, $acw62.useCallback)((options)=>{
        mutate({
            data: {
                email: options.email,
                password: options.password
            }
        }, {
            onSuccess: (data)=>{
                if ((0, $a1c76089443586f4$export$2e2bcd8739ae039)("token", data) && data.user && data.user) {
                    setToken(data.token);
                    setUser(data.user);
                    setIsLoggedIn(true);
                }
            }
        });
    }, [
        mutate
    ]);
    return {
        isLoading: isLoading,
        error: error,
        login: login
    };
};


const $66eabace22259c9d$var$EMAIL_VALIDATION_MESSAGE = "Enter a valid email address";
const $66eabace22259c9d$var$PASSWORD_VALIDATION_MESSAGE = "Enter a valid password";
const $66eabace22259c9d$export$1f58f750f20f344b = ()=>{
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors }, setError: rhFormSetError, clearErrors: clearErrors } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { login: login, error: error, isLoading: isLoading } = (0, $d943e1c07c3eb739$export$d4e22f05f73ea56b)();
    const normalError = error ?? undefined;
    const validationError = (0, $1a8e7e7ea2d4704f$export$7afbc6ab0d56b4de)(normalError);
    const { setError: setError } = (0, $4da5e0f720531533$export$1262e741a2e2f18)({
        error: normalError
    });
    (0, $acw62.useEffect)(()=>{
        setError(validationError);
        if (validationError?.existsForField("email")) rhFormSetError("email", {
            type: "focus",
            message: t($66eabace22259c9d$var$EMAIL_VALIDATION_MESSAGE)
        }, {
            shouldFocus: true
        });
        if (validationError?.existsForField("password")) rhFormSetError("password", {
            type: "focus",
            message: t($66eabace22259c9d$var$PASSWORD_VALIDATION_MESSAGE)
        }, {
            shouldFocus: true
        });
    }, [
        validationError
    ]);
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const togglePasswordVisibility = ()=>{
        setShowPassword(!showPassword);
    };
    const onSubmit = (data)=>{
        clearErrors();
        login(data);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
            spacing: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cc470731e2bfd3d2)),
            align: "stretch",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cd6270424eaeb4d4$export$fe5d99d8691b3f62), {
                    isInvalid: !!errors.email,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3866dc6a93af5f$export$842aba50ed0ce9d7), {
                            htmlFor: "login-form-email",
                            fontWeight: "700",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Email"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ef127d438f0ac5$export$f5b8910cec6cf069), {
                            ...register("email", {
                                required: t($66eabace22259c9d$var$EMAIL_VALIDATION_MESSAGE),
                                pattern: {
                                    value: /\S+@\S+\.\S+/,
                                    message: t($66eabace22259c9d$var$EMAIL_VALIDATION_MESSAGE)
                                }
                            }),
                            id: "login-form-email",
                            type: "email",
                            "data-testid": "login-form__email-field",
                            placeholder: "Enter email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9936500b9cef4dbd$export$185a8afe504e8fca), {
                            sx: (0, $ea2ca5cd54b7d224$export$4d56ea2816714768),
                            children: errors.email && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                "data-testid": "login-form__email-error",
                                children: errors.email.message
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cd6270424eaeb4d4$export$fe5d99d8691b3f62), {
                    isInvalid: !!errors.password,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3866dc6a93af5f$export$842aba50ed0ce9d7), {
                            variant: "primary",
                            htmlFor: "login-form-password",
                            fontWeight: "700",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Password"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c7a110bd37e6dedc$export$6e5a9cd40e0c9b97), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ef127d438f0ac5$export$f5b8910cec6cf069), {
                                    ...register("password", {
                                        required: t($66eabace22259c9d$var$PASSWORD_VALIDATION_MESSAGE)
                                    }),
                                    id: "login-form-password",
                                    type: showPassword ? "text" : "password",
                                    "data-testid": "login-form__password-field",
                                    placeholder: "Enter password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3444b8d3cbeb4c12$export$8a7b8bdd4608e7e3), {
                                    onClick: togglePasswordVisibility,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        "aria-label": showPassword ? "Hide password" : "Show password",
                                        onClick: togglePasswordVisibility,
                                        children: showPassword ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a600bd511b0e43a$export$4b2c798a70974642), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a39c7b18ba33fcee$export$4656e7db9801e7ad), {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9936500b9cef4dbd$export$185a8afe504e8fca), {
                            sx: (0, $ea2ca5cd54b7d224$export$4d56ea2816714768),
                            children: errors.password && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                "data-testid": "login-form__password-error",
                                children: errors.password.message
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a845447b1ebfe73$export$a6c7ac8248d6e38a), {
                            href: "https://sso.rheglobal.com/forgotten-password?service=17",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Forgotten password?"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                    type: "submit",
                    variant: "primary",
                    "data-testid": "login-form__submit-button",
                    isLoading: isLoading,
                    mt: "50px",
                    w: "100%",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Sign in"
                    })
                })
            ]
        })
    });
};



const $e613667a57295b3e$var$cardTextStyles = {
    paddingTop: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
    paddingLeft: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea))
};
const $e613667a57295b3e$export$25233b7fe55e5696 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d16df24508f5c77$export$694e0d28c7ffc90c), {
        align: "center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1071234c98a0a33d$export$8f2ccbc6b4e5d821), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d74216d2c0bf0981$export$60332b2344f7fe41), {
                w: "400px",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3307ee9fb8204c10$export$5665775b26e26c5d), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            as: "h1",
                            tabIndex: 0,
                            sx: $e613667a57295b3e$var$cardTextStyles,
                            "data-testid": "login-page__sign-in-title",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Sign in"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fcf4ae264bbac4fb$export$c64f601a6e4de099), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf2c7f89c79144c1$export$851de33184ecdac4), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            "data-testid": "login-page__login-card",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66eabace22259c9d$export$1f58f750f20f344b), {})
                        })
                    })
                ]
            })
        })
    });
};


const $77d4011c1a569e48$export$f14c0e3f98d164c0 = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        if (isLoggedIn) navigate("/create-licence");
    }, [
        isLoggedIn
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3eb35d4abe9e46$export$1f54913ccc4368b1), {
        "data-testid": "login-page",
        height: "100%",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e613667a57295b3e$export$25233b7fe55e5696), {})
    });
};


const $38a6b3f47b632dde$export$f8f06b22414498a4 = ()=>{
    const { isLoggedIn: isLoggedIn, token: token } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    if (!isLoggedIn || !token) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d4011c1a569e48$export$f14c0e3f98d164c0), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {});
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $ae921eff144f1916$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $ae921eff144f1916$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


var $2bfc4df1a5c6c3d7$var$useCookie = function(cookieName) {
    var _a = (0, $acw62.useState)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).get(cookieName) || null;
    }), value = _a[0], setValue = _a[1];
    var updateCookie = (0, $acw62.useCallback)(function(newValue, options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).set(cookieName, newValue, options);
        setValue(newValue);
    }, [
        cookieName
    ]);
    var deleteCookie = (0, $acw62.useCallback)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).remove(cookieName);
        setValue(null);
    }, [
        cookieName
    ]);
    return [
        value,
        updateCookie,
        deleteCookie
    ];
};
var $2bfc4df1a5c6c3d7$export$2e2bcd8739ae039 = $2bfc4df1a5c6c3d7$var$useCookie;


var $acw62 = parcelRequire("acw62");
var $7f094b67708d6045$var$useEffectOnce = function(effect) {
    (0, $acw62.useEffect)(effect, []);
};
var $7f094b67708d6045$export$2e2bcd8739ae039 = $7f094b67708d6045$var$useEffectOnce;





const $a729a4515b73f625$var$cookie = new (0, $9814bc57a8c0985e$export$2e2bcd8739ae039)();
const $a729a4515b73f625$export$7c0a4d285a69efc1 = ()=>{
    const [token, setToken] = (0, $acw62.useState)("");
    const [isLoggedIn, setIsLoggedIn] = (0, $acw62.useState)(false);
    const [user, setUser] = (0, $acw62.useState)(undefined);
    const [storedToken, updateStoredToken, deleteStoredToken] = (0, $2bfc4df1a5c6c3d7$export$2e2bcd8739ae039)("token");
    const [storedUser, updateStoredUser, deleteStoredUser] = (0, $2bfc4df1a5c6c3d7$export$2e2bcd8739ae039)("user");
    const onUnauthenticated = ()=>{
        deleteStoredToken();
        deleteStoredUser();
        setToken("");
        setIsLoggedIn(false);
        (0, $1d34d5c4a288b213$export$89e12c5b50f7529d)("/login");
        $a729a4515b73f625$var$cookie.remove("token");
    };
    (0, $acw62.useEffect)(()=>{
        (0, $740ca0a739975b1d$export$b07523a6c2c029a5).on("unauthenticated", onUnauthenticated);
        return ()=>{
            (0, $740ca0a739975b1d$export$b07523a6c2c029a5).off("unauthenticated", onUnauthenticated);
        };
    }, [
        (0, $740ca0a739975b1d$export$b07523a6c2c029a5),
        onUnauthenticated
    ]);
    (0, $7f094b67708d6045$export$2e2bcd8739ae039)(()=>{
        if (storedToken && !token) {
            setToken(storedToken);
            setIsLoggedIn(true);
            if (storedUser) {
                const user = JSON.parse(storedUser);
                setUser(user);
            }
        } else if (token) {
            deleteStoredToken();
            deleteStoredUser();
        }
    });
    const setTokenProxy = (token)=>{
        updateStoredToken(token, {
            secure: true
        });
        setToken(token);
    };
    const setUserProxy = (user)=>{
        if (user) updateStoredUser(JSON.stringify(user), {
            secure: true
        });
        else deleteStoredUser();
        setUser(user);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49553c78695c6663$export$1cbb4184b742b6e9).Provider, {
        value: {
            token: token,
            setToken: setTokenProxy,
            isLoggedIn: isLoggedIn,
            setIsLoggedIn: setIsLoggedIn,
            user: user,
            setUser: setUserProxy
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
    });
};



const $13d014f488f21b0f$export$e4a014db366db61e = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Hello, Admin"
    });




// src/heading.tsx



var $88788dd03800ffcb$export$a8a3e93435678ff9 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Heading2(props, ref) {
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Heading", props);
    const { className: className, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).h2, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-heading", props.className),
        ...rest,
        __css: styles
    });
});
$88788dd03800ffcb$export$a8a3e93435678ff9.displayName = "Heading";






var $2bed5f8eb83ed779$exports = {};

$2bed5f8eb83ed779$exports = new URL((parcelRequire("27Lyk")).resolve("g7sS3"), import.meta.url).toString();


const $f2c236c700eed7f6$export$31641b61980e511f = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3eb35d4abe9e46$export$1f54913ccc4368b1), {
        height: "100%",
        backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($2bed5f8eb83ed779$exports)))})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
            role: "main",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                    pb: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                        textStyle: "headingLtPrimary",
                        as: "h1",
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            children: "Oops, page not found!"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                    display: "inline-block",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            pb: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$ed7bdee048351354)),
                            textAlign: "center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                                textStyle: "headingLt4",
                                color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: "404 error."
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            pb: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cc470731e2bfd3d2)),
                            textAlign: "center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                                textStyle: "text03",
                                color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: [
                                        "We are sorry for the inconvenience.",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "It looks like you're trying to access a page that has been",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "moved or deleted."
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                            variant: "primary",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Back to homepage"
                            })
                        })
                    })
                })
            ]
        })
    });
};








var $042aa564dab2c8c3$exports = {};

$042aa564dab2c8c3$exports = new URL((parcelRequire("27Lyk")).resolve("7vday"), import.meta.url).toString();


const $102328d9d107de95$export$5d5f670aa4440fd0 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3eb35d4abe9e46$export$1f54913ccc4368b1), {
        height: "100%",
        backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($042aa564dab2c8c3$exports)))})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
            role: "main",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                    pb: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                        textStyle: "headingLtPrimary",
                        as: "h1",
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            children: "Oops, something went wrong!"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                    display: "inline-block",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            pb: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$ed7bdee048351354)),
                            textAlign: "center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                                textStyle: "headingLt4",
                                color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: "500 error"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            pb: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cc470731e2bfd3d2)),
                            textAlign: "center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                                textStyle: "text03",
                                color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: [
                                        "Unfortunately we’re having trouble loading the page you are looking for.",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                        "Please try again later."
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                            variant: "primary",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Back to homepage"
                            })
                        })
                    })
                })
            ]
        })
    });
};



// src/spacer.tsx

var $8fcb58e791a7825a$export$d7a54cba636a8cd6 = (0, $f1b95b1386d3a42c$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        flex: 1,
        justifySelf: "stretch",
        alignSelf: "stretch"
    }
});
$8fcb58e791a7825a$export$d7a54cba636a8cd6.displayName = "Spacer";



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $f6ccc2005cfc5555$export$699c2130295691b4;
(function(LicenceTypes) {
    LicenceTypes["CERTIFICATE_PREMISES"] = "certificatePremises";
    LicenceTypes["CERTIFICATE_VEHICLE"] = "certificateVehicle";
    LicenceTypes["PRACTITIONER"] = "practitioner";
})($f6ccc2005cfc5555$export$699c2130295691b4 || ($f6ccc2005cfc5555$export$699c2130295691b4 = {}));
var $f6ccc2005cfc5555$export$ce4fe1c9e6520c1a;
(function(Language) {
    Language["en"] = "en";
    Language["cy"] = "cy";
})($f6ccc2005cfc5555$export$ce4fe1c9e6520c1a || ($f6ccc2005cfc5555$export$ce4fe1c9e6520c1a = {}));


const $0fcb58396bd36196$export$655dd0e71353e7d = (language)=>{
    return Object.keys((0, $f6ccc2005cfc5555$export$ce4fe1c9e6520c1a)).includes(language);
};



const $e8ef5ee6ff8929e0$export$c1fd9f444a3dc711 = ()=>{
    const DEFAULT_LANGUAGE = (0, $f6ccc2005cfc5555$export$ce4fe1c9e6520c1a).en;
    const { i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    if ((0, $0fcb58396bd36196$export$655dd0e71353e7d)(i18n.resolvedLanguage)) return i18n.resolvedLanguage;
    return DEFAULT_LANGUAGE;
};



var $acw62 = parcelRequire("acw62");

var $ef70efe2b8b5174c$var$useUnmount = function(fn) {
    var fnRef = (0, $acw62.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0, $7f094b67708d6045$export$2e2bcd8739ae039)(function() {
        return function() {
            return fnRef.current();
        };
    });
};
var $ef70efe2b8b5174c$export$2e2bcd8739ae039 = $ef70efe2b8b5174c$var$useUnmount;


const $d2068099769ece6b$var$axios = (0, $2e59f0ff0fac9290$export$53ea70b747a790ee)();
const $d2068099769ece6b$export$dd0a697e1782aedd = ()=>{
    const language = (0, $e8ef5ee6ff8929e0$export$c1fd9f444a3dc711)();
    const { token: token } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const [results, setResults] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)();
    const [searchParams, setSearchParams] = (0, $acw62.useState)({});
    const [controller, setController] = (0, $acw62.useState)(null);
    (0, $ef70efe2b8b5174c$export$2e2bcd8739ae039)(()=>{
        if (controller) controller.abort();
    });
    const setSearchParamsProxy = (params)=>{
        if (params != searchParams) {
            const controller = new AbortController();
            setSearchParams(params);
            setController(controller);
            setIsLoading(true);
            $d2068099769ece6b$var$axios.get("/licences", {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                params: {
                    ...params,
                    language: language
                },
                signal: controller.signal
            }).then((res)=>setResults([
                    ...res.data.results
                ])).catch((error)=>setError(error instanceof Error ? error : new Error("An unknown error occurred"))).finally(()=>setIsLoading(false));
        }
    };
    return {
        results: results,
        setSearchParams: setSearchParamsProxy,
        error: error,
        isLoading: isLoading
    };
};


var $de16cfecf3a711f6$export$9a72971343552bdf;
(function(SearchActions) {
    SearchActions["READ"] = "read";
    SearchActions["NEXT"] = "next";
})($de16cfecf3a711f6$export$9a72971343552bdf || ($de16cfecf3a711f6$export$9a72971343552bdf = {}));


const $fbf56215de06987e$var$objFromUrlSearchParams = (params)=>{
    const paramsObj = {};
    for (const [key, value] of params)paramsObj[key] = value;
    return paramsObj;
};
const $fbf56215de06987e$export$bd221a7c56b93941 = ()=>{
    const DEFAULT_SKIP = 0;
    const DEFAULT_TAKE = 20;
    const [searchState, dispatchSearchQuery] = (0, $acw62.useState)({
        type: (0, $de16cfecf3a711f6$export$9a72971343552bdf).READ,
        searchParams: new URLSearchParams
    });
    const { results: results, setSearchParams: setSearchParams, error: error, isLoading: isLoading } = (0, $d2068099769ece6b$export$dd0a697e1782aedd)();
    const nextQueryStart = (0, $acw62.useRef)(DEFAULT_TAKE);
    const [searchResults, setSearchResults] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (searchState?.searchParams && searchState.type) {
            const params = searchState.searchParams;
            if (!searchState.searchParams.has("skip")) searchState.searchParams.set("skip", DEFAULT_SKIP.toString());
            if (!searchState.searchParams.has("take")) searchState.searchParams.set("take", DEFAULT_TAKE.toString());
            if (searchState.type === (0, $de16cfecf3a711f6$export$9a72971343552bdf).NEXT) searchState.searchParams.set("skip", nextQueryStart.current.toString());
            else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            nextQueryStart.current = parseInt(searchState.searchParams.get("take")) || DEFAULT_TAKE;
            setSearchParams($fbf56215de06987e$var$objFromUrlSearchParams(params));
        }
    }, [
        searchState
    ]);
    (0, $acw62.useEffect)(()=>{
        if (searchState?.searchParams && searchState.type) {
            if (searchState.type === (0, $de16cfecf3a711f6$export$9a72971343552bdf).NEXT) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const skip = parseInt(searchState.searchParams.get("skip")) || DEFAULT_SKIP;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const take = parseInt(searchState.searchParams.get("take")) || DEFAULT_TAKE;
                nextQueryStart.current = (nextQueryStart.current || skip) + take;
                setSearchResults((prevSearchResults)=>[
                        ...prevSearchResults,
                        ...results
                    ]);
            } else setSearchResults(results);
        }
    }, [
        results
    ]);
    return {
        searchResults: searchResults,
        dispatchSearchQuery: dispatchSearchQuery,
        error: error,
        isLoading: isLoading,
        nextQueryStart: nextQueryStart,
        DEFAULT_TAKE: DEFAULT_TAKE
    };
};






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $06ec8158ccc1b011$var$useRafState = function(initialState) {
    var frame = (0, $acw62.useRef)(0);
    var _a = (0, $acw62.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0, $acw62.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
            setState(value);
        });
    }, []);
    (0, $ef70efe2b8b5174c$export$2e2bcd8739ae039)(function() {
        cancelAnimationFrame(frame.current);
    });
    return [
        state,
        setRafState
    ];
};
var $06ec8158ccc1b011$export$2e2bcd8739ae039 = $06ec8158ccc1b011$var$useRafState;


var $d990dbaa8d958b74$export$8793edee2d425525 = function() {};
function $d990dbaa8d958b74$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $d990dbaa8d958b74$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $d990dbaa8d958b74$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $d990dbaa8d958b74$export$42e7ac6120dd324e = typeof navigator !== "undefined";


var $8d07841d42af443e$var$useWindowSize = function(initialWidth, initialHeight) {
    if (initialWidth === void 0) initialWidth = Infinity;
    if (initialHeight === void 0) initialHeight = Infinity;
    var _a = (0, $06ec8158ccc1b011$export$2e2bcd8739ae039)({
        width: (0, $d990dbaa8d958b74$export$4e09c449d6c407f7) ? window.innerWidth : initialWidth,
        height: (0, $d990dbaa8d958b74$export$4e09c449d6c407f7) ? window.innerHeight : initialHeight
    }), state = _a[0], setState = _a[1];
    (0, $acw62.useEffect)(function() {
        if (0, $d990dbaa8d958b74$export$4e09c449d6c407f7) {
            var handler_1 = function() {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            (0, $d990dbaa8d958b74$export$af631764ddc44097)(window, "resize", handler_1);
            return function() {
                (0, $d990dbaa8d958b74$export$8c8705df4a2dcec9)(window, "resize", handler_1);
            };
        }
    }, []);
    return state;
};
var $8d07841d42af443e$export$2e2bcd8739ae039 = $8d07841d42af443e$var$useWindowSize;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $129fac05c2fc563a$export$abe847132b142195 = /*#__PURE__*/ (0, $acw62.createContext)({
    isSearchPanelOpen: false,
    setIsSearchPanelOpen: ()=>{}
});


const $16f660dc0005d97b$export$d07517a676ce386f = {
    sm: "375px",
    md: "768px",
    lg: "1024px"
};


const $c737e09a87f03db1$export$5089b48e1c7e1fc3 = ()=>{
    const { isSearchPanelOpen: isSearchPanelOpen } = (0, $acw62.useContext)((0, $129fac05c2fc563a$export$abe847132b142195));
    const { width: width } = (0, $8d07841d42af443e$export$2e2bcd8739ae039)();
    const getBufferWidth = (width)=>{
        if (width <= parseInt((0, $16f660dc0005d97b$export$d07517a676ce386f).md) || !isSearchPanelOpen) return 0;
        return 320;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        w: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)(getBufferWidth(width)),
        transition: "width 0.3s linear",
        flexShrink: "0"
    });
};







const $ff239d263cae7178$export$844ec244b1367d54 = (input)=>{
    return typeof input === "string";
};



const $15e827264e564f33$export$cf0f153eb3e3f6ce = ({ title: title, value: value, subTitle: subTitle, fontColour: fontColour = [
    (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf),
    (0, $590eee45b2f4b5a8$export$4bdf0898d78f829f)
], textStyle: textStyle = "textBodyRegular3" })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                as: "p",
                sx: {
                    textStyle: textStyle
                },
                fontWeight: "600",
                color: (0, $ff239d263cae7178$export$844ec244b1367d54)(fontColour) ? fontColour : fontColour[0],
                children: [
                    t(title),
                    ":"
                ]
            }),
            subTitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                as: "p",
                sx: {
                    textStyle: textStyle
                },
                fontWeight: "500",
                color: (0, $ff239d263cae7178$export$844ec244b1367d54)(fontColour) ? fontColour : fontColour[1],
                children: subTitle
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                as: "p",
                sx: {
                    textStyle: textStyle
                },
                py: "1px",
                color: (0, $ff239d263cae7178$export$844ec244b1367d54)(fontColour) ? fontColour : fontColour[1],
                children: value
            })
        ]
    });
};







var $2d2b60aacaee28b5$export$e9897d434e0741ee = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function CardFooter2(props, ref) {
    const { className: className, justify: justify, ...rest } = props;
    const styles = (0, $306e6f73ed942c91$export$7e0f545483b3a68c)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-card__footer", className),
        __css: {
            display: "flex",
            justifyContent: justify,
            ...styles.footer
        },
        ...rest
    });
});

// src/grid.tsx


var $7063a8d74789abc9$export$ef2184bd89960b14 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Grid2(props, ref) {
    const { templateAreas: templateAreas, gap: gap, rowGap: rowGap, columnGap: columnGap, column: column, row: row, autoFlow: autoFlow, autoRows: autoRows, templateRows: templateRows, autoColumns: autoColumns, templateColumns: templateColumns, ...rest } = props;
    const styles = {
        display: "grid",
        gridTemplateAreas: templateAreas,
        gridGap: gap,
        gridRowGap: rowGap,
        gridColumnGap: columnGap,
        gridAutoColumns: autoColumns,
        gridColumn: column,
        gridRow: row,
        gridAutoFlow: autoFlow,
        gridAutoRows: autoRows,
        gridTemplateRows: templateRows,
        gridTemplateColumns: templateColumns
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$7063a8d74789abc9$export$ef2184bd89960b14.displayName = "Grid";





var $296d8d3041dfdf15$export$de97fecb6d4b30a5 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function SimpleGrid2(props, ref) {
    const { columns: columns, spacingX: spacingX, spacingY: spacingY, spacing: spacing, minChildWidth: minChildWidth, ...rest } = props;
    const theme = (0, $dfd3c776139494e3$export$93d4e7f90805808f)();
    const templateColumns = minChildWidth ? $296d8d3041dfdf15$var$widthToColumns(minChildWidth, theme) : $296d8d3041dfdf15$var$countToColumns(columns);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7063a8d74789abc9$export$ef2184bd89960b14), {
        ref: ref,
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        templateColumns: templateColumns,
        ...rest
    });
});
$296d8d3041dfdf15$export$de97fecb6d4b30a5.displayName = "SimpleGrid";
function $296d8d3041dfdf15$var$toPx(n) {
    return typeof n === "number" ? `${n}px` : n;
}
function $296d8d3041dfdf15$var$widthToColumns(width, theme) {
    return (0, $37c1adb04c994149$export$eca1915781c2aaca)(width, (value)=>{
        const _value = (0, $fe369539e4cd5c80$export$257b2d10b709d8ef)("sizes", value, $296d8d3041dfdf15$var$toPx(value))(theme);
        return value === null ? null : `repeat(auto-fit, minmax(${_value}, 1fr))`;
    });
}
function $296d8d3041dfdf15$var$countToColumns(count) {
    return (0, $37c1adb04c994149$export$eca1915781c2aaca)(count, (value)=>value === null ? null : `repeat(${value}, minmax(0, 1fr))`);
}



var $acw62 = parcelRequire("acw62");


// src/ChevronDown.tsx



var $acw62 = parcelRequire("acw62");

function $b9be9a1dd6e65587$export$274edc73af1ae9c8(options) {
    const { viewBox: viewBox = "0 0 24 24", d: pathDefinition, displayName: displayName, defaultProps: defaultProps = {} } = options;
    const path = (0, $acw62.Children).toArray(options.path);
    const Comp = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c7d8d08ac7551ab9$export$f04a61298a47a40f), {
            ref: ref,
            viewBox: viewBox,
            ...defaultProps,
            ...props,
            children: path.length ? path : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: pathDefinition
            })
        }));
    Comp.displayName = displayName;
    return Comp;
}


var $e19204c8cf57470f$export$4857d3f3f5f8319b = (0, $b9be9a1dd6e65587$export$274edc73af1ae9c8)({
    displayName: "ChevronDownIcon",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
});

// src/ChevronUp.tsx

var $473de85d0ecd6af3$export$7f01a6cbee61a0f2 = (0, $b9be9a1dd6e65587$export$274edc73af1ae9c8)({
    d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z",
    displayName: "ChevronUpIcon"
});






const $a70a3787a84ee6fb$export$47adaa49a9a5778b = {
    "warningLight": "#f3efe8",
    "warningDark": "#f5ba31",
    "base1-100": "#E5E9FF",
    "base1-200": "#C3C8E6",
    "base1-300": "#8C9BCD",
    "base1-400": "#5F77B9",
    "base1-500": "#2D5AB4",
    "base1-600": "#284687",
    "base1-700": "#193264",
    "base1-800": "#051441",
    "base2-100": "#e6e8f5",
    "base2-200": "#c3c8e6",
    "base2-300": "#8c9bcd",
    "base2-400": "#5f77b9",
    "base2-500": "#2d5ab4",
    "base2-600": "#284687",
    "base2-700": "#193264",
    "base2-800": "#051441",
    "neutral-100": "#e4e2e2",
    "neutral-200": "#cac6c5",
    "neutral-300": "#ada6a4",
    "neutral-400": "#938b88",
    "neutral-500": "#6e6764",
    "neutral-600": "#5e5856",
    "neutral-700": "#4f4a48",
    "neutral-800": "#403b39",
    "grey-100": "#fafafa",
    "grey-200": "#f5f5f5",
    "grey-300": "#ededed",
    "grey-400": "#e6e6e6",
    "grey-500": "#595959",
    "grey-600": "#4d4d4d",
    "grey-700": "#333333",
    "grey-800": "#1a1a1a",
    "border-radius-01": "2",
    "border-radius-02": "4",
    "success-light": "#e8f3ec",
    "success-dark": "#08a141",
    "information-light": "#dbe0eb",
    "information-dark": "#2471f5",
    "error-light": "#f3ebe8",
    "error-dark": "#c30909",
    "warning-light": "#f3efe8",
    "warning-dark": "#f5ba31",
    "shadow-100": "#1a1a1a1a",
    "shadow-200": "#1a1a1a33",
    "shadow-300": "#1a1a1a4d",
    "shadow-400": "#1a1a1a66",
    "shadow-500": "#1a1a1a80",
    "shadow-600": "#1a1a1a99",
    "shadow-700": "#1a1a1ab3",
    "shadow-800": "#1a1a1acc",
    "shadow-900": "#1a1a1ae6"
};
const $a70a3787a84ee6fb$export$8f45430ccf837300 = {
    primary: {
        text: $a70a3787a84ee6fb$export$47adaa49a9a5778b["base1-500"],
        button: {
            bg: $a70a3787a84ee6fb$export$47adaa49a9a5778b["base1-500"],
            text: $a70a3787a84ee6fb$export$47adaa49a9a5778b["grey-100"],
            hover: {
                bg: $a70a3787a84ee6fb$export$47adaa49a9a5778b["base1-600"]
            },
            active: {
                bg: $a70a3787a84ee6fb$export$47adaa49a9a5778b["base1-700"]
            },
            disabled: {
                bg: $a70a3787a84ee6fb$export$47adaa49a9a5778b["neutral-300"]
            }
        }
    },
    error: {
        text: (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf),
        bg: $a70a3787a84ee6fb$export$47adaa49a9a5778b["error-light"],
        icon: (0, $590eee45b2f4b5a8$export$3a4601f6f873d8a)
    }
};


const $85ae2d8dabb2dce9$export$d7d4d3c8842004ef = {
    paddingY: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
    paddingX: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
    gap: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$ed7bdee048351354)),
    alignItems: "flex-start",
    borderRadius: `${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px ${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px 0 0`
};
const $85ae2d8dabb2dce9$export$76e5ccd76f58fa23 = {
    backgroundColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["grey-100"],
    borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-500"],
    borderRadius: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)),
    borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
    color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-500"],
    _hover: {
        color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-600"],
        borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-600"]
    },
    _active: {
        color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-700"],
        borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-700"]
    }
};





const $92b4fff22466cec9$export$489f79cfcdcf5b9e = {
    padding: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
    borderBottomWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
    borderBottomColor: (0, $590eee45b2f4b5a8$export$78c7442df4e4fa92),
    gap: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$381f0d4736587f5e)),
    align: "flex-start"
};
const $92b4fff22466cec9$export$f263013ff0b9cbc7 = {
    borderBottomWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
    borderBottomColor: (0, $590eee45b2f4b5a8$export$78c7442df4e4fa92),
    padding: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
    gap: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$381f0d4736587f5e)),
    alignItems: "flex-start"
};




function $536e61cd09e63079$export$56d8a8da8edf546a({ height: height = "21px", width: width = "18px" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 21 18",
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 0C9.61305 0 7.32387 0.948211 5.63604 2.63604C3.94821 4.32387 3 6.61305 3 9H0L3.89 12.89L3.96 13.03L8 9H5C5 7.14348 5.7375 5.36301 7.05025 4.05025C8.36301 2.7375 10.1435 2 12 2C13.8565 2 15.637 2.7375 16.9497 4.05025C18.2625 5.36301 19 7.14348 19 9C19 10.8565 18.2625 12.637 16.9497 13.9497C15.637 15.2625 13.8565 16 12 16C10.07 16 8.32 15.21 7.06 13.94L5.64 15.36C7.27 17 9.5 18 12 18C14.3869 18 16.6761 17.0518 18.364 15.364C20.0518 13.6761 21 11.3869 21 9C21 6.61305 20.0518 4.32387 18.364 2.63604C16.6761 0.948211 14.3869 0 12 0Z",
            fill: "#6E6764"
        })
    });
}




function $a79cdc90132ebf6e$export$64abfa02d870a554({ height: height = "18px", width: width = "18px" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 18H1V7H3V16H15V7H17V18ZM0 0H18V6H0V0ZM6.5 8H11.5C11.78 8 12 8.22 12 8.5V10H6V8.5C6 8.22 6.22 8 6.5 8ZM2 2V4H16V2H2Z",
            fill: "#6E6764"
        })
    });
}




function $b2ab0b88d1a59d22$export$2ad141e9e3d81b82({ height: height = "19px", width: width = "18px" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 19 18",
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.06 6L12 6.94L2.92 16H2V15.08L11.06 6ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z",
            fill: "#6E6764"
        })
    });
}



const $0232e2d216463d82$export$18ba853e8bca15be = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};





var $acw62 = parcelRequire("acw62");

const $3b9216cd2dbb7012$export$77d8ddb155d633f5 = ()=>{
    const { user: user } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    return user ? {
        id: user?.organisation_id
    } : undefined;
};


const $9a653a9b5078dcc3$export$a6683e5bda543dce = ({ licence: licence, header: header, children: children, moreInfoShown: moreInfoShown = false })=>{
    const [infoShown, setInfoShown] = (0, $acw62.useState)(moreInfoShown);
    const { isLoggedIn: isLoggedIn } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const organisation = (0, $3b9216cd2dbb7012$export$77d8ddb155d633f5)();
    const { id: id, issue_date: issue_date, archived_date: archived_date, internal_notes: internal_notes, procedure_types: procedure_types, local_authority: local_authority, licence_type: licence_type } = licence;
    const isArchived = !!archived_date;
    const belongsToUsersOrganisation = isLoggedIn && organisation?.id ? licence.organisation_id === organisation.id : false;
    const status = isArchived ? t("dateSuffixedArchived", {
        date: archived_date
    }) : t("dateSuffixedApproved", {
        date: issue_date
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d74216d2c0bf0981$export$60332b2344f7fe41), {
        variant: isArchived ? "resultArchived" : "result",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3307ee9fb8204c10$export$5665775b26e26c5d), {
                children: [
                    isLoggedIn && belongsToUsersOrganisation && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                        sx: (0, $85ae2d8dabb2dce9$export$d7d4d3c8842004ef),
                        backgroundColor: isArchived ? (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["grey-800"] : (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-700"],
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                                sx: {
                                    textStyle: "textBodyRegular3"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            children: "URN: "
                                        })
                                    }),
                                    id
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
                                children: [
                                    isArchived ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                        variant: "tertiary",
                                        sx: (0, $85ae2d8dabb2dce9$export$76e5ccd76f58fa23),
                                        leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $536e61cd09e63079$export$56d8a8da8edf546a), {}),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            children: "Restore"
                                        })
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                        variant: "tertiary",
                                        sx: (0, $85ae2d8dabb2dce9$export$76e5ccd76f58fa23),
                                        leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a79cdc90132ebf6e$export$64abfa02d870a554), {}),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            children: "Archive"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                        onClick: ()=>navigate(`/edit-licence/?urn=${id}`),
                                        variant: "tertiary",
                                        sx: (0, $85ae2d8dabb2dce9$export$76e5ccd76f58fa23),
                                        leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2ab0b88d1a59d22$export$2ad141e9e3d81b82), {}),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            children: "Edit"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                                title: "Note",
                                value: internal_notes || "No notes added",
                                fontColour: (0, $590eee45b2f4b5a8$export$6aefc03aa88b5914)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                        py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
                        px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
                        children: header
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cf2c7f89c79144c1$export$851de33184ecdac4), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                        sx: (0, $92b4fff22466cec9$export$f263013ff0b9cbc7),
                        backgroundColor: isArchived ? (0, $590eee45b2f4b5a8$export$74bec8fff1ee428) : (0, $590eee45b2f4b5a8$export$ffb2798d2b4dbfbe),
                        children: children
                    }),
                    infoShown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $296d8d3041dfdf15$export$de97fecb6d4b30a5), {
                        sx: (0, $92b4fff22466cec9$export$489f79cfcdcf5b9e),
                        templateColumns: {
                            base: "auto",
                            lg: "auto auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                                title: "Procedure type",
                                value: procedure_types
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                                title: "Local authority",
                                value: local_authority
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                                title: "Licence type",
                                value: licence_type
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                                title: "Status",
                                value: status
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d2b60aacaee28b5$export$e9897d434e0741ee), {
                sx: (0, $0232e2d216463d82$export$18ba853e8bca15be),
                children: infoShown ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                    rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473de85d0ecd6af3$export$7f01a6cbee61a0f2), {}),
                    onClick: ()=>setInfoShown(false),
                    variant: "linkPrimary",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Show Less"
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                    rightIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e19204c8cf57470f$export$4857d3f3f5f8319b), {}),
                    onClick: ()=>setInfoShown(true),
                    variant: "linkPrimary",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Show more"
                    })
                })
            })
        ]
    });
};


const $00893634c262b3a5$export$21e3bbfab41576e7 = (address, includeBusinessName = false)=>{
    let outputString = "";
    if (!address) return "";
    if (address.associated_business_name && includeBusinessName) outputString += `${address.associated_business_name}`;
    outputString += `${address.address_line1}, `;
    if (address.address_line2) outputString += `${address.address_line2}, `;
    outputString += `${address.town}, `;
    outputString += address.postcode;
    return outputString;
};


const $da859d4a9b0274ab$export$7572c49d402f2515 = ({ licence: licence })=>{
    const { practitioner_name: practitioner_name, addresses: addresses } = licence;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9a653a9b5078dcc3$export$a6683e5bda543dce), {
        licence: licence,
        header: practitioner_name,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Licence number",
                value: licence.licence_number
            }, 0),
            addresses.map((address, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                    title: "Associated business",
                    subTitle: address.associated_business_name,
                    value: (0, $00893634c262b3a5$export$21e3bbfab41576e7)(address, false)
                }, index))
        ]
    });
};





const $5b54c62481a39a0a$export$4804d9c8a26adcc = ({ licence: licence })=>{
    const { business_name: business_name, certificate_holder_name: certificate_holder_name, vehicle_registration_details: vehicle_registration_details, vehicle_description: vehicle_description } = licence;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9a653a9b5078dcc3$export$a6683e5bda543dce), {
        licence: licence,
        header: business_name,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Licence number",
                value: licence.licence_number
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Certificate holder name",
                value: certificate_holder_name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Vehicle registration details",
                value: vehicle_registration_details
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Vehicle details",
                value: vehicle_description
            })
        ]
    });
};






const $4aaafdffa0bd14dc$export$713b0e976b6c58cb = ({ licence: licence })=>{
    const { business_name: business_name, certificate_holder_name: certificate_holder_name, addresses: addresses, number_of_workstations: number_of_workstations } = licence;
    const strAddress = (0, $00893634c262b3a5$export$21e3bbfab41576e7)(addresses[0]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9a653a9b5078dcc3$export$a6683e5bda543dce), {
        licence: licence,
        header: business_name,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Licence number",
                value: licence.licence_number
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Certificate holder name",
                value: certificate_holder_name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Approved premises address",
                value: strAddress
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15e827264e564f33$export$cf0f153eb3e3f6ce), {
                title: "Number of workstations",
                value: number_of_workstations.toString()
            })
        ]
    });
};




const $9afdbe50b82e7234$export$edee0fa39c47b395 = (licence)=>{
    const validLicenceIds = [
        "practitionerLicence3Year",
        "practitionerLicence7Day",
        "traineeLicence"
    ];
    return validLicenceIds.includes(licence.licence_type_id);
};


const $73fd0d8b1d2f5308$export$2278b423d55f25e2 = (licence)=>{
    const validLicenceIds = [
        "certificateVehicleLicence3Year",
        "certificateVehicleLicence7Day"
    ];
    return validLicenceIds.includes(licence.licence_type_id);
};


const $e3ba7b1a07358ef9$export$ba1f6762b64b0fd0 = (licence)=>{
    const validLicenceIds = [
        "certificatePremisesLicence3Year",
        "certificatePremisesLicence7Day"
    ];
    return validLicenceIds.includes(licence.licence_type_id);
};


const $c29c8272dc877852$export$b9cd4d099158db35 = ({ licence: licence })=>{
    if ((0, $9afdbe50b82e7234$export$edee0fa39c47b395)(licence)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da859d4a9b0274ab$export$7572c49d402f2515), {
        licence: licence
    });
    if ((0, $73fd0d8b1d2f5308$export$2278b423d55f25e2)(licence)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b54c62481a39a0a$export$4804d9c8a26adcc), {
        licence: licence
    });
    if ((0, $e3ba7b1a07358ef9$export$ba1f6762b64b0fd0)(licence)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4aaafdffa0bd14dc$export$713b0e976b6c58cb), {
        licence: licence
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
        tabIndex: 0,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
            children: "Error could not load card"
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $6abc8dde70ddd647$export$2c54b9c78c14ff3f = (x, y, blur, spread, color)=>[
        (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)(x),
        (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)(y),
        (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)(blur),
        (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)(spread),
        color
    ].join(" ");




const $51e386b31c0ba5be$var$SEARCH_HEADER_HEIGHT = "57px";
const $51e386b31c0ba5be$export$b3219800bda33a1f = {
    align: "stretch",
    width: "100%",
    overflowY: "auto",
    height: "100%"
};
const $51e386b31c0ba5be$export$38e42c68cf43b5d4 = {
    position: "sticky",
    top: "0",
    width: "100%",
    height: $51e386b31c0ba5be$var$SEARCH_HEADER_HEIGHT,
    color: (0, $590eee45b2f4b5a8$export$6aefc03aa88b5914),
    backgroundColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"],
    padding: `${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e))} ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea))}`,
    borderBottomWidth: (0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f),
    boxShadow: (0, $6abc8dde70ddd647$export$2c54b9c78c14ff3f)((0, $590eee45b2f4b5a8$export$82e1976588d1fc7c), (0, $590eee45b2f4b5a8$export$cd569af2f704f216), (0, $590eee45b2f4b5a8$export$c45f94b963c4c37b), (0, $590eee45b2f4b5a8$export$5231156381f9884e), (0, $590eee45b2f4b5a8$export$fac8e8efc20285b1))
};
const $51e386b31c0ba5be$export$1e6f07a0baabec29 = {
    px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3ba0070c9b17960f)),
    py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
    gap: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
    alignItems: "stretch",
    width: "100%"
};





const $ae05ab2d87032909$export$a54ec244c8863715 = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { searchResults: searchResults, dispatchSearchQuery: dispatchSearchQuery, isLoading: isLoading, DEFAULT_TAKE: DEFAULT_TAKE, nextQueryStart: nextQueryStart } = (0, $fbf56215de06987e$export$bd221a7c56b93941)();
    (0, $acw62.useEffect)(()=>{
        dispatchSearchQuery({
            type: (0, $de16cfecf3a711f6$export$9a72971343552bdf).READ,
            searchParams: searchParams
        });
    }, [
        searchParams
    ]);
    const pendingOrLoading = isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
        children: t("No results found")
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
        gap: 0,
        justify: "stretch",
        "data-testid": "search-page",
        height: "100%",
        align: "flex-start",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c737e09a87f03db1$export$5089b48e1c7e1fc3), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                sx: (0, $51e386b31c0ba5be$export$b3219800bda33a1f),
                style: {
                    marginInlineStart: "0"
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                        id: "search-title",
                        as: "h1",
                        sx: (0, $51e386b31c0ba5be$export$38e42c68cf43b5d4),
                        zIndex: {
                            base: "0",
                            md: "2",
                            sm: "1"
                        },
                        tabIndex: 0,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Search Results"
                            }),
                            ":"
                        ]
                    }),
                    !!searchResults && searchResults.length !== 0 && !isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                        zIndex: 0,
                        sx: (0, $51e386b31c0ba5be$export$1e6f07a0baabec29),
                        children: [
                            searchResults.map((licence, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c29c8272dc877852$export$b9cd4d099158db35), {
                                    licence: licence
                                }, index)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fcb58e791a7825a$export$d7a54cba636a8cd6), {}),
                            searchResults.length < DEFAULT_TAKE || searchResults.length < nextQueryStart.current ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fcb58e791a7825a$export$d7a54cba636a8cd6), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                w: 200,
                                alignSelf: "center",
                                mt: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
                                isLoading: isLoading,
                                onClick: ()=>dispatchSearchQuery({
                                        type: (0, $de16cfecf3a711f6$export$9a72971343552bdf).NEXT,
                                        searchParams: searchParams
                                    }),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: "Load More"
                                })
                            })
                        ]
                    }) : pendingOrLoading
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");


const $fbdcf5931b478170$export$6bd70292443463a4 = ()=>{
    const [isSearchPanelOpen, setIsSearchPanelOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $129fac05c2fc563a$export$abe847132b142195).Provider, {
        value: {
            isSearchPanelOpen: isSearchPanelOpen,
            setIsSearchPanelOpen: setIsSearchPanelOpen
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
    });
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $bdaa2243693f9b25$export$e2bd290781d68bf1 = /*#__PURE__*/ (0, $acw62.createContext)({
    step: 1,
    setStep: ()=>{}
});



var $426f534707ae6ced$export$acae14b34103071f;
(function(CreateLicenceScreens) {
    CreateLicenceScreens[CreateLicenceScreens["BASIC_DETAILS"] = 1] = "BASIC_DETAILS";
    CreateLicenceScreens[CreateLicenceScreens["ADDITIONAL_DETAILS"] = 2] = "ADDITIONAL_DETAILS";
})($426f534707ae6ced$export$acae14b34103071f || ($426f534707ae6ced$export$acae14b34103071f = {}));


const $45b8cf243d4ac016$export$a51f40efc5c42472 = ()=>{
    const [step, setStep] = (0, $acw62.useState)((0, $426f534707ae6ced$export$acae14b34103071f).BASIC_DETAILS);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdaa2243693f9b25$export$e2bd290781d68bf1).Provider, {
        value: {
            step: step,
            setStep: setStep
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
    });
};






var $acw62 = parcelRequire("acw62");



const $641772106617d27d$export$2b215ce73bbb8647 = (licenceTypeId)=>{
    const certificatePremisesLicenceIds = [
        "certificatePremisesLicence3Year",
        "certificatePremisesLicence7Day"
    ];
    const certificateVehicleLicenceIds = [
        "certificateVehicleLicence3Year",
        "certificateVehicleLicence7Day"
    ];
    const practitionerLicenceIds = [
        "practitionerLicence3Year",
        "practitionerLicence7Day",
        "traineeLicence"
    ];
    if (certificatePremisesLicenceIds.includes(licenceTypeId)) return (0, $f6ccc2005cfc5555$export$699c2130295691b4).CERTIFICATE_PREMISES;
    if (certificateVehicleLicenceIds.includes(licenceTypeId)) return (0, $f6ccc2005cfc5555$export$699c2130295691b4).CERTIFICATE_VEHICLE;
    if (practitionerLicenceIds.includes(licenceTypeId)) return (0, $f6ccc2005cfc5555$export$699c2130295691b4).PRACTITIONER;
    return undefined;
};






var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




const $6db6a5e042da850f$export$1d2123ae1e13fd90 = {
    width: "540px",
    gap: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$9eb2f1764dbb2e83)),
    paddingBottom: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cc470731e2bfd3d2))
};




const $619cde09eab7cfbd$export$8df90684a752ef81 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: "14",
        height: "17",
        viewBox: "0 0 14 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 13V7H0L7 0L14 7H10V13H4ZM0 17V15H14V17H0Z",
            fill: "#2D5AB4"
        })
    });
};




var $acw62 = parcelRequire("acw62");

const $2d7c7ef6c8da9670$export$dde803638a7db51f = ()=>{
    const { user: user } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const permissions = user?.permissions ?? [];
    const hasPermission = (0, $acw62.useCallback)((permission)=>{
        return permissions.includes(permission);
    }, [
        permissions
    ]);
    return {
        hasPermission: hasPermission
    };
};


const $23540125288fb711$export$539f23a864aa3585 = "organisation.list";
const $23540125288fb711$export$b037bb6499b4a085 = "licence.bulk-create";
const $23540125288fb711$export$b7d846e56ce254fb = "licence.create";


const $76821c5fbe903325$export$a26deed65a14d052 = ({ header: header, children: children, onSubmit: onSubmit })=>{
    const { step: step, setStep: setStep } = (0, $acw62.useContext)((0, $bdaa2243693f9b25$export$e2bd290781d68bf1));
    const { handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting } } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const { hasPermission: hasPermission } = (0, $2d7c7ef6c8da9670$export$dde803638a7db51f)();
    const goBack = ()=>{
        setStep((0, $426f534707ae6ced$export$acae14b34103071f).BASIC_DETAILS);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        style: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
            sx: (0, $6db6a5e042da850f$export$1d2123ae1e13fd90),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                    variant: "Lt4",
                    alignSelf: "start",
                    color: (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf),
                    children: header
                }),
                children,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $296d8d3041dfdf15$export$de97fecb6d4b30a5), {
                    gridTemplateColumns: "repeat(2, auto)",
                    justifyContent: "space-between",
                    alignItems: "end",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            children: [
                                step > (0, $426f534707ae6ced$export$acae14b34103071f).BASIC_DETAILS && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                    variant: "secondary",
                                    onClick: goBack,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        children: "Back"
                                    })
                                }),
                                step == (0, $426f534707ae6ced$export$acae14b34103071f).BASIC_DETAILS && hasPermission((0, $23540125288fb711$export$b037bb6499b4a085)) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/bulk-upload",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                        variant: "secondary",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $619cde09eab7cfbd$export$8df90684a752ef81), {}),
                                            "\xa0",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                                children: "Bulk Upload"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                            type: "submit",
                            isDisabled: isSubmitting,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: step === (0, $426f534707ae6ced$export$acae14b34103071f).ADDITIONAL_DETAILS ? "Save and add another licence" : "Continue"
                            })
                        })
                    ]
                })
            ]
        })
    });
};











const $0ba3c62acd269914$export$54a2e2e305599171 = (errors, id)=>{
    if (!errors || (0, $ec30f762231a8e05$export$2e2bcd8739ae039)(errors)) return undefined;
    const parts = id.split(".");
    const errorObject = (0, $9bd9d0833c80fa65$export$2e2bcd8739ae039)(parts, errors);
    if (!errorObject) return undefined;
    return errorObject.message;
};



const $6dd005f903a28199$export$fb9f58ebe9de6283 = ({ id: id = "", required: required = false, label: label = "", children: children })=>{
    const { formState: { errors: errors } } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const errorMessage = (0, $0ba3c62acd269914$export$54a2e2e305599171)(errors, id);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cd6270424eaeb4d4$export$fe5d99d8691b3f62), {
        isInvalid: !!errorMessage && required,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3866dc6a93af5f$export$842aba50ed0ce9d7), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: label
                })
            }),
            children,
            !!errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9936500b9cef4dbd$export$185a8afe504e8fca), {
                sx: (0, $ea2ca5cd54b7d224$export$4d56ea2816714768),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: errorMessage
                })
            })
        ]
    });
};


const $2f992dc2156f2c1e$export$5d92d9428fdc106b = ({ id: id = "issueDate", required: required = false, width: width })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { register: register } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dd005f903a28199$export$fb9f58ebe9de6283), {
        id: id,
        label: "Issue date",
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ef127d438f0ac5$export$f5b8910cec6cf069), {
            w: width ?? "100%",
            placeholder: "Select issue date",
            ...register(id, {
                required: required ? t("Please enter the issue date of the licence") : false
            }),
            type: "date"
        })
    });
};






// src/select-field.tsx



var $72f811983cee5074$export$d55b50a564d0b931 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function SelectField2(props, ref) {
    const { children: children, placeholder: placeholder, className: className, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).select, {
        ...rest,
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-select", className),
        children: [
            placeholder && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: "",
                children: placeholder
            }),
            children
        ]
    });
});
$72f811983cee5074$export$d55b50a564d0b931.displayName = "SelectField";






var $acw62 = parcelRequire("acw62");

// ../../utilities/object-utils/src/index.ts
function $b9a72dfb200c6dd1$var$split(object, keys) {
    const picked = {};
    const omitted = {};
    for (const [key, value] of Object.entries(object))if (keys.includes(key)) picked[key] = value;
    else omitted[key] = value;
    return [
        picked,
        omitted
    ];
}
var $b9a72dfb200c6dd1$export$ef9b1a59e592288f = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Select", props);
    const { rootProps: rootProps, placeholder: placeholder, icon: icon, color: color, height: height, h: h, minH: minH, minHeight: minHeight, iconColor: iconColor, iconSize: iconSize, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const [layoutProps, otherProps] = $b9a72dfb200c6dd1$var$split(rest, (0, $47a6d9fbbf7ee42d$export$bccb7c6ca2f4f912));
    const ownProps = (0, $6129e3e578a61ce7$export$62ecd8ad1bbe1a18)(otherProps);
    const rootStyles = {
        width: "100%",
        height: "fit-content",
        position: "relative",
        color: color
    };
    const fieldStyles = {
        paddingEnd: "2rem",
        ...styles.field,
        _focus: {
            zIndex: "unset",
            ...(_a = styles.field) == null ? void 0 : _a["_focus"]
        }
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        className: "chakra-select__wrapper",
        __css: rootStyles,
        ...layoutProps,
        ...rootProps,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $72f811983cee5074$export$d55b50a564d0b931), {
                ref: ref,
                height: h != null ? h : height,
                minH: minH != null ? minH : minHeight,
                placeholder: placeholder,
                ...ownProps,
                __css: fieldStyles,
                children: props.children
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b9a72dfb200c6dd1$var$SelectIcon, {
                "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(ownProps.disabled),
                ...(iconColor || color) && {
                    color: iconColor || color
                },
                __css: styles.icon,
                ...iconSize && {
                    fontSize: iconSize
                },
                children: icon
            })
        ]
    });
});
$b9a72dfb200c6dd1$export$ef9b1a59e592288f.displayName = "Select";
var $b9a72dfb200c6dd1$export$d206ce4c12e8ddf6 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fill: "currentColor",
            d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        })
    });
var $b9a72dfb200c6dd1$var$IconWrapper = (0, $f1b95b1386d3a42c$export$7cd122d781af9fa4)("div", {
    baseStyle: {
        position: "absolute",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        top: "50%",
        transform: "translateY(-50%)"
    }
});
var $b9a72dfb200c6dd1$var$SelectIcon = (props)=>{
    const { children: children = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b9a72dfb200c6dd1$export$d206ce4c12e8ddf6, {}), ...rest } = props;
    const clone = (0, $acw62.cloneElement)(children, {
        role: "presentation",
        className: "chakra-select__icon",
        focusable: false,
        "aria-hidden": true,
        style: {
            width: "1em",
            height: "1em",
            color: "currentColor"
        }
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($b9a72dfb200c6dd1$var$IconWrapper, {
        ...rest,
        className: "chakra-select__icon-wrapper",
        children: (0, $acw62.isValidElement)(children) ? clone : null
    });
};
$b9a72dfb200c6dd1$var$SelectIcon.displayName = "SelectIcon";








var $acw62 = parcelRequire("acw62");
const $e93eb28e913cc8a3$export$40d561691c647821 = ({ id: id, required: required = false, placeholder: placeholder = "", label: label = "", onChanged: onChanged, errors: errors, children: children, disabled: disabled })=>{
    const { register: register, getValues: getValues, setValue: setValue } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const [fieldValue, setFieldValue] = (0, $acw62.useState)(getValues(id) || "");
    (0, $acw62.useMemo)(()=>{
        if (onChanged) {
            onChanged(fieldValue);
            setValue(id, fieldValue, {
                shouldValidate: true
            });
        }
    }, [
        fieldValue
    ]);
    const DEFAULT_ERROR = {
        required: required ? (0, $1e087ff174cd7c1d$export$d8bd0967cb58683)[(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).EMPTY_SELECT_VALIDATION] : false
    };
    const ERRORS = !errors ? DEFAULT_ERROR : errors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dd005f903a28199$export$fb9f58ebe9de6283), {
        id: id,
        label: label,
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b9a72dfb200c6dd1$export$ef9b1a59e592288f), {
            ...register(id, ERRORS),
            onChange: (e)=>setFieldValue(e.target.value),
            value: fieldValue,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                    value: "",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: placeholder
                    })
                }),
                children
            ]
        })
    });
};




const $c3e612ccfdfddfa8$export$c106feaf2af7a141 = ({ id: id = "licenceType", required: required = false, onChanged: onChanged, enabled: enabled = true, disabled: disabled = false })=>{
    const language = (0, $e8ef5ee6ff8929e0$export$c1fd9f444a3dc711)();
    const { data: licenceTypes, isLoading: isLoading } = (0, $0e529258adfac30f$export$6c8e7212a9bf390a)({
        language: language
    }, {
        query: {
            enabled: enabled
        }
    });
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2), {});
    if (!licenceTypes) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e93eb28e913cc8a3$export$40d561691c647821), {
        id: id,
        label: "Licence type",
        required: required,
        placeholder: "Select a licence",
        onChanged: onChanged,
        disabled: disabled,
        errors: required ? {
            required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                children: "Please select a licence type"
            })
        } : {},
        children: licenceTypes.results.map(({ licence_type_id: licence_type_id, name: name }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: licence_type_id,
                children: name
            }, index))
    });
};



// src/use-initial-animation-state.tsx

var $acw62 = parcelRequire("acw62");
function $9bb056215cec79e2$export$c4008d6206288921(isChecked) {
    const [previousIsChecked, setPreviousIsChecked] = (0, $acw62.useState)(isChecked);
    const [shouldAnimate, setShouldAnimate] = (0, $acw62.useState)(false);
    if (isChecked !== previousIsChecked) {
        setShouldAnimate(true);
        setPreviousIsChecked(isChecked);
    }
    return shouldAnimate;
}


// src/checkbox-context.ts

var [$ae58e1ac9bf52df5$export$95a3c27e07a551c3, $ae58e1ac9bf52df5$export$5575526870d5c2ae] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "CheckboxGroupContext",
    strict: false
});


// src/checkbox-icon.tsx


function $5a1eea42d2b7d764$var$CheckIcon(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).svg, {
        width: "1.2em",
        viewBox: "0 0 12 10",
        style: {
            fill: "none",
            strokeWidth: 2,
            stroke: "currentColor",
            strokeDasharray: 16
        },
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polyline", {
            points: "1.5 6 4.5 9 10.5 1"
        })
    });
}
function $5a1eea42d2b7d764$var$IndeterminateIcon(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).svg, {
        width: "1.2em",
        viewBox: "0 0 24 24",
        style: {
            stroke: "currentColor",
            strokeWidth: 4
        },
        ...props,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("line", {
            x1: "21",
            x2: "3",
            y1: "12",
            y2: "12"
        })
    });
}
function $5a1eea42d2b7d764$export$c0a1936901b0e55(props) {
    const { isIndeterminate: isIndeterminate, isChecked: isChecked, ...rest } = props;
    const BaseIcon = isIndeterminate ? $5a1eea42d2b7d764$var$IndeterminateIcon : $5a1eea42d2b7d764$var$CheckIcon;
    return isChecked || isIndeterminate ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(BaseIcon, {
            ...rest
        })
    }) : null;
}


// src/use-checkbox.ts






// src/visually-hidden.style.ts
var $2900a4716790e66d$export$8fecac46448b5689 = {
    border: "0",
    clip: "rect(0, 0, 0, 0)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};


// src/index.ts
var $10f5b85675c7b32e$var$hasSetup = false;
var $10f5b85675c7b32e$var$modality = null;
var $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
var $10f5b85675c7b32e$var$hasBlurredWindowRecently = false;
var $10f5b85675c7b32e$var$handlers = /* @__PURE__ */ new Set();
function $10f5b85675c7b32e$var$trigger(modality2, event) {
    $10f5b85675c7b32e$var$handlers.forEach((handler)=>handler(modality2, event));
}
var $10f5b85675c7b32e$var$isMac = typeof window !== "undefined" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : false;
function $10f5b85675c7b32e$var$isValidKey(e) {
    return !(e.metaKey || !$10f5b85675c7b32e$var$isMac && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $10f5b85675c7b32e$var$onKeyboardEvent(event) {
    $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
    if ($10f5b85675c7b32e$var$isValidKey(event)) {
        $10f5b85675c7b32e$var$modality = "keyboard";
        $10f5b85675c7b32e$var$trigger("keyboard", event);
    }
}
function $10f5b85675c7b32e$var$onPointerEvent(event) {
    $10f5b85675c7b32e$var$modality = "pointer";
    if (event.type === "mousedown" || event.type === "pointerdown") {
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        const target = event.composedPath ? event.composedPath()[0] : event.target;
        let matches = false;
        try {
            matches = target.matches(":focus-visible");
        } catch  {}
        if (matches) return;
        $10f5b85675c7b32e$var$trigger("pointer", event);
    }
}
function $10f5b85675c7b32e$var$isVirtualClick(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    return event.detail === 0 && !event.pointerType;
}
function $10f5b85675c7b32e$var$onClickEvent(e) {
    if ($10f5b85675c7b32e$var$isVirtualClick(e)) {
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        $10f5b85675c7b32e$var$modality = "virtual";
    }
}
function $10f5b85675c7b32e$var$onWindowFocus(event) {
    if (event.target === window || event.target === document) return;
    if (!$10f5b85675c7b32e$var$hasEventBeforeFocus && !$10f5b85675c7b32e$var$hasBlurredWindowRecently) {
        $10f5b85675c7b32e$var$modality = "virtual";
        $10f5b85675c7b32e$var$trigger("virtual", event);
    }
    $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
    $10f5b85675c7b32e$var$hasBlurredWindowRecently = false;
}
function $10f5b85675c7b32e$var$onWindowBlur() {
    $10f5b85675c7b32e$var$hasEventBeforeFocus = false;
    $10f5b85675c7b32e$var$hasBlurredWindowRecently = true;
}
function $10f5b85675c7b32e$var$isFocusVisible() {
    return $10f5b85675c7b32e$var$modality !== "pointer";
}
function $10f5b85675c7b32e$var$setupGlobalFocusEvents() {
    if (typeof window === "undefined" || $10f5b85675c7b32e$var$hasSetup) return;
    const { focus: focus } = HTMLElement.prototype;
    HTMLElement.prototype.focus = function focusElement(...args) {
        $10f5b85675c7b32e$var$hasEventBeforeFocus = true;
        focus.apply(this, args);
    };
    document.addEventListener("keydown", $10f5b85675c7b32e$var$onKeyboardEvent, true);
    document.addEventListener("keyup", $10f5b85675c7b32e$var$onKeyboardEvent, true);
    document.addEventListener("click", $10f5b85675c7b32e$var$onClickEvent, true);
    window.addEventListener("focus", $10f5b85675c7b32e$var$onWindowFocus, true);
    window.addEventListener("blur", $10f5b85675c7b32e$var$onWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        document.addEventListener("pointerdown", $10f5b85675c7b32e$var$onPointerEvent, true);
        document.addEventListener("pointermove", $10f5b85675c7b32e$var$onPointerEvent, true);
        document.addEventListener("pointerup", $10f5b85675c7b32e$var$onPointerEvent, true);
    } else {
        document.addEventListener("mousedown", $10f5b85675c7b32e$var$onPointerEvent, true);
        document.addEventListener("mousemove", $10f5b85675c7b32e$var$onPointerEvent, true);
        document.addEventListener("mouseup", $10f5b85675c7b32e$var$onPointerEvent, true);
    }
    $10f5b85675c7b32e$var$hasSetup = true;
}
function $10f5b85675c7b32e$export$920b4983565c6f4d(fn) {
    $10f5b85675c7b32e$var$setupGlobalFocusEvents();
    fn($10f5b85675c7b32e$var$isFocusVisible());
    const handler = ()=>fn($10f5b85675c7b32e$var$isFocusVisible());
    $10f5b85675c7b32e$var$handlers.add(handler);
    return ()=>{
        $10f5b85675c7b32e$var$handlers.delete(handler);
    };
}
function $10f5b85675c7b32e$export$1238a82db5699f92(fn) {
    $10f5b85675c7b32e$var$setupGlobalFocusEvents();
    fn($10f5b85675c7b32e$var$modality);
    const handler = ()=>fn($10f5b85675c7b32e$var$modality);
    $10f5b85675c7b32e$var$handlers.add(handler);
    return ()=>{
        $10f5b85675c7b32e$var$handlers.delete(handler);
    };
}
function $10f5b85675c7b32e$export$8397ddfc504fdb9a(value) {
    $10f5b85675c7b32e$var$modality = value;
    $10f5b85675c7b32e$var$trigger(value, null);
}
function $10f5b85675c7b32e$export$630ff653c5ada6a9() {
    return $10f5b85675c7b32e$var$modality;
}



var $acw62 = parcelRequire("acw62");
// ../../utilities/object-utils/src/omit.ts
function $1b556f567c5dae15$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
function $1b556f567c5dae15$export$e375f10ce42261c5(props = {}) {
    const formControlProps = (0, $6129e3e578a61ce7$export$1819803dd567b95f)(props);
    const { isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, isInvalid: isInvalid, id: id, onBlur: onBlur, onFocus: onFocus, "aria-describedby": ariaDescribedBy } = formControlProps;
    const { defaultChecked: defaultChecked, isChecked: checkedProp, isFocusable: isFocusable, onChange: onChange, isIndeterminate: isIndeterminate, name: name, value: value, tabIndex: tabIndex, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-invalid": ariaInvalid, ...rest } = props;
    const htmlProps = $1b556f567c5dae15$var$omit(rest, [
        "isDisabled",
        "isReadOnly",
        "isRequired",
        "isInvalid",
        "id",
        "onBlur",
        "onFocus",
        "aria-describedby"
    ]);
    const onChangeProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChange);
    const onBlurProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onBlur);
    const onFocusProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onFocus);
    const [isFocusVisible, setIsFocusVisible] = (0, $acw62.useState)(false);
    const [isFocused, setFocused] = (0, $acw62.useState)(false);
    const [isHovered, setHovered] = (0, $acw62.useState)(false);
    const [isActive, setActive] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        return (0, $10f5b85675c7b32e$export$920b4983565c6f4d)(setIsFocusVisible);
    }, []);
    const inputRef = (0, $acw62.useRef)(null);
    const [rootIsLabelElement, setRootIsLabelElement] = (0, $acw62.useState)(true);
    const [checkedState, setCheckedState] = (0, $acw62.useState)(!!defaultChecked);
    const isControlled = checkedProp !== void 0;
    const isChecked = isControlled ? checkedProp : checkedState;
    const handleChange = (0, $acw62.useCallback)((event)=>{
        if (isReadOnly || isDisabled) {
            event.preventDefault();
            return;
        }
        if (!isControlled) {
            if (isChecked) setCheckedState(event.target.checked);
            else setCheckedState(isIndeterminate ? true : event.target.checked);
        }
        onChangeProp == null || onChangeProp(event);
    }, [
        isReadOnly,
        isDisabled,
        isChecked,
        isControlled,
        isIndeterminate,
        onChangeProp
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (inputRef.current) inputRef.current.indeterminate = Boolean(isIndeterminate);
    }, [
        isIndeterminate
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (isDisabled) setFocused(false);
    }, [
        isDisabled,
        setFocused
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        const el = inputRef.current;
        if (!(el == null ? void 0 : el.form)) return;
        el.form.onreset = ()=>{
            setCheckedState(!!defaultChecked);
        };
    }, []);
    const trulyDisabled = isDisabled && !isFocusable;
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.key === " ") setActive(true);
    }, [
        setActive
    ]);
    const onKeyUp = (0, $acw62.useCallback)((event)=>{
        if (event.key === " ") setActive(false);
    }, [
        setActive
    ]);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!inputRef.current) return;
        const notInSync = inputRef.current.checked !== isChecked;
        if (notInSync) setCheckedState(inputRef.current.checked);
    }, [
        inputRef.current
    ]);
    const getCheckboxProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>{
        const onPressDown = (event)=>{
            if (isFocused) event.preventDefault();
            setActive(true);
        };
        return {
            ...props2,
            ref: forwardedRef,
            "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isActive),
            "data-hover": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isHovered),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-focus": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused),
            "data-focus-visible": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isFocused && isFocusVisible),
            "data-indeterminate": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isIndeterminate),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid),
            "data-readonly": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isReadOnly),
            "aria-hidden": true,
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, onPressDown),
            onMouseUp: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseUp, ()=>setActive(false)),
            onMouseEnter: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseEnter, ()=>setHovered(true)),
            onMouseLeave: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseLeave, ()=>setHovered(false))
        };
    }, [
        isActive,
        isChecked,
        isDisabled,
        isFocused,
        isFocusVisible,
        isHovered,
        isIndeterminate,
        isInvalid,
        isReadOnly
    ]);
    const getRootProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...htmlProps,
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(forwardedRef, (node)=>{
                if (!node) return;
                setRootIsLabelElement(node.tagName === "LABEL");
            }),
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, ()=>{
                var _a;
                if (!rootIsLabelElement) {
                    (_a = inputRef.current) == null || _a.click();
                    requestAnimationFrame(()=>{
                        var _a2;
                        (_a2 = inputRef.current) == null || _a2.focus({
                            preventScroll: true
                        });
                    });
                }
            }),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid)
        }), [
        htmlProps,
        isDisabled,
        isChecked,
        isInvalid,
        rootIsLabelElement
    ]);
    const getInputProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>{
        return {
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(inputRef, forwardedRef),
            type: "checkbox",
            name: name,
            value: value,
            id: id,
            tabIndex: tabIndex,
            onChange: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onChange, handleChange),
            onBlur: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onBlur, onBlurProp, ()=>setFocused(false)),
            onFocus: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onFocus, onFocusProp, ()=>setFocused(true)),
            onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onKeyUp: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyUp, onKeyUp),
            required: isRequired,
            checked: isChecked,
            disabled: trulyDisabled,
            readOnly: isReadOnly,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
            "aria-describedby": ariaDescribedBy,
            "aria-disabled": isDisabled,
            style: (0, $2900a4716790e66d$export$8fecac46448b5689)
        };
    }, [
        name,
        value,
        id,
        handleChange,
        onBlurProp,
        onFocusProp,
        onKeyDown,
        onKeyUp,
        isRequired,
        isChecked,
        trulyDisabled,
        isReadOnly,
        ariaLabel,
        ariaLabelledBy,
        ariaInvalid,
        isInvalid,
        ariaDescribedBy,
        isDisabled,
        tabIndex
    ]);
    const getLabelProps = (0, $acw62.useCallback)((props2 = {}, forwardedRef = null)=>({
            ...props2,
            ref: forwardedRef,
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, $1b556f567c5dae15$var$stopEvent),
            "data-disabled": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isDisabled),
            "data-checked": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isChecked),
            "data-invalid": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isInvalid)
        }), [
        isChecked,
        isDisabled,
        isInvalid
    ]);
    const state = {
        isInvalid: isInvalid,
        isFocused: isFocused,
        isChecked: isChecked,
        isActive: isActive,
        isHovered: isHovered,
        isIndeterminate: isIndeterminate,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired
    };
    return {
        state: state,
        getRootProps: getRootProps,
        getCheckboxProps: getCheckboxProps,
        getInputProps: getInputProps,
        getLabelProps: getLabelProps,
        htmlProps: htmlProps
    };
}
function $1b556f567c5dae15$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}





var $acw62 = parcelRequire("acw62");

var $d939ff534527fb4c$var$controlStyles = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "top",
    userSelect: "none",
    flexShrink: 0
};
var $d939ff534527fb4c$var$rootStyles = {
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    position: "relative"
};
var $d939ff534527fb4c$var$checkAnim = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0,
        strokeDashoffset: 16,
        transform: "scale(0.95)"
    },
    to: {
        opacity: 1,
        strokeDashoffset: 0,
        transform: "scale(1)"
    }
});
var $d939ff534527fb4c$var$indeterminateOpacityAnim = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var $d939ff534527fb4c$var$indeterminateScaleAnim = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        transform: "scaleX(0.65)"
    },
    to: {
        transform: "scaleX(1)"
    }
});
var $d939ff534527fb4c$export$48513f6b9f8ce62d = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Checkbox2(props, ref) {
    const group = (0, $ae58e1ac9bf52df5$export$5575526870d5c2ae)();
    const mergedProps = {
        ...group,
        ...props
    };
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Checkbox", mergedProps);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { spacing: spacing = "0.5rem", className: className, children: children, iconColor: iconColor, iconSize: iconSize, icon: icon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5a1eea42d2b7d764$export$c0a1936901b0e55), {}), isChecked: isCheckedProp, isDisabled: isDisabled = group == null ? void 0 : group.isDisabled, onChange: onChangeProp, inputProps: inputProps, ...rest } = ownProps;
    let isChecked = isCheckedProp;
    if ((group == null ? void 0 : group.value) && ownProps.value) isChecked = group.value.includes(ownProps.value);
    let onChange = onChangeProp;
    if ((group == null ? void 0 : group.onChange) && ownProps.value) onChange = (0, $abe97432afb3d989$export$9dd9a52f2dd5b9ce)(group.onChange, onChangeProp);
    const { state: state, getInputProps: getInputProps, getCheckboxProps: getCheckboxProps, getLabelProps: getLabelProps, getRootProps: getRootProps } = (0, $1b556f567c5dae15$export$e375f10ce42261c5)({
        ...rest,
        isDisabled: isDisabled,
        isChecked: isChecked,
        onChange: onChange
    });
    const shouldAnimate = (0, $9bb056215cec79e2$export$c4008d6206288921)(state.isChecked);
    const iconStyles = (0, $acw62.useMemo)(()=>({
            animation: !shouldAnimate ? void 0 : state.isIndeterminate ? `${$d939ff534527fb4c$var$indeterminateOpacityAnim} 20ms linear, ${$d939ff534527fb4c$var$indeterminateScaleAnim} 200ms linear` : `${$d939ff534527fb4c$var$checkAnim} 200ms linear`,
            fontSize: iconSize,
            color: iconColor,
            ...styles.icon
        }), [
        iconColor,
        iconSize,
        shouldAnimate,
        state.isIndeterminate,
        styles.icon
    ]);
    const clonedIcon = (0, $acw62.cloneElement)(icon, {
        __css: iconStyles,
        isIndeterminate: state.isIndeterminate,
        isChecked: state.isChecked
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).label, {
        __css: {
            ...$d939ff534527fb4c$var$rootStyles,
            ...styles.container
        },
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-checkbox", className),
        ...getRootProps(),
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "chakra-checkbox__input",
                ...getInputProps(inputProps, ref)
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
                __css: {
                    ...$d939ff534527fb4c$var$controlStyles,
                    ...styles.control
                },
                className: "chakra-checkbox__control",
                ...getCheckboxProps(),
                children: clonedIcon
            }),
            children && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
                className: "chakra-checkbox__label",
                ...getLabelProps(),
                __css: {
                    marginStart: spacing,
                    ...styles.label
                },
                children: children
            })
        ]
    });
});
$d939ff534527fb4c$export$48513f6b9f8ce62d.displayName = "Checkbox";


// src/use-checkbox-group.ts

// src/index.ts

var $acw62 = parcelRequire("acw62");

function $4795b7ced84aa3c2$export$7301e09313e4cf1b(prop, state) {
    const controlled = typeof prop !== "undefined";
    const value = controlled ? prop : state;
    return (0, $acw62.useMemo)(()=>[
            controlled,
            value
        ], [
        controlled,
        value
    ]);
}
function $4795b7ced84aa3c2$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(shouldUpdate);
    const [uncontrolledState, setUncontrolledState] = (0, $acw62.useState)(defaultValue);
    const controlled = valueProp !== void 0;
    const value = controlled ? valueProp : uncontrolledState;
    const setValue = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)((next)=>{
        const setter = next;
        const nextValue = typeof next === "function" ? setter(value) : next;
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!controlled) setUncontrolledState(nextValue);
        onChangeProp(nextValue);
    }, [
        controlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        setValue
    ];
}




var $acw62 = parcelRequire("acw62");
function $e5791f189f39717d$var$isInputEvent(value) {
    return value && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value) && (0, $abe97432afb3d989$export$a6cdc56e425d0d0a)(value.target);
}
function $e5791f189f39717d$export$49ff6f28c54f1cbe(props = {}) {
    const { defaultValue: defaultValue, value: valueProp, onChange: onChange, isDisabled: isDisabled, isNative: isNative } = props;
    const onChangeProp = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onChange);
    const [value, setValue] = (0, $4795b7ced84aa3c2$export$6f32135080cb4c3)({
        value: valueProp,
        defaultValue: defaultValue || [],
        onChange: onChangeProp
    });
    const handleChange = (0, $acw62.useCallback)((eventOrValue)=>{
        if (!value) return;
        const isChecked = $e5791f189f39717d$var$isInputEvent(eventOrValue) ? eventOrValue.target.checked : !value.includes(eventOrValue);
        const selectedValue = $e5791f189f39717d$var$isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
        const nextValue = isChecked ? [
            ...value,
            selectedValue
        ] : value.filter((v)=>String(v) !== String(selectedValue));
        setValue(nextValue);
    }, [
        setValue,
        value
    ]);
    const getCheckboxProps = (0, $acw62.useCallback)((props2 = {})=>{
        const checkedKey = isNative ? "checked" : "isChecked";
        return {
            ...props2,
            [checkedKey]: value.some((val)=>String(props2.value) === String(val)),
            onChange: handleChange
        };
    }, [
        handleChange,
        isNative,
        value
    ]);
    return {
        value: value,
        isDisabled: isDisabled,
        onChange: handleChange,
        setValue: setValue,
        getCheckboxProps: getCheckboxProps
    };
}



var $acw62 = parcelRequire("acw62");

function $1ac45b92db997ce2$export$4aa08d5625cb8ead(props) {
    const { colorScheme: colorScheme, size: size, variant: variant, children: children, isDisabled: isDisabled } = props;
    const { value: value, onChange: onChange } = (0, $e5791f189f39717d$export$49ff6f28c54f1cbe)(props);
    const group = (0, $acw62.useMemo)(()=>({
            size: size,
            onChange: onChange,
            colorScheme: colorScheme,
            value: value,
            variant: variant,
            isDisabled: isDisabled
        }), [
        size,
        onChange,
        colorScheme,
        value,
        variant,
        isDisabled
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $ae58e1ac9bf52df5$export$95a3c27e07a551c3), {
        value: group,
        children: children
    });
}
$1ac45b92db997ce2$export$4aa08d5625cb8ead.displayName = "CheckboxGroup";







const $64ed766538e818d3$export$fef6af226eb2815b = ({ id: id = "procedureTypes", required: required = false, enabled: enabled = true })=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const language = (0, $e8ef5ee6ff8929e0$export$c1fd9f444a3dc711)();
    const { register: register, getValues: getValues } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const { data: procedureTypes, isLoading: isLoading } = (0, $0e529258adfac30f$export$4be4fb61d64ae3de)({
        language: language
    }, {
        query: {
            enabled: enabled
        }
    });
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2), {});
    if (!procedureTypes) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dd005f903a28199$export$fb9f58ebe9de6283), {
        id: id,
        label: "",
        required: required,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cd6270424eaeb4d4$export$fe5d99d8691b3f62), {
            as: "fieldset",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3866dc6a93af5f$export$842aba50ed0ce9d7), {
                    as: "legend",
                    children: t("Procedure types")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ac45b92db997ce2$export$4aa08d5625cb8ead), {
                    defaultValue: getValues(id),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                        align: "start",
                        children: procedureTypes.results.map(({ name: name, procedure_type_id: procedure_type_id }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d939ff534527fb4c$export$48513f6b9f8ce62d), {
                                ...register(id, {
                                    required: required ? t("Please select the procedure types for your organisation") : false
                                }),
                                value: procedure_type_id,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: name
                                })
                            }, index))
                    })
                })
            ]
        })
    });
};



const $aa1c78deb16de548$var$DEFAULT_ADDRESS = {
    "associated_business_name": "",
    "address_line1": "",
    "address_line2": "",
    "town": "",
    "postcode": ""
};
const $aa1c78deb16de548$export$d7e66ef6999696cf = {
    "issue_date": "",
    "licence_number": "",
    "licence_type_id": "",
    "procedure_type_ids": [],
    "internal_notes": "",
    "local_authority_id": "abertawe",
    "practitioner_name": null,
    "addresses": [
        $aa1c78deb16de548$var$DEFAULT_ADDRESS
    ],
    "business_name": null,
    "certificate_holder_name": null,
    "number_of_workstations": null,
    "vehicle_registration_details": null,
    "vehicle_description": null
};
const $aa1c78deb16de548$export$4d3a9952c27de77 = {
    "local_authority_id": "abertawe",
    "practitioner_name": null,
    "addresses": [
        {
            "associated_business_name": undefined,
            "address_line1": undefined,
            "address_line2": undefined,
            "town": undefined,
            "postcode": undefined
        }
    ],
    "business_name": null,
    "certificate_holder_name": null,
    "number_of_workstations": null,
    "vehicle_registration_details": null,
    "vehicle_description": null
};











const $625d87e572640047$export$c895081d03baf31e = ({ id: id, required: required, label: label, placeholder: placeholder = "", errors: errors })=>{
    const { register: register } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const DEFAULT_ERRORS = {
        required: required ? (0, $1e087ff174cd7c1d$export$d8bd0967cb58683)[(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).EMPTY_INPUT_VALIDATION] : false
    };
    const ERRORS = !errors ? DEFAULT_ERRORS : errors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dd005f903a28199$export$fb9f58ebe9de6283), {
        id: id,
        required: required,
        label: t(label),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ef127d438f0ac5$export$f5b8910cec6cf069), {
            ...register(id, ERRORS),
            placeholder: t(placeholder) || placeholder
        })
    });
};



const $7fb6691839270274$export$9c982798ae75228c = ({ id: id = "licenceNumber", required: required = false })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
        id: id,
        required: required,
        label: "Licence number",
        placeholder: "Enter the licence number",
        errors: {
            required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                children: "Please enter the licence number"
            })
        }
    });
};


const $eba412d90415ed17$export$37c8d0d37cf2f536 = ()=>{
    const { setStep: setStep } = (0, $acw62.useContext)((0, $bdaa2243693f9b25$export$e2bd290781d68bf1));
    const { getValues: getValues, reset: reset } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const licenceTypeIdChanged = (0, $acw62.useRef)(false);
    const checkLicenceChanged = (value)=>{
        licenceTypeIdChanged.current = (0, $641772106617d27d$export$2b215ce73bbb8647)(value) !== (0, $641772106617d27d$export$2b215ce73bbb8647)(getValues("licence_type_id"));
    };
    const onSubmit = ()=>{
        if (licenceTypeIdChanged.current) reset((formValues)=>({
                ...formValues,
                ...(0, $aa1c78deb16de548$export$4d3a9952c27de77)
            }));
        setStep((0, $426f534707ae6ced$export$acae14b34103071f).ADDITIONAL_DETAILS);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3eb35d4abe9e46$export$1f54913ccc4368b1), {
        height: "100%",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $76821c5fbe903325$export$a26deed65a14d052), {
            header: "Create a licence",
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3e612ccfdfddfa8$export$c106feaf2af7a141), {
                    id: "licence_type_id",
                    required: true,
                    onChanged: checkLicenceChanged
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7fb6691839270274$export$9c982798ae75228c), {
                    id: "licence_number",
                    required: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64ed766538e818d3$export$fef6af226eb2815b), {
                    id: "procedure_type_ids",
                    required: true
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f992dc2156f2c1e$export$5d92d9428fdc106b), {
                    width: "50%",
                    id: "issue_date",
                    required: true
                })
            ]
        })
    });
};





const $e75477aa8f59835a$export$359105212d118848 = ({ index: index = 0, isAssociated: isAssociated = true })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            isAssociated ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: `addresses.${index}.associated_business_name`,
                label: "Associated business name",
                placeholder: "Enter associated business name here"
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "business_name",
                required: true,
                label: "Business name",
                placeholder: "Enter business name here"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: `addresses.${index}.address_line1`,
                required: true,
                label: "Address line 1",
                placeholder: "Enter address line 1 here",
                errors: {
                    required: "Please enter the business address"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: `addresses.${index}.address_line2`,
                label: "Address line 2",
                placeholder: "Enter address line 2 here"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: `addresses.${index}.town`,
                required: true,
                label: "Town / city",
                placeholder: "Enter town / city here",
                errors: {
                    required: "Please enter the business town / city"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: `addresses.${index}.postcode`,
                required: true,
                label: "Postcode",
                placeholder: "Enter postcode here",
                errors: {
                    required: "Please enter the business postcode"
                }
            })
        ]
    });
};




// src/textarea.tsx




// ../../utilities/object-utils/src/index.ts
function $61888d9ecc0b026f$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
var $61888d9ecc0b026f$var$omitted = [
    "h",
    "minH",
    "height",
    "minHeight"
];
var $61888d9ecc0b026f$export$379139ebc1c2b235 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Textarea", props);
    const { className: className, rows: rows, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const textareaProps = (0, $6129e3e578a61ce7$export$62ecd8ad1bbe1a18)(rest);
    const textareaStyles = rows ? $61888d9ecc0b026f$var$omit(styles, $61888d9ecc0b026f$var$omitted) : styles;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).textarea, {
        ref: ref,
        rows: rows,
        ...textareaProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-textarea", className),
        __css: textareaStyles
    });
});
$61888d9ecc0b026f$export$379139ebc1c2b235.displayName = "Textarea";






const $132d76dd771a3ff6$export$3237a405b221b07 = ({ id: id, required: required, label: label, placeholder: placeholder = "", errors: errors })=>{
    const { register: register } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const DEFAULT_ERROR = {
        required: required ? (0, $1e087ff174cd7c1d$export$d8bd0967cb58683)[(0, $6145d3befdc3de2c$export$d4e71bc0b80dc0fb).EMPTY_INPUT_VALIDATION] : false
    };
    const ERRORS = !errors ? DEFAULT_ERROR : errors;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dd005f903a28199$export$fb9f58ebe9de6283), {
        id: id,
        required: required,
        label: label,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61888d9ecc0b026f$export$379139ebc1c2b235), {
            ...register(id, ERRORS),
            placeholder: placeholder,
            resize: "vertical"
        })
    });
};







var $acw62 = parcelRequire("acw62");
function $a154ce245eea8e38$export$a407b657d3044108(options) {
    const { theme: theme } = (0, $fe369539e4cd5c80$export$a513a93efd9ab8a7)();
    const defaultOptions = (0, $bec5422162fb9c65$export$7c4af276256dc908)();
    return (0, $acw62.useMemo)(()=>(0, $eb1addcd21d45ee8$export$f3af62d19eb14261)(theme.direction, {
            ...defaultOptions,
            ...options
        }), [
        options,
        theme.direction,
        defaultOptions
    ]);
}
var $a154ce245eea8e38$export$6c81af436bf0e329 = $a154ce245eea8e38$export$a407b657d3044108;




var $acw62 = parcelRequire("acw62");
const $78df7481edc561d7$export$eed022e50baffed5 = {
    PROCEDURE_TYPES: "/procedure-types",
    LOCAL_AUTHORITIES: "/local-authorities",
    LICENCE_TYPES: "/licence-types",
    LICENCES: "/licences",
    ORGANISATIONS: "/organisations"
};









const $0bc92389da5ca8f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0bc92389da5ca8f2$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $0bc92389da5ca8f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $46af55383084911e$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $63c01f9040a729a9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $63c01f9040a729a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $63c01f9040a729a9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63c01f9040a729a9$export$cbf60ecb96cbb82f = {
    date: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $f529b3bee3f6d835$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f529b3bee3f6d835$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$f529b3bee3f6d835$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $39a1e2b6239b09b3$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $eb9cac2ee97a0b54$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $eb9cac2ee97a0b54$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eb9cac2ee97a0b54$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $eb9cac2ee97a0b54$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $eb9cac2ee97a0b54$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $eb9cac2ee97a0b54$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $eb9cac2ee97a0b54$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eb9cac2ee97a0b54$var$ordinalNumber,
    era: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eb9cac2ee97a0b54$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $e4df69a5a2d494a3$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e4df69a5a2d494a3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e4df69a5a2d494a3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e4df69a5a2d494a3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e4df69a5a2d494a3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $2594a2c0202dabc6$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d2fa28259adb3ab1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2fa28259adb3ab1$var$parseOrdinalNumberPattern = /\d+/i;
const $d2fa28259adb3ab1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2fa28259adb3ab1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2fa28259adb3ab1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2fa28259adb3ab1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2fa28259adb3ab1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2fa28259adb3ab1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2fa28259adb3ab1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2fa28259adb3ab1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2fa28259adb3ab1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $2594a2c0202dabc6$export$fdaf2fd6d7edde95)({
        matchPattern: $d2fa28259adb3ab1$var$matchOrdinalNumberPattern,
        parsePattern: $d2fa28259adb3ab1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $cd0c27002eb93234$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $0bc92389da5ca8f2$export$2c14ff85d6318973),
    formatLong: (0, $63c01f9040a729a9$export$cbf60ecb96cbb82f),
    formatRelative: (0, $f529b3bee3f6d835$export$8fbbfd65594f46a0),
    localize: (0, $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63),
    match: (0, $d2fa28259adb3ab1$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$cd0c27002eb93234$export$2e2bcd8739ae039 = $cd0c27002eb93234$export$137380d9ce54f7f;


let $39440020b58e1ef8$var$defaultOptions = {};
function $39440020b58e1ef8$export$430a3269e24b912e() {
    return $39440020b58e1ef8$var$defaultOptions;
}
function $39440020b58e1ef8$export$95365be1b0704abc(newOptions) {
    $39440020b58e1ef8$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8540a44f59a4af84$export$dfd9b671c89acc8e = 7;
const $8540a44f59a4af84$export$3913210603d8e9ae = 365.2425;
const $8540a44f59a4af84$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $8540a44f59a4af84$export$4dec998e48f9c246 = -$8540a44f59a4af84$export$81caae6e1cc7a622;
const $8540a44f59a4af84$export$4fad13613e88edc8 = 604800000;
const $8540a44f59a4af84$export$b76b1809a2898f9a = 86400000;
const $8540a44f59a4af84$export$91246f0b9bd9beff = 60000;
const $8540a44f59a4af84$export$7f72910d6dfd237a = 3600000;
const $8540a44f59a4af84$export$397c2d5776aa9055 = 1000;
const $8540a44f59a4af84$export$3633035e63cee86a = 525600;
const $8540a44f59a4af84$export$ab7da2ccd1075c38 = 43200;
const $8540a44f59a4af84$export$2423174df8cd3cd2 = 1440;
const $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = 60;
const $8540a44f59a4af84$export$3c58128db900d44e = 3;
const $8540a44f59a4af84$export$80d7e435f744f319 = 12;
const $8540a44f59a4af84$export$4db7641526e3241f = 4;
const $8540a44f59a4af84$export$698aec755e92c695 = 3600;
const $8540a44f59a4af84$export$a77c1a7ebebe2a5a = 60;
const $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$export$698aec755e92c695 * 24;
const $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$export$815a9362476d2fe3 * 7;
const $8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$export$815a9362476d2fe3 * $8540a44f59a4af84$export$3913210603d8e9ae;
const $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$export$7271e9e3478110d1 / 12;
const $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$export$8e6600bbdee7dabb * 3;
const $8540a44f59a4af84$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $abb9adbdb26342b3$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $8540a44f59a4af84$export$2a7b97929c48d47d) in date) return date[0, $8540a44f59a4af84$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$abb9adbdb26342b3$export$2e2bcd8739ae039 = $abb9adbdb26342b3$export$ead8a1812b171991;


function $231bfb8d72679740$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$231bfb8d72679740$export$2e2bcd8739ae039 = $231bfb8d72679740$export$e67a095c620b86fe;


function $92dc0740ffabe180$export$113002b5eff6e430(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $002c8181c95d5119$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $abb9adbdb26342b3$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $b6caff0bf13dcaf5$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$b6caff0bf13dcaf5$export$2e2bcd8739ae039 = $b6caff0bf13dcaf5$export$63fa379ae8a9ba2;


function $737f54e9ffaddc15$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $92dc0740ffabe180$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $92dc0740ffabe180$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $8540a44f59a4af84$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$737f54e9ffaddc15$export$2e2bcd8739ae039 = $737f54e9ffaddc15$export$4a02e9c37dab4871;



function $29cc086f79701cd9$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$29cc086f79701cd9$export$2e2bcd8739ae039 = $29cc086f79701cd9$export$f91e89d3d0406102;



function $306b88ce50904f9c$export$d3b42cd8452deec(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $29cc086f79701cd9$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$306b88ce50904f9c$export$2e2bcd8739ae039 = $306b88ce50904f9c$export$d3b42cd8452deec;





function $61f11f7a26b3ab78$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$61f11f7a26b3ab78$export$2e2bcd8739ae039 = $61f11f7a26b3ab78$export$42c81a444fbfb5d4;


function $1c9d32c6cb108460$export$6173213f95a4431e(date, options) {
    return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$1c9d32c6cb108460$export$2e2bcd8739ae039 = $1c9d32c6cb108460$export$6173213f95a4431e;






function $c95dff76bf2f692a$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$c95dff76bf2f692a$export$2e2bcd8739ae039 = $c95dff76bf2f692a$export$3dbc52535f6f8fcc;



function $3b2e6199275b27d6$export$236bdfa374eb69a9(date, options) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$3b2e6199275b27d6$export$2e2bcd8739ae039 = $3b2e6199275b27d6$export$236bdfa374eb69a9;



function $83e11b0db4cec366$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $1c9d32c6cb108460$export$6173213f95a4431e)(_date) - +(0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8540a44f59a4af84$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$83e11b0db4cec366$export$2e2bcd8739ae039 = $83e11b0db4cec366$export$7cabdc5698b63e2f;











function $0170e230c8468ebb$export$12d572480ceb6e58(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$0170e230c8468ebb$export$2e2bcd8739ae039 = $0170e230c8468ebb$export$12d572480ceb6e58;



function $ac7640a7ade5a435$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$ac7640a7ade5a435$export$2e2bcd8739ae039 = $ac7640a7ade5a435$export$bb7b45bb8e74da0f;



function $11b38d723fd57381$export$efe19b760242b2fc(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(_date, options) - +(0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8540a44f59a4af84$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$11b38d723fd57381$export$2e2bcd8739ae039 = $11b38d723fd57381$export$efe19b760242b2fc;



function $03d75ed55eeb99fa$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $71a5e81f1193b7a8$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $008fe800ab658844$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $008fe800ab658844$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $306b88ce50904f9c$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $008fe800ab658844$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(minutes, 2);
}
function $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $008fe800ab658844$var$formatTimezone(offset, delimiter);
}
function $008fe800ab658844$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $54cd66db3e5e74df$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $54cd66db3e5e74df$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $54cd66db3e5e74df$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $54cd66db3e5e74df$var$timeLongFormatter(timePattern, formatLong));
};
const $54cd66db3e5e74df$export$70cc8fd02856fd58 = {
    p: $54cd66db3e5e74df$var$timeLongFormatter,
    P: $54cd66db3e5e74df$var$dateTimeLongFormatter
};


const $7e8a5b0b77bf77b9$var$dayOfYearTokenRE = /^D+$/;
const $7e8a5b0b77bf77b9$var$weekYearTokenRE = /^Y+$/;
const $7e8a5b0b77bf77b9$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7e8a5b0b77bf77b9$export$c6cc36aa33304772(token) {
    return $7e8a5b0b77bf77b9$var$dayOfYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1(token) {
    return $7e8a5b0b77bf77b9$var$weekYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $7e8a5b0b77bf77b9$var$message(token, format, input);
    console.warn(_message);
    if ($7e8a5b0b77bf77b9$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7e8a5b0b77bf77b9$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $1896b5e28554d57b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$1896b5e28554d57b$export$2e2bcd8739ae039 = $1896b5e28554d57b$export$871608497c498473;



function $f2a682b251363bc2$export$1ea939691cdc45b8(date) {
    return !(!(0, $1896b5e28554d57b$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $231bfb8d72679740$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$f2a682b251363bc2$export$2e2bcd8739ae039 = $f2a682b251363bc2$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $303ba10db2c74ab4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $303ba10db2c74ab4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $303ba10db2c74ab4$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $303ba10db2c74ab4$var$doubleQuoteRegExp = /''/g;
const $303ba10db2c74ab4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $303ba10db2c74ab4$export$3ae94a2503e890a1(date, formatStr, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($303ba10db2c74ab4$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($303ba10db2c74ab4$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $303ba10db2c74ab4$var$cleanEscapedString(substring)
        };
        if ((0, $008fe800ab658844$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($303ba10db2c74ab4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $008fe800ab658844$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $303ba10db2c74ab4$var$cleanEscapedString(input) {
    const matched = input.match($303ba10db2c74ab4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($303ba10db2c74ab4$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$303ba10db2c74ab4$export$2e2bcd8739ae039 = $303ba10db2c74ab4$export$3ae94a2503e890a1;






function $f3e2f0f906df8397$export$430a3269e24b912e() {
    return Object.assign({}, (0, $39440020b58e1ef8$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$f3e2f0f906df8397$export$2e2bcd8739ae039 = $f3e2f0f906df8397$export$430a3269e24b912e;





function $59425df5ba0b4bea$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $59425df5ba0b4bea$var$isConstructor(constructor) ? new constructor(0) : (0, $abb9adbdb26342b3$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $59425df5ba0b4bea$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$59425df5ba0b4bea$export$2e2bcd8739ae039 = $59425df5ba0b4bea$export$9cb09a71b7d66923;


const $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 extends $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $2c074b7ab8cd2d6d$export$8be15fe85ad72f86 extends $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    priority = $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, (0, $59425df5ba0b4bea$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $db0c34f9a22bf78d$export$8e5a1d3f85a9688 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $90ea69bf2b625c49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $90ea69bf2b625c49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7caea2161b2082cf$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7caea2161b2082cf$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff) + seconds * (0, $8540a44f59a4af84$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$export$d931c43c4608a164(dateString) {
    return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $7caea2161b2082cf$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7caea2161b2082cf$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7caea2161b2082cf$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $66195bae0f19f15a$export$48d352de7cd4a988 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $9fda39b31cab7345$export$b8ef38dfcf05d5db extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}






class $1a189db5f2a1065c$export$951d1df011fde06f extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $c3854b7a937037cd$export$bad9d2ea38e8f1a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d1988bf983127f3e$export$5cb0f701186dde1d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $62b79555ac1f33b0$export$300c0c2990e20e6d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $44a198f4e488a239$export$400dd8b40ef138a3 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $f7643ab884280f91$export$1d7eaa53eaa5deba extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




function $66c7729eb95aa501$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$66c7729eb95aa501$export$2e2bcd8739ae039 = $66c7729eb95aa501$export$4b3066ce4afafd88;






class $0da9b6c0b13ee7fd$export$c4005ffc174e07c0 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)((0, $66c7729eb95aa501$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




function $d0815b4ed45bc80a$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$d0815b4ed45bc80a$export$2e2bcd8739ae039 = $d0815b4ed45bc80a$export$6542bebf6be94082;






class $6803ee1ef2b46eaa$export$6fc8dbedd560a6af extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)((0, $d0815b4ed45bc80a$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $e06f3f7fc9153746$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $e06f3f7fc9153746$export$e8d4b28a20981dd2 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $6b2b75646543924f$export$6cfe0d613455f615 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $a351150ce2eb3ddb$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$a351150ce2eb3ddb$export$2e2bcd8739ae039 = $a351150ce2eb3ddb$export$dd412b56f1e4d8aa;



function $13939a537621d91b$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$13939a537621d91b$export$2e2bcd8739ae039 = $13939a537621d91b$export$b04fdcda82decc6c;



class $9c29ecc5d15fe12f$export$1b03c8b76262f7bd extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $fff6beaa36b4d0e5$export$44d1c127ab42c480 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $1516c9543f7b6045$export$e447a647caaaec1d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $6f80ca66d6710e40$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$6f80ca66d6710e40$export$2e2bcd8739ae039 = $6f80ca66d6710e40$export$c514f4c1a8ed5e9e;



function $87a68208fbd57247$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $6f80ca66d6710e40$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$87a68208fbd57247$export$2e2bcd8739ae039 = $87a68208fbd57247$export$1fd9df65adb0d1aa;




class $6410865f895f2a05$export$693fb1e525095b2a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $87a68208fbd57247$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d5f00db985cb1985$export$8d1e08492351df91 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $40ef93898dc5fd94$export$73ca2bd0a17d273 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $74a8f7a92cf7f4b7$export$bb9212adf05373db extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $c4e91a5550a4af76$export$8a04050a727a1756 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $04e380d05021e0e6$export$e56f4dea2c3e56dd extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $b7df994bc976acad$export$cbbe855312f87d77 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $2a786c11f89b58f4$export$6008046d2b34b6a5 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $fccac2a30b38ae4c$export$2b52670d9e2be53 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $1cf805ecbd4f0c4e$export$94d46d540cf1366a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $93458d2bd887c060$export$b8e6f8b2d70893b1 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $8e1ac7071c05f7b7$export$104d901d49fea29b extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $817e75c4dd06b66a$export$12910e5204b52b9 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $a7e39061a4ba0a45$export$2cd8bf877a05e96 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $dff03ff1496c0b81$export$6d8f69c6906d6368 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $5cf2b811a6ff5b69$export$19131010e7fd8373 = {
    G: new (0, $db0c34f9a22bf78d$export$8e5a1d3f85a9688)(),
    y: new (0, $66195bae0f19f15a$export$48d352de7cd4a988)(),
    Y: new (0, $9fda39b31cab7345$export$b8ef38dfcf05d5db)(),
    R: new (0, $1a189db5f2a1065c$export$951d1df011fde06f)(),
    u: new (0, $c3854b7a937037cd$export$bad9d2ea38e8f1a)(),
    Q: new (0, $d1988bf983127f3e$export$5cb0f701186dde1d)(),
    q: new (0, $62b79555ac1f33b0$export$300c0c2990e20e6d)(),
    M: new (0, $44a198f4e488a239$export$400dd8b40ef138a3)(),
    L: new (0, $f7643ab884280f91$export$1d7eaa53eaa5deba)(),
    w: new (0, $0da9b6c0b13ee7fd$export$c4005ffc174e07c0)(),
    I: new (0, $6803ee1ef2b46eaa$export$6fc8dbedd560a6af)(),
    d: new (0, $e06f3f7fc9153746$export$e8d4b28a20981dd2)(),
    D: new (0, $6b2b75646543924f$export$6cfe0d613455f615)(),
    E: new (0, $9c29ecc5d15fe12f$export$1b03c8b76262f7bd)(),
    e: new (0, $fff6beaa36b4d0e5$export$44d1c127ab42c480)(),
    c: new (0, $1516c9543f7b6045$export$e447a647caaaec1d)(),
    i: new (0, $6410865f895f2a05$export$693fb1e525095b2a)(),
    a: new (0, $d5f00db985cb1985$export$8d1e08492351df91)(),
    b: new (0, $40ef93898dc5fd94$export$73ca2bd0a17d273)(),
    B: new (0, $74a8f7a92cf7f4b7$export$bb9212adf05373db)(),
    h: new (0, $c4e91a5550a4af76$export$8a04050a727a1756)(),
    H: new (0, $04e380d05021e0e6$export$e56f4dea2c3e56dd)(),
    K: new (0, $b7df994bc976acad$export$cbbe855312f87d77)(),
    k: new (0, $2a786c11f89b58f4$export$6008046d2b34b6a5)(),
    m: new (0, $fccac2a30b38ae4c$export$2b52670d9e2be53)(),
    s: new (0, $1cf805ecbd4f0c4e$export$94d46d540cf1366a)(),
    S: new (0, $93458d2bd887c060$export$b8e6f8b2d70893b1)(),
    X: new (0, $8e1ac7071c05f7b7$export$104d901d49fea29b)(),
    x: new (0, $817e75c4dd06b66a$export$12910e5204b52b9)(),
    t: new (0, $a7e39061a4ba0a45$export$2cd8bf877a05e96)(),
    T: new (0, $dff03ff1496c0b81$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8abb93379891fb3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8abb93379891fb3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8abb93379891fb3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8abb93379891fb3e$var$doubleQuoteRegExp = /''/g;
const $8abb93379891fb3e$var$notWhitespaceRegExp = /\S/;
const $8abb93379891fb3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $8abb93379891fb3e$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $f3e2f0f906df8397$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $2c074b7ab8cd2d6d$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($8abb93379891fb3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8abb93379891fb3e$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $5cf2b811a6ff5b69$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($8abb93379891fb3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $8abb93379891fb3e$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $8abb93379891fb3e$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $8abb93379891fb3e$var$cleanEscapedString(input) {
    return input.match($8abb93379891fb3e$var$escapedStringRegExp)[1].replace($8abb93379891fb3e$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$8abb93379891fb3e$export$2e2bcd8739ae039 = $8abb93379891fb3e$export$98e6a39c04603d36;



const $f2e109406cb5aeb5$export$692c1f84971acebc = (input)=>{
    const output = (0, $6ff2619c5464e152$export$2e2bcd8739ae039)(input);
    if (input.issue_date) {
        const parsedIssuedDate = (0, $8abb93379891fb3e$export$98e6a39c04603d36)(input.issue_date, "yyyy-MM-dd", new Date());
        output.issue_date = (0, $303ba10db2c74ab4$export$3ae94a2503e890a1)(parsedIssuedDate, "dd/MM/yyyy");
    }
    return output;
};


const $360df5160de66b73$var$axios = (0, $2e59f0ff0fac9290$export$53ea70b747a790ee)();
var $360df5160de66b73$var$Response;
(function(Response) {
    Response["SUCCESS"] = "success";
    Response["ERROR"] = "error";
    Response["UNKNOWN"] = "unknown";
})($360df5160de66b73$var$Response || ($360df5160de66b73$var$Response = {}));
const $360df5160de66b73$export$eec1f68293554b56 = ({ header: header, children: children })=>{
    const toast = (0, $a154ce245eea8e38$export$a407b657d3044108)();
    const { token: token } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const [state, setState] = (0, $acw62.useState)($360df5160de66b73$var$Response.UNKNOWN);
    const { setStep: setStep } = (0, $acw62.useContext)((0, $bdaa2243693f9b25$export$e2bd290781d68bf1));
    const { reset: reset } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const createNewLicence = async (data)=>{
        try {
            const computedData = (0, $f2e109406cb5aeb5$export$692c1f84971acebc)(data);
            await $360df5160de66b73$var$axios.post((0, $78df7481edc561d7$export$eed022e50baffed5).LICENCES, [
                computedData
            ], {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            setState($360df5160de66b73$var$Response.SUCCESS);
        } catch (e) {
            setState($360df5160de66b73$var$Response.ERROR);
        }
    };
    (0, $acw62.useEffect)(()=>{
        switch(state){
            case $360df5160de66b73$var$Response.SUCCESS:
                toast({
                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Licence successfully created"
                    }),
                    status: "success",
                    position: "bottom-right",
                    duration: 9000,
                    isClosable: true
                });
                reset((0, $aa1c78deb16de548$export$d7e66ef6999696cf));
                setStep((0, $426f534707ae6ced$export$acae14b34103071f).BASIC_DETAILS);
                break;
            case $360df5160de66b73$var$Response.ERROR:
                toast({
                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Licence could not be created"
                    }),
                    description: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Unknown error, please try again later"
                    }),
                    status: "error",
                    position: "bottom-right",
                    duration: 9000
                });
                break;
        }
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76821c5fbe903325$export$a26deed65a14d052), {
        header: header,
        onSubmit: createNewLicence,
        children: children
    });
};


const $bda7389cb6bcbbd0$export$f7b21db91598a87f = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $360df5160de66b73$export$eec1f68293554b56), {
        header: "Enter certificate premises details",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "certificate_holder_name",
                required: true,
                label: "Certificate holder name",
                placeholder: "Enter a certificate holder name here",
                errors: {
                    required: "Please enter the certificate holder name"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "number_of_workstations",
                required: true,
                label: "Number of workstations",
                placeholder: "Enter number of workstations here",
                errors: {
                    required: "Please enter the number of workstations",
                    pattern: {
                        value: /^[0-9]+$/,
                        message: "Please enter a valid number"
                    }
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e75477aa8f59835a$export$359105212d118848), {
                isAssociated: false
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $132d76dd771a3ff6$export$3237a405b221b07), {
                id: "internal_notes",
                label: "Internal notes (optional)"
            })
        ]
    });
};






const $588403384091b119$export$222c901bfa2528cf = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $360df5160de66b73$export$eec1f68293554b56), {
        header: "Enter certificate vehicle details",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "business_name",
                required: true,
                label: "Business name",
                placeholder: "Enter business name here"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "certificate_holder_name",
                required: true,
                label: "Certificate holder name",
                placeholder: "Enter a certificate holder name here"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "vehicle_registration_details",
                required: true,
                label: "Vehicle registration details",
                placeholder: "Enter vehicle registration details here"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $132d76dd771a3ff6$export$3237a405b221b07), {
                id: "vehicle_description",
                required: true,
                label: "Vehicle description",
                placeholder: "Enter vehicle description here"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $132d76dd771a3ff6$export$3237a405b221b07), {
                id: "internal_notes",
                label: "Internal notes (optional)"
            })
        ]
    });
};





// src/divider.tsx



var $f6431999e3731c24$export$2e0a83ec2e27ecbb = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Divider2(props, ref) {
    const { borderLeftWidth: borderLeftWidth, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderWidth: borderWidth, borderStyle: borderStyle, borderColor: borderColor, ...styles } = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Divider", props);
    const { className: className, orientation: orientation = "horizontal", __css: __css, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const dividerStyles = {
        vertical: {
            borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
            height: "100%"
        },
        horizontal: {
            borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
            width: "100%"
        }
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).hr, {
        ref: ref,
        "aria-orientation": orientation,
        ...rest,
        __css: {
            ...styles,
            border: "0",
            borderColor: borderColor,
            borderStyle: borderStyle,
            ...dividerStyles[orientation],
            ...__css
        },
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-divider", className)
    });
});
$f6431999e3731c24$export$2e0a83ec2e27ecbb.displayName = "Divider";

// src/flex.tsx


var $bda88d7286fa84ad$export$f51f4c4ede09e011 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Flex2(props, ref) {
    const { direction: direction, align: align, justify: justify, wrap: wrap, basis: basis, grow: grow, shrink: shrink, ...rest } = props;
    const styles = {
        display: "flex",
        flexDirection: direction,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        flexBasis: basis,
        flexGrow: grow,
        flexShrink: shrink
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        __css: styles,
        ...rest
    });
});
$bda88d7286fa84ad$export$f51f4c4ede09e011.displayName = "Flex";

// src/use-id.ts

var $acw62 = parcelRequire("acw62");
function $532ed011287256c3$export$f680877a34711e37(idProp, prefix) {
    const id = (0, $acw62.useId)();
    return (0, $acw62.useMemo)(()=>idProp || [
            prefix,
            id
        ].filter(Boolean).join("-"), [
        idProp,
        prefix,
        id
    ]);
}
function $532ed011287256c3$export$365c04e2f432779(idProp, ...prefixes) {
    const id = $532ed011287256c3$export$f680877a34711e37(idProp);
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}
function $532ed011287256c3$export$bc294ecf36b44bfb(partId) {
    const [id, setId] = (0, $acw62.useState)(null);
    const ref = (0, $acw62.useCallback)((node)=>{
        setId(node ? partId : null);
    }, [
        partId
    ]);
    return {
        ref: ref,
        id: id,
        isRendered: Boolean(id)
    };
}


// src/use-safe-layout-effect.ts
// src/dom.ts
function $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $a1c7b8cf646d4454$export$1b3bfaa9684536aa(el) {
    var _a;
    if (!$a1c7b8cf646d4454$export$45a5e7f76e0caa8d(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $a1c7b8cf646d4454$export$f21a1ffae260145a(node) {
    var _a, _b;
    return $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(node) ? (_b = (_a = $a1c7b8cf646d4454$export$b204af158042fbac(node)) == null ? void 0 : _a.defaultView) != null ? _b : window : window;
}
function $a1c7b8cf646d4454$export$b204af158042fbac(node) {
    var _a;
    return $a1c7b8cf646d4454$export$45a5e7f76e0caa8d(node) ? (_a = node.ownerDocument) != null ? _a : document : document;
}
function $a1c7b8cf646d4454$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}
function $a1c7b8cf646d4454$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var $a1c7b8cf646d4454$export$4e09c449d6c407f7 = /* @__PURE__ */ $a1c7b8cf646d4454$export$71594e8a50f746f4();
var $a1c7b8cf646d4454$export$5cc3b7b83e34ade7 = (condition)=>condition ? "" : void 0;
var $a1c7b8cf646d4454$export$91a6105db3d4be7b = (condition)=>condition ? true : void 0;
var $a1c7b8cf646d4454$export$a274e22fb40f762e = (...classNames)=>classNames.filter(Boolean).join(" ");
function $a1c7b8cf646d4454$export$cd4e5573fbe2b576(node) {
    const doc = $a1c7b8cf646d4454$export$b204af158042fbac(node);
    return doc == null ? void 0 : doc.activeElement;
}
function $a1c7b8cf646d4454$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}
function $a1c7b8cf646d4454$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return ()=>{
        target.removeEventListener(eventName, handler, options);
    };
}
function $a1c7b8cf646d4454$export$17948c8429b9b73a(event) {
    const { key: key, keyCode: keyCode } = event;
    const isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
    const eventKey = isArrowKey ? `Arrow${key}` : key;
    return eventKey;
}
function $a1c7b8cf646d4454$export$a7a83d2a1d2d9e91(event) {
    var _a, _b;
    const target = (_a = event.target) != null ? _a : event.currentTarget;
    const activeElement = $a1c7b8cf646d4454$export$cd4e5573fbe2b576(target);
    return (_b = event.relatedTarget) != null ? _b : activeElement;
}
function $a1c7b8cf646d4454$export$189689d1febf0166(event) {
    return event.button !== 0;
}



var $acw62 = parcelRequire("acw62");
var $0778b31a6140d2f0$export$deebe11a338de063 = (0, $a1c7b8cf646d4454$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
function $023fde9e76741d2d$export$25bec8c6f54ee79a(fn, deps = []) {
    const ref = (0, $acw62.useRef)(fn);
    (0, $0778b31a6140d2f0$export$deebe11a338de063)(()=>{
        ref.current = fn;
    });
    return (0, $acw62.useCallback)((...args)=>{
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
    }, deps);
}




var $acw62 = parcelRequire("acw62");
function $5d4fa23c70b61f6c$export$7301e09313e4cf1b(prop, state) {
    const isControlled = prop !== void 0;
    const value = isControlled && typeof prop !== "undefined" ? prop : state;
    return [
        isControlled,
        value
    ];
}
function $5d4fa23c70b61f6c$export$6f32135080cb4c3(props) {
    const { value: valueProp, defaultValue: defaultValue, onChange: onChange, shouldUpdate: shouldUpdate = (prev, next)=>prev !== next } = props;
    const onChangeProp = (0, $023fde9e76741d2d$export$25bec8c6f54ee79a)(onChange);
    const shouldUpdateProp = (0, $023fde9e76741d2d$export$25bec8c6f54ee79a)(shouldUpdate);
    const [valueState, setValue] = (0, $acw62.useState)(defaultValue);
    const isControlled = valueProp !== void 0;
    const value = isControlled ? valueProp : valueState;
    const updateValue = (0, $acw62.useCallback)((next)=>{
        const nextValue = (0, $7e9e3a2462729b7f$export$624e501d81f5ffce)(next, value);
        if (!shouldUpdateProp(value, nextValue)) return;
        if (!isControlled) setValue(nextValue);
        onChangeProp(nextValue);
    }, [
        isControlled,
        onChangeProp,
        value,
        shouldUpdateProp
    ]);
    return [
        value,
        updateValue
    ];
}





var $acw62 = parcelRequire("acw62");
function $7eb48cf89f914f76$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const onOpenPropCallbackRef = (0, $023fde9e76741d2d$export$25bec8c6f54ee79a)(onOpenProp);
    const onClosePropCallbackRef = (0, $023fde9e76741d2d$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $acw62.useState)(props.defaultIsOpen || false);
    const [isControlled, isOpen] = (0, $5d4fa23c70b61f6c$export$7301e09313e4cf1b)(isOpenProp, isOpenState);
    const id = (0, $532ed011287256c3$export$f680877a34711e37)(idProp, "disclosure");
    const onClose = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        onClosePropCallbackRef == null || onClosePropCallbackRef();
    }, [
        isControlled,
        onClosePropCallbackRef
    ]);
    const onOpen = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        onOpenPropCallbackRef == null || onOpenPropCallbackRef();
    }, [
        isControlled,
        onOpenPropCallbackRef
    ]);
    const onToggle = (0, $acw62.useCallback)(()=>{
        const action = isOpen ? onClose : onOpen;
        action();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    return {
        isOpen: !!isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: (props2 = {})=>({
                ...props2,
                "aria-expanded": isOpen,
                "aria-controls": id,
                onClick: (0, $7e9e3a2462729b7f$export$5bdd3f730ec2c47e)(props2.onClick, onToggle)
            }),
        getDisclosureProps: (props2 = {})=>({
                ...props2,
                hidden: !isOpen,
                id: id
            })
    };
}



var $acw62 = parcelRequire("acw62");



function $2a03a54a6ef2a295$export$fc799f03c173abf1({ height: height = "20px", width: width = "20px" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        height: height,
        width: width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM11 5H9V9H5V11H9V15H11V11H15V9H11V5Z",
            fill: "#2D5AB4"
        })
    });
}




var $ea7f72a38c44b91a$var$__defProp = Object.defineProperty;
var $ea7f72a38c44b91a$var$__defNormalProp = (obj, key, value)=>key in obj ? $ea7f72a38c44b91a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ea7f72a38c44b91a$export$5cb848ba4d1f099 = (obj, key, value)=>{
    $ea7f72a38c44b91a$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};



var $acw62 = parcelRequire("acw62");
var $b1474d337f7c7355$var$ModalManager = class {
    constructor(){
        (0, $ea7f72a38c44b91a$export$5cb848ba4d1f099)(this, "modals");
        this.modals = /* @__PURE__ */ new Map();
    }
    add(modal) {
        this.modals.set(modal, this.modals.size + 1);
        return this.modals.size;
    }
    remove(modal) {
        this.modals.delete(modal);
    }
    isTopModal(modal) {
        if (!modal) return false;
        return this.modals.get(modal) === this.modals.size;
    }
};
var $b1474d337f7c7355$export$78d35f50a4fd5552 = new $b1474d337f7c7355$var$ModalManager();
function $b1474d337f7c7355$export$8557a94b9bb25060(ref, isOpen) {
    const [index, setIndex] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        if (isOpen) {
            const index2 = $b1474d337f7c7355$export$78d35f50a4fd5552.add(node);
            setIndex(index2);
        }
        return ()=>{
            $b1474d337f7c7355$export$78d35f50a4fd5552.remove(node);
            setIndex(0);
        };
    }, [
        isOpen,
        ref
    ]);
    return index;
}




var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $acw62 = parcelRequire("acw62");
function $8dd3d2af9a12a0ae$export$33ffd74ebf07f060(props) {
    const { isOpen: isOpen, onClose: onClose, id: id, closeOnOverlayClick: closeOnOverlayClick = true, closeOnEsc: closeOnEsc = true, useInert: useInert = true, onOverlayClick: onOverlayClickProp, onEsc: onEsc } = props;
    const dialogRef = (0, $acw62.useRef)(null);
    const overlayRef = (0, $acw62.useRef)(null);
    const [dialogId, headerId, bodyId] = $8dd3d2af9a12a0ae$var$useIds(id, `chakra-modal`, `chakra-modal--header`, `chakra-modal--body`);
    $8dd3d2af9a12a0ae$export$bf01aaa71a18e30b(dialogRef, isOpen && useInert);
    const index = (0, $b1474d337f7c7355$export$8557a94b9bb25060)(dialogRef, isOpen);
    const mouseDownTarget = (0, $acw62.useRef)(null);
    const onMouseDown = (0, $acw62.useCallback)((event)=>{
        mouseDownTarget.current = event.target;
    }, []);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (event.key === "Escape") {
            event.stopPropagation();
            if (closeOnEsc) onClose == null || onClose();
            onEsc == null || onEsc();
        }
    }, [
        closeOnEsc,
        onClose,
        onEsc
    ]);
    const [headerMounted, setHeaderMounted] = (0, $acw62.useState)(false);
    const [bodyMounted, setBodyMounted] = (0, $acw62.useState)(false);
    const getDialogProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            role: "dialog",
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, dialogRef),
            id: dialogId,
            tabIndex: -1,
            "aria-modal": true,
            "aria-labelledby": headerMounted ? headerId : void 0,
            "aria-describedby": bodyMounted ? bodyId : void 0,
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, (event)=>event.stopPropagation())
        }), [
        bodyId,
        bodyMounted,
        dialogId,
        headerId,
        headerMounted
    ]);
    const onOverlayClick = (0, $acw62.useCallback)((event)=>{
        event.stopPropagation();
        if (mouseDownTarget.current !== event.target) return;
        if (!(0, $b1474d337f7c7355$export$78d35f50a4fd5552).isTopModal(dialogRef.current)) return;
        if (closeOnOverlayClick) onClose == null || onClose();
        onOverlayClickProp == null || onOverlayClickProp();
    }, [
        onClose,
        closeOnOverlayClick,
        onOverlayClickProp
    ]);
    const getDialogContainerProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(ref, overlayRef),
            onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onClick, onOverlayClick),
            onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onKeyDown, onKeyDown),
            onMouseDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props2.onMouseDown, onMouseDown)
        }), [
        onKeyDown,
        onMouseDown,
        onOverlayClick
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        headerId: headerId,
        bodyId: bodyId,
        setBodyMounted: setBodyMounted,
        setHeaderMounted: setHeaderMounted,
        dialogRef: dialogRef,
        overlayRef: overlayRef,
        getDialogProps: getDialogProps,
        getDialogContainerProps: getDialogContainerProps,
        index: index
    };
}
function $8dd3d2af9a12a0ae$export$bf01aaa71a18e30b(ref, shouldHide) {
    const currentElement = ref.current;
    (0, $acw62.useEffect)(()=>{
        if (!ref.current || !shouldHide) return void 0;
        return (0, $4a7537e072260c10$export$6e33d16126ed003c)(ref.current);
    }, [
        shouldHide,
        ref,
        currentElement
    ]);
}
function $8dd3d2af9a12a0ae$var$useIds(idProp, ...prefixes) {
    const reactId = (0, $acw62.useId)();
    const id = idProp || reactId;
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}







var [$4c6b64192c399b47$var$ModalStylesProvider, $4c6b64192c399b47$export$c540eec2ed4454a2] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `ModalStylesContext`,
    errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
});
var [$4c6b64192c399b47$export$7c9538f5f3c365e9, $4c6b64192c399b47$export$4cc1699d46f42cae] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: true,
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
});
var $4c6b64192c399b47$export$2b77a92f1a5ad772 = (props)=>{
    const modalProps = {
        scrollBehavior: "outside",
        autoFocus: true,
        trapFocus: true,
        returnFocusOnClose: true,
        blockScrollOnMount: true,
        allowPinchZoom: false,
        motionPreset: "scale",
        lockFocusAcrossFrames: true,
        ...props
    };
    const { portalProps: portalProps, children: children, autoFocus: autoFocus, trapFocus: trapFocus, initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, preserveScrollBarGap: preserveScrollBarGap, motionPreset: motionPreset, lockFocusAcrossFrames: lockFocusAcrossFrames, onCloseComplete: onCloseComplete } = modalProps;
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Modal", modalProps);
    const modal = (0, $8dd3d2af9a12a0ae$export$33ffd74ebf07f060)(modalProps);
    const context = {
        ...modal,
        autoFocus: autoFocus,
        trapFocus: trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        returnFocusOnClose: returnFocusOnClose,
        blockScrollOnMount: blockScrollOnMount,
        allowPinchZoom: allowPinchZoom,
        preserveScrollBarGap: preserveScrollBarGap,
        motionPreset: motionPreset,
        lockFocusAcrossFrames: lockFocusAcrossFrames
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4c6b64192c399b47$export$7c9538f5f3c365e9, {
        value: context,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($4c6b64192c399b47$var$ModalStylesProvider, {
            value: styles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                onExitComplete: onCloseComplete,
                children: context.isOpen && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7dccfa70b276af4f$export$602eac185826482c), {
                    ...portalProps,
                    children: children
                })
            })
        })
    });
};
$4c6b64192c399b47$export$2b77a92f1a5ad772.displayName = "Modal";





var $acw62 = parcelRequire("acw62");

var $982b6692e6c88a18$export$cb540d8b0ef7906c = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const { bodyId: bodyId, setBodyMounted: setBodyMounted } = (0, $4c6b64192c399b47$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        setBodyMounted(true);
        return ()=>setBodyMounted(false);
    }, [
        setBodyMounted
    ]);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__body", className);
    const styles = (0, $4c6b64192c399b47$export$c540eec2ed4454a2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: _className,
        id: bodyId,
        ...rest,
        __css: styles.body
    });
});
$982b6692e6c88a18$export$cb540d8b0ef7906c.displayName = "ModalBody";






var $620ea17661bdce49$export$edf9108895ba774f = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { onClick: onClick, className: className, ...rest } = props;
    const { onClose: onClose } = (0, $4c6b64192c399b47$export$4cc1699d46f42cae)();
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__close-btn", className);
    const styles = (0, $4c6b64192c399b47$export$c540eec2ed4454a2)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3563aea4a86523bd$export$de65de8213222d10), {
        ref: ref,
        __css: styles.closeButton,
        className: _className,
        onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(onClick, (event)=>{
            event.stopPropagation();
            onClose();
        }),
        ...rest
    });
});
$620ea17661bdce49$export$edf9108895ba774f.displayName = "ModalCloseButton";

// src/modal-transition.tsx

// src/transition-utils.ts
var $6842aa27b422dd93$export$9ee1d08bb6db426f = {
    ease: [
        0.25,
        0.1,
        0.25,
        1
    ],
    easeIn: [
        0.4,
        0,
        1,
        1
    ],
    easeOut: [
        0,
        0,
        0.2,
        1
    ],
    easeInOut: [
        0.4,
        0,
        0.2,
        1
    ]
};
var $6842aa27b422dd93$export$55b7325ba41bb523 = {
    scale: {
        enter: {
            scale: 1
        },
        exit: {
            scale: 0.95
        }
    },
    fade: {
        enter: {
            opacity: 1
        },
        exit: {
            opacity: 0
        }
    },
    pushLeft: {
        enter: {
            x: "100%"
        },
        exit: {
            x: "-30%"
        }
    },
    pushRight: {
        enter: {
            x: "-100%"
        },
        exit: {
            x: "30%"
        }
    },
    pushUp: {
        enter: {
            y: "100%"
        },
        exit: {
            y: "-30%"
        }
    },
    pushDown: {
        enter: {
            y: "-100%"
        },
        exit: {
            y: "30%"
        }
    },
    slideLeft: {
        position: {
            left: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "-100%",
            y: 0
        }
    },
    slideRight: {
        position: {
            right: 0,
            top: 0,
            bottom: 0,
            width: "100%"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: "100%",
            y: 0
        }
    },
    slideUp: {
        position: {
            top: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "-100%"
        }
    },
    slideDown: {
        position: {
            bottom: 0,
            left: 0,
            right: 0,
            maxWidth: "100vw"
        },
        enter: {
            x: 0,
            y: 0
        },
        exit: {
            x: 0,
            y: "100%"
        }
    }
};
function $6842aa27b422dd93$export$76af7f35258e628d(options) {
    var _a;
    const side = (_a = options == null ? void 0 : options.direction) != null ? _a : "right";
    switch(side){
        case "right":
            return $6842aa27b422dd93$export$55b7325ba41bb523.slideRight;
        case "left":
            return $6842aa27b422dd93$export$55b7325ba41bb523.slideLeft;
        case "bottom":
            return $6842aa27b422dd93$export$55b7325ba41bb523.slideDown;
        case "top":
            return $6842aa27b422dd93$export$55b7325ba41bb523.slideUp;
        default:
            return $6842aa27b422dd93$export$55b7325ba41bb523.slideRight;
    }
}
var $6842aa27b422dd93$export$f995eb860f745cb = {
    enter: {
        duration: 0.2,
        ease: $6842aa27b422dd93$export$9ee1d08bb6db426f.easeOut
    },
    exit: {
        duration: 0.1,
        ease: $6842aa27b422dd93$export$9ee1d08bb6db426f.easeIn
    }
};
var $6842aa27b422dd93$export$fc492bd0f1c91c = {
    enter: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
        }),
    exit: (transition, delay)=>({
            ...transition,
            delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
        })
};





var $acw62 = parcelRequire("acw62");

var $3000d02bebc53935$var$variants = {
    exit: ({ reverse: reverse, initialScale: initialScale, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            opacity: 0,
            ...reverse ? {
                scale: initialScale,
                transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
            } : {
                transitionEnd: {
                    scale: initialScale,
                    ...transitionEnd == null ? void 0 : transitionEnd.exit
                }
            },
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).exit((0, $6842aa27b422dd93$export$f995eb860f745cb).exit, delay)
        };
    },
    enter: ({ transitionEnd: transitionEnd, transition: transition, delay: delay })=>{
        var _a;
        return {
            opacity: 1,
            scale: 1,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).enter((0, $6842aa27b422dd93$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    }
};
var $3000d02bebc53935$export$9f21bb05021be18d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $3000d02bebc53935$var$variants
};
var $3000d02bebc53935$export$c9ef45b298456c94 = (0, $acw62.forwardRef)(function ScaleFade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, reverse: reverse = true, initialScale: initialScale = 0.95, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, ...rest } = props;
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        initialScale: initialScale,
        reverse: reverse,
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-offset-slide", className),
            ...$3000d02bebc53935$export$9f21bb05021be18d,
            animate: animate,
            custom: custom,
            ...rest
        })
    });
});
$3000d02bebc53935$export$c9ef45b298456c94.displayName = "ScaleFade";





var $acw62 = parcelRequire("acw62");

var $f815f2fef1bf247a$var$variants = {
    initial: ({ offsetX: offsetX, offsetY: offsetY, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            opacity: 0,
            x: offsetX,
            y: offsetY,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).exit((0, $6842aa27b422dd93$export$f995eb860f745cb).exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    },
    enter: ({ transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        return {
            opacity: 1,
            x: 0,
            y: 0,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).enter((0, $6842aa27b422dd93$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    },
    exit: ({ offsetY: offsetY, offsetX: offsetX, transition: transition, transitionEnd: transitionEnd, reverse: reverse, delay: delay })=>{
        var _a;
        const offset = {
            x: offsetX,
            y: offsetY
        };
        return {
            opacity: 0,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).exit((0, $6842aa27b422dd93$export$f995eb860f745cb).exit, delay),
            ...reverse ? {
                ...offset,
                transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
            } : {
                transitionEnd: {
                    ...offset,
                    ...transitionEnd == null ? void 0 : transitionEnd.exit
                }
            }
        };
    }
};
var $f815f2fef1bf247a$export$153404f46b1af630 = {
    initial: "initial",
    animate: "enter",
    exit: "exit",
    variants: $f815f2fef1bf247a$var$variants
};
var $f815f2fef1bf247a$export$2c57c541d078cf9c = (0, $acw62.forwardRef)(function SlideFade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, reverse: reverse = true, className: className, offsetX: offsetX = 0, offsetY: offsetY = 8, transition: transition, transitionEnd: transitionEnd, delay: delay, ...rest } = props;
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        offsetX: offsetX,
        offsetY: offsetY,
        reverse: reverse,
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-offset-slide", className),
            custom: custom,
            ...$f815f2fef1bf247a$export$153404f46b1af630,
            animate: animate,
            ...rest
        })
    });
});
$f815f2fef1bf247a$export$2c57c541d078cf9c.displayName = "SlideFade";




var $acw62 = parcelRequire("acw62");

var $40ec0234c0c5e0df$var$transitions = {
    slideInBottom: {
        ...(0, $f815f2fef1bf247a$export$153404f46b1af630),
        custom: {
            offsetY: 16,
            reverse: true
        }
    },
    slideInRight: {
        ...(0, $f815f2fef1bf247a$export$153404f46b1af630),
        custom: {
            offsetX: 16,
            reverse: true
        }
    },
    scale: {
        ...(0, $3000d02bebc53935$export$9f21bb05021be18d),
        custom: {
            initialScale: 0.95,
            reverse: true
        }
    },
    none: {}
};
var $40ec0234c0c5e0df$var$MotionSection = (0, $f1b95b1386d3a42c$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).section);
var $40ec0234c0c5e0df$var$getMotionProps = (preset)=>{
    return $40ec0234c0c5e0df$var$transitions[preset || "none"];
};
var $40ec0234c0c5e0df$export$f0a3ab1cc2e7e9a6 = (0, $acw62.forwardRef)((props, ref)=>{
    const { preset: preset, motionProps: motionProps = $40ec0234c0c5e0df$var$getMotionProps(preset), ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($40ec0234c0c5e0df$var$MotionSection, {
        ref: ref,
        ...motionProps,
        ...rest
    });
});
$40ec0234c0c5e0df$export$f0a3ab1cc2e7e9a6.displayName = "ModalTransition";




// src/focus-lock.tsx
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/**
 * defines a focus group
 */ var $34f6623b57e1a1c8$export$4f9a06cb7441a087 = "data-focus-lock";
var $34f6623b57e1a1c8$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $34f6623b57e1a1c8$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $34f6623b57e1a1c8$export$70e9b4a1820af101 = "data-autofocus-inside";
var $34f6623b57e1a1c8$export$134ebef29fd94853 = "data-no-autofocus";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
}



var $acw62 = parcelRequire("acw62");

var $119d56c93ccd46db$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $119d56c93ccd46db$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $acw62.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $119d56c93ccd46db$export$b8c7b07253306600
    }));
};
$119d56c93ccd46db$var$InFocusGuard.propTypes = {};
$119d56c93ccd46db$var$InFocusGuard.defaultProps = {
    children: null
};
var $119d56c93ccd46db$export$2e2bcd8739ae039 = $119d56c93ccd46db$var$InFocusGuard;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $292937b69072d1e6$export$5733e022b1d538cb = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $292937b69072d1e6$export$b3e9a9312f73723c = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$3a1d52767cbc07b8 = (0, $dce67a1050af61cf$export$9ffbfcaf067b02c6)();
var $292937b69072d1e6$export$892cbf28e5518020 = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)({
    async: true // focus-lock sidecar is not required on the server
});


var $e86725766b4cde33$var$emptyArray = [];
var $e86725766b4cde33$var$FocusLock = /*#__PURE__*/ $acw62.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $acw62.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $acw62.useRef();
    var isActive = $acw62.useRef(false);
    var originalFocusedElement = $acw62.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $e86725766b4cde33$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $acw62.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $acw62.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $acw62.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $acw62.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $acw62.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $acw62.useCallback(function(event) {
        if (isActive.current) (0, $292937b69072d1e6$export$5733e022b1d538cb).useMedium(event);
    }, []);
    var onBlur = (0, $292937b69072d1e6$export$b3e9a9312f73723c).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $acw62.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[$34f6623b57e1a1c8$export$aeda8252e54b50f7] = disabled && "disabled", _extends2[$34f6623b57e1a1c8$export$4f9a06cb7441a087] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $acw62.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $acw62.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
        }) : null
    ], !disabled && /*#__PURE__*/ $acw62.createElement(SideCar, {
        id: id,
        sideCar: (0, $292937b69072d1e6$export$892cbf28e5518020),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $acw62.createElement(Container, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $acw62.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $119d56c93ccd46db$export$b8c7b07253306600)
    }));
});
$e86725766b4cde33$var$FocusLock.propTypes = {};
$e86725766b4cde33$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: "div",
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $e86725766b4cde33$export$2e2bcd8739ae039 = $e86725766b4cde33$var$FocusLock;


/* eslint-disable no-mixed-operators */ 
var $acw62 = parcelRequire("acw62");


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}




var $acw62 = parcelRequire("acw62");
function $bec73a156e960f78$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $acw62.PureComponent));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $bec73a156e960f78$export$2e2bcd8739ae039 = $bec73a156e960f78$var$withSideEffect;



/*
IE11 support
 */ var $c2cb5aa387a37a50$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $c2cb5aa387a37a50$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $c2cb5aa387a37a50$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};



var $2cff22612808ae96$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $2cff22612808ae96$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $2cff22612808ae96$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $2cff22612808ae96$var$isVisibleUncached = function(node, checkParent) {
    return !node || $2cff22612808ae96$var$isTopNode(node) || !$2cff22612808ae96$var$isElementHidden(node) && checkParent($2cff22612808ae96$var$getParentNode(node));
};
var $2cff22612808ae96$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isVisibleUncached(node, $2cff22612808ae96$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $2cff22612808ae96$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$2cff22612808ae96$var$isTopNode(node) ? $2cff22612808ae96$export$b8550e27de209d85(node) ? checkParent($2cff22612808ae96$var$getParentNode(node)) : false : true;
};
var $2cff22612808ae96$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $2cff22612808ae96$var$isAutoFocusAllowedUncached(node, $2cff22612808ae96$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $2cff22612808ae96$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $2cff22612808ae96$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $2cff22612808ae96$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $2cff22612808ae96$export$9d74f6fbc6f469d0 = function(node) {
    return $2cff22612808ae96$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $2cff22612808ae96$export$8197b0ea56b3b055 = function(node) {
    return !(($2cff22612808ae96$export$88a6ceeed5737ba3(node) || $2cff22612808ae96$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $2cff22612808ae96$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $34f6623b57e1a1c8$export$134ebef29fd94853));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $2cff22612808ae96$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $2cff22612808ae96$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $2cff22612808ae96$export$602e5a0d338d7750 = function(node) {
    return !$2cff22612808ae96$export$d94b8b58ec2f30eb(node);
};
var $2cff22612808ae96$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};



var $e6301f5798625d25$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $e6301f5798625d25$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($e6301f5798625d25$export$350ee6c095d98996);
};




/**
 * list of the object to be considered as focusable
 */ var $9fc4580037f02fd3$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];


var $c85a3cad3fc06f20$var$queryTabbables = (0, $9fc4580037f02fd3$export$8555f4622e95784).join(",");
var $c85a3cad3fc06f20$var$queryGuardTabbables = "".concat($c85a3cad3fc06f20$var$queryTabbables, ", [data-focus-guard]");
var $c85a3cad3fc06f20$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $c85a3cad3fc06f20$var$queryGuardTabbables : $c85a3cad3fc06f20$var$queryTabbables) ? [
            child
        ] : [], $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $c85a3cad3fc06f20$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $c85a3cad3fc06f20$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $c85a3cad3fc06f20$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $c85a3cad3fc06f20$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $c85a3cad3fc06f20$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parent.parentNode.querySelectorAll($c85a3cad3fc06f20$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $c85a3cad3fc06f20$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$70e9b4a1820af101), "]"));
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(parentFocus).map(function(node) {
        return $c85a3cad3fc06f20$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};


var $9b74641517b143d6$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$3c9dc299685ad160)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $2cff22612808ae96$export$8197b0ea56b3b055)(node);
    });
};
var $9b74641517b143d6$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(nodes).filter(function(node) {
        return (0, $2cff22612808ae96$export$bcaa50628f6a736e)(cache, node);
    });
};
var $9b74641517b143d6$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $9b74641517b143d6$export$23c79be8286a3b0c = function(topNodes, visibilityCache) {
    return (0, $e6301f5798625d25$export$cb40ee071f0d5226)($9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$f6768025e418420e)(topNodes), visibilityCache), false);
};
var $9b74641517b143d6$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $9b74641517b143d6$export$6266a5cd5915dc33((0, $c85a3cad3fc06f20$export$853fa94d922e78b9)(topNode), visibilityCache);
};
var $9b74641517b143d6$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $9b74641517b143d6$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $9b74641517b143d6$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $9b74641517b143d6$export$2344b14b097df817(child, element);
        });
    }
};




/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $7bf194f892d90e1b$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $7bf194f892d90e1b$var$getTopParent = function(node) {
    return node.parentNode ? $7bf194f892d90e1b$var$getTopParent(node.parentNode) : node;
};
var $7bf194f892d90e1b$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087));
        acc.push.apply(acc, group ? $7bf194f892d90e1b$var$filterNested((0, $c2cb5aa387a37a50$export$45b10814cc054894)($7bf194f892d90e1b$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$4f9a06cb7441a087), '="').concat(group, '"]:not([').concat((0, $34f6623b57e1a1c8$export$aeda8252e54b50f7), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};



/**
 * returns active element from document or from nested shadowdoms
 */ var $f296cb52f860ecc3$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};


var $b5783d59678393a3$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $f296cb52f860ecc3$export$78d20aae35adef88)(function() {
        return activeElement.contentWindow.document;
    }) ? $b5783d59678393a3$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};


var $eec3e0cab722c011$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $eec3e0cab722c011$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $c2cb5aa387a37a50$export$45b10814cc054894)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $eec3e0cab722c011$var$focusInFrame(node, activeElement);
    }));
};
var $eec3e0cab722c011$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement) || $eec3e0cab722c011$var$focusInsideIframe(node, activeElement);
    });
};






var $4a4957b2dfe49f02$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $c2cb5aa387a37a50$export$45b10814cc054894)(inDocument.querySelectorAll("[".concat((0, $34f6623b57e1a1c8$export$54ecf528c58f9ef6), "]"))).some(function(node) {
        return (0, $9b74641517b143d6$export$2344b14b097df817)(node, activeElement);
    });
};








var $51d90458d728fe34$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $51d90458d728fe34$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $51d90458d728fe34$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $51d90458d728fe34$var$getParents(nodeA);
    var parentsB = $51d90458d728fe34$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $51d90458d728fe34$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(baseActiveElement);
    var leftEntries = (0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $51d90458d728fe34$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $51d90458d728fe34$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $9b74641517b143d6$export$2344b14b097df817)(common, topCommon)) topCommon = common;
                else topCommon = $51d90458d728fe34$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $51d90458d728fe34$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $9b74641517b143d6$export$dc26309a71d1ce47)(node, visibilityCache));
    }, []);
};


var $3f73a80c2e676402$export$30d9c643899a8835 = function(topNode) {
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = (0, $9b74641517b143d6$export$3738e313571e2ad2)([
        commonParent
    ], visibilityCache, true);
    var innerElements = (0, $9b74641517b143d6$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $2cff22612808ae96$export$602e5a0d338d7750)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(node)
        };
    });
};
var $3f73a80c2e676402$export$5f246425711134ac = $3f73a80c2e676402$export$30d9c643899a8835;



var $3315685220e94b72$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $3315685220e94b72$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $2cff22612808ae96$export$9d74f6fbc6f469d0)(node) && node.name) return $3315685220e94b72$var$findSelectedRadio(node, nodes);
    return node;
};
var $3315685220e94b72$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($3315685220e94b72$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};



var $550b7510239b204f$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $3315685220e94b72$export$5261662167ad7ced)(nodes[0], nodes);
    return nodes[0];
};
var $550b7510239b204f$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $3315685220e94b72$export$5261662167ad7ced)(nodes[index], nodes));
    return index;
};



var $5f30961e5fc5285a$export$85710b12cf912438 = "NEW_FOCUS";
var $5f30961e5fc5285a$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $2cff22612808ae96$export$d94b8b58ec2f30eb)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $3315685220e94b72$export$4a5a72a7124e45f9)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, 0);
    var returnLastNode = (0, $550b7510239b204f$export$e06728ee87c96122)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return $5f30961e5fc5285a$export$85710b12cf912438;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};








var $0a6fd98cd390fe5b$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $2cff22612808ae96$export$698b339b0c8edae3)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $0a6fd98cd390fe5b$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $9b74641517b143d6$export$2f70373d403a5d2b)(nodes.filter($0a6fd98cd390fe5b$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)(autoFocusable);
    return (0, $550b7510239b204f$export$f4e86cfa0679b9cc)((0, $9b74641517b143d6$export$2f70373d403a5d2b)(orderedNodes));
};





var $34c76fc1214ef975$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $2cff22612808ae96$export$4e62c701997796c1));
};
var $34c76fc1214ef975$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = (0, $b5783d59678393a3$export$cd4e5573fbe2b576)((0, $c2cb5aa387a37a50$export$75093a47a9fa838d)(topNode).length > 0 ? document : (0, $c2cb5aa387a37a50$export$bcd7afcd904dce14)(topNode).ownerDocument);
    var entries = (0, $7bf194f892d90e1b$export$7e87c4720b9b279b)(topNode).filter((0, $2cff22612808ae96$export$602e5a0d338d7750));
    var commonParent = (0, $51d90458d728fe34$export$a9a7252b5f2e280e)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $9b74641517b143d6$export$23c79be8286a3b0c)(entries, visibilityCache);
    var innerElements = (0, $9b74641517b143d6$export$3738e313571e2ad2)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $2cff22612808ae96$export$602e5a0d338d7750)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $9b74641517b143d6$export$23c79be8286a3b0c)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $34c76fc1214ef975$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $5f30961e5fc5285a$export$65842178e9bb4205)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $5f30961e5fc5285a$export$85710b12cf912438)) {
        var focusNode = (0, $0a6fd98cd390fe5b$export$cfb742983e257555)(anyFocusable, innerNodes, (0, $51d90458d728fe34$export$8f99714c70a37db1)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};


var $c471be4735bd3878$export$c12b3da842c43a8 = function(target, focusOptions) {
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};
var $c471be4735bd3878$var$guardCount = 0;
var $c471be4735bd3878$var$lockDisabled = false;
var $c471be4735bd3878$export$f06c444b0336b5d5 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $34c76fc1214ef975$export$82d3f62e3f171d1d)(topNode, lastNode);
    if ($c471be4735bd3878$var$lockDisabled) return;
    if (focusable) {
        if ($c471be4735bd3878$var$guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $c471be4735bd3878$var$lockDisabled = true;
            setTimeout(function() {
                $c471be4735bd3878$var$lockDisabled = false;
            }, 1);
            return;
        }
        $c471be4735bd3878$var$guardCount++;
        $c471be4735bd3878$export$c12b3da842c43a8(focusable.node, options.focusOptions);
        $c471be4735bd3878$var$guardCount--;
    }
};






var $db815af593127be9$export$2e2bcd8739ae039 //
 = (0, $c471be4735bd3878$export$f06c444b0336b5d5);


function $de7ba2c6b170eb4f$export$6523025722806278(action) {
    // Hidding setImmediate from Webpack to avoid inserting polyfill
    var _window = window, setImmediate = _window.setImmediate;
    if (typeof setImmediate !== "undefined") setImmediate(action);
    else setTimeout(action, 1);
}
var $de7ba2c6b170eb4f$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};



var $00df5dbe84bcea91$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $00df5dbe84bcea91$var$isFreeFocus = function isFreeFocus() {
    return $00df5dbe84bcea91$var$focusOnBody() || (0, $4a4957b2dfe49f02$export$be6b21806d3fd485)();
};
var $00df5dbe84bcea91$var$lastActiveTrap = null;
var $00df5dbe84bcea91$var$lastActiveFocus = null;
var $00df5dbe84bcea91$var$lastPortaledElement = null;
var $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
var $00df5dbe84bcea91$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $00df5dbe84bcea91$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($00df5dbe84bcea91$var$lastActiveTrap.whiteList || $00df5dbe84bcea91$var$defaultWhitelist)(activeElement);
};
var $00df5dbe84bcea91$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $00df5dbe84bcea91$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $00df5dbe84bcea91$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement === element;
};
function $00df5dbe84bcea91$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $00df5dbe84bcea91$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $00df5dbe84bcea91$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($00df5dbe84bcea91$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $00df5dbe84bcea91$var$focusWasOutsideWindow === "meanwhile";
};
var $00df5dbe84bcea91$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $00df5dbe84bcea91$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $00df5dbe84bcea91$var$checkInHost(activeElement, area, area);
    });
};
var $00df5dbe84bcea91$var$activateTrap = function activateTrap() {
    var result = false;
    if ($00df5dbe84bcea91$var$lastActiveTrap) {
        var _lastActiveTrap = $00df5dbe84bcea91$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $00df5dbe84bcea91$var$lastPortaledElement && $00df5dbe84bcea91$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($00df5dbe84bcea91$var$extractRef).filter(Boolean));
            if (!activeElement || $00df5dbe84bcea91$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $00df5dbe84bcea91$var$focusWasOutside(crossFrame) || !$00df5dbe84bcea91$var$isFreeFocus() || !$00df5dbe84bcea91$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $eec3e0cab722c011$export$20115f8da7baa6fa)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $00df5dbe84bcea91$var$withinHost(activeElement, workingArea) || $00df5dbe84bcea91$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$00df5dbe84bcea91$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $db815af593127be9$export$2e2bcd8739ae039)(workingArea, $00df5dbe84bcea91$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $00df5dbe84bcea91$var$lastPortaledElement = {};
                        }
                    }
                    $00df5dbe84bcea91$var$focusWasOutsideWindow = false;
                    $00df5dbe84bcea91$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $3f73a80c2e676402$export$30d9c643899a8835)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $00df5dbe84bcea91$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $00df5dbe84bcea91$var$onTrap = function onTrap(event) {
    if ($00df5dbe84bcea91$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $00df5dbe84bcea91$var$onBlur = function onBlur() {
    return (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
};
var $00df5dbe84bcea91$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $00df5dbe84bcea91$var$recordPortal(currentNode, source);
};
var $00df5dbe84bcea91$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $00df5dbe84bcea91$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        onBlur: $00df5dbe84bcea91$var$onBlur,
        onFocus: $00df5dbe84bcea91$var$onFocus
    }, children);
};
$00df5dbe84bcea91$var$FocusTrap.propTypes = {};
var $00df5dbe84bcea91$var$onWindowBlur = function onWindowBlur() {
    $00df5dbe84bcea91$var$focusWasOutsideWindow = "just"; // using setTimeout to set  this variable after React/sidecar reaction
    setTimeout(function() {
        $00df5dbe84bcea91$var$focusWasOutsideWindow = "meanwhile";
    }, 0);
};
var $00df5dbe84bcea91$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.addEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.addEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
var $00df5dbe84bcea91$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $00df5dbe84bcea91$var$onTrap);
    document.removeEventListener("focusout", $00df5dbe84bcea91$var$onBlur);
    window.removeEventListener("blur", $00df5dbe84bcea91$var$onWindowBlur);
};
function $00df5dbe84bcea91$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $00df5dbe84bcea91$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$00df5dbe84bcea91$var$lastActiveTrap) $00df5dbe84bcea91$var$attachHandler();
    var lastTrap = $00df5dbe84bcea91$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $00df5dbe84bcea91$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $00df5dbe84bcea91$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $00df5dbe84bcea91$var$activateTrap(true);
        (0, $de7ba2c6b170eb4f$export$6523025722806278)($00df5dbe84bcea91$var$activateTrap);
    } else {
        $00df5dbe84bcea91$var$detachHandler();
        $00df5dbe84bcea91$var$lastActiveFocus = null;
    }
} // bind medium
(0, $292937b69072d1e6$export$5733e022b1d538cb).assignSyncMedium($00df5dbe84bcea91$var$onFocus);
(0, $292937b69072d1e6$export$b3e9a9312f73723c).assignMedium($00df5dbe84bcea91$var$onBlur);
(0, $292937b69072d1e6$export$3a1d52767cbc07b8).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $db815af593127be9$export$2e2bcd8739ae039),
        focusInside: (0, $eec3e0cab722c011$export$20115f8da7baa6fa)
    });
});
var $00df5dbe84bcea91$export$2e2bcd8739ae039 = (0, $bec73a156e960f78$export$2e2bcd8739ae039)($00df5dbe84bcea91$var$reducePropsToState, $00df5dbe84bcea91$var$handleStateChangeOnClient)($00df5dbe84bcea91$var$FocusWatcher);


/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $afd3cd9c4d0274d7$var$FocusLockCombination = /*#__PURE__*/ $acw62.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $e86725766b4cde33$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        sideCar: (0, $00df5dbe84bcea91$export$2e2bcd8739ae039),
        ref: ref
    }, props));
});
var $afd3cd9c4d0274d7$var$_ref = (0, $e86725766b4cde33$export$2e2bcd8739ae039).propTypes || {}, $afd3cd9c4d0274d7$var$sideCar = $afd3cd9c4d0274d7$var$_ref.sideCar, $afd3cd9c4d0274d7$var$propTypes = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)($afd3cd9c4d0274d7$var$_ref, [
    "sideCar"
]);
$afd3cd9c4d0274d7$var$FocusLockCombination.propTypes = {};
var $afd3cd9c4d0274d7$export$2e2bcd8739ae039 = $afd3cd9c4d0274d7$var$FocusLockCombination;



var $9962412629625ccb$export$2e2bcd8739ae039 = (0, $afd3cd9c4d0274d7$export$2e2bcd8739ae039);



// src/dom.ts
function $534108a0b0d3445d$export$45a5e7f76e0caa8d(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $534108a0b0d3445d$export$1b3bfaa9684536aa(el) {
    var _a;
    if (!$534108a0b0d3445d$export$45a5e7f76e0caa8d(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $534108a0b0d3445d$export$f21a1ffae260145a(node) {
    var _a, _b;
    return (_b = (_a = $534108a0b0d3445d$export$b204af158042fbac(node)) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
function $534108a0b0d3445d$export$b204af158042fbac(node) {
    return $534108a0b0d3445d$export$45a5e7f76e0caa8d(node) ? node.ownerDocument : document;
}
function $534108a0b0d3445d$export$8d16348623687f6(event) {
    var _a;
    return (_a = event.view) != null ? _a : window;
}
function $534108a0b0d3445d$export$4e09c449d6c407f7() {
    return Boolean(globalThis == null ? void 0 : globalThis.document);
}
function $534108a0b0d3445d$export$cd4e5573fbe2b576(node) {
    return $534108a0b0d3445d$export$b204af158042fbac(node).activeElement;
}
function $534108a0b0d3445d$export$2344b14b097df817(parent, child) {
    if (!parent) return false;
    return parent === child || parent.contains(child);
}


// src/tabbable.ts
var $2d4b29ebc030a42a$export$f5f22eac728522fd = (element)=>window.getComputedStyle(element).display === "none";
var $2d4b29ebc030a42a$export$54209d29bacd2cb9 = (element)=>element.hasAttribute("tabindex");
var $2d4b29ebc030a42a$export$87df0ed37d24dd13 = (element)=>$2d4b29ebc030a42a$export$54209d29bacd2cb9(element) && element.tabIndex === -1;
function $2d4b29ebc030a42a$export$30e0dc115df457ed(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function $2d4b29ebc030a42a$export$63ed1d20cf8213cf(element) {
    return (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) && element.localName === "input" && "select" in element;
}
function $2d4b29ebc030a42a$export$8a2eb51c14bb8899(element) {
    const doc = (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) ? (0, $534108a0b0d3445d$export$b204af158042fbac)(element) : document;
    return doc.activeElement === element;
}
function $2d4b29ebc030a42a$export$848589947316f680(element) {
    if (!document.activeElement) return false;
    return element.contains(document.activeElement);
}
function $2d4b29ebc030a42a$export$ee695c13482bb5dd(element) {
    if (element.parentElement && $2d4b29ebc030a42a$export$ee695c13482bb5dd(element.parentElement)) return true;
    return element.hidden;
}
function $2d4b29ebc030a42a$export$3453cc819780f652(element) {
    const value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
}
function $2d4b29ebc030a42a$export$4c063cf1350e6fed(element) {
    if (!(0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) || $2d4b29ebc030a42a$export$ee695c13482bb5dd(element) || $2d4b29ebc030a42a$export$30e0dc115df457ed(element)) return false;
    const { localName: localName } = element;
    const focusableTags = [
        "input",
        "select",
        "textarea",
        "button"
    ];
    if (focusableTags.indexOf(localName) >= 0) return true;
    const others = {
        a: ()=>element.hasAttribute("href"),
        audio: ()=>element.hasAttribute("controls"),
        video: ()=>element.hasAttribute("controls")
    };
    if (localName in others) return others[localName]();
    if ($2d4b29ebc030a42a$export$3453cc819780f652(element)) return true;
    return $2d4b29ebc030a42a$export$54209d29bacd2cb9(element);
}
function $2d4b29ebc030a42a$export$bebd5a1431fec25d(element) {
    if (!element) return false;
    return (0, $534108a0b0d3445d$export$1b3bfaa9684536aa)(element) && $2d4b29ebc030a42a$export$4c063cf1350e6fed(element) && !$2d4b29ebc030a42a$export$87df0ed37d24dd13(element);
}



// src/index.ts
var $2858cbef67902129$var$focusableElList = [
    "input:not(:disabled):not([disabled])",
    "select:not(:disabled):not([disabled])",
    "textarea:not(:disabled):not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not(:disabled):not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
];
var $2858cbef67902129$var$focusableElSelector = $2858cbef67902129$var$focusableElList.join();
var $2858cbef67902129$var$isVisible = (el)=>el.offsetWidth > 0 && el.offsetHeight > 0;
function $2858cbef67902129$export$4ae682d253b556eb(container) {
    const focusableEls = Array.from(container.querySelectorAll($2858cbef67902129$var$focusableElSelector));
    focusableEls.unshift(container);
    return focusableEls.filter((el)=>(0, $2d4b29ebc030a42a$export$4c063cf1350e6fed)(el) && $2858cbef67902129$var$isVisible(el));
}
function $2858cbef67902129$export$748138f04a69bf21(container) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container);
    return allFocusable.length ? allFocusable[0] : null;
}
function $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable) {
    const allFocusable = Array.from(container.querySelectorAll($2858cbef67902129$var$focusableElSelector));
    const allTabbable = allFocusable.filter((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d));
    if ((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)(container)) allTabbable.unshift(container);
    if (!allTabbable.length && fallbackToFocusable) return allFocusable;
    return allTabbable;
}
function $2858cbef67902129$export$168b663469d4c75e(container, fallbackToFocusable) {
    const [first] = $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return first || null;
}
function $2858cbef67902129$export$a6fe3106a93f5f4b(container, fallbackToFocusable) {
    const allTabbable = $2858cbef67902129$export$f9ba66356f7359cf(container, fallbackToFocusable);
    return allTabbable[allTabbable.length - 1] || null;
}
function $2858cbef67902129$export$28f33206776129a7(container, fallbackToFocusable) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container);
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || allFocusable.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}
function $2858cbef67902129$export$2e5518c3303f364a(container, fallbackToFocusable) {
    const allFocusable = $2858cbef67902129$export$4ae682d253b556eb(container).reverse();
    const index = allFocusable.indexOf(document.activeElement);
    const slice = allFocusable.slice(index + 1);
    return slice.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || allFocusable.find((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)) || (fallbackToFocusable ? slice[0] : null);
}



var $acw62 = parcelRequire("acw62");

var $2e4eb73a6c3afbd5$var$_a;
var $2e4eb73a6c3afbd5$var$FocusTrap = ($2e4eb73a6c3afbd5$var$_a = (0, $9962412629625ccb$export$2e2bcd8739ae039).default) != null ? $2e4eb73a6c3afbd5$var$_a : (0, $9962412629625ccb$export$2e2bcd8739ae039);
var $2e4eb73a6c3afbd5$export$ae70e1f3be7e1299 = (props)=>{
    const { initialFocusRef: initialFocusRef, finalFocusRef: finalFocusRef, contentRef: contentRef, restoreFocus: restoreFocus, children: children, isDisabled: isDisabled, autoFocus: autoFocus, persistentFocus: persistentFocus, lockFocusAcrossFrames: lockFocusAcrossFrames } = props;
    const onActivation = (0, $acw62.useCallback)(()=>{
        if (initialFocusRef == null ? void 0 : initialFocusRef.current) initialFocusRef.current.focus();
        else if (contentRef == null ? void 0 : contentRef.current) {
            const focusables = (0, $2858cbef67902129$export$4ae682d253b556eb)(contentRef.current);
            if (focusables.length === 0) requestAnimationFrame(()=>{
                var _a2;
                (_a2 = contentRef.current) == null || _a2.focus();
            });
        }
    }, [
        initialFocusRef,
        contentRef
    ]);
    const onDeactivation = (0, $acw62.useCallback)(()=>{
        var _a2;
        (_a2 = finalFocusRef == null ? void 0 : finalFocusRef.current) == null || _a2.focus();
    }, [
        finalFocusRef
    ]);
    const returnFocus = restoreFocus && !finalFocusRef;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($2e4eb73a6c3afbd5$var$FocusTrap, {
        crossFrame: lockFocusAcrossFrames,
        persistentFocus: persistentFocus,
        autoFocus: autoFocus,
        disabled: isDisabled,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        children: children
    });
};
$2e4eb73a6c3afbd5$export$ae70e1f3be7e1299.displayName = "FocusLock";
var $2e4eb73a6c3afbd5$export$5cc412d51d00246f = $2e4eb73a6c3afbd5$export$ae70e1f3be7e1299;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";




var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;



function $75dff39d2e471e2c$export$ffa1d90344e68399(props) {
    const { autoFocus: autoFocus, trapFocus: trapFocus, dialogRef: dialogRef, initialFocusRef: initialFocusRef, blockScrollOnMount: blockScrollOnMount, allowPinchZoom: allowPinchZoom, finalFocusRef: finalFocusRef, returnFocusOnClose: returnFocusOnClose, preserveScrollBarGap: preserveScrollBarGap, lockFocusAcrossFrames: lockFocusAcrossFrames, isOpen: isOpen } = (0, $4c6b64192c399b47$export$4cc1699d46f42cae)();
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    (0, $acw62.useEffect)(()=>{
        if (!isPresent && safeToRemove) setTimeout(safeToRemove);
    }, [
        isPresent,
        safeToRemove
    ]);
    const index = (0, $b1474d337f7c7355$export$8557a94b9bb25060)(dialogRef, isOpen);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2e4eb73a6c3afbd5$export$ae70e1f3be7e1299), {
        autoFocus: autoFocus,
        isDisabled: !trapFocus,
        initialFocusRef: initialFocusRef,
        finalFocusRef: finalFocusRef,
        restoreFocus: returnFocusOnClose,
        contentRef: dialogRef,
        lockFocusAcrossFrames: lockFocusAcrossFrames,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
            removeScrollBar: !preserveScrollBarGap,
            allowPinchZoom: allowPinchZoom,
            enabled: index === 1 && blockScrollOnMount,
            forwardProps: true,
            children: props.children
        })
    });
}






var $5be25ee4d24a14dc$export$6da19a24bf249f17 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, children: children, containerProps: rootProps, motionProps: motionProps, ...rest } = props;
    const { getDialogProps: getDialogProps, getDialogContainerProps: getDialogContainerProps } = (0, $4c6b64192c399b47$export$4cc1699d46f42cae)();
    const dialogProps = getDialogProps(rest, ref);
    const containerProps = getDialogContainerProps(rootProps);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__content", className);
    const styles = (0, $4c6b64192c399b47$export$c540eec2ed4454a2)();
    const dialogStyles = {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        outline: 0,
        ...styles.dialog
    };
    const dialogContainerStyles = {
        display: "flex",
        width: "100vw",
        height: "$100vh",
        position: "fixed",
        left: 0,
        top: 0,
        ...styles.dialogContainer
    };
    const { motionPreset: motionPreset } = (0, $4c6b64192c399b47$export$4cc1699d46f42cae)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $75dff39d2e471e2c$export$ffa1d90344e68399), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
            ...containerProps,
            className: "chakra-modal__content-container",
            tabIndex: -1,
            __css: dialogContainerStyles,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $40ec0234c0c5e0df$export$f0a3ab1cc2e7e9a6), {
                preset: motionPreset,
                motionProps: motionProps,
                className: _className,
                ...dialogProps,
                __css: dialogStyles,
                children: children
            })
        })
    });
});
$5be25ee4d24a14dc$export$6da19a24bf249f17.displayName = "ModalContent";





var $f7c00257743a6627$export$519437715052e656 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__footer", className);
    const styles = (0, $4c6b64192c399b47$export$c540eec2ed4454a2)();
    const footerStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        ...styles.footer
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).footer, {
        ref: ref,
        ...rest,
        __css: footerStyles,
        className: _className
    });
});
$f7c00257743a6627$export$519437715052e656.displayName = "ModalFooter";





var $acw62 = parcelRequire("acw62");

var $032b0663279d980b$export$f50a68e3694789ee = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, ...rest } = props;
    const { headerId: headerId, setHeaderMounted: setHeaderMounted } = (0, $4c6b64192c399b47$export$4cc1699d46f42cae)();
    (0, $acw62.useEffect)(()=>{
        setHeaderMounted(true);
        return ()=>setHeaderMounted(false);
    }, [
        setHeaderMounted
    ]);
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__header", className);
    const styles = (0, $4c6b64192c399b47$export$c540eec2ed4454a2)();
    const headerStyles = {
        flex: 0,
        ...styles.header
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).header, {
        ref: ref,
        className: _className,
        id: headerId,
        ...rest,
        __css: headerStyles
    });
});
$032b0663279d980b$export$f50a68e3694789ee.displayName = "ModalHeader";








var $acw62 = parcelRequire("acw62");

var $940ba962ec0fe671$var$variants = {
    enter: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>{
        var _a;
        return {
            opacity: 1,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).enter((0, $6842aa27b422dd93$export$f995eb860f745cb).enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    },
    exit: ({ transition: transition, transitionEnd: transitionEnd, delay: delay } = {})=>{
        var _a;
        return {
            opacity: 0,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).exit((0, $6842aa27b422dd93$export$f995eb860f745cb).exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    }
};
var $940ba962ec0fe671$export$4342735ea5c231d = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: $940ba962ec0fe671$var$variants
};
var $940ba962ec0fe671$export$c983850c6c9d8b0e = (0, $acw62.forwardRef)(function Fade2(props, ref) {
    const { unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, ...rest } = props;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const custom = {
        transition: transition,
        transitionEnd: transitionEnd,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ref: ref,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-fade", className),
            custom: custom,
            ...$940ba962ec0fe671$export$4342735ea5c231d,
            animate: animate,
            ...rest
        })
    });
});
$940ba962ec0fe671$export$c983850c6c9d8b0e.displayName = "Fade";




var $875b8ec845cf2e20$var$MotionDiv = (0, $f1b95b1386d3a42c$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div);
var $875b8ec845cf2e20$export$8948f78d83984c69 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { className: className, transition: transition, motionProps: _motionProps, ...rest } = props;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-modal__overlay", className);
    const styles = (0, $4c6b64192c399b47$export$c540eec2ed4454a2)();
    const overlayStyle = {
        pos: "fixed",
        left: "0",
        top: "0",
        w: "100vw",
        h: "100vh",
        ...styles.overlay
    };
    const { motionPreset: motionPreset } = (0, $4c6b64192c399b47$export$4cc1699d46f42cae)();
    const defaultMotionProps = motionPreset === "none" ? {} : (0, $940ba962ec0fe671$export$4342735ea5c231d);
    const motionProps = _motionProps || defaultMotionProps;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($875b8ec845cf2e20$var$MotionDiv, {
        ...motionProps,
        __css: overlayStyle,
        ref: ref,
        className: _className,
        ...rest
    });
});
$875b8ec845cf2e20$export$8948f78d83984c69.displayName = "ModalOverlay";



const $71747713becad983$export$427af6990c8ff682 = ({ title: title, children: children, callback: callback, isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4c6b64192c399b47$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $875b8ec845cf2e20$export$8948f78d83984c69), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5be25ee4d24a14dc$export$6da19a24bf249f17), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $032b0663279d980b$export$f50a68e3694789ee), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $620ea17661bdce49$export$edf9108895ba774f), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $982b6692e6c88a18$export$cb540d8b0ef7906c), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f7c00257743a6627$export$519437715052e656), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                mr: 3,
                                onClick: callback,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: "Confirm"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                variant: "secondary",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: "Cancel"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $0ce0833c596a8ba3$export$8faedc3900394996 = ()=>{
    const [addresses, setAddresses] = (0, $acw62.useState)([]);
    const [index, setIndex] = (0, $acw62.useState)(1);
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = (0, $7eb48cf89f914f76$export$6e3e27031a30522f)();
    const addAddress = ()=>{
        onClose();
        setAddresses((prevAddresses)=>[
                ...prevAddresses,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6431999e3731c24$export$2e0a83ec2e27ecbb), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e75477aa8f59835a$export$359105212d118848), {
                            index: index
                        }, index)
                    ]
                })
            ]);
        setIndex((prevIndex)=>prevIndex + 1);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $71747713becad983$export$427af6990c8ff682), {
                isOpen: isOpen,
                onClose: onClose,
                title: "Add another business",
                callback: addAddress,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            children: "You are about to add a new entry for another business. Please note that this cannot be removed later, and the only way to complete this form will be to start again."
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                        mt: 3,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            children: "Are you sure you want to add another business?"
                        })
                    })
                ]
            }),
            ...addresses,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bda88d7286fa84ad$export$f51f4c4ede09e011), {
                w: "100%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                        leftIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a03a54a6ef2a295$export$fc799f03c173abf1), {}),
                        variant: "tertiary",
                        onClick: onOpen,
                        padding: 0,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            children: "Add another business"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fcb58e791a7825a$export$d7a54cba636a8cd6), {})
                ]
            })
        ]
    });
};





const $d6e928a9b2a796e1$export$23a1191352d7955b = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $360df5160de66b73$export$eec1f68293554b56), {
        header: "Create practitioner licence details",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "practitioner_name",
                required: true,
                label: "Practitioner name",
                placeholder: "Enter practitioner name",
                errors: {
                    required: "Please enter the practitioner name"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e75477aa8f59835a$export$359105212d118848), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ce0833c596a8ba3$export$8faedc3900394996), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $132d76dd771a3ff6$export$3237a405b221b07), {
                id: "internal_notes",
                label: "Internal notes (optional)"
            })
        ]
    });
};




const $59dc96d2b8b12198$export$68be23f89cd35d24 = ()=>{
    const { step: step } = (0, $acw62.useContext)((0, $bdaa2243693f9b25$export$e2bd290781d68bf1));
    const { getValues: getValues } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const licence_type_id = getValues("licence_type_id");
    if (step === (0, $426f534707ae6ced$export$acae14b34103071f).BASIC_DETAILS) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eba412d90415ed17$export$37c8d0d37cf2f536), {});
    else if (step === (0, $426f534707ae6ced$export$acae14b34103071f).ADDITIONAL_DETAILS) switch((0, $641772106617d27d$export$2b215ce73bbb8647)(licence_type_id)){
        case (0, $f6ccc2005cfc5555$export$699c2130295691b4).CERTIFICATE_PREMISES:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bda7389cb6bcbbd0$export$f7b21db91598a87f), {});
        case (0, $f6ccc2005cfc5555$export$699c2130295691b4).CERTIFICATE_VEHICLE:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588403384091b119$export$222c901bfa2528cf), {});
        case (0, $f6ccc2005cfc5555$export$699c2130295691b4).PRACTITIONER:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6e928a9b2a796e1$export$23a1191352d7955b), {});
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "An error has occurred please try again"
                })
            });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
            children: "An error has occurred please try again"
        })
    });
};










const $71df3cb5cdd82a1d$export$33d8d8ad1089b050 = (props)=>{
    const { hasPermission: hasPermission } = (0, $2d7c7ef6c8da9670$export$dde803638a7db51f)();
    if (!hasPermission(props.permission)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0f429e331c7b6f4b$export$caec2af78bcc877f), {
        status: "error",
        "data-testid": "permissions-guard__alert",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92200e681b16e3f1$export$4a143c8822a09fb4), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a85737e2eeda27d8$export$d4feae172fccda11), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "You do not have permission to perform this action, please contact your administrator."
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: props.children
    });
};



const $a58164f7ff792b0c$export$85a3b20090004421 = ()=>{
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: (0, $aa1c78deb16de548$export$d7e66ef6999696cf)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71df3cb5cdd82a1d$export$33d8d8ad1089b050), {
        permission: (0, $23540125288fb711$export$b7d846e56ce254fb),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
            ...methods,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3eb35d4abe9e46$export$1f54913ccc4368b1), {
                mt: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cc470731e2bfd3d2)),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59dc96d2b8b12198$export$68be23f89cd35d24), {})
            })
        })
    });
};



// src/table.tsx




var [$728262ae280f5d4a$var$TableStylesProvider, $728262ae280f5d4a$export$2975c3d3b5f0252a] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `TableStylesContext`,
    errorMessage: `useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Table />" `
});
var $728262ae280f5d4a$export$54ec01a60f47d33d = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Table", props);
    const { className: className, layout: layout, ...tableProps } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($728262ae280f5d4a$var$TableStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).table, {
            ref: ref,
            __css: {
                tableLayout: layout,
                ...styles.table
            },
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-table", className),
            ...tableProps
        })
    });
});
$728262ae280f5d4a$export$54ec01a60f47d33d.displayName = "Table";

// src/table-container.tsx



var $541cdb1ed093fa3f$export$f2c3aea42b2a048f = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    var _a;
    const { overflow: overflow, overflowX: overflowX, className: className, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-table__container", className),
        ...rest,
        __css: {
            display: "block",
            whiteSpace: "nowrap",
            WebkitOverflowScrolling: "touch",
            overflowX: (_a = overflow != null ? overflow : overflowX) != null ? _a : "auto",
            overflowY: "hidden",
            maxWidth: "100%"
        }
    });
});




var $7bbbcde37b04909c$export$e4d84274604d936d = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $728262ae280f5d4a$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).tbody, {
        ...props,
        ref: ref,
        __css: styles.tbody
    });
});




var $a28a6db82aa7dcca$export$478f015b832c0fb2 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(({ isNumeric: isNumeric, ...rest }, ref)=>{
    const styles = (0, $728262ae280f5d4a$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).th, {
        ...rest,
        ref: ref,
        __css: styles.th,
        "data-is-numeric": isNumeric
    });
});




var $31603346a93eb2e0$export$5de8fa06af5ae15a = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $728262ae280f5d4a$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).thead, {
        ...props,
        ref: ref,
        __css: styles.thead
    });
});




var $06ae2249e71279cf$export$3be148b8762ca608 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $728262ae280f5d4a$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).tr, {
        ...props,
        ref: ref,
        __css: styles.tr
    });
});








var $1f4d8346049498fe$export$8f04ceab90eac988 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(({ isNumeric: isNumeric, ...rest }, ref)=>{
    const styles = (0, $728262ae280f5d4a$export$2975c3d3b5f0252a)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).td, {
        ...rest,
        ref: ref,
        __css: styles.td,
        "data-is-numeric": isNumeric
    });
});


const $6cd02ceffe83c3a3$export$4815ec64a7892ff4 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06ae2249e71279cf$export$3be148b8762ca608), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f4d8346049498fe$export$8f04ceab90eac988), {
            children: props.organisation.name
        })
    });
};





var $acw62 = parcelRequire("acw62");
const $c8cbee78cb80c8bc$var$usePages = ()=>{
    const [page, setPage] = (0, $acw62.useState)(1);
    const movePage = (delta)=>()=>{
            const newPage = page + delta;
            if (newPage < 1) return;
            setPage(page + delta);
        };
    const decrementPage = movePage(-1);
    const incrementPage = movePage(1);
    return {
        movePage: movePage,
        setPage: setPage,
        incrementPage: incrementPage,
        decrementPage: decrementPage,
        page: page
    };
};
var $c8cbee78cb80c8bc$export$2e2bcd8739ae039 = $c8cbee78cb80c8bc$var$usePages;





const $f0e95aa44d6e6aa4$export$68f5e1453c188a82 = (props)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                children: t("paginationSummary", {
                    page: props.pagination.page,
                    totalPages: props.pagination.total_pages
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                    onClick: props.onPrev,
                    isDisabled: props.pagination.page === 1,
                    p: 2,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Previous"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                    onClick: props.onNext,
                    isDisabled: props.pagination.page === props.pagination.total_pages,
                    p: 2,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Next"
                    })
                })
            })
        ]
    });
};




const $319caf0b55e4aabd$export$56f39d25c369e44b = ()=>{
    const { page: page, decrementPage: decrementPage, incrementPage: incrementPage } = (0, $c8cbee78cb80c8bc$export$2e2bcd8739ae039)();
    const { data: data, isLoading: isLoading, isError: isError, error: error } = (0, $0e529258adfac30f$export$9dbe3df0445d7a7b)({
        page: page
    });
    const organisations = data?.data;
    if (isError && error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ce0e8c0ab7a5d29$export$1d64315127b209a), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66bfb0253608fd83$export$5511e886634120cb), {
            error: error
        })
    });
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2), {
        "data-testid": "list-organisations-page__loading"
    });
    if (!organisations || organisations.length === 0 || !data) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
        children: "No results found."
    });
    const rows = organisations.map((organisation)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cd02ceffe83c3a3$export$4815ec64a7892ff4), {
            organisation: organisation
        }, organisation.id));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $71df3cb5cdd82a1d$export$33d8d8ad1089b050), {
        permission: (0, $23540125288fb711$export$539f23a864aa3585),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                ml: 10,
                mt: 10,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                    as: "h1",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Authorities"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $541cdb1ed093fa3f$export$f2c3aea42b2a048f), {
                mx: 10,
                mt: 2,
                mb: 4,
                boxShadow: "md",
                borderRadius: "md",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $728262ae280f5d4a$export$54ec01a60f47d33d), {
                        variant: "rounded",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31603346a93eb2e0$export$5de8fa06af5ae15a), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06ae2249e71279cf$export$3be148b8762ca608), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a28a6db82aa7dcca$export$478f015b832c0fb2), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            children: "Name"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bbbcde37b04909c$export$e4d84274604d936d), {
                                children: rows
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                        align: "flex-end",
                        m: 2,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0e95aa44d6e6aa4$export$68f5e1453c188a82), {
                            pagination: data.meta,
                            onNext: incrementPage,
                            onPrev: decrementPage
                        })
                    })
                ]
            })
        ]
    });
};



// src/container.tsx



var $18cd7e19a577c7ed$export$42a852a2b6b56249 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Container2(props, ref) {
    const { className: className, centerContent: centerContent, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("Container", props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-container", className),
        ...rest,
        __css: {
            ...styles,
            ...centerContent && {
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }
        }
    });
});
$18cd7e19a577c7ed$export$42a852a2b6b56249.displayName = "Container";





var $acw62 = parcelRequire("acw62");
var $aa2a1ef4a8acfa58$export$1acb8639fa37a33a;
(function(BulkUploadType) {
    BulkUploadType["VEHICLE"] = "VEHICLE";
    BulkUploadType["PRACTITIONER"] = "PRACTITIONER";
    BulkUploadType["PREMIS"] = "PREMIS";
})($aa2a1ef4a8acfa58$export$1acb8639fa37a33a || ($aa2a1ef4a8acfa58$export$1acb8639fa37a33a = {}));










const $1780bfa63c312bf3$export$964503283a1b2dff = (props)=>{
    const { mutate: mutate, isLoading: isLoading, isError: isError, error: error } = (0, $0e529258adfac30f$export$ac85db810fc6a0b8)();
    const onClick = ()=>{
        if (!isLoading) mutate({
            params: {
                key: props.path
            }
        }, {
            onSuccess: (response)=>{
                window.open(response.url, "_blank");
            }
        });
    };
    if (isError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66bfb0253608fd83$export$5511e886634120cb), {
        error: error
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a845447b1ebfe73$export$a6c7ac8248d6e38a), {
        variant: "primary",
        href: "#",
        onClick: onClick,
        "data-testid": "protected-resource-link__link",
        children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2), {
            "data-testid": "protected-resource-link__loading"
        }) : props.children
    });
};




// src/list.tsx





var [$283882fe2c2fb711$var$ListStylesProvider, $283882fe2c2fb711$export$cc8f1462c0be9565] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `ListStylesContext`,
    errorMessage: `useListStyles returned is 'undefined'. Seems you forgot to wrap the components in "<List />" `
});
var $283882fe2c2fb711$export$54c2e3dc7acea9f5 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function List2(props, ref) {
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("List", props);
    const { children: children, styleType: styleType = "none", stylePosition: stylePosition, spacing: spacing, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
    const selector = "& > *:not(style) ~ *:not(style)";
    const spacingStyle = spacing ? {
        [selector]: {
            mt: spacing
        }
    } : {};
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($283882fe2c2fb711$var$ListStylesProvider, {
        value: styles,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).ul, {
            ref: ref,
            listStyleType: styleType,
            listStylePosition: stylePosition,
            role: "list",
            __css: {
                ...styles.container,
                ...spacingStyle
            },
            ...rest,
            children: validChildren
        })
    });
});
$283882fe2c2fb711$export$54c2e3dc7acea9f5.displayName = "List";
var $283882fe2c2fb711$export$547f885a1fca4e31 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { as: as, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($283882fe2c2fb711$export$54c2e3dc7acea9f5, {
        ref: ref,
        as: "ol",
        styleType: "decimal",
        marginStart: "1em",
        ...rest
    });
});
$283882fe2c2fb711$export$547f885a1fca4e31.displayName = "OrderedList";
var $283882fe2c2fb711$export$30b2abb1ad323770 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function UnorderedList2(props, ref) {
    const { as: as, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($283882fe2c2fb711$export$54c2e3dc7acea9f5, {
        ref: ref,
        as: "ul",
        styleType: "initial",
        marginStart: "1em",
        ...rest
    });
});
$283882fe2c2fb711$export$30b2abb1ad323770.displayName = "UnorderedList";
var $283882fe2c2fb711$export$a7b06bfba60a8a78 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function ListItem2(props, ref) {
    const styles = $283882fe2c2fb711$export$cc8f1462c0be9565();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).li, {
        ref: ref,
        ...props,
        __css: styles.item
    });
});
$283882fe2c2fb711$export$a7b06bfba60a8a78.displayName = "ListItem";
var $283882fe2c2fb711$export$230671d7ba50d3c8 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function ListIcon2(props, ref) {
    const styles = $283882fe2c2fb711$export$cc8f1462c0be9565();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c7d8d08ac7551ab9$export$f04a61298a47a40f), {
        ref: ref,
        role: "presentation",
        ...props,
        __css: styles.icon
    });
});
$283882fe2c2fb711$export$230671d7ba50d3c8.displayName = "ListIcon";


var $dc757a02f89b9a8a$export$5c65f956a8d65120;
(function(ValidationErrorCode) {
    ValidationErrorCode[ValidationErrorCode["UNKNOWN"] = -1] = "UNKNOWN";
    ValidationErrorCode[ValidationErrorCode["MISSING_FIELD"] = 100] = "MISSING_FIELD";
    ValidationErrorCode[ValidationErrorCode["INVALID_EMAIL"] = 200] = "INVALID_EMAIL";
    ValidationErrorCode[ValidationErrorCode["FIELD_EMPTY"] = 300] = "FIELD_EMPTY";
    ValidationErrorCode[ValidationErrorCode["INVALID_DATE"] = 400] = "INVALID_DATE";
    ValidationErrorCode[ValidationErrorCode["INVALID_VALUE"] = 500] = "INVALID_VALUE";
    ValidationErrorCode[ValidationErrorCode["BULK_UPLOAD_UNKNOWN_FIELD"] = 600] = "BULK_UPLOAD_UNKNOWN_FIELD";
})($dc757a02f89b9a8a$export$5c65f956a8d65120 || ($dc757a02f89b9a8a$export$5c65f956a8d65120 = {}));


const $74a4b27a1a99a47c$export$af1e14e964849c8c = {
    [(0, $dc757a02f89b9a8a$export$5c65f956a8d65120).INVALID_EMAIL]: "Enter a valid email address",
    [(0, $dc757a02f89b9a8a$export$5c65f956a8d65120).MISSING_FIELD]: "This field is required",
    [(0, $dc757a02f89b9a8a$export$5c65f956a8d65120).FIELD_EMPTY]: "This field is required",
    [(0, $dc757a02f89b9a8a$export$5c65f956a8d65120).UNKNOWN]: "An unknown validation error occurred",
    [(0, $dc757a02f89b9a8a$export$5c65f956a8d65120).INVALID_DATE]: "Invalid date (year-month-day) (eg. 2001-01-14)",
    [(0, $dc757a02f89b9a8a$export$5c65f956a8d65120).INVALID_VALUE]: "Invalid value, this field only supports specific values",
    [(0, $dc757a02f89b9a8a$export$5c65f956a8d65120).BULK_UPLOAD_UNKNOWN_FIELD]: "This field is not recognised"
};


const $05b846e53c58b94b$export$7ab04d4c9584557d = (code)=>{
    if (!code) return "";
    return (0, $74a4b27a1a99a47c$export$af1e14e964849c8c)[code];
};




const $fd591ebb05bac595$export$fff596b838433a14 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        layerStyle: "primaryModalAlert",
        "data-testid": "app-alert",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d16df24508f5c77$export$694e0d28c7ffc90c), {
            children: props.children
        })
    });
};





const $8749a6eb8497b8a9$export$9d643c9b597847af = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
        color: "error.icon",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0180d89bb5504dcc$export$7d4f4094ff87ec53), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                textStyle: "textBodyMedium3",
                color: "error.text",
                children: props.children
            })
        ]
    });
};




const $dd2bcda14e64e9cd$export$a0cfbbf97d130bf1 = (props)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        children: props.children
    });
};




const $8184efb51b46d1f8$export$b42f0dfa9258afa9 = (props)=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18cd7e19a577c7ed$export$42a852a2b6b56249), {
        width: "100%",
        maxWidth: "auto",
        padding: 0,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd591ebb05bac595$export$fff596b838433a14), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d16df24508f5c77$export$694e0d28c7ffc90c), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                    maxWidth: (0, $eb59596c7abcbbe0$export$2009667448466d86),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8749a6eb8497b8a9$export$9d643c9b597847af), {
                            children: t("A problem was encountered when processing your file")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd2bcda14e64e9cd$export$a0cfbbf97d130bf1), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$54c2e3dc7acea9f5), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: props.errors.map((error, index)=>{
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                t((0, $05b846e53c58b94b$export$7ab04d4c9584557d)(error.code)),
                                                ": ",
                                                error.path
                                            ]
                                        }, index);
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};



const $ef25cbfa27d468f0$export$e4697407d0c8ff47 = (props)=>{
    return props.condition ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: props.children
    }) : null;
};


const $eb59596c7abcbbe0$export$2009667448466d86 = "540px";
const $eb59596c7abcbbe0$export$f6fb75f68e6e354 = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const { get: getErrorMessage } = (0, $a4c71e3abee08e6a$export$e0e09b7d717f1251)();
    const [type, setType] = (0, $acw62.useState)((0, $aa2a1ef4a8acfa58$export$1acb8639fa37a33a).PREMIS);
    const { mutate: mutate, isLoading: isLoading } = (0, $0e529258adfac30f$export$80d7e80571e8d095)();
    const toast = (0, $a154ce245eea8e38$export$a407b657d3044108)();
    const file = (0, $acw62.useRef)(null);
    const [errors, setErrors] = (0, $acw62.useState)([]);
    const [stagedFileName, setStagedFileName] = (0, $acw62.useState)("");
    const onChangeType = (event)=>{
        setType(event.target.value);
    };
    const actSubmit = (records)=>{
        setErrors([]);
        mutate({
            data: {
                records: records,
                type: type
            }
        }, {
            onSuccess: ()=>{
                toast({
                    title: t("Success"),
                    description: t("Bulk upload successful"),
                    status: "success",
                    duration: 5000
                });
                const input = file.current;
                if (input) {
                    input.value = "";
                    setStagedFileName("");
                }
            },
            onError: (error)=>{
                const validationError = (0, $1a8e7e7ea2d4704f$export$7afbc6ab0d56b4de)(error);
                setErrors(validationError?.validationErrors ?? []);
                toast({
                    title: t("Error"),
                    description: getErrorMessage(error),
                    status: "error",
                    duration: 10000
                });
            }
        });
    };
    const onSubmit = ()=>{
        if (file.current && file.current.files && file.current.files.length > 0) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (typeof reader.result == "string") actSubmit(reader.result);
                else toast({
                    title: t("Error"),
                    description: t("Unknown error, please try again later"),
                    status: "error",
                    duration: 10000
                });
            };
            reader.readAsText(file.current.files[0]);
        }
    };
    const onFileChange = (event)=>{
        const file = event.currentTarget.files?.[0];
        if (file) {
            setStagedFileName(file.name);
            return;
        }
        setStagedFileName("");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71df3cb5cdd82a1d$export$33d8d8ad1089b050), {
        permission: (0, $23540125288fb711$export$b037bb6499b4a085),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
            spacing: "20px",
            gap: "40px",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef25cbfa27d468f0$export$e4697407d0c8ff47), {
                    condition: errors.length > 0,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8184efb51b46d1f8$export$b42f0dfa9258afa9), {
                        errors: errors
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18cd7e19a577c7ed$export$42a852a2b6b56249), {
                    mt: "40px",
                    width: "540px",
                    maxWidth: "75%",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                        as: "h2",
                        variant: "Lt4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            children: "Bulk Upload"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $18cd7e19a577c7ed$export$42a852a2b6b56249), {
                    width: "540px",
                    maxWidth: "75%",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3866dc6a93af5f$export$842aba50ed0ce9d7), {
                            children: t("Licence Type")
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $b9a72dfb200c6dd1$export$ef9b1a59e592288f), {
                            onChange: onChangeType,
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: (0, $aa2a1ef4a8acfa58$export$1acb8639fa37a33a).PREMIS,
                                    selected: type === (0, $aa2a1ef4a8acfa58$export$1acb8639fa37a33a).PREMIS,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        children: "Premises"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: (0, $aa2a1ef4a8acfa58$export$1acb8639fa37a33a).PRACTITIONER,
                                    selected: type === (0, $aa2a1ef4a8acfa58$export$1acb8639fa37a33a).PRACTITIONER,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        children: "Practitioner"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: (0, $aa2a1ef4a8acfa58$export$1acb8639fa37a33a).VEHICLE,
                                    selected: type === (0, $aa2a1ef4a8acfa58$export$1acb8639fa37a33a).VEHICLE,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        children: "Vehicle"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18cd7e19a577c7ed$export$42a852a2b6b56249), {
                    maxWidth: $eb59596c7abcbbe0$export$2009667448466d86,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3866dc6a93af5f$export$842aba50ed0ce9d7), {
                                        children: t("Upload csv file")
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ef127d438f0ac5$export$f5b8910cec6cf069), {
                                        type: "file",
                                        "data-testid": "bulk-upload-page__file",
                                        ref: file,
                                        accept: "text/csv",
                                        hidden: true,
                                        onChange: onFileChange
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fcb58e791a7825a$export$d7a54cba636a8cd6), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                        variant: "quaternary",
                                        onClick: ()=>file.current?.click(),
                                        children: t("Choose file")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef25cbfa27d468f0$export$e4697407d0c8ff47), {
                                condition: stagedFileName.length > 0,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                                    style: {
                                        backgroundColor: "rgba(0, 72, 194, 0.1)",
                                        padding: "5px",
                                        width: "100%",
                                        color: "#6E6764"
                                    },
                                    children: stagedFileName
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $18cd7e19a577c7ed$export$42a852a2b6b56249), {
                    maxWidth: $eb59596c7abcbbe0$export$2009667448466d86,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1780bfa63c312bf3$export$964503283a1b2dff), {
                                path: "/bulk-upload/Special-Procedures-Formatting.pdf",
                                children: t("Formatting Guidelines")
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1780bfa63c312bf3$export$964503283a1b2dff), {
                                path: "/bulk-upload/premis-template.csv",
                                children: t("Download Premises Template")
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1780bfa63c312bf3$export$964503283a1b2dff), {
                                path: "/bulk-upload/vehicle-template.csv",
                                children: t("Download Vehicle Template")
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1780bfa63c312bf3$export$964503283a1b2dff), {
                                path: "/bulk-upload/practitioner-template.csv",
                                children: t("Download Practitioner Template")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18cd7e19a577c7ed$export$42a852a2b6b56249), {
                    maxWidth: "540px",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/create-licence",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                        variant: "secondary",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                            children: "Create Single"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fcb58e791a7825a$export$d7a54cba636a8cd6), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                                alignSelf: "flex-end",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                    isLoading: isLoading,
                                    onClick: onSubmit,
                                    width: "100%",
                                    "data-testid": "bulk-upload-page__submit",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        children: "Submit"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $acb46632cd278e1c$var$defaultTransition = {
    exit: {
        duration: 0.15,
        ease: (0, $6842aa27b422dd93$export$9ee1d08bb6db426f).easeInOut
    },
    enter: {
        type: "spring",
        damping: 25,
        stiffness: 180
    }
};
var $acb46632cd278e1c$var$variants = {
    exit: ({ direction: direction, transition: transition, transitionEnd: transitionEnd, delay: delay })=>{
        var _a;
        const { exit: exitStyles } = (0, $6842aa27b422dd93$export$76af7f35258e628d)({
            direction: direction
        });
        return {
            ...exitStyles,
            transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).exit($acb46632cd278e1c$var$defaultTransition.exit, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
        };
    },
    enter: ({ direction: direction, transitionEnd: transitionEnd, transition: transition, delay: delay })=>{
        var _a;
        const { enter: enterStyles } = (0, $6842aa27b422dd93$export$76af7f35258e628d)({
            direction: direction
        });
        return {
            ...enterStyles,
            transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : (0, $6842aa27b422dd93$export$fc492bd0f1c91c).enter($acb46632cd278e1c$var$defaultTransition.enter, delay),
            transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
        };
    }
};
var $acb46632cd278e1c$export$d8dc01b5c85a37b9 = (0, $acw62.forwardRef)(function Slide2(props, ref) {
    const { direction: direction = "right", style: style, unmountOnExit: unmountOnExit, in: isOpen, className: className, transition: transition, transitionEnd: transitionEnd, delay: delay, motionProps: motionProps, ...rest } = props;
    const transitionStyles = (0, $6842aa27b422dd93$export$76af7f35258e628d)({
        direction: direction
    });
    const computedStyle = Object.assign({
        position: "fixed"
    }, transitionStyles.position, style);
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
        transitionEnd: transitionEnd,
        transition: transition,
        direction: direction,
        delay: delay
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        custom: custom,
        children: show && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            ...rest,
            ref: ref,
            initial: "exit",
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-slide", className),
            animate: animate,
            exit: "exit",
            custom: custom,
            variants: $acb46632cd278e1c$var$variants,
            style: computedStyle,
            ...motionProps
        })
    });
});
$acb46632cd278e1c$export$d8dc01b5c85a37b9.displayName = "Slide";




// src/Hamburger.tsx

var $6f03b4535fc4e4ec$export$e369611dc3dfbf44 = (0, $b9be9a1dd6e65587$export$274edc73af1ae9c8)({
    displayName: "HamburgerIcon",
    viewBox: "0 0 24 24",
    d: "M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z"
});


// src/avatar-context.tsx

var [$55631a1af4b5527c$export$ba63ffea77f18f6b, $55631a1af4b5527c$export$766de4db34c66f23] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `AvatarStylesContext`,
    hookName: `useAvatarStyles`,
    providerName: "<Avatar/>"
});




function $5c9e20ac3232a3a5$export$82a129a7016c8ea8(name) {
    var _a;
    const names = name.split(" ");
    const firstName = (_a = names[0]) != null ? _a : "";
    const lastName = names.length > 1 ? names[names.length - 1] : "";
    return firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
}
function $5c9e20ac3232a3a5$export$1851e4eca212b22f(props) {
    const { name: name, getInitials: getInitials, ...rest } = props;
    const styles = (0, $55631a1af4b5527c$export$766de4db34c66f23)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        role: "img",
        "aria-label": name,
        ...rest,
        __css: styles.label,
        children: name ? getInitials == null ? void 0 : getInitials(name) : null
    });
}
$5c9e20ac3232a3a5$export$1851e4eca212b22f.displayName = "AvatarName";


// src/generic-avatar-icon.tsx


var $0a0761b59db31e95$export$7f80e61621b7c427 = (props)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).svg, {
        viewBox: "0 0 128 128",
        color: "#fff",
        width: "100%",
        height: "100%",
        className: "chakra-avatar__svg",
        ...props,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "currentColor",
                d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
            })
        ]
    });


// src/use-image.ts


var $acw62 = parcelRequire("acw62");
function $ce5e5dab032804f9$export$e4da99f09da8b739(props) {
    const { loading: loading, src: src, srcSet: srcSet, onLoad: onLoad, onError: onError, crossOrigin: crossOrigin, sizes: sizes, ignoreFallback: ignoreFallback } = props;
    const [status, setStatus] = (0, $acw62.useState)("pending");
    (0, $acw62.useEffect)(()=>{
        setStatus(src ? "loading" : "pending");
    }, [
        src
    ]);
    const imageRef = (0, $acw62.useRef)();
    const load = (0, $acw62.useCallback)(()=>{
        if (!src) return;
        flush();
        const img = new Image();
        img.src = src;
        if (crossOrigin) img.crossOrigin = crossOrigin;
        if (srcSet) img.srcset = srcSet;
        if (sizes) img.sizes = sizes;
        if (loading) img.loading = loading;
        img.onload = (event)=>{
            flush();
            setStatus("loaded");
            onLoad == null || onLoad(event);
        };
        img.onerror = (error)=>{
            flush();
            setStatus("failed");
            onError == null || onError(error);
        };
        imageRef.current = img;
    }, [
        src,
        crossOrigin,
        srcSet,
        sizes,
        onLoad,
        onError,
        loading
    ]);
    const flush = ()=>{
        if (imageRef.current) {
            imageRef.current.onload = null;
            imageRef.current.onerror = null;
            imageRef.current = null;
        }
    };
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (ignoreFallback) return void 0;
        if (status === "loading") load();
        return ()=>{
            flush();
        };
    }, [
        status,
        load,
        ignoreFallback
    ]);
    return ignoreFallback ? "loaded" : status;
}
var $ce5e5dab032804f9$export$b80814126d314dea = (status, fallbackStrategy)=>status !== "loaded" && fallbackStrategy === "beforeLoadOrError" || status === "failed" && fallbackStrategy === "onError";




var $acw62 = parcelRequire("acw62");

function $eaa66bbda0f0b407$export$2cd8ae1985206fe8(props) {
    const { src: src, srcSet: srcSet, onError: onError, onLoad: onLoad, getInitials: getInitials, name: name, borderRadius: borderRadius, loading: loading, iconLabel: iconLabel, icon: icon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0a0761b59db31e95$export$7f80e61621b7c427), {}), ignoreFallback: ignoreFallback, referrerPolicy: referrerPolicy, crossOrigin: crossOrigin } = props;
    const status = (0, $ce5e5dab032804f9$export$e4da99f09da8b739)({
        src: src,
        onError: onError,
        crossOrigin: crossOrigin,
        ignoreFallback: ignoreFallback
    });
    const hasLoaded = status === "loaded";
    const showFallback = !src || !hasLoaded;
    if (showFallback) return name ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $5c9e20ac3232a3a5$export$1851e4eca212b22f), {
        className: "chakra-avatar__initials",
        getInitials: getInitials,
        name: name
    }) : (0, $acw62.cloneElement)(icon, {
        role: "img",
        "aria-label": iconLabel
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).img, {
        src: src,
        srcSet: srcSet,
        alt: name,
        onLoad: onLoad,
        referrerPolicy: referrerPolicy,
        crossOrigin: crossOrigin != null ? crossOrigin : void 0,
        className: "chakra-avatar__img",
        loading: loading,
        __css: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: borderRadius
        }
    });
}
$eaa66bbda0f0b407$export$2cd8ae1985206fe8.displayName = "AvatarImage";








var $acw62 = parcelRequire("acw62");

var $ffda53e2ce8b8770$export$360b744af11007ac = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "medium",
    position: "relative",
    flexShrink: 0
};
var $ffda53e2ce8b8770$export$e2255cf6045e8d47 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Avatar", props);
    const [isLoaded, setIsLoaded] = (0, $acw62.useState)(false);
    const { src: src, srcSet: srcSet, name: name, showBorder: showBorder, borderRadius: borderRadius = "full", onError: onError, onLoad: onLoadProp, getInitials: getInitials = (0, $5c9e20ac3232a3a5$export$82a129a7016c8ea8), icon: icon = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0a0761b59db31e95$export$7f80e61621b7c427), {}), iconLabel: iconLabel = " avatar", loading: loading, children: children, borderColor: borderColor, ignoreFallback: ignoreFallback, crossOrigin: crossOrigin, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const avatarStyles = {
        borderRadius: borderRadius,
        borderWidth: showBorder ? "2px" : void 0,
        ...$ffda53e2ce8b8770$export$360b744af11007ac,
        ...styles.container
    };
    if (borderColor) avatarStyles.borderColor = borderColor;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
        ref: ref,
        ...rest,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-avatar", props.className),
        "data-loaded": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isLoaded),
        __css: avatarStyles,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $55631a1af4b5527c$export$ba63ffea77f18f6b), {
            value: styles,
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $eaa66bbda0f0b407$export$2cd8ae1985206fe8), {
                    src: src,
                    srcSet: srcSet,
                    loading: loading,
                    onLoad: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(onLoadProp, ()=>{
                        setIsLoaded(true);
                    }),
                    onError: onError,
                    getInitials: getInitials,
                    name: name,
                    borderRadius: borderRadius,
                    icon: icon,
                    iconLabel: iconLabel,
                    ignoreFallback: ignoreFallback,
                    crossOrigin: crossOrigin
                }),
                children
            ]
        })
    });
});
$ffda53e2ce8b8770$export$e2255cf6045e8d47.displayName = "Avatar";




var $acw62 = parcelRequire("acw62");

var $ba00ccf1f556de7f$export$c25acd513dcc8062 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { icon: icon, children: children, isRound: isRound, "aria-label": ariaLabel, ...rest } = props;
    const element = icon || children;
    const _children = (0, $acw62.isValidElement)(element) ? (0, $acw62.cloneElement)(element, {
        "aria-hidden": true,
        focusable: false
    }) : null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
        padding: "0",
        borderRadius: isRound ? "full" : void 0,
        ref: ref,
        "aria-label": ariaLabel,
        ...rest,
        children: _children
    });
});
$ba00ccf1f556de7f$export$c25acd513dcc8062.displayName = "IconButton";

// src/native-image.tsx


var $1640f3aa64220120$export$1a94f80a613efc3a = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function NativeImage2(props, ref) {
    const { htmlWidth: htmlWidth, htmlHeight: htmlHeight, alt: alt, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("img", {
        width: htmlWidth,
        height: htmlHeight,
        ref: ref,
        alt: alt,
        ...rest
    });
});
$1640f3aa64220120$export$1a94f80a613efc3a.displayName = "NativeImage";





// ../../utilities/object-utils/src/omit.ts
function $e96158f8c291873d$var$omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit)if (key in clone) delete clone[key];
    return clone;
}
var $e96158f8c291873d$export$3e431a229df88919 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function Image2(props, ref) {
    const { fallbackSrc: fallbackSrc, fallback: fallback, src: src, srcSet: srcSet, align: align, fit: fit, loading: loading, ignoreFallback: ignoreFallback, crossOrigin: crossOrigin, fallbackStrategy: fallbackStrategy = "beforeLoadOrError", referrerPolicy: referrerPolicy, ...rest } = props;
    const providedFallback = fallbackSrc !== void 0 || fallback !== void 0;
    const shouldIgnoreFallbackImage = loading != null || ignoreFallback || !providedFallback;
    const status = (0, $ce5e5dab032804f9$export$e4da99f09da8b739)({
        ...props,
        crossOrigin: crossOrigin,
        ignoreFallback: shouldIgnoreFallbackImage
    });
    const showFallbackImage = (0, $ce5e5dab032804f9$export$b80814126d314dea)(status, fallbackStrategy);
    const shared = {
        ref: ref,
        objectFit: fit,
        objectPosition: align,
        ...shouldIgnoreFallbackImage ? rest : $e96158f8c291873d$var$omit(rest, [
            "onError",
            "onLoad"
        ])
    };
    if (showFallbackImage) {
        if (fallback) return fallback;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).img, {
            as: (0, $1640f3aa64220120$export$1a94f80a613efc3a),
            className: "chakra-image__placeholder",
            src: fallbackSrc,
            ...shared
        });
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).img, {
        as: (0, $1640f3aa64220120$export$1a94f80a613efc3a),
        src: src,
        srcSet: srcSet,
        crossOrigin: crossOrigin,
        loading: loading,
        referrerPolicy: referrerPolicy,
        className: "chakra-image",
        ...shared
    });
});
$e96158f8c291873d$export$3e431a229df88919.displayName = "Image";

// src/use-shortcut.ts

var $acw62 = parcelRequire("acw62");
function $32f9a39ae8d1d0c3$var$isPrintableCharacter(event) {
    const { key: key } = event;
    return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
}
function $32f9a39ae8d1d0c3$export$b0ebbe7904d8d94a(props = {}) {
    const { timeout: timeout = 300, preventDefault: preventDefault = ()=>true } = props;
    const [keys, setKeys] = (0, $acw62.useState)([]);
    const timeoutRef = (0, $acw62.useRef)();
    const flush = ()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    const clearKeysAfterDelay = ()=>{
        flush();
        timeoutRef.current = setTimeout(()=>{
            setKeys([]);
            timeoutRef.current = null;
        }, timeout);
    };
    (0, $acw62.useEffect)(()=>flush, []);
    function onKeyDown(fn) {
        return (event)=>{
            if (event.key === "Backspace") {
                const keysCopy = [
                    ...keys
                ];
                keysCopy.pop();
                setKeys(keysCopy);
                return;
            }
            if ($32f9a39ae8d1d0c3$var$isPrintableCharacter(event)) {
                const keysCopy = keys.concat(event.key);
                if (preventDefault(event)) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                setKeys(keysCopy);
                fn(keysCopy.join(""));
                clearKeysAfterDelay();
            }
        };
    }
    return onKeyDown;
}


// src/get-next-item-from-search.ts
function $584ade77564d5759$export$18ed781d9da46f95(items, searchString, itemToString, currentItem) {
    if (searchString == null) return currentItem;
    if (!currentItem) {
        const foundItem = items.find((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
        return foundItem;
    }
    const matchingItems = items.filter((item)=>itemToString(item).toLowerCase().startsWith(searchString.toLowerCase()));
    if (matchingItems.length > 0) {
        let nextIndex;
        if (matchingItems.includes(currentItem)) {
            const currentIndex = matchingItems.indexOf(currentItem);
            nextIndex = currentIndex + 1;
            if (nextIndex === matchingItems.length) nextIndex = 0;
            return matchingItems[nextIndex];
        }
        nextIndex = items.indexOf(matchingItems[0]);
        return items[nextIndex];
    }
    return currentItem;
}


// src/use-event-listeners.ts

var $acw62 = parcelRequire("acw62");
function $8b652ada713b344d$export$43d26308f6d75a57() {
    const listeners = (0, $acw62.useRef)(/* @__PURE__ */ new Map());
    const currentListeners = listeners.current;
    const add = (0, $acw62.useCallback)((el, type, listener, options)=>{
        listeners.current.set(listener, {
            type: type,
            el: el,
            options: options
        });
        el.addEventListener(type, listener, options);
    }, []);
    const remove = (0, $acw62.useCallback)((el, type, listener, options)=>{
        el.removeEventListener(type, listener, options);
        listeners.current.delete(listener);
    }, []);
    (0, $acw62.useEffect)(()=>()=>{
            currentListeners.forEach((value, key)=>{
                remove(value.el, value.type, key, value.options);
            });
        }, [
        remove,
        currentListeners
    ]);
    return {
        add: add,
        remove: remove
    };
}





var $acw62 = parcelRequire("acw62");
function $62678a1f41b1c526$var$isValidElement(event) {
    const element = event.target;
    const { tagName: tagName, isContentEditable: isContentEditable } = element;
    return tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true;
}
function $62678a1f41b1c526$export$ed213cc82e426b1a(props = {}) {
    const { ref: htmlRef, isDisabled: isDisabled, isFocusable: isFocusable, clickOnEnter: clickOnEnter = true, clickOnSpace: clickOnSpace = true, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, tabIndex: tabIndexProp, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, ...htmlProps } = props;
    const [isButton, setIsButton] = (0, $acw62.useState)(true);
    const [isPressed, setIsPressed] = (0, $acw62.useState)(false);
    const listeners = (0, $8b652ada713b344d$export$43d26308f6d75a57)();
    const refCallback = (node)=>{
        if (!node) return;
        if (node.tagName !== "BUTTON") setIsButton(false);
    };
    const tabIndex = isButton ? tabIndexProp : tabIndexProp || 0;
    const trulyDisabled = isDisabled && !isFocusable;
    const handleClick = (0, $acw62.useCallback)((event)=>{
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        const self = event.currentTarget;
        self.focus();
        onClick == null || onClick(event);
    }, [
        isDisabled,
        onClick
    ]);
    const onDocumentKeyUp = (0, $acw62.useCallback)((e)=>{
        if (isPressed && $62678a1f41b1c526$var$isValidElement(e)) {
            e.preventDefault();
            e.stopPropagation();
            setIsPressed(false);
            listeners.remove(document, "keyup", onDocumentKeyUp, false);
        }
    }, [
        isPressed,
        listeners
    ]);
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        onKeyDown == null || onKeyDown(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$62678a1f41b1c526$var$isValidElement(event.nativeEvent) || isButton) return;
        const shouldClickOnEnter = clickOnEnter && event.key === "Enter";
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(true);
        }
        if (shouldClickOnEnter) {
            event.preventDefault();
            const self = event.currentTarget;
            self.click();
        }
        listeners.add(document, "keyup", onDocumentKeyUp, false);
    }, [
        isDisabled,
        isButton,
        onKeyDown,
        clickOnEnter,
        clickOnSpace,
        listeners,
        onDocumentKeyUp
    ]);
    const handleKeyUp = (0, $acw62.useCallback)((event)=>{
        onKeyUp == null || onKeyUp(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) return;
        if (!$62678a1f41b1c526$var$isValidElement(event.nativeEvent) || isButton) return;
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
            event.preventDefault();
            setIsPressed(false);
            const self = event.currentTarget;
            self.click();
        }
    }, [
        clickOnSpace,
        isButton,
        isDisabled,
        onKeyUp
    ]);
    const onDocumentMouseUp = (0, $acw62.useCallback)((event)=>{
        if (event.button !== 0) return;
        setIsPressed(false);
        listeners.remove(document, "mouseup", onDocumentMouseUp, false);
    }, [
        listeners
    ]);
    const handleMouseDown = (0, $acw62.useCallback)((event)=>{
        if (event.button !== 0) return;
        if (isDisabled) {
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (!isButton) setIsPressed(true);
        const target = event.currentTarget;
        target.focus({
            preventScroll: true
        });
        listeners.add(document, "mouseup", onDocumentMouseUp, false);
        onMouseDown == null || onMouseDown(event);
    }, [
        isDisabled,
        isButton,
        onMouseDown,
        listeners,
        onDocumentMouseUp
    ]);
    const handleMouseUp = (0, $acw62.useCallback)((event)=>{
        if (event.button !== 0) return;
        if (!isButton) setIsPressed(false);
        onMouseUp == null || onMouseUp(event);
    }, [
        onMouseUp,
        isButton
    ]);
    const handleMouseOver = (0, $acw62.useCallback)((event)=>{
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        onMouseOver == null || onMouseOver(event);
    }, [
        isDisabled,
        onMouseOver
    ]);
    const handleMouseLeave = (0, $acw62.useCallback)((event)=>{
        if (isPressed) {
            event.preventDefault();
            setIsPressed(false);
        }
        onMouseLeave == null || onMouseLeave(event);
    }, [
        isPressed,
        onMouseLeave
    ]);
    const ref = (0, $457901a59fc0a4e6$export$c9058316764c140e)(htmlRef, refCallback);
    if (isButton) return {
        ...htmlProps,
        ref: ref,
        type: "button",
        "aria-disabled": trulyDisabled ? void 0 : isDisabled,
        disabled: trulyDisabled,
        onClick: handleClick,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
    };
    return {
        ...htmlProps,
        ref: ref,
        role: "button",
        "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(isPressed),
        "aria-disabled": isDisabled ? "true" : void 0,
        tabIndex: trulyDisabled ? void 0 : tabIndex,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        onKeyUp: handleKeyUp,
        onKeyDown: handleKeyDown,
        onMouseOver: handleMouseOver,
        onMouseLeave: handleMouseLeave
    };
}



var $acw62 = parcelRequire("acw62");
var $309c4a16fdb25c6a$var$__defProp = Object.defineProperty;
var $309c4a16fdb25c6a$var$__defNormalProp = (obj, key, value)=>key in obj ? $309c4a16fdb25c6a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $309c4a16fdb25c6a$export$5cb848ba4d1f099 = (obj, key, value)=>{
    $309c4a16fdb25c6a$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
function $309c4a16fdb25c6a$export$96d07f33920abf3e(nodes) {
    return nodes.sort((a, b)=>{
        const compare = a.compareDocumentPosition(b);
        if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
        if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) return 1;
        if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) throw Error("Cannot sort the given nodes.");
        else return 0;
    });
}
var $309c4a16fdb25c6a$export$45a5e7f76e0caa8d = (el)=>typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
function $309c4a16fdb25c6a$export$c42e0e80904d519(current, max, loop) {
    let next = current + 1;
    if (loop && next >= max) next = 0;
    return next;
}
function $309c4a16fdb25c6a$export$1081b7170ed6e343(current, max, loop) {
    let next = current - 1;
    if (loop && next < 0) next = max;
    return next;
}
var $309c4a16fdb25c6a$export$deebe11a338de063 = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $309c4a16fdb25c6a$export$f2db7d5238e1d23f = (value)=>value;


// src/descendant.ts
var $f453e097d0409398$export$e6418ef1851accd = class {
    constructor(){
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "descendants", /* @__PURE__ */ new Map());
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "register", (nodeOrOptions)=>{
            if (nodeOrOptions == null) return;
            if ((0, $309c4a16fdb25c6a$export$45a5e7f76e0caa8d)(nodeOrOptions)) return this.registerNode(nodeOrOptions);
            return (node)=>{
                this.registerNode(node, nodeOrOptions);
            };
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "unregister", (node)=>{
            this.descendants.delete(node);
            const sorted = (0, $309c4a16fdb25c6a$export$96d07f33920abf3e)(Array.from(this.descendants.keys()));
            this.assignIndex(sorted);
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "destroy", ()=>{
            this.descendants.clear();
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "assignIndex", (descendants)=>{
            this.descendants.forEach((descendant)=>{
                const index = descendants.indexOf(descendant.node);
                descendant.index = index;
                descendant.node.dataset["index"] = descendant.index.toString();
            });
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "count", ()=>this.descendants.size);
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "enabledCount", ()=>this.enabledValues().length);
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "values", ()=>{
            const values = Array.from(this.descendants.values());
            return values.sort((a, b)=>a.index - b.index);
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "enabledValues", ()=>{
            return this.values().filter((descendant)=>!descendant.disabled);
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "item", (index)=>{
            if (this.count() === 0) return void 0;
            return this.values()[index];
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "enabledItem", (index)=>{
            if (this.enabledCount() === 0) return void 0;
            return this.enabledValues()[index];
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "first", ()=>this.item(0));
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "firstEnabled", ()=>this.enabledItem(0));
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "last", ()=>this.item(this.descendants.size - 1));
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "lastEnabled", ()=>{
            const lastIndex = this.enabledValues().length - 1;
            return this.enabledItem(lastIndex);
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "indexOf", (node)=>{
            var _a, _b;
            if (!node) return -1;
            return (_b = (_a = this.descendants.get(node)) == null ? void 0 : _a.index) != null ? _b : -1;
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "enabledIndexOf", (node)=>{
            if (node == null) return -1;
            return this.enabledValues().findIndex((i)=>i.node.isSameNode(node));
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "next", (index, loop = true)=>{
            const next = (0, $309c4a16fdb25c6a$export$c42e0e80904d519)(index, this.count(), loop);
            return this.item(next);
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "nextEnabled", (index, loop = true)=>{
            const item = this.item(index);
            if (!item) return;
            const enabledIndex = this.enabledIndexOf(item.node);
            const nextEnabledIndex = (0, $309c4a16fdb25c6a$export$c42e0e80904d519)(enabledIndex, this.enabledCount(), loop);
            return this.enabledItem(nextEnabledIndex);
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "prev", (index, loop = true)=>{
            const prev = (0, $309c4a16fdb25c6a$export$1081b7170ed6e343)(index, this.count() - 1, loop);
            return this.item(prev);
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "prevEnabled", (index, loop = true)=>{
            const item = this.item(index);
            if (!item) return;
            const enabledIndex = this.enabledIndexOf(item.node);
            const prevEnabledIndex = (0, $309c4a16fdb25c6a$export$1081b7170ed6e343)(enabledIndex, this.enabledCount() - 1, loop);
            return this.enabledItem(prevEnabledIndex);
        });
        (0, $309c4a16fdb25c6a$export$5cb848ba4d1f099)(this, "registerNode", (node, options)=>{
            if (!node || this.descendants.has(node)) return;
            const keys = Array.from(this.descendants.keys()).concat(node);
            const sorted = (0, $309c4a16fdb25c6a$export$96d07f33920abf3e)(keys);
            if (options == null ? void 0 : options.disabled) options.disabled = !!options.disabled;
            const descendant = {
                node: node,
                index: -1,
                ...options
            };
            this.descendants.set(node, descendant);
            this.assignIndex(sorted);
        });
    }
};






var $acw62 = parcelRequire("acw62");
function $9e461e0afcb98734$var$useDescendants() {
    const descendants = (0, $acw62.useRef)(new (0, $f453e097d0409398$export$e6418ef1851accd)());
    (0, $309c4a16fdb25c6a$export$deebe11a338de063)(()=>{
        return ()=>descendants.current.destroy();
    });
    return descendants.current;
}
var [$9e461e0afcb98734$var$DescendantsContextProvider, $9e461e0afcb98734$var$useDescendantsContext] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function $9e461e0afcb98734$var$useDescendant(options) {
    const descendants = $9e461e0afcb98734$var$useDescendantsContext();
    const [index, setIndex] = (0, $acw62.useState)(-1);
    const ref = (0, $acw62.useRef)(null);
    (0, $309c4a16fdb25c6a$export$deebe11a338de063)(()=>{
        return ()=>{
            if (!ref.current) return;
            descendants.unregister(ref.current);
        };
    }, []);
    (0, $309c4a16fdb25c6a$export$deebe11a338de063)(()=>{
        if (!ref.current) return;
        const dataIndex = Number(ref.current.dataset["index"]);
        if (index != dataIndex && !Number.isNaN(dataIndex)) setIndex(dataIndex);
    });
    const refCallback = options ? (0, $309c4a16fdb25c6a$export$f2db7d5238e1d23f)(descendants.register(options)) : (0, $309c4a16fdb25c6a$export$f2db7d5238e1d23f)(descendants.register);
    return {
        descendants: descendants,
        index: index,
        enabledIndex: descendants.enabledIndexOf(ref.current),
        register: (0, $457901a59fc0a4e6$export$c9058316764c140e)(refCallback, ref)
    };
}
function $9e461e0afcb98734$export$126c4100f8947d7() {
    const ContextProvider = (0, $309c4a16fdb25c6a$export$f2db7d5238e1d23f)($9e461e0afcb98734$var$DescendantsContextProvider);
    const _useDescendantsContext = ()=>(0, $309c4a16fdb25c6a$export$f2db7d5238e1d23f)($9e461e0afcb98734$var$useDescendantsContext());
    const _useDescendant = (options)=>$9e461e0afcb98734$var$useDescendant(options);
    const _useDescendants = ()=>$9e461e0afcb98734$var$useDescendants();
    return [
        ContextProvider,
        _useDescendantsContext,
        _useDescendants,
        _useDescendant
    ];
}


// src/index.ts

// src/index.ts

var $acw62 = parcelRequire("acw62");

function $3bc081da2876e6e9$export$7080b3e976bc91ab(target, event, handler, options) {
    const listener = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(handler);
    (0, $acw62.useEffect)(()=>{
        const node = typeof target === "function" ? target() : target != null ? target : document;
        if (!handler || !node) return;
        node.addEventListener(event, listener, options);
        return ()=>{
            node.removeEventListener(event, listener, options);
        };
    }, [
        event,
        target,
        options,
        listener,
        handler
    ]);
    return ()=>{
        const node = typeof target === "function" ? target() : target != null ? target : document;
        node == null || node.removeEventListener(event, listener, options);
    };
}





var $acw62 = parcelRequire("acw62");
function $96ef6c3784d3cdb8$var$preventReturnFocus(containerRef) {
    const el = containerRef.current;
    if (!el) return false;
    const activeElement = (0, $534108a0b0d3445d$export$cd4e5573fbe2b576)(el);
    if (!activeElement) return false;
    if (el.contains(activeElement)) return false;
    if ((0, $2d4b29ebc030a42a$export$bebd5a1431fec25d)(activeElement)) return true;
    return false;
}
function $96ef6c3784d3cdb8$export$68b323438c1fbb28(containerRef, options) {
    const { shouldFocus: shouldFocusProp, visible: visible, focusRef: focusRef } = options;
    const shouldFocus = shouldFocusProp && !visible;
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!shouldFocus) return;
        if ($96ef6c3784d3cdb8$var$preventReturnFocus(containerRef)) return;
        const el = (focusRef == null ? void 0 : focusRef.current) || containerRef.current;
        let rafId;
        if (el) {
            rafId = requestAnimationFrame(()=>{
                el.focus({
                    preventScroll: true
                });
            });
            return ()=>{
                cancelAnimationFrame(rafId);
            };
        }
    }, [
        shouldFocus,
        containerRef,
        focusRef
    ]);
}
var $96ef6c3784d3cdb8$var$defaultOptions = {
    preventScroll: true,
    shouldFocus: false
};
function $96ef6c3784d3cdb8$export$54b5c2a5755195e7(target, options = $96ef6c3784d3cdb8$var$defaultOptions) {
    const { focusRef: focusRef, preventScroll: preventScroll, shouldFocus: shouldFocus, visible: visible } = options;
    const element = $96ef6c3784d3cdb8$var$isRefObject(target) ? target.current : target;
    const autoFocusValue = shouldFocus && visible;
    const autoFocusRef = (0, $acw62.useRef)(autoFocusValue);
    const lastVisibleRef = (0, $acw62.useRef)(visible);
    (0, $79d69f59c8a92bff$export$deebe11a338de063)(()=>{
        if (!lastVisibleRef.current && visible) autoFocusRef.current = autoFocusValue;
        lastVisibleRef.current = visible;
    }, [
        visible,
        autoFocusValue
    ]);
    const onFocus = (0, $acw62.useCallback)(()=>{
        if (!visible || !element || !autoFocusRef.current) return;
        autoFocusRef.current = false;
        if (element.contains(document.activeElement)) return;
        if (focusRef == null ? void 0 : focusRef.current) requestAnimationFrame(()=>{
            var _a;
            (_a = focusRef.current) == null || _a.focus({
                preventScroll: preventScroll
            });
        });
        else {
            const tabbableEls = (0, $2858cbef67902129$export$4ae682d253b556eb)(element);
            if (tabbableEls.length > 0) requestAnimationFrame(()=>{
                tabbableEls[0].focus({
                    preventScroll: preventScroll
                });
            });
        }
    }, [
        visible,
        preventScroll,
        element,
        focusRef
    ]);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        onFocus();
    }, [
        onFocus
    ]);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(element, "transitionend", onFocus);
}
function $96ef6c3784d3cdb8$var$isRefObject(val) {
    return "current" in val;
}


// src/utils.ts
var $7ac64574e4f7ffab$var$toVar = (value, fallback)=>({
        var: value,
        varRef: fallback ? `var(${value}, ${fallback})` : `var(${value})`
    });
var $7ac64574e4f7ffab$export$fd62969fb0b7081c = {
    arrowShadowColor: $7ac64574e4f7ffab$var$toVar("--popper-arrow-shadow-color"),
    arrowSize: $7ac64574e4f7ffab$var$toVar("--popper-arrow-size", "8px"),
    arrowSizeHalf: $7ac64574e4f7ffab$var$toVar("--popper-arrow-size-half"),
    arrowBg: $7ac64574e4f7ffab$var$toVar("--popper-arrow-bg"),
    transformOrigin: $7ac64574e4f7ffab$var$toVar("--popper-transform-origin"),
    arrowOffset: $7ac64574e4f7ffab$var$toVar("--popper-arrow-offset")
};
function $7ac64574e4f7ffab$export$bba5a971afe05444(placement) {
    if (placement.includes("top")) return `1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("bottom")) return `-1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("right")) return `-1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("left")) return `1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
}
var $7ac64574e4f7ffab$var$transforms = {
    top: "bottom center",
    "top-start": "bottom left",
    "top-end": "bottom right",
    bottom: "top center",
    "bottom-start": "top left",
    "bottom-end": "top right",
    left: "right center",
    "left-start": "right top",
    "left-end": "right bottom",
    right: "left center",
    "right-start": "left top",
    "right-end": "left bottom"
};
var $7ac64574e4f7ffab$export$4b94194e48e4ec29 = (placement)=>$7ac64574e4f7ffab$var$transforms[placement];
var $7ac64574e4f7ffab$var$defaultEventListeners = {
    scroll: true,
    resize: true
};
function $7ac64574e4f7ffab$export$fafd30a196ad8838(value) {
    let eventListeners;
    if (typeof value === "object") eventListeners = {
        enabled: true,
        options: {
            ...$7ac64574e4f7ffab$var$defaultEventListeners,
            ...value
        }
    };
    else eventListeners = {
        enabled: value,
        options: $7ac64574e4f7ffab$var$defaultEventListeners
    };
    return eventListeners;
}


// src/modifiers.ts
var $dce38e9373762856$export$45d38cc6268103c7 = {
    name: "matchWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: ({ state: state })=>{
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state: state })=>()=>{
            const reference = state.elements.reference;
            state.elements.popper.style.width = `${reference.offsetWidth}px`;
        }
};
var $dce38e9373762856$export$bd7bb1bc943e0611 = {
    name: "transformOrigin",
    enabled: true,
    phase: "write",
    fn: ({ state: state })=>{
        $dce38e9373762856$var$setTransformOrigin(state);
    },
    effect: ({ state: state })=>()=>{
            $dce38e9373762856$var$setTransformOrigin(state);
        }
};
var $dce38e9373762856$var$setTransformOrigin = (state)=>{
    state.elements.popper.style.setProperty((0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).transformOrigin.var, (0, $7ac64574e4f7ffab$export$4b94194e48e4ec29)(state.placement));
};
var $dce38e9373762856$export$36f2614d91c73bb6 = {
    name: "positionArrow",
    enabled: true,
    phase: "afterWrite",
    fn: ({ state: state })=>{
        $dce38e9373762856$var$setArrowStyles(state);
    }
};
var $dce38e9373762856$var$setArrowStyles = (state)=>{
    var _a;
    if (!state.placement) return;
    const overrides = $dce38e9373762856$var$getArrowStyle(state.placement);
    if (((_a = state.elements) == null ? void 0 : _a.arrow) && overrides) {
        Object.assign(state.elements.arrow.style, {
            [overrides.property]: overrides.value,
            width: (0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowSize.varRef,
            height: (0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowSize.varRef,
            zIndex: -1
        });
        const vars = {
            [(0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowSizeHalf.var]: `calc(${(0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowSize.varRef} / 2 - 1px)`,
            [(0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowOffset.var]: `calc(${(0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowSizeHalf.varRef} * -1)`
        };
        for(const property in vars)state.elements.arrow.style.setProperty(property, vars[property]);
    }
};
var $dce38e9373762856$var$getArrowStyle = (placement)=>{
    if (placement.startsWith("top")) return {
        property: "bottom",
        value: (0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("bottom")) return {
        property: "top",
        value: (0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("left")) return {
        property: "right",
        value: (0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowOffset.varRef
    };
    if (placement.startsWith("right")) return {
        property: "left",
        value: (0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowOffset.varRef
    };
};
var $dce38e9373762856$export$616f7fc4ffce8510 = {
    name: "innerArrow",
    enabled: true,
    phase: "main",
    requires: [
        "arrow"
    ],
    fn: ({ state: state })=>{
        $dce38e9373762856$var$setInnerArrowStyles(state);
    },
    effect: ({ state: state })=>()=>{
            $dce38e9373762856$var$setInnerArrowStyles(state);
        }
};
var $dce38e9373762856$var$setInnerArrowStyles = (state)=>{
    if (!state.elements.arrow) return;
    const inner = state.elements.arrow.querySelector("[data-popper-arrow-inner]");
    if (!inner) return;
    const boxShadow = (0, $7ac64574e4f7ffab$export$bba5a971afe05444)(state.placement);
    if (boxShadow) inner.style.setProperty("--popper-arrow-default-shadow", boxShadow);
    Object.assign(inner.style, {
        transform: "rotate(45deg)",
        background: (0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).arrowBg.varRef,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: "inherit",
        boxShadow: `var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))`
    });
};


// src/popper.placement.ts
var $a88d559d3ef3d6bc$var$logicals = {
    "start-start": {
        ltr: "left-start",
        rtl: "right-start"
    },
    "start-end": {
        ltr: "left-end",
        rtl: "right-end"
    },
    "end-start": {
        ltr: "right-start",
        rtl: "left-start"
    },
    "end-end": {
        ltr: "right-end",
        rtl: "left-end"
    },
    start: {
        ltr: "left",
        rtl: "right"
    },
    end: {
        ltr: "right",
        rtl: "left"
    }
};
var $a88d559d3ef3d6bc$var$opposites = {
    "auto-start": "auto-end",
    "auto-end": "auto-start",
    "top-start": "top-end",
    "top-end": "top-start",
    "bottom-start": "bottom-end",
    "bottom-end": "bottom-start"
};
function $a88d559d3ef3d6bc$export$833b022d5a236f09(placement, dir = "ltr") {
    var _a, _b;
    const value = ((_a = $a88d559d3ef3d6bc$var$logicals[placement]) == null ? void 0 : _a[dir]) || placement;
    if (dir === "ltr") return value;
    return (_b = $a88d559d3ef3d6bc$var$opposites[placement]) != null ? _b : value;
}




function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $acw62 = parcelRequire("acw62");
function $dd33383b0026ab21$export$f4d5bf230a36dd6e(props = {}) {
    const { enabled: enabled = true, modifiers: modifiers, placement: placementProp = "bottom", strategy: strategy = "absolute", arrowPadding: arrowPadding = 8, eventListeners: eventListeners = true, offset: offset, gutter: gutter = 8, flip: flip = true, boundary: boundary = "clippingParents", preventOverflow: preventOverflow = true, matchWidth: matchWidth2, direction: direction = "ltr" } = props;
    const reference = (0, $acw62.useRef)(null);
    const popper = (0, $acw62.useRef)(null);
    const instance = (0, $acw62.useRef)(null);
    const placement = (0, $a88d559d3ef3d6bc$export$833b022d5a236f09)(placementProp, direction);
    const cleanup = (0, $acw62.useRef)(()=>{});
    const setupPopper = (0, $acw62.useCallback)(()=>{
        var _a;
        if (!enabled || !reference.current || !popper.current) return;
        (_a = cleanup.current) == null || _a.call(cleanup);
        instance.current = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(reference.current, popper.current, {
            placement: placement,
            modifiers: [
                (0, $dce38e9373762856$export$616f7fc4ffce8510),
                (0, $dce38e9373762856$export$36f2614d91c73bb6),
                (0, $dce38e9373762856$export$bd7bb1bc943e0611),
                {
                    ...(0, $dce38e9373762856$export$45d38cc6268103c7),
                    enabled: !!matchWidth2
                },
                {
                    name: "eventListeners",
                    ...(0, $7ac64574e4f7ffab$export$fafd30a196ad8838)(eventListeners)
                },
                {
                    name: "arrow",
                    options: {
                        padding: arrowPadding
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: offset != null ? offset : [
                            0,
                            gutter
                        ]
                    }
                },
                {
                    name: "flip",
                    enabled: !!flip,
                    options: {
                        padding: 8
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: !!preventOverflow,
                    options: {
                        boundary: boundary
                    }
                },
                ...modifiers != null ? modifiers : []
            ],
            strategy: strategy
        });
        instance.current.forceUpdate();
        cleanup.current = instance.current.destroy;
    }, [
        placement,
        enabled,
        modifiers,
        matchWidth2,
        eventListeners,
        arrowPadding,
        offset,
        gutter,
        flip,
        preventOverflow,
        boundary,
        strategy
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var _a;
            if (!reference.current && !popper.current) {
                (_a = instance.current) == null || _a.destroy();
                instance.current = null;
            }
        };
    }, []);
    const referenceRef = (0, $acw62.useCallback)((node)=>{
        reference.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getReferenceProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(referenceRef, ref)
        }), [
        referenceRef
    ]);
    const popperRef = (0, $acw62.useCallback)((node)=>{
        popper.current = node;
        setupPopper();
    }, [
        setupPopper
    ]);
    const getPopperProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(popperRef, ref),
            style: {
                ...props2.style,
                position: strategy,
                minWidth: matchWidth2 ? void 0 : "max-content",
                inset: "0 auto auto 0"
            }
        }), [
        strategy,
        popperRef,
        matchWidth2
    ]);
    const getArrowProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>{
        const { size: size, shadowColor: shadowColor, bg: bg, style: style, ...rest } = props2;
        return {
            ...rest,
            ref: ref,
            "data-popper-arrow": "",
            style: $dd33383b0026ab21$var$getArrowStyle(props2)
        };
    }, []);
    const getArrowInnerProps = (0, $acw62.useCallback)((props2 = {}, ref = null)=>({
            ...props2,
            ref: ref,
            "data-popper-arrow-inner": ""
        }), []);
    return {
        update () {
            var _a;
            (_a = instance.current) == null || _a.update();
        },
        forceUpdate () {
            var _a;
            (_a = instance.current) == null || _a.forceUpdate();
        },
        transformOrigin: (0, $7ac64574e4f7ffab$export$fd62969fb0b7081c).transformOrigin.varRef,
        referenceRef: referenceRef,
        popperRef: popperRef,
        getPopperProps: getPopperProps,
        getArrowProps: getArrowProps,
        getArrowInnerProps: getArrowInnerProps,
        getReferenceProps: getReferenceProps
    };
}
function $dd33383b0026ab21$var$getArrowStyle(props) {
    const { size: size, shadowColor: shadowColor, bg: bg, style: style } = props;
    const computedStyle = {
        ...style,
        position: "absolute"
    };
    if (size) computedStyle["--popper-arrow-size"] = size;
    if (shadowColor) computedStyle["--popper-arrow-shadow-color"] = shadowColor;
    if (bg) computedStyle["--popper-arrow-bg"] = bg;
    return computedStyle;
}


// src/index.ts


var $acw62 = parcelRequire("acw62");
function $7bea845a3dd58b1a$export$6e3e27031a30522f(props = {}) {
    const { onClose: onCloseProp, onOpen: onOpenProp, isOpen: isOpenProp, id: idProp } = props;
    const handleOpen = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onOpenProp);
    const handleClose = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(onCloseProp);
    const [isOpenState, setIsOpen] = (0, $acw62.useState)(props.defaultIsOpen || false);
    const isOpen = isOpenProp !== void 0 ? isOpenProp : isOpenState;
    const isControlled = isOpenProp !== void 0;
    const uid = (0, $acw62.useId)();
    const id = idProp != null ? idProp : `disclosure-${uid}`;
    const onClose = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(false);
        handleClose == null || handleClose();
    }, [
        isControlled,
        handleClose
    ]);
    const onOpen = (0, $acw62.useCallback)(()=>{
        if (!isControlled) setIsOpen(true);
        handleOpen == null || handleOpen();
    }, [
        isControlled,
        handleOpen
    ]);
    const onToggle = (0, $acw62.useCallback)(()=>{
        if (isOpen) onClose();
        else onOpen();
    }, [
        isOpen,
        onOpen,
        onClose
    ]);
    function getButtonProps(props2 = {}) {
        return {
            ...props2,
            "aria-expanded": isOpen,
            "aria-controls": id,
            onClick (event) {
                var _a;
                (_a = props2.onClick) == null || _a.call(props2, event);
                onToggle();
            }
        };
    }
    function getDisclosureProps(props2 = {}) {
        return {
            ...props2,
            hidden: !isOpen,
            id: id
        };
    }
    return {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        onToggle: onToggle,
        isControlled: isControlled,
        getButtonProps: getButtonProps,
        getDisclosureProps: getDisclosureProps
    };
}


// src/index.ts

var $acw62 = parcelRequire("acw62");

function $61adfc4b64394725$export$71b2224f1ce5e08e(props) {
    const { ref: ref, handler: handler, enabled: enabled = true } = props;
    const savedHandler = (0, $eeeb32c390fb7f0b$export$25bec8c6f54ee79a)(handler);
    const stateRef = (0, $acw62.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    const state = stateRef.current;
    (0, $acw62.useEffect)(()=>{
        if (!enabled) return;
        const onPointerDown = (e)=>{
            if ($61adfc4b64394725$var$isValidEvent(e, ref)) state.isPointerDown = true;
        };
        const onMouseUp = (event)=>{
            if (state.ignoreEmulatedMouseEvents) {
                state.ignoreEmulatedMouseEvents = false;
                return;
            }
            if (state.isPointerDown && handler && $61adfc4b64394725$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const onTouchEnd = (event)=>{
            state.ignoreEmulatedMouseEvents = true;
            if (handler && state.isPointerDown && $61adfc4b64394725$var$isValidEvent(event, ref)) {
                state.isPointerDown = false;
                savedHandler(event);
            }
        };
        const doc = $61adfc4b64394725$var$getOwnerDocument(ref.current);
        doc.addEventListener("mousedown", onPointerDown, true);
        doc.addEventListener("mouseup", onMouseUp, true);
        doc.addEventListener("touchstart", onPointerDown, true);
        doc.addEventListener("touchend", onTouchEnd, true);
        return ()=>{
            doc.removeEventListener("mousedown", onPointerDown, true);
            doc.removeEventListener("mouseup", onMouseUp, true);
            doc.removeEventListener("touchstart", onPointerDown, true);
            doc.removeEventListener("touchend", onTouchEnd, true);
        };
    }, [
        handler,
        ref,
        savedHandler,
        state,
        enabled
    ]);
}
function $61adfc4b64394725$var$isValidEvent(event, ref) {
    var _a;
    const target = event.target;
    if (target) {
        const doc = $61adfc4b64394725$var$getOwnerDocument(target);
        if (!doc.contains(target)) return false;
    }
    return !((_a = ref.current) == null ? void 0 : _a.contains(target));
}
function $61adfc4b64394725$var$getOwnerDocument(node) {
    var _a;
    return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}


// src/index.ts

var $acw62 = parcelRequire("acw62");


function $ed3c43d27f5556ee$export$7ee548861327febe(props) {
    const { isOpen: isOpen, ref: ref } = props;
    const [mounted, setMounted] = (0, $acw62.useState)(isOpen);
    const [once, setOnce] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!once) {
            setMounted(isOpen);
            setOnce(true);
        }
    }, [
        isOpen,
        once,
        mounted
    ]);
    (0, $3bc081da2876e6e9$export$7080b3e976bc91ab)(()=>ref.current, "animationend", ()=>{
        setMounted(isOpen);
    });
    const hidden = isOpen ? false : !mounted;
    return {
        present: !hidden,
        onComplete () {
            var _a;
            const win = (0, $534108a0b0d3445d$export$f21a1ffae260145a)(ref.current);
            const evt = new win.CustomEvent("animationend", {
                bubbles: true
            });
            (_a = ref.current) == null || _a.dispatchEvent(evt);
        }
    };
}








// src/index.ts
function $d3159b9260b16e67$export$76655e7dd9ffc0ba(options) {
    const { wasSelected: wasSelected, enabled: enabled, isSelected: isSelected, mode: mode = "unmount" } = options;
    if (!enabled) return true;
    if (isSelected) return true;
    if (mode === "keepMounted" && wasSelected) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");
var [$1ae7a4685b2fd1cf$export$6bd12c048acae948, $1ae7a4685b2fd1cf$export$fb081774625c317c, $1ae7a4685b2fd1cf$export$c383d7d91778257e, $1ae7a4685b2fd1cf$export$e44adeffd1a0865c] = (0, $9e461e0afcb98734$export$126c4100f8947d7)();
var [$1ae7a4685b2fd1cf$export$62b22d151866115d, $1ae7a4685b2fd1cf$export$21c7ab35b39f78ec] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    strict: false,
    name: "MenuContext"
});
function $1ae7a4685b2fd1cf$var$useIds(idProp, ...prefixes) {
    const reactId = (0, $acw62.useId)();
    const id = idProp || reactId;
    return (0, $acw62.useMemo)(()=>{
        return prefixes.map((prefix)=>`${prefix}-${id}`);
    }, [
        id,
        prefixes
    ]);
}
function $1ae7a4685b2fd1cf$var$getOwnerDocument(node) {
    var _a;
    return (_a = node == null ? void 0 : node.ownerDocument) != null ? _a : document;
}
function $1ae7a4685b2fd1cf$var$isActiveElement(element) {
    const doc = $1ae7a4685b2fd1cf$var$getOwnerDocument(element);
    return doc.activeElement === element;
}
function $1ae7a4685b2fd1cf$export$38eaa17faae8f579(props = {}) {
    const { id: id, closeOnSelect: closeOnSelect = true, closeOnBlur: closeOnBlur = true, initialFocusRef: initialFocusRef, autoSelect: autoSelect = true, isLazy: isLazy, isOpen: isOpenProp, defaultIsOpen: defaultIsOpen, onClose: onCloseProp, onOpen: onOpenProp, placement: placement = "bottom-start", lazyBehavior: lazyBehavior = "unmount", direction: direction, computePositionOnMount: computePositionOnMount = false, ...popperProps } = props;
    const menuRef = (0, $acw62.useRef)(null);
    const buttonRef = (0, $acw62.useRef)(null);
    const descendants = $1ae7a4685b2fd1cf$export$c383d7d91778257e();
    const focusMenu = (0, $acw62.useCallback)(()=>{
        requestAnimationFrame(()=>{
            var _a;
            (_a = menuRef.current) == null || _a.focus({
                preventScroll: false
            });
        });
    }, []);
    const focusFirstItem = (0, $acw62.useCallback)(()=>{
        const id2 = setTimeout(()=>{
            var _a;
            if (initialFocusRef) (_a = initialFocusRef.current) == null || _a.focus();
            else {
                const first = descendants.firstEnabled();
                if (first) setFocusedIndex(first.index);
            }
        });
        timeoutIds.current.add(id2);
    }, [
        descendants,
        initialFocusRef
    ]);
    const focusLastItem = (0, $acw62.useCallback)(()=>{
        const id2 = setTimeout(()=>{
            const last = descendants.lastEnabled();
            if (last) setFocusedIndex(last.index);
        });
        timeoutIds.current.add(id2);
    }, [
        descendants
    ]);
    const onOpenInternal = (0, $acw62.useCallback)(()=>{
        onOpenProp == null || onOpenProp();
        if (autoSelect) focusFirstItem();
        else focusMenu();
    }, [
        autoSelect,
        focusFirstItem,
        focusMenu,
        onOpenProp
    ]);
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose, onToggle: onToggle } = (0, $7bea845a3dd58b1a$export$6e3e27031a30522f)({
        isOpen: isOpenProp,
        defaultIsOpen: defaultIsOpen,
        onClose: onCloseProp,
        onOpen: onOpenInternal
    });
    (0, $61adfc4b64394725$export$71b2224f1ce5e08e)({
        enabled: isOpen && closeOnBlur,
        ref: menuRef,
        handler: (event)=>{
            var _a;
            if (!((_a = buttonRef.current) == null ? void 0 : _a.contains(event.target))) onClose();
        }
    });
    const popper = (0, $dd33383b0026ab21$export$f4d5bf230a36dd6e)({
        ...popperProps,
        enabled: isOpen || computePositionOnMount,
        placement: placement,
        direction: direction
    });
    const [focusedIndex, setFocusedIndex] = (0, $acw62.useState)(-1);
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!isOpen) setFocusedIndex(-1);
    }, [
        isOpen
    ]);
    (0, $96ef6c3784d3cdb8$export$68b323438c1fbb28)(menuRef, {
        focusRef: buttonRef,
        visible: isOpen,
        shouldFocus: true
    });
    const animationState = (0, $ed3c43d27f5556ee$export$7ee548861327febe)({
        isOpen: isOpen,
        ref: menuRef
    });
    const [buttonId, menuId] = $1ae7a4685b2fd1cf$var$useIds(id, `menu-button`, `menu-list`);
    const openAndFocusMenu = (0, $acw62.useCallback)(()=>{
        onOpen();
        focusMenu();
    }, [
        onOpen,
        focusMenu
    ]);
    const timeoutIds = (0, $acw62.useRef)(/* @__PURE__ */ new Set([]));
    $1ae7a4685b2fd1cf$var$useUnmountEffect(()=>{
        timeoutIds.current.forEach((id2)=>clearTimeout(id2));
        timeoutIds.current.clear();
    });
    const openAndFocusFirstItem = (0, $acw62.useCallback)(()=>{
        onOpen();
        focusFirstItem();
    }, [
        focusFirstItem,
        onOpen
    ]);
    const openAndFocusLastItem = (0, $acw62.useCallback)(()=>{
        onOpen();
        focusLastItem();
    }, [
        onOpen,
        focusLastItem
    ]);
    const refocus = (0, $acw62.useCallback)(()=>{
        var _a, _b;
        const doc = $1ae7a4685b2fd1cf$var$getOwnerDocument(menuRef.current);
        const hasFocusWithin = (_a = menuRef.current) == null ? void 0 : _a.contains(doc.activeElement);
        const shouldRefocus = isOpen && !hasFocusWithin;
        if (!shouldRefocus) return;
        const node = (_b = descendants.item(focusedIndex)) == null ? void 0 : _b.node;
        node == null || node.focus();
    }, [
        isOpen,
        focusedIndex,
        descendants
    ]);
    const rafId = (0, $acw62.useRef)(null);
    return {
        openAndFocusMenu: openAndFocusMenu,
        openAndFocusFirstItem: openAndFocusFirstItem,
        openAndFocusLastItem: openAndFocusLastItem,
        onTransitionEnd: refocus,
        unstable__animationState: animationState,
        descendants: descendants,
        popper: popper,
        buttonId: buttonId,
        menuId: menuId,
        forceUpdate: popper.forceUpdate,
        orientation: "vertical",
        isOpen: isOpen,
        onToggle: onToggle,
        onOpen: onOpen,
        onClose: onClose,
        menuRef: menuRef,
        buttonRef: buttonRef,
        focusedIndex: focusedIndex,
        closeOnSelect: closeOnSelect,
        closeOnBlur: closeOnBlur,
        autoSelect: autoSelect,
        setFocusedIndex: setFocusedIndex,
        isLazy: isLazy,
        lazyBehavior: lazyBehavior,
        initialFocusRef: initialFocusRef,
        rafId: rafId
    };
}
function $1ae7a4685b2fd1cf$export$660510f872408795(props = {}, externalRef = null) {
    const menu = $1ae7a4685b2fd1cf$export$21c7ab35b39f78ec();
    const { onToggle: onToggle, popper: popper, openAndFocusFirstItem: openAndFocusFirstItem, openAndFocusLastItem: openAndFocusLastItem } = menu;
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        const eventKey = event.key;
        const keyMap = {
            Enter: openAndFocusFirstItem,
            ArrowDown: openAndFocusFirstItem,
            ArrowUp: openAndFocusLastItem
        };
        const action = keyMap[eventKey];
        if (action) {
            event.preventDefault();
            event.stopPropagation();
            action(event);
        }
    }, [
        openAndFocusFirstItem,
        openAndFocusLastItem
    ]);
    return {
        ...props,
        ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(menu.buttonRef, externalRef, popper.referenceRef),
        id: menu.buttonId,
        "data-active": (0, $abe97432afb3d989$export$5cc3b7b83e34ade7)(menu.isOpen),
        "aria-expanded": menu.isOpen,
        "aria-haspopup": "menu",
        "aria-controls": menu.menuId,
        onClick: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onClick, onToggle),
        onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $1ae7a4685b2fd1cf$var$isTargetMenuItem(target) {
    var _a;
    return $1ae7a4685b2fd1cf$var$isHTMLElement(target) && !!((_a = target == null ? void 0 : target.getAttribute("role")) == null ? void 0 : _a.startsWith("menuitem"));
}
function $1ae7a4685b2fd1cf$export$8dcac42583be8292(props = {}, ref = null) {
    const menu = $1ae7a4685b2fd1cf$export$21c7ab35b39f78ec();
    if (!menu) throw new Error(`useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>`);
    const { focusedIndex: focusedIndex, setFocusedIndex: setFocusedIndex, menuRef: menuRef, isOpen: isOpen, onClose: onClose, menuId: menuId, isLazy: isLazy, lazyBehavior: lazyBehavior, unstable__animationState: animated } = menu;
    const descendants = $1ae7a4685b2fd1cf$export$fb081774625c317c();
    const createTypeaheadHandler = (0, $32f9a39ae8d1d0c3$export$b0ebbe7904d8d94a)({
        preventDefault: (event)=>event.key !== " " && $1ae7a4685b2fd1cf$var$isTargetMenuItem(event.target)
    });
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.target)) return;
        const eventKey = event.key;
        const keyMap = {
            Tab: (event2)=>event2.preventDefault(),
            Escape: onClose,
            ArrowDown: ()=>{
                const next = descendants.nextEnabled(focusedIndex);
                if (next) setFocusedIndex(next.index);
            },
            ArrowUp: ()=>{
                const prev = descendants.prevEnabled(focusedIndex);
                if (prev) setFocusedIndex(prev.index);
            }
        };
        const fn = keyMap[eventKey];
        if (fn) {
            event.preventDefault();
            fn(event);
            return;
        }
        const onTypeahead = createTypeaheadHandler((character)=>{
            const nextItem = (0, $584ade77564d5759$export$18ed781d9da46f95)(descendants.values(), character, (item)=>{
                var _a, _b;
                return (_b = (_a = item == null ? void 0 : item.node) == null ? void 0 : _a.textContent) != null ? _b : "";
            }, descendants.item(focusedIndex));
            if (nextItem) {
                const index = descendants.indexOf(nextItem.node);
                setFocusedIndex(index);
            }
        });
        if ($1ae7a4685b2fd1cf$var$isTargetMenuItem(event.target)) onTypeahead(event);
    }, [
        descendants,
        focusedIndex,
        createTypeaheadHandler,
        onClose,
        setFocusedIndex
    ]);
    const hasBeenOpened = (0, $acw62.useRef)(false);
    if (isOpen) hasBeenOpened.current = true;
    const shouldRenderChildren = (0, $d3159b9260b16e67$export$76655e7dd9ffc0ba)({
        wasSelected: hasBeenOpened.current,
        enabled: isLazy,
        mode: lazyBehavior,
        isSelected: animated.present
    });
    return {
        ...props,
        ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(menuRef, ref),
        children: shouldRenderChildren ? props.children : null,
        tabIndex: -1,
        role: "menu",
        id: menuId,
        style: {
            ...props.style,
            transformOrigin: "var(--popper-transform-origin)"
        },
        "aria-orientation": "vertical",
        onKeyDown: (0, $abe97432afb3d989$export$5bdd3f730ec2c47e)(props.onKeyDown, onKeyDown)
    };
}
function $1ae7a4685b2fd1cf$export$5149508ab5f84d86(props = {}) {
    const { popper: popper, isOpen: isOpen } = $1ae7a4685b2fd1cf$export$21c7ab35b39f78ec();
    return popper.getPopperProps({
        ...props,
        style: {
            visibility: isOpen ? "visible" : "hidden",
            ...props.style
        }
    });
}
function $1ae7a4685b2fd1cf$export$9d32628fc2aea7da(props = {}, externalRef = null) {
    const { onMouseEnter: onMouseEnterProp, onMouseMove: onMouseMoveProp, onMouseLeave: onMouseLeaveProp, onClick: onClickProp, onFocus: onFocusProp, isDisabled: isDisabled, isFocusable: isFocusable, closeOnSelect: closeOnSelect, type: typeProp, ...htmlProps } = props;
    const menu = $1ae7a4685b2fd1cf$export$21c7ab35b39f78ec();
    const { setFocusedIndex: setFocusedIndex, focusedIndex: focusedIndex, closeOnSelect: menuCloseOnSelect, onClose: onClose, menuRef: menuRef, isOpen: isOpen, menuId: menuId, rafId: rafId } = menu;
    const ref = (0, $acw62.useRef)(null);
    const id = `${menuId}-menuitem-${(0, $acw62.useId)()}`;
    const { index: index, register: register } = $1ae7a4685b2fd1cf$export$e44adeffd1a0865c({
        disabled: isDisabled && !isFocusable
    });
    const onMouseEnter = (0, $acw62.useCallback)((event)=>{
        onMouseEnterProp == null || onMouseEnterProp(event);
        if (isDisabled) return;
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        index,
        isDisabled,
        onMouseEnterProp
    ]);
    const onMouseMove = (0, $acw62.useCallback)((event)=>{
        onMouseMoveProp == null || onMouseMoveProp(event);
        if (ref.current && !$1ae7a4685b2fd1cf$var$isActiveElement(ref.current)) onMouseEnter(event);
    }, [
        onMouseEnter,
        onMouseMoveProp
    ]);
    const onMouseLeave = (0, $acw62.useCallback)((event)=>{
        onMouseLeaveProp == null || onMouseLeaveProp(event);
        if (isDisabled) return;
        setFocusedIndex(-1);
    }, [
        setFocusedIndex,
        isDisabled,
        onMouseLeaveProp
    ]);
    const onClick = (0, $acw62.useCallback)((event)=>{
        onClickProp == null || onClickProp(event);
        if (!$1ae7a4685b2fd1cf$var$isTargetMenuItem(event.currentTarget)) return;
        if (closeOnSelect != null ? closeOnSelect : menuCloseOnSelect) onClose();
    }, [
        onClose,
        onClickProp,
        menuCloseOnSelect,
        closeOnSelect
    ]);
    const onFocus = (0, $acw62.useCallback)((event)=>{
        onFocusProp == null || onFocusProp(event);
        setFocusedIndex(index);
    }, [
        setFocusedIndex,
        onFocusProp,
        index
    ]);
    const isFocused = index === focusedIndex;
    const trulyDisabled = isDisabled && !isFocusable;
    (0, $9af20caeda6fe4e1$export$496315a1608d9602)(()=>{
        if (!isOpen) return;
        if (isFocused && !trulyDisabled && ref.current) {
            if (rafId.current) cancelAnimationFrame(rafId.current);
            rafId.current = requestAnimationFrame(()=>{
                var _a;
                (_a = ref.current) == null || _a.focus();
                rafId.current = null;
            });
        } else if (menuRef.current && !$1ae7a4685b2fd1cf$var$isActiveElement(menuRef.current)) menuRef.current.focus({
            preventScroll: true
        });
    }, [
        isFocused,
        trulyDisabled,
        menuRef,
        isOpen
    ]);
    const clickableProps = (0, $62678a1f41b1c526$export$ed213cc82e426b1a)({
        onClick: onClick,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseMove: onMouseMove,
        onMouseLeave: onMouseLeave,
        ref: (0, $457901a59fc0a4e6$export$c9058316764c140e)(register, ref, externalRef),
        isDisabled: isDisabled,
        isFocusable: isFocusable
    });
    return {
        ...htmlProps,
        ...clickableProps,
        type: typeProp != null ? typeProp : clickableProps.type,
        id: id,
        role: "menuitem",
        tabIndex: isFocused ? 0 : -1
    };
}
function $1ae7a4685b2fd1cf$export$8ca3fd7c19c454af(props = {}, ref = null) {
    const { type: type = "radio", isChecked: isChecked, ...rest } = props;
    const ownProps = $1ae7a4685b2fd1cf$export$9d32628fc2aea7da(rest, ref);
    return {
        ...ownProps,
        role: `menuitem${type}`,
        "aria-checked": isChecked
    };
}
function $1ae7a4685b2fd1cf$export$9dcb3089500f52be(props = {}) {
    const { children: children, type: type = "radio", value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, ...htmlProps } = props;
    const isRadio = type === "radio";
    const fallback = isRadio ? "" : [];
    const [value, setValue] = (0, $4795b7ced84aa3c2$export$6f32135080cb4c3)({
        defaultValue: defaultValue != null ? defaultValue : fallback,
        value: valueProp,
        onChange: onChangeProp
    });
    const onChange = (0, $acw62.useCallback)((selectedValue)=>{
        if (type === "radio" && typeof value === "string") setValue(selectedValue);
        if (type === "checkbox" && Array.isArray(value)) {
            const nextValue = value.includes(selectedValue) ? value.filter((item)=>item !== selectedValue) : value.concat(selectedValue);
            setValue(nextValue);
        }
    }, [
        value,
        setValue,
        type
    ]);
    const validChildren = (0, $197fffec5094e9ee$export$b2c43d7d050b2e63)(children);
    const clones = validChildren.map((child)=>{
        if (child.type.id !== "MenuItemOption") return child;
        const onClick = (event)=>{
            var _a, _b;
            onChange(child.props.value);
            (_b = (_a = child.props).onClick) == null || _b.call(_a, event);
        };
        const isChecked = type === "radio" ? child.props.value === value : value.includes(child.props.value);
        return (0, $acw62.cloneElement)(child, {
            type: type,
            onClick: onClick,
            isChecked: isChecked
        });
    });
    return {
        ...htmlProps,
        children: clones
    };
}
function $1ae7a4685b2fd1cf$export$8091e3849c182a6() {
    const { isOpen: isOpen, onClose: onClose } = $1ae7a4685b2fd1cf$export$21c7ab35b39f78ec();
    return {
        isOpen: isOpen,
        onClose: onClose
    };
}
function $1ae7a4685b2fd1cf$var$isHTMLElement(el) {
    var _a;
    if (!$1ae7a4685b2fd1cf$var$isElement(el)) return false;
    const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
    return el instanceof win.HTMLElement;
}
function $1ae7a4685b2fd1cf$var$isElement(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function $1ae7a4685b2fd1cf$var$useUnmountEffect(fn, deps = []) {
    return (0, $acw62.useEffect)(()=>()=>fn(), deps);
}






var $acw62 = parcelRequire("acw62");

var [$828a09c5eeed915a$var$MenuStylesProvider, $828a09c5eeed915a$export$e7aea412cbc2ca01] = (0, $61ba61605ac0202a$export$fd42f52fd3ae1109)({
    name: `MenuStylesContext`,
    errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
});
var $828a09c5eeed915a$export$d9b273488cd8ce6f = (props)=>{
    const { children: children } = props;
    const styles = (0, $77e83ee974fe0992$export$31cdfe60c085d76f)("Menu", props);
    const ownProps = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    const { direction: direction } = (0, $dfd3c776139494e3$export$93d4e7f90805808f)();
    const { descendants: descendants, ...ctx } = (0, $1ae7a4685b2fd1cf$export$38eaa17faae8f579)({
        ...ownProps,
        direction: direction
    });
    const context = (0, $acw62.useMemo)(()=>ctx, [
        ctx
    ]);
    const { isOpen: isOpen, onClose: onClose, forceUpdate: forceUpdate } = context;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1ae7a4685b2fd1cf$export$6bd12c048acae948), {
        value: descendants,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $1ae7a4685b2fd1cf$export$62b22d151866115d), {
            value: context,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($828a09c5eeed915a$var$MenuStylesProvider, {
                value: styles,
                children: (0, $abe97432afb3d989$export$624e501d81f5ffce)(children, {
                    isOpen: isOpen,
                    onClose: onClose,
                    forceUpdate: forceUpdate
                })
            })
        })
    });
};
$828a09c5eeed915a$export$d9b273488cd8ce6f.displayName = "Menu";






var $93dd13af51f64c9e$var$StyledMenuButton = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $828a09c5eeed915a$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).button, {
        ref: ref,
        ...props,
        __css: {
            display: "inline-flex",
            appearance: "none",
            alignItems: "center",
            outline: 0,
            ...styles.button
        }
    });
});
var $93dd13af51f64c9e$export$266a769812832828 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, as: As, ...rest } = props;
    const buttonProps = (0, $1ae7a4685b2fd1cf$export$660510f872408795)(rest, ref);
    const Element = As || $93dd13af51f64c9e$var$StyledMenuButton;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Element, {
        ...buttonProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__menu-button", props.className),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
            __css: {
                pointerEvents: "none",
                flex: "1 1 auto",
                minW: 0
            },
            children: props.children
        })
    });
});
$93dd13af51f64c9e$export$266a769812832828.displayName = "MenuButton";




var $4930e13e2a9811d4$export$1fab7891e4a3c1fd = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const styles = (0, $828a09c5eeed915a$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
        ref: ref,
        ...props,
        __css: styles.command,
        className: "chakra-menu__command"
    });
});
$4930e13e2a9811d4$export$1fab7891e4a3c1fd.displayName = "MenuCommand";





var $acw62 = parcelRequire("acw62");

var $a9b2f41b65be6b53$export$cae703c457e46f23 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { type: type, ...rest } = props;
    const styles = (0, $828a09c5eeed915a$export$e7aea412cbc2ca01)();
    const btnType = rest.as || type ? type != null ? type : void 0 : "button";
    const buttonStyles = (0, $acw62.useMemo)(()=>({
            textDecoration: "none",
            color: "inherit",
            userSelect: "none",
            display: "flex",
            width: "100%",
            alignItems: "center",
            textAlign: "start",
            flex: "0 0 auto",
            outline: 0,
            ...styles.item
        }), [
        styles.item
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).button, {
        ref: ref,
        type: btnType,
        ...rest,
        __css: buttonStyles
    });
});



// src/menu-icon.tsx



var $acw62 = parcelRequire("acw62");

var $7a58d7fe8c7c643f$export$46e1d66043f363e6 = (props)=>{
    const { className: className, children: children, ...rest } = props;
    const child = (0, $acw62.Children).only(children);
    const clone = (0, $acw62.isValidElement)(child) ? (0, $acw62.cloneElement)(child, {
        focusable: "false",
        "aria-hidden": true,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__icon", child.props.className)
    }) : null;
    const _className = (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__icon-wrapper", className);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).span, {
        className: _className,
        ...rest,
        __css: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
        },
        children: clone
    });
};
$7a58d7fe8c7c643f$export$46e1d66043f363e6.displayName = "MenuIcon";





var $20fe282397a2785c$export$2ce376c2cc3355c8 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)((props, ref)=>{
    const { icon: icon, iconSpacing: iconSpacing = "0.75rem", command: command, commandSpacing: commandSpacing = "0.75rem", children: children, ...rest } = props;
    const menuitemProps = (0, $1ae7a4685b2fd1cf$export$9d32628fc2aea7da)(rest, ref);
    const shouldWrap = icon || command;
    const _children = shouldWrap ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            pointerEvents: "none",
            flex: 1
        },
        children: children
    }) : children;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $a9b2f41b65be6b53$export$cae703c457e46f23), {
        ...menuitemProps,
        className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__menuitem", menuitemProps.className),
        children: [
            icon && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7a58d7fe8c7c643f$export$46e1d66043f363e6), {
                fontSize: "0.8em",
                marginEnd: iconSpacing,
                children: icon
            }),
            _children,
            command && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $4930e13e2a9811d4$export$1fab7891e4a3c1fd), {
                marginStart: commandSpacing,
                children: command
            })
        ]
    });
});
$20fe282397a2785c$export$2ce376c2cc3355c8.displayName = "MenuItem";







var $f3e95f6f4a3c5ca7$var$motionVariants = {
    enter: {
        visibility: "visible",
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.2,
            ease: [
                0.4,
                0,
                0.2,
                1
            ]
        }
    },
    exit: {
        transitionEnd: {
            visibility: "hidden"
        },
        opacity: 0,
        scale: 0.8,
        transition: {
            duration: 0.1,
            easings: "easeOut"
        }
    }
};
var $f3e95f6f4a3c5ca7$var$MenuTransition = (0, $f1b95b1386d3a42c$export$7cd122d781af9fa4)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div);
var $f3e95f6f4a3c5ca7$export$d4c4e98c5044dc8 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function MenuList2(props, ref) {
    var _a, _b;
    const { rootProps: rootProps, motionProps: motionProps, ...rest } = props;
    const { isOpen: isOpen, onTransitionEnd: onTransitionEnd, unstable__animationState: animated } = (0, $1ae7a4685b2fd1cf$export$21c7ab35b39f78ec)();
    const listProps = (0, $1ae7a4685b2fd1cf$export$8dcac42583be8292)(rest, ref);
    const positionerProps = (0, $1ae7a4685b2fd1cf$export$5149508ab5f84d86)(rootProps);
    const styles = (0, $828a09c5eeed915a$export$e7aea412cbc2ca01)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ...positionerProps,
        __css: {
            zIndex: (_b = props.zIndex) != null ? _b : (_a = styles.list) == null ? void 0 : _a.zIndex
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f3e95f6f4a3c5ca7$var$MenuTransition, {
            variants: $f3e95f6f4a3c5ca7$var$motionVariants,
            initial: false,
            animate: isOpen ? "enter" : "exit",
            __css: {
                outline: 0,
                ...styles.list
            },
            ...motionProps,
            className: (0, $abe97432afb3d989$export$a274e22fb40f762e)("chakra-menu__menu-list", listProps.className),
            ...listProps,
            onUpdate: onTransitionEnd,
            onAnimationComplete: (0, $abe97432afb3d989$export$9dd9a52f2dd5b9ce)(animated.onComplete, listProps.onAnimationComplete)
        })
    });
});
$f3e95f6f4a3c5ca7$export$d4c4e98c5044dc8.displayName = "MenuList";



var $acw62 = parcelRequire("acw62");



const $db92dc55401bac05$export$cdb7fd9d999c7168 = "66px";
const $db92dc55401bac05$export$5939e41228734fb7 = {
    position: "sticky",
    top: "0",
    width: "100%",
    height: $db92dc55401bac05$export$cdb7fd9d999c7168,
    gridTemplateColumns: "auto 1fr auto",
    padding: "12px",
    placeItems: "center",
    gap: "12px",
    backgroundColor: (0, $590eee45b2f4b5a8$export$5273722fbdc5ce7b),
    borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-800"],
    borderBottomWidth: (0, $590eee45b2f4b5a8$export$3373d970111b7d43),
    boxShadow: `${(0, $590eee45b2f4b5a8$export$54830509930cfa97)}px ${(0, $590eee45b2f4b5a8$export$c7a01a900877df68)}px ${(0, $590eee45b2f4b5a8$export$4cacc6533891eb93)}px ${(0, $590eee45b2f4b5a8$export$59237760b754467e)}px ${(0, $590eee45b2f4b5a8$export$f0a163cab0d1f2a2)}`,
    zIndex: 3
};
const $db92dc55401bac05$export$c9bd49aeadf330bc = {
    justifySelf: "start",
    justifyItems: "center"
};




var $79fa5fd1ba2fc8d4$exports = {};

$79fa5fd1ba2fc8d4$exports = new URL((parcelRequire("27Lyk")).resolve("iEqCv"), import.meta.url).toString();





var $acw62 = parcelRequire("acw62");




const $3a98ca40785264d8$export$9a5b97a7aba1a585 = ()=>{
    const { setToken: setToken, setIsLoggedIn: setIsLoggedIn, setUser: setUser } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const { mutate: mutate, isLoading: isLoading, error: error, isError: isError } = (0, $0e529258adfac30f$export$d816d864bc4e1280)();
    const toast = (0, $a154ce245eea8e38$export$a407b657d3044108)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const logout = ()=>{
        mutate(undefined, {
            onSuccess: ()=>{
                setToken("");
                setUser(undefined);
                setIsLoggedIn(false);
            },
            onError: ()=>{
                toast({
                    title: t("Unable to logout at this time"),
                    status: "error"
                });
            }
        });
    };
    return {
        logout: logout,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
};


// src/skip-nav.tsx


var $f4d025d0c0480605$var$fallbackId = "chakra-skip-nav";
function $f4d025d0c0480605$var$getStyles(styles) {
    return {
        userSelect: "none",
        border: "0",
        height: "1px",
        width: "1px",
        margin: "-1px",
        padding: "0",
        outline: "0",
        overflow: "hidden",
        position: "absolute",
        clip: "rect(0 0 0 0)",
        ...styles,
        _focus: {
            clip: "auto",
            width: "auto",
            height: "auto",
            ...styles["_focus"]
        }
    };
}
var $f4d025d0c0480605$export$345406bcda0ada7e = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function SkipNavLink2(props, ref) {
    const styles = (0, $77e83ee974fe0992$export$b863f77547fbcb03)("SkipLink", props);
    const { id: id = $f4d025d0c0480605$var$fallbackId, ...rest } = (0, $47a6d9fbbf7ee42d$export$adfcf5a5e4d17785)(props);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).a, {
        ...rest,
        ref: ref,
        href: `#${id}`,
        __css: $f4d025d0c0480605$var$getStyles(styles)
    });
});
$f4d025d0c0480605$export$345406bcda0ada7e.displayName = "SkipNavLink";
var $f4d025d0c0480605$export$eb2a97be934b94b7 = (0, $ccbd86c9321ccea7$export$257a8862b851cb5b)(function SkipNavContent2(props, ref) {
    const { id: id = $f4d025d0c0480605$var$fallbackId, ...rest } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $f1b95b1386d3a42c$export$7cd122d781af9fa4).div, {
        ref: ref,
        id: id,
        tabIndex: -1,
        style: {
            outline: 0
        },
        ...rest
    });
});
$f4d025d0c0480605$export$eb2a97be934b94b7.displayName = "SkipNavContent";


const $e1131a681a58b314$export$8b251419efc915eb = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const { isSearchPanelOpen: isSearchPanelOpen, setIsSearchPanelOpen: setIsSearchPanelOpen } = (0, $acw62.useContext)((0, $129fac05c2fc563a$export$abe847132b142195));
    const { logout: logout } = (0, $3a98ca40785264d8$export$9a5b97a7aba1a585)();
    const { i18n: i18n } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const onLanguageChange = (lang)=>{
        sessionStorage.setItem("language", lang);
        i18n.changeLanguage(lang);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4d025d0c0480605$export$345406bcda0ada7e), {
                zIndex: 99,
                id: "content-start",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "Skip to content"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $296d8d3041dfdf15$export$de97fecb6d4b30a5), {
                sx: (0, $db92dc55401bac05$export$5939e41228734fb7),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                        variant: "link",
                        onClick: ()=>setIsSearchPanelOpen(!isSearchPanelOpen),
                        "aria-label": "Clickable, opens Search Panel.",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f03b4535fc4e4ec$export$e369611dc3dfbf44), {
                            h: "24px",
                            w: "24px",
                            color: (0, $590eee45b2f4b5a8$export$90cfbd2e6796672c)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bda88d7286fa84ad$export$f51f4c4ede09e011), {
                        sx: (0, $db92dc55401bac05$export$c9bd49aeadf330bc),
                        direction: {
                            base: "column",
                            md: "row"
                        },
                        gap: {
                            base: "0",
                            md: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$381f0d4736587f5e))
                        },
                        align: {
                            base: "flex-start",
                            md: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                                as: "p",
                                variant: {
                                    base: "Md6Primary",
                                    md: "Md4Primary",
                                    sm: "Md6Primary"
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        children: "SPECIAL PROCEDURES"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                                as: "p",
                                variant: {
                                    base: "Lt6",
                                    md: "Lt4",
                                    sm: "Lt6"
                                },
                                fontWeight: "200",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: "PUBLIC REGISTER"
                                })
                            })
                        ]
                    }),
                    isLoggedIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
                        spacing: "12px",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $828a09c5eeed915a$export$d9b273488cd8ce6f), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93dd13af51f64c9e$export$266a769812832828), {
                                        as: (0, $ba00ccf1f556de7f$export$c25acd513dcc8062),
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffda53e2ce8b8770$export$e2255cf6045e8d47), {
                                            size: "sm"
                                        }),
                                        variant: "solid",
                                        colorScheme: "white"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3e95f6f4a3c5ca7$export$d4c4e98c5044dc8), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20fe282397a2785c$export$2ce376c2cc3355c8), {
                                            onClick: logout,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                                children: "Sign out"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e96158f8c291873d$export$3e431a229df88919), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($79fa5fd1ba2fc8d4$exports))),
                                alt: "RHE logo"
                            })
                        ]
                    }) : i18n.language === (0, $f6ccc2005cfc5555$export$ce4fe1c9e6520c1a).en || i18n.language === undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: ()=>onLanguageChange((0, $f6ccc2005cfc5555$export$ce4fe1c9e6520c1a).cy),
                        "aria-label": "Change language to Cymraeg",
                        children: "Cymraeg"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                        variant: "outline",
                        onClick: ()=>onLanguageChange((0, $f6ccc2005cfc5555$export$ce4fe1c9e6520c1a).en),
                        "aria-label": "Change language to English",
                        children: "English"
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");


var $540d645d063bea67$exports = {};

$540d645d063bea67$exports = new URL((parcelRequire("27Lyk")).resolve("2MWcm"), import.meta.url).toString();



parcelRequire("acw62");
const $11770de72a0a2eb4$var$RheLogoVector = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 2592 864",
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("style", {
                    children: [
                        ".cls-1 { opacity: .5;}",
                        ".cls-1, .cls-2 { fill: #fff; }",
                        ".cls-3 { fill: #231f20; opacity: 0; }"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                id: "outline",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    className: "cls-3",
                    x: "144",
                    y: "144",
                    width: "2304",
                    height: "576"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                id: "matrix",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "180",
                        cy: "180",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "252",
                        cy: "180",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "324",
                        cy: "180",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "396",
                        cy: "180",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "468",
                        cy: "180",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "540",
                        cy: "180",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "180",
                        cy: "252",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "252",
                        cy: "252",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "324",
                        cy: "252",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "396",
                        cy: "252",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "468",
                        cy: "252",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "540",
                        cy: "252",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "180",
                        cy: "324",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "252",
                        cy: "324",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "324",
                        cy: "324",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "396",
                        cy: "324",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "468",
                        cy: "324",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "540",
                        cy: "324",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "180",
                        cy: "396",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "252",
                        cy: "396",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "324",
                        cy: "396",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "396",
                        cy: "396",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "468",
                        cy: "396",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "540",
                        cy: "396",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "180",
                        cy: "468",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "252",
                        cy: "468",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "324",
                        cy: "468",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "396",
                        cy: "468",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "468",
                        cy: "468",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "540",
                        cy: "468",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "180",
                        cy: "540",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "252",
                        cy: "540",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "324",
                        cy: "540",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "396",
                        cy: "540",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "468",
                        cy: "540",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "540",
                        cy: "540",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "180",
                        cy: "612",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "252",
                        cy: "612",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "324",
                        cy: "612",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "396",
                        cy: "612",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "468",
                        cy: "612",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "540",
                        cy: "612",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "180",
                        cy: "684",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "252",
                        cy: "684",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "324",
                        cy: "684",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "396",
                        cy: "684",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "468",
                        cy: "684",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "540",
                        cy: "684",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "612",
                        cy: "180",
                        r: "21"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "cls-1",
                        cx: "612",
                        cy: "684",
                        r: "21"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                id: "letterforms",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        className: "cls-2",
                        d: "M939.61,543.73h45.91c3.37-7.99,6.37-16.16,9.02-24.5h-54.93v24.5ZM1006.21,464.07h-66.31v23.9h62.64c1.55-7.86,2.77-15.83,3.67-23.9M682.42,491.65c3.3-3.92,4.95-8.2,4.95-12.85,0-4.98-1.8-9.24-5.4-12.8-3.6-3.55-7.6-5.33-12-5.33h-22.3v36.85h22.3c5,0,9.15-1.96,12.45-5.88M875.51,576h-38.9v-57.76h-49.9v57.76h-38.9v-144h38.9v54.57h49.9v-54.57h38.9v144ZM703.57,520.23l25.4,55.77h-39.9l-21-49.59h-20.4v49.59h-38.9v-144h65.6c12.53,0,22.62,2.06,30.25,6.17,7.63,4.12,13.18,9.68,16.65,16.68,3.46,7.01,5.2,14.86,5.2,23.55,0,11.02-2.13,19.72-6.4,26.09-4.27,6.37-9.77,11.62-16.5,15.74M900.71,432h107.29c0-159.06-128.94-288-288-288s-288,128.94-288,288,128.94,288,288,288c106.6,0,199.66-57.92,249.46-144h-68.75v-144Z"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                className: "cls-2",
                                d: "M1143.42,577.99c-13.47,0-25.16-3.05-35.07-9.15-9.92-6.1-17.63-14.66-23.13-25.67-5.51-11.01-8.26-23.88-8.26-38.61s2.89-28.26,8.66-39.4c5.77-11.14,13.8-19.77,24.08-25.87,10.28-6.1,22.19-9.15,35.72-9.15,9.09,0,17.33,1.43,24.73,4.28,7.4,2.85,13.75,6.7,19.05,11.54,5.31,4.84,9.43,10.32,12.39,16.42,2.95,6.1,4.53,12.44,4.73,19h-35.52c-1.33-6.37-4.2-11.79-8.61-16.27-4.41-4.48-10.27-6.72-17.56-6.72-5.64,0-10.76,1.46-15.37,4.38-4.61,2.92-8.31,7.68-11.09,14.28-2.79,6.6-4.18,15.44-4.18,26.52,0,9.15.95,16.65,2.84,22.49,1.89,5.84,4.39,10.38,7.51,13.63,3.12,3.25,6.57,5.52,10.35,6.82,3.78,1.29,7.56,1.94,11.34,1.94,4.64,0,8.71-.95,12.19-2.84,3.48-1.89,6.27-4.24,8.36-7.06,2.09-2.82,3.43-5.62,4.03-8.41l1.49-6.97h-27.46v-23.08l63.08.3v75.62h-22.69v-17.31c-2.45,2.85-5.41,5.77-8.86,8.76-3.45,2.98-7.81,5.49-13.08,7.51s-11.83,3.04-19.65,3.04Z"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                className: "cls-2",
                                d: "M1268.49,577.99c-8.56,0-15.27-.95-20.15-2.84-4.88-1.89-8.44-4.39-10.7-7.51-2.26-3.12-3.67-6.57-4.23-10.35-.56-3.78-.85-7.53-.85-11.24v-117.91h33.13v113.53c0,3.12.73,5.82,2.19,8.11,1.46,2.29,4.61,3.73,9.45,4.33l4.48.3v20.8c-2.12.8-4.33,1.46-6.62,1.99-2.29.53-4.53.8-6.72.8Z"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                className: "cls-2",
                                d: "M1340.33,577.99c-10.35,0-19.34-2.21-26.96-6.62-7.63-4.41-13.53-10.56-17.71-18.46-4.18-7.89-6.27-17.15-6.27-27.76s2.14-20.18,6.42-28.31c4.28-8.12,10.25-14.44,17.91-18.96,7.66-4.51,16.6-6.77,26.82-6.77s19.42,2.27,27.01,6.82c7.59,4.54,13.47,10.88,17.61,19,4.14,8.13,6.22,17.53,6.22,28.21s-2.06,19.4-6.17,27.36c-4.11,7.96-9.98,14.2-17.61,18.71-7.63,4.51-16.72,6.77-27.26,6.77ZM1340.53,553.12c4.58,0,8.16-1.44,10.75-4.33,2.59-2.89,4.41-6.57,5.47-11.04,1.06-4.48,1.59-9.04,1.59-13.68s-.5-9.04-1.49-13.38c-.99-4.34-2.79-7.94-5.37-10.8-2.59-2.85-6.24-4.28-10.94-4.28s-8.38,1.38-11,4.13c-2.62,2.75-4.46,6.3-5.52,10.65-1.06,4.35-1.59,8.91-1.59,13.68,0,4.51.5,9,1.49,13.48.99,4.48,2.8,8.19,5.42,11.14,2.62,2.95,6.35,4.43,11.19,4.43Z"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                className: "cls-2",
                                d: "M1469.48,577.99c-9.22,0-16.33-2.24-21.34-6.72-5.01-4.48-8.54-9.93-10.6-16.37l-3.98,21.09h-24.18v-147.86h33.93v57.81c2.85-4.84,6.96-8.52,12.34-11.04,5.37-2.52,11.18-3.78,17.41-3.78,12.67,0,22.59,4.68,29.75,14.03,7.16,9.35,10.75,22.29,10.75,38.81s-3.77,29.4-11.29,39.25c-7.53,9.85-18.46,14.78-32.79,14.78ZM1461.72,554.01c5.37,0,9.87-2.27,13.48-6.82,3.62-4.54,5.42-12.35,5.42-23.43,0-10.15-1.78-17.43-5.32-21.84-3.55-4.41-8.11-6.62-13.68-6.62s-10.33,2.27-13.48,6.82c-3.15,4.54-4.76,11.76-4.83,21.64,0,11.14,1.59,18.97,4.78,23.48,3.18,4.51,7.73,6.77,13.63,6.77Z"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                className: "cls-2",
                                d: "M1562.51,577.99c-6.57,0-12.5-1.24-17.81-3.73-5.31-2.49-9.52-6.12-12.64-10.9-3.12-4.78-4.68-10.61-4.68-17.51,0-11.21,4.31-19.83,12.93-25.87,8.62-6.04,22.15-9.09,40.6-9.15l10.45-.1v-5.27c0-8.16-4.71-12.17-14.13-12.04-3.52.13-7.01.98-10.5,2.54-3.48,1.56-5.95,4.4-7.41,8.51h-27.76c.33-7.76,2.6-14.1,6.82-19,4.21-4.91,9.82-8.52,16.82-10.85,7-2.32,14.84-3.48,23.53-3.48,11.21,0,20.11,1.33,26.72,3.98,6.6,2.65,11.31,6.4,14.13,11.24,2.82,4.84,4.23,10.51,4.23,17.01v72.63h-28.16l-2.89-17.01c-3.32,7.23-7.41,12.21-12.29,14.92-4.88,2.72-10.86,4.08-17.96,4.08ZM1574.16,556.2c4.51,0,8.49-1.49,11.94-4.48,3.45-2.98,5.21-6.43,5.27-10.35v-14.03l-8.36.1c-3.45,0-7,.46-10.65,1.39-3.65.93-6.75,2.47-9.3,4.63-2.55,2.16-3.83,5.12-3.83,8.91,0,4.38,1.48,7.78,4.43,10.2,2.95,2.42,6.45,3.63,10.5,3.63Z"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                className: "cls-2",
                                d: "M1681.02,577.99c-8.56,0-15.27-.95-20.15-2.84-4.88-1.89-8.44-4.39-10.7-7.51-2.26-3.12-3.67-6.57-4.23-10.35-.56-3.78-.85-7.53-.85-11.24v-117.91h33.13v113.53c0,3.12.73,5.82,2.19,8.11,1.46,2.29,4.61,3.73,9.45,4.33l4.48.3v20.8c-2.12.8-4.33,1.46-6.62,1.99-2.29.53-4.53.8-6.72.8Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $11770de72a0a2eb4$export$2e2bcd8739ae039 = $11770de72a0a2eb4$var$RheLogoVector;



const $a453b9a38a1f36da$var$Footer = ()=>{
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        color: $590eee45b2f4b5a8$export$6aefc03aa88b5914,
        p: 8,
        bg: $590eee45b2f4b5a8$export$fa0abf3b9ffec737,
        w: "100%",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
                spacing: [
                    $590eee45b2f4b5a8$export$a275cc59cf419b0e,
                    $590eee45b2f4b5a8$export$3ba0070c9b17960f,
                    $590eee45b2f4b5a8$export$cc470731e2bfd3d2
                ],
                align: {
                    base: "start",
                    md: "center"
                },
                flexDirection: [
                    "column",
                    "row",
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
                        align: "start",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a845447b1ebfe73$export$a6c7ac8248d6e38a), {
                                href: "https://rheglobal.com",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11770de72a0a2eb4$export$2e2bcd8739ae039), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e96158f8c291873d$export$3e431a229df88919), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($540d645d063bea67$exports))),
                            alt: "Logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                                fontWeight: "bold",
                                children: t("Help")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $283882fe2c2fb711$export$54c2e3dc7acea9f5), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a845447b1ebfe73$export$a6c7ac8248d6e38a), {
                                            href: "https://sso.rheglobal.com/licences/98",
                                            color: $590eee45b2f4b5a8$export$6aefc03aa88b5914,
                                            textDecoration: "none",
                                            isExternal: true,
                                            children: t("Accessibility")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a845447b1ebfe73$export$a6c7ac8248d6e38a), {
                                            href: "https://www.rheglobal.com/contact",
                                            color: $590eee45b2f4b5a8$export$6aefc03aa88b5914,
                                            textDecoration: "none",
                                            isExternal: true,
                                            children: t("Contact")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                                fontWeight: "bold",
                                children: t("Legal")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $283882fe2c2fb711$export$54c2e3dc7acea9f5), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a845447b1ebfe73$export$a6c7ac8248d6e38a), {
                                            href: "https://www.rheglobal.com/copyright",
                                            color: $590eee45b2f4b5a8$export$6aefc03aa88b5914,
                                            textDecoration: "none",
                                            isExternal: true,
                                            children: t("Copyright")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a845447b1ebfe73$export$a6c7ac8248d6e38a), {
                                            href: "https://sso.rheglobal.com/licences/103",
                                            color: $590eee45b2f4b5a8$export$6aefc03aa88b5914,
                                            textDecoration: "none",
                                            isExternal: true,
                                            children: t("Terms Conditions")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                mt: 10,
                children: [
                    "\xa9 ",
                    t("RH Environmental Limited trading as RHE Global. All rights reserved.")
                ]
            })
        ]
    });
};
var $a453b9a38a1f36da$export$2e2bcd8739ae039 = $a453b9a38a1f36da$var$Footer;





const $2e250b55aac098ac$export$2544460dd150867e = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["shadow-600"],
    overflow: "hidden"
};
const $2e250b55aac098ac$export$83fb4597a681c2cd = {
    ...$2e250b55aac098ac$export$2544460dd150867e,
    backgroundColor: "transparent"
};





var $acw62 = parcelRequire("acw62");

const $72dafde69d16e920$export$cde958be9143af49 = ()=>{
    const { isSearchPanelOpen: isSearchPanelOpen, setIsSearchPanelOpen: setIsSearchPanelOpen } = (0, $acw62.useContext)((0, $129fac05c2fc563a$export$abe847132b142195));
    const { width: width } = (0, $8d07841d42af443e$export$2e2bcd8739ae039)();
    if (isSearchPanelOpen) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        onClick: ()=>setIsSearchPanelOpen(false),
        sx: width <= parseInt((0, $16f660dc0005d97b$export$d07517a676ce386f).md) ? (0, $2e250b55aac098ac$export$2544460dd150867e) : (0, $2e250b55aac098ac$export$83fb4597a681c2cd)
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
};





var $acw62 = parcelRequire("acw62");




function $1720d3c36782d8c4$export$82eafebb825fc23f({ height: height = "18px", width: width = "18px" }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
        as: "svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        fill: "none",
        width: width,
        height: height,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.59 12.41 8.11 13 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z",
            fill: "#5E5856"
        })
    });
}









const $04d61b1b2866b161$export$93e9d161a81c711b = {
    top: (0, $db92dc55401bac05$export$cdb7fd9d999c7168),
    height: `100vh - ${(0, $db92dc55401bac05$export$cdb7fd9d999c7168)}`,
    width: "320px",
    zIndex: 1
};
const $04d61b1b2866b161$export$b405035a3b0458d2 = {
    height: "100%",
    width: "320px",
    backgroundColor: (0, $590eee45b2f4b5a8$export$5273722fbdc5ce7b),
    boxShadow: (0, $6abc8dde70ddd647$export$2c54b9c78c14ff3f)((0, $590eee45b2f4b5a8$export$ffc743971d90eb81), (0, $590eee45b2f4b5a8$export$9bfdd7a586c47c19), (0, $590eee45b2f4b5a8$export$6a6166d2e7fa4d69), (0, $590eee45b2f4b5a8$export$a3249067ec37b98f), (0, $590eee45b2f4b5a8$export$bc6c3059b6b4ed6a)),
    overflowX: "hidden",
    overflowY: "scroll"
};








const $3a7b570d8d88d4b0$export$4b97a00585c854ae = ({ id: id = "localAuthority", required: required = false, enabled: enabled = true })=>{
    const language = (0, $e8ef5ee6ff8929e0$export$c1fd9f444a3dc711)();
    const { data: localAuthorities, isLoading: isLoading } = (0, $0e529258adfac30f$export$fd2e5ba55b656870)({
        language: language
    }, {
        query: {
            enabled: enabled
        }
    });
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2), {});
    if (!localAuthorities) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e93eb28e913cc8a3$export$40d561691c647821), {
        id: id,
        label: "Local authority",
        required: required,
        placeholder: "Select local authority",
        children: localAuthorities.results.map(({ name: name, local_authority_id: local_authority_id }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                value: local_authority_id,
                children: name
            }, index))
    });
};




const $d1e87dc11312064a$export$4c7a03676454bcb7 = ()=>{
    const { isSearchPanelOpen: isSearchPanelOpen } = (0, $acw62.useContext)((0, $129fac05c2fc563a$export$abe847132b142195));
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)();
    const { register: register, handleSubmit: handleSubmit } = methods;
    const { isLoggedIn: isLoggedIn } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const [hasSearched, setHasSearched] = (0, $acw62.useState)(false);
    const { setIsSearchPanelOpen: setIsSearchPanelOpen } = (0, $acw62.useContext)((0, $129fac05c2fc563a$export$abe847132b142195));
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { width: width } = (0, $8d07841d42af443e$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    const focusTitle = ()=>{
        const title = document.getElementById("search-title");
        if (title) title.focus();
    };
    const onSubmit = (data)=>{
        if (width <= parseInt((0, $16f660dc0005d97b$export$d07517a676ce386f).sm)) setIsSearchPanelOpen(false);
        setHasSearched(true);
        const normalisedData = {};
        let key;
        for(key in data){
            const value = data[key];
            if (!value || value.length === 0) continue;
            if (Array.isArray(value)) {
                normalisedData[key] = value.join();
                continue;
            }
            normalisedData[key] = value;
        }
        const params = new URLSearchParams(normalisedData);
        focusTitle();
        navigate(`/search?${params.toString()}`);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
        ...methods,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
            style: {
                height: "100%"
            },
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                sx: {
                    ...(0, $04d61b1b2866b161$export$b405035a3b0458d2),
                    "@media(min-height:836px)": {
                        overflowY: "hidden"
                    }
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                    w: "320px",
                    align: "flex-start",
                    spacing: "24px",
                    p: "16px",
                    pb: "40px",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                            variant: "link",
                            alignSelf: "flex-end",
                            onClick: ()=>setIsSearchPanelOpen(false),
                            "aria-label": t("Clickable close Search panel"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Close"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cd6270424eaeb4d4$export$fe5d99d8691b3f62), {
                            w: "100%",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3866dc6a93af5f$export$842aba50ed0ce9d7), {
                                    variant: "primary",
                                    htmlFor: "search-form-search",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        children: "Search for business or practitioner name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c7a110bd37e6dedc$export$6e5a9cd40e0c9b97), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ef127d438f0ac5$export$f5b8910cec6cf069), {
                                            id: "search-form-search",
                                            ...register("searchTerm"),
                                            type: "text",
                                            "data-testid": "search-form__search-field",
                                            defaultValue: "",
                                            placeholder: t("Enter search text")
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3444b8d3cbeb4c12$export$8a7b8bdd4608e7e3), {
                                            py: "16px",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1720d3c36782d8c4$export$82eafebb825fc23f), {})
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                            as: "h2",
                            variant: "Lt4Primary",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Filter"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a7b570d8d88d4b0$export$4b97a00585c854ae), {
                            enabled: isSearchPanelOpen
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64ed766538e818d3$export$fef6af226eb2815b), {
                            enabled: isSearchPanelOpen
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3e612ccfdfddfa8$export$c106feaf2af7a141), {
                            enabled: isSearchPanelOpen
                        }),
                        isLoggedIn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d939ff534527fb4c$export$48513f6b9f8ce62d), {
                            ...register("showArchived"),
                            value: "1",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Show archived"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fcb58e791a7825a$export$d7a54cba636a8cd6), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                            type: "submit",
                            variant: "primary",
                            "data-testid": "search-form__submit-button",
                            w: "100%",
                            "aria-label": hasSearched ? t("Apply search filter") : t("Search licences"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: hasSearched ? t("Apply") : t("Search")
                            })
                        })
                    ]
                })
            })
        })
    });
};




const $da67f51ac62fedc5$var$MainLayout = ()=>{
    const { isSearchPanelOpen: isSearchPanelOpen } = (0, $acw62.useContext)((0, $129fac05c2fc563a$export$abe847132b142195));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $296d8d3041dfdf15$export$de97fecb6d4b30a5), {
        minHeight: "100vh",
        templateRows: "auto 1fr",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1131a681a58b314$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                id: "content-start",
                maxWidth: "100vw",
                h: "100%",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72dafde69d16e920$export$cde958be9143af49), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dccfa70b276af4f$export$602eac185826482c), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acb46632cd278e1c$export$d8dc01b5c85a37b9), {
                    direction: "left",
                    in: isSearchPanelOpen,
                    style: (0, $04d61b1b2866b161$export$93e9d161a81c711b),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d1e87dc11312064a$export$4c7a03676454bcb7), {})
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a453b9a38a1f36da$export$2e2bcd8739ae039), {})
        ]
    });
};
var $da67f51ac62fedc5$export$2e2bcd8739ae039 = $da67f51ac62fedc5$var$MainLayout;




var $acw62 = parcelRequire("acw62");







const $efd65b98704291c2$var$textStyle = "textBodyRegular2";
const $efd65b98704291c2$var$MarketingPage = ()=>{
    const { setIsSearchPanelOpen: setIsSearchPanelOpen } = (0, $acw62.useContext)((0, $129fac05c2fc563a$export$abe847132b142195));
    const { width: width } = (0, $8d07841d42af443e$export$2e2bcd8739ae039)();
    const { t: t } = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)();
    (0, $acw62.useEffect)(()=>{
        if (width <= parseInt((0, $16f660dc0005d97b$export$d07517a676ce386f).sm)) setIsSearchPanelOpen(true);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac55bae635a0b519$export$15e411dc07b9c834), {
        justifyContent: "center",
        width: "100%",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
            width: "70%",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                    as: "h1",
                    tabIndex: -1,
                    variant: "Md2Primary",
                    mt: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cc470731e2bfd3d2)),
                    mb: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3ba0070c9b17960f)),
                    children: t("Special Procedures Wales Public Register")
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
                    gap: 6,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                t: t,
                                i18nKey: "marketing.part-1",
                                children: [
                                    "The Special Procedures Licensing Scheme for Wales came into force on 29th November 2024. This public national register provides details of all individuals who are ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("u", {
                                        children: "licenced"
                                    }),
                                    " and all premises and vehicles which have been ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("u", {
                                        children: "approved"
                                    }),
                                    " under the new Licensing Scheme for the purpose of providing special procedures in Wales. Special procedures are:"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $283882fe2c2fb711$export$30b2abb1ad323770), {
                            sx: {
                                textStyle: $efd65b98704291c2$var$textStyle
                            },
                            alignSelf: "start",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: t("marketing.licence-type-1")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: t("marketing.licence-type-2")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: t("marketing.licence-type-3")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: t("marketing.licence-type-4")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                            sx: {
                                textStyle: $efd65b98704291c2$var$textStyle
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                t: t,
                                i18nKey: "marketing.part-2",
                                children: [
                                    "Previously registered practitioners and premises will not appear on this register but if they have received a transitional licence and/or transitional premises/vehicle approval certificate from their local authority they can continue to trade while local authorities process their applications under the new scheme. This could take a number of months for local authorities to assess. Information on the transitional arrangements, licensing conditions, and how to apply for a licence is available from your Local Authority and the Welsh Government website. ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        children: "If you would like to check whether a practitioner or business holds a transitional licence, please contact your Local Authority."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                            sx: {
                                textStyle: $efd65b98704291c2$var$textStyle
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: t("Important Information")
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $283882fe2c2fb711$export$30b2abb1ad323770), {
                            sx: {
                                textStyle: $efd65b98704291c2$var$textStyle
                            },
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        i18nKey: "marketing.info-section-1",
                                        t: t,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd65b98704291c2$var$Emphasis, {
                                                children: "A Special Procedure Licence"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd65b98704291c2$var$StrongEmphasis, {
                                                children: "does not"
                                            }),
                                            " provide any assurance of the competence, skill levels, quality of work, or artistic ability of the licence holder performing the special procedure. The Licence confirms the licence holder's knowledge and application of infection prevention and control standards, and first aid relating to their performance of their specified special procedures so as to reduce any risks of harm to clients' health in the performance of those procedures."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        i18nKey: "marketing.info-section-2",
                                        t: t,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd65b98704291c2$var$Emphasis, {
                                                children: "A Premises/Vehicle Approval Certificate"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd65b98704291c2$var$StrongEmphasis, {
                                                children: "does not"
                                            }),
                                            " relate to the quality of work performed by or at that business. The Approval Certificate confirms that the premises/vehicle is of a standard that will enable compliance with the required infection prevention and control standards applicable for the performance of the special procedures within them."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                        i18nKey: "marketing.info-section-3",
                                        t: t,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd65b98704291c2$var$StrongEmphasis, {
                                                children: "Exempted Individuals and Individuals to Whom the Licensing Scheme Does Not Apply."
                                            }),
                                            " This licensing scheme ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd65b98704291c2$var$StrongEmphasis, {
                                                children: "does not apply"
                                            }),
                                            " to the NHS in Wales, therefore medical professionals and healthcare professionals with statutory professional registration and regulation who are employed within the NHS and who may perform one or more of the four specified special procedures as part of their NHS role are not captured by this licensing scheme. These individuals will therefore not feature within this Register."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $283882fe2c2fb711$export$a7b06bfba60a8a78), {
                                    children: t("marketing.info-section-4")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
                            sx: {
                                textStyle: $efd65b98704291c2$var$textStyle
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                t: t,
                                i18nKey: "marketing.outro",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd65b98704291c2$var$StrongEmphasisLink, {
                                        href: t("marketing.link"),
                                        target: "_blank",
                                        children: "CLICK HERE"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd65b98704291c2$var$Emphasis, {
                                        children: "for further information on the requirements for Licence Holders and Approval Certificate Holders"
                                    }),
                                    " (this information provides register users with information on what individuals must fulfil to be able to be granted a licence and/or an approval certificate)"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                    onClick: ()=>setIsSearchPanelOpen(true),
                    w: "288px",
                    my: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3ba0070c9b17960f)),
                    px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
                    py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
                    children: t("Let's get started")
                })
            ]
        })
    });
};
const $efd65b98704291c2$var$Emphasis = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
        sx: {
            textStyle: $efd65b98704291c2$var$textStyle
        },
        display: "inline",
        fontWeight: "bold",
        children: props.children
    });
const $efd65b98704291c2$var$StrongEmphasis = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3398707317c270b$export$5f1af8db9871e1d6), {
        sx: {
            textStyle: $efd65b98704291c2$var$textStyle
        },
        display: "inline",
        fontWeight: "bold",
        textDecoration: "underline",
        children: props.children
    });
const $efd65b98704291c2$var$StrongEmphasisLink = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a845447b1ebfe73$export$a6c7ac8248d6e38a), {
        sx: {
            textStyle: $efd65b98704291c2$var$textStyle
        },
        fontWeight: "bold",
        textDecoration: "underline",
        color: "inherit",
        ...props
    });
var $efd65b98704291c2$export$2e2bcd8739ae039 = $efd65b98704291c2$var$MarketingPage;



























const $b67445ec33b98652$export$64e6ff04c9a17200 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                variant: "Lt4",
                alignSelf: "start",
                color: (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "Edit certificate premises details"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "certificate_holder_name",
                required: true,
                label: "Certificate holder name",
                placeholder: "Enter a certificate holder name here",
                errors: {
                    required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Please enter the certificate holder name"
                    })
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "number_of_workstations",
                required: true,
                label: "Number of workstations",
                placeholder: "Enter number of workstations here",
                errors: {
                    required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Please enter the number of workstations"
                    }),
                    pattern: {
                        value: /^[0-9]+$/,
                        message: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                            children: "Please enter a valid number"
                        })
                    }
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e75477aa8f59835a$export$359105212d118848), {
                isAssociated: false
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $132d76dd771a3ff6$export$3237a405b221b07), {
                id: "internal_notes",
                label: "Internal notes (optional)"
            })
        ]
    });
};








const $55fdd2230baa0262$export$19f87db4f771ad01 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                variant: "Lt4",
                alignSelf: "start",
                color: (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "Edit certificate vehicle details"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "business_name",
                required: true,
                label: "Business name",
                placeholder: "Enter business name here",
                errors: {
                    required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Please enter the business name"
                    })
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "certificate_holder_name",
                required: true,
                label: "Certificate holder name",
                placeholder: "Enter a certificate holder name here",
                errors: {
                    required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Please enter the certificate holder name"
                    })
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "vehicle_registration_details",
                required: true,
                label: "Vehicle registration details",
                placeholder: "Enter vehicle registration details here",
                errors: {
                    required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Please enter the vehicle registration"
                    })
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $132d76dd771a3ff6$export$3237a405b221b07), {
                id: "vehicle_description",
                required: true,
                label: "Vehicle description",
                placeholder: "Enter vehicle description here",
                errors: {
                    required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Please enter the vehicle details"
                    })
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $132d76dd771a3ff6$export$3237a405b221b07), {
                id: "internal_notes",
                label: "Internal notes (optional)"
            })
        ]
    });
};











const $620af1da2c3c4081$export$bf0b217d0aff73b1 = ()=>{
    const { getValues: getValues } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const addresses = [];
    for(let i = 1; i < getValues("addresses").length; i++)addresses.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6431999e3731c24$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e75477aa8f59835a$export$359105212d118848), {
                index: i
            }, i)
        ]
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                variant: "Lt4",
                alignSelf: "start",
                color: (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "Edit practitioner licence details"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $625d87e572640047$export$c895081d03baf31e), {
                id: "practitioner_name",
                required: true,
                label: "Practitioner name",
                placeholder: "Enter practitioner name",
                errors: {
                    required: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: "Please enter the practitioner name"
                    })
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e75477aa8f59835a$export$359105212d118848), {
                index: 0
            }, 0),
            ...addresses,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ce0833c596a8ba3$export$8faedc3900394996), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $132d76dd771a3ff6$export$3237a405b221b07), {
                id: "internal_notes",
                label: "Internal notes (optional)"
            })
        ]
    });
};



const $31b345b846d2cfcd$export$bc477af8ba6a5bb1 = ()=>{
    const { getValues: getValues } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const licence_type_id = getValues("licence_type_id");
    switch((0, $641772106617d27d$export$2b215ce73bbb8647)(licence_type_id)){
        case (0, $f6ccc2005cfc5555$export$699c2130295691b4).CERTIFICATE_PREMISES:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b67445ec33b98652$export$64e6ff04c9a17200), {});
        case (0, $f6ccc2005cfc5555$export$699c2130295691b4).CERTIFICATE_VEHICLE:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55fdd2230baa0262$export$19f87db4f771ad01), {});
        case (0, $f6ccc2005cfc5555$export$699c2130295691b4).PRACTITIONER:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $620af1da2c3c4081$export$bf0b217d0aff73b1), {});
        default:
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                children: "An error has occurred please try again"
            });
    }
};










const $1e32ea79d28381e4$export$35427970e832b6f9 = ({ header: header, children: children, onSubmit: onSubmit })=>{
    const { handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting, isDirty: isDirty } } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    const goBack = ()=>{
        window.history.back();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        style: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
            sx: (0, $6db6a5e042da850f$export$1d2123ae1e13fd90),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
                    variant: "Lt4",
                    alignSelf: "start",
                    color: (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                        children: header
                    })
                }),
                children,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $296d8d3041dfdf15$export$de97fecb6d4b30a5), {
                    gridTemplateColumns: "repeat(2, auto)",
                    justifyContent: "space-between",
                    alignItems: "end",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f52a9bf465e52cde$export$e71c4d32a2263218), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                                variant: "secondary",
                                onClick: goBack,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                    children: "Back"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d4025908d716953$export$353f5b6fc5456de1), {
                            type: "submit",
                            isDisabled: isSubmitting || !isDirty,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                                children: "Save"
                            })
                        })
                    ]
                })
            ]
        })
    });
};



var $acw62 = parcelRequire("acw62");






const $f565d1900d404407$var$axios = (0, $2e59f0ff0fac9290$export$53ea70b747a790ee)();
const $f565d1900d404407$export$c2578bda2e60f454 = ({ header: header, children: children })=>{
    const toast = (0, $a154ce245eea8e38$export$a407b657d3044108)();
    const { token: token } = (0, $acw62.useContext)((0, $49553c78695c6663$export$1cbb4184b742b6e9));
    const editLicence = async (data)=>{
        const updatedLicence = (0, $cc8ac6ed0ffb93b6$export$2e2bcd8739ae039)([
            "procedure_types",
            "organisation_id"
        ], data);
        try {
            const computedData = (0, $f2e109406cb5aeb5$export$692c1f84971acebc)(updatedLicence);
            await $f565d1900d404407$var$axios.put((0, $78df7481edc561d7$export$eed022e50baffed5).LICENCES, [
                computedData
            ], {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            toast({
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "Licence successfully updated"
                }),
                status: "success",
                position: "bottom-right",
                duration: 9000,
                isClosable: true
            });
        } catch (e) {
            toast({
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "Licence could not be updated"
                }),
                description: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "Unknown error, please try again later"
                }),
                status: "error",
                position: "bottom-right",
                duration: 9000
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e32ea79d28381e4$export$35427970e832b6f9), {
        header: header,
        onSubmit: editLicence,
        children: children
    });
};






const $3c539f97dffa1640$export$a19fc473bbe5305b = ({ id: id = "issueDate", width: width })=>{
    const { register: register } = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dd005f903a28199$export$fb9f58ebe9de6283), {
        id: id,
        label: "Archived date",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ef127d438f0ac5$export$f5b8910cec6cf069), {
            w: width ?? "100%",
            placeholder: "Select archived date",
            ...register(id),
            type: "date"
        })
    });
};





const $c70bc42e7dd42c47$export$754b4960ff2480d8 = (props)=>{
    const methods = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: {
            ...props.licence,
            archived_date: props.licence.archived_date ?? undefined,
            issue_date: (0, $303ba10db2c74ab4$export$3ae94a2503e890a1)(new Date(props.licence.issue_date), "yyyy-MM-dd"),
            procedure_type_ids: (0, $c57cf2ecbe3ddf08$export$2e2bcd8739ae039)("procedure_type_id", props.licence.procedure_types)
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
        w: "100%",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$8ce1ff4f94d08846), {
            ...methods,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f565d1900d404407$export$c2578bda2e60f454), {
                header: "Edit licence",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3e612ccfdfddfa8$export$c106feaf2af7a141), {
                        disabled: true,
                        id: "licence_type_id",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7fb6691839270274$export$9c982798ae75228c), {
                        id: "licence_number",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64ed766538e818d3$export$fef6af226eb2815b), {
                        id: "procedure_type_ids",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f992dc2156f2c1e$export$5d92d9428fdc106b), {
                        width: "50%",
                        id: "issue_date",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c539f97dffa1640$export$a19fc473bbe5305b), {
                        width: "50%",
                        id: "archived_date"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31b345b846d2cfcd$export$bc477af8ba6a5bb1), {})
                ]
            })
        })
    });
};







const $cc23aeb784d6fa91$export$85782b9530fe5ddb = (props)=>{
    const organisation = (0, $3b9216cd2dbb7012$export$77d8ddb155d633f5)();
    if (!organisation || organisation.id !== props.organisationId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0f429e331c7b6f4b$export$caec2af78bcc877f), {
        status: "error",
        "data-testid": "organisation-guard__alert",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92200e681b16e3f1$export$4a143c8822a09fb4), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a85737e2eeda27d8$export$d4feae172fccda11), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                    children: "You do not have permission to perform this action, please contact your administrator."
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: props.children
    });
};


const $79d03987c865db5e$export$8383754161d0d0d6 = ()=>{
    const [params] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { data: licenceDetails, isLoading: isLoading } = (0, $0e529258adfac30f$export$be8ce6c65f29d3ba)({
        id: params.get("urn") ?? undefined
    }, {
        query: {
            enabled: params.has("urn")
        }
    });
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2abf42c373b7af6c$export$7f7cbe89f1eacd2), {});
    if (!licenceDetails) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91114d1604a86a91$export$e6c02a6dccfa2120), {
        alignContent: "center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88788dd03800ffcb$export$a8a3e93435678ff9), {
            as: "h2",
            variant: "Lt4",
            mt: (0, $590eee45b2f4b5a8$export$ed7bdee048351354),
            color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04d9533328ca578$export$8d6a9236f2e3f2ce), {
                children: "No licence details found"
            })
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc23aeb784d6fa91$export$85782b9530fe5ddb), {
        organisationId: licenceDetails.results.organisation_id,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $71df3cb5cdd82a1d$export$33d8d8ad1089b050), {
            permission: (0, $23540125288fb711$export$b7d846e56ce254fb),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef3eb35d4abe9e46$export$1f54913ccc4368b1), {
                mt: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cc470731e2bfd3d2)),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c70bc42e7dd42c47$export$754b4960ff2480d8), {
                    licence: licenceDetails.results
                })
            })
        })
    });
};


const $043f87f23fd0da03$export$3565eb3d00ca5a74 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbdcf5931b478170$export$6bd70292443463a4), {}),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a729a4515b73f625$export$7c0a4d285a69efc1), {}),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da67f51ac62fedc5$export$2e2bcd8739ae039), {}),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efd65b98704291c2$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/login",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d4011c1a569e48$export$f14c0e3f98d164c0), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/search",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae05ab2d87032909$export$a54ec244c8863715), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38a6b3f47b632dde$export$f8f06b22414498a4), {}),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/admin",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13d014f488f21b0f$export$e4a014db366db61e), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45b8cf243d4ac016$export$a51f40efc5c42472), {}),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/create-licence",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a58164f7ff792b0c$export$85a3b20090004421), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/edit-licence",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $79d03987c865db5e$export$8383754161d0d0d6), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/authorities",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $319caf0b55e4aabd$export$56f39d25c369e44b), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                    path: "/bulk-upload",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb59596c7abcbbe0$export$f6fb75f68e6e354), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2c236c700eed7f6$export$31641b61980e511f), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/500",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $102328d9d107de95$export$5d5f670aa4440fd0), {})
                        })
                    ]
                })
            })
        })
    });




const $f21bc82042c71370$export$9dd6ff9ea0189349 = {
    global: {
        body: {
            background: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["grey-300"]
        }
    }
};




const $8f754619adea0af8$export$1ba820c705ea1928 = ", Helvetica, Arial, sans-serif";


const $1a211241b412719d$export$6a54c24d15b0f6ba = {
    "headingLt4": {
        fontFamily: (0, $590eee45b2f4b5a8$export$6ded285245556693) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$551c1be1ccab0e43),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$e145890412ec5292)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$218c3a7826075780),
        textDecoration: (0, $590eee45b2f4b5a8$export$1a5727466b96c599),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$ae355babc43656d1)),
        textTransform: (0, $590eee45b2f4b5a8$export$9ed9fd7d239c902e)
    },
    "headingLtPrimary": {
        fontFamily: (0, $590eee45b2f4b5a8$export$292aa28deb82f6ec) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$bf12335799fd8efd)),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$7aa478b3971f3bb1)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$e4a4173a12619852),
        textDecoration: (0, $590eee45b2f4b5a8$export$83369c1e55f553b2),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$ed345f932fb8865a)),
        textTransform: (0, $590eee45b2f4b5a8$export$2757c8478892139c),
        color: "primary.text"
    },
    "headingMd4Primary": {
        fontFamily: (0, $590eee45b2f4b5a8$export$91626964489edf0d) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$37e237aefd2a0a94)),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$da3fbc117361d103)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$3759a7b59a7fc39),
        textDecoration: (0, $590eee45b2f4b5a8$export$7e6f83aba4758909),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$c5b94acc9ce6cab9)),
        textTransform: (0, $590eee45b2f4b5a8$export$8d95a054ad315e),
        color: "primary.text"
    },
    "headingMd2Primary": {
        fontFamily: (0, $590eee45b2f4b5a8$export$3e50f1c612b01b46) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$79e1fb61fb8bde4d)),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2c37fadc16f0d822)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$5f6e0b4d27811ca5),
        textDecoration: (0, $590eee45b2f4b5a8$export$7ba94d4f89b37ab1),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$9c8fea5f4f4965f6)),
        textTransform: (0, $590eee45b2f4b5a8$export$7ec3671b11ff4bc1),
        color: "primary.text"
    },
    "text03": {
        fontFamily: (0, $590eee45b2f4b5a8$export$f5765c5d56afcf36) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$4efdac93b8c031f3)),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$1986f92956d2cf69)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$300c3eab212cbef5),
        textDecoration: (0, $590eee45b2f4b5a8$export$6bcdac418900a522),
        textTransform: (0, $590eee45b2f4b5a8$export$28d08c4cbb57e20f),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$bbf94eb9e9c3fb86))
    },
    "textBodyLink4": {
        fontFamily: (0, $590eee45b2f4b5a8$export$ec734e0aa9967354) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$c23273c6909be83d),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a9953ce6112a12de)),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3eedbc45e050fffd)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$2a885dd7468bb58c),
        textTransform: (0, $590eee45b2f4b5a8$export$3e18ba893bd862a7),
        textDecoration: (0, $590eee45b2f4b5a8$export$be6e37e703bb5551)
    },
    "textBodyMedium3": {
        fontFamily: (0, $590eee45b2f4b5a8$export$e1c356845e929286) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$99a9e48d08419c04),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$120e29ae13fcf68b)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$32259957cf1bf44f),
        textTransform: (0, $590eee45b2f4b5a8$export$346d28403e8ed847),
        textDecoration: (0, $590eee45b2f4b5a8$export$aea1425f29a7992c),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$fa8c8c6a1f3b700f))
    },
    "textBodyMedium4": {
        fontFamily: (0, $590eee45b2f4b5a8$export$fcd25cb19b57747f) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$c702f2c8b91e5dac),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$800fa31cc224d2fd)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$2a885dd7468bb58c),
        textTransform: (0, $590eee45b2f4b5a8$export$ebdedb0d2b619773),
        textDecoration: (0, $590eee45b2f4b5a8$export$bb86fa8b978463c7),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$808adbba399a6506))
    },
    "textBodyRegular2": {
        fontFamily: (0, $590eee45b2f4b5a8$export$3c777a585cb58ec) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$b2106c41dc8777c),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$7a33fdad703593b9)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$8186c0f4e9d8d53e),
        textTransform: (0, $590eee45b2f4b5a8$export$60eeb2cf97aa1fdb),
        textDecoration: (0, $590eee45b2f4b5a8$export$4fd414c4a5d1ed),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$c08ab810dec3a02e))
    },
    "textBodyRegular3": {
        fontFamily: (0, $590eee45b2f4b5a8$export$f5765c5d56afcf36) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$4efdac93b8c031f3),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$bbf94eb9e9c3fb86)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$300c3eab212cbef5),
        textTransform: (0, $590eee45b2f4b5a8$export$28d08c4cbb57e20f),
        textDecoration: (0, $590eee45b2f4b5a8$export$6bcdac418900a522),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$1986f92956d2cf69))
    },
    "textBodyRegular4": {
        fontFamily: (0, $590eee45b2f4b5a8$export$10fcfc3f7e64ed9c) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$17e242d5f7403ce5),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a5c94894e62f6149)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$e46f0991d2c4040c),
        textTransform: (0, $590eee45b2f4b5a8$export$c907894989c2c608),
        textDecoration: (0, $590eee45b2f4b5a8$export$65bede91f19c65b3),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$69027de17ce58d50))
    },
    "textButton2": {
        fontFamily: (0, $590eee45b2f4b5a8$export$76d56331f9bc203b) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$5f47ab32c5ca034e),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$b52a4ab3fc8d5633)),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$33fd2561203dee2e)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$240c89b94ed04c53),
        textDecoration: (0, $590eee45b2f4b5a8$export$f037a438bba65086)
    },
    "textButton3": {
        fontFamily: (0, $590eee45b2f4b5a8$export$b58ee2cddcfa0a3c) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$428e07a28b3b6026),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$4f038b27f964d915)),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$fc2908fe8e6b310c)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$986bfaa1aa2d293b),
        textDecoration: (0, $590eee45b2f4b5a8$export$70e12cde98ec0473)
    }
};




const $1e3136b29e7546eb$export$c5ce54c56ca9d603 = {
    primaryAlertBox: {
        bg: "error.bg",
        color: "error.text",
        borderLeftWidth: (0, $590eee45b2f4b5a8$export$43179893ad9f1189),
        borderLeftColor: (0, $590eee45b2f4b5a8$export$3a4601f6f873d8a),
        padding: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea))
    },
    primaryModalAlert: {
        bg: "error.bg",
        color: "error.text",
        borderBottomWidth: (0, $590eee45b2f4b5a8$export$3373d970111b7d43),
        borderBottomColor: (0, $590eee45b2f4b5a8$export$3a4601f6f873d8a),
        padding: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
        textStyle: "textBodyRegular4"
    }
};









const $39cb1d8d3afd6734$export$353f5b6fc5456de1 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    variants: {
        primary: {
            color: "primary.button.text",
            bg: "primary.button.bg",
            boxShadow: (0, $6abc8dde70ddd647$export$2c54b9c78c14ff3f)((0, $590eee45b2f4b5a8$export$54830509930cfa97), (0, $590eee45b2f4b5a8$export$c7a01a900877df68), (0, $590eee45b2f4b5a8$export$4cacc6533891eb93), (0, $590eee45b2f4b5a8$export$59237760b754467e), (0, $590eee45b2f4b5a8$export$f0a163cab0d1f2a2)),
            height: "auto",
            px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
            py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
            fontFamily: (0, $590eee45b2f4b5a8$export$76d56331f9bc203b) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
            fontWeight: (0, $590eee45b2f4b5a8$export$5f47ab32c5ca034e),
            lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$33fd2561203dee2e)),
            fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$b52a4ab3fc8d5633)),
            letterSpacing: (0, $590eee45b2f4b5a8$export$240c89b94ed04c53),
            textTransform: (0, $590eee45b2f4b5a8$export$e2c645197509422),
            textDecoration: (0, $590eee45b2f4b5a8$export$f037a438bba65086),
            _hover: {
                bg: "primary.button.hover.bg",
                _disabled: {
                    bg: "primary.button.disabled.bg"
                }
            },
            _active: {
                bg: "primary.button.active.bg"
            },
            _disabled: {
                bg: "primary.button.disabled.bg",
                color: "primary.button.disabled.text"
            }
        },
        secondary: {
            color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"],
            bg: (0, $590eee45b2f4b5a8$export$e98aa9f3e50b8670),
            borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"],
            borderWidth: (0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f),
            boxShadow: (0, $6abc8dde70ddd647$export$2c54b9c78c14ff3f)((0, $590eee45b2f4b5a8$export$54830509930cfa97), (0, $590eee45b2f4b5a8$export$c7a01a900877df68), (0, $590eee45b2f4b5a8$export$4cacc6533891eb93), (0, $590eee45b2f4b5a8$export$59237760b754467e), (0, $590eee45b2f4b5a8$export$f0a163cab0d1f2a2)),
            px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
            py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
            height: "auto",
            fontFamily: (0, $590eee45b2f4b5a8$export$76d56331f9bc203b) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
            fontWeight: (0, $590eee45b2f4b5a8$export$5f47ab32c5ca034e),
            lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$33fd2561203dee2e)),
            fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$b52a4ab3fc8d5633)),
            letterSpacing: (0, $590eee45b2f4b5a8$export$240c89b94ed04c53),
            textTransform: (0, $590eee45b2f4b5a8$export$e2c645197509422),
            textDecoration: (0, $590eee45b2f4b5a8$export$f037a438bba65086),
            _hover: {
                bg: (0, $590eee45b2f4b5a8$export$b3edcfd12ee1e54e),
                borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-600"],
                color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-600"],
                _disabled: {
                    opacity: (0, $590eee45b2f4b5a8$export$a29839f1461b65ad)
                }
            },
            _active: {
                bg: (0, $590eee45b2f4b5a8$export$55b3678155c8978e),
                borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-700"],
                color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-700"]
            },
            _disabled: {
                opacity: (0, $590eee45b2f4b5a8$export$a29839f1461b65ad)
            }
        },
        quaternary: {
            color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-500"],
            bg: (0, $590eee45b2f4b5a8$export$e98aa9f3e50b8670),
            borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-500"],
            borderWidth: (0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f),
            px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$381f0d4736587f5e)),
            py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$ed7bdee048351354)),
            height: "auto",
            fontFamily: (0, $590eee45b2f4b5a8$export$b58ee2cddcfa0a3c) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
            fontWeight: (0, $590eee45b2f4b5a8$export$428e07a28b3b6026),
            lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$fc2908fe8e6b310c)),
            fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$4f038b27f964d915)),
            letterSpacing: (0, $590eee45b2f4b5a8$export$986bfaa1aa2d293b),
            textTransform: (0, $590eee45b2f4b5a8$export$c67b1538c9f307f4),
            textDecoration: (0, $590eee45b2f4b5a8$export$70e12cde98ec0473),
            _hover: {
                bg: (0, $590eee45b2f4b5a8$export$b3edcfd12ee1e54e),
                borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-600"],
                color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-600"],
                _disabled: {
                    opacity: (0, $590eee45b2f4b5a8$export$a29839f1461b65ad)
                }
            },
            _active: {
                bg: (0, $590eee45b2f4b5a8$export$55b3678155c8978e),
                borderColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-700"],
                color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-700"]
            },
            _disabled: {
                opacity: (0, $590eee45b2f4b5a8$export$a29839f1461b65ad)
            }
        },
        tertiary: {
            color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"],
            textStyle: "textButton2",
            height: "auto",
            px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
            py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
            _hover: {
                color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-600"]
            },
            _active: {
                color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-700"]
            }
        },
        linkPrimary: {
            color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"],
            lineHeight: 1,
            height: "1em",
            padding: 0
        },
        link: {
            color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3)
        },
        outline: {
            borderColor: (0, $590eee45b2f4b5a8$export$78c7442df4e4fa92),
            borderRadius: (0, $590eee45b2f4b5a8$export$6eac148052ad90cb),
            color: (0, $590eee45b2f4b5a8$export$4bdf0898d78f829f),
            fontWeight: 500
        }
    },
    defaultProps: {
        variant: "primary"
    }
});







const { definePartsStyle: $d62829c56d9124f1$var$definePartsStyle, defineMultiStyleConfig: $d62829c56d9124f1$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$1ffeb100b532f46d).keys);
const $d62829c56d9124f1$var$primary = $d62829c56d9124f1$var$definePartsStyle({
    field: {
        backgroundColor: (0, $590eee45b2f4b5a8$export$c500f73a63679704),
        borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
        borderColor: (0, $590eee45b2f4b5a8$export$78c7442df4e4fa92),
        borderRadius: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$6eac148052ad90cb)),
        color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3),
        marginLeft: "1px",
        marginRight: "1px",
        px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
        py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
        fontFamily: (0, $590eee45b2f4b5a8$export$f5765c5d56afcf36) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$4efdac93b8c031f3),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$bbf94eb9e9c3fb86)),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$1986f92956d2cf69)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$300c3eab212cbef5),
        textTransform: (0, $590eee45b2f4b5a8$export$28d08c4cbb57e20f),
        textDecoration: (0, $590eee45b2f4b5a8$export$6bcdac418900a522),
        height: "auto",
        _focus: {
            backgroundColor: (0, $590eee45b2f4b5a8$export$5273722fbdc5ce7b),
            margin: 0,
            color: (0, $590eee45b2f4b5a8$export$cac2caa807436676),
            borderColor: (0, $590eee45b2f4b5a8$export$6aba7ce9a9a6ceb),
            borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3373d970111b7d43))
        },
        _invalid: {
            backgroundColor: (0, $590eee45b2f4b5a8$export$5273722fbdc5ce7b),
            color: (0, $590eee45b2f4b5a8$export$cac2caa807436676),
            borderColor: (0, $590eee45b2f4b5a8$export$3a4601f6f873d8a),
            borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3373d970111b7d43))
        },
        /** This affects only date fields, specifically in Webkit browsers **/ "::-webkit-calendar-picker-indicator": {
            width: "100%",
            height: "100%",
            left: 0,
            position: "absolute",
            opacity: 0
        }
    },
    element: {
        px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
        py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
        color: (0, $590eee45b2f4b5a8$export$90cfbd2e6796672c)
    }
});
const $d62829c56d9124f1$export$f5b8910cec6cf069 = $d62829c56d9124f1$var$defineMultiStyleConfig({
    variants: {
        primary: $d62829c56d9124f1$var$primary
    },
    defaultProps: {
        variant: "primary"
    }
});





const $7f1a3f470d24547b$export$842aba50ed0ce9d7 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    variants: {
        primary: {
            color: (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf),
            textStyle: "textBodyMedium4",
            marginBottom: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$4eaa1d4f12b95711)),
            fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$808adbba399a6506))
        }
    },
    defaultProps: {
        variant: "primary"
    }
});







const { definePartsStyle: $0525801d60479ce6$var$definePartsStyle, defineMultiStyleConfig: $0525801d60479ce6$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$487a447ffa5755b6).keys);
const $0525801d60479ce6$var$primary = $0525801d60479ce6$var$definePartsStyle({
    container: {
        backgroundColor: (0, $590eee45b2f4b5a8$export$5273722fbdc5ce7b),
        borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
        borderRadius: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)),
        borderColor: (0, $590eee45b2f4b5a8$export$2acf0bd6e4a649be),
        boxShadow: `${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$62730874a6820f04))} ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$6a41e59fc5cf0b0a))} ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$8c8655252e9246db))}  ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$b23a6d415651bd7b))} ${(0, $590eee45b2f4b5a8$export$e911b675050534fe)}`
    },
    header: {
        borderColor: (0, $590eee45b2f4b5a8$export$2acf0bd6e4a649be),
        borderBottomWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
        paddingY: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
        paddingX: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
        textStyle: "headingLt4"
    },
    body: {
        paddingY: "40px",
        paddingX: (0, $590eee45b2f4b5a8$export$381f0d4736587f5e)
    }
});
const $0525801d60479ce6$var$result = $0525801d60479ce6$var$definePartsStyle({
    container: {
        borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
        borderRadius: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)),
        borderColor: (0, $590eee45b2f4b5a8$export$78c7442df4e4fa92),
        boxShadow: `${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$54830509930cfa97))} ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$c7a01a900877df68))} ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$4cacc6533891eb93))}  ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$59237760b754467e))} ${(0, $590eee45b2f4b5a8$export$f0a163cab0d1f2a2)}`
    },
    header: {
        borderColor: (0, $590eee45b2f4b5a8$export$2acf0bd6e4a649be),
        borderBottomWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
        padding: 0,
        textStyle: "headingLt4",
        color: (0, $590eee45b2f4b5a8$export$6aefc03aa88b5914),
        backgroundColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"],
        borderRadius: `${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px ${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px 0 0`
    },
    body: {
        backgroundColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["grey-100"],
        textStyle: "textBodyMedium3",
        color: (0, $590eee45b2f4b5a8$export$4bdf0898d78f829f),
        padding: 0
    },
    footer: {
        backgroundColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["grey-100"],
        borderRadius: `0 0 ${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px ${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px`,
        color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"],
        textStyle: "textBodyReg3"
    }
});
const $0525801d60479ce6$var$resultArchived = $0525801d60479ce6$var$definePartsStyle({
    container: {
        borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
        borderRadius: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)),
        borderColor: (0, $590eee45b2f4b5a8$export$78c7442df4e4fa92),
        boxShadow: `${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$54830509930cfa97))} ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$c7a01a900877df68))} ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$4cacc6533891eb93))}  ${(0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$59237760b754467e))} ${(0, $590eee45b2f4b5a8$export$f0a163cab0d1f2a2)}`
    },
    header: {
        borderColor: (0, $590eee45b2f4b5a8$export$2acf0bd6e4a649be),
        borderBottomWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
        padding: 0,
        textStyle: "headingLt4",
        color: (0, $590eee45b2f4b5a8$export$6aefc03aa88b5914),
        backgroundColor: (0, $590eee45b2f4b5a8$export$fa0abf3b9ffec737),
        borderRadius: `${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px ${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px 0 0`
    },
    body: {
        backgroundColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["grey-100"],
        textStyle: "textBodyMedium3",
        color: (0, $590eee45b2f4b5a8$export$4bdf0898d78f829f),
        padding: 0
    },
    footer: {
        backgroundColor: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["grey-100"],
        borderRadius: `0 0 ${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px ${(0, $590eee45b2f4b5a8$export$a1b13b0099b51b3f)}px`,
        color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"],
        textStyle: "textBodyReg3"
    }
});
const $0525801d60479ce6$export$60332b2344f7fe41 = $0525801d60479ce6$var$defineMultiStyleConfig({
    variants: {
        primary: $0525801d60479ce6$var$primary,
        result: $0525801d60479ce6$var$result,
        resultArchived: $0525801d60479ce6$var$resultArchived
    },
    defaultProps: {
        variant: "primary"
    }
});




const $24731845166adced$export$a6c7ac8248d6e38a = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    variants: {
        primary: {
            color: (0, $590eee45b2f4b5a8$export$67efe7a6dccb9914),
            textDecoration: "underline",
            textStyle: "textBodyLink4"
        }
    },
    defaultProps: {
        variant: "primary"
    }
});








const $0b67c69dd75849d6$var$Lt4 = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: (0, $590eee45b2f4b5a8$export$6ded285245556693) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
    fontWeight: (0, $590eee45b2f4b5a8$export$551c1be1ccab0e43),
    fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$e145890412ec5292)),
    letterSpacing: (0, $590eee45b2f4b5a8$export$218c3a7826075780),
    textDecoration: (0, $590eee45b2f4b5a8$export$1a5727466b96c599),
    lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$ae355babc43656d1)),
    textTransform: (0, $590eee45b2f4b5a8$export$9ed9fd7d239c902e),
    color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-500"]
});
const $0b67c69dd75849d6$var$Lt4Primary = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: (0, $590eee45b2f4b5a8$export$6ded285245556693) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
    fontWeight: (0, $590eee45b2f4b5a8$export$551c1be1ccab0e43),
    fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$e145890412ec5292)),
    letterSpacing: (0, $590eee45b2f4b5a8$export$218c3a7826075780),
    textDecoration: (0, $590eee45b2f4b5a8$export$1a5727466b96c599),
    lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$ae355babc43656d1)),
    textTransform: (0, $590eee45b2f4b5a8$export$9ed9fd7d239c902e),
    color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"]
});
const $0b67c69dd75849d6$var$Md2Primary = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: (0, $590eee45b2f4b5a8$export$3e50f1c612b01b46) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
    fontWeight: (0, $590eee45b2f4b5a8$export$79e1fb61fb8bde4d),
    fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2c37fadc16f0d822)),
    letterSpacing: (0, $590eee45b2f4b5a8$export$5f6e0b4d27811ca5),
    textDecoration: (0, $590eee45b2f4b5a8$export$7ba94d4f89b37ab1),
    lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$9c8fea5f4f4965f6)),
    textTransform: (0, $590eee45b2f4b5a8$export$7ec3671b11ff4bc1),
    color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"]
});
const $0b67c69dd75849d6$var$Md4Primary = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: (0, $590eee45b2f4b5a8$export$91626964489edf0d) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
    fontWeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$37e237aefd2a0a94)),
    fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$da3fbc117361d103)),
    letterSpacing: (0, $590eee45b2f4b5a8$export$3759a7b59a7fc39),
    textDecoration: (0, $590eee45b2f4b5a8$export$7e6f83aba4758909),
    lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$c5b94acc9ce6cab9)),
    textTransform: (0, $590eee45b2f4b5a8$export$8d95a054ad315e),
    color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"]
});
const $0b67c69dd75849d6$var$Lt6 = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: (0, $590eee45b2f4b5a8$export$cbf8f0b12c1706d) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
    fontWeight: (0, $590eee45b2f4b5a8$export$d181039be6d8a946),
    fontSize: (0, $16f660dc0005d97b$export$d07517a676ce386f).sm ? (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$69027de17ce58d50)) : (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$9c53b98c25e28fe9)),
    letterSpacing: (0, $590eee45b2f4b5a8$export$ed4f518cafc1b6d7),
    textDecoration: (0, $590eee45b2f4b5a8$export$f40df5bc3cf9daac),
    lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$52283bb8b8edb8c9)),
    textTransform: (0, $590eee45b2f4b5a8$export$511d63ad815fc837),
    color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["neutral-500"]
});
const $0b67c69dd75849d6$var$Lt6Primary = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: (0, $590eee45b2f4b5a8$export$cbf8f0b12c1706d) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
    fontWeight: (0, $590eee45b2f4b5a8$export$d181039be6d8a946),
    fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$9c53b98c25e28fe9)),
    letterSpacing: (0, $590eee45b2f4b5a8$export$ed4f518cafc1b6d7),
    textDecoration: (0, $590eee45b2f4b5a8$export$f40df5bc3cf9daac),
    lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$52283bb8b8edb8c9)),
    textTransform: (0, $590eee45b2f4b5a8$export$511d63ad815fc837),
    color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"]
});
const $0b67c69dd75849d6$var$Md6Primary = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    fontFamily: (0, $590eee45b2f4b5a8$export$2e58fe52ac126347) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
    fontWeight: (0, $590eee45b2f4b5a8$export$431a6622f9795b9e),
    fontSize: (0, $16f660dc0005d97b$export$d07517a676ce386f).sm ? (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$69027de17ce58d50)) : (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$7185a68768b6b5fc)),
    letterSpacing: (0, $590eee45b2f4b5a8$export$61580f1dda72df60),
    textDecoration: (0, $590eee45b2f4b5a8$export$c85026323cda12ac),
    lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$6562b26fc3b502c4)),
    textTransform: (0, $590eee45b2f4b5a8$export$e54b8b621c9a5e7e),
    color: (0, $a70a3787a84ee6fb$export$47adaa49a9a5778b)["base1-500"]
});
const $0b67c69dd75849d6$export$a8a3e93435678ff9 = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    variants: {
        Lt4: $0b67c69dd75849d6$var$Lt4,
        Lt4Primary: $0b67c69dd75849d6$var$Lt4Primary,
        Md2Primary: $0b67c69dd75849d6$var$Md2Primary,
        Md4Primary: $0b67c69dd75849d6$var$Md4Primary,
        Lt6: $0b67c69dd75849d6$var$Lt6,
        Lt6Primary: $0b67c69dd75849d6$var$Lt6Primary,
        Md6Primary: $0b67c69dd75849d6$var$Md6Primary
    },
    defaultProps: {
        variant: "Lt4Primary"
    }
});







const { definePartsStyle: $88beff93cb23318d$var$definePartsStyle, defineMultiStyleConfig: $88beff93cb23318d$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$1ffeb100b532f46d).keys);
const $88beff93cb23318d$var$primary = $88beff93cb23318d$var$definePartsStyle({
    field: {
        backgroundColor: (0, $590eee45b2f4b5a8$export$c500f73a63679704),
        borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
        borderColor: (0, $590eee45b2f4b5a8$export$78c7442df4e4fa92),
        borderRadius: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$6eac148052ad90cb)),
        color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3),
        fontFamily: (0, $590eee45b2f4b5a8$export$f5765c5d56afcf36) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$4efdac93b8c031f3),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$bbf94eb9e9c3fb86)),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$1986f92956d2cf69)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$300c3eab212cbef5),
        textTransform: (0, $590eee45b2f4b5a8$export$28d08c4cbb57e20f),
        textDecoration: (0, $590eee45b2f4b5a8$export$6bcdac418900a522),
        px: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$2e9d67b3a51e4aea)),
        py: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a275cc59cf419b0e)),
        height: "auto",
        _focus: {
            backgroundColor: (0, $590eee45b2f4b5a8$export$5273722fbdc5ce7b),
            color: (0, $590eee45b2f4b5a8$export$cac2caa807436676),
            borderColor: (0, $590eee45b2f4b5a8$export$6aba7ce9a9a6ceb),
            borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3373d970111b7d43))
        },
        _invalid: {
            backgroundColor: (0, $590eee45b2f4b5a8$export$5273722fbdc5ce7b),
            color: (0, $590eee45b2f4b5a8$export$cac2caa807436676),
            borderColor: (0, $590eee45b2f4b5a8$export$3a4601f6f873d8a),
            borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3373d970111b7d43))
        }
    }
});
const $88beff93cb23318d$export$ef9b1a59e592288f = $88beff93cb23318d$var$defineMultiStyleConfig({
    variants: {
        primary: $88beff93cb23318d$var$primary
    },
    defaultProps: {
        variant: "primary"
    }
});







const { definePartsStyle: $e2a00a59fdd29348$var$definePartsStyle, defineMultiStyleConfig: $e2a00a59fdd29348$var$defineMultiStyleConfig } = (0, $47a6d9fbbf7ee42d$export$d5f717dc145477b8)((0, $14dc7d8b583e9ee9$export$21946b04497ed6ac).keys);
const $e2a00a59fdd29348$var$TOGGLES_SELECTED = "#051441";
const $e2a00a59fdd29348$var$primary = $e2a00a59fdd29348$var$definePartsStyle({
    control: {
        borderRadius: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$9078c51d1d0b33cd)),
        backgroundColor: (0, $590eee45b2f4b5a8$export$2153df39761f2b4),
        _checked: {
            backgroundColor: $e2a00a59fdd29348$var$TOGGLES_SELECTED,
            borderColor: $e2a00a59fdd29348$var$TOGGLES_SELECTED
        }
    },
    label: {
        fontFamily: (0, $590eee45b2f4b5a8$export$10fcfc3f7e64ed9c) + (0, $8f754619adea0af8$export$1ba820c705ea1928),
        fontWeight: (0, $590eee45b2f4b5a8$export$17e242d5f7403ce5),
        lineHeight: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$a5c94894e62f6149)),
        fontSize: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$69027de17ce58d50)),
        letterSpacing: (0, $590eee45b2f4b5a8$export$e46f0991d2c4040c),
        textTransform: (0, $590eee45b2f4b5a8$export$c907894989c2c608),
        textDecoration: (0, $590eee45b2f4b5a8$export$65bede91f19c65b3),
        color: (0, $590eee45b2f4b5a8$export$4e7c4bccd1e97ecf)
    }
});
const $e2a00a59fdd29348$export$48513f6b9f8ce62d = $e2a00a59fdd29348$var$defineMultiStyleConfig({
    variants: {
        primary: $e2a00a59fdd29348$var$primary
    },
    defaultProps: {
        variant: "primary",
        size: "lg"
    }
});






const $d3e0010ffadb4403$var$primary = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    backgroundColor: (0, $590eee45b2f4b5a8$export$c500f73a63679704),
    color: (0, $590eee45b2f4b5a8$export$bbab08086b8634b3),
    borderColor: (0, $590eee45b2f4b5a8$export$78c7442df4e4fa92),
    borderRadius: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$6eac148052ad90cb)),
    borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$cd9ead0feef17e8f)),
    textStyle: "text03",
    _invalid: {
        borderColor: (0, $590eee45b2f4b5a8$export$3a4601f6f873d8a),
        borderWidth: (0, $1d5090bbb9ec8e9b$export$91c0eda1d06bf008)((0, $590eee45b2f4b5a8$export$3373d970111b7d43))
    }
});
const $d3e0010ffadb4403$export$379139ebc1c2b235 = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    variants: {
        primary: $d3e0010ffadb4403$var$primary
    },
    defaultProps: {
        variant: "primary"
    }
});




const $fb624147e21fd833$var$primary = (0, $47a6d9fbbf7ee42d$export$9a6b93c1c4f92839)({
    borderColor: (0, $590eee45b2f4b5a8$export$fa0abf3b9ffec737),
    borderStyle: "solid",
    borderWidth: "1px"
});
const $fb624147e21fd833$export$2e0a83ec2e27ecbb = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    variants: {
        primary: $fb624147e21fd833$var$primary
    },
    defaultProps: {
        variant: "primary"
    }
});




const $d09be945d53f8bbe$export$54ec01a60f47d33d = (0, $47a6d9fbbf7ee42d$export$5c9a64458a4ed8a4)({
    variants: {
        rounded: {
            table: {
                background: $590eee45b2f4b5a8$export$e37de4b4fac6db2b,
                borderRadius: "8px",
                "-webkit-tap-highlight-color": "transparent"
            },
            thead: {
                background: $590eee45b2f4b5a8$export$e37de4b4fac6db2b,
                borderBottomColor: $590eee45b2f4b5a8$export$e9cb372114aadf30,
                borderBottomWidth: $590eee45b2f4b5a8$export$cd9ead0feef17e8f
            },
            tr: {
                borderBottomColor: $590eee45b2f4b5a8$export$78c7442df4e4fa92,
                borderBottomWidth: $590eee45b2f4b5a8$export$cd9ead0feef17e8f,
                fontSize: $590eee45b2f4b5a8$export$69027de17ce58d50,
                color: $590eee45b2f4b5a8$export$4bdf0898d78f829f,
                background: $590eee45b2f4b5a8$export$4f99ab36c26efe10,
                _odd: {
                    background: $590eee45b2f4b5a8$export$28e00750b991884e
                }
            },
            td: {
                py: 3,
                px: 3
            },
            th: {
                textTransform: "none",
                fontSize: $590eee45b2f4b5a8$export$808adbba399a6506,
                fontWeight: $590eee45b2f4b5a8$export$c702f2c8b91e5dac,
                color: $590eee45b2f4b5a8$export$cac2caa807436676,
                background: $590eee45b2f4b5a8$export$e37de4b4fac6db2b,
                letterSpacing: "normal",
                py: 5,
                px: 3
            }
        }
    }
});


const $227f11a6809b1d6b$export$bca14c5b3b88a9c9 = (0, $72e226b9ca0e0bbe$export$33a2b855d5b8731e)({
    styles: $f21bc82042c71370$export$9dd6ff9ea0189349,
    textStyles: $1a211241b412719d$export$6a54c24d15b0f6ba,
    layerStyles: $1e3136b29e7546eb$export$c5ce54c56ca9d603,
    breakpoints: $16f660dc0005d97b$export$d07517a676ce386f,
    components: {
        Button: $39cb1d8d3afd6734$export$353f5b6fc5456de1,
        Card: $0525801d60479ce6$export$60332b2344f7fe41,
        Divider: $fb624147e21fd833$export$2e0a83ec2e27ecbb,
        Input: $d62829c56d9124f1$export$f5b8910cec6cf069,
        Heading: $0b67c69dd75849d6$export$a8a3e93435678ff9,
        FormLabel: $7f1a3f470d24547b$export$842aba50ed0ce9d7,
        Link: $24731845166adced$export$a6c7ac8248d6e38a,
        Select: $88beff93cb23318d$export$ef9b1a59e592288f,
        Checkbox: $e2a00a59fdd29348$export$48513f6b9f8ce62d,
        Textarea: $d3e0010ffadb4403$export$379139ebc1c2b235,
        Table: $d09be945d53f8bbe$export$54ec01a60f47d33d
    },
    colors: $a70a3787a84ee6fb$export$8f45430ccf837300
});











// CLASS
class $e66552176030227e$export$62297b13309008b2 extends (0, $3141b454c0d4745f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $e66552176030227e$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $f8b865b18d670cc6$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        Array.isArray(this.options.queryKey);
        const abortController = (0, $f8b865b18d670cc6$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $cd25260720ff3eef$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $cd25260720ff3eef$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $cd25260720ff3eef$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $cd25260720ff3eef$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $cd25260720ff3eef$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $e66552176030227e$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}




// CLASS
class $013b25af9cb1d94e$export$5dde0cd941da8468 extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $f8b865b18d670cc6$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $e66552176030227e$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $f8b865b18d670cc6$export$c5d1efe363797780)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $f8b865b18d670cc6$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}






// CLASS
class $cc7bef81aaa407d7$export$1fcfd9a244434844 extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $da939cdf983103e1$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $f8b865b18d670cc6$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $f8b865b18d670cc6$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $f8b865b18d670cc6$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}





function $2fb8e98898cdca1c$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $2fb8e98898cdca1c$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $2fb8e98898cdca1c$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $2fb8e98898cdca1c$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $2fb8e98898cdca1c$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $2fb8e98898cdca1c$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $2fb8e98898cdca1c$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $2fb8e98898cdca1c$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $2fb8e98898cdca1c$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $2fb8e98898cdca1c$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $993a0f6ad9d6681b$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $013b25af9cb1d94e$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $cc7bef81aaa407d7$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $2a29005856faa11a$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $f8b865b18d670cc6$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $f8b865b18d670cc6$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $2fb8e98898cdca1c$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $f8b865b18d670cc6$export$5fcb678681417b54)(queryKey) === (0, $f8b865b18d670cc6$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $f8b865b18d670cc6$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $f8b865b18d670cc6$export$5fcb678681417b54)(mutationKey) === (0, $f8b865b18d670cc6$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $f8b865b18d670cc6$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $f8b865b18d670cc6$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}



const $a964e17998d2b6e7$var$permCacheOptions = {
    cacheTime: Infinity,
    staleTime: Infinity,
    retry: false,
    retryOnMount: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
};
const $a964e17998d2b6e7$var$client = new (0, $993a0f6ad9d6681b$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false
        }
    }
});
$a964e17998d2b6e7$var$client.setQueryDefaults((0, $0e529258adfac30f$export$2103cd12bd33fe6a)(), $a964e17998d2b6e7$var$permCacheOptions);
$a964e17998d2b6e7$var$client.setQueryDefaults((0, $0e529258adfac30f$export$be93e9d2bd47a84d)(), $a964e17998d2b6e7$var$permCacheOptions);
$a964e17998d2b6e7$var$client.setQueryDefaults((0, $0e529258adfac30f$export$83afda26ea578668)(), $a964e17998d2b6e7$var$permCacheOptions);
const $a964e17998d2b6e7$export$7c07b633a151f9c5 = $a964e17998d2b6e7$var$client;


function $cd93687958c8007e$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $27b686752740163d$export$80dbe0482bcbd25a), {
        theme: (0, $227f11a6809b1d6b$export$bca14c5b3b88a9c9),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0126047dd734bc33$export$45604f0cc8ae667b), {
            client: (0, $a964e17998d2b6e7$export$7c07b633a151f9c5),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $043f87f23fd0da03$export$3565eb3d00ca5a74), {})
            })
        })
    });
}


const $70fc9a727fa662ae$var$container = document.getElementById("app");
if (!$70fc9a727fa662ae$var$container) throw new Error("Root element not found");
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.04ba42ef.js.map
